import {
  Duration__minus_impl_q5cfm715b1yelrxm0ir as Duration__minus_impl_q5cfm7,
  Duration__plus_impl_yu9v8f24i74j9g7b01u as Duration__plus_impl_yu9v8f,
  Duration__compareTo_impl_pchp0f86u5y5kbz283 as Duration__compareTo_impl_pchp0f,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  Unit_instanceat14thlj150z as Unit_instance,
  Comparable198qfk8pnblz0 as Comparable,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  Duration__toString_impl_8d916b13ohvvi8wucz4 as Duration__toString_impl_8d916b,
  ValueTimeMark__elapsedNow_impl_eonqvs3jczd809bixyd as ValueTimeMark__elapsedNow_impl_eonqvs,
  Duration5ynfiptaqcrg as Duration,
  printStackTrace18lnx7a39cni as printStackTrace,
  Monotonic_instance29u86ypunv10 as Monotonic_instance,
  ArrayDeque2dzc9uld4xi7n as ArrayDeque,
  maxOfnpw4mt1rg0hl as maxOf,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  protoOf180f3jzyo7rfj as protoOf,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  createThis2j2avj17cvnv2 as createThis,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  Enum3alwj03lh1n41 as Enum,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  toString14fd7g605f91p as toString_0,
  Char__hashCode_impl_otmys1ewos5t0dm35g as Char__hashCode_impl_otmys,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  equals2au1ep9vhcato as equals,
  toString30pk9tzaqopn as toString_1,
  hashCodeq5arwsb9dgti as hashCode,
  Exceptiondt2hlxn7j7vw as Exception,
  captureStack1fzi4aczwc4hg as captureStack,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  joinToString1cxrrlmo0chqs as joinToString,
  booleanArray2jdug9b51huk7 as booleanArray,
  StringBuildermazzzhj6kkai as StringBuilder,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  emptySetcxexqki71qfa as emptySet,
  Long2qws0ah9gnpki as Long,
  isInterface3d6p8outrmvmk as isInterface,
  distinct10qe1scfdvu5k as distinct,
  compareTo3ankvs086tmwq as compareTo,
  Companion_getInstance1krakgr3yg44t as Companion_getInstance_0,
  toLongw1zpgk99d84b as toLong,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  KProperty1ca4yb4wlo496 as KProperty1,
  RuntimeException1r3t0zl97011n as RuntimeException,
  toList3jhuyej2anx2q as toList,
  listOfvhqybd2zx248 as listOf,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  HashMap1a0ld5kgwhmhv as HashMap,
  lazy2hsh8ze7j6ikd as lazy,
  numberToLong1a4cndvg6c52s as numberToLong,
  println2shhhgwwt4c61 as println,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  listOf1jh22dvmctj1r as listOf_0,
  Triple1vhi3d0dgpnjb as Triple,
  stackTraceToString2670q6lbhdojj as stackTraceToString,
  last1vo29oleiqj36 as last,
  Regexxgw0gjiagf4z as Regex,
  replace3le3ie7l9k8aq as replace,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  getOrNull1go7ef9ldk0df as getOrNull,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  sortedWith2csnbbb21k0lg as sortedWith,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  emptyList1g2z5xcrvp2zy as emptyList,
  reversed22y3au42jl32b as reversed,
  HashSet2dzve9y63nf0v as HashSet,
  plus310ted5e4i90h as plus,
  joinToStringxqcavsxcmh4q as joinToString_0,
  contains2el4s70rdq4ld as contains,
  maxOrNull2e5ok5wkly1cp as maxOrNull,
  Iterable1y3qizuf89iou as Iterable,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  contentEqualsaf55p28mnw74 as contentEquals,
  contentHashCode2i020q5tbeh2s as contentHashCode,
  toList383f556t1dixk as toList_0,
  to2cs3ny02qtbcb as to,
  boxApply1qmzdb3dh90hg as boxApply,
  plus1ogy4liedzq5j as plus_0,
  withIndex37cl61h9v5txo as withIndex,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  Char__toInt_impl_vasixd17daqndsyg0ov as Char__toInt_impl_vasixd,
  toByte4i43936u611k as toByte,
  numberToChar93r9buh19yek as numberToChar,
  until1jbpn0z3f8lbg as until,
  toSet2orjxp16sotqu as toSet,
  split2bvyvnrlcifjv as split,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  numberToDouble210hrknaofnhf as numberToDouble,
  get_indicesc04v40g017hw as get_indices,
  anyToString3ho3k49fc56mj as anyToString,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  copyToArray2j022khrow2yi as copyToArray,
  startsWith1bgirhbedtv2y as startsWith,
  isBlank1dvkhjjvox3p0 as isBlank,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  split3d3yeauc4rm2n as split_0,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  toShort36kaw0zjdq3ex as toShort,
  contains1tccixv8iwdcq as contains_0,
  EmptyCoroutineContext_getInstance7yleecrz3jzr as EmptyCoroutineContext_getInstance,
  round2mrvepag8eey0 as round,
  coerceAtLeastklytehohcpeq as coerceAtLeast_0,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  mapOf1xd03cq9cnmy8 as mapOf,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  ObservableProperty3aw08lidjfpjm as ObservableProperty,
  Delegates_instance3jf2rsvdhmxzn as Delegates_instance,
  DurationUnit_MICROSECONDS_getInstance3qb7b7owxf6lo as DurationUnit_MICROSECONDS_getInstance,
  Duration__times_impl_sfuzvp2zkq9ykxbil7d as Duration__times_impl_sfuzvp,
  get6d5x931vk0s as get,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus_1,
  Element2gr7ezmxqaln7 as Element,
  Companion_instance144r68bk89en4 as Companion_instance,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  toDurationba1nlt78o6vu as toDuration_0,
  PrimitiveClasses_getInstanceeand5azd2sul as PrimitiveClasses_getInstance,
  arrayOf1akklvh2at202 as arrayOf,
  createKType1lgox3mzhchp5 as createKType,
  createInvariantKTypeProjection3sfd0u0y62ozd as createInvariantKTypeProjection,
  getKClass1s3j9wy1cofik as getKClass,
  Unitkvevlwgzwiuc as Unit,
  encodeToByteArray1onwao0uakjfh as encodeToByteArray,
  KProperty02ce7r476m8633 as KProperty0,
  toSet1glep2u1u9tcb as toSet_0,
  reversednxqwdkac9dn0 as reversed_0,
  toMutableListoiy7juhbnlr7 as toMutableList,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  isInfinite12nl8hpz1hbp2 as isInfinite,
  isNaNymqb93xtq8w8 as isNaN_0,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Console_getInstance8lqb2pbph5yn as Console_getInstance,
  Companion_getInstance3qvmjlq9y5ia6 as Companion_getInstance_1,
  Level_INFO_getInstance3huxkjtm54h8u as Level_INFO_getInstance,
  Level_ERROR_getInstance18552yzhsfztk as Level_ERROR_getInstance,
  Level_TRACE_getInstance1ni95vo21pald as Level_TRACE_getInstance,
  Level_DEBUG_getInstancewzibhbcrmy7h as Level_DEBUG_getInstance,
  valueOf3aj0dpb8xpu5n as valueOf,
  Level_WARN_getInstance2cg04z8rod8ga as Level_WARN_getInstance,
} from './korlibs-logger-root-korlibs-logger.mjs';
import {
  SyncPauseable20rt0nt3umu2s as SyncPauseable,
  Companion_instance2r8kc48nhvjcq as Companion_instance_0,
  FastIdentityMap17d14y8i3m5g7 as FastIdentityMap,
  get2pw1zlgv5zypd as get_0,
  set2vuztm9k7ubgo as set,
  FastIntMapl0pzyavg6uw5 as FastIntMap,
  IntArrayList3liuagbdnwmna as IntArrayList,
  Ref11k43t82thcp3 as Ref,
  FastStringMap1l1uzdhsfbatm as FastStringMap,
  linkedHashMapOf2w2uhgrq4khrk as linkedHashMapOf,
  toIntMapp1jij98esrcm as toIntMap,
  IntMap2d9g6f5pyaoc2 as IntMap,
  Pool1zbsw0zhvh8ca as Pool,
  containsrsn76oa0puwr as contains_1,
  clear3idbm40uzyume as clear,
  get_size2tttv7g2u748n as get_size,
  FastSmallSet2og2j8v2pz4c7 as FastSmallSet,
  getAndRemove1ksxnnren48mb as getAndRemove,
  get_keyswqddktl7cnu2 as get_keys,
  ReturnablePool3rkgvxsckx2u2 as ReturnablePool,
  TGenQueue2v9j3ju90xgpv as TGenQueue,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  Lock5n7hh3dgcidl as Lock,
  Signal3nnez3346azzf as Signal,
  invoke2sf88d1xeuyqh as invoke,
  NonRecursiveLock2vf7fkhp857q as NonRecursiveLock,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  cancel1amaozv14ic7s as cancel,
  CloseableCancellable3mxnqaxyfppmn as CloseableCancellable,
  CancellableGroup3e8z70ga3djg as CancellableGroup,
  get_unreachable2fi7msfg0vgzd as get_unreachable,
  unsupported198cz39rr1ztw as unsupported,
  Companion_instance1mbrm9vk5fsmd as Companion_instance_1,
  get_portableSimpleName6o7s8nc63i85 as get_portableSimpleName,
  Companion_getInstance39o54489czp6d as Companion_getInstance_2,
  Os_UNKNOWN_getInstancecnx3cm3i6e2g as Os_UNKNOWN_getInstance,
  invalidOp1stebxh2m3n07 as invalidOp,
  get_invalidOp31x7cztl0dv9m as get_invalidOp,
  Companion_getInstancegk7jn4e7je7g as Companion_getInstance_3,
  DenoPointerpb0vypijx63v as DenoPointer,
  get_pointerlkbwhoqlhapz as get_pointer,
  get_jsGlobalThis3odmbn60utci as get_jsGlobalThis,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  FastArrayListw5fr1wlp4slq as FastArrayList,
  toFastList1btvvxvv57pw as toFastList,
  Mixin3lmkm5hum2vdj as Mixin,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
  setExtra314k0z6q35eku as setExtra,
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  toFastListzo2jtkrx0z5y as toFastList_0,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  Companion_getInstancewdpvtc2ehxkt as Companion_getInstance_4,
  RectangleInt3lmu13ytuf5lk as RectangleInt,
  Companion_getInstance1bdwtq6rroayu as Companion_getInstance_5,
  Vector2D378fe5rov8fgw as Vector2D,
  BoundsBuilder__plus_impl_cz7f7xocbq7jeozma3 as BoundsBuilder__plus_impl_cz7f7x,
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstance3qti4zygy7usz as Companion_getInstance_6,
  Companion_getInstance1zxby1ngivg0d as Companion_getInstance_7,
  MatrixTransform1wlsrhxt7473v as MatrixTransform,
  get_scale17gmsnxnqj6j9 as get_scale,
  Matrix43neeu8v4zk4i7 as Matrix4,
  orthow9c0o91bw54n as ortho,
  SizeInte6w85oa6mz6v as SizeInt,
  Companion_instanceu31qrc8c1r0r as Companion_instance_2,
  get_degrees3czcd4ojw4i as get_degrees,
  Angle__times_impl_v3s9y21yznxo5bj1uj7 as Angle__times_impl_v3s9y2,
  Angle2itorpob18n08 as Angle,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Companion_getInstance36wz4kh9aujgq as Companion_getInstance_8,
  DateTime__hashCode_impl_yf0bc92s64omsn0fynv as DateTime__hashCode_impl_yf0bc9,
  _FastDuration___get_fastNanoseconds__impl__9kjwbr3nvm3csqkttdd as _FastDuration___get_fastNanoseconds__impl__9kjwbr,
  get_fastNanosecondsibv7lnrlu50o as get_fastNanoseconds,
  _FastDuration___get_fastMilliseconds__impl__pe68va81p5t8ucvnk8 as _FastDuration___get_fastMilliseconds__impl__pe68va,
  get_fastMillisecondsfxaeyfzoedsj as get_fastMilliseconds,
  FastDuration__minus_impl_evs237rhg84spop2c8 as FastDuration__minus_impl_evs237,
  FastDuration__compareTo_impl_4fhnj72c084ut3ho50d as FastDuration__compareTo_impl_4fhnj7,
  Companion_instance293l0r179rei7 as Companion_instance_3,
  get_fastNanoseconds1laeiegsk8vcx as get_fastNanoseconds_0,
  FastDuration__plus_impl_q1enab1plpz0e6mgxzj as FastDuration__plus_impl_q1enab,
  toDuration15w5sljvx2ut2 as toDuration_1,
  FastDuration__hashCode_impl_y13la6nym0c1xbwjaa as FastDuration__hashCode_impl_y13la6,
  get_fastMicroseconds3xewe49ldi5s as get_fastMicroseconds,
  FastDuration__minus_impl_evs237bt7zqxxnwet as FastDuration__minus_impl_evs237_0,
  FastDuration3d3pupg2e5ora as FastDuration,
  minus2npwq73u0d9yx as minus,
  max1q2oylvn6uire as max,
  get_fastMilliseconds2pmoifl74b2oz as get_fastMilliseconds_0,
  FastDuration__plus_impl_q1enab30y5opwsu5po5 as FastDuration__plus_impl_q1enab_0,
  get_fast37cu8s8qwnuyi as get_fast,
  roundMilliseconds3bd2pntxev66o as roundMilliseconds,
  FastDuration__toString_impl_c9xohb3u75ye94mx1dw as FastDuration__toString_impl_c9xohb,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  arraycopy52dxe7vhzf14 as arraycopy,
  clonelcrqoxe4ne5i as clone,
  Companion_instancejzamqjlqqs4y as Companion_instance_4,
  _Int8Buffer___init__impl__e20lvcp4p2uvfo996c as _Int8Buffer___init__impl__e20lvc,
  _Int8Buffer___get_buffer__impl__q0gulbq12sgwh1jcvh as _Int8Buffer___get_buffer__impl__q0gulb,
  sliceWithSize2i7i6olf26byj as sliceWithSize,
  Companion_getInstance35xii7iw9kdg2 as Companion_getInstance_9,
  ByteUnits__toString_impl_ox2ku22zb4xrvk9phl9 as ByteUnits__toString_impl_ox2ku2,
  arraycopy3uxsqjlixmnz3 as arraycopy_0,
  Buffer25z94vsj0kb1s as Buffer,
  get_i323p4hlz6j3xys8 as get_i32,
  arraycopy1hsh296f5d0xg as arraycopy_1,
  get_f3218rglfhpgbhzp as get_f32,
  arraycopy3fi6tr79d693r as arraycopy_2,
  get_i83qhdj74rhdyeg as get_i8,
  arraycopyphzg5lpa6gvz as arraycopy_3,
  get_size13scmefs6mbfn as get_size_0,
  allocDirecttfrgytwudkpf as allocDirect,
  sliceBufferpiate0wictoq as sliceBuffer,
  arrayequal25g4om83vd8w1 as arrayequal,
  copyOfnqvdm0sc8lk as copyOf,
  setArrayLEwil75hzlfusu as setArrayLE,
  setInt32178h074gei71f as setInt32,
  getInt32gmg3zyw00v1v as getInt32,
  arraycopy9a0yzbjqwnvw as arraycopy_4,
  Uint16Buffer__set_impl_g0kliu1ltqm2yo4vfb6 as Uint16Buffer__set_impl_g0kliu,
  Float32Buffer__get_impl_659lhu2fcy7ilfo0o6g as Float32Buffer__get_impl_659lhu,
  Float32Buffer__set_impl_34sznedf8x821xo8e0 as Float32Buffer__set_impl_34szne,
  get_u163bxpdbbave1v5 as get_u16,
  setFloat323e0ukqyly1ufv as setFloat32,
  asUShortArrayInt2gfk0h9rafip5 as asUShortArrayInt,
  arraycopy28e1us87mwypg as arraycopy_5,
  arrayadd3erpr00t9k8j as arrayadd,
  arraycopyqmyo4vjwforw as arraycopy_6,
  arrayfill1njpugsfcm512 as arrayfill,
  arrayfill2iqmyqqqfwuaf as arrayfill_0,
  allocNoDirect3dykranmovqsj as allocNoDirect,
  get_arrayUByte9swx7ogt2hf2 as get_arrayUByte,
  get_arrayInt3v8kuk47rixtz as get_arrayInt,
  get_arrayFloat1r0vk858s9phl as get_arrayFloat,
} from './korlibs-memory-root-korlibs-memory.mjs';
import {
  get_niceStr1tlwtz2l2j4my as get_niceStr,
  get_isPowerOfTwoeb2yxu9ww0f7 as get_isPowerOfTwo,
  extract2vhru1ihy4ogl as extract,
  insert52qor1kqho1lpj as insert5,
  insert22yqrzxcpmo55e as insert2,
  insert2fz5125p2hdyd as insert,
  insert42sy0xc4ax89g9 as insert4,
  toShortClampedqjuvod9w2qhj as toShortClamped,
  toIntRound1mv0y8x9hh1p4 as toIntRound,
  toIntRoundjnzmk86x1qp5 as toIntRound_0,
  get_low2kdkn3173rx8r as get_low,
  get_high3vl4k4kkorqlu as get_high,
  insert141hi307uxchfzk as insert14,
  ilog23dbvpk38jf7rc as ilog2,
  insert8f3zk23r8x9da as insert8,
  insert32d422lnha9g5r as insert3,
  extractScaledf013fj6eqsu4szwo as extractScaledf01,
  insertScaledf01oj6k04gavkch as insertScaledf01,
  insertm9bp9ll4cml3 as insert_0,
  min1z074tc6jeruz as min,
  max1izmzj76cv5b4 as max_0,
  nextMultipleOf14oge7vxqp9sy as nextMultipleOf,
  nextAlignedTo2788hp7lcoqp as nextAlignedTo,
  setBitsqsmqq5kc486j as setBits,
  Companion_getInstance2tun2u13u8fzr as Companion_getInstance_10,
  _Ratio___init__impl__9mwvn224skkn3fz6cfs as _Ratio___init__impl__9mwvn2,
  Ratio136tf4z2t0p2d as Ratio,
  interpolate2g7wzskc23f1q as interpolate,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  NullBitmap15b22oyta4usb as NullBitmap,
  MultiBitmapk0zsv2zy1mpk as MultiBitmap,
  ForcedTexId3ivekmtdm8t3u as ForcedTexId,
  RGBA__toString_impl_4lw6dp2tumn1mea41fm as RGBA__toString_impl_4lw6dp,
  RGBA__hashCode_impl_h59qf629uhw1oxrapg6 as RGBA__hashCode_impl_h59qf6,
  FloatBitmap321fufbxi3ys0iu as FloatBitmap32,
  Bitmap82ekc5d8xpcfp2 as Bitmap8,
  NativeImagebqxh3nwkmck as NativeImage,
  _RGBA___get_rf__impl__kvz75k2enjmg3zrtnq3 as _RGBA___get_rf__impl__kvz75k,
  _RGBA___get_gf__impl__5gcu1f1tcfjj6a92jd8 as _RGBA___get_gf__impl__5gcu1f,
  _RGBA___get_bf__impl__1xz5yg37iolmxbb8ro0 as _RGBA___get_bf__impl__1xz5yg,
  _RGBA___get_af__impl__vu36qv3fdqajvftucv7 as _RGBA___get_af__impl__vu36qv,
  _RGBAPremultiplied___get_rf__impl__pt0c4yud4u7tot9j6v as _RGBAPremultiplied___get_rf__impl__pt0c4y,
  _RGBAPremultiplied___get_gf__impl__ivron7124n55fu7nftq as _RGBAPremultiplied___get_gf__impl__ivron7,
  _RGBAPremultiplied___get_bf__impl__qa3on231tqs9tgl21ni as _RGBAPremultiplied___get_bf__impl__qa3on2,
  _RGBAPremultiplied___get_af__impl__euwcjn2miyh1t3zubgx as _RGBAPremultiplied___get_af__impl__euwcjn,
  Colors_getInstance2cnv7p5d6jz4u as Colors_getInstance,
  Companion_instance1sgltfeqg9bxt as Companion_instance_5,
  ImageDecodingProps12g4gdsvb3zm5 as ImageDecodingProps,
  readBitmap1yhww5yoq3a9l as readBitmap,
  slice2pfxfvku0ybgy as slice,
  Companion_instance1zw3l6m7tnvps as Companion_instance_6,
  Glyphdz1l7rusab9h as Glyph,
  BitmapFontImpljoxrxbqjo5ee as BitmapFontImpl,
  get_baseMipmapLevel1ty2cgb5p9xw4 as get_baseMipmapLevel,
  get_maxMipmapLevel13juf70j6ney9 as get_maxMipmapLevel,
  _RGBA___get_value__impl__hhco8vehpblbe3f2y8 as _RGBA___get_value__impl__hhco8v,
  RGBA34obx2i62wcl3 as RGBA,
  HtmlNativeImagenz79853f60h as HtmlNativeImage,
  toHtmlNative1zcg9na83p2te as toHtmlNative,
} from './korlibs-image-root-korlibs-image.mjs';
import {
  get_hex32p4ssq0y1xxx as get_hex,
  fromBase6434uveajlhn2ar as fromBase64,
} from './korlibs-encoding-root-korlibs-encoding.mjs';
import {
  atomic$int$11d5swdyn6j0pu as atomic$int$1,
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
} from './kotlinx-atomicfu.mjs';
import {
  Companion_getInstance2vt0vokm4ixbh as Companion_getInstance_11,
  Indenterdf10c5coibyi as Indenter,
  MountableVfs3mmbka3zq5l6i as MountableVfs,
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
  launchImmediatelylnv8lnistpdy as launchImmediately,
  delay2vwv568c245r8 as delay,
  toVfsr7ir4p66g1my as toVfs,
  launchImmediately11za8mkid9pxu as launchImmediately_0,
} from './korlibs-io-root-korlibs-io.mjs';
import {
  DisposableHandle1uzxt8frdchxn as DisposableHandle,
  delay1blitpytzu6gr as delay_0,
  CoroutineName2g5zosw74tf0f as CoroutineName,
  cancelChildrennwartoz0yn6c as cancelChildren,
  CoroutineDispatcherizb7p9bijexj as CoroutineDispatcher,
  Delay9umexudtwyie as Delay,
  cancelAndJoin2j6ktsickm6hy as cancelAndJoin,
  MainScope1gi1r4abhrtmm as MainScope,
} from './kotlinx-coroutines-core.mjs';
import {
  get_immutablepxpdoj6e54ll as get_immutable,
  Companion_instance2i0t7ux7bzoqc as Companion_instance_7,
  RectSlicec5msorw5q4el as RectSlice,
  Companion_getInstance154uzbkgf0e3s as Companion_getInstance_12,
  toMatrix42ci5k1es0x1v1 as toMatrix4,
  MMatrix1y71lv7vv6y8t as MMatrix,
} from './korlibs-math-root-korlibs-math.mjs';
import { openAsync37anb1e84urmo as openAsync } from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import { InjectorDependency2f8dsqe1kn3nn as InjectorDependency } from './korlibs-inject-root-korlibs-inject.mjs';
import {
  IntTimedCache39ymx9abjz88x as IntTimedCache,
  PerformanceCounter_getInstance3b8d94s1bsc37 as PerformanceCounter_getInstance,
  Stopwatch1guqi4xl0rpfb as Stopwatch,
} from './korlibs-time-root-korlibs-time.mjs';
import {
  FFILiby83bova0zjfy as FFILib,
  Companion_getInstance2ww1whxsubyyu as Companion_getInstance_13,
  FuncInfocud0a7bce10z as FuncInfo,
  CreateFFIPointernsr7ilwulbub as CreateFFIPointer,
  get_pointer2afz2rc14joly as get_pointer_0,
  CreateFFIMemoryv82e6jbfcdze as CreateFFIMemory,
  set3216gyp8r69gas8 as set32,
  CreateFFIMemory2iekizxdvtyvt as CreateFFIMemory_0,
  setFFIPointerjzarmbova4sm as setFFIPointer,
  getS32284qh8a5ldxzn as getS32,
} from './korlibs-ffi-root-korlibs-ffi-legacy.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class TimedTask {
  constructor(eventLoop, now, time, interval, callback) {
    this.j6d_1 = eventLoop;
    this.k6d_1 = now;
    this.l6d_1 = time;
    this.m6d_1 = interval;
    this.n6d_1 = callback;
  }
  o6d(value) {
    this.k6d_1 = Duration__minus_impl_q5cfm7(value, this.l6d_1);
  }
  p6d() {
    return Duration__plus_impl_yu9v8f(this.k6d_1, this.l6d_1);
  }
  q6d(other) {
    return Duration__compareTo_impl_pchp0f(this.p6d(), other.p6d());
  }
  d(other) {
    return this.q6d(other instanceof TimedTask ? other : THROW_CCE());
  }
  n6() {
    this.m6d_1 = false;
    this.j6d_1.a6e_1.p2q(this);
  }
}
class BaseEventLoop {
  constructor() {
    this.j6e_1 = new Lock();
  }
}
class SyncEventLoop extends BaseEventLoop {
  constructor(immediateRun) {
    immediateRun = immediateRun === VOID ? false : immediateRun;
    super();
    this.s6d_1 = immediateRun;
    this.t6d_1 = new SyncPauseable();
    this.u6d_1 = paused$factory(this.t6d_1);
    this.v6d_1 = new Lock();
    this.w6d_1 = true;
    this.x6d_1 = Monotonic_instance.kj();
    var tmp = this;
    tmp.y6d_1 = SyncEventLoop$nowProvider$lambda(this);
    this.z6d_1 = ArrayDeque.pk();
    var tmp_0 = this;
    var tmp_1 = Companion_instance_0;
    tmp_0.a6e_1 = tmp_1.t2u(VOID, SyncEventLoop$timedTasks$lambda);
    var tmp_2 = this;
    tmp_2.b6e_1 = SyncEventLoop$uncatchedExceptionHandler$lambda;
    this.c6e_1 = null;
  }
  d6e(task) {
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = this.v6d_1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.i1y();
      try {
        this.z6d_1.tk(task);
        this.v6d_1.m1y();
        break $l$block;
      }finally {
        this_0.k1y();
      }
    }
  }
  e6e(time, task) {
    return _queueAfter(this, time, false, task);
  }
  n6() {
    var oldImmediateRun = this.s6d_1;
    try {
      this.s6d_1 = true;
      this.f6e();
      this.w6d_1 = false;
    }finally {
      this.s6d_1 = oldImmediateRun;
    }
  }
  g6e(task) {
    if (this.s6d_1)
      return true;
    return Duration__compareTo_impl_pchp0f(_get_now__e6dlkr(this), this.a6e_1.z2u().p6d()) >= 0;
  }
  h6e(runTimers) {
    var count = 0;
    while (this.i6e(runTimers)) {
      count = count + 1 | 0;
    }
    return count;
  }
  f6e(runTimers, $super) {
    runTimers = runTimers === VOID ? true : runTimers;
    return $super === VOID ? this.h6e(runTimers) : $super.h6e.call(this, runTimers);
  }
  i6e(runTimers) {
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = this.v6d_1;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.i1y();
      try {
        // Inline function 'korlibs.datastructure.event.SyncEventLoop.runAvailableNextTask.<anonymous>' call
        var tmp;
        if (runTimers) {
          var tmp_0;
          var tmp_1;
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!this.a6e_1.h1()) {
            tmp_1 = this.g6e(this.a6e_1.z2u());
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp_0 = this.a6e_1.a2v();
          } else {
            tmp_0 = null;
          }
          tmp = tmp_0;
        } else {
          tmp = null;
        }
        tmp$ret$2 = tmp;
        break $l$block;
      }finally {
        this_0.k1y();
      }
    }
    var timedTask = tmp$ret$2;
    if (!(timedTask == null)) {
      // Inline function 'korlibs.datastructure.event.SyncEventLoop.runCatchingExceptions' call
      try {
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.event.SyncEventLoop.runAvailableNextTask.<anonymous>' call
        timedTask.n6d_1();
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          this.b6e_1(e);
        } else {
          throw $p;
        }
      }
      if (timedTask.m6d_1 && !this.s6d_1) {
        timedTask.o6d(maxOf(new Duration(Duration__plus_impl_yu9v8f(timedTask.p6d(), timedTask.l6d_1)), new Duration(_get_now__e6dlkr(this))).qj_1);
        this.a6e_1.o2q(timedTask);
      }
    }
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_1 = this.v6d_1;
    var tmp$ret$7;
    $l$block_0: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_1.i1y();
      try {
        // Inline function 'korlibs.datastructure.event.SyncEventLoop.runAvailableNextTask.<anonymous>' call
        var tmp_2;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.z6d_1.h1()) {
          tmp_2 = this.z6d_1.uk();
        } else {
          tmp_2 = null;
        }
        tmp$ret$7 = tmp_2;
        break $l$block_0;
      }finally {
        this_1.k1y();
      }
    }
    var task = tmp$ret$7;
    // Inline function 'korlibs.datastructure.event.SyncEventLoop.runCatchingExceptions' call
    try {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      if (task == null)
        null;
      else
        task();
    } catch ($p) {
      if ($p instanceof Error) {
        var e_0 = $p;
        this.b6e_1(e_0);
      } else {
        throw $p;
      }
    }
    return !(task == null) || !(timedTask == null);
  }
}
class Listener {
  constructor(func, node, base) {
    this.k6e_1 = func;
    this.l6e_1 = node;
    this.m6e_1 = base;
  }
  n6() {
    if (this.l6e_1.o6e_1.m3(this)) {
      __updateChildListenerCount(this.m6e_1, this.l6e_1.n6e_1, -1);
    }
  }
  q6e() {
    this.l6e_1.o6e_1.h(this);
    __updateChildListenerCount(this.m6e_1, this.l6e_1.n6e_1, 1);
  }
}
class ListenerNode {
  constructor(type) {
    this.n6e_1 = type;
    this.o6e_1 = FastArrayList.q10();
    this.p6e_1 = FastArrayList.q10();
  }
}
class EventListener {}
function onEvents(etypes, handler) {
  // Inline function 'kotlin.collections.isEmpty' call
  if (etypes.length === 0) {
    // Inline function 'kotlin.error' call
    var message = 'Must have at least one event type';
    throw IllegalStateException.h5(toString(message));
  }
  var closeable = new CancellableGroup();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < etypes.length) {
    // Inline function 'korlibs.event.EventListener.onEvents.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = etypes[_unary__edvuaz];
    closeable.qt(this.x6e(it, handler));
  }
  return closeable;
}
function dispatch(type, event, result) {
  return this.z6e(type, event, result, true, true);
}
function dispatch$default(type, event, result, $super) {
  result = result === VOID ? null : result;
  return $super === VOID ? this.g6f(type, event, result) : dispatch(type, event, result);
}
function dispatchDown(type, event, result) {
  return this.z6e(type, event, result, false, true);
}
function dispatchUp(type, event, result) {
  return this.z6e(type, event, result, true, false);
}
function dispatch_0(event) {
  // Inline function 'korlibs.datastructure.fastCastTo' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return this.h6f(event.c2e(), event);
}
class BaseEventListener {
  static v6e() {
    var $this = createThis(this);
    $this.r6e_1 = null;
    $this.s6e_1 = null;
    $this.t6e_1 = null;
    $this.u6e_1 = null;
    return $this;
  }
  yz(_set____db54di) {
    this.r6e_1 = _set____db54di;
  }
  zz() {
    return this.r6e_1;
  }
  w6e(other) {
    var tmp0_safe_receiver = this.s6e_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      __updateChildListenerCount_0(tmp0_safe_receiver, this, false);
    }
    this.s6e_1 = other;
    var tmp1_safe_receiver = this.s6e_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      __updateChildListenerCount_0(tmp1_safe_receiver, this, true);
    }
  }
  x6e(type, handler) {
    if (this.t6e_1 == null)
      this.t6e_1 = FastIdentityMap();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = ensureNotNull(this.t6e_1);
      var res = get_0(this_0, type);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.event.BaseEventListener.onEvent.<anonymous>' call
      var out = new ListenerNode(type);
      set(this_0, type, out);
      tmp$ret$0 = out;
    }
    var tmp = tmp$ret$0;
    var lists = tmp instanceof ListenerNode ? tmp : THROW_CCE();
    // Inline function 'kotlin.also' call
    var this_1 = new Listener(handler, lists, this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.event.BaseEventListener.onEvent.<anonymous>' call
    this_1.q6e();
    return this_1;
  }
  y6e(type) {
    var tmp0_safe_receiver = this.t6e_1;
    var tmp = tmp0_safe_receiver == null ? null : get_0(tmp0_safe_receiver, type);
    return tmp instanceof ListenerNode ? tmp : null;
  }
  z6e(type, event, result, up, down) {
    var eventListenerCount = this.a6f(type);
    if (eventListenerCount <= 0)
      return false;
    if (down) {
      this.b6f(type, event, result);
    }
    var listeners = this.y6e(type);
    var tmp1_safe_receiver = listeners == null ? null : listeners.o6e_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEachWithTemp' call
      var temp = listeners.p6e_1;
      toFastList(tmp1_safe_receiver, temp);
      try {
        // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array = temp.o10_1;
        var n = 0;
        while (n < array.length) {
          // Inline function 'korlibs.event.BaseEventListener.dispatch.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          array[_unary__edvuaz].k6e_1(event);
          if (result == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            result.d6f_1 = result.d6f_1 + 1 | 0;
          }
        }
      }finally {
        temp.k3();
      }
    }
    if (up) {
      this.e6f(type, event, result);
    }
    if (result == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.event.BaseEventListener.dispatch.<anonymous>' call
      result.c6f_1 = result.c6f_1 + 1 | 0;
    }
    return event.f6f();
  }
  g6f(type, event, result) {
    return dispatch.call(this, type, event, result);
  }
  i6f(event) {
    return dispatch_0.call(this, event);
  }
  e6f(type, event, result) {
  }
  b6f(type, event, result) {
  }
  a6f(type) {
    var tmp0_safe_receiver = this.u6e_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.getNull' call
      tmp = type == null ? null : get_0(tmp0_safe_receiver, type);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  }
}
class EventResult {
  constructor(iterationCount, resultCount) {
    iterationCount = iterationCount === VOID ? 0 : iterationCount;
    resultCount = resultCount === VOID ? 0 : resultCount;
    this.c6f_1 = iterationCount;
    this.d6f_1 = resultCount;
  }
  p2u() {
    this.c6f_1 = 0;
    this.d6f_1 = 0;
  }
  toString() {
    return 'EventResult(iterationCount=' + this.c6f_1 + ', resultCount=' + this.d6f_1 + ')';
  }
  hashCode() {
    var result = this.c6f_1;
    result = imul(result, 31) + this.d6f_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EventResult))
      return false;
    var tmp0_other_with_cast = other instanceof EventResult ? other : THROW_CCE();
    if (!(this.c6f_1 === tmp0_other_with_cast.c6f_1))
      return false;
    if (!(this.d6f_1 === tmp0_other_with_cast.d6f_1))
      return false;
    return true;
  }
}
class Companion {}
class Event {
  constructor() {
    this.p6f_1 = null;
    this.q6f_1 = false;
  }
  r6f(_set____db54di) {
    this.p6f_1 = _set____db54di;
  }
  s6f(reason) {
    throw StopPropagatingException.r6i(reason);
  }
  t6f(reason, $super) {
    reason = reason === VOID ? null : reason;
    var tmp;
    if ($super === VOID) {
      this.s6f(reason);
      tmp = Unit_instance;
    } else {
      tmp = $super.s6f.call(this, reason);
    }
    return tmp;
  }
  u6f(_set____db54di) {
    this.q6f_1 = _set____db54di;
  }
  f6f() {
    return this.q6f_1;
  }
}
class TypedEvent extends Event {
  constructor(type) {
    super();
    this.o6f_1 = type;
  }
  c2e() {
    return this.o6f_1;
  }
}
class PauseEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_8);
  }
}
class Companion_0 {}
class ResumeEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_9);
  }
}
class Companion_1 {}
class StopEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_10);
  }
}
class Companion_2 {}
class DestroyEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_11);
  }
}
class RenderEvent extends TypedEvent {
  constructor() {
    Companion_getInstance_18();
    super(Companion_getInstance_18());
    this.y6f_1 = true;
    this.z6f_1 = true;
  }
  toString() {
    return 'RenderEvent(update=' + this.y6f_1 + ', render=' + this.z6f_1 + ')';
  }
}
class Companion_3 extends RenderEvent {
  constructor() {
    Companion_instance_12 = null;
    super();
    Companion_instance_12 = this;
  }
}
class InitEvent extends TypedEvent {
  constructor() {
    Companion_getInstance_19();
    super(Companion_getInstance_19());
  }
}
class Companion_4 extends InitEvent {
  constructor() {
    Companion_instance_13 = null;
    super();
    Companion_instance_13 = this;
  }
}
class Companion_5 {}
class DisposeEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_14);
  }
}
class Companion_6 {}
class FullScreenEvent extends TypedEvent {
  constructor(fullscreen) {
    fullscreen = fullscreen === VOID ? false : fullscreen;
    super(Companion_instance_15);
    this.d6g_1 = fullscreen;
  }
  toString() {
    return 'FullScreenEvent(fullscreen=' + this.d6g_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.d6g_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FullScreenEvent))
      return false;
    var tmp0_other_with_cast = other instanceof FullScreenEvent ? other : THROW_CCE();
    if (!(this.d6g_1 === tmp0_other_with_cast.d6g_1))
      return false;
    return true;
  }
}
class Companion_7 {}
class ReshapeEvent extends TypedEvent {
  constructor(x, y, width, height, setPos) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    width = width === VOID ? 0 : width;
    height = height === VOID ? 0 : height;
    setPos = setPos === VOID ? true : setPos;
    super(Companion_instance_16);
    this.h6g_1 = x;
    this.i6g_1 = y;
    this.j6g_1 = width;
    this.k6g_1 = height;
    this.l6g_1 = setPos;
  }
  toString() {
    return 'ReshapeEvent(x=' + this.h6g_1 + ', y=' + this.i6g_1 + ', width=' + this.j6g_1 + ', height=' + this.k6g_1 + ', setPos=' + this.l6g_1 + ')';
  }
  hashCode() {
    var result = this.h6g_1;
    result = imul(result, 31) + this.i6g_1 | 0;
    result = imul(result, 31) + this.j6g_1 | 0;
    result = imul(result, 31) + this.k6g_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l6g_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ReshapeEvent))
      return false;
    var tmp0_other_with_cast = other instanceof ReshapeEvent ? other : THROW_CCE();
    if (!(this.h6g_1 === tmp0_other_with_cast.h6g_1))
      return false;
    if (!(this.i6g_1 === tmp0_other_with_cast.i6g_1))
      return false;
    if (!(this.j6g_1 === tmp0_other_with_cast.j6g_1))
      return false;
    if (!(this.k6g_1 === tmp0_other_with_cast.k6g_1))
      return false;
    if (!(this.l6g_1 === tmp0_other_with_cast.l6g_1))
      return false;
    return true;
  }
}
class Companion_8 {
  constructor() {
    Companion_instance_17 = this;
    this.m6g_1 = values();
  }
}
class Type extends Enum {}
class KeyEvent extends Event {
  constructor(type, id, key, keyCode, character, shift, ctrl, alt, meta, str) {
    type = type === VOID ? Type_UP_getInstance() : type;
    id = id === VOID ? 0 : id;
    key = key === VOID ? Key_UP_getInstance() : key;
    keyCode = keyCode === VOID ? 0 : keyCode;
    character = character === VOID ? _Char___init__impl__6a9atx(0) : character;
    shift = shift === VOID ? false : shift;
    ctrl = ctrl === VOID ? false : ctrl;
    alt = alt === VOID ? false : alt;
    meta = meta === VOID ? false : meta;
    str = str === VOID ? null : str;
    super();
    this.p6g_1 = type;
    this.q6g_1 = id;
    this.r6g_1 = key;
    this.s6g_1 = keyCode;
    this.t6g_1 = character;
    this.u6g_1 = shift;
    this.v6g_1 = ctrl;
    this.w6g_1 = alt;
    this.x6g_1 = meta;
    this.y6g_1 = str;
    this.z6g_1 = Companion_getInstance().rj_1;
  }
  c2e() {
    return this.p6g_1;
  }
  toString() {
    return 'KeyEvent(type=' + toString(this.p6g_1) + ', id=' + this.q6g_1 + ', key=' + this.r6g_1.toString() + ', keyCode=' + this.s6g_1 + ', character=' + toString_0(this.t6g_1) + ', shift=' + this.u6g_1 + ', ctrl=' + this.v6g_1 + ', alt=' + this.w6g_1 + ', meta=' + this.x6g_1 + ', str=' + this.y6g_1 + ')';
  }
  hashCode() {
    var result = this.p6g_1.hashCode();
    result = imul(result, 31) + this.q6g_1 | 0;
    result = imul(result, 31) + this.r6g_1.hashCode() | 0;
    result = imul(result, 31) + this.s6g_1 | 0;
    result = imul(result, 31) + Char__hashCode_impl_otmys(this.t6g_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.u6g_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.v6g_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.w6g_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.x6g_1) | 0;
    result = imul(result, 31) + (this.y6g_1 == null ? 0 : getStringHashCode(this.y6g_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KeyEvent))
      return false;
    var tmp0_other_with_cast = other instanceof KeyEvent ? other : THROW_CCE();
    if (!this.p6g_1.equals(tmp0_other_with_cast.p6g_1))
      return false;
    if (!(this.q6g_1 === tmp0_other_with_cast.q6g_1))
      return false;
    if (!this.r6g_1.equals(tmp0_other_with_cast.r6g_1))
      return false;
    if (!(this.s6g_1 === tmp0_other_with_cast.s6g_1))
      return false;
    if (!(this.t6g_1 === tmp0_other_with_cast.t6g_1))
      return false;
    if (!(this.u6g_1 === tmp0_other_with_cast.u6g_1))
      return false;
    if (!(this.v6g_1 === tmp0_other_with_cast.v6g_1))
      return false;
    if (!(this.w6g_1 === tmp0_other_with_cast.w6g_1))
      return false;
    if (!(this.x6g_1 === tmp0_other_with_cast.x6g_1))
      return false;
    if (!(this.y6g_1 == tmp0_other_with_cast.y6g_1))
      return false;
    return true;
  }
}
class Companion_9 {
  constructor() {
    Companion_instance_18 = this;
    this.a6h_1 = values_0();
  }
}
class Type_0 extends Enum {}
class ScrollDeltaMode extends Enum {
  constructor(name, ordinal, scale) {
    super(name, ordinal);
    this.d6h_1 = scale;
  }
  e6h(value, target) {
    return value * (this.d6h_1 / target.d6h_1);
  }
}
class MouseEvent extends Event {
  constructor(type, id, x, y, button, buttons, scrollDeltaX, scrollDeltaY, scrollDeltaZ, isShiftDown, isCtrlDown, isAltDown, isMetaDown, scaleCoords, emulated, scrollDeltaMode) {
    type = type === VOID ? Type_MOVE_getInstance() : type;
    id = id === VOID ? 0 : id;
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    button = button === VOID ? MouseButton_NONE_getInstance() : button;
    buttons = buttons === VOID ? 0 : buttons;
    scrollDeltaX = scrollDeltaX === VOID ? 0.0 : scrollDeltaX;
    scrollDeltaY = scrollDeltaY === VOID ? 0.0 : scrollDeltaY;
    scrollDeltaZ = scrollDeltaZ === VOID ? 0.0 : scrollDeltaZ;
    isShiftDown = isShiftDown === VOID ? false : isShiftDown;
    isCtrlDown = isCtrlDown === VOID ? false : isCtrlDown;
    isAltDown = isAltDown === VOID ? false : isAltDown;
    isMetaDown = isMetaDown === VOID ? false : isMetaDown;
    scaleCoords = scaleCoords === VOID ? true : scaleCoords;
    emulated = emulated === VOID ? false : emulated;
    scrollDeltaMode = scrollDeltaMode === VOID ? ScrollDeltaMode_LINE_getInstance() : scrollDeltaMode;
    super();
    this.h6h_1 = type;
    this.i6h_1 = id;
    this.j6h_1 = x;
    this.k6h_1 = y;
    this.l6h_1 = button;
    this.m6h_1 = buttons;
    this.n6h_1 = scrollDeltaX;
    this.o6h_1 = scrollDeltaY;
    this.p6h_1 = scrollDeltaZ;
    this.q6h_1 = isShiftDown;
    this.r6h_1 = isCtrlDown;
    this.s6h_1 = isAltDown;
    this.t6h_1 = isMetaDown;
    this.u6h_1 = scaleCoords;
    this.v6h_1 = emulated;
    this.w6h_1 = scrollDeltaMode;
    this.x6h_1 = null;
    var tmp = this;
    tmp.y6h_1 = MouseEvent$requestLock$lambda;
  }
  c2e() {
    return this.h6h_1;
  }
  z6h(other) {
    this.h6h_1 = other.h6h_1;
    this.i6h_1 = other.i6h_1;
    this.j6h_1 = other.j6h_1;
    this.k6h_1 = other.k6h_1;
    this.l6h_1 = other.l6h_1;
    this.m6h_1 = other.m6h_1;
    this.n6h_1 = other.n6h_1;
    this.o6h_1 = other.o6h_1;
    this.p6h_1 = other.p6h_1;
    this.q6h_1 = other.q6h_1;
    this.r6h_1 = other.r6h_1;
    this.s6h_1 = other.s6h_1;
    this.t6h_1 = other.t6h_1;
    this.u6h_1 = other.u6h_1;
    this.v6h_1 = other.v6h_1;
    this.w6h_1 = other.w6h_1;
  }
  a6i(mode) {
    return this.w6h_1.e6h(this.o6h_1, mode);
  }
  b6i(mode, x, y, z) {
    this.w6h_1 = mode;
    this.n6h_1 = x;
    this.o6h_1 = y;
    this.p6h_1 = z;
  }
  toString() {
    return 'MouseEvent(type=' + toString(this.h6h_1) + ', id=' + this.i6h_1 + ', x=' + this.j6h_1 + ', y=' + this.k6h_1 + ', button=' + this.l6h_1.toString() + ', buttons=' + this.m6h_1 + ', scrollDeltaX=' + this.n6h_1 + ', scrollDeltaY=' + this.o6h_1 + ', scrollDeltaZ=' + this.p6h_1 + ', isShiftDown=' + this.q6h_1 + ', isCtrlDown=' + this.r6h_1 + ', isAltDown=' + this.s6h_1 + ', isMetaDown=' + this.t6h_1 + ', scaleCoords=' + this.u6h_1 + ', emulated=' + this.v6h_1 + ', scrollDeltaMode=' + this.w6h_1.toString() + ')';
  }
  hashCode() {
    var result = this.h6h_1.hashCode();
    result = imul(result, 31) + this.i6h_1 | 0;
    result = imul(result, 31) + this.j6h_1 | 0;
    result = imul(result, 31) + this.k6h_1 | 0;
    result = imul(result, 31) + this.l6h_1.hashCode() | 0;
    result = imul(result, 31) + this.m6h_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.n6h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.o6h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p6h_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.q6h_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.r6h_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.s6h_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.t6h_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.u6h_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.v6h_1) | 0;
    result = imul(result, 31) + this.w6h_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MouseEvent))
      return false;
    var tmp0_other_with_cast = other instanceof MouseEvent ? other : THROW_CCE();
    if (!this.h6h_1.equals(tmp0_other_with_cast.h6h_1))
      return false;
    if (!(this.i6h_1 === tmp0_other_with_cast.i6h_1))
      return false;
    if (!(this.j6h_1 === tmp0_other_with_cast.j6h_1))
      return false;
    if (!(this.k6h_1 === tmp0_other_with_cast.k6h_1))
      return false;
    if (!this.l6h_1.equals(tmp0_other_with_cast.l6h_1))
      return false;
    if (!(this.m6h_1 === tmp0_other_with_cast.m6h_1))
      return false;
    if (!equals(this.n6h_1, tmp0_other_with_cast.n6h_1))
      return false;
    if (!equals(this.o6h_1, tmp0_other_with_cast.o6h_1))
      return false;
    if (!equals(this.p6h_1, tmp0_other_with_cast.p6h_1))
      return false;
    if (!(this.q6h_1 === tmp0_other_with_cast.q6h_1))
      return false;
    if (!(this.r6h_1 === tmp0_other_with_cast.r6h_1))
      return false;
    if (!(this.s6h_1 === tmp0_other_with_cast.s6h_1))
      return false;
    if (!(this.t6h_1 === tmp0_other_with_cast.t6h_1))
      return false;
    if (!(this.u6h_1 === tmp0_other_with_cast.u6h_1))
      return false;
    if (!(this.v6h_1 === tmp0_other_with_cast.v6h_1))
      return false;
    if (!this.w6h_1.equals(tmp0_other_with_cast.w6h_1))
      return false;
    return true;
  }
}
class Companion_10 {
  constructor() {
    Companion_instance_19 = this;
    this.c6i_1 = values_1();
  }
}
class Type_1 extends Enum {}
class GestureEvent extends Event {
  constructor(type, id, amountX, amountY) {
    type = type === VOID ? Type_MAGNIFY_getInstance() : type;
    id = id === VOID ? 0 : id;
    amountX = amountX === VOID ? 0.0 : amountX;
    amountY = amountY === VOID ? 0.0 : amountY;
    super();
    this.f6i_1 = type;
    this.g6i_1 = id;
    this.h6i_1 = amountX;
    this.i6i_1 = amountY;
  }
  c2e() {
    return this.f6i_1;
  }
  toString() {
    return 'GestureEvent(type=' + toString(this.f6i_1) + ', id=' + this.g6i_1 + ', amountX=' + this.h6i_1 + ', amountY=' + this.i6i_1 + ')';
  }
  hashCode() {
    var result = this.f6i_1.hashCode();
    result = imul(result, 31) + this.g6i_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.h6i_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.i6i_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GestureEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GestureEvent ? other : THROW_CCE();
    if (!this.f6i_1.equals(tmp0_other_with_cast.f6i_1))
      return false;
    if (!(this.g6i_1 === tmp0_other_with_cast.g6i_1))
      return false;
    if (!equals(this.h6i_1, tmp0_other_with_cast.h6i_1))
      return false;
    if (!equals(this.i6i_1, tmp0_other_with_cast.i6i_1))
      return false;
    return true;
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_20 = this;
    this.j6i_1 = values_2();
  }
}
class Type_2 extends Enum {}
class DropFileEvent extends Event {
  constructor(type, files) {
    type = type === VOID ? Type_START_getInstance() : type;
    files = files === VOID ? null : files;
    super();
    this.m6i_1 = type;
    this.n6i_1 = files;
  }
  c2e() {
    return this.m6i_1;
  }
  toString() {
    return 'DropFileEvent(type=' + toString(this.m6i_1) + ', files=' + toString_1(this.n6i_1) + ')';
  }
  hashCode() {
    var result = this.m6i_1.hashCode();
    result = imul(result, 31) + (this.n6i_1 == null ? 0 : hashCode(this.n6i_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DropFileEvent))
      return false;
    var tmp0_other_with_cast = other instanceof DropFileEvent ? other : THROW_CCE();
    if (!this.m6i_1.equals(tmp0_other_with_cast.m6i_1))
      return false;
    if (!equals(this.n6i_1, tmp0_other_with_cast.n6i_1))
      return false;
    return true;
  }
}
class StopPropagatingException extends Exception {
  static r6i(reason) {
    reason = reason === VOID ? null : reason;
    var $this = this.fe();
    captureStack($this, $this.q6i_1);
    $this.p6i_1 = reason;
    return $this;
  }
}
class Status extends Enum {}
class Kind extends Enum {}
class Companion_12 {
  constructor() {
    Companion_instance_21 = this;
    this.s6i_1 = new Touch(-1);
  }
}
class Touch {
  constructor(index, id, p, force, status, kind, button) {
    Companion_getInstance_27();
    index = index === VOID ? -1 : index;
    id = id === VOID ? -1 : id;
    p = p === VOID ? Companion_getInstance_4().c2a_1 : p;
    force = force === VOID ? 1.0 : force;
    status = status === VOID ? Status_KEEP_getInstance() : status;
    kind = kind === VOID ? Kind_FINGER_getInstance() : kind;
    button = button === VOID ? MouseButton_LEFT_getInstance() : button;
    this.t6i_1 = new Mixin();
    this.u6i_1 = index;
    this.v6i_1 = id;
    this.w6i_1 = p;
    this.x6i_1 = force;
    this.y6i_1 = status;
    this.z6i_1 = kind;
    this.a6j_1 = button;
  }
  b6j() {
    return this.w6i_1.a2a_1;
  }
  c6j() {
    return this.w6i_1.b2a_1;
  }
  c17() {
    return !this.y6i_1.equals(Status_REMOVE_getInstance());
  }
  d6j(other) {
    this.v6i_1 = other.v6i_1;
    this.w6i_1 = other.w6i_1;
    this.x6i_1 = other.x6i_1;
    this.y6i_1 = other.y6i_1;
    this.z6i_1 = other.z6i_1;
    this.a6j_1 = other.a6j_1;
  }
  hashCode() {
    return this.u6i_1;
  }
  equals(other) {
    var tmp;
    if (other instanceof Touch) {
      tmp = this.u6i_1 === other.u6i_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  toString() {
    return 'Touch(index=' + this.u6i_1 + ', id=' + this.v6i_1 + ', p=' + this.w6i_1.toString() + ', force=' + this.x6i_1 + ', status=' + this.y6i_1.toString() + ', kind=' + this.z6i_1.toString() + ', button=' + this.a6j_1.toString() + ')';
  }
  yz(value) {
    this.t6i_1.yz(value);
  }
  zz() {
    return this.t6i_1.zz();
  }
}
class Companion_13 {
  constructor() {
    Companion_instance_22 = this;
    this.e6j_1 = values_3();
  }
}
class Type_3 extends Enum {}
class Companion_14 {
  constructor() {
    this.f6j_1 = 10;
  }
}
class TouchEvent extends Event {
  constructor(type, screen, currentTime, scaleCoords, emulated) {
    type = type === VOID ? Type_START_getInstance_0() : type;
    screen = screen === VOID ? 0 : screen;
    currentTime = currentTime === VOID ? Companion_getInstance_8().o1x_1 : currentTime;
    scaleCoords = scaleCoords === VOID ? true : scaleCoords;
    emulated = emulated === VOID ? false : emulated;
    super();
    this.i6j_1 = type;
    this.j6j_1 = screen;
    this.k6j_1 = currentTime;
    this.l6j_1 = scaleCoords;
    this.m6j_1 = emulated;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = Companion_instance_23.f6j_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = new Touch(tmp_3);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.n6j_1 = tmp_2;
    this.o6j_1 = FastArrayList.q10();
    this.p6j_1 = FastArrayList.q10();
    this.q6j_1 = FastIntMap();
  }
  c2e() {
    return this.i6j_1;
  }
  r6j() {
    return this.o6j_1;
  }
  s6j() {
    return this.r6j().f1();
  }
  t6j(id) {
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.q6j_1.get(id);
  }
  toString() {
    var tmp = toString(this.i6j_1);
    var tmp_0 = this.s6j();
    var tmp_1 = this.r6j();
    return 'TouchEvent[' + tmp + '][' + tmp_0 + '](' + joinToString(tmp_1, ', ', VOID, VOID, VOID, VOID, TouchEvent$toString$lambda) + ')';
  }
  u6j(type) {
    this.i6j_1 = type;
    this.k6j_1 = Companion_getInstance_8().s1x();
    this.o6j_1.k3();
    // Inline function 'korlibs.datastructure.clear' call
    // Inline function 'kotlin.js.asDynamic' call
    this.q6j_1.clear();
  }
  v6j() {
    this.p6j_1.k3();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.r6j();
    var n = 0;
    while (n < this_0.f1()) {
      // Inline function 'korlibs.event.TouchEvent.endFrame.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0.e1(_unary__edvuaz);
      if (it.c17()) {
        this.p6j_1.h(it);
      }
    }
  }
  w6j(id) {
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_elvis_lhs = this.q6j_1.get(id);
    return tmp0_elvis_lhs == null ? this.x6j(id) : tmp0_elvis_lhs;
  }
  x6j(id) {
    var touch = this.n6j_1[this.o6j_1.f1()];
    touch.v6i_1 = id;
    this.o6j_1.h(touch);
    // Inline function 'korlibs.datastructure.set' call
    var this_0 = this.q6j_1;
    var key = touch.v6i_1;
    // Inline function 'kotlin.js.asDynamic' call
    this_0.set(key, touch);
    return touch;
  }
  y6j(id, p, status, force, kind, button) {
    var touch = this.w6j(id);
    touch.w6i_1 = p;
    touch.y6i_1 = status;
    touch.x6i_1 = force;
    touch.z6i_1 = kind;
    touch.a6j_1 = button;
  }
  z6j(id, p, status, force, kind, button, $super) {
    status = status === VOID ? Status_KEEP_getInstance() : status;
    force = force === VOID ? 1.0 : force;
    kind = kind === VOID ? Kind_FINGER_getInstance() : kind;
    button = button === VOID ? MouseButton_LEFT_getInstance() : button;
    var tmp;
    if ($super === VOID) {
      this.y6j(id, p, status, force, kind, button);
      tmp = Unit_instance;
    } else {
      tmp = $super.y6j.call(this, id, p, status, force, kind, button);
    }
    return tmp;
  }
  a6k(touch) {
    this.y6j(touch.v6i_1, touch.w6i_1, touch.y6i_1, touch.x6i_1, touch.z6i_1, touch.a6j_1);
  }
  b6k(other) {
    this.i6j_1 = other.i6j_1;
    this.j6j_1 = other.j6j_1;
    this.k6j_1 = other.k6j_1;
    this.l6j_1 = other.l6j_1;
    this.m6j_1 = other.m6j_1;
    var inductionVariable = 0;
    var last = Companion_instance_23.f6j_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.n6j_1[n].d6j(other.n6j_1[n]);
      }
       while (inductionVariable < last);
    this.o6j_1.k3();
    this.p6j_1.k3();
    // Inline function 'korlibs.datastructure.clear' call
    // Inline function 'kotlin.js.asDynamic' call
    this.q6j_1.clear();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = other.r6j();
    var n_0 = 0;
    while (n_0 < this_0.f1()) {
      // Inline function 'korlibs.event.TouchEvent.copyFrom.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      var otherTouch = this_0.e1(_unary__edvuaz);
      var touch = this.n6j_1[otherTouch.u6i_1];
      this.o6j_1.h(touch);
      if (touch.c17()) {
        this.p6j_1.h(touch);
      }
      // Inline function 'korlibs.datastructure.set' call
      var this_1 = this.q6j_1;
      var key = touch.v6i_1;
      // Inline function 'kotlin.js.asDynamic' call
      this_1.set(key, touch);
    }
  }
  c6k() {
    return this.i6j_1.equals(Type_START_getInstance_0());
  }
  d6k() {
    return this.i6j_1.equals(Type_END_getInstance_0());
  }
  hashCode() {
    var result = this.i6j_1.hashCode();
    result = imul(result, 31) + this.j6j_1 | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.k6j_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l6j_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.m6j_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TouchEvent))
      return false;
    var tmp0_other_with_cast = other instanceof TouchEvent ? other : THROW_CCE();
    if (!this.i6j_1.equals(tmp0_other_with_cast.i6j_1))
      return false;
    if (!(this.j6j_1 === tmp0_other_with_cast.j6j_1))
      return false;
    if (!equals(this.k6j_1, tmp0_other_with_cast.k6j_1))
      return false;
    if (!(this.l6j_1 === tmp0_other_with_cast.l6j_1))
      return false;
    if (!(this.m6j_1 === tmp0_other_with_cast.m6j_1))
      return false;
    return true;
  }
}
class Mode extends Enum {}
class TouchBuilder {
  constructor() {
    this.e6k_1 = new TouchEvent();
    this.f6k_1 = new TouchEvent();
    this.g6k_1 = Mode_JS_getInstance();
  }
  h6k(type, scaleCoords) {
    this.f6k_1.l6j_1 = scaleCoords;
    this.f6k_1.u6j(type);
    if (this.g6k_1.r3_1 === 2) {
      this.f6k_1.b6k(this.e6k_1);
      this.f6k_1.i6j_1 = type;
      // Inline function 'korlibs.datastructure.iterators.fastIterateRemove' call
      var this_0 = this.f6k_1.o6j_1;
      var n = 0;
      var m = 0;
      while (n < this_0.f1()) {
        if (m >= 0 && !(m === n)) {
          this_0.o3(m, this_0.e1(n));
        }
        // Inline function 'korlibs.event.TouchBuilder.startFrame.<anonymous>' call
        var it = this_0.e1(n);
        var tmp;
        if (it.c17()) {
          it.y6i_1 = Status_KEEP_getInstance();
          tmp = false;
        } else {
          // Inline function 'korlibs.datastructure.remove' call
          var this_1 = this.f6k_1.q6j_1;
          var key = it.v6i_1;
          // Inline function 'kotlin.js.asDynamic' call
          this_1.delete(key);
          tmp = true;
        }
        if (tmp) {
          m = m - 1 | 0;
        }
        n = n + 1 | 0;
        m = m + 1 | 0;
      }
      while (this_0.f1() > m) {
        this_0.p3(this_0.f1() - 1 | 0);
      }
    }
  }
  i6k() {
    switch (this.g6k_1.r3_1) {
      case 0:
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var this_0 = this.e6k_1.r6j();
        var n = 0;
        while (n < this_0.f1()) {
          // Inline function 'korlibs.event.TouchBuilder.endFrame.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          var oldTouch = this_0.e1(_unary__edvuaz);
          if (this.f6k_1.t6j(oldTouch.v6i_1) == null) {
            if (oldTouch.c17()) {
              oldTouch.y6i_1 = Status_REMOVE_getInstance();
              this.f6k_1.a6k(oldTouch);
            }
          }
        }

        break;
      case 2:
        break;
      default:
        break;
    }
    this.f6k_1.v6j();
    this.e6k_1.b6k(this.f6k_1);
    return this.f6k_1;
  }
  j6k(id, p, force, kind, button) {
    var touch = this.f6k_1.w6j(id);
    touch.w6i_1 = p;
    touch.x6i_1 = force;
    touch.z6i_1 = kind;
    touch.a6j_1 = button;
    if (this.g6k_1.r3_1 === 2) {
      var tmp = touch;
      switch (this.f6k_1.i6j_1.r3_1) {
        case 0:
          tmp.y6i_1 = Status_ADD_getInstance();
          break;
        case 1:
          tmp.y6i_1 = Status_REMOVE_getInstance();
          break;
        default:
          tmp.y6i_1 = Status_KEEP_getInstance();
          break;
      }
    } else {
      var oldTouch = this.e6k_1.t6j(id);
      touch.y6i_1 = oldTouch == null ? Status_ADD_getInstance() : Status_KEEP_getInstance();
    }
  }
  k6k(id, p, force, kind, button, $super) {
    force = force === VOID ? 1.0 : force;
    kind = kind === VOID ? Kind_FINGER_getInstance() : kind;
    button = button === VOID ? MouseButton_LEFT_getInstance() : button;
    var tmp;
    if ($super === VOID) {
      this.j6k(id, p, force, kind, button);
      tmp = Unit_instance;
    } else {
      tmp = $super.j6k.call(this, id, p, force, kind, button);
    }
    return tmp;
  }
}
class GamepadInfoEmitter {
  constructor(dispatcher) {
    this.l6k_1 = dispatcher;
    this.m6k_1 = booleanArray(4);
    this.n6k_1 = new GamePadUpdateEvent();
    this.o6k_1 = new GamePadConnectionEvent();
    this.p6k_1 = IntArrayList.m2o();
  }
  q6k() {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.n6k_1.u6k_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.event.GamepadInfoEmitter.dispatchGamepadUpdateStart.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0[_unary__edvuaz].w6k_1 = false;
    }
    this.n6k_1.t6k_1 = 0;
  }
  c6l(info) {
    var _receiver__tnumb7 = this.n6k_1;
    var _unary__edvuaz = _receiver__tnumb7.t6k_1;
    _receiver__tnumb7.t6k_1 = _unary__edvuaz + 1 | 0;
    var index = _unary__edvuaz;
    var pad = this.n6k_1.u6k_1[index];
    pad.d6l(info);
    pad.w6k_1 = true;
    pad.v6k_1 = index;
  }
  e6l(out) {
    out.k3();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.n6k_1.u6k_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.event.GamepadInfoEmitter.dispatchGamepadUpdateEnd.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0[_unary__edvuaz];
      if (!(this.m6k_1[it.v6k_1] === it.w6k_1)) {
        this.m6k_1[it.v6k_1] = it.w6k_1;
        out.s2o(it.v6k_1);
        if (!it.w6k_1) {
          it.x6k_1 = null;
        }
        // Inline function 'kotlin.apply' call
        var this_1 = this.o6k_1;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.event.GamepadInfoEmitter.dispatchGamepadUpdateEnd.<anonymous>.<anonymous>' call
        this_1.h6l_1 = Companion_getInstance_32().k6l(it.w6k_1);
        this_1.i6l_1 = it.v6k_1;
        this.l6k_1.i6f(this_1);
      }
    }
    this.l6k_1.i6f(this.n6k_1);
    return out;
  }
}
class BatteryStatus extends Enum {}
class Companion_15 {
  constructor() {
    this.l6l_1 = 'Wireless Controller';
    this.m6l_1 = 4;
    this.n6l_1 = 0.075;
  }
  o6l(value, margin, apply) {
    var tmp;
    if (apply) {
      // Inline function 'kotlin.math.absoluteValue' call
      tmp = Math.abs(value) < margin;
    } else {
      tmp = false;
    }
    if (tmp)
      return 0.0;
    return value;
  }
  p6l(value, margin, apply, $super) {
    margin = margin === VOID ? 0.075 : margin;
    apply = apply === VOID ? true : apply;
    return $super === VOID ? this.o6l(value, margin, apply) : $super.o6l.call(this, value, margin, apply);
  }
}
class GamepadInfo {
  constructor(index, connected, name, rawButtons, batteryLevel, name2, batteryStatus) {
    index = index === VOID ? 0 : index;
    connected = connected === VOID ? false : connected;
    name = name === VOID ? null : name;
    rawButtons = rawButtons === VOID ? new Float32Array(32) : rawButtons;
    batteryLevel = batteryLevel === VOID ? 1.0 : batteryLevel;
    name2 = name2 === VOID ? Companion_instance_24.l6l_1 : name2;
    batteryStatus = batteryStatus === VOID ? BatteryStatus_UNKNOWN_getInstance() : batteryStatus;
    this.v6k_1 = index;
    this.w6k_1 = connected;
    this.x6k_1 = name;
    this.y6k_1 = rawButtons;
    this.z6k_1 = batteryLevel;
    this.a6l_1 = name2;
    this.b6l_1 = batteryStatus;
  }
  q6l() {
    var tmp0_elvis_lhs = this.x6k_1;
    return (tmp0_elvis_lhs == null ? 'unknown' : tmp0_elvis_lhs) + ' - ' + this.a6l_1;
  }
  d6l(that) {
    this.v6k_1 = that.v6k_1;
    this.x6k_1 = that.x6k_1;
    this.a6l_1 = that.a6l_1;
    this.w6k_1 = that.w6k_1;
    this.z6k_1 = that.z6k_1;
    this.b6l_1 = that.b6l_1;
    var tmp = that.y6k_1;
    var tmp_0 = this.y6k_1;
    // Inline function 'kotlin.math.min' call
    var a = this.y6k_1.length;
    var b = that.y6k_1.length;
    var tmp$ret$0 = Math.min(a, b);
    arraycopy(tmp, 0, tmp_0, 0, tmp$ret$0);
  }
  r6l(button) {
    return this.y6k_1[button.u6l()];
  }
  v6l(includeButtons) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.event.GamepadInfo.toStringEx.<anonymous>' call
    this_0.bc('Gamepad[' + this.v6k_1 + '][' + this.q6l() + ']');
    if (includeButtons) {
      this_0.bc('[');
      var count = 0;
      var indexedObject = values_5();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var button = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var value = this.r6l(button);
        if (!(value === 0.0)) {
          if (count > 0) {
            this_0.bc(',');
          }
          this_0.bc(button.toString() + '=' + get_niceStr(value));
          count = count + 1 | 0;
        }
      }
      this_0.bc(']');
    }
    return this_0.toString();
  }
  w6l(includeButtons, $super) {
    includeButtons = includeButtons === VOID ? true : includeButtons;
    return $super === VOID ? this.v6l(includeButtons) : $super.v6l.call(this, includeButtons);
  }
  toString() {
    return this.v6l(false);
  }
}
class Companion_16 {}
class GamePadUpdateEvent extends Event {
  constructor(gamepadsLength, gamepads) {
    gamepadsLength = gamepadsLength === VOID ? 0 : gamepadsLength;
    var tmp;
    if (gamepads === VOID) {
      var tmp_0 = 0;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = fillArrayVal(Array(4), null);
      while (tmp_0 < 4) {
        var tmp_2 = tmp_0;
        tmp_1[tmp_2] = new GamepadInfo(tmp_2);
        tmp_0 = tmp_0 + 1 | 0;
      }
      tmp = tmp_1;
    } else {
      tmp = gamepads;
    }
    gamepads = tmp;
    super();
    this.t6k_1 = gamepadsLength;
    this.u6k_1 = gamepads;
  }
  c2e() {
    return Companion_instance_25;
  }
  toString() {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.u6k_1;
    var destination = ArrayList.j1();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.event.GamePadUpdateEvent.toString.<anonymous>' call
      if (element.w6k_1) {
        destination.h(element);
      }
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(destination, 10));
    var tmp0_iterator = destination.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.event.GamePadUpdateEvent.toString.<anonymous>' call
      var tmp$ret$3 = item.w6l();
      destination_0.h(tmp$ret$3);
    }
    return 'GamePadUpdateEvent(' + toString(destination_0) + ')';
  }
  hashCode() {
    var result = this.t6k_1;
    result = imul(result, 31) + hashCode(this.u6k_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadUpdateEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GamePadUpdateEvent ? other : THROW_CCE();
    if (!(this.t6k_1 === tmp0_other_with_cast.t6k_1))
      return false;
    if (!equals(this.u6k_1, tmp0_other_with_cast.u6k_1))
      return false;
    return true;
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_26 = this;
    this.j6l_1 = values_4();
  }
  k6l(connected) {
    return connected ? Type_CONNECTED_getInstance() : Type_DISCONNECTED_getInstance();
  }
}
class Type_4 extends Enum {}
class GamePadConnectionEvent extends Event {
  constructor(type, gamepad) {
    type = type === VOID ? Type_CONNECTED_getInstance() : type;
    gamepad = gamepad === VOID ? 0 : gamepad;
    super();
    this.h6l_1 = type;
    this.i6l_1 = gamepad;
  }
  c2e() {
    return this.h6l_1;
  }
  toString() {
    return 'GamePadConnectionEvent(type=' + toString(this.h6l_1) + ', gamepad=' + this.i6l_1 + ')';
  }
  hashCode() {
    var result = this.h6l_1.hashCode();
    result = imul(result, 31) + this.i6l_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadConnectionEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GamePadConnectionEvent ? other : THROW_CCE();
    if (!this.h6l_1.equals(tmp0_other_with_cast.h6l_1))
      return false;
    if (!(this.i6l_1 === tmp0_other_with_cast.i6l_1))
      return false;
    return true;
  }
}
class Companion_18 {
  constructor() {
    Companion_instance_27 = this;
    this.x6l_1 = values_5();
    this.y6l_1 = 32;
  }
}
class GameButton extends Enum {
  u6l() {
    return this.r3_1;
  }
}
class Companion_19 {
  constructor() {
    Companion_instance_28 = this;
    this.z6l_1 = Key_UNKNOWN_getInstance().r3_1 + 1 | 0;
    this.a6m_1 = Key_ENTER_getInstance();
    this.b6m_1 = Key_N0_getInstance();
    this.c6m_1 = Key_N1_getInstance();
    this.d6m_1 = Key_N2_getInstance();
    this.e6m_1 = Key_N3_getInstance();
    this.f6m_1 = Key_N4_getInstance();
    this.g6m_1 = Key_N5_getInstance();
    this.h6m_1 = Key_N6_getInstance();
    this.i6m_1 = Key_N7_getInstance();
    this.j6m_1 = Key_N8_getInstance();
    this.k6m_1 = Key_N9_getInstance();
  }
  l6m() {
    return Key_CONTROL_getInstance();
  }
  m6m() {
    return Key_CONTROL_getInstance();
  }
  n6m() {
    return Key_SHIFT_getInstance();
  }
  o6m() {
    return Key_SHIFT_getInstance();
  }
  p6m() {
    return Key_ALT_getInstance();
  }
  q6m() {
    return Key_ALT_getInstance();
  }
  r6m() {
    return Key_SUPER_getInstance();
  }
  s6m() {
    return Key_SUPER_getInstance();
  }
}
class Key extends Enum {
  v6m() {
    switch (this.r3_1) {
      case 81:
      case 82:
      case 83:
      case 84:
      case 85:
      case 86:
      case 87:
      case 88:
      case 89:
      case 90:
      case 91:
      case 92:
      case 93:
      case 94:
      case 95:
      case 96:
      case 97:
      case 98:
      case 99:
      case 100:
      case 101:
      case 102:
      case 103:
      case 104:
      case 105:
        return true;
      default:
        return false;
    }
  }
}
class Companion_20 {
  constructor() {
    Companion_instance_29 = this;
    this.w6m_1 = MouseButton_NONE_getInstance().r3_1 + 1 | 0;
    this.x6m_1 = values_6();
  }
  e1(id) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = this.x6m_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= id ? id <= (this_0.length - 1 | 0) : false) {
      tmp = this_0[id];
    } else {
      // Inline function 'korlibs.event.Companion.get.<anonymous>' call
      tmp = MouseButton_BUTTON_UNKNOWN_getInstance();
    }
    return tmp;
  }
}
class MouseButton extends Enum {
  constructor(name, ordinal, id, bits) {
    bits = bits === VOID ? 1 << id : bits;
    super(name, ordinal);
    this.a6n_1 = id;
    this.b6n_1 = bits;
  }
  c6n() {
    return this.equals(MouseButton_LEFT_getInstance());
  }
}
class Companion_21 {
  constructor() {
    Companion_instance_30 = this;
    this.d6n_1 = Companion_getInstance_1().ey('AG');
    this.e6n_1 = 96.0;
  }
}
class AGFeatures {}
function get_parentFeatures() {
  return null;
}
function get_isUniformBuffersSupported() {
  var tmp0_safe_receiver = this.f6o();
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g6o();
  return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
}
function get_isVertexArraysSupported() {
  var tmp0_safe_receiver = this.f6o();
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h6o();
  return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
}
class AG {
  static j6n() {
    Companion_getInstance_36();
    var $this = createThis(this);
    $this.f6n_1 = new Mixin();
    $this.g6n_1 = AGFrameBuffer.x6n(true);
    $this.h6n_1 = 0;
    $this.i6n_1 = new AGStats();
    return $this;
  }
  y6n() {
    return this.g6n_1;
  }
  z6n() {
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = Companion_getInstance_36().d6n_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.x2x(level)) {
      // Inline function 'korlibs.graphics.AG.contextLost.<anonymous>' call
      this_0.y2x(level, this);
      tmp = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_1 = Companion_getInstance_36().d6n_1;
    var level_0 = Level_INFO_getInstance();
    var tmp_0;
    if (this_1.x2x(level_0)) {
      // Inline function 'korlibs.graphics.AG.contextLost.<anonymous>' call
      var tmp$ret$2 = 'AG.contextLost()';
      this_1.y2x(level_0, tmp$ret$2);
      tmp_0 = Unit_instance;
    }
    this.h6n_1 = this.h6n_1 + 1 | 0;
  }
  a6o() {
    return this.b6o(AGFinish_instance);
  }
  c6o() {
    return Unit_instance;
  }
  v6j() {
    return Unit_instance;
  }
  b6o(command) {
    return Unit_instance;
  }
  d6o(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    return this.b6o(new AGClear(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil));
  }
  e6o(frameBuffer, frameBufferInfo, vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances) {
    return this.b6o(new AGBatch(frameBuffer, frameBufferInfo, vertexData, indices, indexType, program, uniformBlocks, textureUnits, blending, stencilOpFunc, stencilRef, colorMask, depthAndFrontFace, scissor, cullFace, drawType, drawOffset, vertexCount, instances));
  }
  yz(value) {
    this.f6n_1.yz(value);
  }
  zz() {
    return this.f6n_1.zz();
  }
}
class Immutable {
  constructor(parentFeatures, graphicExtensions, isInstancedSupported, isUniformBuffersSupported, isVertexArraysSupported, isStorageMultisampleSupported, isFloatTextureSupported) {
    parentFeatures = parentFeatures === VOID ? null : parentFeatures;
    graphicExtensions = graphicExtensions === VOID ? emptySet() : graphicExtensions;
    isInstancedSupported = isInstancedSupported === VOID ? false : isInstancedSupported;
    isUniformBuffersSupported = isUniformBuffersSupported === VOID ? false : isUniformBuffersSupported;
    isVertexArraysSupported = isVertexArraysSupported === VOID ? false : isVertexArraysSupported;
    isStorageMultisampleSupported = isStorageMultisampleSupported === VOID ? false : isStorageMultisampleSupported;
    isFloatTextureSupported = isFloatTextureSupported === VOID ? false : isFloatTextureSupported;
    this.r6p_1 = parentFeatures;
    this.s6p_1 = graphicExtensions;
    this.t6p_1 = isInstancedSupported;
    this.u6p_1 = isUniformBuffersSupported;
    this.v6p_1 = isVertexArraysSupported;
    this.w6p_1 = isStorageMultisampleSupported;
    this.x6p_1 = isFloatTextureSupported;
  }
  f6o() {
    return this.r6p_1;
  }
  g6o() {
    return this.u6p_1;
  }
  h6o() {
    return this.v6p_1;
  }
  toString() {
    return 'Immutable(parentFeatures=' + toString_1(this.r6p_1) + ', graphicExtensions=' + toString(this.s6p_1) + ', isInstancedSupported=' + this.t6p_1 + ', isUniformBuffersSupported=' + this.u6p_1 + ', isVertexArraysSupported=' + this.v6p_1 + ', isStorageMultisampleSupported=' + this.w6p_1 + ', isFloatTextureSupported=' + this.x6p_1 + ')';
  }
  hashCode() {
    var result = this.r6p_1 == null ? 0 : hashCode(this.r6p_1);
    result = imul(result, 31) + hashCode(this.s6p_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.t6p_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.u6p_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.v6p_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.w6p_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.x6p_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Immutable))
      return false;
    var tmp0_other_with_cast = other instanceof Immutable ? other : THROW_CCE();
    if (!equals(this.r6p_1, tmp0_other_with_cast.r6p_1))
      return false;
    if (!equals(this.s6p_1, tmp0_other_with_cast.s6p_1))
      return false;
    if (!(this.t6p_1 === tmp0_other_with_cast.t6p_1))
      return false;
    if (!(this.u6p_1 === tmp0_other_with_cast.u6p_1))
      return false;
    if (!(this.v6p_1 === tmp0_other_with_cast.v6p_1))
      return false;
    if (!(this.w6p_1 === tmp0_other_with_cast.w6p_1))
      return false;
    if (!(this.x6p_1 === tmp0_other_with_cast.x6p_1))
      return false;
    return true;
  }
}
class AGObject {
  constructor() {
    this.y6q_1 = null;
    this.z6q_1 = -1;
    this.a6r_1 = -2;
    this.b6r_1 = -1;
  }
  g6r() {
    this.c6r();
    this.a6r_1 = this.b6r_1 - 1 | 0;
  }
  c6r() {
    this.b6r_1 = this.b6r_1 + 1 | 0;
  }
  n6() {
    var tmp0_safe_receiver = this.y6q_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.h6u();
    }
    this.y6q_1 = null;
  }
}
class AGBuffer extends AGObject {
  constructor() {
    super();
    this.x6q_1 = null;
  }
  d6r(data, offset, length) {
    return upload(this, _Int8Buffer___get_buffer__impl__q0gulb(_Int8Buffer___init__impl__e20lvc(data, offset, length)), false);
  }
  e6r(data, offset, length) {
    return upload(this, sliceWithSize(data, offset, length), true);
  }
  f6r(data) {
    return upload(this, data, true);
  }
  toString() {
    var tmp0_safe_receiver = this.x6q_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r14();
    return 'AGBuffer(' + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) + ')';
  }
}
class Companion_22 {
  constructor() {
    this.t6o_1 = 8;
  }
  u6o() {
    return AGTextureUnits.j6r();
  }
}
class AGTextureUnits {
  static k6r(textures, infos) {
    var $this = createThis(this);
    $this.h6r_1 = textures;
    $this.i6r_1 = infos;
    return $this;
  }
  static j6r(size) {
    size = size === VOID ? Companion_instance_31.t6o_1 : size;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$0 = fillArrayVal(Array(size), null);
    return this.k6r(tmp$ret$0, _AGTextureUnitInfoArray___init__impl__c77rdb_0(size));
  }
  f1() {
    return this.h6r_1.length;
  }
  l6r(index, texture, info) {
    this.h6r_1[index] = texture;
    AGTextureUnitInfoArray__set_impl_s95rfh(this.i6r_1, index, info);
  }
  m6r(sampler, texture, info) {
    this.l6r(sampler.y6r_1, texture, info);
  }
  a6s(sampler, texture, info, $super) {
    info = info === VOID ? Companion_getInstance_39().c6s_1 : info;
    var tmp;
    if ($super === VOID) {
      this.m6r(sampler, texture, info);
      tmp = Unit_instance;
    } else {
      tmp = $super.m6r.call(this, sampler, texture, new AGTextureUnitInfo(info));
    }
    return tmp;
  }
  k3() {
    var inductionVariable = 0;
    var last = this.f1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.l6r(n, null, Companion_getInstance_39().c6s_1);
      }
       while (inductionVariable < last);
  }
  uz() {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.h6r_1.slice();
    return AGTextureUnits.k6r(tmp$ret$1, AGTextureUnitInfoArray__copyOf_impl_z2w8z3(this.i6r_1));
  }
  toString() {
    return 'AGTextureUnits(textures=' + toString(this.h6r_1) + ', infos=' + AGTextureUnitInfoArray__toString_impl_kr9cgh(this.i6r_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.h6r_1);
    result = imul(result, 31) + AGTextureUnitInfoArray__hashCode_impl_siosps(this.i6r_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGTextureUnits))
      return false;
    var tmp0_other_with_cast = other instanceof AGTextureUnits ? other : THROW_CCE();
    if (!equals(this.h6r_1, tmp0_other_with_cast.h6r_1))
      return false;
    if (!equals(this.i6r_1, tmp0_other_with_cast.i6r_1))
      return false;
    return true;
  }
}
class Companion_23 {
  constructor() {
    this.d6s_1 = 128;
    this.e6s_1 = 128;
  }
}
class AGFrameBuffer {
  static f6s(base, id) {
    id = id === VOID ? -1 : id;
    var $this = createThis(this);
    $this.k6n_1 = base;
    $this.l6n_1 = id;
    $this.m6n_1 = 1;
    $this.n6n_1 = true;
    $this.o6n_1 = true;
    $this.p6n_1 = 0;
    $this.q6n_1 = 0;
    $this.r6n_1 = 128;
    $this.s6n_1 = 128;
    $this.t6n_1 = 128;
    $this.u6n_1 = 128;
    $this.v6n_1 = RectangleInt.k2j();
    $this.w6n_1 = null;
    return $this;
  }
  static x6n(isMain, id) {
    isMain = isMain === VOID ? false : isMain;
    id = id === VOID ? -1 : id;
    return this.f6s(new AGFrameBufferBase(isMain), id);
  }
  g6s() {
    return this.k6n_1.g6s();
  }
  o6s() {
    return this.k6n_1.l6s_1;
  }
  p6s() {
    return this.k6n_1.m6s_1;
  }
  q6p() {
    return AGFrameBufferInfo__withHasStencil_impl_nbaemo(AGFrameBufferInfo__withHasDepth_impl_fjgbiv(AGFrameBufferInfo__withSamples_impl_83818f(AGFrameBufferInfo__withBounds_impl_sg0n3x(_AGFrameBufferInfo___init__impl__dbxiro(new Long(0, 0)), this.p6n_1, this.q6n_1, this.r6n_1, this.s6n_1), this.m6n_1), this.o6n_1), this.n6n_1);
  }
  q6s(width, height) {
    return this.r6s(0, 0, width, height);
  }
  s6s(x, y, width, height, fullWidth, fullHeight) {
    if (this.p6n_1 === x && this.q6n_1 === y && this.r6n_1 === width && this.s6n_1 === height && this.t6n_1 === fullWidth && this.u6n_1 === fullHeight)
      return true;
    this.p6s().h6t(NullBitmap.c4e(width, height));
    this.k6n_1.n6s_1 = Companion_getInstance_9().q16(imul(imul(fullWidth, fullHeight), 8));
    this.p6n_1 = x;
    this.q6n_1 = y;
    this.r6n_1 = width;
    this.s6n_1 = height;
    this.t6n_1 = fullWidth;
    this.u6n_1 = fullHeight;
    markAsDirty(this);
    return false;
  }
  r6s(x, y, width, height, fullWidth, fullHeight, $super) {
    fullWidth = fullWidth === VOID ? width : fullWidth;
    fullHeight = fullHeight === VOID ? height : fullHeight;
    return $super === VOID ? this.s6s(x, y, width, height, fullWidth, fullHeight) : $super.s6s.call(this, x, y, width, height, fullWidth, fullHeight);
  }
  n6() {
    this.k6n_1.n6();
  }
  i6t(samples) {
    if (this.m6n_1 === samples)
      return Unit_instance;
    this.m6n_1 = samples;
    markAsDirty(this);
  }
  j6t(hasDepth, hasStencil) {
    if (this.o6n_1 === hasDepth && this.n6n_1 === hasStencil)
      return Unit_instance;
    this.o6n_1 = hasDepth;
    this.n6n_1 = hasStencil;
    markAsDirty(this);
  }
  toString() {
    return 'AGFrameBuffer(' + (this.o6s() ? 'main' : '' + this.l6n_1) + ', ' + this.r6n_1 + ', ' + this.s6n_1 + ')';
  }
}
class AGTexture extends AGObject {
  constructor(targetKind) {
    targetKind = targetKind === VOID ? Companion_getInstance_50().k6t_1 : targetKind;
    super();
    this.x6s_1 = targetKind;
    this.y6s_1 = Companion_getInstance_1().ey('AGTexture');
    this.z6s_1 = false;
    this.a6t_1 = false;
    this.b6t_1 = null;
    this.c6t_1 = null;
    this.d6t_1 = null;
    this.e6t_1 = false;
    this.f6t_1 = null;
    this.g6t_1 = Companion_getInstance_9().r16(new Long(0, 0));
  }
  o6t() {
    var tmp0_safe_receiver = this.f6t_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a4d();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.graphics.AGTexture.<get-implForcedTexTarget>.<anonymous>' call
      tmp = fromGl(Companion_getInstance_50(), tmp1_safe_receiver);
    }
    var tmp2_elvis_lhs = tmp;
    var tmp_0;
    var tmp_1 = tmp2_elvis_lhs;
    if ((tmp_1 == null ? null : new AGTextureTargetKind(tmp_1)) == null) {
      tmp_0 = this.x6s_1;
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    return tmp_0;
  }
  d2m() {
    var tmp0_safe_receiver = this.d6t_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z3y_1;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  }
  e2m() {
    var tmp0_safe_receiver = this.d6t_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a3z_1;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  }
  q6t() {
    var tmp = this.d6t_1;
    var tmp0_safe_receiver = (tmp == null ? true : tmp instanceof MultiBitmap) ? tmp : null;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e6u_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.f1();
    return tmp2_elvis_lhs == null ? 1 : tmp2_elvis_lhs;
  }
  f6u(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) {
    if (bmp == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      checkBitmaps(this, bmp);
    }
    var tmp = this;
    tmp.f6t_1 = (bmp == null ? true : isInterface(bmp, ForcedTexId)) ? bmp : null;
    this.d6t_1 = bmp;
    this.g6t_1 = Companion_getInstance_9().q16(imul(imul(imul(this.d2m(), this.e2m()), this.q6t()), 4));
    this.c6r();
    this.a6t_1 = mipmaps;
    this.b6t_1 = baseMipmapLevel;
    this.c6t_1 = maxMipmapLevel;
    return this;
  }
  h6t(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel, $super) {
    mipmaps = mipmaps === VOID ? false : mipmaps;
    baseMipmapLevel = baseMipmapLevel === VOID ? null : baseMipmapLevel;
    maxMipmapLevel = maxMipmapLevel === VOID ? null : maxMipmapLevel;
    return $super === VOID ? this.f6u(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) : $super.f6u.call(this, bmp, mipmaps, baseMipmapLevel, maxMipmapLevel);
  }
  g6u(bitmap, requestMipmaps) {
    var tmp1_elvis_lhs = bitmap == null ? null : bitmap.z3y_1;
    var width = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = bitmap == null ? null : bitmap.a3z_1;
    var height = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
    return requestMipmaps && get_isPowerOfTwo(width) && get_isPowerOfTwo(height);
  }
  toString() {
    return 'AGTexture(size=' + this.d2m() + ',' + this.e2m() + ')';
  }
}
class AGFrameBufferBase extends AGObject {
  constructor(isMain) {
    super();
    this.l6s_1 = isMain;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new AGTexture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.AGFrameBufferBase.tex.<anonymous>' call
    this_0.z6s_1 = true;
    tmp.m6s_1 = this_0;
    this.n6s_1 = Companion_getInstance_9().q16(0);
  }
  g6s() {
    return !this.l6s_1;
  }
  n6() {
    this.m6s_1.n6();
  }
  toString() {
    return 'AGFrameBufferBase(isMain=' + this.l6s_1 + ')';
  }
}
class Companion_24 {
  constructor() {
    Companion_instance_33 = this;
    this.b6s_1 = _AGTextureUnitInfo___init__impl__s1tthu(-1);
    this.c6s_1 = AGTextureUnitInfo__withKind_impl_aa0b04(AGTextureUnitInfo__withWrap_impl_akwb6y(AGTextureUnitInfo__withLinearTrilinear_impl_aactvz(_AGTextureUnitInfo___init__impl__s1tthu(0), true, true), Companion_getInstance_51().j6u_1), Companion_getInstance_50().k6t_1);
  }
  i6u(data) {
    return _AGTextureUnitInfo___init__impl__s1tthu(data);
  }
  m6u(wrap, linear, trilinear) {
    return AGTextureUnitInfo__withLinearTrilinear_impl_aactvz(AGTextureUnitInfo__withWrap_impl_akwb6y(_AGTextureUnitInfo___init__impl__s1tthu(0), wrap), linear, trilinear);
  }
  n6u(wrap, linear, trilinear, $super) {
    wrap = wrap === VOID ? Companion_getInstance_51().j6u_1 : wrap;
    linear = linear === VOID ? true : linear;
    trilinear = trilinear === VOID ? linear : trilinear;
    return $super === VOID ? this.m6u(wrap, linear, trilinear) : $super.m6u.call(this, new AGWrapMode(wrap), linear, trilinear).o6u_1;
  }
}
class AGTextureUnitInfo {
  constructor(data) {
    Companion_getInstance_39();
    this.o6u_1 = data;
  }
  toString() {
    return AGTextureUnitInfo__toString_impl_7im6je(this.o6u_1);
  }
  hashCode() {
    return AGTextureUnitInfo__hashCode_impl_e8jq9h(this.o6u_1);
  }
  equals(other) {
    return AGTextureUnitInfo__equals_impl_j2jlgn(this.o6u_1, other);
  }
}
class AGNativeObject {}
class BufferCache {
  constructor() {
    this.p6u_1 = FastIdentityMap();
  }
  p2u() {
    // Inline function 'korlibs.datastructure.fastForEach' call
    var this_0 = this.p6u_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.graphics.BufferCache.reset.<anonymous>' call
      ensureNotNull(get_0(this_0, it)).p2u();
    }
  }
  y6u() {
    // Inline function 'korlibs.datastructure.fastForEach' call
    var this_0 = this.p6u_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.graphics.BufferCache.uploadUpdatedBuffers.<anonymous>' call
      ensureNotNull(get_0(this_0, it)).z6u();
    }
  }
  a6v(block) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.p6u_1;
      var res = get_0(this_0, block);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.BufferCache.get.<anonymous>' call
      var out = new UniformBlockBuffer(block);
      set(this_0, block, out);
      tmp$ret$0 = out;
    }
    var tmp = tmp$ret$0;
    return tmp instanceof UniformBlockBuffer ? tmp : THROW_CCE();
  }
}
class AGProgramWithUniforms {
  constructor(program, bufferCache) {
    bufferCache = bufferCache === VOID ? new BufferCache() : bufferCache;
    this.b6v_1 = program;
    this.c6v_1 = bufferCache;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.b6v_1.o6v_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.graphics.AGProgramWithUniforms.uniformLayouts.<anonymous>' call
      var tmp$ret$0 = item.i6w_1;
      destination.h(tmp$ret$0);
    }
    tmp.d6v_1 = distinct(destination);
    var tmp_0 = this;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var iterator = this.d6v_1.b1();
      if (!iterator.c1()) {
        tmp$ret$3 = null;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.AGProgramWithUniforms.maxLocation.<anonymous>' call
      var maxValue = iterator.d1().k6w_1 + 1 | 0;
      while (iterator.c1()) {
        // Inline function 'korlibs.graphics.AGProgramWithUniforms.maxLocation.<anonymous>' call
        var v = iterator.d1().k6w_1 + 1 | 0;
        if (compareTo(maxValue, v) < 0) {
          maxValue = v;
        }
      }
      tmp$ret$3 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$3;
    tmp_0.e6v_1 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp_1 = this;
    // Inline function 'kotlin.also' call
    var tmp_2 = 0;
    var tmp_3 = this.e6v_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_4 = fillArrayVal(Array(tmp_3), null);
    while (tmp_2 < tmp_3) {
      tmp_4[tmp_2] = null;
      tmp_2 = tmp_2 + 1 | 0;
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.AGProgramWithUniforms.uniformsBlocks.<anonymous>' call
    var _iterator__ex2g4s = this.d6v_1.b1();
    while (_iterator__ex2g4s.c1()) {
      var layout = _iterator__ex2g4s.d1();
      tmp_4[layout.k6w_1] = layout;
    }
    tmp_1.f6v_1 = tmp_4;
    var tmp_5 = this;
    var tmp_6 = 0;
    var tmp_7 = this.f6v_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_8 = fillArrayVal(Array(tmp_7), null);
    while (tmp_6 < tmp_7) {
      var tmp_9 = tmp_6;
      var tmp0_safe_receiver = this.f6v_1[tmp_9];
      var tmp_10;
      if (tmp0_safe_receiver == null) {
        tmp_10 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.AGProgramWithUniforms.uniformsBlocksData.<anonymous>' call
        tmp_10 = this.c6v_1.a6v(tmp0_safe_receiver);
      }
      tmp_8[tmp_9] = tmp_10;
      tmp_6 = tmp_6 + 1 | 0;
    }
    tmp_5.g6v_1 = tmp_8;
    var tmp_11 = this;
    var tmp_12 = 0;
    var tmp_13 = this.f6v_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_14 = fillArrayVal(Array(tmp_13), null);
    while (tmp_12 < tmp_13) {
      var tmp_15 = tmp_12;
      var tmp0_safe_receiver_0 = this.g6v_1[tmp_15];
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.q6u_1;
      var tmp_16;
      if (tmp1_safe_receiver == null) {
        tmp_16 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.AGProgramWithUniforms.agUniformBlockDatas.<anonymous>' call
        tmp_16 = new UniformBlockBuffer(tmp1_safe_receiver);
      }
      tmp_14[tmp_15] = tmp_16;
      tmp_12 = tmp_12 + 1 | 0;
    }
    tmp_11.h6v_1 = tmp_14;
    var tmp_17 = this;
    var tmp_18 = 0;
    var tmp_19 = this.f6v_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_20 = fillArrayVal(Array(tmp_19), null);
    while (tmp_18 < tmp_19) {
      var tmp_21 = tmp_18;
      var tmp0_safe_receiver_1 = this.g6v_1[tmp_21];
      tmp_20[tmp_21] = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.r6u_1;
      tmp_18 = tmp_18 + 1 | 0;
    }
    tmp_17.i6v_1 = tmp_20;
    var tmp_22 = this;
    var tmp_23 = 0;
    var tmp_24 = this.f6v_1.length;
    var tmp_25 = new Int32Array(tmp_24);
    while (tmp_23 < tmp_24) {
      tmp_25[tmp_23] = 0;
      tmp_23 = tmp_23 + 1 | 0;
    }
    tmp_22.j6v_1 = tmp_25;
  }
  o6w() {
    var inductionVariable = 0;
    var last = this.j6v_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_safe_receiver = this.g6v_1[n];
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p6w();
        this.j6v_1[n] = tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
      }
       while (inductionVariable <= last);
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.j6v_1.slice();
    return new UniformBlocksBuffersRef(this.h6v_1, this.i6v_1, tmp$ret$1);
  }
}
class AGVertexArrayObject {
  static t6w(list, isDynamic) {
    isDynamic = isDynamic === VOID ? true : isDynamic;
    var $this = createThis(this);
    $this.q6w_1 = new Mixin();
    $this.r6w_1 = list;
    $this.s6w_1 = isDynamic;
    return $this;
  }
  static u6w(datas, isDynamic) {
    isDynamic = isDynamic === VOID ? true : isDynamic;
    return this.t6w(fastArrayListOf(datas.slice()), isDynamic);
  }
  toString() {
    return 'AGVertexArrayObject(list=' + this.r6w_1.toString() + ', isDynamic=' + this.s6w_1 + ')';
  }
  hashCode() {
    var result = this.r6w_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.s6w_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGVertexArrayObject))
      return false;
    var tmp0_other_with_cast = other instanceof AGVertexArrayObject ? other : THROW_CCE();
    if (!this.r6w_1.equals(tmp0_other_with_cast.r6w_1))
      return false;
    if (!(this.s6w_1 === tmp0_other_with_cast.s6w_1))
      return false;
    return true;
  }
  yz(value) {
    this.q6w_1.yz(value);
  }
  zz() {
    return this.q6w_1.zz();
  }
}
class AGVertexData {
  constructor(layout, buffer, baseOffset) {
    layout = layout === VOID ? ProgramLayout.d6x([]) : layout;
    buffer = buffer === VOID ? new AGBuffer() : buffer;
    baseOffset = baseOffset === VOID ? 0 : baseOffset;
    this.e6x_1 = layout;
    this.f6x_1 = buffer;
    this.g6x_1 = baseOffset;
  }
  toString() {
    return 'AGVertexData(layout=' + this.e6x_1.toString() + ', buffer=' + this.f6x_1.toString() + ', baseOffset=' + this.g6x_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.e6x_1);
    result = imul(result, 31) + hashCode(this.f6x_1) | 0;
    result = imul(result, 31) + this.g6x_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGVertexData))
      return false;
    var tmp0_other_with_cast = other instanceof AGVertexData ? other : THROW_CCE();
    if (!equals(this.e6x_1, tmp0_other_with_cast.e6x_1))
      return false;
    if (!equals(this.f6x_1, tmp0_other_with_cast.f6x_1))
      return false;
    if (!(this.g6x_1 === tmp0_other_with_cast.g6x_1))
      return false;
    return true;
  }
}
class Companion_25 {
  constructor() {
    Companion_instance_34 = this;
    this.h6x_1 = _AGDrawType___init__impl__emm6mb(0);
    this.i6x_1 = _AGDrawType___init__impl__emm6mb(1);
    this.j6x_1 = _AGDrawType___init__impl__emm6mb(2);
    this.k6x_1 = _AGDrawType___init__impl__emm6mb(3);
    this.l6x_1 = _AGDrawType___init__impl__emm6mb(4);
    this.m6x_1 = _AGDrawType___init__impl__emm6mb(5);
    this.n6x_1 = _AGDrawType___init__impl__emm6mb(6);
  }
}
class AGDrawType {
  constructor(ordinal) {
    Companion_getInstance_40();
    this.o6x_1 = ordinal;
  }
  toString() {
    return AGDrawType__toString_impl_eonaeb(this.o6x_1);
  }
  hashCode() {
    return AGDrawType__hashCode_impl_ylaury(this.o6x_1);
  }
  equals(other) {
    return AGDrawType__equals_impl_rtafo6(this.o6x_1, other);
  }
}
class Companion_26 {
  constructor() {
    Companion_instance_35 = this;
    this.i6o_1 = _AGIndexType___init__impl__yqnmb7(0);
    this.j6o_1 = _AGIndexType___init__impl__yqnmb7(1);
    this.k6o_1 = _AGIndexType___init__impl__yqnmb7(2);
    this.l6o_1 = _AGIndexType___init__impl__yqnmb7(3);
  }
}
class Companion_27 {
  constructor() {
    Companion_instance_36 = this;
    this.m6o_1 = _AGBlending___init__impl__upt3bq(-1);
    this.n6o_1 = Companion_getInstance_42().d6y(Companion_getInstance_52().v6x_1, Companion_getInstance_52().c6y_1, Companion_getInstance_52().v6x_1, Companion_getInstance_52().c6y_1);
    this.o6o_1 = Companion_getInstance_42().d6y(Companion_getInstance_52().a6y_1, Companion_getInstance_52().y6x_1, Companion_getInstance_52().v6x_1, Companion_getInstance_52().y6x_1);
    this.p6o_1 = Companion_getInstance_42().e6y(Companion_getInstance_52().v6x_1, Companion_getInstance_52().y6x_1);
    this.q6o_1 = Companion_getInstance_42().d6y(Companion_getInstance_52().a6y_1, Companion_getInstance_52().t6x_1, Companion_getInstance_52().v6x_1, Companion_getInstance_52().v6x_1);
    this.r6o_1 = Companion_getInstance_42().d6y(Companion_getInstance_52().v6x_1, Companion_getInstance_52().v6x_1, Companion_getInstance_52().v6x_1, Companion_getInstance_52().v6x_1);
  }
  f6y(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA) {
    return AGBlending__withEQ_impl_e9gm04(AGBlending__withDST_impl_y1hpet(AGBlending__withSRC_impl_hh0mjq(_AGBlending___init__impl__upt3bq(0), srcRGB, srcA), dstRGB, dstA), eqRGB, eqA);
  }
  d6y(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA, $super) {
    srcA = srcA === VOID ? srcRGB : srcA;
    dstA = dstA === VOID ? dstRGB : dstA;
    eqRGB = eqRGB === VOID ? Companion_getInstance_53().g6y_1 : eqRGB;
    eqA = eqA === VOID ? eqRGB : eqA;
    return $super === VOID ? this.f6y(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA) : $super.f6y.call(this, new AGBlendFactor(srcRGB), new AGBlendFactor(dstRGB), new AGBlendFactor(srcA), new AGBlendFactor(dstA), new AGBlendEquation(eqRGB), new AGBlendEquation(eqA)).p6x_1;
  }
  j6y(src, dst, eq) {
    return AGBlending__withEQ$default_impl_iltiw7(AGBlending__withDST$default_impl_leu6qg(AGBlending__withSRC$default_impl_uuu5hz(_AGBlending___init__impl__upt3bq(0), src), dst), eq);
  }
  e6y(src, dst, eq, $super) {
    eq = eq === VOID ? Companion_getInstance_53().g6y_1 : eq;
    return $super === VOID ? this.j6y(src, dst, eq) : $super.j6y.call(this, new AGBlendFactor(src), new AGBlendFactor(dst), new AGBlendEquation(eq)).p6x_1;
  }
}
class AGBlending {
  constructor(data) {
    Companion_getInstance_42();
    this.p6x_1 = data;
  }
  toString() {
    return AGBlending__toString_impl_d5hic6(this.p6x_1);
  }
  hashCode() {
    return AGBlending__hashCode_impl_ywnf51(this.p6x_1);
  }
  equals(other) {
    return AGBlending__equals_impl_rp3dmf(this.p6x_1, other);
  }
}
class Companion_28 {
  constructor() {
    Companion_instance_37 = this;
    this.h6p_1 = AGScissor.o6y(0, 0, 0, 0);
    this.i6p_1 = Companion_getInstance_43().d2i(-2147483648, -2147483648, 2147483647, 2147483647);
    this.j6p_1 = Companion_getInstance_43().d2i(-32766, -32766, 2147483647, 2147483647);
    this.k6p_1 = Companion_getInstance_43().d2i(-32767, -32767, 2147483647, 2147483647);
  }
  d2i(left, top, right, bottom) {
    return AGScissor.o6y(left, top, right - left | 0, bottom - top | 0);
  }
  p6y(left, top, right, bottom) {
    return AGScissor.q6y(left, top, right - left, bottom - top);
  }
  r6y(rect) {
    if (rect == null)
      return this.k6p_1;
    if (rect.p2a())
      return this.k6p_1;
    return AGScissor.s6y(rect.k2a_1, rect.l2a_1, rect.m2a_1, rect.n2a_1);
  }
  t6y(prev, next) {
    if (prev.equals(this.k6p_1))
      return next;
    if (next.equals(this.k6p_1))
      return prev;
    var intersectsX = prev.r2a() <= next.s2a() && prev.s2a() >= next.r2a();
    var intersectsY = prev.t2a() <= next.u2a() && prev.u2a() >= next.t2a();
    if (!intersectsX || !intersectsY)
      return this.h6p_1;
    // Inline function 'kotlin.math.max' call
    var a = prev.r2a();
    var b = next.r2a();
    var left = Math.max(a, b);
    // Inline function 'kotlin.math.max' call
    var a_0 = prev.t2a();
    var b_0 = next.t2a();
    var top = Math.max(a_0, b_0);
    // Inline function 'kotlin.math.min' call
    var a_1 = prev.s2a();
    var b_1 = next.s2a();
    var right = Math.min(a_1, b_1);
    // Inline function 'kotlin.math.min' call
    var a_2 = prev.u2a();
    var b_2 = next.u2a();
    var bottom = Math.min(a_2, b_2);
    return this.d2i(left, top, right, bottom);
  }
}
class AGScissor {
  static u6y(_left, _top, _right, _bottom) {
    Companion_getInstance_43();
    var $this = createThis(this);
    $this.k6y_1 = _left;
    $this.l6y_1 = _top;
    $this.m6y_1 = _right;
    $this.n6y_1 = _bottom;
    return $this;
  }
  p2a() {
    return this.equals(Companion_getInstance_43().k6p_1);
  }
  static o6y(x, y, width, height) {
    Companion_getInstance_43();
    return this.u6y(toShortClamped(x), toShortClamped(y), toShortClamped(x + width | 0), toShortClamped(y + height | 0));
  }
  static q6y(x, y, width, height) {
    Companion_getInstance_43();
    return this.o6y(toIntRound(x), toIntRound(y), toIntRound(width), toIntRound(height));
  }
  static s6y(x, y, width, height) {
    Companion_getInstance_43();
    return this.o6y(toIntRound_0(x), toIntRound_0(y), toIntRound_0(width), toIntRound_0(height));
  }
  r2a() {
    return this.k6y_1;
  }
  t2a() {
    return this.l6y_1;
  }
  s2a() {
    return this.m6y_1;
  }
  u2a() {
    return this.n6y_1;
  }
  b6j() {
    return this.r2a();
  }
  c6j() {
    return this.t2a();
  }
  d2m() {
    return this.s2a() - this.r2a() | 0;
  }
  e2m() {
    return this.u2a() - this.t2a() | 0;
  }
  toString() {
    if (this.equals(Companion_getInstance_43().k6p_1))
      return 'null';
    return 'Scissor(x=' + this.b6j() + ', y=' + this.c6j() + ', width=' + this.d2m() + ', height=' + this.e2m() + ')';
  }
  v6y() {
    return this.p2a() ? Companion_getInstance_5().z2a() : Companion_getInstance_5().z2h(this.b6j(), this.c6j(), this.d2m(), this.e2m());
  }
  w6y() {
    // Inline function 'kotlin.takeIf' call
    var this_0 = this.v6y();
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    // Inline function 'korlibs.graphics.AGScissor.toRectOrNull.<anonymous>' call
    if (this_0.q2a()) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    return tmp;
  }
  hashCode() {
    var result = this.k6y_1;
    result = imul(result, 31) + this.l6y_1 | 0;
    result = imul(result, 31) + this.m6y_1 | 0;
    result = imul(result, 31) + this.n6y_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGScissor))
      return false;
    var tmp0_other_with_cast = other instanceof AGScissor ? other : THROW_CCE();
    if (!(this.k6y_1 === tmp0_other_with_cast.k6y_1))
      return false;
    if (!(this.l6y_1 === tmp0_other_with_cast.l6y_1))
      return false;
    if (!(this.m6y_1 === tmp0_other_with_cast.m6y_1))
      return false;
    if (!(this.n6y_1 === tmp0_other_with_cast.n6y_1))
      return false;
    return true;
  }
}
class Companion_29 {
  constructor() {
    Companion_instance_38 = this;
    this.y6y_1 = _AGFrameBufferInfo___init__impl__dbxiro_0(0, 0);
    this.z6y_1 = _AGFrameBufferInfo___init__impl__dbxiro_0(-1, 0);
  }
}
class AGFinish {}
class AGClear {
  constructor(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil) {
    this.a6z_1 = frameBuffer;
    this.b6z_1 = frameBufferInfo;
    this.c6z_1 = color;
    this.d6z_1 = depth;
    this.e6z_1 = stencil;
    this.f6z_1 = clearColor;
    this.g6z_1 = clearDepth;
    this.h6z_1 = clearStencil;
  }
  toString() {
    return 'AGClear(frameBuffer=' + this.a6z_1.toString() + ', frameBufferInfo=' + AGFrameBufferInfo__toString_impl_xecyr8(this.b6z_1) + ', color=' + RGBA__toString_impl_4lw6dp(this.c6z_1) + ', depth=' + this.d6z_1 + ', stencil=' + this.e6z_1 + ', clearColor=' + this.f6z_1 + ', clearDepth=' + this.g6z_1 + ', clearStencil=' + this.h6z_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.a6z_1);
    result = imul(result, 31) + AGFrameBufferInfo__hashCode_impl_fvl6f1(this.b6z_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.c6z_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d6z_1) | 0;
    result = imul(result, 31) + this.e6z_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.f6z_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.g6z_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.h6z_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGClear))
      return false;
    var tmp0_other_with_cast = other instanceof AGClear ? other : THROW_CCE();
    if (!equals(this.a6z_1, tmp0_other_with_cast.a6z_1))
      return false;
    if (!equals(this.b6z_1, tmp0_other_with_cast.b6z_1))
      return false;
    if (!(this.c6z_1 === tmp0_other_with_cast.c6z_1))
      return false;
    if (!equals(this.d6z_1, tmp0_other_with_cast.d6z_1))
      return false;
    if (!(this.e6z_1 === tmp0_other_with_cast.e6z_1))
      return false;
    if (!(this.f6z_1 === tmp0_other_with_cast.f6z_1))
      return false;
    if (!(this.g6z_1 === tmp0_other_with_cast.g6z_1))
      return false;
    if (!(this.h6z_1 === tmp0_other_with_cast.h6z_1))
      return false;
    return true;
  }
}
class Companion_30 {
  constructor() {
    Companion_instance_39 = this;
    this.v6o_1 = _AGStencilReference___init__impl__rta8vg(new Long(-1, -1));
    this.w6o_1 = AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReadMask$default_impl_7mdffx(AGStencilReference__withReferenceValue$default_impl_2trj0v(_AGStencilReference___init__impl__rta8vg(new Long(0, 0)), 0), 255), 255);
  }
}
class AGStencilReference {
  constructor(data) {
    Companion_getInstance_45();
    this.i6z_1 = data;
  }
  toString() {
    return AGStencilReference__toString_impl_qu5r8s(this.i6z_1);
  }
  hashCode() {
    return AGStencilReference__hashCode_impl_52zufx(this.i6z_1);
  }
  equals(other) {
    return AGStencilReference__equals_impl_kj05j(this.i6z_1, other);
  }
}
class Companion_31 {
  constructor() {
    Companion_instance_40 = this;
    this.x6o_1 = _AGStencilOpFunc___init__impl__t3f62q(-1);
    this.y6o_1 = AGStencilOpFunc__withAction$default_impl_jx9cm1(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(_AGStencilOpFunc___init__impl__t3f62q(0), false), Companion_getInstance_56().m6z_1), Companion_getInstance_55().z6z_1, Companion_getInstance_55().z6z_1, Companion_getInstance_55().z6z_1);
  }
}
class AGStencilOpFunc {
  constructor(data) {
    Companion_getInstance_46();
    this.c70_1 = data;
  }
  toString() {
    return AGStencilOpFunc__toString_impl_pl8quy(this.c70_1);
  }
  hashCode() {
    return AGStencilOpFunc__hashCode_impl_nopebb(this.c70_1);
  }
  equals(other) {
    return AGStencilOpFunc__equals_impl_y44i4z(this.c70_1, other);
  }
}
class Companion_32 {
  constructor() {
    Companion_instance_41 = this;
    this.z6o_1 = _AGColorMask___init__impl__j38ai8(-1);
    this.a6p_1 = _AGColorMask___init__impl__j38ai8_1();
    this.b6p_1 = _AGColorMask___init__impl__j38ai8_1(true);
    this.c6p_1 = _AGColorMask___init__impl__j38ai8_1(true);
    this.d6p_1 = _AGColorMask___init__impl__j38ai8_0(true, true, true, false);
    this.e6p_1 = _AGColorMask___init__impl__j38ai8_1(false);
  }
}
class AGColorMask {
  constructor(data) {
    Companion_getInstance_47();
    this.g70_1 = data;
  }
  toString() {
    return AGColorMask__toString_impl_5i5oqg(this.g70_1);
  }
  hashCode() {
    return AGColorMask__hashCode_impl_g9082f(this.g70_1);
  }
  equals(other) {
    return AGColorMask__equals_impl_mrih8l(this.g70_1, other);
  }
}
class Companion_33 {
  constructor() {
    Companion_instance_42 = this;
    this.f6p_1 = _AGDepthAndFrontFace___init__impl__ra8x65(-2);
    this.g6p_1 = AGDepthAndFrontFace__withFrontFace_impl_mwk87t(AGDepthAndFrontFace__withDepthFunc_impl_7t7yrs(AGDepthAndFrontFace__withDepthMask_impl_610nhs(AGDepthAndFrontFace__withDepth_impl_wsx82k(_AGDepthAndFrontFace___init__impl__ra8x65(0), 0.0, 1.0), true), Companion_getInstance_56().m6z_1), Companion_getInstance_57().h70_1);
  }
}
class Companion_34 {
  constructor() {
    Companion_instance_43 = this;
    this.l6p_1 = _AGCullFace___init__impl__ckmjdg(-1);
    this.m6p_1 = _AGCullFace___init__impl__ckmjdg(0);
    this.n6p_1 = _AGCullFace___init__impl__ckmjdg(1);
    this.o6p_1 = _AGCullFace___init__impl__ckmjdg(2);
    this.p6p_1 = _AGCullFace___init__impl__ckmjdg(3);
  }
}
class AGCullFace {
  constructor(ordinal) {
    Companion_getInstance_49();
    this.k70_1 = ordinal;
  }
  toString() {
    return AGCullFace__toString_impl_7d891w(this.k70_1);
  }
  hashCode() {
    return AGCullFace__hashCode_impl_t4e5ur(this.k70_1);
  }
  equals(other) {
    return AGCullFace__equals_impl_wgngjr(this.k70_1, other);
  }
}
class AGBatch {
  constructor(frameBuffer, frameBufferInfo, vertexData, indices, indexType, program, uniformBlocks, textureUnits, blending, stencilOpFunc, stencilRef, colorMask, depthAndFrontFace, scissor, cullFace, drawType, drawOffset, vertexCount, instances) {
    vertexData = vertexData === VOID ? AGVertexArrayObject.u6w([new AGVertexData()], true) : vertexData;
    indices = indices === VOID ? null : indices;
    indexType = indexType === VOID ? Companion_getInstance_41().k6o_1 : indexType;
    program = program === VOID ? DefaultShaders_getInstance().e71_1 : program;
    uniformBlocks = uniformBlocks === VOID ? Companion_getInstance_58().s6o_1 : uniformBlocks;
    textureUnits = textureUnits === VOID ? Companion_instance_31.u6o() : textureUnits;
    blending = blending === VOID ? Companion_getInstance_42().o6o_1 : blending;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_46().y6o_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_45().w6o_1 : stencilRef;
    colorMask = colorMask === VOID ? Companion_getInstance_47().b6p_1 : colorMask;
    depthAndFrontFace = depthAndFrontFace === VOID ? Companion_getInstance_48().g6p_1 : depthAndFrontFace;
    scissor = scissor === VOID ? Companion_getInstance_43().k6p_1 : scissor;
    cullFace = cullFace === VOID ? Companion_getInstance_49().m6p_1 : cullFace;
    drawType = drawType === VOID ? Companion_getInstance_40().l6x_1 : drawType;
    drawOffset = drawOffset === VOID ? 0 : drawOffset;
    vertexCount = vertexCount === VOID ? 0 : vertexCount;
    instances = instances === VOID ? 1 : instances;
    this.a6q_1 = frameBuffer;
    this.b6q_1 = frameBufferInfo;
    this.c6q_1 = vertexData;
    this.d6q_1 = indices;
    this.e6q_1 = indexType;
    this.f6q_1 = program;
    this.g6q_1 = uniformBlocks;
    this.h6q_1 = textureUnits;
    this.i6q_1 = blending;
    this.j6q_1 = stencilOpFunc;
    this.k6q_1 = stencilRef;
    this.l6q_1 = colorMask;
    this.m6q_1 = depthAndFrontFace;
    this.n6q_1 = scissor;
    this.o6q_1 = cullFace;
    this.p6q_1 = drawType;
    this.q6q_1 = drawOffset;
    this.r6q_1 = vertexCount;
    this.s6q_1 = instances;
  }
  z6p(ag) {
    ag.e6o(this.a6q_1, this.b6q_1, this.c6q_1, this.f6q_1, this.p6q_1, this.r6q_1, this.d6q_1, this.e6q_1, this.q6q_1, this.i6q_1, this.g6q_1, this.h6q_1, this.k6q_1, this.j6q_1, this.l6q_1, this.m6q_1, this.n6q_1, this.o6q_1, this.s6q_1);
  }
  toString() {
    return 'AGBatch(frameBuffer=' + this.a6q_1.toString() + ', frameBufferInfo=' + AGFrameBufferInfo__toString_impl_xecyr8(this.b6q_1) + ', vertexData=' + this.c6q_1.toString() + ', indices=' + toString_1(this.d6q_1) + ', indexType=' + AGIndexType__toString_impl_hjqwm3(this.e6q_1) + ', program=' + this.f6q_1.toString() + ', uniformBlocks=' + toString(this.g6q_1) + ', textureUnits=' + this.h6q_1.toString() + ', blending=' + AGBlending__toString_impl_d5hic6(this.i6q_1) + ', stencilOpFunc=' + AGStencilOpFunc__toString_impl_pl8quy(this.j6q_1) + ', stencilRef=' + AGStencilReference__toString_impl_qu5r8s(this.k6q_1) + ', colorMask=' + AGColorMask__toString_impl_5i5oqg(this.l6q_1) + ', depthAndFrontFace=' + AGDepthAndFrontFace__toString_impl_c305m3(this.m6q_1) + ', scissor=' + this.n6q_1.toString() + ', cullFace=' + AGCullFace__toString_impl_7d891w(this.o6q_1) + ', drawType=' + AGDrawType__toString_impl_eonaeb(this.p6q_1) + ', drawOffset=' + this.q6q_1 + ', vertexCount=' + this.r6q_1 + ', instances=' + this.s6q_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.a6q_1);
    result = imul(result, 31) + AGFrameBufferInfo__hashCode_impl_fvl6f1(this.b6q_1) | 0;
    result = imul(result, 31) + this.c6q_1.hashCode() | 0;
    result = imul(result, 31) + (this.d6q_1 == null ? 0 : hashCode(this.d6q_1)) | 0;
    result = imul(result, 31) + AGIndexType__hashCode_impl_47f06s(this.e6q_1) | 0;
    result = imul(result, 31) + this.f6q_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.g6q_1) | 0;
    result = imul(result, 31) + this.h6q_1.hashCode() | 0;
    result = imul(result, 31) + AGBlending__hashCode_impl_ywnf51(this.i6q_1) | 0;
    result = imul(result, 31) + AGStencilOpFunc__hashCode_impl_nopebb(this.j6q_1) | 0;
    result = imul(result, 31) + AGStencilReference__hashCode_impl_52zufx(this.k6q_1) | 0;
    result = imul(result, 31) + AGColorMask__hashCode_impl_g9082f(this.l6q_1) | 0;
    result = imul(result, 31) + AGDepthAndFrontFace__hashCode_impl_xu62ey(this.m6q_1) | 0;
    result = imul(result, 31) + this.n6q_1.hashCode() | 0;
    result = imul(result, 31) + AGCullFace__hashCode_impl_t4e5ur(this.o6q_1) | 0;
    result = imul(result, 31) + AGDrawType__hashCode_impl_ylaury(this.p6q_1) | 0;
    result = imul(result, 31) + this.q6q_1 | 0;
    result = imul(result, 31) + this.r6q_1 | 0;
    result = imul(result, 31) + this.s6q_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGBatch))
      return false;
    var tmp0_other_with_cast = other instanceof AGBatch ? other : THROW_CCE();
    if (!equals(this.a6q_1, tmp0_other_with_cast.a6q_1))
      return false;
    if (!equals(this.b6q_1, tmp0_other_with_cast.b6q_1))
      return false;
    if (!this.c6q_1.equals(tmp0_other_with_cast.c6q_1))
      return false;
    if (!equals(this.d6q_1, tmp0_other_with_cast.d6q_1))
      return false;
    if (!(this.e6q_1 === tmp0_other_with_cast.e6q_1))
      return false;
    if (!this.f6q_1.equals(tmp0_other_with_cast.f6q_1))
      return false;
    if (!equals(this.g6q_1, tmp0_other_with_cast.g6q_1))
      return false;
    if (!this.h6q_1.equals(tmp0_other_with_cast.h6q_1))
      return false;
    if (!(this.i6q_1 === tmp0_other_with_cast.i6q_1))
      return false;
    if (!(this.j6q_1 === tmp0_other_with_cast.j6q_1))
      return false;
    if (!equals(this.k6q_1, tmp0_other_with_cast.k6q_1))
      return false;
    if (!(this.l6q_1 === tmp0_other_with_cast.l6q_1))
      return false;
    if (!(this.m6q_1 === tmp0_other_with_cast.m6q_1))
      return false;
    if (!this.n6q_1.equals(tmp0_other_with_cast.n6q_1))
      return false;
    if (!(this.o6q_1 === tmp0_other_with_cast.o6q_1))
      return false;
    if (!(this.p6q_1 === tmp0_other_with_cast.p6q_1))
      return false;
    if (!(this.q6q_1 === tmp0_other_with_cast.q6q_1))
      return false;
    if (!(this.r6q_1 === tmp0_other_with_cast.r6q_1))
      return false;
    if (!(this.s6q_1 === tmp0_other_with_cast.s6q_1))
      return false;
    return true;
  }
}
class Companion_35 {
  constructor() {
    Companion_instance_44 = this;
    this.k6t_1 = _AGTextureTargetKind___init__impl__4zdmch(0);
    this.l6t_1 = _AGTextureTargetKind___init__impl__4zdmch(1);
    this.m6t_1 = _AGTextureTargetKind___init__impl__4zdmch(2);
    this.n6t_1 = _AGTextureTargetKind___init__impl__4zdmch(3);
  }
}
class AGTextureTargetKind {
  constructor(ordinal) {
    Companion_getInstance_50();
    this.p6t_1 = ordinal;
  }
  toString() {
    return AGTextureTargetKind__toString_impl_68648p(this.p6t_1);
  }
  hashCode() {
    return AGTextureTargetKind__hashCode_impl_rzc11k(this.p6t_1);
  }
  equals(other) {
    return AGTextureTargetKind__equals_impl_q2tams(this.p6t_1, other);
  }
}
class Companion_36 {
  constructor() {
    Companion_instance_45 = this;
    this.j6u_1 = _AGWrapMode___init__impl__x5wmya(0);
    this.k6u_1 = _AGWrapMode___init__impl__x5wmya(1);
    this.l6u_1 = _AGWrapMode___init__impl__x5wmya(2);
  }
}
class AGWrapMode {
  constructor(ordinal) {
    Companion_getInstance_51();
    this.g71_1 = ordinal;
  }
  toString() {
    return AGWrapMode__toString_impl_8bjnw2(this.g71_1);
  }
  hashCode() {
    return AGWrapMode__hashCode_impl_u2pkox(this.g71_1);
  }
  equals(other) {
    return AGWrapMode__equals_impl_4aw0kl(this.g71_1, other);
  }
}
class Companion_37 {
  constructor() {
    Companion_instance_46 = this;
    this.t6x_1 = _AGBlendFactor___init__impl__iqtmxr(0);
    this.u6x_1 = _AGBlendFactor___init__impl__iqtmxr(1);
    this.v6x_1 = _AGBlendFactor___init__impl__iqtmxr(2);
    this.w6x_1 = _AGBlendFactor___init__impl__iqtmxr(3);
    this.x6x_1 = _AGBlendFactor___init__impl__iqtmxr(4);
    this.y6x_1 = _AGBlendFactor___init__impl__iqtmxr(5);
    this.z6x_1 = _AGBlendFactor___init__impl__iqtmxr(6);
    this.a6y_1 = _AGBlendFactor___init__impl__iqtmxr(7);
    this.b6y_1 = _AGBlendFactor___init__impl__iqtmxr(8);
    this.c6y_1 = _AGBlendFactor___init__impl__iqtmxr(9);
  }
}
class AGBlendFactor {
  constructor(ordinal) {
    Companion_getInstance_52();
    this.h71_1 = ordinal;
  }
  toString() {
    return AGBlendFactor__toString_impl_1hr6m1(this.h71_1);
  }
  hashCode() {
    return AGBlendFactor__hashCode_impl_n8x3ew(this.h71_1);
  }
  equals(other) {
    return AGBlendFactor__equals_impl_dlauac(this.h71_1, other);
  }
}
class Companion_38 {
  constructor() {
    Companion_instance_47 = this;
    this.g6y_1 = _AGBlendEquation___init__impl__fpv7c2(0);
    this.h6y_1 = _AGBlendEquation___init__impl__fpv7c2(1);
    this.i6y_1 = _AGBlendEquation___init__impl__fpv7c2(2);
  }
}
class AGBlendEquation {
  constructor(ordinal) {
    Companion_getInstance_53();
    this.i71_1 = ordinal;
  }
  toString() {
    return AGBlendEquation__toString_impl_5t2sx6(this.i71_1);
  }
  hashCode() {
    return AGBlendEquation__hashCode_impl_fy33vp(this.i71_1);
  }
  equals(other) {
    return AGBlendEquation__equals_impl_yykk3b(this.i71_1, other);
  }
}
class Companion_39 {
  j71() {
    return _AGSize___init__impl__h9blcq(-2);
  }
  x6y(width, height) {
    return AGSize__with_impl_qn6qww(_AGSize___init__impl__h9blcq(0), width, height);
  }
}
class Companion_40 {
  constructor() {
    Companion_instance_49 = this;
    this.u6z_1 = _AGStencilOp___init__impl__llpkv6(0);
    this.v6z_1 = _AGStencilOp___init__impl__llpkv6(1);
    this.w6z_1 = _AGStencilOp___init__impl__llpkv6(2);
    this.x6z_1 = _AGStencilOp___init__impl__llpkv6(3);
    this.y6z_1 = _AGStencilOp___init__impl__llpkv6(4);
    this.z6z_1 = _AGStencilOp___init__impl__llpkv6(5);
    this.a70_1 = _AGStencilOp___init__impl__llpkv6(6);
    this.b70_1 = _AGStencilOp___init__impl__llpkv6(7);
  }
}
class AGStencilOp {
  constructor(ordinal) {
    Companion_getInstance_55();
    this.k71_1 = ordinal;
  }
  toString() {
    return AGStencilOp__toString_impl_1dm6fq(this.k71_1);
  }
  hashCode() {
    return AGStencilOp__hashCode_impl_n4s38l(this.k71_1);
  }
  equals(other) {
    return AGStencilOp__equals_impl_rq4p55(this.k71_1, other);
  }
}
class Companion_41 {
  constructor() {
    Companion_instance_50 = this;
    this.m6z_1 = _AGCompareMode___init__impl__j8kqbb(0);
    this.n6z_1 = _AGCompareMode___init__impl__j8kqbb(1);
    this.o6z_1 = _AGCompareMode___init__impl__j8kqbb(2);
    this.p6z_1 = _AGCompareMode___init__impl__j8kqbb(3);
    this.q6z_1 = _AGCompareMode___init__impl__j8kqbb(4);
    this.r6z_1 = _AGCompareMode___init__impl__j8kqbb(5);
    this.s6z_1 = _AGCompareMode___init__impl__j8kqbb(6);
    this.t6z_1 = _AGCompareMode___init__impl__j8kqbb(7);
  }
}
class AGCompareMode {
  constructor(ordinal) {
    Companion_getInstance_56();
    this.l71_1 = ordinal;
  }
  toString() {
    return AGCompareMode__toString_impl_gs33a9(this.l71_1);
  }
  hashCode() {
    return AGCompareMode__hashCode_impl_whv1w0(this.l71_1);
  }
  equals(other) {
    return AGCompareMode__equals_impl_rbniy4(this.l71_1, other);
  }
}
class Companion_42 {
  constructor() {
    Companion_instance_51 = this;
    this.h70_1 = _AGFrontFace___init__impl__vsm7rb(0);
    this.i70_1 = _AGFrontFace___init__impl__vsm7rb(1);
    this.j70_1 = _AGFrontFace___init__impl__vsm7rb(2);
  }
}
class AGMultiBatch {
  constructor(list) {
    this.y6p_1 = list;
  }
  z6p(ag) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.y6p_1;
    var n = 0;
    while (n < this_0.f1()) {
      // Inline function 'korlibs.graphics.AGMultiBatch.execute.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.e1(_unary__edvuaz).z6p(ag);
    }
  }
  toString() {
    return 'AGMultiBatch(list=' + toString(this.y6p_1) + ')';
  }
  hashCode() {
    return hashCode(this.y6p_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGMultiBatch))
      return false;
    var tmp0_other_with_cast = other instanceof AGMultiBatch ? other : THROW_CCE();
    if (!equals(this.y6p_1, tmp0_other_with_cast.y6p_1))
      return false;
    return true;
  }
}
class AGConfig {
  constructor(antialiasHint) {
    antialiasHint = antialiasHint === VOID ? true : antialiasHint;
    this.m71_1 = antialiasHint;
  }
  toString() {
    return 'AGConfig(antialiasHint=' + this.m71_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.m71_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGConfig))
      return false;
    var tmp0_other_with_cast = other instanceof AGConfig ? other : THROW_CCE();
    if (!(this.m71_1 === tmp0_other_with_cast.m71_1))
      return false;
    return true;
  }
}
class AGBufferKind extends Enum {}
class AGStats {
  constructor(texturesCount, texturesMemory, buffersCount, buffersMemory, frameBuffersCount, frameBuffersMemory, texturesCreated, texturesDeleted, programCount) {
    texturesCount = texturesCount === VOID ? 0 : texturesCount;
    texturesMemory = texturesMemory === VOID ? Companion_getInstance_9().q16(0) : texturesMemory;
    buffersCount = buffersCount === VOID ? 0 : buffersCount;
    buffersMemory = buffersMemory === VOID ? Companion_getInstance_9().q16(0) : buffersMemory;
    frameBuffersCount = frameBuffersCount === VOID ? 0 : frameBuffersCount;
    frameBuffersMemory = frameBuffersMemory === VOID ? Companion_getInstance_9().q16(0) : frameBuffersMemory;
    texturesCreated = texturesCreated === VOID ? 0 : texturesCreated;
    texturesDeleted = texturesDeleted === VOID ? 0 : texturesDeleted;
    programCount = programCount === VOID ? 0 : programCount;
    this.n71_1 = texturesCount;
    this.o71_1 = texturesMemory;
    this.p71_1 = buffersCount;
    this.q71_1 = buffersMemory;
    this.r71_1 = frameBuffersCount;
    this.s71_1 = frameBuffersMemory;
    this.t71_1 = texturesCreated;
    this.u71_1 = texturesDeleted;
    this.v71_1 = programCount;
  }
  toString() {
    return 'AGStats(textures[' + this.n71_1 + '] = ' + ByteUnits__toString_impl_ox2ku2(this.o71_1) + ', buffers[' + this.p71_1 + '] = ' + ByteUnits__toString_impl_ox2ku2(this.q71_1) + ', frameBuffers[' + this.r71_1 + '] = ' + ByteUnits__toString_impl_ox2ku2(this.s71_1) + ', programs[' + this.v71_1 + '])';
  }
}
class UniformBlock {
  constructor(fixedLocation) {
    this.k6w_1 = fixedLocation;
    this.l6w_1 = new UBLayoutBuilder();
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.m6w_1 = ArrayList.j1();
    this.n6w_1 = 0;
  }
  s3() {
    return get_portableSimpleName(getKClassFromExpression(this));
  }
  p72() {
    return this.m6w_1;
  }
  q72() {
    return this.l6w_1.f1();
  }
  r72() {
    return nextMultipleOf(this.q72(), 256);
  }
  s72() {
    return this.p72().f1();
  }
  t72(name) {
    return this.y72(name, VarType_Float1_getInstance(), 4, 4);
  }
  u72(name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.t72(name) : $super.t72.call(this, name);
  }
  v72(name) {
    return this.y72(name, VarType_Float4_getInstance(), 16, 16);
  }
  w72(name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.v72(name) : $super.v72.call(this, name);
  }
  x72(name) {
    return this.y72(name, VarType_Mat4_getInstance(), 64, 16);
  }
  c72(name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.x72(name) : $super.x72.call(this, name);
  }
  y72(name, type, size, align) {
    var tmp = this.l6w_1.d7i(size, align);
    var _unary__edvuaz = this.n6w_1;
    this.n6w_1 = _unary__edvuaz + 1 | 0;
    return new Gen(this, name, tmp, _unary__edvuaz, type, 1, size, align);
  }
  toString() {
    return 'UniformBlock[' + get_portableSimpleName(getKClassFromExpression(this)) + '][' + joinToString(this.p72(), ', ') + ', fixedLocation=' + this.k6w_1 + ']';
  }
}
class ProjViewUB extends UniformBlock {
  constructor() {
    ProjViewUB_instance = null;
    super(0);
    ProjViewUB_instance = this;
    this.a72_1 = this.c72().m72(this, u_ProjMat$factory());
    this.b72_1 = this.c72().m72(this, u_ViewMat$factory());
  }
  n72() {
    return this.a72_1.mo(this, u_ProjMat$factory_0());
  }
  o72() {
    return this.b72_1.mo(this, u_ViewMat$factory_0());
  }
}
class DefaultShaders {
  constructor() {
    DefaultShaders_instance = this;
    this.l70_1 = Sampler_0(1, SamplerVarType_Sampler2D_getInstance()).b73(this, u_Tex$factory());
    this.m70_1 = Sampler_0(2, SamplerVarType_Sampler2D_getInstance()).b73(this, u_TexEx$factory());
    this.n70_1 = Attribute.s73('a_Pos', VarType_Float2_getInstance(), false, Precision_HIGH_getInstance(), 0);
    this.o70_1 = Attribute.s73('a_Tex', VarType_Float2_getInstance(), false, Precision_MEDIUM_getInstance(), 1);
    this.p70_1 = Attribute.s73('a_Col', VarType_UByte4_getInstance(), true, Precision_LOW_getInstance(), 2);
    this.q70_1 = Varying.e74('v_Tex', VarType_Float2_getInstance(), Precision_MEDIUM_getInstance());
    this.r70_1 = Varying.e74('v_Col', VarType_Float4_getInstance());
    this.s70_1 = Temp.q74(0, VarType_Float4_getInstance());
    this.t70_1 = Temp.q74(1, VarType_Float4_getInstance());
    this.u70_1 = Temp.q74(2, VarType_Mat2_getInstance());
    this.v70_1 = ProgramLayout.d6x([this.n70_1, this.o70_1, this.p70_1]);
    var tmp = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder = ProgramBuilderDefault.t74();
    // Inline function 'korlibs.graphics.DefaultShaders.VERTEX_DEFAULT.<anonymous>' call
    builder.y74(builder.u74(), builder.v74());
    builder.y74(builder.z74(), builder.a75());
    builder.y74(builder.b75(), builder.c75(builder.c75(builder.n72(), builder.o72()), builder.f75([builder.d75(), builder.e75(0.0), builder.e75(1.0)])));
    tmp.w70_1 = VertexShader(builder.g75());
    var tmp_0 = this;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.t74();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.DefaultShaders.MERGE_ALPHA_PROGRAM.<anonymous>' call
    var coords = this_0.h75(this_0.u74(), 'xy');
    this_0.y74(this_0.b75(), this_0.c75(this_0.j75(this_0.i75(), coords), this_0.l75(this_0.j75(DefaultShaders_getInstance().k75(), coords))));
    var tmp$ret$2 = FragmentShader(this_0.g75());
    tmp_0.x70_1 = new Program(this.w70_1, tmp$ret$2);
    var tmp_1 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_0 = ProgramBuilderDefault.t74();
    // Inline function 'korlibs.graphics.DefaultShaders.FRAGMENT_DEBUG.<anonymous>' call
    builder_0.y74(builder_0.b75(), builder_0.f75([builder_0.e75(1.0), builder_0.e75(1.0), builder_0.e75(0.0), builder_0.e75(1.0)]));
    tmp_1.y70_1 = FragmentShader(builder_0.g75());
    var tmp_2 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_1 = ProgramBuilderDefault.t74();
    // Inline function 'korlibs.graphics.DefaultShaders.FRAGMENT_SOLID_COLOR.<anonymous>' call
    builder_1.y74(builder_1.b75(), builder_1.z74());
    tmp_2.z70_1 = FragmentShader(builder_1.g75());
    var tmp_3 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_2 = ProgramBuilderDefault.t74();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_TINTED_TEXTURE.<anonymous>' call
    builder_2.y74(builder_2.b75(), builder_2.c75(builder_2.h75(builder_2.j75(builder_2.i75(), builder_2.h75(builder_2.u74(), 'xy')), 'rgba'), builder_2.z74()));
    var tmp$ret$5 = FragmentShader(builder_2.g75());
    tmp_3.a71_1 = new Program(this.w70_1, tmp$ret$5, 'PROGRAM_TINTED_TEXTURE');
    var tmp_4 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_3 = ProgramBuilderDefault.t74();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_TINTED_TEXTURE_PREMULT.<anonymous>' call
    builder_3.y74(builder_3.m75(), builder_3.j75(builder_3.i75(), builder_3.h75(builder_3.u74(), 'xy')));
    builder_3.y74(builder_3.h75(builder_3.m75(), 'rgb'), builder_3.n75(builder_3.h75(builder_3.m75(), 'rgb'), builder_3.h75(builder_3.m75(), 'a')));
    builder_3.y74(builder_3.b75(), builder_3.c75(builder_3.h75(builder_3.m75(), 'rgba'), builder_3.z74()));
    var tmp$ret$6 = FragmentShader(builder_3.g75());
    tmp_4.b71_1 = new Program(this.w70_1, tmp$ret$6, 'PROGRAM_TINTED_TEXTURE');
    this.c71_1 = new Program(this.w70_1, this.z70_1, 'PROGRAM_SOLID_COLOR');
    this.d71_1 = ProgramLayout.d6x([this.n70_1]);
    var tmp_5 = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder_4 = ProgramBuilderDefault.t74();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG.<anonymous>' call
    builder_4.y74(builder_4.b75(), builder_4.f75([builder_4.d75(), builder_4.e75(0.0), builder_4.e75(1.0)]));
    var tmp_6 = VertexShader(builder_4.g75());
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_5 = ProgramBuilderDefault.t74();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG.<anonymous>' call
    builder_5.y74(builder_5.b75(), builder_5.f75([builder_5.e75(1.0), builder_5.e75(0.0), builder_5.e75(0.0), builder_5.e75(1.0)]));
    var tmp$ret$8 = FragmentShader(builder_5.g75());
    tmp_5.e71_1 = new Program(tmp_6, tmp$ret$8, 'PROGRAM_DEBUG');
    var tmp_7 = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder_6 = ProgramBuilderDefault.t74();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG_WITH_PROJ.<anonymous>' call
    builder_6.y74(builder_6.b75(), builder_6.c75(builder_6.c75(builder_6.n72(), builder_6.o72()), builder_6.f75([builder_6.d75(), builder_6.e75(0.0), builder_6.e75(1.0)])));
    var tmp_8 = VertexShader(builder_6.g75());
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_7 = ProgramBuilderDefault.t74();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG_WITH_PROJ.<anonymous>' call
    builder_7.y74(builder_7.b75(), builder_7.f75([builder_7.e75(1.0), builder_7.e75(0.0), builder_7.e75(0.0), builder_7.e75(1.0)]));
    var tmp$ret$10 = FragmentShader(builder_7.g75());
    tmp_7.f71_1 = new Program(tmp_8, tmp$ret$10, 'PROGRAM_DEBUG_WITH_PROJ');
  }
  i75() {
    return this.l70_1.mo(this, u_Tex$factory_0());
  }
  k75() {
    return this.m70_1.mo(this, u_TexEx$factory_0());
  }
  n72() {
    return ProjViewUB_getInstance().n72().j6w_1;
  }
  o72() {
    return ProjViewUB_getInstance().o72().j6w_1;
  }
}
class VarTypeAccessor {}
function get_Float1() {
  return VarType_Float1_getInstance();
}
function get_Float2() {
  return VarType_Float2_getInstance();
}
function get_Float4() {
  return VarType_Float4_getInstance();
}
class ExpressionBuilder {}
function get_out() {
  return Output_getInstance();
}
function atan(y, x) {
  return Func.v7r('atan', [y, x], y.c2e());
}
function texture2D(sampler, coord) {
  return Func.v7r('texture2D', [sampler, coord], VarType_Float4_getInstance());
}
function TERNARY(cond, otrue, ofalse) {
  return Ternary.h7r(cond, otrue, ofalse);
}
function pow(b, e) {
  return Func.v7r('pow', [b, e], b.c2e());
}
function sqrt(v) {
  return Func.v7r('sqrt', [v], v.c2e());
}
function abs(v) {
  return Func.v7r('abs', [v], v.c2e());
}
function fract(v) {
  return Func.v7r('fract', [v], v.c2e());
}
function clamp(v, min, max) {
  return Func.v7r('clamp', [v, min, max], v.c2e());
}
function min_0(a, b) {
  return Func.v7r('min', [a, b], a.c2e());
}
function max_1(a, b) {
  return Func.v7r('max', [a, b], a.c2e());
}
function fwidth(a) {
  return Func.v7r('fwidth', [a], a.c2e());
}
function mix(a, b, step) {
  return Func.v7r('mix', [a, b, step], a.c2e());
}
function smoothstep(a, b, c) {
  return Func.v7r('smoothstep', [a, b, c], a.c2e());
}
function length(a) {
  return Func.v7r('length', [a], VarType_Float1_getInstance());
}
function get_lit(_this__u8e3s4) {
  return FloatLiteral.l7r(_this__u8e3s4);
}
function vec2(ops) {
  return Vector.m7r(VarType_Float2_getInstance(), ops);
}
function vec4(ops) {
  return Vector.m7r(VarType_Float4_getInstance(), ops);
}
function get_1(_this__u8e3s4, swizzle) {
  return Swizzle.n7r(_this__u8e3s4, swizzle);
}
function get_x(_this__u8e3s4) {
  return this.h75(_this__u8e3s4, 'x');
}
function get_y(_this__u8e3s4) {
  return this.h75(_this__u8e3s4, 'y');
}
function get_z(_this__u8e3s4) {
  return this.h75(_this__u8e3s4, 'z');
}
function get_w(_this__u8e3s4) {
  return this.h75(_this__u8e3s4, 'w');
}
function get_a(_this__u8e3s4) {
  return this.h75(_this__u8e3s4, 'w');
}
function unaryMinus(_this__u8e3s4) {
  return Unop.j7r('-', _this__u8e3s4);
}
function minus_0(_this__u8e3s4, that) {
  return Binop.k7r(_this__u8e3s4, '-', that);
}
function plus_2(_this__u8e3s4, that) {
  return Binop.k7r(_this__u8e3s4, '+', that);
}
function times(_this__u8e3s4, that) {
  return Binop.k7r(_this__u8e3s4, '*', that);
}
function div(_this__u8e3s4, that) {
  return Binop.k7r(_this__u8e3s4, '/', that);
}
function eq(_this__u8e3s4, that) {
  return Binop.k7r(_this__u8e3s4, '==', that);
}
function lt(_this__u8e3s4, that) {
  return Binop.k7r(_this__u8e3s4, '<', that);
}
function le(_this__u8e3s4, that) {
  return Binop.k7r(_this__u8e3s4, '<=', that);
}
function gt(_this__u8e3s4, that) {
  return Binop.k7r(_this__u8e3s4, '>', that);
}
function minus_1(_this__u8e3s4, that) {
  return this.x76(this.e75(_this__u8e3s4), that);
}
function plus_3(_this__u8e3s4, that) {
  return this.y76(this.e75(_this__u8e3s4), that);
}
function times_0(_this__u8e3s4, that) {
  return this.c75(this.e75(_this__u8e3s4), that);
}
function plus_4(_this__u8e3s4, that) {
  return this.y76(_this__u8e3s4, this.e75(that));
}
function gt_0(_this__u8e3s4, that) {
  return this.c77(_this__u8e3s4, this.e75(that));
}
class Builder {
  static o75(context) {
    context = context === VOID ? new BuilderContext() : context;
    var $this = createThis(this);
    $this.w74_1 = context;
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.x74_1 = ArrayList.j1();
    return $this;
  }
  static d7q(parent) {
    return this.o75(parent.w74_1);
  }
  p75() {
    return Builder.d7q(this);
  }
  q75() {
    return FuncBuilder.c7q(this);
  }
  r75() {
    return new Stms(toList(this.x74_1));
  }
  s75() {
    var funcs = LinkedHashMap.oc();
    (new Program$Builder$_funcs$1(funcs)).g7r(this.x74_1);
    var _iterator__ex2g4s = this.w74_1.y7r_1.b1();
    while (_iterator__ex2g4s.c1()) {
      var func = _iterator__ex2g4s.d1();
      // Inline function 'kotlin.collections.set' call
      var key = func.h7n_1;
      funcs.h3(key, func);
    }
    return toList(funcs.l3());
  }
  g75() {
    return to(this.r75(), this.s75());
  }
  t75(name, rettype, block) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.q75();
    // Inline function 'kotlin.contracts.contract' call
    block(this_0);
    var funcBuild = this_0;
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.collections.map' call
    var this_1 = funcBuild.a7q_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator = this_1.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.graphics.shader.Builder.FUNC.<anonymous>' call
      var tmp$ret$1 = to(item.e7a_1, item.c2e());
      destination.h(tmp$ret$1);
    }
    var this_2 = new FuncDecl(name, rettype, destination, funcBuild.r75());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Builder.FUNC.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    this.w74_1.y7r_1.h(this_2);
    return this_2;
  }
  u75(p0, dummy, returns, block) {
    var tmp = listOf(p0);
    return new FuncProvider(returns, tmp, this, Program$Builder$FUNC$lambda(block));
  }
  v75(p0, dummy, returns, block, $super) {
    dummy = dummy === VOID ? Unit_instance : dummy;
    var tmp;
    if ($super === VOID) {
      tmp = this.u75(p0, dummy, returns, block);
    } else {
      var tmp_0 = $super.u75;
      tmp = tmp_0.call(this, p0, Unit_instance, returns, block);
    }
    return tmp;
  }
  w75(p0, p1, dummy, returns, block) {
    var tmp = listOf_0([p0, p1]);
    return new FuncProvider(returns, tmp, this, Program$Builder$FUNC$lambda_0(block));
  }
  x75(p0, p1, dummy, returns, block, $super) {
    dummy = dummy === VOID ? Unit_instance : dummy;
    var tmp;
    if ($super === VOID) {
      tmp = this.w75(p0, p1, dummy, returns, block);
    } else {
      var tmp_0 = $super.w75;
      tmp = tmp_0.call(this, p0, p1, Unit_instance, returns, block);
    }
    return tmp;
  }
  y75(p0, p1, p2, dummy, returns, block) {
    var tmp = listOf_0([p0, p1, p2]);
    return new FuncProvider(returns, tmp, this, Program$Builder$FUNC$lambda_1(block));
  }
  z75(p0, p1, p2, dummy, returns, block, $super) {
    dummy = dummy === VOID ? Unit_instance : dummy;
    var tmp;
    if ($super === VOID) {
      tmp = this.y75(p0, p1, p2, dummy, returns, block);
    } else {
      var tmp_0 = $super.y75;
      tmp = tmp_0.call(this, p0, p1, p2, Unit_instance, returns, block);
    }
    return tmp;
  }
  a76(type) {
    var _receiver__tnumb7 = this.w74_1;
    var _unary__edvuaz = _receiver__tnumb7.z7r_1;
    _receiver__tnumb7.z7r_1 = _unary__edvuaz + 1 | 0;
    return Temp.q74(_unary__edvuaz, type);
  }
  q7q(initialValue) {
    var temp = this.a76(initialValue.c2e());
    this.y74(temp, initialValue);
    return temp;
  }
  b76(_this__u8e3s4, p0) {
    return CustomFunc.w7r(_this__u8e3s4, listOf(p0));
  }
  c76(_this__u8e3s4, p0, p1, p2) {
    return CustomFunc.w7r(_this__u8e3s4, listOf_0([p0, p1, p2]));
  }
  d76(_this__u8e3s4, callback) {
    var body = this.p75();
    callback(body);
    _this__u8e3s4.u7o_1 = body.r75();
  }
  e76(ref, min, max, block) {
    if (min >= max) {
      block(this, min);
    } else if ((max - min | 0) <= 1) {
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond = this.z76(ref, this.e75(min));
      var body = this.p75();
      // Inline function 'korlibs.graphics.shader.Builder.IF_ELSE_BINARY_LOOKUP.<anonymous>' call
      block(body, min);
      var stmIf = new If(cond, body.r75());
      // Inline function 'kotlin.collections.plusAssign' call
      this.x74_1.h(stmIf);
      var tmp = stmIf;
      this.d76(tmp, Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda(block, max));
    } else {
      var middle = (min + max | 0) / 2 | 0;
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond_0 = this.b77(ref, this.e75(middle));
      var body_0 = this.p75();
      // Inline function 'korlibs.graphics.shader.Builder.IF_ELSE_BINARY_LOOKUP.<anonymous>' call
      body_0.e76(ref, min, middle, block);
      var stmIf_0 = new If(cond_0, body_0.r75());
      // Inline function 'kotlin.collections.plusAssign' call
      this.x74_1.h(stmIf_0);
      var tmp_0 = stmIf_0;
      this.d76(tmp_0, Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda_0(ref, middle, max, block));
    }
  }
  f76(ref, min, max, block) {
    if (min >= max) {
      block(this, min);
    } else {
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond = this.z76(ref, this.e75(min));
      var body = this.p75();
      // Inline function 'korlibs.graphics.shader.Builder.IF_ELSE_LIST.<anonymous>' call
      block(body, min);
      var stmIf = new If(cond, body.r75());
      // Inline function 'kotlin.collections.plusAssign' call
      this.x74_1.h(stmIf);
      var tmp = stmIf;
      this.d76(tmp, Program$Builder$IF_ELSE_LIST$lambda(ref, min, max, block));
    }
  }
  y74(target, expr) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.x74_1;
    var element = new Set(target, expr);
    this_0.h(element);
  }
  g76() {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.x74_1;
    var element = Discard_getInstance();
    this_0.h(element);
  }
  h76(operand) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.x74_1;
    var element = new Return(operand);
    this_0.h(element);
  }
  i76(operand, $super) {
    operand = operand === VOID ? null : operand;
    var tmp;
    if ($super === VOID) {
      this.h76(operand);
      tmp = Unit_instance;
    } else {
      tmp = $super.h76.call(this, operand);
    }
    return tmp;
  }
  j76(type) {
    var _receiver__tnumb7 = this.w74_1;
    var _unary__edvuaz = _receiver__tnumb7.z7r_1;
    _receiver__tnumb7.z7r_1 = _unary__edvuaz + 1 | 0;
    return Temp.a7s(_unary__edvuaz, type, 1);
  }
}
class IDefaultShaders {}
function get_u_Tex() {
  return DefaultShaders_getInstance().i75();
}
function get_u_ProjMat() {
  return DefaultShaders_getInstance().n72();
}
function get_u_ViewMat() {
  return DefaultShaders_getInstance().o72();
}
function get_a_Pos() {
  return DefaultShaders_getInstance().n70_1;
}
function get_a_Tex() {
  return DefaultShaders_getInstance().o70_1;
}
function get_a_Col() {
  return DefaultShaders_getInstance().p70_1;
}
function get_v_Tex() {
  return DefaultShaders_getInstance().q70_1;
}
function get_v_Col() {
  return DefaultShaders_getInstance().r70_1;
}
function get_t_Temp0() {
  return DefaultShaders_getInstance().s70_1;
}
function get_t_Temp1() {
  return DefaultShaders_getInstance().t70_1;
}
class ProgramBuilderDefault extends Builder {
  static t74() {
    return this.o75();
  }
}
class GLVAO {
  constructor(vao, glId, contextVersion) {
    glId = glId === VOID ? -1 : glId;
    contextVersion = contextVersion === VOID ? -1 : contextVersion;
    this.e77_1 = vao;
    this.f77_1 = glId;
    this.g77_1 = contextVersion;
  }
}
class ShaderException extends RuntimeException {
  static r77(str, error, errorInt, gl, debugName, type, shaderReturnInt) {
    var $this = this.wa('Error Compiling Shader : ' + debugName + ' type=' + type + ' : ' + get_hex(errorInt) + " : '" + error + "' : source='" + str + "', shaderReturnInt=" + shaderReturnInt + ', gl.versionInt=' + get_versionInt(gl) + ", gl.versionString='" + get_versionString(gl) + "', gl=" + toString(gl));
    captureStack($this, $this.q77_1);
    $this.j77_1 = str;
    $this.k77_1 = error;
    $this.l77_1 = errorInt;
    $this.m77_1 = gl;
    $this.n77_1 = debugName;
    $this.o77_1 = type;
    $this.p77_1 = shaderReturnInt;
    return $this;
  }
}
class TextureUnitParams {
  constructor(index) {
    this.s7a_1 = index;
    this.t7a_1 = _AGWrapMode___init__impl__x5wmya(-1);
    this.u7a_1 = -1;
    this.v7a_1 = -1;
    this.w7a_1 = -1;
    this.x7a_1 = -1;
  }
  p2u() {
    this.t7a_1 = _AGWrapMode___init__impl__x5wmya(-1);
    this.u7a_1 = -1;
    this.v7a_1 = -1;
    this.w7a_1 = -1;
    this.x7a_1 = -1;
  }
}
class AGOpengl extends AG {
  static g7d(gl, context) {
    context = context === VOID ? null : context;
    var $this = this.j6n();
    $this.w77_1 = gl;
    $this.x77_1 = context;
    var tmp = $this;
    // Inline function 'kotlin.collections.linkedSetOf' call
    tmp.y77_1 = LinkedHashSet.i1();
    $this.z77_1 = new GLGlobalState($this.w77_1, $this);
    $this.a78_1 = HashMap.t8();
    $this.b78_1 = null;
    var tmp_0 = $this;
    tmp_0.c78_1 = lazy(AGOpengl$glslConfig$delegate$lambda($this));
    $this.d78_1 = null;
    $this.e78_1 = Companion_getInstance_42().m6o_1;
    $this.f78_1 = Companion_getInstance_49().l6p_1;
    $this.g78_1 = Companion_getInstance_46().x6o_1;
    $this.h78_1 = Companion_getInstance_45().v6o_1;
    $this.i78_1 = Companion_getInstance_47().z6o_1;
    $this.j78_1 = Companion_getInstance_48().f6p_1;
    $this.k78_1 = null;
    $this.l78_1 = AGTextureUnits.j6r();
    $this.m78_1 = new Int32Array($this.l78_1.f1());
    $this.n78_1 = 0;
    $this.o78_1 = Companion_getInstance_43().j6p_1;
    $this.p78_1 = -1;
    $this.q78_1 = -1;
    $this.r78_1 = get_ENABLE_VERTEX_ARRAY_OBJECTS();
    $this.s78_1 = Ref();
    $this.t78_1 = Buffer.m14(36);
    var tmp_1 = $this;
    var tmp_2 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_3 = fillArrayVal(Array(32), null);
    while (tmp_2 < 32) {
      var tmp_4 = tmp_2;
      tmp_3[tmp_4] = new TextureUnitParams(tmp_4);
      tmp_2 = tmp_2 + 1 | 0;
    }
    tmp_1.u78_1 = tmp_3;
    $this.v78_1 = allocDirect(Companion_instance_4, 0);
    $this.w78_1 = 7;
    $this.x78_1 = 0;
    $this.y78_1 = Companion_instance_48.j71();
    $this.z78_1 = -1;
    $this.a79_1 = new Long(-1, -1);
    $this.b79_1 = null;
    return $this;
  }
  static h7d(context) {
    return this.g7d(context.j7d_1, context);
  }
  f6o() {
    return this.w77_1;
  }
  z6n() {
    var gl = this.w77_1;
    super.z6n();
    gl.l7d();
    gl.m7d();
    this.a78_1.k3();
    resetObjects(this);
    this.p78_1 = -1;
    this.q78_1 = -1;
    this.r78_1 = true;
  }
  d6o(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    var gl = this.w77_1;
    this.n7d(frameBuffer, frameBufferInfo);
    this.o7d(scissor, frameBuffer, frameBufferInfo);
    var mask = 0;
    if (clearColor) {
      this.p7d(Companion_getInstance_47().c6p_1);
      gl.q7d(_RGBA___get_rf__impl__kvz75k(color), _RGBA___get_gf__impl__5gcu1f(color), _RGBA___get_bf__impl__1xz5yg(color), _RGBA___get_af__impl__vu36qv(color));
      mask = mask | 16384;
    }
    if (clearDepth) {
      gl.r7d(true);
      gl.s7d(depth);
      mask = mask | 256;
    }
    if (clearStencil) {
      this.g78_1 = Companion_getInstance_46().x6o_1;
      gl.t7d(-1);
      gl.u7d(stencil);
      mask = mask | 1024;
    }
    gl.v7d(mask);
  }
  e6o(frameBuffer, frameBufferInfo, vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances) {
    var gl = this.w77_1;
    this.n7d(frameBuffer, frameBufferInfo);
    this.o7d(scissor, frameBuffer, frameBufferInfo);
    var tmp1_safe_receiver = this.d78_1;
    if (!equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.r6w_1, vertexData.r6w_1)) {
      var tmp0_safe_receiver = this.d78_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        this.w7d(tmp0_safe_receiver);
      }
      this.d78_1 = vertexData;
      this.x7d(vertexData);
    } else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = vertexData.r6w_1.o10_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.draw.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var entry = array[_unary__edvuaz];
        bindBuffer$default(this, entry.f6x_1, AGBufferKind_VERTEX_getInstance(), true);
      }
    }
    useProgram(this, program);
    this.y7d(uniformBlocks, textureUnits, program, frameBuffer);
    if (!(this.e78_1 === blending)) {
      this.e78_1 = blending;
      // Inline function 'korlibs.kgl.KmlGl.enableDisable' call
      var enable = _AGBlending___get_enabled__impl__s7igz6(blending);
      if (gl.b7e(3042, enable)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.draw.<anonymous>' call
        gl.z7d(toGl(_AGBlending___get_eqRGB__impl__7pv8oi(blending)), toGl(_AGBlending___get_eqA__impl__2j4ray(blending)));
        gl.a7e(toGl_0(_AGBlending___get_srcRGB__impl__jvh03e(blending)), toGl_0(_AGBlending___get_dstRGB__impl__nz9ogp(blending)), toGl_0(_AGBlending___get_srcA__impl__ftmwxe(blending)), toGl_0(_AGBlending___get_dstA__impl__l7q6tv(blending)));
      }
    }
    this.c7e(depthAndFrontFace);
    this.p7d(colorMask);
    if (!(this.f78_1 === cullFace)) {
      this.f78_1 = cullFace;
      this.d7e(cullFace);
    }
    if (!(this.g78_1 === stencilOpFunc) || !equals(this.h78_1, stencilRef)) {
      this.g78_1 = stencilOpFunc;
      this.h78_1 = stencilRef;
      if (_AGStencilOpFunc___get_enabled__impl__hxq8wy(stencilOpFunc)) {
        gl.f7e(2960);
        if (_AGStencilOpFunc___get_compareModeFront__impl__uctsey(stencilOpFunc) === _AGStencilOpFunc___get_compareModeBack__impl__2rklx0(stencilOpFunc) && _AGStencilReference___get_referenceValueFront__impl__p7smsu(stencilRef) === _AGStencilReference___get_referenceValueBack__impl__mlrbhc(stencilRef) && _AGStencilReference___get_readMaskFront__impl__oc0s46(stencilRef) === _AGStencilReference___get_readMaskBack__impl__lwtaqk(stencilRef)) {
          gl.h7e(toGl_1(_AGStencilOpFunc___get_compareModeFront__impl__uctsey(stencilOpFunc)), _AGStencilReference___get_referenceValueFront__impl__p7smsu(stencilRef), _AGStencilReference___get_readMaskFront__impl__oc0s46(stencilRef));
        } else {
          gl.g7e(1028, toGl_1(_AGStencilOpFunc___get_compareModeFront__impl__uctsey(stencilOpFunc)), _AGStencilReference___get_referenceValueFront__impl__p7smsu(stencilRef), _AGStencilReference___get_readMaskFront__impl__oc0s46(stencilRef));
          gl.g7e(1029, toGl_1(_AGStencilOpFunc___get_compareModeBack__impl__2rklx0(stencilOpFunc)), _AGStencilReference___get_referenceValueBack__impl__mlrbhc(stencilRef), _AGStencilReference___get_readMaskBack__impl__lwtaqk(stencilRef));
        }
        if (_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq(stencilOpFunc) === _AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28(stencilOpFunc) && _AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh(stencilOpFunc) === _AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh(stencilOpFunc) && _AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx(stencilOpFunc) === _AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9(stencilOpFunc)) {
          gl.j7e(toGl_2(_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx(stencilOpFunc)));
        } else {
          gl.i7e(1028, toGl_2(_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx(stencilOpFunc)));
          gl.i7e(1029, toGl_2(_AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9(stencilOpFunc)));
        }
        if (_AGStencilReference___get_writeMaskFront__impl__cqdpbj(stencilRef) === _AGStencilReference___get_writeMaskBack__impl__mths73(stencilRef)) {
          gl.t7d(_AGStencilReference___get_writeMaskFront__impl__cqdpbj(stencilRef));
        } else {
          gl.k7e(1028, _AGStencilReference___get_writeMaskFront__impl__cqdpbj(stencilRef));
          gl.k7e(1029, _AGStencilReference___get_writeMaskBack__impl__mths73(stencilRef));
        }
      } else {
        gl.e7e(2960);
        gl.t7d(0);
      }
    }
    if (indices == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.graphics.gl.AGOpengl.draw.<anonymous>' call
      bindBuffer$default(this, indices, AGBufferKind_INDEX_getInstance());
    }
    var indexType_0 = !(indices == null) ? indexType : Companion_getInstance_41().i6o_1;
    if (!(indexType_0 === Companion_getInstance_41().i6o_1))
      if (!(instances === 1)) {
        gl.o7e(toGl_3(drawType), vertexCount, toGl_4(indexType_0), drawOffset, instances);
      } else {
        gl.n7e(toGl_3(drawType), vertexCount, toGl_4(indexType_0), drawOffset);
      }
     else if (!(instances === 1)) {
      gl.m7e(toGl_3(drawType), drawOffset, vertexCount, instances);
    } else {
      gl.l7e(toGl_3(drawType), drawOffset, vertexCount);
    }
  }
  h79() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.c78_1;
    glslConfig$factory();
    return this_0.s1();
  }
  c6o() {
    var gl = this.w77_1;
    var tmp0_safe_receiver = this.x77_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p7e();
    }
    gl.q7e(this.h6n_1);
    resetObjects(this);
    this.n78_1 = getIntegerv(gl, 36006);
    gl.r7c(33984);
    if (_GLVariant___get_supportTextureLevel__impl__3yeu62(gl.s7c())) {
      // Inline function 'korlibs.kgl.KmlGl.TEXTURE_2D' call
      gl.q7c(3553, 33084, 0);
      // Inline function 'korlibs.kgl.KmlGl.TEXTURE_2D' call
      gl.q7c(3553, 33085, 0);
    }
  }
  v6j() {
    var tmp0_safe_receiver = this.d78_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.w7d(tmp0_safe_receiver);
    }
    this.d78_1 = null;
    this.n7d(this.y6n().k6n_1, this.y6n().q6p());
    var tmp1_safe_receiver = this.x77_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.r7e();
    }
  }
  a6o() {
    var tmp0_safe_receiver = this.d78_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.w7d(tmp0_safe_receiver);
    }
    this.d78_1 = null;
    this.w77_1.yc();
    deletePendingObjects(this);
  }
  d7e(face) {
    if (this.w77_1.b7e(2884, _AGCullFace___get_ordinal__impl__jd1wps(face) > _AGCullFace___get_ordinal__impl__jd1wps(Companion_getInstance_49().m6p_1))) {
      this.w77_1.s7e(toGl_5(face));
    }
  }
  r7b(_this__u8e3s4, block) {
    if (!(_this__u8e3s4.a6r_1 === _this__u8e3s4.b6r_1)) {
      _this__u8e3s4.a6r_1 = _this__u8e3s4.b6r_1;
      block(_this__u8e3s4);
    }
  }
  w7d(vao) {
    if (this.r78_1 && this.w77_1.h6o()) {
      this.w77_1.v7e(0);
    } else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = vao.r6w_1.o10_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.vaoUnuse.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        // Inline function 'korlibs.graphics.shader.attributes' call
        var this_0 = array[_unary__edvuaz].e6x_1.v6w_1;
        var n_0 = 0;
        while (n_0 < this_0.f1()) {
          // Inline function 'korlibs.graphics.gl.AGOpengl.vaoUnuse.<anonymous>.<anonymous>' call
          var _unary__edvuaz_0 = n_0;
          n_0 = _unary__edvuaz_0 + 1 | 0;
          var att = this_0.e1(_unary__edvuaz_0);
          if (att.p73_1) {
            var loc = att.r73_1;
            if (loc >= 0) {
              if (!(att.q73_1 === 0)) {
                this.w77_1.t7e(loc, 0);
              }
              this.w77_1.u7e(loc);
            }
          }
        }
      }
    }
  }
  x7d(vao) {
    var gl = this.w77_1;
    if (this.r78_1 && gl.h6o()) {
      var vaoGl = get_gl(vao);
      if (vao.s6w_1) {
        if (!(this.q78_1 === this.h6n_1)) {
          this.p78_1 = genVertexArray(gl);
          this.q78_1 = this.h6n_1;
          if (this.p78_1 <= 0)
            this.r78_1 = false;
        }
        gl.v7e(this.p78_1);
        this.w7e(vao);
      } else {
        if (!(vaoGl.g77_1 === this.h6n_1)) {
          vaoGl.g77_1 = this.h6n_1;
          vaoGl.f77_1 = genVertexArray(gl);
          if (vaoGl.f77_1 <= 0)
            this.r78_1 = false;
          gl.v7e(vaoGl.f77_1);
          this.w7e(vao);
        }
        gl.v7e(vaoGl.f77_1);
        this.x7e(vao, this.r78_1);
      }
    } else {
      this.w7e(vao);
    }
  }
  x7e(vao, updateBuffersOnly) {
    var gl = this.w77_1;
    if (updateBuffersOnly) {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = vao.r6w_1.o10_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.graphics.gl.AGOpengl._vaoUse.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var entry = array[_unary__edvuaz];
        bindBuffer$default(this, entry.f6x_1, AGBufferKind_VERTEX_getInstance(), VOID, VOID, this.s78_1);
      }
      return Unit_instance;
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array_0 = vao.r6w_1.o10_1;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      // Inline function 'korlibs.graphics.gl.AGOpengl._vaoUse.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var entry_0 = array_0[_unary__edvuaz_0];
      var vertices = entry_0.f6x_1;
      var vertexLayout = entry_0.e6x_1;
      // Inline function 'korlibs.graphics.shader.attributes' call
      var vattrs = vertexLayout.v6w_1;
      // Inline function 'korlibs.graphics.shader.attributePositions' call
      var vattrspos = vertexLayout.a6x_1;
      bindBuffer$default(this, vertices, AGBufferKind_VERTEX_getInstance(), VOID, VOID, this.s78_1);
      var totalSize = vertexLayout.c6x_1;
      var inductionVariable = 0;
      var last = vattrspos.f1() - 1 | 0;
      if (inductionVariable <= last)
        $l$loop: do {
          var n_1 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var att = vattrs.e1(n_1);
          if (!att.p73_1)
            continue $l$loop;
          var off = vattrspos.e1(n_1);
          var loc = att.r73_1;
          var glElementType = toGl_7(att.c2e());
          var elementCount = att.c2e().c7c_1;
          if (loc >= 0) {
            gl.y7e(loc);
            gl.z7e(loc, elementCount, glElementType, att.o73_1, totalSize, numberToLong(entry_0.g6x_1).y3(toLong(off)));
            if (!(att.q73_1 === 0)) {
              gl.t7e(loc, att.q73_1);
            }
          }
        }
         while (inductionVariable <= last);
    }
  }
  w7e(vao, updateBuffersOnly, $super) {
    updateBuffersOnly = updateBuffersOnly === VOID ? false : updateBuffersOnly;
    var tmp;
    if ($super === VOID) {
      this.x7e(vao, updateBuffersOnly);
      tmp = Unit_instance;
    } else {
      tmp = $super.x7e.call(this, vao, updateBuffersOnly);
    }
    return tmp;
  }
  y7d(uniformBlocks, textureUnits, program, frameBuffer) {
    var tmp0_elvis_lhs = this.k78_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var glProgram = tmp;
    // Inline function 'korlibs.graphics.AGTextureUnits.fastForEach' call
    var inductionVariable = 0;
    var last = textureUnits.f1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.graphics.gl.AGOpengl.uniformsSet.<anonymous>' call
        var tex = textureUnits.h6r_1[n];
        var info = AGTextureUnitInfoArray__get_impl_xhvpef(textureUnits.i6r_1, n);
        var tex_0 = tex;
        if (equals(frameBuffer.m6s_1, tex_0)) {
          tex_0 = null;
        }
        var tmp0_safe_receiver = tex_0;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b6r_1;
        var texVersion = tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
        if (!(this.l78_1.h6r_1[n] === tex_0) || !(AGTextureUnitInfoArray__get_impl_xhvpef(this.l78_1.i6r_1, n) === info) || !(this.m78_1[n] === texVersion)) {
          this.l78_1.l6r(n, tex_0, info);
          this.m78_1[n] = texVersion;
          selectTextureUnit(this, n);
          if (!(tex_0 == null)) {
            var wrap = _AGTextureUnitInfo___get_wrap__impl__dwp6l(info);
            var linear = _AGTextureUnitInfo___get_linear__impl__jak6ny(info);
            var trilinear = _AGTextureUnitInfo___get_trilinear__impl__hxtqfb(info);
            this.a7f(tex_0, _AGTextureUnitInfo___get_kind__impl__6xtjoz(info));
            textureUnitParameters(this, tex_0.o6t(), wrap, this.b7f(tex_0, linear, trilinear), this.c7f(tex_0, linear, trilinear), _AGTextureTargetKind___get_dims__impl__k3cmhd(tex_0.o6t()));
          } else {
            this.a7f(null, Companion_getInstance_50().k6t_1);
          }
        }
      }
       while (inductionVariable < last);
    var glProgramInfo = glProgram.m79_1;
    // Inline function 'korlibs.graphics.shader.UniformBlocksBuffersRef.fastForEachBlock' call
    var inductionVariable_0 = 0;
    var last_0 = uniformBlocks.f1();
    if (inductionVariable_0 < last_0)
      $l$loop: do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var tmp0_elvis_lhs_0 = uniformBlocks.d7f_1[n_0];
        var tmp_0;
        if (tmp0_elvis_lhs_0 == null) {
          continue $l$loop;
        } else {
          tmp_0 = tmp0_elvis_lhs_0;
        }
        var block = tmp_0;
        $l$block: {
          // Inline function 'korlibs.graphics.gl.AGOpengl.uniformsSet.<anonymous>' call
          var buffer = uniformBlocks.e7f_1[n_0];
          var valueIndex = uniformBlocks.f7f_1[n_0];
          if (glProgram.m79_1.s79_1.r7a()) {
            var buffer_0 = bindBuffer$default(this, buffer, AGBufferKind_UNIFORM_getInstance());
            var tmp1_elvis_lhs_0 = buffer_0 == null ? null : buffer_0.o7b_1;
            this.w77_1.g7f(35345, block.q6u_1.k6w_1, tmp1_elvis_lhs_0 == null ? -1 : tmp1_elvis_lhs_0, imul(valueIndex, block.t6u_1), block.t6u_1);
            break $l$block;
          }
          var tmp2_elvis_lhs = glProgramInfo.v79_1[block.q6u_1.k6w_1];
          var tmp_1;
          if (tmp2_elvis_lhs == null) {
            var message = "Can't find uniform at " + block.q6u_1.k6w_1 + ' for program ' + program.toString() + ' for block ' + block.toString();
            throw IllegalStateException.h5(toString(message));
          } else {
            tmp_1 = tmp2_elvis_lhs;
          }
          var ref = tmp_1;
          var bufferMem = ensureNotNull(ensureNotNull(buffer).x6q_1);
          var currentMem = ref.i7f_1;
          var ublock = ref.h7f_1;
          if (valueIndex >= 0) {
            if (!arrayequal(bufferMem, valueIndex, currentMem, 0, ublock.r72())) {
              arraycopy_0(bufferMem, imul(ublock.r72(), valueIndex), currentMem, 0, ublock.r72());
              // Inline function 'korlibs.datastructure.iterators.fastForEach' call
              var this_0 = ublock.p72();
              var n_1 = 0;
              while (n_1 < this_0.f1()) {
                // Inline function 'korlibs.graphics.gl.AGOpengl.uniformsSet.<anonymous>.<anonymous>' call
                var _unary__edvuaz = n_1;
                n_1 = _unary__edvuaz + 1 | 0;
                var uniform = this_0.e1(_unary__edvuaz);
                writeUniform(this, uniform.j6w_1, glProgramInfo, sliceBuffer(currentMem, uniform.g6w_1, uniform.g6w_1 + uniform.y7b_1 | 0), 'blockUniformSet');
              }
            }
          } else {
            println('ERROR block: ' + block.q6u_1.toString() + ' has an invalid valueIndex=' + valueIndex);
          }
        }
      }
       while (inductionVariable_0 < last_0);
  }
  b7f(_this__u8e3s4, linear, trilinear) {
    var tmp;
    if ((_this__u8e3s4 == null ? null : _this__u8e3s4.e6t_1) === true) {
      tmp = linear ? trilinear ? 9987 : 9985 : trilinear ? 9986 : 9984;
    } else {
      tmp = linear ? 9729 : 9728;
    }
    return tmp;
  }
  c7f(_this__u8e3s4, linear, trilinear) {
    return linear ? 9729 : 9728;
  }
  l7f(scissor, frameBuffer, frameBufferInfo) {
    return scissor.equals(Companion_getInstance_43().k6p_1) || scissor.equals(Companion_getInstance_43().i6p_1) ? scissor : frameBuffer.l6s_1 ? Companion_getInstance_43().d2i(scissor.r2a(), _AGFrameBufferInfo___get_height__impl__yfespa(frameBufferInfo) - scissor.u2a() | 0, scissor.s2a(), _AGFrameBufferInfo___get_height__impl__yfespa(frameBufferInfo) - scissor.t2a() | 0) : scissor;
  }
  a7f(tex, target) {
    var gl = this.w77_1;
    var glTex = tex == null ? null : _get_gl__ndc1ty_1(tex, this);
    var tmp = toGl_8(target);
    var tmp2_elvis_lhs = glTex == null ? null : glTex.c7d_1;
    gl.m7f(tmp, tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs);
    var texBitmap = tex == null ? null : tex.d6t_1;
    if (!(glTex == null) && !(texBitmap == null)) {
      if (!(glTex.d7d_1 === texBitmap.i3z_1) || !(glTex.e7d_1 === this.h6n_1)) {
        glTex.d7d_1 = texBitmap.i3z_1;
        glTex.e7d_1 = this.h6n_1;
        tex.g6r();
      }
      this.r7b(tex, AGOpengl$textureBind$lambda(tex, target, gl, this, glTex));
    }
  }
  n7d(frameBuffer, info) {
    var gl = this.w77_1;
    if (!(this.y78_1 === _AGFrameBufferInfo___get_size__impl__uw80y4(info))) {
      gl.n7f(_AGFrameBufferInfo___get_x__impl__6dzfjj(info), _AGFrameBufferInfo___get_y__impl__mfn1io(info), _AGFrameBufferInfo___get_width__impl__yhp94z(info), _AGFrameBufferInfo___get_height__impl__yfespa(info));
    }
    if (frameBuffer.l6s_1) {
      if (!(this.z78_1 === this.n78_1)) {
        this.z78_1 = this.n78_1;
        gl.o7f(36160, this.n78_1);
      }
      return Unit_instance;
    }
    var fb = _get_gl__ndc1ty_0(frameBuffer, this);
    var tex = fb.r7f_1.m6s_1;
    var doMsaa = false;
    if (!equals(fb.u7f_1, info)) {
      fb.u7f_1 = info;
      var internalFormat = _AGFrameBufferInfo___get_hasStencilAndDepth__impl__aauqdj(info) ? 34041 : _AGFrameBufferInfo___get_hasStencil__impl__hjoes3(info) ? 36168 : _AGFrameBufferInfo___get_hasDepth__impl__9knjmc(info) ? 6402 : 0;
      var texTarget = doMsaa ? 37120 : 3553;
      tex.d6t_1 = NullBitmap.c4e(_AGFrameBufferInfo___get_width__impl__yhp94z(info), _AGFrameBufferInfo___get_height__impl__yfespa(info), false);
      // Inline function 'korlibs.graphics.gl.AGOpengl.selectTextureUnitTemp' call
      var index = this.w78_1;
      var old = selectTextureUnit(this, index);
      try {
        // Inline function 'korlibs.graphics.gl.AGOpengl.bindFrameBuffer.<anonymous>' call
        this.a7f(tex, Companion_getInstance_50().k6t_1);
        textureUnitParameters(this, Companion_getInstance_50().k6t_1, Companion_getInstance_51().j6u_1, 9729, 9729, 2);
      }finally {
        if (true) {
          this.a7f(null, Companion_getInstance_50().k6t_1);
        }
        selectTextureUnit(this, old);
      }
      gl.v7f(36161, fb.s7f_1);
      if (!(internalFormat === 0)) {
        gl.w7f(36161, internalFormat, _AGFrameBufferInfo___get_width__impl__yhp94z(info), _AGFrameBufferInfo___get_height__impl__yfespa(info));
      }
      gl.v7f(36161, 0);
      gl.o7f(36160, fb.t7f_1);
      gl.x7f(36160, 36064, 3553, _get_gl__ndc1ty_1(fb.r7f_1.m6s_1, this).c7d_1, 0);
      if (!(internalFormat === 0)) {
        gl.y7f(36160, _AGFrameBufferInfo___get_hasStencilAndDepth__impl__aauqdj(info) ? 33306 : _AGFrameBufferInfo___get_hasStencil__impl__hjoes3(info) ? 36128 : _AGFrameBufferInfo___get_hasDepth__impl__9knjmc(info) ? 36096 : 0, 36161, fb.s7f_1);
      } else {
        gl.y7f(36160, 36128, 36161, 0);
        gl.y7f(36160, 36096, 36161, 0);
      }
    }
    if (!(this.z78_1 === fb.t7f_1)) {
      this.z78_1 = fb.t7f_1;
      gl.o7f(36160, fb.t7f_1);
    }
  }
  c7e(renderState) {
    var gl = this.w77_1;
    if (!(this.j78_1 === renderState)) {
      this.j78_1 = renderState;
      gl.z7f(toGl_10(_AGDepthAndFrontFace___get_frontFace__impl__w07k4s(renderState)));
      gl.r7d(_AGDepthAndFrontFace___get_depthMask__impl__ouijn(renderState));
      gl.a7g(_AGDepthAndFrontFace___get_depthNear__impl__cir3a1(renderState), _AGDepthAndFrontFace___get_depthFar__impl__g0cno8(renderState));
      // Inline function 'korlibs.kgl.KmlGl.enableDisable' call
      var enable = !(_AGDepthAndFrontFace___get_depthFunc__impl__8fo7zp(renderState) === Companion_getInstance_56().m6z_1);
      if (gl.b7e(2929, enable)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.setDepthAndFrontFace.<anonymous>' call
        gl.b7g(toGl_1(_AGDepthAndFrontFace___get_depthFunc__impl__8fo7zp(renderState)));
      }
    }
  }
  p7d(colorMask) {
    var gl = this.w77_1;
    if (!(this.i78_1 === colorMask)) {
      this.i78_1 = colorMask;
      gl.c7g(_AGColorMask___get_red__impl__opo1fo(colorMask), _AGColorMask___get_green__impl__d3m1w2(colorMask), _AGColorMask___get_blue__impl__42l0s1(colorMask), _AGColorMask___get_alpha__impl__xmrqzb(colorMask));
    }
  }
  o7d(scissor, frameBuffer, frameBufferInfo) {
    var gl = this.w77_1;
    var scissor_0 = this.l7f(scissor, frameBuffer, frameBufferInfo);
    if (!this.o78_1.equals(scissor_0)) {
      this.o78_1 = scissor_0;
      // Inline function 'korlibs.kgl.KmlGl.enableDisable' call
      var enable = !scissor_0.equals(Companion_getInstance_43().k6p_1);
      if (gl.b7e(3089, enable)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.setScissorState.<anonymous>' call
        gl.d7g(scissor_0.b6j(), scissor_0.c6j(), scissor_0.d2m(), scissor_0.e2m());
      }
    }
  }
}
class GLGlobalState {
  constructor(gl, ag) {
    this.y7a_1 = gl;
    this.z7a_1 = ag;
    this.a7b_1 = atomic$int$1(0);
    this.b7b_1 = atomic$int$1(0);
    this.c7b_1 = atomic$ref$1(0.0);
    this.d7b_1 = atomic$int$1(0);
    this.e7b_1 = atomic$int$1(0);
    this.f7b_1 = atomic$ref$1(0.0);
    this.g7b_1 = new Lock();
    this.h7b_1 = fastArrayListOf([]);
  }
}
class GLBaseObject {
  constructor(globalState) {
    this.i7b_1 = globalState;
    this.j7b_1 = this.i7b_1.y7a_1;
  }
  k7b() {
  }
  h6u() {
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = this.i7b_1.g7b_1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.i1y();
      try {
        this.i7b_1.h7b_1.h(this);
        break $l$block;
      }finally {
        this_0.k1y();
      }
    }
  }
}
class GLBaseProgram extends GLBaseObject {
  constructor(globalState, programInfo) {
    super(globalState);
    this.m79_1 = programInfo;
  }
  k7b() {
    this.m79_1.e7g(this.j7b_1);
  }
  n79() {
    this.m79_1.f7g(this.j7b_1);
  }
}
class GLBuffer extends GLBaseObject {
  constructor(state) {
    super(state);
    this.o7b_1 = genBuffer(this.j7b_1);
    this.p7b_1 = -1;
    this.q7b_1 = 0.0;
    this.i7b_1.d7b_1.atomicfu$incrementAndGet();
  }
  t7c(value) {
    $l$block: {
      // Inline function 'kotlinx.atomicfu.updateAndGet' call
      var this_0 = this.i7b_1.f7b_1;
      while (true) {
        var cur = this_0.kotlinx$atomicfu$value;
        // Inline function 'korlibs.graphics.gl.GLBuffer.<set-estimatedBytes>.<anonymous>' call
        var upd = cur + value - this.q7b_1;
        if (this_0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    this.q7b_1 = value;
  }
  k7b() {
    this.i7b_1.e7b_1.atomicfu$incrementAndGet();
    deleteBuffer(this.j7b_1, this.o7b_1);
    this.o7b_1 = -1;
    this.p7b_1 = -1;
  }
  toString() {
    return 'GLBuffer(' + this.o7b_1 + ')';
  }
}
class GLTexture extends GLBaseObject {
  constructor(state) {
    super(state);
    this.c7d_1 = genTexture(this.j7b_1);
    this.d7d_1 = -2;
    this.e7d_1 = -2;
    this.f7d_1 = 0.0;
    this.i7b_1.a7b_1.atomicfu$incrementAndGet();
  }
  t7c(value) {
    $l$block: {
      // Inline function 'kotlinx.atomicfu.updateAndGet' call
      var this_0 = this.i7b_1.c7b_1;
      while (true) {
        var cur = this_0.kotlinx$atomicfu$value;
        // Inline function 'korlibs.graphics.gl.GLTexture.<set-estimatedBytes>.<anonymous>' call
        var upd = cur + value - this.f7d_1;
        if (this_0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    this.f7d_1 = value;
  }
  k7b() {
    this.i7b_1.b7b_1.atomicfu$incrementAndGet();
    deleteTexture(this.j7b_1, this.c7d_1);
    this.c7d_1 = -1;
  }
}
class GLFrameBuffer extends GLBaseObject {
  constructor(state, ag) {
    super(state);
    this.r7f_1 = ag;
    this.s7f_1 = genRenderbuffer(this.j7b_1);
    this.t7f_1 = genFramebuffer(this.j7b_1);
    this.u7f_1 = Companion_getInstance_44().z6y_1;
  }
  k7b() {
    deleteRenderbuffer(this.j7b_1, this.s7f_1);
    deleteFramebuffer(this.j7b_1, this.t7f_1);
    this.s7f_1 = -1;
    this.t7f_1 = -1;
  }
}
class GLProgramInfo {
  constructor(programId, vertexId, fragmentId, blocks, config) {
    this.o79_1 = programId;
    this.p79_1 = vertexId;
    this.q79_1 = fragmentId;
    this.r79_1 = blocks;
    this.s79_1 = config;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.r79_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.pc(capacity);
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.graphics.gl.GLProgramInfo.blocksByFixedLocation.<anonymous>' call
      var tmp$ret$0 = element.k6w_1;
      destination.h3(tmp$ret$0, element);
    }
    tmp.t79_1 = destination;
    var tmp_0 = this;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var iterator = this.r79_1.b1();
      if (!iterator.c1()) {
        tmp$ret$3 = null;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.gl.GLProgramInfo.maxBlockId.<anonymous>' call
      var maxValue = iterator.d1().k6w_1;
      while (iterator.c1()) {
        // Inline function 'korlibs.graphics.gl.GLProgramInfo.maxBlockId.<anonymous>' call
        var v = iterator.d1().k6w_1;
        if (compareTo(maxValue, v) < 0) {
          maxValue = v;
        }
      }
      tmp$ret$3 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$3;
    tmp_0.u79_1 = (tmp0_elvis_lhs == null ? -1 : tmp0_elvis_lhs) + 1 | 0;
    var tmp_1 = this;
    var tmp_2 = 0;
    var tmp_3 = this.u79_1 + 1 | 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_4 = fillArrayVal(Array(tmp_3), null);
    while (tmp_2 < tmp_3) {
      var tmp_5 = tmp_2;
      var tmp0_safe_receiver = this.t79_1.f3(tmp_5);
      var tmp_6;
      if (tmp0_safe_receiver == null) {
        tmp_6 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.gl.GLProgramInfo.uniforms.<anonymous>' call
        tmp_6 = UniformsRef.g7g(tmp0_safe_receiver);
      }
      tmp_4[tmp_5] = tmp_6;
      tmp_2 = tmp_2 + 1 | 0;
    }
    tmp_1.v79_1 = tmp_4;
    this.w79_1 = FastStringMap();
    this.x79_1 = FastStringMap();
  }
  j7a(gl, name) {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.x79_1;
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var res = this_0.get(name);
      if (!(res == null)) {
        tmp$ret$2 = res;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.gl.GLProgramInfo.getUniformLocation.<anonymous>' call
      var out = gl.h7g(this.o79_1, name);
      // Inline function 'korlibs.datastructure.set' call
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.set(name, out);
      tmp$ret$2 = out;
    }
    return tmp$ret$2;
  }
  f7g(gl) {
    gl.i7g(this.o79_1);
  }
  e7g(gl) {
    if (!(this.p79_1 === 0)) {
      gl.j7g(this.p79_1);
    }
    if (!(this.q79_1 === 0)) {
      gl.j7g(this.q79_1);
    }
    if (!(this.o79_1 === 0)) {
      gl.k7g(this.o79_1);
    }
    this.p79_1 = 0;
    this.q79_1 = 0;
    this.o79_1 = 0;
  }
  toString() {
    return 'GLProgramInfo(programId=' + this.o79_1 + ', vertexId=' + this.p79_1 + ', fragmentId=' + this.q79_1 + ', blocks=' + toString(this.r79_1) + ', config=' + this.s79_1.toString() + ')';
  }
  hashCode() {
    var result = this.o79_1;
    result = imul(result, 31) + this.p79_1 | 0;
    result = imul(result, 31) + this.q79_1 | 0;
    result = imul(result, 31) + hashCode(this.r79_1) | 0;
    result = imul(result, 31) + this.s79_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GLProgramInfo))
      return false;
    var tmp0_other_with_cast = other instanceof GLProgramInfo ? other : THROW_CCE();
    if (!(this.o79_1 === tmp0_other_with_cast.o79_1))
      return false;
    if (!(this.p79_1 === tmp0_other_with_cast.p79_1))
      return false;
    if (!(this.q79_1 === tmp0_other_with_cast.q79_1))
      return false;
    if (!equals(this.r79_1, tmp0_other_with_cast.r79_1))
      return false;
    if (!this.s79_1.equals(tmp0_other_with_cast.s79_1))
      return false;
    return true;
  }
}
class GLShaderCompiler {
  constructor() {
    GLShaderCompiler_instance = this;
    this.i79_1 = Companion_getInstance_1().ey('GLShaderCompiler');
  }
  j79(gl, config, program, debugName) {
    var id = gl.p7g();
    var guessedGlSlVersion = get_versionInt(gl);
    var tmp0_elvis_lhs = Companion_getInstance_61().r7g();
    var usedGlSlVersion = tmp0_elvis_lhs == null ? guessedGlSlVersion : tmp0_elvis_lhs;
    if (Companion_getInstance_61().s7g()) {
      // Inline function 'korlibs.logger.Logger.trace' call
      var this_0 = this.i79_1;
      var level = Level_TRACE_getInstance();
      var tmp;
      if (this_0.x2x(level)) {
        // Inline function 'korlibs.graphics.gl.GLShaderCompiler.programCreate.<anonymous>' call
        var tmp$ret$0 = 'GLSL version: usedGlSlVersion=' + usedGlSlVersion + ', guessed=' + guessedGlSlVersion + ', forced=' + Companion_getInstance_61().r7g() + '. used=' + usedGlSlVersion;
        this_0.y2x(level, tmp$ret$0);
        tmp = Unit_instance;
      }
    }
    // Inline function 'kotlin.collections.map' call
    var this_1 = listOf_0([false, true]);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator = this_1.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.graphics.gl.GLShaderCompiler.programCreate.<anonymous>' call
      var tmp$ret$2 = config.t7g(VOID, VOID, usedGlSlVersion, item);
      destination.h(tmp$ret$2);
    }
    var _destruct__k2r9zo = this.u7g(gl, program, debugName, destination);
    var fragmentShaderId = _destruct__k2r9zo.nl();
    var vertexShaderId = _destruct__k2r9zo.ol();
    var finalConfig = _destruct__k2r9zo.vr();
    var _iterator__ex2g4s = program.s6v_1.b1();
    while (_iterator__ex2g4s.c1()) {
      var attr = _iterator__ex2g4s.d1();
      var location = attr.r73_1;
      gl.v7g(id, location, attr.e7a_1);
    }
    gl.w7g(id, fragmentShaderId);
    gl.w7g(id, vertexShaderId);
    gl.x7g(id);
    // Inline function 'korlibs.kgl.KmlGl.LINK_STATUS' call
    var linkStatus = getProgramiv(gl, id, 35714);
    return new GLProgramInfo(id, vertexShaderId, fragmentShaderId, program.p6v_1, finalConfig);
  }
  u7g(gl, program, debugName, configs) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var errors = ArrayList.j1();
    var _iterator__ex2g4s = configs.b1();
    $l$loop: while (_iterator__ex2g4s.c1()) {
      var config = _iterator__ex2g4s.d1();
      try {
        var fragmentString = toNewGlslString(program.l6v_1, config);
        var vertexString = toNewGlslString(program.k6v_1, config);
        var fragmentShaderId = createShader(this, gl, 35632, fragmentString, debugName);
        var vertexShaderId = createShader(this, gl, 35633, vertexString, debugName);
        // Inline function 'korlibs.logger.Logger.debug' call
        var this_0 = this.i79_1;
        var level = Level_DEBUG_getInstance();
        var tmp;
        if (this_0.x2x(level)) {
          // Inline function 'korlibs.graphics.gl.GLShaderCompiler.createShaderWithConfigs.<anonymous>' call
          var tmp$ret$1 = '!!! PROGRAM SUCCESSFULLY COMPILED: config=' + config.toString() + '\n' + vertexString + '\n' + fragmentString;
          this_0.y2x(level, tmp$ret$1);
          tmp = Unit_instance;
        }
        return new Triple(fragmentShaderId, vertexShaderId, config);
      } catch ($p) {
        if ($p instanceof ShaderException) {
          var e = $p;
          // Inline function 'korlibs.logger.Logger.debug' call
          var this_1 = this.i79_1;
          var level_0 = Level_DEBUG_getInstance();
          var tmp_0;
          if (this_1.x2x(level_0)) {
            // Inline function 'korlibs.graphics.gl.GLShaderCompiler.createShaderWithConfigs.<anonymous>' call
            var tmp$ret$3 = stackTraceToString(e);
            this_1.y2x(level_0, tmp$ret$3);
            tmp_0 = Unit_instance;
          }
          // Inline function 'kotlin.collections.plusAssign' call
          errors.h(e);
          continue $l$loop;
        } else {
          throw $p;
        }
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(errors, 10));
    var tmp0_iterator = errors.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.graphics.gl.GLShaderCompiler.createShaderWithConfigs.<anonymous>' call
      var tmp$ret$5 = item.message;
      destination.h(tmp$ret$5);
    }
    throw Exception.ge('Tried several shaders: ' + toString(destination), last(errors));
  }
}
class AGDummy extends AG {
  static c7h(size) {
    size = size === VOID ? Size2D.h2b(640, 480) : size;
    var $this = this.j6n();
    $this.y6n().q6s(numberToInt(size.f2b_1), numberToInt(size.g2b_1));
    return $this;
  }
}
class AGBaseLog extends AGDummy {
  static w7h(size) {
    size = size === VOID ? Size2D.h2b(640, 480) : size;
    var $this = this.c7h(size);
    $this.r7h_1 = 0;
    $this.s7h_1 = 0;
    $this.t7h_1 = 0;
    $this.u7h_1 = 0;
    $this.v7h_1 = linkedHashMapOf([]);
    return $this;
  }
  x7h(str, kind) {
  }
  b6o(command) {
    this.x7h(toString(command), Kind_COMMAND_getInstance());
  }
  a6o() {
    return this.x7h('finish()', Kind_FLIP_getInstance());
  }
}
class AGPrint extends AGBaseLog {
  static m7h(size) {
    size = size === VOID ? Size2D.h2b(640, 480) : size;
    return this.w7h(size);
  }
  x7h(str, kind) {
    println('PrintAG: ' + str);
  }
}
class Kind_0 extends Enum {}
class Companion_43 {
  constructor() {
    Companion_instance_52 = this;
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    var tmp_0 = [];
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$1 = [];
    tmp.s6o_1 = new UniformBlocksBuffersRef(tmp_0, tmp$ret$1, new Int32Array(0));
  }
}
class UniformBlocksBuffersRef {
  constructor(blocks, buffers, valueIndices) {
    Companion_getInstance_58();
    this.d7f_1 = blocks;
    this.e7f_1 = buffers;
    this.f7f_1 = valueIndices;
  }
  f1() {
    return this.d7f_1.length;
  }
}
class Gen {
  constructor(block, name, voffset, vindex, type, arrayCount, size, align) {
    arrayCount = arrayCount === VOID ? 1 : arrayCount;
    this.d72_1 = block;
    this.e72_1 = name;
    this.f72_1 = voffset;
    this.g72_1 = vindex;
    this.h72_1 = type;
    this.i72_1 = arrayCount;
    this.j72_1 = size;
    this.k72_1 = align;
    var tmp = this;
    tmp.l72_1 = lazy(UniformBlock$Gen$uniform$delegate$lambda(this));
  }
  z7h() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.l72_1;
    uniform$factory();
    return this_0.s1();
  }
  m72(block, property) {
    var tmp = this;
    var tmp0_elvis_lhs = this.e72_1;
    tmp.e72_1 = tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs;
    return this.z7h();
  }
  toString() {
    return 'Gen(block=' + this.d72_1.toString() + ', name=' + this.e72_1 + ', voffset=' + this.f72_1 + ', vindex=' + this.g72_1 + ', type=' + this.h72_1.toString() + ', arrayCount=' + this.i72_1 + ', size=' + this.j72_1 + ', align=' + this.k72_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.d72_1);
    result = imul(result, 31) + (this.e72_1 == null ? 0 : getStringHashCode(this.e72_1)) | 0;
    result = imul(result, 31) + this.f72_1 | 0;
    result = imul(result, 31) + this.g72_1 | 0;
    result = imul(result, 31) + this.h72_1.hashCode() | 0;
    result = imul(result, 31) + this.i72_1 | 0;
    result = imul(result, 31) + this.j72_1 | 0;
    result = imul(result, 31) + this.k72_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Gen))
      return false;
    var tmp0_other_with_cast = other instanceof Gen ? other : THROW_CCE();
    if (!equals(this.d72_1, tmp0_other_with_cast.d72_1))
      return false;
    if (!(this.e72_1 == tmp0_other_with_cast.e72_1))
      return false;
    if (!(this.f72_1 === tmp0_other_with_cast.f72_1))
      return false;
    if (!(this.g72_1 === tmp0_other_with_cast.g72_1))
      return false;
    if (!this.h72_1.equals(tmp0_other_with_cast.h72_1))
      return false;
    if (!(this.i72_1 === tmp0_other_with_cast.i72_1))
      return false;
    if (!(this.j72_1 === tmp0_other_with_cast.j72_1))
      return false;
    if (!(this.k72_1 === tmp0_other_with_cast.k72_1))
      return false;
    return true;
  }
}
class Operand {
  static i7r(type) {
    var $this = createThis(this);
    $this.s7b_1 = type;
    return $this;
  }
  c2e() {
    return this.s7b_1;
  }
}
class OperandWithArray extends Operand {
  static f7t(type, arrayCount) {
    var $this = this.i7r(type);
    $this.u7b_1 = arrayCount;
    $this.v7b_1 = type.b7c_1;
    $this.w7b_1 = type.c7c_1;
    $this.x7b_1 = imul($this.w7b_1, $this.u7b_1);
    $this.y7b_1 = imul(type.e7c_1, $this.u7b_1);
    return $this;
  }
}
class Variable extends OperandWithArray {
  static g7s(name, type, arrayCount, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    var $this = this.f7t(type, arrayCount);
    $this.e7a_1 = name;
    $this.f7a_1 = precision;
    var tmp = $this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(arrayCount), null);
    while (tmp_0 < arrayCount) {
      var tmp_2 = tmp_0;
      tmp_1[tmp_2] = $this.e7a_1 + '[' + tmp_2 + ']';
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.g7a_1 = tmp_1;
    $this.h7a_1 = 0;
    $this.i7a_1 = null;
    return $this;
  }
  static x7s(name, type, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.g7s(name, type, 1, precision);
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Variable) {
      tmp_2 = this.h7a_1 === other.h7a_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.c2e().equals(other.c2e());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.u7b_1 === other.u7b_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.e7a_1 === other.e7a_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.h7a_1 + imul(this.c2e().hashCode(), 7) | 0) + imul(getStringHashCode(this.e7a_1), 11) | 0;
  }
}
class VariableWithOffset extends Variable {
  static q7i(name, type, arrayCount, precision, offset) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    offset = offset === VOID ? null : offset;
    var $this = this.g7s(name, type, arrayCount, precision);
    $this.p7i_1 = offset;
    return $this;
  }
}
class TypedUniform extends VariableWithOffset {
  static y7h(name, voffset, vindex, block, type, arrayCount) {
    var $this = this.q7i(name, type, arrayCount, Precision_DEFAULT_getInstance());
    $this.g6w_1 = voffset;
    $this.h6w_1 = vindex;
    $this.i6w_1 = block;
    $this.j6w_1 = Uniform.e7j(name, type, arrayCount, VOID, VOID, $this);
    return $this;
  }
  mo(thisRef, property) {
    return this;
  }
  toString() {
    return "TypedUniform(name='" + this.e7a_1 + "', offset=" + this.g6w_1 + ', type=' + this.c2e().toString() + ')';
  }
}
class Companion_44 {}
class UniformBlockBuffer {
  constructor(block) {
    this.q6u_1 = block;
    this.r6u_1 = new AGBuffer();
    this.s6u_1 = this.q6u_1.q72();
    this.t6u_1 = this.q6u_1.r72();
    this.u6u_1 = this.q6u_1.p72().f1();
    this.v6u_1 = Buffer.m14(imul(this.t6u_1, 1));
    this.w6u_1 = UniformsRef.f7j(this.q6u_1, this.v6u_1, -1);
    this.x6u_1 = Buffer.m14(this.q6u_1.r72());
  }
  toString() {
    return 'UniformBlockBuffer(' + toString(this.q6u_1) + ')';
  }
  g7j(value) {
    this.w6u_1.j7f_1 = value;
  }
  p6w() {
    return this.w6u_1.j7f_1;
  }
  h7j(index) {
    if (index >= (_get_bufferSize__mp12kq(this) - 1 | 0)) {
      // Inline function 'kotlin.math.max' call
      var a = index + 1 | 0;
      var b = imul(index + 2 | 0, 3);
      var newCapacity = Math.max(a, b);
      this.v6u_1 = copyOf(this.v6u_1, imul(this.t6u_1, newCapacity));
      this.w6u_1.i7f_1 = this.v6u_1;
    }
  }
  p2u() {
    this.g7j(-1);
  }
  z6u() {
    var tmp = this.v6u_1;
    // Inline function 'kotlin.math.max' call
    var b = imul(this.p6w() + 1 | 0, this.q6u_1.r72());
    var tmp$ret$0 = Math.max(0, b);
    this.r6u_1.e6r(tmp, 0, tmp$ret$0);
    return this;
  }
  i7j() {
    var _unary__edvuaz = this.p6w();
    this.g7j(_unary__edvuaz - 1 | 0);
  }
}
class UBLayoutBuilder {
  constructor() {
    this.a7i_1 = 0;
    this.b7i_1 = 4;
    var tmp = this;
    tmp.c7i_1 = lazy(UBLayoutBuilder$size$delegate$lambda(this));
  }
  f1() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.c7i_1;
    size$factory();
    return this_0.s1();
  }
  d7i(size, align_0) {
    // Inline function 'kotlin.also' call
    var this_0 = align(this, align_0).a7i_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UBLayoutBuilder.rawAlloc.<anonymous>' call
    this.a7i_1 = this.a7i_1 + size | 0;
    return this_0;
  }
}
class UniformsRef {
  static f7j(block, buffer, index) {
    var $this = createThis(this);
    $this.h7f_1 = block;
    $this.i7f_1 = buffer;
    $this.j7f_1 = index;
    $this.k7f_1 = $this.h7f_1.r72();
    return $this;
  }
  static g7g(block, size, index) {
    size = size === VOID ? 1 : size;
    index = index === VOID ? 0 : index;
    return this.f7j(block, Buffer.m14(imul(block.r72(), size)), index);
  }
  j7j(uniform) {
    return imul(this.j7f_1, this.k7f_1) + uniform.g6w_1 | 0;
  }
  k7j(ref) {
    arraycopy_0(ref.v6u_1, 0, this.i7f_1, imul(this.j7f_1, this.k7f_1), this.k7f_1);
  }
  l7j(uniform, value) {
    return this.m7j(uniform, value);
  }
  n7j(uniform, value) {
    return this.o7j(uniform, _RGBAPremultiplied___get_rf__impl__pt0c4y(value), _RGBAPremultiplied___get_gf__impl__ivron7(value), _RGBAPremultiplied___get_bf__impl__qa3on2(value), _RGBAPremultiplied___get_af__impl__euwcjn(value));
  }
  p7j(uniform, value) {
    return this.o7j(uniform, value.h2l_1, value.i2l_1, value.j2l_1, value.k2l_1);
  }
  q7j(uniform, value) {
    switch (uniform.c2e().r3_1) {
      case 3:
        this.r7j(uniform, value, Companion_getInstance_6().o2g_1);
        break;
      case 2:
        this.s7j(uniform, value, Companion_getInstance_6().o2g_1, 12);
        break;
      default:
        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.be();
    }
  }
  s7j(uniform, value, indices, max) {
    // Inline function 'kotlin.also' call
    var this_0 = this.j7j(uniform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.bufferSetFloatNIndexed' call
    var inductionVariable = 0;
    if (inductionVariable < max)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.memory.setF32' call
        var this_1 = this.i7f_1;
        var byteOffset = this_0 + imul(n, 4) | 0;
        // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>.<anonymous>' call
        var it = indices[n];
        var value_0 = value.s2h(it);
        var tmp;
        if (true) {
          this_1.q14(byteOffset, value_0);
          tmp = Unit_instance;
        } else {
          this_1.p14(byteOffset, value_0);
          tmp = Unit_instance;
        }
      }
       while (inductionVariable < max);
  }
  r7j(uniform, value, indices, max, $super) {
    max = max === VOID ? indices.length : max;
    var tmp;
    if ($super === VOID) {
      this.s7j(uniform, value, indices, max);
      tmp = Unit_instance;
    } else {
      tmp = $super.s7j.call(this, uniform, value, indices, max);
    }
    return tmp;
  }
  m7j(uniform, value) {
    // Inline function 'kotlin.also' call
    var this_0 = this.j7j(uniform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>' call
    // Inline function 'korlibs.memory.setF32' call
    var this_1 = this.i7f_1;
    var byteOffset = this_0 + 0 | 0;
    var tmp;
    if (true) {
      this_1.q14(byteOffset, value);
      tmp = Unit_instance;
    } else {
      this_1.p14(byteOffset, value);
      tmp = Unit_instance;
    }
  }
  o7j(uniform, x, y, z, w) {
    // Inline function 'kotlin.also' call
    var this_0 = this.j7j(uniform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>' call
    this.t7j(this_0, x, y, z, w);
  }
  t7j(index, x, y, z, w) {
    // Inline function 'korlibs.memory.setF32' call
    var this_0 = this.i7f_1;
    var byteOffset = index + 0 | 0;
    var tmp;
    if (true) {
      this_0.q14(byteOffset, x);
      tmp = Unit_instance;
    } else {
      this_0.p14(byteOffset, x);
      tmp = Unit_instance;
    }
    // Inline function 'korlibs.memory.setF32' call
    var this_1 = this.i7f_1;
    var byteOffset_0 = index + 4 | 0;
    var tmp_0;
    if (true) {
      this_1.q14(byteOffset_0, y);
      tmp_0 = Unit_instance;
    } else {
      this_1.p14(byteOffset_0, y);
      tmp_0 = Unit_instance;
    }
    // Inline function 'korlibs.memory.setF32' call
    var this_2 = this.i7f_1;
    var byteOffset_1 = index + 8 | 0;
    var tmp_1;
    if (true) {
      this_2.q14(byteOffset_1, z);
      tmp_1 = Unit_instance;
    } else {
      this_2.p14(byteOffset_1, z);
      tmp_1 = Unit_instance;
    }
    // Inline function 'korlibs.memory.setF32' call
    var this_3 = this.i7f_1;
    var byteOffset_2 = index + 12 | 0;
    var tmp_2;
    if (true) {
      this_3.q14(byteOffset_2, w);
      tmp_2 = Unit_instance;
    } else {
      this_3.p14(byteOffset_2, w);
      tmp_2 = Unit_instance;
    }
  }
}
class Companion_45 {
  u7j(isES, isWebGL, isCore, version, os) {
    return _GLVariant___init__impl__cjzpjb(insert8(insert8(insert(insert(insert(0, isES, 0), isWebGL, 1), isCore, 2), version, 8), os.r3_1, 16));
  }
  v7j(isES, isWebGL, isCore, version, os, $super) {
    isES = isES === VOID ? false : isES;
    isWebGL = isWebGL === VOID ? false : isWebGL;
    isCore = isCore === VOID ? false : isCore;
    version = version === VOID ? 0 : version;
    os = os === VOID ? Os_UNKNOWN_getInstance() : os;
    return $super === VOID ? this.u7j(isES, isWebGL, isCore, version, os) : $super.u7j.call(this, isES, isWebGL, isCore, version, os).w7j_1;
  }
  x7j() {
    return Companion_instance_54.v7j(false, VOID, VOID, 1, Os_UNKNOWN_getInstance());
  }
  y7j(version) {
    return Companion_instance_54.v7j(true, true, VOID, version);
  }
}
class GLVariant {
  constructor(data) {
    this.w7j_1 = data;
  }
  toString() {
    return GLVariant__toString_impl_o5yi3l(this.w7j_1);
  }
  hashCode() {
    return GLVariant__hashCode_impl_2eslaq(this.w7j_1);
  }
  equals(other) {
    return GLVariant__equals_impl_kmlw2(this.w7j_1, other);
  }
}
class Visitor {
  constructor(default_0, $box) {
    boxApply(this, $box);
    this.r7l_1 = default_0;
  }
  s7l(func) {
    this.t7l(func.k7n_1);
  }
  g7r(stms) {
    var _iterator__ex2g4s = stms.b1();
    while (_iterator__ex2g4s.c1()) {
      var stm = _iterator__ex2g4s.d1();
      this.t7l(stm);
    }
  }
  t7l(stm) {
    var tmp;
    if (stm == null) {
      tmp = Unit_instance;
    } else {
      if (stm instanceof Stms) {
        this.u7l(stm);
        tmp = Unit_instance;
      } else {
        if (stm instanceof Set) {
          this.x7l(stm);
          tmp = Unit_instance;
        } else {
          if (stm instanceof If) {
            this.v7l(stm);
            tmp = Unit_instance;
          } else {
            if (stm instanceof ForSimple) {
              this.w7l(stm);
              tmp = Unit_instance;
            } else {
              if (stm instanceof Discard) {
                this.y7l(stm);
                tmp = Unit_instance;
              } else {
                if (stm instanceof Continue) {
                  this.a7m(stm);
                  tmp = Unit_instance;
                } else {
                  if (stm instanceof Break) {
                    this.z7l(stm);
                    tmp = Unit_instance;
                  } else {
                    if (stm instanceof Raw) {
                      this.b7m(stm);
                      tmp = Unit_instance;
                    } else {
                      if (stm instanceof Return) {
                        this.c7m(stm);
                        tmp = Unit_instance;
                      } else {
                        noWhenBranchMatchedException();
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  u7l(stms) {
    var _iterator__ex2g4s = stms.y7n_1.b1();
    while (_iterator__ex2g4s.c1()) {
      var stm = _iterator__ex2g4s.d1();
      this.t7l(stm);
    }
  }
  v7l(stm) {
    this.d7m(stm.s7o_1);
    this.t7l(stm.t7o_1);
    this.t7l(stm.u7o_1);
  }
  w7l(stm) {
    this.g7m(stm.v7o_1);
    this.d7m(stm.w7o_1);
    this.t7l(stm.y7o_1);
  }
  x7l(stm) {
    this.d7m(stm.a7o_1);
    this.d7m(stm.z7n_1);
  }
  y7l(stm) {
  }
  z7l(stm) {
  }
  a7m(stm) {
  }
  b7m(stm) {
    this.t7l(stm.u7n_1);
  }
  c7m(stm) {
    var tmp0_safe_receiver = stm.b7o_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.graphics.shader.Visitor.visit.<anonymous>' call
      this.d7m(tmp0_safe_receiver);
    }
  }
  d7m(operand) {
    var tmp;
    if (operand instanceof Variable) {
      tmp = this.g7m(operand);
    } else {
      if (operand instanceof Unop) {
        tmp = this.k7m(operand);
      } else {
        if (operand instanceof Binop) {
          tmp = this.l7m(operand);
        } else {
          if (operand instanceof Ternary) {
            tmp = this.m7m(operand);
          } else {
            if (operand instanceof BoolLiteral) {
              tmp = this.s7m(operand);
            } else {
              if (operand instanceof IntLiteral) {
                tmp = this.q7m(operand);
              } else {
                if (operand instanceof FloatLiteral) {
                  tmp = this.r7m(operand);
                } else {
                  if (operand instanceof Vector) {
                    tmp = this.p7m(operand);
                  } else {
                    if (operand instanceof Swizzle) {
                      tmp = this.n7m(operand);
                    } else {
                      if (operand instanceof ArrayAccess) {
                        tmp = this.o7m(operand);
                      } else {
                        if (operand instanceof BaseFunc) {
                          tmp = this.e7m(operand);
                        } else {
                          invalidOp("Don't know how to visit operand " + toString(operand));
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  e7m(func) {
    var _iterator__ex2g4s = func.n7o().b1();
    while (_iterator__ex2g4s.c1()) {
      var op = _iterator__ex2g4s.d1();
      this.d7m(op);
    }
    var tmp;
    if (func instanceof Func) {
      tmp = this.f7m(func);
    } else {
      if (func instanceof CustomFunc) {
        tmp = this.q7l(func);
      } else {
        invalidOp("Don't know how to visit func " + toString(func));
      }
    }
    return tmp;
  }
  f7m(func) {
    return this.r7l_1;
  }
  q7l(func) {
    return this.r7l_1;
  }
  g7m(operand) {
    var tmp;
    if (operand instanceof Attribute) {
      tmp = this.c7l(operand);
    } else {
      if (operand instanceof Varying) {
        tmp = this.e7l(operand);
      } else {
        if (operand instanceof Sampler) {
          tmp = this.k7l(operand);
        } else {
          if (operand instanceof Uniform) {
            tmp = this.g7l(operand);
          } else {
            if (operand instanceof TypedUniform) {
              tmp = this.i7l(operand);
            } else {
              if (operand instanceof Output) {
                tmp = this.j7m(operand);
              } else {
                if (operand instanceof Temp) {
                  tmp = this.h7m(operand);
                } else {
                  if (operand instanceof Arg) {
                    tmp = this.i7m(operand);
                  } else {
                    noWhenBranchMatchedException();
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  h7m(temp) {
    return this.r7l_1;
  }
  i7m(arg) {
    return this.r7l_1;
  }
  c7l(attribute) {
    return this.r7l_1;
  }
  e7l(varying) {
    return this.r7l_1;
  }
  g7l(uniform) {
    return this.r7l_1;
  }
  k7l(sampler) {
    return this.r7l_1;
  }
  i7l(typedUniform) {
    return this.g7l(typedUniform.j6w_1);
  }
  j7m(output) {
    return this.r7l_1;
  }
  k7m(operand) {
    this.d7m(operand.h7o_1);
    return this.r7l_1;
  }
  l7m(operand) {
    this.d7m(operand.j7o_1);
    this.d7m(operand.l7o_1);
    return this.r7l_1;
  }
  m7m(operand) {
    this.d7m(operand.p7o_1);
    this.d7m(operand.q7o_1);
    this.d7m(operand.r7o_1);
    return this.r7l_1;
  }
  n7m(operand) {
    this.d7m(operand.g7p_1);
    return this.r7l_1;
  }
  o7m(operand) {
    this.d7m(operand.j7p_1);
    this.d7m(operand.k7p_1);
    return this.r7l_1;
  }
  p7m(operand) {
    var indexedObject = operand.e7o_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var op = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      this.d7m(op);
    }
    return this.r7l_1;
  }
  q7m(operand) {
    return this.r7l_1;
  }
  r7m(operand) {
    return this.r7l_1;
  }
  s7m(operand) {
    return this.r7l_1;
  }
}
class GlobalsProgramVisitor extends Visitor {
  constructor() {
    super(Unit_instance);
    this.u7k_1 = LinkedHashSet.i1();
    this.v7k_1 = LinkedHashSet.i1();
    this.w7k_1 = LinkedHashSet.i1();
    this.x7k_1 = LinkedHashSet.i1();
    this.y7k_1 = LinkedHashSet.i1();
    this.z7k_1 = LinkedHashSet.i1();
    this.a7l_1 = LinkedHashSet.i1();
  }
  b7l(attribute) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.u7k_1.h(attribute);
  }
  c7l(attribute) {
    this.b7l(attribute);
    return Unit_instance;
  }
  d7l(varying) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.v7k_1.h(varying);
  }
  e7l(varying) {
    this.d7l(varying);
    return Unit_instance;
  }
  f7l(uniform) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.w7k_1.h(uniform);
    var tmp0_safe_receiver = uniform.d7j_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.x7k_1.h(tmp0_safe_receiver);
    }
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.y7k_1;
    var element = uniform.d7j_1.i6w_1;
    this_0.h(element);
  }
  g7l(uniform) {
    this.f7l(uniform);
    return Unit_instance;
  }
  h7l(typedUniform) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.w7k_1;
    var element = typedUniform.j6w_1;
    this_0.h(element);
    // Inline function 'kotlin.collections.plusAssign' call
    this.x7k_1.h(typedUniform);
    // Inline function 'kotlin.collections.plusAssign' call
    var this_1 = this.y7k_1;
    var element_0 = typedUniform.i6w_1;
    this_1.h(element_0);
  }
  i7l(typedUniform) {
    this.h7l(typedUniform);
    return Unit_instance;
  }
  j7l(sampler) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.z7k_1.h(sampler);
  }
  k7l(sampler) {
    this.j7l(sampler);
    return Unit_instance;
  }
  l7l(func) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.a7l_1;
    var element = func.p7l().s3();
    this_0.h(element);
  }
  q7l(func) {
    this.l7l(func);
    return Unit_instance;
  }
}
class Companion_46 {
  constructor() {
    Companion_instance_55 = this;
    this.q7g_1 = Companion_getInstance_1().ey('GlslGenerator');
  }
  r7g() {
    return Companion_getInstance_62().r7g();
  }
  s7g() {
    return Companion_getInstance_62().s7g();
  }
}
class Result {
  constructor(generator, result, attributes, uniforms, varyings) {
    this.z7j_1 = generator;
    this.a7k_1 = result;
    this.b7k_1 = attributes;
    this.c7k_1 = uniforms;
    this.d7k_1 = varyings;
  }
  toString() {
    return 'Result(generator=' + toString(this.z7j_1) + ', result=' + this.a7k_1 + ', attributes=' + toString(this.b7k_1) + ', uniforms=' + toString(this.c7k_1) + ', varyings=' + toString(this.d7k_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.z7j_1);
    result = imul(result, 31) + getStringHashCode(this.a7k_1) | 0;
    result = imul(result, 31) + hashCode(this.b7k_1) | 0;
    result = imul(result, 31) + hashCode(this.c7k_1) | 0;
    result = imul(result, 31) + hashCode(this.d7k_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Result))
      return false;
    var tmp0_other_with_cast = other instanceof Result ? other : THROW_CCE();
    if (!equals(this.z7j_1, tmp0_other_with_cast.z7j_1))
      return false;
    if (!(this.a7k_1 === tmp0_other_with_cast.a7k_1))
      return false;
    if (!equals(this.b7k_1, tmp0_other_with_cast.b7k_1))
      return false;
    if (!equals(this.c7k_1, tmp0_other_with_cast.c7k_1))
      return false;
    if (!equals(this.d7k_1, tmp0_other_with_cast.d7k_1))
      return false;
    return true;
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.y7m_1 = function_0;
  }
  aj(a, b) {
    return this.y7m_1(a, b);
  }
  compare(a, b) {
    return this.aj(a, b);
  }
  o4() {
    return this.y7m_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.o4(), other.o4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.o4());
  }
}
class BaseGlslGenerator {}
function precToString(prec) {
  var tmp;
  if (!_GLVariant___get_isES__impl__yezzg8(this.r7n().n7a_1)) {
    tmp = '';
  } else {
    var tmp_0;
    switch (prec.r3_1) {
      case 0:
        tmp_0 = '';
        break;
      case 1:
        tmp_0 = 'lowp ';
        break;
      case 2:
        tmp_0 = 'mediump ';
        break;
      case 3:
        tmp_0 = 'highp ';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function typeToString(type) {
  var tmp;
  switch (type.r3_1) {
    case 0:
      tmp = 'void';
      break;
    case 21:
      tmp = 'vec4';
      break;
    case 1:
      tmp = 'mat2';
      break;
    case 2:
      tmp = 'mat3';
      break;
    case 3:
      tmp = 'mat4';
      break;
    case 4:
      tmp = 'sampler1D';
      break;
    case 5:
      tmp = 'sampler2D';
      break;
    case 6:
      tmp = 'sampler3D';
      break;
    case 7:
      tmp = 'samplerCube';
      break;
    default:
      var tmp_0;
      switch (type.b7c_1.r3_1) {
        case 0:
          var tmp_1;
          switch (type.c7c_1) {
            case 1:
              tmp_1 = 'bool';
              break;
            case 2:
              tmp_1 = 'bvec2';
              break;
            case 3:
              tmp_1 = 'bvec3';
              break;
            case 4:
              tmp_1 = 'bvec4';
              break;
            default:
              errorType(this, type);
              break;
          }

          tmp_0 = tmp_1;
          break;
        case 1:
        case 2:
        case 3:
        case 4:
        case 6:
          var tmp_2;
          switch (type.c7c_1) {
            case 1:
              tmp_2 = 'float';
              break;
            case 2:
              tmp_2 = 'vec2';
              break;
            case 3:
              tmp_2 = 'vec3';
              break;
            case 4:
              tmp_2 = 'vec4';
              break;
            default:
              errorType(this, type);
              break;
          }

          tmp_0 = tmp_2;
          break;
        case 5:
          var tmp_3;
          switch (type.c7c_1) {
            case 1:
              tmp_3 = 'int';
              break;
            case 2:
              tmp_3 = 'ivec2';
              break;
            case 3:
              tmp_3 = 'ivec3';
              break;
            case 4:
              tmp_3 = 'ivec4';
              break;
            default:
              errorType(this, type);
              break;
          }

          tmp_0 = tmp_3;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }

      tmp = tmp_0;
      break;
  }
  return tmp;
}
function get_arrayDecl(_this__u8e3s4) {
  return !(_this__u8e3s4.u7b_1 === 1) ? '[' + _this__u8e3s4.u7b_1 + ']' : '';
}
function get_IN() {
  return this.r7n().a7n();
}
function get_OUT() {
  return this.r7n().f7n();
}
function get_UNIFORM() {
  return this.r7n().e7n();
}
class GlslGenerator {
  constructor(kind, config) {
    Companion_getInstance_61();
    this.q7k_1 = kind;
    this.r7k_1 = config;
  }
  r7n() {
    return this.r7k_1;
  }
  s7k(shader) {
    return this.s7n(shader.f7k_1, shader.g7k_1);
  }
  s7n(root, funcs) {
    var types = new GlobalsProgramVisitor();
    if (this.q7k_1.equals(ShaderType_FRAGMENT_getInstance()) && this.r7k_1.z7m()) {
      types.v7k_1.h(Varying.e74(this.r7k_1.g7n(), VarType_Float4_getInstance()));
    }
    var tmp = VarType_TVOID_getInstance();
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    var mainFunc = new FuncDecl('main', tmp, tmp$ret$0, root);
    types.s7l(mainFunc);
    // Inline function 'kotlin.collections.distinctBy' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.j1();
    var tmp0_iterator = funcs.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>' call
      if (types.a7l_1.x2(element.l7n_1.s3())) {
        destination.h(element);
      }
    }
    var this_0 = reversed(destination);
    var set = HashSet.pa();
    var list = ArrayList.j1();
    var tmp0_iterator_0 = this_0.b1();
    while (tmp0_iterator_0.c1()) {
      var e = tmp0_iterator_0.d1();
      // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>' call
      var key = e.l7n_1.s3();
      if (set.h(key)) {
        list.h(e);
      }
    }
    var customFuncs = list;
    var _iterator__ex2g4s = funcs.b1();
    while (_iterator__ex2g4s.c1()) {
      var func = _iterator__ex2g4s.d1();
      types.s7l(mainFunc);
    }
    var allFuncs = plus(customFuncs, listOf(mainFunc));
    // Inline function 'kotlin.also' call
    var tmp_0 = Companion_getInstance_11();
    var this_1 = tmp_0.a38(GlslGenerator$generateResult$lambda(this, types, allFuncs)).toString();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>' call
    if (Companion_getInstance_62().s7g()) {
      // Inline function 'korlibs.logger.Logger.info' call
      var this_2 = Companion_getInstance_61().q7g_1;
      var level = Level_INFO_getInstance();
      var tmp_1;
      if (this_2.x2x(level)) {
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var tmp$ret$6 = 'GlSlGenerator.version: ' + this.r7k_1.p7a_1;
        this_2.y2x(level, tmp$ret$6);
        tmp_1 = Unit_instance;
      }
      // Inline function 'korlibs.logger.Logger.debug' call
      var this_3 = Companion_getInstance_61().q7g_1;
      var level_0 = Level_DEBUG_getInstance();
      var tmp_2;
      if (this_3.x2x(level_0)) {
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var tmp$ret$8 = 'GlSlGenerator:\n' + this_1;
        this_3.y2x(level_0, tmp$ret$8);
        tmp_2 = Unit_instance;
      }
    }
    var result = this_1;
    var tmp_3;
    if (root instanceof Raw) {
      tmp_3 = root.v7n(Companion_getInstance_62().u7m_1);
    } else {
      tmp_3 = result;
    }
    return new Result(this, tmp_3, toList(types.u7k_1), toList(types.w7k_1), toList(types.v7k_1));
  }
}
class Companion_47 {
  constructor() {
    Companion_instance_56 = this;
    this.t7m_1 = new GlslConfig(Companion_instance_54.x7j(), new Immutable(VOID, VOID, VOID, true));
    this.u7m_1 = 'GLSL';
    this.v7m_1 = 100;
    this.w7m_1 = 'fragColor';
    this.x7m_1 = 'gl_FragColor';
  }
  r7g() {
    var tmp0_safe_receiver = Companion_instance_1.hi('FORCE_GLSL_VERSION');
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : replace(tmp0_safe_receiver, '.', '');
    return tmp1_safe_receiver == null ? null : toIntOrNull(tmp1_safe_receiver);
  }
  s7g() {
    return Companion_instance_1.hi('DEBUG_GLSL') === 'true';
  }
}
class GlslConfig {
  constructor(variant, features, glslVersion, compatibility) {
    Companion_getInstance_62();
    glslVersion = glslVersion === VOID ? -1 : glslVersion;
    compatibility = compatibility === VOID ? true : compatibility;
    this.n7a_1 = variant;
    this.o7a_1 = features;
    this.p7a_1 = glslVersion;
    this.q7a_1 = compatibility;
  }
  w7n(name) {
    if (this.q7a_1)
      return name;
    return name === 'texture2D' ? 'texture' : name;
  }
  z7m() {
    if (_GLVariant___get_isES__impl__yezzg8(this.n7a_1))
      return this.p7a_1 >= 300;
    return !this.q7a_1;
  }
  r7a() {
    return get_ENABLE_UNIFORM_BLOCKS() && this.z7m() && this.o7a_1.g6o();
  }
  a7n() {
    return this.z7m() ? 'in' : 'attribute';
  }
  f7n() {
    return this.z7m() ? 'out' : 'varying';
  }
  e7n() {
    return 'uniform';
  }
  g7n() {
    return this.z7m() ? Companion_getInstance_62().w7m_1 : Companion_getInstance_62().x7m_1;
  }
  x7n(variant, features, glslVersion, compatibility) {
    return new GlslConfig(variant, features, glslVersion, compatibility);
  }
  t7g(variant, features, glslVersion, compatibility, $super) {
    variant = variant === VOID ? this.n7a_1 : variant;
    features = features === VOID ? this.o7a_1 : features;
    glslVersion = glslVersion === VOID ? this.p7a_1 : glslVersion;
    compatibility = compatibility === VOID ? this.q7a_1 : compatibility;
    return $super === VOID ? this.x7n(variant, features, glslVersion, compatibility) : $super.x7n.call(this, new GLVariant(variant), features, glslVersion, compatibility);
  }
  toString() {
    return 'GlslConfig(variant=' + GLVariant__toString_impl_o5yi3l(this.n7a_1) + ', features=' + toString(this.o7a_1) + ', glslVersion=' + this.p7a_1 + ', compatibility=' + this.q7a_1 + ')';
  }
  hashCode() {
    var result = GLVariant__hashCode_impl_2eslaq(this.n7a_1);
    result = imul(result, 31) + hashCode(this.o7a_1) | 0;
    result = imul(result, 31) + this.p7a_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.q7a_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlslConfig))
      return false;
    var tmp0_other_with_cast = other instanceof GlslConfig ? other : THROW_CCE();
    if (!(this.n7a_1 === tmp0_other_with_cast.n7a_1))
      return false;
    if (!equals(this.o7a_1, tmp0_other_with_cast.o7a_1))
      return false;
    if (!(this.p7a_1 === tmp0_other_with_cast.p7a_1))
      return false;
    if (!(this.q7a_1 === tmp0_other_with_cast.q7a_1))
      return false;
    return true;
  }
}
class GlslBodyGenerator extends Visitor {
  constructor(kind, config) {
    super('');
    this.n7n_1 = kind;
    this.o7n_1 = config;
    this.p7n_1 = LinkedHashSet.i1();
    this.q7n_1 = new Indenter();
  }
  r7n() {
    return this.o7n_1;
  }
  u7l(stms) {
    var _iterator__ex2g4s = stms.y7n_1.b1();
    while (_iterator__ex2g4s.c1()) {
      var stm = _iterator__ex2g4s.d1();
      this.t7l(stm);
    }
  }
  x7l(stm) {
    this.q7n_1.oy(this.d7m(stm.z7n_1) + ' = ' + this.d7m(stm.a7o_1) + ';');
  }
  y7l(stm) {
    this.q7n_1.oy('discard;');
  }
  z7l(stm) {
    this.q7n_1.oy('break;');
  }
  a7m(stm) {
    this.q7n_1.oy('continue;');
  }
  c7m(stm) {
    var result = stm.b7o_1;
    if (!(result == null)) {
      this.q7n_1.oy('return ' + this.d7m(result) + ';');
    } else {
      this.q7n_1.oy('return;');
    }
  }
  p7m(operand) {
    var tmp = this.c7n(operand.d7o_1) + '(';
    return tmp + joinToString_0(operand.e7o_1, ', ', VOID, VOID, VOID, VOID, GlslBodyGenerator$visit$lambda(this)) + ')';
  }
  k7m(operand) {
    return '(' + operand.g7o_1 + '(' + this.d7m(operand.h7o_1) + ')' + ')';
  }
  l7m(operand) {
    return '(' + this.d7m(operand.j7o_1) + ' ' + operand.k7o_1 + ' ' + this.d7m(operand.l7o_1) + ')';
  }
  e7m(func) {
    var tmp = this.o7n_1.w7n(func.s3()) + '(';
    var tmp_0 = func.n7o();
    return tmp + joinToString(tmp_0, ', ', VOID, VOID, VOID, VOID, GlslBodyGenerator$visit$lambda_0(this)) + ')';
  }
  m7m(ternary) {
    return '((' + this.d7m(ternary.p7o_1) + ') ? (' + this.d7m(ternary.q7o_1) + ') : (' + this.d7m(ternary.r7o_1) + '))';
  }
  v7l(stm) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.q7n_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>' call
    // Inline function 'korlibs.io.util.Indenter.line' call
    var str = 'if (' + this.d7m(stm.s7o_1) + ')';
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(str) === 0) {
      tmp = '{';
    } else {
      tmp = str + ' {';
    }
    this_0.oy(tmp);
    // Inline function 'korlibs.io.util.Indenter.indent' call
    this_0.py();
    try {
      // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>.<anonymous>' call
      this.t7l(stm.t7o_1);
    }finally {
      this_0.qy();
    }
    this_0.oy('}');
    if (!(stm.u7o_1 == null)) {
      // Inline function 'korlibs.io.util.Indenter.line' call
      var tmp_0;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength('else') === 0) {
        tmp_0 = '{';
      } else {
        tmp_0 = 'else' + ' {';
      }
      this_0.oy(tmp_0);
      // Inline function 'korlibs.io.util.Indenter.indent' call
      this_0.py();
      try {
        // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>.<anonymous>' call
        this.t7l(ensureNotNull(stm.u7o_1));
      }finally {
        this_0.qy();
      }
      this_0.oy('}');
    }
  }
  w7l(stm) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.q7n_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>' call
    var varType = this.c7n(stm.v7o_1.c2e());
    var loopVar = this.g7m(stm.v7o_1);
    var min = this.d7m(stm.w7o_1);
    var maxExclusive = this.d7m(stm.x7o_1);
    // Inline function 'korlibs.io.util.Indenter.line' call
    var str = 'for (' + varType + ' ' + loopVar + ' = (' + min + '); ' + loopVar + ' < (' + maxExclusive + '); ' + loopVar + '++)';
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(str) === 0) {
      tmp = '{';
    } else {
      tmp = str + ' {';
    }
    this_0.oy(tmp);
    // Inline function 'korlibs.io.util.Indenter.indent' call
    this_0.py();
    try {
      // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>.<anonymous>' call
      this.t7l(stm.y7o_1);
    }finally {
      this_0.qy();
    }
    this_0.oy('}');
  }
  b7m(stm) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>' call
    this.q7n_1.oy(stm.v7n(Companion_getInstance_62().u7m_1));
  }
  g7m(operand) {
    super.g7m(operand);
    var tmp;
    if (operand instanceof Output) {
      var tmp_0;
      switch (this.n7n_1.r3_1) {
        case 0:
          tmp_0 = 'gl_Position';
          break;
        case 1:
          tmp_0 = this.o7n_1.g7n();
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      tmp = tmp_0;
    } else {
      tmp = operand.e7a_1;
    }
    return tmp;
  }
  h7m(temp) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.p7n_1.h(temp);
    return super.h7m(temp);
  }
  j7m(output) {
    return super.j7m(output);
  }
  q7m(operand) {
    return '' + operand.a7p_1;
  }
  r7m(operand) {
    var str = '' + operand.c7p_1;
    return contains(str, _Char___init__impl__6a9atx(46)) ? str : str + '.0';
  }
  s7m(operand) {
    return '' + operand.e7p_1;
  }
  n7m(operand) {
    return this.d7m(operand.g7p_1) + '.' + operand.h7p_1;
  }
  o7m(operand) {
    return this.d7m(operand.j7p_1) + '[' + this.d7m(operand.k7p_1) + ']';
  }
}
class ProgramLayout {
  static l7p(items, layoutSize, fixedLocation) {
    fixedLocation = fixedLocation === VOID ? -1 : fixedLocation;
    var $this = createThis(this);
    $this.v6w_1 = items;
    $this.w6w_1 = layoutSize;
    $this.x6w_1 = fixedLocation;
    $this.y6w_1 = 0;
    var tmp = $this;
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_0 = $this.v6w_1;
    // Inline function 'kotlin.also' call
    var this_1 = IntArrayList.m2o();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
    var _iterator__ex2g4s = this_0.b1();
    while (_iterator__ex2g4s.c1()) {
      var v = _iterator__ex2g4s.d1();
      // Inline function 'korlibs.graphics.shader.ProgramLayout.alignments.<anonymous>' call
      var a = v.c2e().b7c_1.o7p_1;
      var tmp$ret$0 = a <= 1 ? 1 : a;
      this_1.s2o(tmp$ret$0);
    }
    tmp.z6w_1 = this_1;
    var tmp_0 = $this;
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_2 = $this.v6w_1;
    // Inline function 'kotlin.also' call
    var this_3 = IntArrayList.m2o();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
    var _iterator__ex2g4s_0 = this_2.b1();
    while (_iterator__ex2g4s_0.c1()) {
      var v_0 = _iterator__ex2g4s_0.d1();
      // Inline function 'korlibs.graphics.shader.ProgramLayout._positions.<anonymous>' call
      $this.y6w_1 = !(v_0.p7i_1 == null) ? v_0.p7i_1 : nextAlignedTo($this.y6w_1, v_0.c2e().b7c_1.o7p_1);
      var out = $this.y6w_1;
      $this.y6w_1 = $this.y6w_1 + v_0.c2e().e7c_1 | 0;
      this_3.s2o(out);
    }
    tmp_0.a6x_1 = this_3;
    var tmp_1 = $this;
    var tmp0_elvis_lhs = maxOrNull($this.z6w_1);
    tmp_1.b6x_1 = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
    var tmp_2 = $this;
    var tmp0_elvis_lhs_0 = $this.w6w_1;
    tmp_2.c6x_1 = tmp0_elvis_lhs_0 == null ? nextAlignedTo($this.y6w_1, $this.b6x_1) : tmp0_elvis_lhs_0;
    return $this;
  }
  static d6x(variables, layoutSize) {
    layoutSize = layoutSize === VOID ? null : layoutSize;
    return this.l7p(toFastList_0(variables), layoutSize);
  }
  p7p() {
    return joinToString(this.v6w_1, ', ', VOID, VOID, VOID, VOID, ProgramLayout$names$lambda);
  }
  toString() {
    return get_portableSimpleName(getKClassFromExpression(this)) + '[' + this.p7p() + ', fixedLocation=' + this.x6w_1 + ']';
  }
  b1() {
    return this.v6w_1.b1();
  }
}
class Attribute extends VariableWithOffset {
  static q7p(name, type, normalized, offset, active, precision, divisor, fixedLocation) {
    offset = offset === VOID ? null : offset;
    active = active === VOID ? true : active;
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    divisor = divisor === VOID ? 0 : divisor;
    var $this = this.q7i(name, type, 1, precision, offset);
    $this.o73_1 = normalized;
    $this.p73_1 = active;
    $this.q73_1 = divisor;
    $this.r73_1 = fixedLocation;
    return $this;
  }
  static s73(name, type, normalized, precision, fixedLocation) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.q7p(name, type, normalized, null, true, precision, VOID, fixedLocation);
  }
  toString() {
    return 'Attribute(' + this.e7a_1 + ')';
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp_2;
    var tmp_3;
    var tmp_4;
    var tmp_5;
    if (other instanceof Attribute) {
      tmp_5 = this.h7a_1 === other.h7a_1;
    } else {
      tmp_5 = false;
    }
    if (tmp_5) {
      tmp_4 = this.c2e().equals(other.c2e());
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp_3 = this.u7b_1 === other.u7b_1;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = this.e7a_1 === other.e7a_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.o73_1 === (other instanceof Attribute ? other : THROW_CCE()).o73_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.p7i_1 == other.p7i_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.p73_1 === other.p73_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    var out = (this.h7a_1 + imul(this.c2e().hashCode(), 7) | 0) + imul(getStringHashCode(this.e7a_1), 11) | 0;
    out = imul(out, 7);
    out = out + getBooleanHashCode(this.o73_1) | 0;
    out = imul(out, 7);
    var tmp = out;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.p7i_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    out = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    out = imul(out, 7);
    out = out + getBooleanHashCode(this.p73_1) | 0;
    return out;
  }
}
class Stm {}
class Stms extends Stm {
  constructor(stms) {
    super();
    this.y7n_1 = stms;
  }
  toString() {
    return 'Stms(stms=' + toString(this.y7n_1) + ')';
  }
  hashCode() {
    return hashCode(this.y7n_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Stms))
      return false;
    var tmp0_other_with_cast = other instanceof Stms ? other : THROW_CCE();
    if (!equals(this.y7n_1, tmp0_other_with_cast.y7n_1))
      return false;
    return true;
  }
}
class Set extends Stm {
  constructor(to, from) {
    super();
    this.z7n_1 = to;
    this.a7o_1 = from;
  }
  toString() {
    return 'Set(to=' + toString(this.z7n_1) + ', from=' + toString(this.a7o_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.z7n_1);
    result = imul(result, 31) + hashCode(this.a7o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Set))
      return false;
    var tmp0_other_with_cast = other instanceof Set ? other : THROW_CCE();
    if (!equals(this.z7n_1, tmp0_other_with_cast.z7n_1))
      return false;
    if (!equals(this.a7o_1, tmp0_other_with_cast.a7o_1))
      return false;
    return true;
  }
}
class Return extends Stm {
  constructor(result) {
    super();
    this.b7o_1 = result;
  }
  toString() {
    return 'Return(result=' + toString_1(this.b7o_1) + ')';
  }
  hashCode() {
    return this.b7o_1 == null ? 0 : hashCode(this.b7o_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Return))
      return false;
    var tmp0_other_with_cast = other instanceof Return ? other : THROW_CCE();
    if (!equals(this.b7o_1, tmp0_other_with_cast.b7o_1))
      return false;
    return true;
  }
}
class Break extends Stm {}
class Continue extends Stm {}
class Discard extends Stm {
  constructor() {
    Discard_instance = null;
    super();
    Discard_instance = this;
  }
  toString() {
    return 'Discard';
  }
}
class If extends Stm {
  constructor(cond, tbody, fbody) {
    fbody = fbody === VOID ? null : fbody;
    super();
    this.s7o_1 = cond;
    this.t7o_1 = tbody;
    this.u7o_1 = fbody;
  }
  toString() {
    return 'If(cond=' + toString(this.s7o_1) + ', tbody=' + toString(this.t7o_1) + ', fbody=' + toString_1(this.u7o_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.s7o_1);
    result = imul(result, 31) + hashCode(this.t7o_1) | 0;
    result = imul(result, 31) + (this.u7o_1 == null ? 0 : hashCode(this.u7o_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof If))
      return false;
    var tmp0_other_with_cast = other instanceof If ? other : THROW_CCE();
    if (!equals(this.s7o_1, tmp0_other_with_cast.s7o_1))
      return false;
    if (!equals(this.t7o_1, tmp0_other_with_cast.t7o_1))
      return false;
    if (!equals(this.u7o_1, tmp0_other_with_cast.u7o_1))
      return false;
    return true;
  }
}
class ForSimple extends Stm {}
class Raw extends Stm {
  r7p(name) {
    return this.t7n_1.f3(name);
  }
  s7p(name, default_0) {
    var tmp0_elvis_lhs = this.r7p(name);
    return tmp0_elvis_lhs == null ? default_0 : tmp0_elvis_lhs;
  }
  v7n(name, default_0, $super) {
    default_0 = default_0 === VOID ? '' : default_0;
    return $super === VOID ? this.s7p(name, default_0) : $super.s7p.call(this, name, default_0);
  }
}
class Program$ExpressionBuilder$Companion$INSTANCE$1 {}
class Companion_48 {
  constructor() {
    Companion_instance_57 = this;
    var tmp = this;
    tmp.t7p_1 = new Program$ExpressionBuilder$Companion$INSTANCE$1();
  }
}
class FuncBuilder extends Builder {
  static c7q(parent) {
    var $this = this.d7q(parent);
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.a7q_1 = ArrayList.j1();
    return $this;
  }
  b7q(name, type) {
    // Inline function 'kotlin.also' call
    var this_0 = Arg.p7q(name, type);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.FuncBuilder.ARG.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    this.a7q_1.h(this_0);
    return this_0;
  }
}
class FuncDeclGetter {
  constructor(decl) {
    this.d7r_1 = decl;
  }
  mo(thisRef, property) {
    var tmp = this.d7r_1;
    return isInterface(tmp, FuncRef) ? tmp : THROW_CCE();
  }
}
class FuncProvider {
  constructor(rettype, varTypes, builder, block) {
    this.u7p_1 = rettype;
    this.v7p_1 = varTypes;
    this.w7p_1 = builder;
    this.x7p_1 = block;
  }
  b73(thisRef, property) {
    var tmp = property.callableName;
    var tmp_0 = this.w7p_1.t75(tmp, this.u7p_1, Program$Builder$FuncProvider$provideDelegate$lambda(this));
    return new FuncDeclGetter(tmp_0 instanceof FuncDecl ? tmp_0 : THROW_CCE());
  }
}
class Program$Builder$_funcs$1 extends Visitor {
  constructor($funcs, $box) {
    if ($box === VOID)
      $box = {};
    $box.f7r_1 = $funcs;
    super(Unit_instance, $box);
  }
  l7l(func) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.f7r_1;
    var key = func.s3();
    var tmp = func.p7l();
    var value = tmp instanceof FuncDecl ? tmp : THROW_CCE();
    this_0.h3(key, value);
  }
  q7l(func) {
    this.l7l(func);
    return Unit_instance;
  }
}
class Ternary extends Operand {
  static h7r(cond, otrue, ofalse) {
    var $this = this.i7r(otrue.c2e());
    $this.p7o_1 = cond;
    $this.q7o_1 = otrue;
    $this.r7o_1 = ofalse;
    return $this;
  }
  toString() {
    return 'Ternary(cond=' + toString(this.p7o_1) + ', otrue=' + toString(this.q7o_1) + ', ofalse=' + toString(this.r7o_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.p7o_1);
    result = imul(result, 31) + hashCode(this.q7o_1) | 0;
    result = imul(result, 31) + hashCode(this.r7o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Ternary))
      return false;
    var tmp0_other_with_cast = other instanceof Ternary ? other : THROW_CCE();
    if (!equals(this.p7o_1, tmp0_other_with_cast.p7o_1))
      return false;
    if (!equals(this.q7o_1, tmp0_other_with_cast.q7o_1))
      return false;
    if (!equals(this.r7o_1, tmp0_other_with_cast.r7o_1))
      return false;
    return true;
  }
}
class Unop extends Operand {
  static j7r(op, right) {
    var $this = this.i7r(right.c2e());
    $this.g7o_1 = op;
    $this.h7o_1 = right;
    return $this;
  }
  toString() {
    return 'Unop(op=' + this.g7o_1 + ', right=' + toString(this.h7o_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.g7o_1);
    result = imul(result, 31) + hashCode(this.h7o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Unop))
      return false;
    var tmp0_other_with_cast = other instanceof Unop ? other : THROW_CCE();
    if (!(this.g7o_1 === tmp0_other_with_cast.g7o_1))
      return false;
    if (!equals(this.h7o_1, tmp0_other_with_cast.h7o_1))
      return false;
    return true;
  }
}
class Binop extends Operand {
  static k7r(left, op, right) {
    var $this = this.i7r(left.c2e());
    $this.j7o_1 = left;
    $this.k7o_1 = op;
    $this.l7o_1 = right;
    return $this;
  }
  toString() {
    return 'Binop(left=' + toString(this.j7o_1) + ', op=' + this.k7o_1 + ', right=' + toString(this.l7o_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.j7o_1);
    result = imul(result, 31) + getStringHashCode(this.k7o_1) | 0;
    result = imul(result, 31) + hashCode(this.l7o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Binop))
      return false;
    var tmp0_other_with_cast = other instanceof Binop ? other : THROW_CCE();
    if (!equals(this.j7o_1, tmp0_other_with_cast.j7o_1))
      return false;
    if (!(this.k7o_1 === tmp0_other_with_cast.k7o_1))
      return false;
    if (!equals(this.l7o_1, tmp0_other_with_cast.l7o_1))
      return false;
    return true;
  }
}
class IntLiteral extends Operand {}
class FloatLiteral extends Operand {
  static l7r(value) {
    var $this = this.i7r(VarType_Float1_getInstance());
    $this.c7p_1 = value;
    return $this;
  }
  toString() {
    return 'FloatLiteral(value=' + this.c7p_1 + ')';
  }
  hashCode() {
    return getNumberHashCode(this.c7p_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FloatLiteral))
      return false;
    var tmp0_other_with_cast = other instanceof FloatLiteral ? other : THROW_CCE();
    if (!equals(this.c7p_1, tmp0_other_with_cast.c7p_1))
      return false;
    return true;
  }
}
class BoolLiteral extends Operand {}
class Vector extends Operand {
  static m7r(type, ops) {
    var $this = this.i7r(type);
    $this.d7o_1 = type;
    $this.e7o_1 = ops;
    return $this;
  }
  c2e() {
    return this.d7o_1;
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof Vector) {
      tmp_0 = this.d7o_1.equals(other.d7o_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(this.e7o_1, other.e7o_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return imul(this.d7o_1.hashCode(), 7) + contentHashCode(this.e7o_1) | 0;
  }
  toString() {
    return 'Vector(type=' + this.d7o_1.toString() + ', ops=' + toString(this.e7o_1) + ')';
  }
}
class Swizzle extends Operand {
  static n7r(left, swizzle) {
    var $this = this.i7r(left.c2e().o7r(swizzle.length));
    $this.g7p_1 = left;
    $this.h7p_1 = swizzle;
    return $this;
  }
  toString() {
    return 'Swizzle(left=' + toString(this.g7p_1) + ', swizzle=' + this.h7p_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.g7p_1);
    result = imul(result, 31) + getStringHashCode(this.h7p_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Swizzle))
      return false;
    var tmp0_other_with_cast = other instanceof Swizzle ? other : THROW_CCE();
    if (!equals(this.g7p_1, tmp0_other_with_cast.g7p_1))
      return false;
    if (!(this.h7p_1 === tmp0_other_with_cast.h7p_1))
      return false;
    return true;
  }
}
class ArrayAccess extends Operand {}
class BaseFunc extends Operand {
  static p7r(type) {
    return this.i7r(type);
  }
}
class Func extends BaseFunc {
  static u7r(name, ops, type) {
    type = type === VOID ? VarType_Float1_getInstance() : type;
    var $this = this.p7r(type);
    $this.r7r_1 = name;
    $this.s7r_1 = ops;
    $this.t7r_1 = type;
    return $this;
  }
  s3() {
    return this.r7r_1;
  }
  n7o() {
    return this.s7r_1;
  }
  c2e() {
    return this.t7r_1;
  }
  static v7r(name, ops, type) {
    type = type === VOID ? VarType_Float1_getInstance() : type;
    return this.u7r(name, toList_0(ops), type);
  }
  toString() {
    return 'Func(name=' + this.r7r_1 + ', ops=' + toString(this.s7r_1) + ', type=' + this.t7r_1.toString() + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.r7r_1);
    result = imul(result, 31) + hashCode(this.s7r_1) | 0;
    result = imul(result, 31) + this.t7r_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Func))
      return false;
    var tmp0_other_with_cast = other instanceof Func ? other : THROW_CCE();
    if (!(this.r7r_1 === tmp0_other_with_cast.r7r_1))
      return false;
    if (!equals(this.s7r_1, tmp0_other_with_cast.s7r_1))
      return false;
    if (!this.t7r_1.equals(tmp0_other_with_cast.t7r_1))
      return false;
    return true;
  }
}
class CustomFunc extends BaseFunc {
  static w7r(ref, ops) {
    var $this = this.p7r(ref.x7r());
    $this.n7l_1 = ref;
    $this.o7l_1 = ops;
    return $this;
  }
  p7l() {
    return this.n7l_1;
  }
  n7o() {
    return this.o7l_1;
  }
  s3() {
    return this.p7l().s3();
  }
}
class FuncRef {}
class BuilderContext {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.y7r_1 = ArrayList.j1();
    this.z7r_1 = 3;
  }
}
class Program {
  constructor(vertex, fragment, name) {
    name = name === VOID ? 'program-' + vertex.h7k_1 + '-' + fragment.h7k_1 : name;
    this.k6v_1 = vertex;
    this.l6v_1 = fragment;
    this.m6v_1 = name;
    this.n6v_1 = plus_0(this.k6v_1.m7k_1, this.l6v_1.m7k_1);
    this.o6v_1 = plus_0(this.k6v_1.n7k_1, this.l6v_1.n7k_1);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.o6v_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.graphics.shader.Program.uniformBlocks.<anonymous>' call
      var tmp$ret$0 = item.i6w_1;
      destination.h(tmp$ret$0);
    }
    tmp.p6v_1 = distinct(destination);
    this.q6v_1 = plus_0(this.k6v_1.p7k_1, this.l6v_1.p7k_1);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.associate' call
    var this_1 = withIndex(this.n6v_1);
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination_0 = LinkedHashMap.pc(capacity);
    var tmp0_iterator_0 = this_1.b1();
    while (tmp0_iterator_0.c1()) {
      var element = tmp0_iterator_0.d1();
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'korlibs.graphics.shader.Program.uniformsToIndex.<anonymous>' call
      var pair = to(element.hl_1, new UniformInProgram(element.hl_1, element.gl_1));
      destination_0.h3(pair.ll_1, pair.ml_1);
    }
    tmp_0.r6v_1 = destination_0;
    this.s6v_1 = plus_0(this.k6v_1.o7k_1, this.l6v_1.o7k_1);
    this.t6v_1 = (imul(this.k6v_1.hashCode(), 11) + imul(this.l6v_1.hashCode(), 7) | 0) + getStringHashCode(this.m6v_1) | 0;
  }
  hashCode() {
    return this.t6v_1;
  }
  equals(other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      if (other instanceof Program) {
        tmp_2 = this.k6v_1.equals(other.k6v_1);
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = this.l6v_1.equals(other.l6v_1);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = this.m6v_1 === other.m6v_1;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  n6() {
  }
  toString() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.s6v_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.graphics.shader.Program.toString.<anonymous>' call
      var tmp$ret$0 = item.e7a_1;
      destination.h(tmp$ret$0);
    }
    var tmp = toString(destination);
    // Inline function 'kotlin.collections.map' call
    var this_1 = this.n6v_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator_0 = this_1.b1();
    while (tmp0_iterator_0.c1()) {
      var item_0 = tmp0_iterator_0.d1();
      // Inline function 'korlibs.graphics.shader.Program.toString.<anonymous>' call
      var tmp$ret$3 = item_0.e7a_1;
      destination_0.h(tmp$ret$3);
    }
    return 'Program(name=' + this.m6v_1 + ', attributes=' + tmp + ', uniforms=' + toString(destination_0) + ')';
  }
  d7s(vertex, fragment, name) {
    return new Program(vertex, fragment, name);
  }
  e7s(vertex, fragment, name, $super) {
    vertex = vertex === VOID ? this.k6v_1 : vertex;
    fragment = fragment === VOID ? this.l6v_1 : fragment;
    name = name === VOID ? this.m6v_1 : name;
    return $super === VOID ? this.d7s(vertex, fragment, name) : $super.d7s.call(this, vertex, fragment, name);
  }
}
class Shader {
  constructor(type, stm, functions, name) {
    name = name === VOID ? null : name;
    this.e7k_1 = type;
    this.f7k_1 = stm;
    this.g7k_1 = functions;
    this.h7k_1 = name;
    this.i7k_1 = hashCode(this.f7k_1);
    this.j7k_1 = hashCode(this.g7k_1);
    this.k7k_1 = (imul(this.e7k_1.hashCode(), 17) + this.i7k_1 | 0) + imul(this.j7k_1, 53) | 0;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new GlobalsProgramVisitor();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Shader.globals.<anonymous>' call
    this_0.t7l(this.f7k_1);
    tmp.l7k_1 = this_0;
    this.m7k_1 = this.l7k_1.w7k_1;
    this.n7k_1 = this.l7k_1.x7k_1;
    this.o7k_1 = this.l7k_1.u7k_1;
    this.p7k_1 = this.l7k_1.z7k_1;
  }
  equals(other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      var tmp_3;
      if (other instanceof Shader) {
        tmp_3 = this.e7k_1.equals(other.e7k_1);
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp_2 = this.k7k_1 === other.k7k_1;
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = equals(this.f7k_1, other.f7k_1);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = equals(this.g7k_1, other.g7k_1);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  hashCode() {
    return this.k7k_1;
  }
  toString() {
    return 'Shader(type=' + this.e7k_1.toString() + ', stm=' + toString(this.f7k_1) + ', functions=' + toString(this.g7k_1) + ', name=' + this.h7k_1 + ')';
  }
}
class Varying extends Variable {
  static f7s(name, type, arrayCount, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.g7s(name, type, arrayCount, precision);
  }
  static e74(name, type, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.f7s(name, type, 1, precision);
  }
  toString() {
    return 'Varying(' + this.e7a_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Varying) {
      tmp_2 = this.h7a_1 === other.h7a_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.c2e().equals(other.c2e());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.u7b_1 === other.u7b_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.e7a_1 === other.e7a_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.h7a_1 + imul(this.c2e().hashCode(), 7) | 0) + imul(getStringHashCode(this.e7a_1), 11) | 0;
  }
}
class Output extends Varying {
  static s7s() {
    Output_instance = null;
    var $this = this.e74('out', VarType_Float4_getInstance());
    Output_instance = $this;
    return $this;
  }
  toString() {
    return 'Output';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Output) {
      tmp_2 = this.h7a_1 === other.h7a_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.c2e().equals(other.c2e());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.u7b_1 === other.u7b_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.e7a_1 === other.e7a_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.h7a_1 + imul(this.c2e().hashCode(), 7) | 0) + imul(getStringHashCode(this.e7a_1), 11) | 0;
  }
}
class Provider {
  constructor(index, stype) {
    this.z72_1 = index;
    this.a73_1 = stype;
  }
  b73(thisRef, property) {
    return Sampler.t7s(property.callableName, this.z72_1, this.a73_1);
  }
}
class Sampler extends Variable {
  static t7s(name, index, stype) {
    var $this = this.x7s(name, stype.w7s_1);
    $this.y6r_1 = index;
    $this.z6r_1 = stype;
    return $this;
  }
  toString() {
    return 'Sampler(' + this.e7a_1 + ', ' + this.y6r_1 + ', ' + this.z6r_1.toString() + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Sampler) {
      tmp_2 = this.h7a_1 === other.h7a_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.c2e().equals(other.c2e());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.u7b_1 === other.u7b_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.e7a_1 === other.e7a_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.h7a_1 + imul(this.c2e().hashCode(), 7) | 0) + imul(getStringHashCode(this.e7a_1), 11) | 0;
  }
  mo(thisRef, property) {
    return this;
  }
}
class SamplerVarType extends Enum {
  constructor(name, ordinal, vtype) {
    super(name, ordinal);
    this.w7s_1 = vtype;
  }
}
class Uniform extends VariableWithOffset {
  static e7j(name, type, arrayCount, precision, offset, typedUniform) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    offset = offset === VOID ? null : offset;
    var $this = this.q7i(name, type, arrayCount, precision, offset);
    $this.d7j_1 = typedUniform;
    if (type.y7s()) {
      // Inline function 'kotlin.error' call
      var message = "Can't create uniform '" + name + "' with a sampler type '" + type.toString() + "', please use `Sampler` class instead";
      throw IllegalStateException.h5(toString(message));
    }
    return $this;
  }
  toString() {
    return 'Uniform(' + this.e7a_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Uniform) {
      tmp_2 = this.h7a_1 === other.h7a_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.c2e().equals(other.c2e());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.u7b_1 === other.u7b_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.e7a_1 === other.e7a_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.h7a_1 + imul(this.c2e().hashCode(), 7) | 0) + imul(getStringHashCode(this.e7a_1), 11) | 0;
  }
}
class Companion_49 {
  z7s(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_SByte1_getInstance();
        break;
      case 2:
        tmp = VarType_SByte2_getInstance();
        break;
      case 3:
        tmp = VarType_SByte3_getInstance();
        break;
      case 4:
        tmp = VarType_SByte4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  a7t(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_UByte1_getInstance();
        break;
      case 2:
        tmp = VarType_UByte2_getInstance();
        break;
      case 3:
        tmp = VarType_UByte3_getInstance();
        break;
      case 4:
        tmp = VarType_UByte4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  b7t(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_SShort1_getInstance();
        break;
      case 2:
        tmp = VarType_SShort2_getInstance();
        break;
      case 3:
        tmp = VarType_SShort3_getInstance();
        break;
      case 4:
        tmp = VarType_SShort4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  c7t(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_UShort1_getInstance();
        break;
      case 2:
        tmp = VarType_UShort2_getInstance();
        break;
      case 3:
        tmp = VarType_UShort3_getInstance();
        break;
      case 4:
        tmp = VarType_UShort4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  d7t(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_SInt1_getInstance();
        break;
      case 2:
        tmp = VarType_SInt2_getInstance();
        break;
      case 3:
        tmp = VarType_SInt3_getInstance();
        break;
      case 4:
        tmp = VarType_SInt4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  e7t(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_Float1_getInstance();
        break;
      case 2:
        tmp = VarType_Float2_getInstance();
        break;
      case 3:
        tmp = VarType_Float3_getInstance();
        break;
      case 4:
        tmp = VarType_Float4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
}
class VarType extends Enum {
  constructor(name, ordinal, kind, elementCount, isMatrix) {
    isMatrix = isMatrix === VOID ? false : isMatrix;
    super(name, ordinal);
    this.b7c_1 = kind;
    this.c7c_1 = elementCount;
    this.d7c_1 = isMatrix;
    this.e7c_1 = imul(this.b7c_1.o7p_1, this.c7c_1);
  }
  o7r(length) {
    var tmp;
    switch (this.b7c_1.r3_1) {
      case 1:
        tmp = Companion_instance_58.z7s(length);
        break;
      case 2:
        tmp = Companion_instance_58.a7t(length);
        break;
      case 3:
        tmp = Companion_instance_58.b7t(length);
        break;
      case 4:
        tmp = Companion_instance_58.c7t(length);
        break;
      case 5:
        tmp = Companion_instance_58.d7t(length);
        break;
      case 6:
        tmp = Companion_instance_58.e7t(length);
        break;
      default:
        throw NotImplementedError.be();
    }
    return tmp;
  }
  y7s() {
    return this.equals(VarType_Sampler1D_getInstance()) || this.equals(VarType_Sampler2D_getInstance()) || this.equals(VarType_Sampler3D_getInstance()) || this.equals(VarType_SamplerCube_getInstance());
  }
}
class Precision extends Enum {}
class Temp extends Variable {
  static a7s(id, type, arrayCount, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.g7s('temp' + id, type, arrayCount, precision);
  }
  static q74(id, type, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.a7s(id, type, 1, precision);
  }
  toString() {
    return 'Temp(' + this.e7a_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Temp) {
      tmp_2 = this.h7a_1 === other.h7a_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.c2e().equals(other.c2e());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.u7b_1 === other.u7b_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.e7a_1 === other.e7a_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.h7a_1 + imul(this.c2e().hashCode(), 7) | 0) + imul(getStringHashCode(this.e7a_1), 11) | 0;
  }
}
class FuncDecl {
  constructor(name, rettype, args, stm) {
    this.h7n_1 = name;
    this.i7n_1 = rettype;
    this.j7n_1 = args;
    this.k7n_1 = stm;
    this.l7n_1 = this;
  }
  s3() {
    return this.h7n_1;
  }
  x7r() {
    return this.i7n_1;
  }
  toString() {
    return 'FuncDecl(name=' + this.h7n_1 + ', rettype=' + this.i7n_1.toString() + ', args=' + toString(this.j7n_1) + ', stm=' + toString(this.k7n_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.h7n_1);
    result = imul(result, 31) + this.i7n_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.j7n_1) | 0;
    result = imul(result, 31) + hashCode(this.k7n_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FuncDecl))
      return false;
    var tmp0_other_with_cast = other instanceof FuncDecl ? other : THROW_CCE();
    if (!(this.h7n_1 === tmp0_other_with_cast.h7n_1))
      return false;
    if (!this.i7n_1.equals(tmp0_other_with_cast.i7n_1))
      return false;
    if (!equals(this.j7n_1, tmp0_other_with_cast.j7n_1))
      return false;
    if (!equals(this.k7n_1, tmp0_other_with_cast.k7n_1))
      return false;
    return true;
  }
}
class VarKind extends Enum {
  constructor(name, ordinal, bytesSize) {
    super(name, ordinal);
    this.o7p_1 = bytesSize;
  }
}
class UniformInProgram {
  constructor(uniform, index) {
    this.g7t_1 = uniform;
    this.h7t_1 = index;
  }
  toString() {
    return 'UniformInProgram(uniform=' + this.g7t_1.toString() + ', index=' + this.h7t_1 + ')';
  }
  hashCode() {
    var result = this.g7t_1.hashCode();
    result = imul(result, 31) + this.h7t_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UniformInProgram))
      return false;
    var tmp0_other_with_cast = other instanceof UniformInProgram ? other : THROW_CCE();
    if (!this.g7t_1.equals(tmp0_other_with_cast.g7t_1))
      return false;
    if (!(this.h7t_1 === tmp0_other_with_cast.h7t_1))
      return false;
    return true;
  }
}
class Arg extends Variable {
  static p7q(name, type, arrayCount, precision) {
    arrayCount = arrayCount === VOID ? 1 : arrayCount;
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.g7s(name, type, arrayCount, precision);
  }
  toString() {
    return 'Arg(' + this.e7a_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Arg) {
      tmp_2 = this.h7a_1 === other.h7a_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.c2e().equals(other.c2e());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.u7b_1 === other.u7b_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.e7a_1 === other.e7a_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.h7a_1 + imul(this.c2e().hashCode(), 7) | 0) + imul(getStringHashCode(this.e7a_1), 11) | 0;
  }
}
class ShaderType extends Enum {}
class sam$kotlinx_coroutines_DisposableHandle$0 {
  constructor(function_0) {
    this.i7t_1 = function_0;
  }
  m1a() {
    return this.i7t_1();
  }
  o4() {
    return this.i7t_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DisposableHandle) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.o4(), other.o4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.o4());
  }
}
class ContextInfo {
  constructor() {
    var tmp = this;
    tmp.j7t_1 = KmlGl$ContextInfo$current$lambda;
  }
  toString() {
    return 'current=' + toString_1(this.j7t_1());
  }
}
class Companion_50 {
  constructor() {
    this.k7t_1 = 33309;
    this.l7t_1 = 33084;
    this.m7t_1 = 33085;
    this.n7t_1 = 256;
    this.o7t_1 = 1024;
    this.p7t_1 = 16384;
    this.q7t_1 = 0;
    this.r7t_1 = 1;
    this.s7t_1 = 0;
    this.t7t_1 = 1;
    this.u7t_1 = 2;
    this.v7t_1 = 3;
    this.w7t_1 = 4;
    this.x7t_1 = 5;
    this.y7t_1 = 6;
    this.z7t_1 = 0;
    this.a7u_1 = 1;
    this.b7u_1 = 768;
    this.c7u_1 = 769;
    this.d7u_1 = 770;
    this.e7u_1 = 771;
    this.f7u_1 = 772;
    this.g7u_1 = 773;
    this.h7u_1 = 774;
    this.i7u_1 = 775;
    this.j7u_1 = 776;
    this.k7u_1 = 32774;
    this.l7u_1 = 32777;
    this.m7u_1 = 32777;
    this.n7u_1 = 34877;
    this.o7u_1 = 32778;
    this.p7u_1 = 32779;
    this.q7u_1 = 32968;
    this.r7u_1 = 32969;
    this.s7u_1 = 32970;
    this.t7u_1 = 32971;
    this.u7u_1 = 32769;
    this.v7u_1 = 32770;
    this.w7u_1 = 32771;
    this.x7u_1 = 32772;
    this.y7u_1 = 32773;
    this.z7u_1 = 34962;
    this.a7v_1 = 34963;
    this.b7v_1 = 34964;
    this.c7v_1 = 34965;
    this.d7v_1 = 35040;
    this.e7v_1 = 35044;
    this.f7v_1 = 35048;
    this.g7v_1 = 34660;
    this.h7v_1 = 34661;
    this.i7v_1 = 34342;
    this.j7v_1 = 1028;
    this.k7v_1 = 1029;
    this.l7v_1 = 1032;
    this.m7v_1 = 3553;
    this.n7v_1 = 32879;
    this.o7v_1 = 2884;
    this.p7v_1 = 3042;
    this.q7v_1 = 3024;
    this.r7v_1 = 2960;
    this.s7v_1 = 2929;
    this.t7v_1 = 3089;
    this.u7v_1 = 32823;
    this.v7v_1 = 32926;
    this.w7v_1 = 32928;
    this.x7v_1 = 0;
    this.y7v_1 = 1280;
    this.z7v_1 = 1281;
    this.a7w_1 = 1282;
    this.b7w_1 = 1285;
    this.c7w_1 = 2304;
    this.d7w_1 = 2305;
    this.e7w_1 = 2849;
    this.f7w_1 = 33901;
    this.g7w_1 = 33902;
    this.h7w_1 = 2885;
    this.i7w_1 = 2886;
    this.j7w_1 = 2928;
    this.k7w_1 = 2930;
    this.l7w_1 = 2931;
    this.m7w_1 = 2932;
    this.n7w_1 = 2961;
    this.o7w_1 = 2962;
    this.p7w_1 = 2964;
    this.q7w_1 = 2965;
    this.r7w_1 = 2966;
    this.s7w_1 = 2967;
    this.t7w_1 = 2963;
    this.u7w_1 = 2968;
    this.v7w_1 = 34816;
    this.w7w_1 = 34817;
    this.x7w_1 = 34818;
    this.y7w_1 = 34819;
    this.z7w_1 = 36003;
    this.a7x_1 = 36004;
    this.b7x_1 = 36005;
    this.c7x_1 = 2978;
    this.d7x_1 = 3088;
    this.e7x_1 = 3106;
    this.f7x_1 = 3107;
    this.g7x_1 = 3317;
    this.h7x_1 = 3333;
    this.i7x_1 = 3379;
    this.j7x_1 = 3386;
    this.k7x_1 = 3408;
    this.l7x_1 = 3410;
    this.m7x_1 = 3411;
    this.n7x_1 = 3412;
    this.o7x_1 = 3413;
    this.p7x_1 = 3414;
    this.q7x_1 = 3415;
    this.r7x_1 = 10752;
    this.s7x_1 = 32824;
    this.t7x_1 = 32873;
    this.u7x_1 = 32936;
    this.v7x_1 = 32937;
    this.w7x_1 = 32938;
    this.x7x_1 = 32939;
    this.y7x_1 = 34466;
    this.z7x_1 = 34467;
    this.a7y_1 = 4352;
    this.b7y_1 = 4353;
    this.c7y_1 = 4354;
    this.d7y_1 = 33170;
    this.e7y_1 = 5120;
    this.f7y_1 = 5121;
    this.g7y_1 = 5122;
    this.h7y_1 = 5123;
    this.i7y_1 = 5124;
    this.j7y_1 = 5125;
    this.k7y_1 = 5126;
    this.l7y_1 = 5132;
    this.m7y_1 = 6402;
    this.n7y_1 = 6406;
    this.o7y_1 = 6407;
    this.p7y_1 = 6408;
    this.q7y_1 = 6409;
    this.r7y_1 = 6410;
    this.s7y_1 = 32819;
    this.t7y_1 = 32820;
    this.u7y_1 = 33635;
    this.v7y_1 = 35632;
    this.w7y_1 = 35633;
    this.x7y_1 = 34921;
    this.y7y_1 = 36347;
    this.z7y_1 = 36348;
    this.a7z_1 = 35661;
    this.b7z_1 = 35660;
    this.c7z_1 = 34930;
    this.d7z_1 = 36349;
    this.e7z_1 = 35663;
    this.f7z_1 = 35712;
    this.g7z_1 = 35714;
    this.h7z_1 = 35715;
    this.i7z_1 = 35717;
    this.j7z_1 = 35718;
    this.k7z_1 = 35719;
    this.l7z_1 = 35721;
    this.m7z_1 = 35722;
    this.n7z_1 = 35724;
    this.o7z_1 = 35725;
    this.p7z_1 = 512;
    this.q7z_1 = 513;
    this.r7z_1 = 514;
    this.s7z_1 = 515;
    this.t7z_1 = 516;
    this.u7z_1 = 517;
    this.v7z_1 = 518;
    this.w7z_1 = 519;
    this.x7z_1 = 7680;
    this.y7z_1 = 7681;
    this.z7z_1 = 7682;
    this.a80_1 = 7683;
    this.b80_1 = 5386;
    this.c80_1 = 34055;
    this.d80_1 = 34056;
    this.e80_1 = 7936;
    this.f80_1 = 7937;
    this.g80_1 = 7938;
    this.h80_1 = 7939;
    this.i80_1 = 9728;
    this.j80_1 = 9729;
    this.k80_1 = 9984;
    this.l80_1 = 9985;
    this.m80_1 = 9986;
    this.n80_1 = 9987;
    this.o80_1 = 10240;
    this.p80_1 = 10241;
    this.q80_1 = 10242;
    this.r80_1 = 10243;
    this.s80_1 = 32882;
    this.t80_1 = 5890;
    this.u80_1 = 34067;
    this.v80_1 = 34068;
    this.w80_1 = 34069;
    this.x80_1 = 34070;
    this.y80_1 = 34071;
    this.z80_1 = 34072;
    this.a81_1 = 34073;
    this.b81_1 = 34074;
    this.c81_1 = 34076;
    this.d81_1 = 33984;
    this.e81_1 = 33985;
    this.f81_1 = 33986;
    this.g81_1 = 33987;
    this.h81_1 = 33988;
    this.i81_1 = 33989;
    this.j81_1 = 33990;
    this.k81_1 = 33991;
    this.l81_1 = 33992;
    this.m81_1 = 33993;
    this.n81_1 = 33994;
    this.o81_1 = 33995;
    this.p81_1 = 33996;
    this.q81_1 = 33997;
    this.r81_1 = 33998;
    this.s81_1 = 33999;
    this.t81_1 = 34000;
    this.u81_1 = 34001;
    this.v81_1 = 34002;
    this.w81_1 = 34003;
    this.x81_1 = 34004;
    this.y81_1 = 34005;
    this.z81_1 = 34006;
    this.a82_1 = 34007;
    this.b82_1 = 34008;
    this.c82_1 = 34009;
    this.d82_1 = 34010;
    this.e82_1 = 34011;
    this.f82_1 = 34012;
    this.g82_1 = 34013;
    this.h82_1 = 34014;
    this.i82_1 = 34015;
    this.j82_1 = 34016;
    this.k82_1 = 10497;
    this.l82_1 = 33071;
    this.m82_1 = 33648;
    this.n82_1 = 35664;
    this.o82_1 = 35665;
    this.p82_1 = 35666;
    this.q82_1 = 35667;
    this.r82_1 = 35668;
    this.s82_1 = 35669;
    this.t82_1 = 35670;
    this.u82_1 = 35671;
    this.v82_1 = 35672;
    this.w82_1 = 35673;
    this.x82_1 = 35674;
    this.y82_1 = 35675;
    this.z82_1 = 35676;
    this.a83_1 = 35678;
    this.b83_1 = 35680;
    this.c83_1 = 34338;
    this.d83_1 = 34339;
    this.e83_1 = 34340;
    this.f83_1 = 34341;
    this.g83_1 = 34922;
    this.h83_1 = 34373;
    this.i83_1 = 34975;
    this.j83_1 = 35738;
    this.k83_1 = 35739;
    this.l83_1 = 35713;
    this.m83_1 = 35716;
    this.n83_1 = 35720;
    this.o83_1 = 36346;
    this.p83_1 = 36344;
    this.q83_1 = 36345;
    this.r83_1 = 36336;
    this.s83_1 = 36337;
    this.t83_1 = 36338;
    this.u83_1 = 36339;
    this.v83_1 = 36340;
    this.w83_1 = 36341;
    this.x83_1 = 36160;
    this.y83_1 = 36161;
    this.z83_1 = 32854;
    this.a84_1 = 32855;
    this.b84_1 = 36194;
    this.c84_1 = 33189;
    this.d84_1 = 6401;
    this.e84_1 = 36168;
    this.f84_1 = 36162;
    this.g84_1 = 36163;
    this.h84_1 = 36164;
    this.i84_1 = 36176;
    this.j84_1 = 36177;
    this.k84_1 = 36178;
    this.l84_1 = 36179;
    this.m84_1 = 36180;
    this.n84_1 = 36181;
    this.o84_1 = 36048;
    this.p84_1 = 36049;
    this.q84_1 = 36050;
    this.r84_1 = 36051;
    this.s84_1 = 36064;
    this.t84_1 = 36096;
    this.u84_1 = 33306;
    this.v84_1 = 34041;
    this.w84_1 = 36128;
    this.x84_1 = 0;
    this.y84_1 = 36053;
    this.z84_1 = 36054;
    this.a85_1 = 36055;
    this.b85_1 = 36057;
    this.c85_1 = 36061;
    this.d85_1 = 36006;
    this.e85_1 = 36007;
    this.f85_1 = 34024;
    this.g85_1 = 1286;
    this.h85_1 = 37120;
    this.i85_1 = 34836;
    this.j85_1 = 3313;
    this.k85_1 = 3314;
    this.l85_1 = 3316;
    this.m85_1 = 3315;
    this.n85_1 = 3312;
    this.o85_1 = 37441;
    this.p85_1 = 36197;
    this.q85_1 = 35345;
    this.r85_1 = 35368;
    this.s85_1 = 35380;
  }
}
class KmlGl {
  constructor() {
    this.c79_1 = new Mixin();
    this.d79_1 = new ContextInfo();
    this.e79_1 = null;
    var tmp = this;
    tmp.f79_1 = lazy(KmlGl$isFloatTextureSupported$delegate$lambda(this));
  }
  r7c(texture) {
    throw NotImplementedError.be();
  }
  w7g(program, shader) {
    throw NotImplementedError.be();
  }
  v7g(program, index, name) {
    throw NotImplementedError.be();
  }
  l7b(target, buffer) {
    throw NotImplementedError.be();
  }
  o7f(target, framebuffer) {
    throw NotImplementedError.be();
  }
  v7f(target, renderbuffer) {
    throw NotImplementedError.be();
  }
  m7f(target, texture) {
    throw NotImplementedError.be();
  }
  z7d(modeRGB, modeAlpha) {
    throw NotImplementedError.be();
  }
  a7e(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha) {
    throw NotImplementedError.be();
  }
  v7c(target, size, data, usage) {
    throw NotImplementedError.be();
  }
  u7c(target, offset, size, data) {
    throw NotImplementedError.be();
  }
  v7d(mask) {
    throw NotImplementedError.be();
  }
  q7d(red, green, blue, alpha) {
    throw NotImplementedError.be();
  }
  s7d(d) {
    throw NotImplementedError.be();
  }
  u7d(s) {
    throw NotImplementedError.be();
  }
  c7g(red, green, blue, alpha) {
    throw NotImplementedError.be();
  }
  n7g(shader) {
    throw NotImplementedError.be();
  }
  p7g() {
    throw NotImplementedError.be();
  }
  l7g(type) {
    throw NotImplementedError.be();
  }
  s7e(mode) {
    throw NotImplementedError.be();
  }
  t85(n, items) {
    throw NotImplementedError.be();
  }
  u85(n, items) {
    throw NotImplementedError.be();
  }
  k7g(program) {
    throw NotImplementedError.be();
  }
  v85(n, items) {
    throw NotImplementedError.be();
  }
  j7g(shader) {
    throw NotImplementedError.be();
  }
  w85(n, items) {
    throw NotImplementedError.be();
  }
  b7g(func) {
    throw NotImplementedError.be();
  }
  r7d(flag) {
    throw NotImplementedError.be();
  }
  a7g(n, f) {
    throw NotImplementedError.be();
  }
  e7e(cap) {
    throw NotImplementedError.be();
  }
  u7e(index) {
    throw NotImplementedError.be();
  }
  l7e(mode, first, count) {
    throw NotImplementedError.be();
  }
  n7e(mode, count, type, indices) {
    throw NotImplementedError.be();
  }
  f7e(cap) {
    throw NotImplementedError.be();
  }
  y7e(index) {
    throw NotImplementedError.be();
  }
  yc() {
    throw NotImplementedError.be();
  }
  y7f(target, attachment, renderbuffertarget, renderbuffer) {
    throw NotImplementedError.be();
  }
  x7f(target, attachment, textarget, texture, level) {
    throw NotImplementedError.be();
  }
  z7f(mode) {
    throw NotImplementedError.be();
  }
  x85(n, buffers) {
    throw NotImplementedError.be();
  }
  z7c(target) {
    throw NotImplementedError.be();
  }
  y85(n, framebuffers) {
    throw NotImplementedError.be();
  }
  z85(n, renderbuffers) {
    throw NotImplementedError.be();
  }
  a86(n, textures) {
    throw NotImplementedError.be();
  }
  h7g(program, name) {
    throw NotImplementedError.be();
  }
  o7g() {
    throw NotImplementedError.be();
  }
  b86(pname, data) {
    throw NotImplementedError.be();
  }
  c86(program, pname, params) {
    throw NotImplementedError.be();
  }
  d86(shader, pname, params) {
    throw NotImplementedError.be();
  }
  e86(shader, bufSize, length, infoLog) {
    throw NotImplementedError.be();
  }
  g79(name) {
    throw NotImplementedError.be();
  }
  x7g(program) {
    throw NotImplementedError.be();
  }
  w7c(pname, param) {
    throw NotImplementedError.be();
  }
  w7f(target, internalformat, width, height) {
    throw NotImplementedError.be();
  }
  d7g(x, y, width, height) {
    throw NotImplementedError.be();
  }
  m7g(shader, string) {
    throw NotImplementedError.be();
  }
  h7e(func, ref, mask) {
    throw NotImplementedError.be();
  }
  g7e(face, func, ref, mask) {
    throw NotImplementedError.be();
  }
  t7d(mask) {
    throw NotImplementedError.be();
  }
  k7e(face, mask) {
    throw NotImplementedError.be();
  }
  j7e(fail, zfail, zpass) {
    throw NotImplementedError.be();
  }
  i7e(face, sfail, dpfail, dppass) {
    throw NotImplementedError.be();
  }
  x7c(target, level, internalformat, width, height, border, format, type, pixels) {
    throw NotImplementedError.be();
  }
  y7c(target, level, internalformat, format, type, data) {
    var buffer = Buffer.m14(imul(imul(data.z3y_1, data.a3z_1), 4), true);
    setArrayLE(buffer, 0, data.w46().p3y_1);
    this.x7c(target, level, internalformat, data.z3y_1, data.a3z_1, 0, format, type, buffer);
  }
  q7c(target, pname, param) {
    throw NotImplementedError.be();
  }
  m7c(location, count, value) {
    throw NotImplementedError.be();
  }
  k7a(location, v0) {
    throw NotImplementedError.be();
  }
  f7c(location, count, value) {
    throw NotImplementedError.be();
  }
  n7c(location, count, value) {
    throw NotImplementedError.be();
  }
  g7c(location, count, value) {
    throw NotImplementedError.be();
  }
  o7c(location, count, value) {
    throw NotImplementedError.be();
  }
  h7c(location, count, value) {
    throw NotImplementedError.be();
  }
  p7c(location, count, value) {
    throw NotImplementedError.be();
  }
  i7c(location, count, value) {
    throw NotImplementedError.be();
  }
  j7c(location, count, transpose, value) {
    throw NotImplementedError.be();
  }
  k7c(location, count, transpose, value) {
    throw NotImplementedError.be();
  }
  l7c(location, count, transpose, value) {
    throw NotImplementedError.be();
  }
  i7g(program) {
    throw NotImplementedError.be();
  }
  z7e(index, size, type, normalized, stride, pointer) {
    throw NotImplementedError.be();
  }
  n7f(x, y, width, height) {
    throw NotImplementedError.be();
  }
  b7e(cap, enable) {
    if (enable) {
      this.f7e(cap);
    } else {
      this.e7e(cap);
    }
    return enable;
  }
  m7e(mode, first, count, instancecount) {
    unsupported('Not supported instanced drawing');
  }
  o7e(mode, count, type, indices, instancecount) {
    unsupported('Not supported instanced drawing');
  }
  t7e(index, divisor) {
    unsupported();
  }
  g7f(target, index, buffer, offset, size) {
    unsupported('Not supported uniform buffers ' + toString(getKClassFromExpression(this)));
  }
  l7a(program, name) {
    unsupported('Not supported uniform buffers ' + toString(getKClassFromExpression(this)));
  }
  m7a(program, uniformBlockIndex, uniformBlockBinding) {
    unsupported('Not supported uniform buffers ' + toString(getKClassFromExpression(this)));
  }
  f86(n, arrays) {
    unsupported('Not supported vertex arrays ' + toString(getKClassFromExpression(this)));
  }
  v7e(array) {
    unsupported('Not supported vertex arrays ' + toString(getKClassFromExpression(this)));
  }
  s7c() {
    return Companion_instance_54.x7j();
  }
  l7d() {
    return Unit_instance;
  }
  q7e(contextVersion) {
    return Unit_instance;
  }
  g86(name, index) {
    throw NotImplementedError.be();
  }
  o5v() {
    if (this.e79_1 == null) {
      var tmp = this;
      var tmp_0;
      try {
        var numExtensions = getIntegerv(this, 33309);
        if (numExtensions <= 0) {
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError.be();
        }
        // Inline function 'kotlin.collections.mapNotNull' call
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var this_0 = until(0, numExtensions);
        var destination = ArrayList.j1();
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = this_0.b2_1;
        var last = this_0.c2_1;
        if (inductionVariable <= last)
          do {
            var element = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
            // Inline function 'korlibs.kgl.KmlGl.<get-extensions>.<anonymous>' call
            var it = element;
            // Inline function 'korlibs.kgl.KmlGl.EXTENSIONS' call
            var tmp0_safe_receiver = this.g86(7939, it);
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              destination.h(tmp0_safe_receiver);
            }
          }
           while (!(element === last));
        tmp_0 = toSet(destination);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'korlibs.kgl.KmlGl.EXTENSIONS' call
          tmp_1 = toSet(split(this.g79(7939), [' ']));
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      tmp.e79_1 = tmp_0;
    }
    return ensureNotNull(this.e79_1);
  }
  m7d() {
    return this.o5v();
  }
  yz(value) {
    this.c79_1.yz(value);
  }
  zz() {
    return this.c79_1.zz();
  }
}
class KmlGlContext {
  constructor(window_0, gl, parent, $box) {
    parent = parent === VOID ? null : parent;
    boxApply(this, $box);
    this.i7d_1 = window_0;
    this.j7d_1 = gl;
    this.k7d_1 = parent;
  }
  p7e() {
  }
  r7e() {
  }
  n6() {
  }
}
class KorgeReloadInternalImpl {
  h86(clazz, context) {
    return clazz;
  }
  i86(old, new_0) {
    return Unit_instance;
  }
}
class ReloadClassContext {
  constructor(injector, refreshedClasses, rootFolders) {
    this.j86_1 = injector;
    this.k86_1 = refreshedClasses;
    this.l86_1 = rootFolders;
  }
}
class KorgeReload {
  constructor() {
    KorgeReload_instance = this;
    this.m86_1 = null;
    this.n86_1 = Companion_getInstance_1().ey('KorgeReload');
  }
  o86(eventDispatcher) {
    if (!Companion_getInstance_3().tv().fw() || !(Companion_instance_1.hi('KORGE_AUTORELOAD') === 'true'))
      return Unit_instance;
    this.m86_1 = eventDispatcher;
  }
  p86() {
    if (!Companion_getInstance_3().tv().fw())
      return Unit_instance;
    if (!(this.m86_1 == null))
      this.m86_1 = null;
  }
}
class Companion_51 {}
class Companion_52 {
  constructor() {
    Companion_instance_61 = this;
    var tmp = this;
    var tmp0_factors = Companion_getInstance_42().p6o_1;
    tmp.q86_1 = new BlendMode(tmp0_factors, 'NORMAL');
    this.r86_1 = this.q86_1.d8a(VOID, 'INHERIT');
    var tmp_0 = this;
    var tmp0_factors_0 = Companion_getInstance_42().e6y(Companion_getInstance_52().v6x_1, Companion_getInstance_52().c6y_1);
    tmp_0.s86_1 = new BlendMode(tmp0_factors_0, 'NONE');
    var tmp_1 = this;
    var tmp0_factors_1 = Companion_getInstance_42().r6o_1;
    tmp_1.t86_1 = new BlendMode(tmp0_factors_1, 'ADD');
    var tmp_2 = this;
    var tmp0_factors_2 = Companion_getInstance_42().e6y(Companion_getInstance_52().u6x_1, Companion_getInstance_52().y6x_1);
    tmp_2.u86_1 = new BlendMode(tmp0_factors_2, 'MULTIPLY');
    var tmp_3 = this;
    var tmp0_factors_3 = Companion_getInstance_42().e6y(Companion_getInstance_52().v6x_1, Companion_getInstance_52().z6x_1);
    tmp_3.v86_1 = new BlendMode(tmp0_factors_3, 'SCREEN');
    var tmp_4 = this;
    var tmp0_factors_4 = Companion_getInstance_42().e6y(Companion_getInstance_52().c6y_1, Companion_getInstance_52().y6x_1);
    tmp_4.w86_1 = new BlendMode(tmp0_factors_4, 'ERASE');
    var tmp_5 = this;
    var tmp0_factors_5 = Companion_getInstance_42().e6y(Companion_getInstance_52().c6y_1, Companion_getInstance_52().a6y_1);
    tmp_5.x86_1 = new BlendMode(tmp0_factors_5, 'MASK');
    var tmp_6 = this;
    var tmp0_factors_6 = Companion_getInstance_42().e6y(Companion_getInstance_52().w6x_1, Companion_getInstance_52().t6x_1);
    tmp_6.y86_1 = new BlendMode(tmp0_factors_6, 'BELOW');
    var tmp_7 = this;
    var tmp0_factors_7 = Companion_getInstance_42().d6y(Companion_getInstance_52().a6y_1, Companion_getInstance_52().t6x_1, Companion_getInstance_52().v6x_1, Companion_getInstance_52().v6x_1, Companion_getInstance_53().i6y_1);
    tmp_7.z86_1 = new BlendMode(tmp0_factors_7, 'SUBTRACT');
    var tmp_8 = this;
    var tmp0_factors_8 = Companion_getInstance_42().d6y(Companion_getInstance_52().x6x_1, Companion_getInstance_52().c6y_1, Companion_getInstance_52().v6x_1, Companion_getInstance_52().v6x_1);
    tmp_8.a87_1 = new BlendMode(tmp0_factors_8, 'INVERT');
    var tmp_9 = this;
    var tmp0_factors_9 = Companion_getInstance_42().d6y(Companion_getInstance_52().a6y_1, Companion_getInstance_52().t6x_1, Companion_getInstance_52().v6x_1, Companion_getInstance_52().v6x_1);
    tmp_9.b87_1 = new BlendMode(tmp0_factors_9, 'LIGHTEN');
    var tmp_10 = this;
    var tmp0_factors_10 = Companion_getInstance_42().d6y(Companion_getInstance_52().a6y_1, Companion_getInstance_52().t6x_1, Companion_getInstance_52().v6x_1, Companion_getInstance_52().v6x_1);
    tmp_10.c87_1 = new BlendMode(tmp0_factors_10, 'DARKEN');
    var tmp_11 = this;
    var tmp0_factors_11 = Companion_getInstance_42().d6y(Companion_getInstance_52().a6y_1, Companion_getInstance_52().t6x_1, Companion_getInstance_52().v6x_1, Companion_getInstance_52().v6x_1);
    tmp_11.d87_1 = new BlendMode(tmp0_factors_11, 'DIFFERENCE');
    var tmp_12 = this;
    var tmp0_factors_12 = Companion_getInstance_42().d6y(Companion_getInstance_52().a6y_1, Companion_getInstance_52().t6x_1, Companion_getInstance_52().v6x_1, Companion_getInstance_52().v6x_1);
    tmp_12.e87_1 = new BlendMode(tmp0_factors_12, 'ALPHA');
    var tmp_13 = this;
    var tmp0_factors_13 = Companion_getInstance_42().d6y(Companion_getInstance_52().a6y_1, Companion_getInstance_52().t6x_1, Companion_getInstance_52().v6x_1, Companion_getInstance_52().v6x_1);
    tmp_13.f87_1 = new BlendMode(tmp0_factors_13, 'HARDLIGHT');
    var tmp_14 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_14.g87_1 = [this.r86_1, this.s86_1, this.q86_1, this.t86_1, this.u86_1, this.v86_1, this.w86_1, this.x86_1, this.y86_1, this.z86_1, this.a87_1, this.b87_1, this.c87_1, this.d87_1, this.e87_1, this.f87_1];
    var tmp_15 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.g87_1;
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.pc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.korge.blend.Companion.BY_NAME.<anonymous>' call
      var tmp$ret$3 = ensureNotNull(element.b8a_1);
      destination.h3(tmp$ret$3, element);
    }
    tmp_15.h87_1 = destination;
    this.i87_1 = toList_0(this.g87_1);
    var tmp_16 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_1 = get_indices(this.g87_1);
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap.pc(capacity_0);
    var inductionVariable_0 = this_1.b2_1;
    var last_0 = this_1.c2_1;
    if (inductionVariable_0 <= last_0)
      do {
        var element_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'korlibs.korge.blend.Companion.TO_ORDINAL.<anonymous>' call
        var it = element_0;
        var tmp$ret$6 = Companion_getInstance_67().g87_1[it];
        destination_0.h3(tmp$ret$6, element_0);
      }
       while (!(element_0 === last_0));
    tmp_16.j87_1 = destination_0;
  }
}
class BlendMode {
  constructor(factors, name) {
    Companion_getInstance_67();
    name = name === VOID ? null : name;
    this.a8a_1 = factors;
    this.b8a_1 = name;
    var tmp = this;
    var tmp_0 = AGBlending__hashCode_impl_ywnf51(this.a8a_1);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.b8a_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    tmp.c8a_1 = tmp_0 + imul(tmp$ret$0, 7) | 0;
  }
  hashCode() {
    return this.c8a_1;
  }
  equals(other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      if (other instanceof BlendMode) {
        tmp_1 = this.a8a_1 === other.a8a_1;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = this.b8a_1 == other.b8a_1;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  toString() {
    var tmp0_elvis_lhs = this.b8a_1;
    return tmp0_elvis_lhs == null ? anyToString(this) : tmp0_elvis_lhs;
  }
  e8a(factors, name) {
    return new BlendMode(factors, name);
  }
  d8a(factors, name, $super) {
    factors = factors === VOID ? this.a8a_1 : factors;
    name = name === VOID ? this.b8a_1 : name;
    return $super === VOID ? this.e8a(factors, name) : $super.e8a.call(this, new AGBlending(factors), name);
  }
}
class InputKeys {
  constructor() {
    this.f8a_1 = booleanArray(Companion_getInstance_34().z6l_1);
    this.g8a_1 = booleanArray(Companion_getInstance_34().z6l_1);
    this.h8a_1 = false;
    this.i8a_1 = false;
    this.j8a_1 = false;
    this.k8a_1 = false;
  }
  l8a(key) {
    return this.m8a(key);
  }
  m8a(key) {
    return this.f8a_1[key.r3_1];
  }
  n8a(key, up, shift, ctrl, alt, meta) {
    switch (up) {
      case true:
        this.f8a_1[key.r3_1] = false;
        break;
      case false:
        this.f8a_1[key.r3_1] = true;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    this.h8a_1 = shift || this.l8a(Companion_getInstance_34().n6m()) || this.l8a(Companion_getInstance_34().o6m());
    this.i8a_1 = ctrl || this.l8a(Companion_getInstance_34().l6m()) || this.l8a(Companion_getInstance_34().m6m());
    this.j8a_1 = alt || this.l8a(Companion_getInstance_34().p6m()) || this.l8a(Companion_getInstance_34().q6m());
    this.k8a_1 = meta || this.l8a(Key_META_getInstance());
  }
  o8a(e) {
    switch (e.p6g_1.r3_1) {
      case 0:
      case 1:
        this.n8a(e.r6g_1, e.p6g_1.equals(Type_UP_getInstance()), this.h8a_1, this.i8a_1, this.j8a_1, this.k8a_1);
        break;
      default:
        break;
    }
  }
  p8a(delta) {
  }
  q8a(delta) {
    arraycopy_4(this.f8a_1, 0, this.g8a_1, 0, this.f8a_1.length);
  }
}
class Companion_53 {
  constructor() {
    this.r8a_1 = 256;
  }
}
class Input {
  constructor() {
    this.s8a_1 = new Mixin();
    this.t8a_1 = Companion_getInstance_27().s6i_1;
    this.u8a_1 = new TouchEvent();
    var tmp = this;
    tmp.v8a_1 = Input$_isTouchDeviceGen$lambda;
    var tmp_0 = this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_0.w8a_1 = toDuration(400, DurationUnit_MILLISECONDS_getInstance());
    this.x8a_1 = 20.0;
    this.y8a_1 = Vector2D.k2c(-1000.0, -1000.0);
    this.z8a_1 = Vector2D.k2c(-1000.0, -1000.0);
    this.a8b_1 = 0;
    this.b8b_1 = false;
    this.c8b_1 = true;
    this.d8b_1 = false;
    this.e8b_1 = new InputKeys();
    this.f8b_1 = booleanArray(256);
    this.g8b_1 = booleanArray(256);
    this.h8b_1 = new Float64Array(256);
    this.i8b_1 = new Float64Array(256);
    this.j8b_1 = booleanArray(256);
    this.k8b_1 = booleanArray(256);
    this.l8b_1 = booleanArray(256);
    var tmp_1 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, 8);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.b2_1;
    var last = this_0.c2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.korge.input.Input.gamepads.<anonymous>' call
        var it = item;
        var tmp$ret$2 = new GamepadInfo(it);
        destination.h(tmp$ret$2);
      }
       while (!(item === last));
    tmp_1.m8b_1 = copyToArray(destination);
    var tmp_2 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_2.n8b_1 = ArrayList.j1();
  }
  p8b(touchEvent) {
    this.u8a_1.b6k(touchEvent);
  }
  q8b() {
    return this.y8a_1;
  }
  r8b(p, down) {
    if (down)
      this.z8a_1 = p;
    else
      this.y8a_1 = p;
  }
  s8b(button, down) {
    this.a8b_1 = setBits(this.a8b_1, button.b6n_1, down);
  }
  t8b() {
    this.n8b_1.k3();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.m8b_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.korge.input.Input.updateConnectedGamepads.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var gamepad = this_0[_unary__edvuaz];
      if (gamepad.w6k_1) {
        // Inline function 'kotlin.collections.plusAssign' call
        this.n8b_1.h(gamepad);
      }
    }
  }
  u8b(keyCode, b) {
    var pKeyCode = keyCode & 255;
    if (0 <= pKeyCode ? pKeyCode <= (this.f8b_1.length - 1 | 0) : false) {
      this.f8b_1[pKeyCode] = b;
    }
  }
  v8b(delta) {
    var tmp0_safe_receiver = this.zz();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.k3();
    }
    this.e8b_1.p8a(delta);
  }
  w8b(delta) {
    this.d8b_1 = false;
    this.e8b_1.q8a(delta);
    endFrameOldKeys(this, delta);
  }
  x8b(e) {
    switch (e.p6g_1.r3_1) {
      case 1:
        this.u8b(e.s6g_1, true);
        break;
      case 0:
        this.u8b(e.s6g_1, false);
        break;
      case 2:
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  yz(value) {
    this.s8a_1.yz(value);
  }
  zz() {
    return this.s8a_1.zz();
  }
}
class DefaultViewport {
  constructor() {
    DefaultViewport_instance = this;
    this.y8b_1 = 1280;
    this.z8b_1 = 720;
    this.a8c_1 = Size2D.h2b(1280, 720);
  }
}
class Companion_54 {
  b8c(str) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Props();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.logger.Companion.load.<anonymous>' call
    this_0.d8c(str);
    return this_0;
  }
}
class Props {
  constructor(props) {
    props = props === VOID ? LinkedHashMap.oc() : props;
    this.c8c_1 = props;
  }
  e8c(str) {
    var _iterator__ex2g4s = split(str, ['\n']).b1();
    $l$loop_0: while (_iterator__ex2g4s.c1()) {
      var line = _iterator__ex2g4s.d1();
      if (startsWith(line, _Char___init__impl__6a9atx(35)))
        continue $l$loop_0;
      if (isBlank(line))
        continue $l$loop_0;
      var parts = split_0(line, charArrayOf([_Char___init__impl__6a9atx(61)]), VOID, 2);
      // Inline function 'kotlin.text.trim' call
      var this_0 = parts.e1(0);
      var key = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      // Inline function 'kotlin.text.trim' call
      // Inline function 'kotlin.collections.getOrElse' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp;
      if (0 <= 1 ? 1 < parts.f1() : false) {
        tmp = parts.e1(1);
      } else {
        // Inline function 'korlibs.korge.logger.Props.deserializeAdd.<anonymous>' call
        tmp = ' ';
      }
      var this_1 = tmp;
      var value = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
      // Inline function 'kotlin.collections.set' call
      this.c8c_1.h3(key, value);
    }
  }
  d8c(str) {
    this.k3();
    this.e8c(str);
  }
  k3() {
    this.c8c_1.k3();
  }
  f8c(key, value) {
    return this.c8c_1.h3(key, value);
  }
  h3(key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.f8c(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  }
  k10(key) {
    return this.c8c_1.i3(key);
  }
  i3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.k10((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  q1() {
    return this.c8c_1.q1();
  }
  g3() {
    return this.c8c_1.g3();
  }
  l3() {
    return this.c8c_1.l3();
  }
  m10(key) {
    return this.c8c_1.d3(key);
  }
  d3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.m10((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  hi(key) {
    return this.c8c_1.f3(key);
  }
  f3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.hi((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  h1() {
    return this.c8c_1.h1();
  }
  f1() {
    return this.c8c_1.f1();
  }
}
class Entry {
  constructor(closeable) {
    closeable = closeable === VOID ? null : closeable;
    this.g8c_1 = closeable;
  }
  h8c() {
    var tmp0_safe_receiver = this.g8c_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.n6();
    }
    this.g8c_1 = null;
  }
  p2u() {
    this.g8c_1 = null;
  }
}
class AgAutoFreeManager {
  constructor() {
    var tmp = this;
    var tmp_0 = AgAutoFreeManager$entryPool$lambda;
    tmp.i8c_1 = Pool.w2t(tmp_0, VOID, AgAutoFreeManager$entryPool$lambda_0);
    this.j8c_1 = FastIdentityMap();
    this.k8c_1 = fastArrayListOf([]);
    this.l8c_1 = 0;
    this.m8c_1 = 60;
  }
  n8c(closeable) {
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.j8c_1;
      var res = get_0(this_0, closeable);
      if (!(res == null)) {
        break $l$block;
      }
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.reference.<anonymous>' call
      // Inline function 'kotlin.also' call
      var this_1 = this.i8c_1.z2t();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.reference.<anonymous>.<anonymous>' call
      this_1.g8c_1 = closeable;
      var out = this_1;
      set(this_0, closeable, out);
    }
  }
  o8c() {
    this.l8c_1 = this.l8c_1 + 1 | 0;
    if (this.l8c_1 >= this.m8c_1) {
      this.l8c_1 = 0;
      this.p8c();
    }
  }
  p8c() {
    var _iterator__ex2g4s = this.k8c_1.b1();
    while (_iterator__ex2g4s.c1()) {
      var entry = _iterator__ex2g4s.d1();
      if (!contains_1(this.j8c_1, entry.g8c_1)) {
        var tmp0_safe_receiver = entry.g8c_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.n6();
        }
        this.i8c_1.a2u(entry);
      }
    }
    this.k8c_1.k3();
    // Inline function 'korlibs.datastructure.fastValueForEach' call
    var this_0 = this.j8c_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastValueForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.gc.<anonymous>' call
      var it_0 = ensureNotNull(get_0(this_0, it));
      this.k8c_1.h(it_0);
    }
    clear(this.j8c_1);
  }
  n6() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.k8c_1.o10_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.close.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      array[_unary__edvuaz].h8c();
    }
    // Inline function 'korlibs.datastructure.fastValueForEach' call
    var this_0 = this.j8c_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastValueForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.close.<anonymous>' call
      ensureNotNull(get_0(this_0, it)).h8c();
    }
    this.k8c_1.k3();
    this.i8c_1.k3();
    clear(this.j8c_1);
  }
}
class BitmapTextureInfo {
  constructor() {
    this.q8c_1 = 0;
    this.r8c_1 = TextureBase.w8c(null, 0, 0);
    this.s8c_1 = FastIdentityMap();
  }
  p2u() {
    this.q8c_1 = 0;
    this.r8c_1.t8c_1 = null;
    this.r8c_1.v8c_1 = -1;
    this.r8c_1.x8c(0);
    this.r8c_1.y8c(0);
    clear(this.s8c_1);
  }
  toString() {
    return 'BitmapTextureInfo(textureBase=' + this.r8c_1.toString() + ', usedMemory=' + this.q8c_1 + ', slices=' + get_size(this.s8c_1) + ')';
  }
}
class AgBitmapTextureManager {
  constructor(ag) {
    this.z8c_1 = ag;
    this.a8d_1 = new Long(0, 0);
    this.b8d_1 = FastSmallSet.l2r();
    this.c8d_1 = FastSmallSet.l2r();
    this.d8d_1 = FastArrayList.q10();
    this.e8d_1 = 60;
    this.f8d_1 = new Long(0, 0);
    var tmp = this;
    var tmp_0 = AgBitmapTextureManager$textureInfoPool$lambda;
    tmp.g8d_1 = Pool.w2t(tmp_0, VOID, AgBitmapTextureManager$textureInfoPool$lambda_0);
    this.h8d_1 = FastIdentityMap();
    this.i8d_1 = null;
    this.j8d_1 = null;
    this.k8d_1 = null;
    this.l8d_1 = null;
    this.m8d_1 = null;
    this.n8d_1 = null;
    this.o8d_1 = null;
    this.p8d_1 = null;
    this.q8d_1 = 0;
  }
  s8d() {
    return this.b8d_1.f1();
  }
  t8d() {
    return this.c8d_1.f1();
  }
  u8d() {
    return this.d8d_1.f1();
  }
  toString() {
    return this.v8d();
  }
  v8d() {
    return 'AgBitmapTextureManager(numCachedBitmaps=' + this.s8d() + ', numReferencedBitmapsSinceGC=' + this.t8d() + ', numReferencedBitmaps=' + this.u8d() + ', maxCachedMemory=' + ByteUnits__toString_impl_ox2ku2(Companion_getInstance_9().r16(this.a8d_1)) + ', managedTextureMemory=' + ByteUnits__toString_impl_ox2ku2(Companion_getInstance_9().r16(this.f8d_1)) + ')';
  }
  w8d(bitmap) {
    return ensureNotNull(getTextureInfo(this, bitmap).r8c_1);
  }
  x8d(slice) {
    var tmp = _getTexture(this, slice);
    return tmp instanceof RectSlice ? tmp : THROW_CCE();
  }
  y8d(slice) {
    return _getTexture(this, slice);
  }
  z8d() {
    clearFastCacheAccess(this);
    this.q8d_1 = this.q8d_1 + 1 | 0;
    if (this.q8d_1 >= this.e8d_1) {
      this.q8d_1 = 0;
      this.p8c();
    }
  }
  p8c() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.d8d_1.o10_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.gc.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var bmp = array[_unary__edvuaz];
      if (!this.c8d_1.el(bmp))
        if (this.a8d_1.x1(this.f8d_1) < 0 || this.f8d_1.x1(new Long(0, 0)) < 0) {
          this.a8e(bmp, 'GC');
        } else
          this.b8d_1.m2r(bmp);
    }
    this.d8d_1.k3();
    // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.c8d_1.h2r_1.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach.<anonymous>' call
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.gc.<anonymous>' call
      this.d8d_1.h(element);
    }
    // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = this.b8d_1.h2r_1.b1();
    while (tmp0_iterator_0.c1()) {
      var element_0 = tmp0_iterator_0.d1();
      // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach.<anonymous>' call
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.gc.<anonymous>' call
      this.d8d_1.h(element_0);
    }
    this.c8d_1.k3();
  }
  a8e(bmp, reason) {
    var tmp0_elvis_lhs = getAndRemove(this.h8d_1, bmp);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var info = tmp;
    var tmp_0 = this;
    // Inline function 'kotlin.Long.minus' call
    var this_0 = this.f8d_1;
    var other = info.q8c_1;
    tmp_0.f8d_1 = this_0.y1(toLong(other));
    this.c8d_1.n2r(bmp);
    if (this.j8d_1 === info || this.l8d_1 === info) {
      clearFastCacheAccess(this);
    }
    info.r8c_1.n6();
    this.g8d_1.a2u(info);
    this.b8d_1.n2r(bmp);
  }
  n6() {
    clearFastCacheAccess(this);
    var _iterator__ex2g4s = toList(get_keys(this.h8d_1)).b1();
    while (_iterator__ex2g4s.c1()) {
      var bmp = _iterator__ex2g4s.d1();
      this.a8e(bmp, 'close');
    }
    clear(this.h8d_1);
    this.d8d_1.k3();
    this.c8d_1.k3();
    this.b8d_1.k3();
    this.g8d_1.k3();
  }
}
class AgBufferManager {
  constructor(ag) {
    this.b8e_1 = ag;
    this.c8e_1 = FastIdentityMap();
    this.d8e_1 = FastSmallSet.l2r();
    var tmp = this;
    tmp.e8e_1 = Pool.x2t(VOID, AgBufferManager$bufferPool$lambda);
    this.f8e_1 = 0;
    this.g8e_1 = 60;
    this.h8e_1 = Buffer.m14(0);
  }
  i8e(cached) {
    this.d8e_1.m2r(cached);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.c8e_1;
      var res = get_0(this_0, cached);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.korge.render.AgBufferManager.getBuffer.<anonymous>' call
      // Inline function 'kotlin.also' call
      var this_1 = this.e8e_1.z2t();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.render.AgBufferManager.getBuffer.<anonymous>.<anonymous>' call
      this_1.f6r(cached.j8e_1);
      var out = this_1;
      set(this_0, cached, out);
      tmp$ret$0 = out;
    }
    return tmp$ret$0;
  }
  o8c() {
    removeCache(this);
    this.f8e_1 = this.f8e_1 + 1 | 0;
    if (this.f8e_1 >= this.g8e_1) {
      this.f8e_1 = 0;
      this.p8c();
    }
  }
  p8c() {
    // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.d8e_1.h2r_1.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach.<anonymous>' call
      // Inline function 'korlibs.korge.render.AgBufferManager.gc.<anonymous>' call
      this.k8e(element);
    }
    this.d8e_1.k3();
  }
  l8e(buffer) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < buffer.f1()) {
      // Inline function 'korlibs.korge.render.AgBufferManager.delete.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = buffer.e1(_unary__edvuaz);
      this.k8e(it);
    }
  }
  k8e(buffer) {
    var buf = getAndRemove(this.c8e_1, buffer);
    if (buf == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      buf.f6r(this.h8e_1);
      this.e8e_1.a2u(buf);
    }
  }
}
class AgCachedBuffer {
  constructor(data) {
    this.j8e_1 = data;
  }
}
class BatchBuffers {
  constructor() {
    this.w8e_1 = new AGBuffer();
    this.x8e_1 = new AGBuffer();
    this.y8e_1 = new AGBuffer();
    this.z8e_1 = AGVertexArrayObject.u6w([new AGVertexData(Companion_getInstance_70().t8e_1, this.w8e_1), new AGVertexData(Companion_getInstance_70().u8e_1, this.x8e_1)], false);
  }
}
class Companion_55 {
  constructor() {
    Companion_instance_64 = this;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = get_BB_MAX_TEXTURES();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = Sampler.t7s('u_Tex' + tmp_3, 3 + tmp_3 | 0, SamplerVarType_Sampler2D_getInstance());
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.m8e_1 = tmp_2;
    this.n8e_1 = 16383;
    this.o8e_1 = 8192;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = get_logger();
    var level = Level_TRACE_getInstance();
    var tmp_4;
    if (this_0.x2x(level)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$2 = 'BatchBuilder2D.Companion[0]';
      this_0.y2x(level, tmp$ret$2);
      tmp_4 = Unit_instance;
    }
    this.p8e_1 = Attribute.s73('a_Col2', VarType_UByte4_getInstance(), true, VOID, 3);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_1 = get_logger();
    var level_0 = Level_TRACE_getInstance();
    var tmp_5;
    if (this_1.x2x(level_0)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$4 = 'BatchBuilder2D.Companion[1]';
      this_1.y2x(level_0, tmp$ret$4);
      tmp_5 = Unit_instance;
    }
    this.q8e_1 = Varying.e74('v_Col2', VarType_Float4_getInstance());
    this.r8e_1 = Attribute.s73('a_TexIndex', VarType_UByte1_getInstance(), false, Precision_LOW_getInstance(), 4);
    this.s8e_1 = Varying.e74('v_TexIndex', VarType_Float1_getInstance(), Precision_LOW_getInstance());
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_2 = get_logger();
    var level_1 = Level_TRACE_getInstance();
    var tmp_6;
    if (this_2.x2x(level_1)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$6 = 'BatchBuilder2D.Companion[2]';
      this_2.y2x(level_1, tmp$ret$6);
      tmp_6 = Unit_instance;
    }
    this.t8e_1 = ProgramLayout.d6x([DefaultShaders_getInstance().n70_1, DefaultShaders_getInstance().o70_1, this.a8f(), this.p8e_1]);
    this.u8e_1 = ProgramLayout.d6x([this.r8e_1]);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_3 = get_logger();
    var level_2 = Level_TRACE_getInstance();
    var tmp_7;
    if (this_3.x2x(level_2)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$8 = 'BatchBuilder2D.Companion[3]';
      this_3.y2x(level_2, tmp$ret$8);
      tmp_7 = Unit_instance;
    }
    var tmp_8 = this;
    // Inline function 'korlibs.graphics.VertexShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_4 = ProgramBuilderDefault.t74();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.PROGRAM.<anonymous>' call
    this_4.y74(this_4.u74(), this_4.v74());
    this_4.y74(Companion_getInstance_70().s8e_1, Companion_getInstance_70().r8e_1);
    this_4.y74(Companion_getInstance_70().b8f(), this_4.f75([this_4.c75(this_4.h75(Companion_getInstance_70().a8f(), 'rgb'), this_4.h75(Companion_getInstance_70().a8f(), 'a')), this_4.h75(Companion_getInstance_70().a8f(), 'a')]));
    this_4.y74(Companion_getInstance_70().q8e_1, Companion_getInstance_70().p8e_1);
    this_4.y74(this_4.b75(), this_4.c75(this_4.c75(this_4.n72(), this_4.o72()), this_4.f75([this_4.d75(), this_4.e75(0.0), this_4.e75(1.0)])));
    var tmp_9 = VertexShader(this_4.g75());
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_5 = ProgramBuilderDefault.t74();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.PROGRAM.<anonymous>' call
    Companion_getInstance_70().c8f(this_5);
    this_5.y74(this_5.b75(), this_5.c75(this_5.b75(), Companion_getInstance_70().b8f()));
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond = this_5.b77(this_5.h75(this_5.b75(), 'a'), this_5.e75(0.0));
    var body = this_5.p75();
    // Inline function 'korlibs.korge.render.Companion.PROGRAM.<anonymous>.<anonymous>' call
    body.g76();
    var stmIf = new If(cond, body.r75());
    // Inline function 'kotlin.collections.plusAssign' call
    this_5.x74_1.h(stmIf);
    var tmp$ret$14 = FragmentShader(this_5.g75());
    tmp_8.v8e_1 = new Program(tmp_9, tmp$ret$14, 'BatchBuilder2D.Tinted');
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_6 = get_logger();
    var level_3 = Level_TRACE_getInstance();
    var tmp_10;
    if (this_6.x2x(level_3)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$15 = 'BatchBuilder2D.Companion[4]';
      this_6.y2x(level_3, tmp$ret$15);
      tmp_10 = Unit_instance;
    }
  }
  a8f() {
    return DefaultShaders_getInstance().p70_1;
  }
  b8f() {
    return DefaultShaders_getInstance().r70_1;
  }
  c8f(builder) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.createTextureLookup.<anonymous>' call
    var tmp = Companion_getInstance_70().s8e_1;
    var tmp_0 = get_BB_MAX_TEXTURES() - 1 | 0;
    builder.e76(tmp, 0, tmp_0, BatchBuilder2D$Companion$createTextureLookup$lambda(builder));
  }
}
class BatchBuilder2D {
  constructor(ctx, reqMaxQuads) {
    Companion_getInstance_70();
    reqMaxQuads = reqMaxQuads === VOID ? Companion_getInstance_70().o8e_1 : reqMaxQuads;
    this.s88_1 = ctx;
    this.t88_1 = reqMaxQuads;
    this.u88_1 = get_BB_MAX_TEXTURES();
    var tmp = this;
    // Inline function 'kotlin.math.min' call
    var a = this.t88_1;
    var b = Companion_getInstance_70().n8e_1;
    tmp.v88_1 = Math.min(a, b);
    this.w88_1 = this.s88_1.e88_1;
    this.x88_1 = this.s88_1.l87_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = get_logger();
    var level = Level_TRACE_getInstance();
    var tmp_0;
    if (this_0.x2x(level)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$1 = 'BatchBuilder2D[0]';
      this_0.y2x(level, tmp$ret$1);
      tmp_0 = Unit_instance;
    }
    this.s88_1.g88_1.q20(BatchBuilder2D$lambda(this));
    this.y88_1 = imul(this.v88_1, 4);
    this.z88_1 = imul(this.v88_1, 6);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_1 = get_logger();
    var level_0 = Level_TRACE_getInstance();
    var tmp_1;
    if (this_1.x2x(level_0)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$3 = 'BatchBuilder2D[1]';
      this_1.y2x(level_0, tmp$ret$3);
      tmp_1 = Unit_instance;
    }
    this.a89_1 = Buffer.m14(imul(24, this.y88_1));
    this.b89_1 = new Int8Array(this.y88_1);
    this.c89_1 = Buffer.m14(imul(2, this.z88_1));
    this.d89_1 = get_u16(this.c89_1);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_2 = get_logger();
    var level_1 = Level_TRACE_getInstance();
    var tmp_2;
    if (this_2.x2x(level_1)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$5 = 'BatchBuilder2D[2]';
      this_2.y2x(level_1, tmp$ret$5);
      tmp_2 = Unit_instance;
    }
    this.e89_1 = 0;
    this.f89_1 = 0;
    this.g89_1 = 0;
    this.h89_1 = 0;
    var tmp_3 = this;
    var tmp_4 = 0;
    var tmp_5 = this.u88_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_6 = fillArrayVal(Array(tmp_5), null);
    while (tmp_4 < tmp_5) {
      tmp_6[tmp_4] = null;
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.i89_1 = tmp_6;
    this.j89_1 = false;
    this.k89_1 = Companion_getInstance_67().q86_1;
    this.l89_1 = Companion_getInstance_70().v8e_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_3 = get_logger();
    var level_2 = Level_TRACE_getInstance();
    var tmp_7;
    if (this_3.x2x(level_2)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$9 = 'BatchBuilder2D[3]';
      this_3.y2x(level_2, tmp$ret$9);
      tmp_7 = Unit_instance;
    }
    var tmp_8 = this;
    tmp_8.m89_1 = new ReturnablePool(VOID, BatchBuilder2D$buffers$lambda);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_4 = get_logger();
    var level_3 = Level_TRACE_getInstance();
    var tmp_9;
    if (this_4.x2x(level_3)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$11 = 'BatchBuilder2D[4]';
      this_4.y2x(level_3, tmp$ret$11);
      tmp_9 = Unit_instance;
    }
    this.n89_1 = Companion_getInstance_45().w6o_1;
    this.o89_1 = Companion_getInstance_46().y6o_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_5 = get_logger();
    var level_4 = Level_TRACE_getInstance();
    var tmp_10;
    if (this_5.x2x(level_4)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$13 = 'BatchBuilder2D[5]';
      this_5.y2x(level_4, tmp$ret$13);
      tmp_10 = Unit_instance;
    }
    this.p89_1 = _AGColorMask___init__impl__j38ai8_1();
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_6 = get_logger();
    var level_5 = Level_TRACE_getInstance();
    var tmp_11;
    if (this_6.x2x(level_5)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$15 = 'BatchBuilder2D[6]';
      this_6.y2x(level_5, tmp$ret$15);
      tmp_11 = Unit_instance;
    }
    this.q89_1 = Companion_getInstance_43().k6p_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_7 = get_logger();
    var level_6 = Level_TRACE_getInstance();
    var tmp_12;
    if (this_7.x2x(level_6)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$17 = 'BatchBuilder2D[7]';
      this_7.y2x(level_6, tmp$ret$17);
      tmp_12 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_8 = get_logger();
    var level_7 = Level_TRACE_getInstance();
    var tmp_13;
    if (this_8.x2x(level_7)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$19 = 'BatchBuilder2D[11]';
      this_8.y2x(level_7, tmp$ret$19);
      tmp_13 = Unit_instance;
    }
    this.r89_1 = new Signal();
    this.s89_1 = new Signal();
    this.t89_1 = fastArrayListOf([]);
    this.u89_1 = 0;
    this.v89_1 = 0;
    this.w89_1 = 0;
  }
  f8f() {
    return this.s88_1.z87_1;
  }
  g8f(value) {
    this.e89_1 = value;
  }
  h8f() {
    return this.e89_1;
  }
  i8f() {
    var inductionVariable = 0;
    var last = this.u88_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.i89_1[n] = null;
      }
       while (inductionVariable < last);
    this.h89_1 = 0;
  }
  o8c() {
    this.m89_1.p2u();
  }
  j8f() {
    return this.q89_1;
  }
  k8f(vd, vp, x, y, u, v, colorMul, texIndex) {
    setFloat32(vd, vp + 0 | 0, x);
    setFloat32(vd, vp + 1 | 0, y);
    setFloat32(vd, vp + 2 | 0, u);
    setFloat32(vd, vp + 3 | 0, v);
    setInt32(vd, vp + 4 | 0, colorMul);
    setInt32(vd, vp + 5 | 0, 0);
    this.b89_1[vp / 6 | 0] = toByte(texIndex);
    return 6;
  }
  l8f(x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex) {
    this.m8f(6, 4);
    this.n8f();
    var vp = this.f89_1;
    var vd = this.a89_1;
    vp = vp + this.k8f(vd, vp, x0, y0, tex.l3l(), tex.m3l(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.k8f(vd, vp, x1, y1, tex.n3l(), tex.o3l(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.k8f(vd, vp, x2, y2, tex.p3l(), tex.q3l(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.k8f(vd, vp, x3, y3, tex.r3l(), tex.s3l(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    this.f89_1 = vp;
    this.g8f(this.h8f() + 4 | 0);
  }
  o8f(x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex, $super) {
    texIndex = texIndex === VOID ? this.h89_1 : texIndex;
    var tmp;
    if ($super === VOID) {
      this.l8f(x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.l8f.call(this, x0, y0, x1, y1, x2, y2, x3, y3, tex, new RGBA(colorMul), texIndex);
    }
    return tmp;
  }
  p8f(vc) {
    this.g89_1 = this.g89_1 + _addIndices(this, this.d89_1, this.g89_1, vc + 0 | 0, vc + 1 | 0, vc + 2 | 0, vc + 3 | 0, vc + 0 | 0, vc + 2 | 0) | 0;
  }
  n8f(vc, $super) {
    vc = vc === VOID ? this.h8f() : vc;
    var tmp;
    if ($super === VOID) {
      this.p8f(vc);
      tmp = Unit_instance;
    } else {
      tmp = $super.p8f.call(this, vc);
    }
    return tmp;
  }
  q8f(array, matrix, vcount, icount, texIndex) {
    this.m8f(icount, vcount);
    var i16 = this.d89_1;
    var ip = this.g89_1;
    var vc = this.h8f();
    var arrayIndices = array.r8f_1;
    // Inline function 'kotlin.math.min' call
    var b = array.u8f_1;
    var icount_0 = Math.min(icount, b);
    arraycopy_5(asUShortArrayInt(arrayIndices), 0, i16, ip, icount_0);
    arrayadd(i16, toShort(vc), ip, ip + icount_0 | 0);
    var vp = this.f89_1;
    var src = get_i32(array.v8f_1);
    var dst = get_i32(this.a89_1);
    arraycopy_6(src, 0, dst, vp, imul(vcount, 6));
    var vp6 = this.f89_1 / 6 | 0;
    arrayfill(this.b89_1, toByte(texIndex), vp6, vp6 + vcount | 0);
    if (matrix.q2a()) {
      applyMatrix(this, matrix, this.f89_1, vcount);
    }
    this.e89_1 = this.e89_1 + vcount | 0;
    this.f89_1 = this.f89_1 + imul(vcount, 6) | 0;
    this.g89_1 = this.g89_1 + icount_0 | 0;
  }
  y8f(array, matrix, vcount, icount, texIndex, $super) {
    vcount = vcount === VOID ? array.t8f_1 : vcount;
    icount = icount === VOID ? array.u8f_1 : icount;
    texIndex = texIndex === VOID ? this.h89_1 : texIndex;
    var tmp;
    if ($super === VOID) {
      this.q8f(array, matrix, vcount, icount, texIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.q8f.call(this, array, matrix, vcount, icount, texIndex);
    }
    return tmp;
  }
  m8f(indices, vertices) {
    if (indices === 0 && vertices === 0)
      return false;
    var doFlush = !checkAvailable(this, indices, vertices);
    if (doFlush) {
      this.z8f();
    }
    if (!checkAvailable(this, indices, vertices)) {
      // Inline function 'kotlin.error' call
      var message = 'Too much vertices: indices=' + indices + ', vertices=' + vertices;
      throw IllegalStateException.h5(toString(message));
    }
    return doFlush;
  }
  a8g(tex, smoothing, blendMode, program, icount, vcount) {
    $l$block: {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
      var tex_0 = tex.t8c_1;
      this.m8f(icount, vcount);
      var pprogram = program == null ? Companion_getInstance_70().v8e_1 : program;
      if (this.b8g(tex_0, smoothing, blendMode, pprogram)) {
        break $l$block;
      }
      this.d8f();
      if (!contains_0(this.i89_1, tex_0)) {
        this.h89_1 = 0;
        this.i89_1[0] = tex_0;
      }
      this.j89_1 = smoothing;
      this.k89_1 = blendMode;
      this.l89_1 = pprogram;
    }
  }
  c8g(tex) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.i89_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.hasTex.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      if (this_0[_unary__edvuaz] === tex)
        return true;
    }
    return false;
  }
  b8g(tex, smoothing, blendMode, program) {
    var hasTex = this.c8g(tex);
    if (!(this.i89_1[0] === null) && !hasTex) {
      var inductionVariable = 1;
      var last = this.i89_1.length;
      if (inductionVariable < last)
        $l$loop: do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (this.i89_1[n] === null) {
            this.i89_1[n] = tex;
            hasTex = true;
            break $l$loop;
          }
        }
         while (inductionVariable < last);
    }
    var inductionVariable_0 = 0;
    var last_0 = this.i89_1.length - 1 | 0;
    if (inductionVariable_0 <= last_0)
      $l$loop_0: do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        if (tex === this.i89_1[n_0]) {
          this.h89_1 = n_0;
          break $l$loop_0;
        }
      }
       while (inductionVariable_0 <= last_0);
    return hasTex && this.j89_1 === smoothing && this.k89_1 === blendMode && this.l89_1 === program;
  }
  d8g(tex, smoothing, blendMode, program, icount, vcount) {
    this.a8g(this.w88_1.w8d(tex), smoothing, blendMode, program, icount, vcount);
  }
  e8g(tex, x, y, width, height, m, filtering, colorMul, blendMode, program) {
    return this.f8g(tex, x, y, width, height, m, filtering, colorMul, blendMode, program, Unit_instance);
  }
  z89(tex, x, y, width, height, m, filtering, colorMul, blendMode, program, $super) {
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    width = width === VOID ? tex.d2m() : width;
    height = height === VOID ? tex.e2m() : height;
    m = m === VOID ? Companion_getInstance_7().m2d_1 : m;
    filtering = filtering === VOID ? true : filtering;
    colorMul = colorMul === VOID ? Colors_getInstance().g40_1 : colorMul;
    blendMode = blendMode === VOID ? Companion_getInstance_67().q86_1 : blendMode;
    program = program === VOID ? null : program;
    var tmp;
    if ($super === VOID) {
      this.e8g(tex, x, y, width, height, m, filtering, colorMul, blendMode, program);
      tmp = Unit_instance;
    } else {
      tmp = $super.e8g.call(this, tex, x, y, width, height, m, filtering, new RGBA(colorMul), blendMode, program);
    }
    return tmp;
  }
  f8g(tex, x, y, width, height, m, filtering, colorMul, blendMode, program, unit) {
    this.a8g(tex.a3l(), filtering, blendMode, program, 6, 4);
    this.g8g(x, y, width, height, m, tex, colorMul);
  }
  g8g(x, y, width, height, m, tex, colorMul) {
    var x0 = x;
    var x1 = x + width;
    var y0 = y;
    var y1 = y + height;
    this.o8f(m.f2e(x0, y0), m.g2e(x0, y0), m.f2e(x1, y0), m.g2e(x1, y0), m.f2e(x1, y1), m.g2e(x1, y1), m.f2e(x0, y1), m.g2e(x0, y1), tex, colorMul);
  }
  h8g() {
    this.m89_1.o2u_1.y8e_1.e6r(this.c89_1, 0, imul(this.g89_1, 2));
  }
  i8g() {
    this.s88_1.i8g();
    var inductionVariable = 0;
    var last = this.u88_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var info = Companion_getInstance_39().n6u(VOID, this.j89_1);
        this.s88_1.u87_1.m6r(Companion_getInstance_70().m8e_1[n], this.i89_1[n], info);
      }
       while (inductionVariable < last);
  }
  d8f() {
    if (this.u89_1 === this.g89_1)
      return Unit_instance;
    this.i8g();
    this.v89_1 = this.v89_1 + 1 | 0;
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.t89_1;
    var tmp0_frameBuffer = this.s88_1.o88_1.k6n_1;
    var tmp1_frameBufferInfo = this.s88_1.o88_1.q6p();
    var tmp2_vertexData = this.m89_1.o2u_1.z8e_1;
    var tmp3_indices = this.m89_1.o2u_1.y8e_1;
    var tmp4_program = this.l89_1;
    var tmp5_drawType = Companion_getInstance_40().l6x_1;
    var tmp6_blending = this.k89_1.a8a_1;
    var tmp7_uniformBlocks = this.s88_1.j8g(this.l89_1, false);
    var tmp8_textureUnits = this.s88_1.u87_1.uz();
    var tmp9_stencilOpFunc = this.o89_1;
    var tmp10_stencilRef = this.n89_1;
    var tmp11_colorMask = this.p89_1;
    var tmp12_scissor = this.q89_1;
    var tmp13_drawOffset = imul(this.u89_1, 2);
    var tmp14_vertexCount = this.g89_1 - this.u89_1 | 0;
    var element = new AGBatch(tmp0_frameBuffer, tmp1_frameBufferInfo, tmp2_vertexData, tmp3_indices, VOID, tmp4_program, tmp7_uniformBlocks, tmp8_textureUnits, tmp6_blending, tmp9_stencilOpFunc, tmp10_stencilRef, tmp11_colorMask, VOID, tmp12_scissor, VOID, tmp5_drawType, tmp13_drawOffset, tmp14_vertexCount);
    this_0.h(element);
    this.u89_1 = this.g89_1;
  }
  k8g(uploadVertices, uploadIndices) {
    this.l8g(uploadVertices, uploadIndices);
    var inductionVariable = 0;
    var last = this.u88_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.i89_1[n] = null;
      }
       while (inductionVariable < last);
    this.h89_1 = 0;
  }
  e8f(uploadVertices, uploadIndices, $super) {
    uploadVertices = uploadVertices === VOID ? true : uploadVertices;
    uploadIndices = uploadIndices === VOID ? true : uploadIndices;
    var tmp;
    if ($super === VOID) {
      this.k8g(uploadVertices, uploadIndices);
      tmp = Unit_instance;
    } else {
      tmp = $super.k8g.call(this, uploadVertices, uploadIndices);
    }
    return tmp;
  }
  l8g(uploadVertices, uploadIndices) {
    this.d8f();
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.t89_1.h1()) {
      if (uploadVertices) {
        this.m89_1.o2u_1.w8e_1.e6r(this.a89_1, 0, imul(this.f89_1, 4));
        this.m89_1.o2u_1.x8e_1.d6r(this.b89_1, 0, this.f89_1 / 6 | 0);
      }
      if (uploadIndices) {
        this.h8g();
      }
      this.s88_1.m8g();
      draw_0(this.x88_1, new AGMultiBatch(toList(this.t89_1)));
      this.t89_1.k3();
      this.r89_1.x20(this);
      this.w89_1 = this.w89_1 + 1 | 0;
      this.s88_1.n8g();
      this.m89_1.d1();
    }
    this.g8f(0);
    this.f89_1 = 0;
    this.u89_1 = 0;
    this.g89_1 = 0;
  }
  z8f(uploadVertices, uploadIndices, $super) {
    uploadVertices = uploadVertices === VOID ? true : uploadVertices;
    uploadIndices = uploadIndices === VOID ? true : uploadIndices;
    var tmp;
    if ($super === VOID) {
      this.l8g(uploadVertices, uploadIndices);
      tmp = Unit_instance;
    } else {
      tmp = $super.l8g.call(this, uploadVertices, uploadIndices);
    }
    return tmp;
  }
  o8g(vertexCount) {
    var oldVertexCount = this.h8f();
    this.g8f(vertexCount);
    try {
      this.r89_1.x20(this);
    }finally {
      this.g8f(oldVertexCount);
    }
  }
}
class BoundsProvider {}
function get_windowToGlobalScaleAvg() {
  return get_scale(this.x8g()).x2f();
}
function get_globalToWindowScaleAvg() {
  return this.b8h().x2f();
}
function windowToGlobalCoords(pos) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    var this_0 = this.v8g();
    if (this_0.p2a()) {
      tmp$ret$0 = pos;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.k2c(this_0.e2e(pos.a2a_1, pos.b2a_1), this_0.h2e(pos.a2a_1, pos.b2a_1));
  }
  return tmp$ret$0;
}
class Base {
  constructor() {
    this.p8g_1 = Companion_getInstance_7().p2d();
    this.q8g_1 = MatrixTransform.v2f();
    this.r8g_1 = Companion_getInstance_7().p2d();
    this.s8g_1 = MatrixTransform.v2f();
    this.t8g_1 = Companion_getInstance_5().z2h(0, 0, 1280, 720);
  }
  u8g(_set____db54di) {
    this.p8g_1 = _set____db54di;
  }
  v8g() {
    return this.p8g_1;
  }
  w8g(_set____db54di) {
    this.q8g_1 = _set____db54di;
  }
  x8g() {
    return this.q8g_1;
  }
  y8g(_set____db54di) {
    this.r8g_1 = _set____db54di;
  }
  z8g() {
    return this.r8g_1;
  }
  a8h(_set____db54di) {
    this.s8g_1 = _set____db54di;
  }
  b8h() {
    return this.s8g_1;
  }
  c8h(_set____db54di) {
    this.t8g_1 = _set____db54di;
  }
}
class Companion_56 {
  constructor() {
    Companion_instance_65 = this;
    this.g8h_1 = ProgramLayout.d6x([DefaultShaders_getInstance().n70_1, DefaultShaders_getInstance().p70_1]);
    var tmp = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder = ProgramBuilderDefault.t74();
    // Inline function 'korlibs.korge.render.Companion.VERTEX.<anonymous>' call
    // Inline function 'kotlin.apply' call
    var this_0 = DefaultShaders_getInstance();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.VERTEX.<anonymous>.<anonymous>' call
    builder.y74(builder.b75(), builder.c75(builder.c75(this_0.n72(), this_0.o72()), builder.f75([this_0.n70_1, builder.e75(0.0), builder.e75(1.0)])));
    builder.y74(this_0.r70_1, this_0.p70_1);
    tmp.h8h_1 = VertexShader(builder.g75());
    var tmp_0 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_0 = ProgramBuilderDefault.t74();
    // Inline function 'korlibs.korge.render.Companion.FRAGMENT.<anonymous>' call
    // Inline function 'kotlin.apply' call
    var this_1 = DefaultShaders_getInstance();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.FRAGMENT.<anonymous>.<anonymous>' call
    builder_0.y74(builder_0.b75(), this_1.r70_1);
    tmp_0.i8h_1 = FragmentShader(builder_0.g75());
    this.j8h_1 = new Program(this.h8h_1, this.i8h_1);
  }
}
class LineRenderBatcher {
  constructor(ctx) {
    Companion_getInstance_71();
    this.k8h_1 = ctx;
    this.l8h_1 = new Signal();
    this.k8h_1.g88_1.q20(LineRenderBatcher$lambda(this));
    this.m8h_1 = this.k8h_1.l87_1;
    this.n8h_1 = Colors_getInstance().w45_1;
    this.o8h_1 = new AGBuffer();
    this.p8h_1 = AGVertexArrayObject.u6w([new AGVertexData(Companion_getInstance_71().g8h_1, this.o8h_1)], false);
    this.q8h_1 = 1024;
    this.r8h_1 = allocDirect(Companion_instance_4, imul(24, this.q8h_1));
    this.s8h_1 = Matrix4.u2g();
    this.t8h_1 = 0;
    this.u8h_1 = 0;
    this.v8h_1 = Companion_getInstance_67().q86_1;
    this.w8h_1 = Companion_getInstance_7().p2d();
  }
  x8h(p0, p1, color0, color1, m) {
    return this.y8h(p0.a2a_1, p0.b2a_1, p1.a2a_1, p1.b2a_1, this.n8h_1, color1, m);
  }
  z8h(p0, p1, color0, color1, m, $super) {
    color0 = color0 === VOID ? this.n8h_1 : color0;
    color1 = color1 === VOID ? color0 : color1;
    m = m === VOID ? this.w8h_1 : m;
    var tmp;
    if ($super === VOID) {
      this.x8h(p0, p1, color0, color1, m);
      tmp = Unit_instance;
    } else {
      tmp = $super.x8h.call(this, p0, p1, new RGBA(color0), new RGBA(color1), m);
    }
    return tmp;
  }
  a8i(x0, y0, x1, y1, color0, color1, m) {
    if (this.t8h_1 >= (this.q8h_1 - 2 | 0)) {
      this.yc();
    }
    addVertex(this, x0, y0, color0, m);
    addVertex(this, x1, y1, color1, m);
  }
  b8i(x0, y0, x1, y1, color0, color1, m, $super) {
    color0 = color0 === VOID ? this.n8h_1 : color0;
    color1 = color1 === VOID ? color0 : color1;
    m = m === VOID ? this.w8h_1 : m;
    var tmp;
    if ($super === VOID) {
      this.a8i(x0, y0, x1, y1, color0, color1, m);
      tmp = Unit_instance;
    } else {
      tmp = $super.a8i.call(this, x0, y0, x1, y1, new RGBA(color0), new RGBA(color1), m);
    }
    return tmp;
  }
  y8h(x0, y0, x1, y1, color0, color1, m) {
    return this.a8i(x0, y0, x1, y1, color0, color1, m);
  }
  c8i(path, m) {
    var lastPos = {_v: Vector2D.v2c()};
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i = Vector2D.v2c();
    var l = Vector2D.v2c();
    // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.w3h_1;
    var n_0 = 0;
    while (n_0 < this_0.f1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.sz(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.x3h_1.e1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var it = Vector2D.k2c(tmp, path.x3h_1.e1(_unary__edvuaz_1));
          i = it;
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call

          if (!true) {
            this.z8h(lastPos._v, it, VOID, VOID, m);
          }

          lastPos._v = it;
          l = it;
          break;
        case 1:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.x3h_1.e1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var it_0 = Vector2D.k2c(tmp_0, path.x3h_1.e1(_unary__edvuaz_3));
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call

          if (!false) {
            this.z8h(lastPos._v, it_0, VOID, VOID, m);
          }

          lastPos._v = it_0;
          l = it_0;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 2:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.x3h_1.e1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var c = Vector2D.k2c(tmp_1, path.x3h_1.e1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.x3h_1.e1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var a = Vector2D.k2c(tmp_2, path.x3h_1.e1(_unary__edvuaz_7));
          var sum = Companion_getInstance_4().t2k(l, c) + Companion_getInstance_4().t2k(c, a);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_0 = numberToInt(sum);
          var rcurveSteps = Math.max(a_0, 20);
          var dt = 1.0 / rcurveSteps;
          var lastPos_0 = {_v: Vector2D.v2c()};
          var prevPos = {_v: Vector2D.v2c()};
          var emittedCount = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio = Companion_getInstance_10().mz_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_0._v = Companion_getInstance_12().t3f(l, c, a, ratio);
          var nStart = false ? 0 : 1;
          var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
          var inductionVariable = nStart;
          if (inductionVariable <= nEnd)
            do {
              var n_1 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var ratio_0 = _Ratio___init__impl__9mwvn2(n_1 * dt);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_1 = Companion_getInstance_12().t3f(l, c, a, ratio_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
              if (!false) {
                this.z8h(lastPos._v, it_1, VOID, VOID, m);
              }
              lastPos._v = it_1;
              emittedCount._v = emittedCount._v + 1 | 0;
              lastPos_0._v = prevPos._v;
              prevPos._v = it_1;
            }
             while (!(n_1 === nEnd));
          l = a;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 3:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.x3h_1.e1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var c0 = Vector2D.k2c(tmp_3, path.x3h_1.e1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.x3h_1.e1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var c1 = Vector2D.k2c(tmp_4, path.x3h_1.e1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.x3h_1.e1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var a_1 = Vector2D.k2c(tmp_5, path.x3h_1.e1(_unary__edvuaz_13));
          var sum_0 = Companion_getInstance_4().t2k(l, c0) + Companion_getInstance_4().t2k(c0, c1) + Companion_getInstance_4().t2k(c1, a_1);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_2 = numberToInt(sum_0);
          var rcurveSteps_0 = Math.max(a_2, 20);
          var dt_0 = 1.0 / rcurveSteps_0;
          var lastPos_1 = {_v: Vector2D.v2c()};
          var prevPos_0 = {_v: Vector2D.v2c()};
          var emittedCount_0 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_1 = Companion_getInstance_10().mz_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_1._v = Companion_getInstance_12().s3f(l, c0, c1, a_1, ratio_1);
          var nStart_0 = false ? 0 : 1;
          var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
          var inductionVariable_0 = nStart_0;
          if (inductionVariable_0 <= nEnd_0)
            do {
              var n_2 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var ratio_2 = _Ratio___init__impl__9mwvn2(n_2 * dt_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_2 = Companion_getInstance_12().s3f(l, c0, c1, a_1, ratio_2);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
              if (!false) {
                this.z8h(lastPos._v, it_2, VOID, VOID, m);
              }
              lastPos._v = it_2;
              emittedCount_0._v = emittedCount_0._v + 1 | 0;
              lastPos_1._v = prevPos_0._v;
              prevPos_0._v = it_2;
            }
             while (!(n_2 === nEnd_0));
          l = a_1;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 4:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call

          var p = i;
          if (!false) {
            this.z8h(lastPos._v, p, VOID, VOID, m);
          }

          lastPos._v = p;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
      }
    }
    // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
  }
  yc() {
    if (this.t8h_1 > 0) {
      this.l8h_1.x20(this);
      this.o8h_1.e6r(this.r8h_1, 0, imul(this.u8h_1, 4));
      this.k8h_1.i8g();
      var tmp0_$receiver = this.m8h_1;
      var tmp1_frameBuffer = this.k8h_1.o88_1;
      var tmp2_vertexData = this.p8h_1;
      var tmp3_program = Companion_getInstance_71().j8h_1;
      var tmp4_drawType = Companion_getInstance_40().k6x_1;
      var tmp5_vertexCount = this.t8h_1;
      var tmp6_uniformBlocks = this.k8h_1.d8i(Companion_getInstance_71().j8h_1);
      var tmp7_blending = this.v8h_1.a8a_1;
      draw(tmp0_$receiver, tmp1_frameBuffer, tmp2_vertexData, tmp3_program, tmp4_drawType, tmp5_vertexCount, VOID, VOID, VOID, tmp7_blending, tmp6_uniformBlocks);
    }
    this.t8h_1 = 0;
    this.u8h_1 = 0;
  }
}
class FlushKind extends Enum {}
class DeviceDimensionsProvider {}
function get_devicePixelRatio() {
  return 1.0;
}
function get_pixelsPerInch() {
  return 96.0 * this.w8i();
}
function get_pixelsPerLogicalInchRatio() {
  return this.x8i() / 96.0;
}
function get_computedPixelRatio() {
  return this.w8i() * this.y8i();
}
class RenderContext {
  constructor(ag, bp, deviceDimensionsProvider, stats, coroutineContext, batchMaxQuads, windowConfig) {
    bp = bp === VOID ? new Base() : bp;
    var tmp;
    if (deviceDimensionsProvider === VOID) {
      var tmp0_elvis_lhs = isInterface(bp, DeviceDimensionsProvider) ? bp : null;
      tmp = tmp0_elvis_lhs == null ? DEFAULT_instance : tmp0_elvis_lhs;
    } else {
      tmp = deviceDimensionsProvider;
    }
    deviceDimensionsProvider = tmp;
    stats = stats === VOID ? new Stats() : stats;
    coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_getInstance() : coroutineContext;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_70().o8e_1 : batchMaxQuads;
    windowConfig = windowConfig === VOID ? new Impl() : windowConfig;
    this.k87_1 = new Mixin();
    this.l87_1 = ag;
    this.m87_1 = bp;
    this.n87_1 = deviceDimensionsProvider;
    this.o87_1 = stats;
    this.p87_1 = coroutineContext;
    this.q87_1 = batchMaxQuads;
    this.r87_1 = windowConfig;
    this.s87_1 = new BufferCache();
    this.t87_1 = FastIdentityMap();
    this.u87_1 = AGTextureUnits.j6r();
    this.v87_1 = Companion_getInstance_7().p2d();
    this.w87_1 = Companion_getInstance_7().p2d();
    this.x87_1 = Matrix4.u2g();
    this.y87_1 = Matrix4.u2g();
    this.z87_1 = Companion_getInstance_7().p2d();
    this.a88_1 = true;
    var tmp_0 = this;
    tmp_0.b88_1 = Pool.x2t(VOID, RenderContext$tempTexturePool$lambda);
    var tmp_1 = this;
    tmp_1.c88_1 = lazy(RenderContext$projViewMatUB$delegate$lambda(this));
    this.d88_1 = new AgAutoFreeManager();
    this.e88_1 = new AgBitmapTextureManager(this.l87_1);
    this.f88_1 = new AgBufferManager(this.l87_1);
    this.g88_1 = new Signal();
    this.h88_1 = 1.0;
    this.i88_1 = Colors_getInstance().g40_1;
    this.j88_1 = new BatchBuilder2D(this, this.q87_1);
    var tmp_2 = this;
    tmp_2.k88_1 = Pool.x2t(VOID, RenderContext$dynamicVertexBufferPool$lambda);
    this.l88_1 = new RenderContext2D(this.j88_1, this.e88_1);
    this.m88_1 = true;
    this.n88_1 = null;
    this.o88_1 = this.l87_1.y6n();
    this.p88_1 = LinkedHashSet.i1();
    var tmp_3 = this;
    tmp_3.q88_1 = Pool.x2t(VOID, RenderContext$frameBuffers$lambda);
    this.r88_1 = FastArrayList.q10();
  }
  e8i() {
    return this.r87_1.e8i();
  }
  n8g() {
  }
  f8i() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.c88_1;
    projViewMatUB$factory();
    return this_0.s1();
  }
  i8g() {
    if (this.a88_1 && this.o88_1.g6s()) {
      this.x87_1 = ortho(Companion_getInstance_6(), Companion_getInstance_5().d2i(0, this.o88_1.s6n_1, this.o88_1.r6n_1, 0), -1.0, 1.0);
    } else {
      this.x87_1 = ortho(Companion_getInstance_6(), Companion_getInstance_5().d2i(0, 0, this.o88_1.r6n_1, this.o88_1.s6n_1), -1.0, 1.0);
      this.x87_1 = this.x87_1.r2h(toMatrix4(this.v87_1));
    }
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var this_0 = this.f8i();
      var _unary__edvuaz = this_0.p6w();
      this_0.g7j(_unary__edvuaz + 1 | 0);
      this_0.h7j(this_0.p6w() + 1 | 0);
      var blockSize = this_0.t6u_1;
      var index0 = imul(this_0.p6w() - 1 | 0, blockSize);
      var index1 = imul(this_0.p6w(), blockSize);
      var texBlockSize = this_0.q6u_1.p72().f1();
      var texIndex0 = imul(this_0.p6w() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_0.p6w(), texBlockSize);
      if (this_0.p6w() > 0) {
        arraycopy_0(this_0.v6u_1, index0, this_0.v6u_1, index1, blockSize);
      } else {
        arrayfill_0(this_0.v6u_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.korge.render.RenderContext.updateStandardUniforms.<anonymous>' call
      var $this$push = this_0.q6u_1;
      var it = this_0.w6u_1;
      it.q7j($this$push.n72(), this.x87_1);
      it.q7j($this$push.o72(), this.y87_1);
      if (true && this_0.p6w() >= 1) {
        var equals = arrayequal(this_0.v6u_1, index0, this_0.v6u_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_0.p6w();
          this_0.g7j(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
  }
  g8i() {
    return coerceAtLeast_0(round(this.h8i() * this.h88_1), 1.0);
  }
  i8i(kind) {
    this.g88_1.x20(kind);
  }
  x89(kind, $super) {
    kind = kind === VOID ? FlushKind_FULL_getInstance() : kind;
    var tmp;
    if ($super === VOID) {
      this.i8i(kind);
      tmp = Unit_instance;
    } else {
      tmp = $super.i8i.call(this, kind);
    }
    return tmp;
  }
  j8i() {
    var tmp0_elvis_lhs = this.o88_1;
    return tmp0_elvis_lhs == null ? this.y6n() : tmp0_elvis_lhs;
  }
  k8i() {
    return this.j8i() === this.y6n();
  }
  y6n() {
    return this.l87_1.y6n();
  }
  l8i(color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    this.l87_1.d6o(this.o88_1.k6n_1, this.o88_1.q6p(), color, depth, stencil, clearColor, clearDepth, clearStencil, scissor);
  }
  m8i(color, depth, stencil, clearColor, clearDepth, clearStencil, scissor, $super) {
    color = color === VOID ? Colors_getInstance().l40_1 : color;
    depth = depth === VOID ? 1.0 : depth;
    stencil = stencil === VOID ? 0 : stencil;
    clearColor = clearColor === VOID ? true : clearColor;
    clearDepth = clearDepth === VOID ? true : clearDepth;
    clearStencil = clearStencil === VOID ? true : clearStencil;
    scissor = scissor === VOID ? Companion_getInstance_43().k6p_1 : scissor;
    var tmp;
    if ($super === VOID) {
      this.l8i(color, depth, stencil, clearColor, clearDepth, clearStencil, scissor);
      tmp = Unit_instance;
    } else {
      tmp = $super.l8i.call(this, new RGBA(color), depth, stencil, clearColor, clearDepth, clearStencil, scissor);
    }
    return tmp;
  }
  a6o() {
    this.l87_1.a6o();
    this.q88_1.b2u(this.p88_1);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.p88_1.h1()) {
      this.p88_1.k3();
    }
  }
  y89(bmp) {
    return this.e88_1.x8d(bmp);
  }
  n8i(bmp) {
    return this.e88_1.y8d(bmp);
  }
  i8e(buffer) {
    return this.f88_1.i8e(buffer);
  }
  o8i(closeable) {
    return this.d88_1.n8c(closeable);
  }
  p8i() {
    this.j88_1.i8f();
  }
  z8d() {
    this.x89();
    this.a6o();
    this.j88_1.o8c();
    this.d88_1.o8c();
    this.e88_1.z8d();
    this.f88_1.o8c();
  }
  n6() {
    this.e88_1.n6();
    this.d88_1.n6();
  }
  q8i(width, height, hasDepth, hasStencil, msamples, onlyThisFrame) {
    // Inline function 'kotlin.math.max' call
    var realWidth = Math.max(width, 64);
    // Inline function 'kotlin.math.max' call
    var realHeight = Math.max(height, 64);
    var rb = this.q88_1.z2t();
    if (onlyThisFrame) {
      // Inline function 'kotlin.collections.plusAssign' call
      this.p88_1.h(rb);
    }
    rb.s6s(0, 0, realWidth, realHeight, realWidth, realHeight);
    rb.j6t(hasDepth, hasStencil);
    rb.i6t(msamples);
    return rb;
  }
  r8i(width, height, hasDepth, hasStencil, msamples, onlyThisFrame, $super) {
    hasDepth = hasDepth === VOID ? false : hasDepth;
    hasStencil = hasStencil === VOID ? true : hasStencil;
    msamples = msamples === VOID ? 1 : msamples;
    onlyThisFrame = onlyThisFrame === VOID ? true : onlyThisFrame;
    return $super === VOID ? this.q8i(width, height, hasDepth, hasStencil, msamples, onlyThisFrame) : $super.q8i.call(this, width, height, hasDepth, hasStencil, msamples, onlyThisFrame);
  }
  s8i(rb) {
    this.p88_1.m3(rb);
    this.q88_1.a2u(rb);
  }
  t8i(frameBuffer) {
    this.r88_1.h(this.o88_1);
    this.o88_1 = frameBuffer;
  }
  u8i() {
    this.o88_1 = this.r88_1.p3(this.r88_1.f1() - 1 | 0);
  }
  a6v(uniformBlock) {
    return this.s87_1.a6v(uniformBlock);
  }
  v8i(program) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.t87_1;
      var res = get_0(this_0, program);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.korge.render.RenderContext.get.<anonymous>' call
      var out = new AGProgramWithUniforms(program, this.s87_1);
      set(this_0, program, out);
      tmp$ret$0 = out;
    }
    return tmp$ret$0;
  }
  j8g(program, autoUpload) {
    if (autoUpload) {
      this.m8g();
    }
    return this.v8i(program).o6w();
  }
  d8i(program, autoUpload, $super) {
    autoUpload = autoUpload === VOID ? true : autoUpload;
    return $super === VOID ? this.j8g(program, autoUpload) : $super.j8g.call(this, program, autoUpload);
  }
  m8g() {
    this.s87_1.y6u();
  }
  yz(value) {
    this.k87_1.yz(value);
  }
  zz() {
    return this.k87_1.zz();
  }
  u8g(_set____db54di) {
    this.m87_1.u8g(_set____db54di);
  }
  v8g() {
    return this.m87_1.v8g();
  }
  w8g(_set____db54di) {
    this.m87_1.w8g(_set____db54di);
  }
  x8g() {
    return this.m87_1.x8g();
  }
  y8g(_set____db54di) {
    this.m87_1.y8g(_set____db54di);
  }
  z8g() {
    return this.m87_1.z8g();
  }
  a8h(_set____db54di) {
    this.m87_1.a8h(_set____db54di);
  }
  b8h() {
    return this.m87_1.b8h();
  }
  c8h(_set____db54di) {
    this.m87_1.c8h(_set____db54di);
  }
  d8h() {
    return this.m87_1.d8h();
  }
  e8h() {
    return this.m87_1.e8h();
  }
  f8h(pos) {
    return this.m87_1.f8h(pos);
  }
  f6o() {
    return this.l87_1.f6o();
  }
  g6o() {
    return this.l87_1.g6o();
  }
  h6o() {
    return this.l87_1.h6o();
  }
  w8i() {
    return this.n87_1.w8i();
  }
  x8i() {
    return this.n87_1.x8i();
  }
  y8i() {
    return this.n87_1.y8i();
  }
  h8i() {
    return this.n87_1.h8i();
  }
}
class RenderContext2D {
  constructor(batch, agBitmapTextureManager) {
    this.z8i_1 = new Mixin();
    this.a8j_1 = batch;
    this.b8j_1 = agBitmapTextureManager;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = get_logger_0();
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.x2x(level)) {
      // Inline function 'korlibs.korge.render.RenderContext2D.<anonymous>' call
      var tmp$ret$0 = 'RenderContext2D[0]';
      this_0.y2x(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    this.c8j_1 = Size2D.h2b(0, 0);
    var tmp_0 = this;
    tmp_0.d8j_1 = Pool.x2t(VOID, RenderContext2D$mpool$lambda);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_1 = get_logger_0();
    var level_0 = Level_TRACE_getInstance();
    var tmp_1;
    if (this_1.x2x(level_0)) {
      // Inline function 'korlibs.korge.render.RenderContext2D.<anonymous>' call
      var tmp$ret$2 = 'RenderContext2D[1]';
      this_1.y2x(level_0, tmp$ret$2);
      tmp_1 = Unit_instance;
    }
    this.e8j_1 = Companion_getInstance_7().m2d_1;
    this.f8j_1 = Companion_getInstance_67().q86_1;
    this.g8j_1 = Colors_getInstance().g40_1;
    this.h8j_1 = true;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_2 = get_logger_0();
    var level_1 = Level_TRACE_getInstance();
    var tmp_2;
    if (this_2.x2x(level_1)) {
      // Inline function 'korlibs.korge.render.RenderContext2D.<anonymous>' call
      var tmp$ret$4 = 'RenderContext2D[2]';
      this_2.y2x(level_1, tmp$ret$4);
      tmp_2 = Unit_instance;
    }
  }
  i8j(scissor) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.e8j_1;
      var p = Vector2D.x2c(scissor.r2a(), scissor.t2a());
      if (this_0.p2a()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.k2c(this_0.e2e(p.a2a_1, p.b2a_1), this_0.h2e(p.a2a_1, p.b2a_1));
    }
    var tl = tmp$ret$0;
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_1 = this.e8j_1;
      var p_0 = Vector2D.x2c(scissor.s2a(), scissor.u2a());
      if (this_1.p2a()) {
        tmp$ret$1 = p_0;
        break $l$block_0;
      }
      tmp$ret$1 = Vector2D.k2c(this_1.e2e(p_0.a2a_1, p_0.b2a_1), this_1.h2e(p_0.a2a_1, p_0.b2a_1));
    }
    var br = tmp$ret$1;
    return Companion_getInstance_43().p6y(tl.a2a_1, tl.b2a_1, br.a2a_1, br.b2a_1);
  }
  yz(value) {
    this.z8i_1.yz(value);
  }
  zz() {
    return this.z8i_1.zz();
  }
}
class SDFShaders extends Builder {
  static b8k() {
    SDFShaders_instance = null;
    var $this = this.o75();
    SDFShaders_instance = $this;
    var tmp = $this;
    var tmp_0 = $this.k76();
    var tmp_1 = $this.k76();
    var tmp_2 = $this.k76();
    var tmp_3 = $this.k76();
    tmp.l8j_1 = $this.z75(tmp_0, tmp_1, tmp_2, VOID, tmp_3, SDFShaders$opInterpolate$delegate$lambda).b73($this, opInterpolate$factory());
    var tmp_4 = $this;
    var tmp_5 = $this.k76();
    var tmp_6 = $this.k76();
    var tmp_7 = $this.k76();
    tmp_4.m8j_1 = $this.x75(tmp_5, tmp_6, VOID, tmp_7, SDFShaders$opUnion$delegate$lambda).b73($this, opUnion$factory());
    var tmp_8 = $this;
    var tmp_9 = $this.k76();
    var tmp_10 = $this.k76();
    var tmp_11 = $this.k76();
    tmp_8.n8j_1 = $this.x75(tmp_9, tmp_10, VOID, tmp_11, SDFShaders$opIntersect$delegate$lambda).b73($this, opIntersect$factory());
    var tmp_12 = $this;
    var tmp_13 = $this.k76();
    var tmp_14 = $this.k76();
    var tmp_15 = $this.k76();
    tmp_12.o8j_1 = $this.x75(tmp_13, tmp_14, VOID, tmp_15, SDFShaders$opSubtract$delegate$lambda).b73($this, opSubtract$factory());
    var tmp_16 = $this;
    var tmp_17 = $this.k76();
    var tmp_18 = $this.k76();
    var tmp_19 = $this.k76();
    tmp_16.p8j_1 = $this.x75(tmp_17, tmp_18, VOID, tmp_19, SDFShaders$opRound$delegate$lambda).b73($this, opRound$factory());
    var tmp_20 = $this;
    var tmp_21 = $this.k76();
    var tmp_22 = $this.k76();
    var tmp_23 = $this.k76();
    tmp_20.q8j_1 = $this.x75(tmp_21, tmp_22, VOID, tmp_23, SDFShaders$opBorder$delegate$lambda).b73($this, opBorder$factory());
    var tmp_24 = $this;
    var tmp_25 = $this.k76();
    var tmp_26 = $this.k76();
    var tmp_27 = $this.k76();
    tmp_24.r8j_1 = $this.x75(tmp_25, tmp_26, VOID, tmp_27, SDFShaders$opBorderInner$delegate$lambda).b73($this, opBorderInner$factory());
    var tmp_28 = $this;
    var tmp_29 = $this.k76();
    var tmp_30 = $this.k76();
    tmp_28.s8j_1 = $this.v75(tmp_29, VOID, tmp_30, SDFShaders$opAA$delegate$lambda).b73($this, opAA$factory());
    var tmp_31 = $this;
    var tmp_32 = $this.k76();
    var tmp_33 = $this.k76();
    tmp_31.t8j_1 = $this.v75(tmp_32, VOID, tmp_33, SDFShaders$opAARev$delegate$lambda).b73($this, opAARev$factory());
    var tmp_34 = $this;
    var tmp_35 = $this.k76();
    var tmp_36 = $this.k76();
    var tmp_37 = $this.k76();
    var tmp_38 = $this.k76();
    tmp_34.u8j_1 = $this.z75(tmp_35, tmp_36, tmp_37, VOID, tmp_38, SDFShaders$opSmoothUnion$delegate$lambda).b73($this, opSmoothUnion$factory());
    var tmp_39 = $this;
    var tmp_40 = $this.k76();
    var tmp_41 = $this.k76();
    var tmp_42 = $this.k76();
    var tmp_43 = $this.k76();
    tmp_39.v8j_1 = $this.z75(tmp_40, tmp_41, tmp_42, VOID, tmp_43, SDFShaders$opSmoothSubtraction$delegate$lambda).b73($this, opSmoothSubtraction$factory());
    var tmp_44 = $this;
    var tmp_45 = $this.k76();
    var tmp_46 = $this.k76();
    var tmp_47 = $this.k76();
    var tmp_48 = $this.k76();
    tmp_44.w8j_1 = $this.z75(tmp_45, tmp_46, tmp_47, VOID, tmp_48, SDFShaders$opSmoothIntersection$delegate$lambda).b73($this, opSmoothIntersection$factory());
    var tmp_49 = $this;
    var tmp_50 = $this.b7s();
    var tmp_51 = $this.k76();
    var tmp_52 = $this.k76();
    tmp_49.x8j_1 = $this.x75(tmp_50, tmp_51, VOID, tmp_52, SDFShaders$circle$delegate$lambda).b73($this, circle$factory());
    var tmp_53 = $this;
    var tmp_54 = $this.b7s();
    var tmp_55 = $this.b7s();
    var tmp_56 = $this.c7s();
    var tmp_57 = $this.k76();
    tmp_53.y8j_1 = $this.z75(tmp_54, tmp_55, tmp_56, VOID, tmp_57, SDFShaders$roundedBox$delegate$lambda).b73($this, roundedBox$factory());
    var tmp_58 = $this;
    var tmp_59 = $this.b7s();
    var tmp_60 = $this.b7s();
    var tmp_61 = $this.k76();
    tmp_58.z8j_1 = $this.x75(tmp_59, tmp_60, VOID, tmp_61, SDFShaders$box$delegate$lambda).b73($this, box$factory());
    var tmp_62 = $this;
    var tmp_63 = $this.c7s();
    var tmp_64 = $this.c7s();
    var tmp_65 = $this.c7s();
    tmp_62.a8k_1 = $this.x75(tmp_63, tmp_64, VOID, tmp_65, SDFShaders$opCombinePremultipliedColors$delegate$lambda).b73($this, opCombinePremultipliedColors$factory());
    return $this;
  }
  c8k() {
    return this.l8j_1.mo(this, opInterpolate$factory_0());
  }
  d8k() {
    return this.m8j_1.mo(this, opUnion$factory_0());
  }
  e8k() {
    return this.n8j_1.mo(this, opIntersect$factory_0());
  }
  f8k() {
    return this.o8j_1.mo(this, opSubtract$factory_0());
  }
  g8k() {
    return this.p8j_1.mo(this, opRound$factory_0());
  }
  h8k() {
    return this.q8j_1.mo(this, opBorder$factory_0());
  }
  i8k() {
    return this.r8j_1.mo(this, opBorderInner$factory_0());
  }
  j8k() {
    return this.s8j_1.mo(this, opAA$factory_0());
  }
  k8k() {
    return this.t8j_1.mo(this, opAARev$factory_0());
  }
  l8k() {
    return this.u8j_1.mo(this, opSmoothUnion$factory_0());
  }
  m8k() {
    return this.v8j_1.mo(this, opSmoothSubtraction$factory_0());
  }
  n8k() {
    return this.w8j_1.mo(this, opSmoothIntersection$factory_0());
  }
  o8k() {
    return this.x8j_1.mo(this, circle$factory_0());
  }
  p8k() {
    return this.y8j_1.mo(this, roundedBox$factory_0());
  }
  q8k() {
    return this.z8j_1.mo(this, box$factory_0());
  }
  r8k() {
    return this.a8k_1.mo(this, opCombinePremultipliedColors$factory_0());
  }
}
class TextureBase {
  static s8k(base, size) {
    var $this = createThis(this);
    $this.t8c_1 = base;
    $this.u8c_1 = size;
    $this.v8c_1 = -1;
    return $this;
  }
  f1() {
    return this.u8c_1;
  }
  static w8c(base, width, height) {
    return this.s8k(base, SizeInt.n2k(width, height));
  }
  x8c(width) {
    this.u8c_1 = SizeInt.n2k(width, this.e2m());
  }
  d2m() {
    return this.u8c_1.l2k_1;
  }
  y8c(height) {
    this.u8c_1 = SizeInt.n2k(this.d2m(), height);
  }
  e2m() {
    return this.u8c_1.m2k_1;
  }
  n6() {
    var tmp0_safe_receiver = this.t8c_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.n6();
    }
    this.t8c_1 = null;
  }
  r8d(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) {
    var tmp0_safe_receiver = this.t8c_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.f6u(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel);
  }
  toString() {
    return 'TextureBase(' + toString_1(this.t8c_1) + ')';
  }
}
class Companion_57 {
  constructor() {
    Companion_instance_66 = this;
    this.t8k_1 = new TexturedVertexArray(0, new Int16Array(0));
  }
}
class TexturedVertexArray {
  constructor(vcount, indices, icount) {
    Companion_getInstance_72();
    icount = icount === VOID ? indices.length : icount;
    this.r8f_1 = indices;
    this.s8f_1 = vcount;
    this.t8f_1 = vcount;
    this.u8f_1 = icount;
    this.v8f_1 = allocNoDirect(Companion_instance_4, imul(imul(6, this.s8f_1), 4));
    this.w8f_1 = this.v8f_1;
    this.x8f_1 = 0;
  }
  u8k(fast, pos, x, y, u, v, colMul) {
    setFloat32(fast, pos + 0 | 0, x);
    setFloat32(fast, pos + 1 | 0, y);
    setFloat32(fast, pos + 2 | 0, u);
    setFloat32(fast, pos + 3 | 0, v);
    setInt32(fast, pos + 4 | 0, colMul);
    setInt32(fast, pos + 5 | 0, 0);
    return 6;
  }
  v8k(index, x, y, width, height, matrix, bmp, colMul) {
    this.w8k(index, x, y, width, height, matrix, bmp.l3l(), bmp.m3l(), bmp.n3l(), bmp.o3l(), bmp.r3l(), bmp.s3l(), bmp.p3l(), bmp.q3l(), colMul);
  }
  w8k(index, x, y, width, height, matrix, tl_x, tl_y, tr_x, tr_y, bl_x, bl_y, br_x, br_y, colMul) {
    var xw = x + width;
    var yh = y + height;
    var af = matrix.r2d_1;
    var cf = matrix.t2d_1;
    var txf = matrix.v2d_1;
    var x0 = af * x + cf * y + txf;
    var x1 = af * xw + cf * y + txf;
    var x2 = af * xw + cf * yh + txf;
    var x3 = af * x + cf * yh + txf;
    var df = matrix.u2d_1;
    var bf = matrix.s2d_1;
    var tyf = matrix.w2d_1;
    var y0 = df * y + bf * x + tyf;
    var y1 = df * y + bf * xw + tyf;
    var y2 = df * yh + bf * xw + tyf;
    var y3 = df * yh + bf * x + tyf;
    var fast = this.w8f_1;
    var pos = imul(index, 6);
    var cm = _RGBA___get_value__impl__hhco8v(colMul);
    pos = pos + this.u8k(fast, pos, x0, y0, tl_x, tl_y, cm) | 0;
    pos = pos + this.u8k(fast, pos, x1, y1, tr_x, tr_y, cm) | 0;
    pos = pos + this.u8k(fast, pos, x2, y2, br_x, br_y, cm) | 0;
    pos = pos + this.u8k(fast, pos, x3, y3, bl_x, bl_y, cm) | 0;
  }
}
class ResourcesRoot {
  z8k(path, file) {
    _get_mountable__707cy(this).u32(path, file);
  }
  n6c(injector) {
    var tmp = this;
    // Inline function 'korlibs.io.file.std.MountableVfs' call
    // Inline function 'korlibs.io.file.std.MountableVfsSync' call
    // Inline function 'kotlin.also' call
    var this_0 = new MountableVfs(false);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.std.MountableVfsSync.<anonymous>' call
    // Inline function 'korlibs.io.file.std.MountableVfs.<anonymous>' call
    // Inline function 'korlibs.korge.resources.ResourcesRoot.init.<anonymous>' call
    this.y8k_1 = this_0;
    tmp.x8k_1 = this_0.e28();
    this.z8k('/', get_resourcesVfs());
  }
  toString() {
    return 'ResourcesRoot[' + _get_root__dd8asp(this).toString() + ']';
  }
}
class RCollection {
  constructor() {
    this.a8l_1 = ArrayList.j1();
    this.b8l_1 = LinkedHashMap.oc();
  }
}
class Stats {
  constructor() {
    this.c8l_1 = new RCollection();
    this.d8l_1 = new RCollection();
  }
  c6o() {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.c8l_1.a8l_1;
    var n = 0;
    while (n < this_0.f1()) {
      // Inline function 'korlibs.korge.stat.Stats.startFrame.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.e1(_unary__edvuaz).c6o();
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.d8l_1.a8l_1;
    var n_0 = 0;
    while (n_0 < this_1.f1()) {
      // Inline function 'korlibs.korge.stat.Stats.startFrame.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      this_1.e1(_unary__edvuaz_0).c6o();
    }
  }
}
class V2 {
  constructor(key, initial, end, interpolator, includeStart, fastStartTime, fastDuration, initialization) {
    fastStartTime = fastStartTime === VOID ? Companion_instance_3.x1x() : fastStartTime;
    fastDuration = fastDuration === VOID ? Companion_instance_3.y1x() : fastDuration;
    initialization = initialization === VOID ? null : initialization;
    this.l8l_1 = key;
    this.m8l_1 = initial;
    this.n8l_1 = end;
    this.o8l_1 = interpolator;
    this.p8l_1 = includeStart;
    this.q8l_1 = fastStartTime;
    this.r8l_1 = fastDuration;
    this.s8l_1 = initialization;
    this.t8l_1 = FastDuration__plus_impl_q1enab(this.q8l_1, equals(this.r8l_1, Companion_instance_3.y1x()) ? get_fastNanoseconds_0(0) : this.r8l_1);
  }
  u8l() {
    return toDuration_1(this.q8l_1);
  }
  v8l() {
    return toDuration_1(this.r8l_1);
  }
  c3a() {
    if (!this.p8l_1) {
      this.m8l_1 = this.l8l_1.get();
    }
    var tmp0_safe_receiver = this.s8l_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver();
  }
  w8l(ratio) {
    this.l8l_1.set(this.o8l_1(new Ratio(ratio), this.m8l_1, this.n8l_1));
  }
  toString() {
    return 'V2(key=' + this.l8l_1.callableName + ', range=[' + toString_1(this.m8l_1) + '-' + toString_1(this.n8l_1) + '], startTime=' + Duration__toString_impl_8d916b(this.u8l()) + ', duration=' + Duration__toString_impl_8d916b(this.v8l()) + ')';
  }
  hashCode() {
    var result = hashCode(this.l8l_1);
    result = imul(result, 31) + (this.m8l_1 == null ? 0 : hashCode(this.m8l_1)) | 0;
    result = imul(result, 31) + (this.n8l_1 == null ? 0 : hashCode(this.n8l_1)) | 0;
    result = imul(result, 31) + hashCode(this.o8l_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p8l_1) | 0;
    result = imul(result, 31) + FastDuration__hashCode_impl_y13la6(this.q8l_1) | 0;
    result = imul(result, 31) + FastDuration__hashCode_impl_y13la6(this.r8l_1) | 0;
    result = imul(result, 31) + (this.s8l_1 == null ? 0 : hashCode(this.s8l_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof V2))
      return false;
    var tmp0_other_with_cast = other instanceof V2 ? other : THROW_CCE();
    if (!equals(this.l8l_1, tmp0_other_with_cast.l8l_1))
      return false;
    if (!equals(this.m8l_1, tmp0_other_with_cast.m8l_1))
      return false;
    if (!equals(this.n8l_1, tmp0_other_with_cast.n8l_1))
      return false;
    if (!equals(this.o8l_1, tmp0_other_with_cast.o8l_1))
      return false;
    if (!(this.p8l_1 === tmp0_other_with_cast.p8l_1))
      return false;
    if (!equals(this.q8l_1, tmp0_other_with_cast.q8l_1))
      return false;
    if (!equals(this.r8l_1, tmp0_other_with_cast.r8l_1))
      return false;
    if (!equals(this.s8l_1, tmp0_other_with_cast.s8l_1))
      return false;
    return true;
  }
}
class DEFAULT {}
class Impl {
  constructor(quality) {
    quality = quality === VOID ? Quality_AUTOMATIC_getInstance() : quality;
    this.x8l_1 = quality;
  }
  e8i() {
    return this.x8l_1;
  }
}
class Companion_58 {
  constructor() {
    Companion_instance_67 = this;
    this.y8l_1 = mapOf([to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 0)), Cursor_RESIZE_EAST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 1)), Cursor_RESIZE_SOUTH_EAST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 2)), Cursor_RESIZE_SOUTH_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 3)), Cursor_RESIZE_SOUTH_WEST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 4)), Cursor_RESIZE_WEST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 5)), Cursor_RESIZE_NORTH_WEST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 6)), Cursor_RESIZE_NORTH_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 7)), Cursor_RESIZE_NORTH_EAST_getInstance())]);
  }
}
class Cursor extends Enum {}
class MenuItem {
  constructor(text, enabled, children, action) {
    enabled = enabled === VOID ? true : enabled;
    children = children === VOID ? null : children;
    var tmp;
    if (action === VOID) {
      tmp = GameWindow$MenuItem$_init_$lambda_465oqx;
    } else {
      tmp = action;
    }
    action = tmp;
    this.b8m_1 = text;
    this.c8m_1 = enabled;
    this.d8m_1 = children;
    this.e8m_1 = action;
  }
  toString() {
    return 'MenuItem(text=' + this.b8m_1 + ', enabled=' + this.c8m_1 + ', children=' + toString_1(this.d8m_1) + ', action=' + toString(this.e8m_1) + ')';
  }
  hashCode() {
    var result = this.b8m_1 == null ? 0 : getStringHashCode(this.b8m_1);
    result = imul(result, 31) + getBooleanHashCode(this.c8m_1) | 0;
    result = imul(result, 31) + (this.d8m_1 == null ? 0 : hashCode(this.d8m_1)) | 0;
    result = imul(result, 31) + hashCode(this.e8m_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MenuItem))
      return false;
    var tmp0_other_with_cast = other instanceof MenuItem ? other : THROW_CCE();
    if (!(this.b8m_1 == tmp0_other_with_cast.b8m_1))
      return false;
    if (!(this.c8m_1 === tmp0_other_with_cast.c8m_1))
      return false;
    if (!equals(this.d8m_1, tmp0_other_with_cast.d8m_1))
      return false;
    if (!equals(this.e8m_1, tmp0_other_with_cast.e8m_1))
      return false;
    return true;
  }
}
class CoroutineKey {
  constructor() {
    CoroutineKey_instance = this;
    this.f8m_1 = 60;
    this.g8m_1 = Companion_getInstance_1().ey('GameWindow');
    this.h8m_1 = new MenuItem(null);
  }
}
class Quality extends Enum {
  constructor(name, ordinal, level) {
    super(name, ordinal);
    this.v8o_1 = level;
    this.w8o_1 = 4000000;
  }
  v2x() {
    return this.v8o_1;
  }
  x8o(width, height, devicePixelRatio, targetPixels) {
    var tmp;
    switch (this.r3_1) {
      case 0:
        tmp = 1.0;
        break;
      case 1:
        tmp = devicePixelRatio;
        break;
      case 2:
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var tmp0_iterator = listOf_0([devicePixelRatio, 2.0, 1.0]).b1();
          while (tmp0_iterator.c1()) {
            var element = tmp0_iterator.d1();
            // Inline function 'korlibs.render.Quality.computeTargetScale.<anonymous>' call
            if (imul(width, height) * element <= targetPixels) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }

        var tmp1_elvis_lhs = tmp$ret$1;
        tmp = tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  y8o(width, height, devicePixelRatio, targetPixels, $super) {
    targetPixels = targetPixels === VOID ? this.w8o_1 : targetPixels;
    return $super === VOID ? this.x8o(width, height, devicePixelRatio, targetPixels) : $super.x8o.call(this, width, height, devicePixelRatio, targetPixels);
  }
}
class GameWindow$loop$slambda {
  constructor($entry, this$0) {
    this.z8l_1 = $entry;
    this.a8m_1 = this$0;
  }
  ce($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
  }
}
class _no_name_provided__qut3iv extends ObservableProperty {
  constructor($initialValue, this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.f8p_1 = this$0;
    super($initialValue, $box);
  }
  g8p(property, oldValue, newValue) {
    var tmp0_safe_receiver = this.f8p_1.z8n_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(newValue);
    return Unit_instance;
  }
  lo(property, oldValue, newValue) {
    var tmp = (oldValue == null ? true : !(oldValue == null)) ? oldValue : THROW_CCE();
    return this.g8p(property, tmp, (newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  }
}
class GameWindow extends BaseEventListener {
  static h8p() {
    CoroutineKey_getInstance();
    var $this = this.v6e();
    $this.m8m_1 = new Mixin();
    $this.n8m_1 = Cursor_DEFAULT_getInstance();
    $this.o8m_1 = false;
    $this.p8m_1 = AGDummy.c7h();
    $this.q8m_1 = SyncEventLoopCoroutineDispatcher.k8p();
    $this.r8m_1 = GameWindowCoroutineDispatcher.v8p();
    $this.s8m_1 = new PauseEvent();
    $this.t8m_1 = new ResumeEvent();
    $this.u8m_1 = new StopEvent();
    $this.v8m_1 = new DestroyEvent();
    $this.w8m_1 = new UpdateEvent();
    $this.x8m_1 = new RenderEvent();
    $this.y8m_1 = new InitEvent();
    $this.z8m_1 = new DisposeEvent();
    $this.a8n_1 = new FullScreenEvent();
    $this.b8n_1 = new ReshapeEvent();
    $this.c8n_1 = new KeyEvent();
    $this.d8n_1 = new MouseEvent();
    $this.e8n_1 = new GestureEvent();
    $this.f8n_1 = new DropFileEvent();
    var tmp = $this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp_0 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
    tmp.g8n_1 = new IntTimedCache(tmp_0, VOID, GameWindow$fpsCached$delegate$lambda($this));
    $this.h8n_1 = 60;
    $this.i8n_1 = 0;
    $this.j8n_1 = 0;
    $this.k8n_1 = true;
    $this.l8n_1 = null;
    $this.m8n_1 = false;
    $this.n8n_1 = false;
    $this.o8n_1 = Colors_getInstance().h40_1;
    $this.p8n_1 = new Signal();
    $this.q8n_1 = new Signal();
    $this.r8n_1 = null;
    $this.s8n_1 = false;
    $this.t8n_1 = true;
    $this.u8n_1 = 0;
    $this.v8n_1 = true;
    $this.w8n_1 = false;
    var tmp_1 = $this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_1.x8n_1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
    var tmp_2 = $this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_2.y8n_1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
    $this.z8n_1 = null;
    var tmp_3 = $this;
    // Inline function 'kotlin.properties.Delegates.observable' call
    tmp_3.a8o_1 = new _no_name_provided__qut3iv(true, $this);
    $this.b8o_1 = false;
    $this.c8o_1 = -1;
    $this.d8o_1 = -1;
    $this.e8o_1 = -1;
    $this.f8o_1 = -1;
    $this.g8o_1 = false;
    $this.h8o_1 = false;
    $this.i8o_1 = false;
    $this.j8o_1 = 0;
    $this.k8o_1 = Companion_instance_3.x1x();
    $this.l8o_1 = new Lock();
    $this.m8o_1 = booleanArray(Companion_getInstance_34().z6l_1);
    $this.n8o_1 = 0;
    $this.o8o_1 = 0.0;
    $this.p8o_1 = 0.0;
    $this.q8o_1 = 0.0;
    $this.r8o_1 = false;
    $this.s8o_1 = new GamepadInfoEmitter($this);
    return $this;
  }
  w8p(_set____db54di) {
    this.n8m_1 = _set____db54di;
  }
  x8p() {
    return this.n8m_1;
  }
  r1() {
    return CoroutineKey_getInstance();
  }
  y8p() {
    return this.p8m_1;
  }
  z8p() {
    return this.r8m_1;
  }
  a8q(coroutineContext) {
    return coroutineContext.cn(this.z8p());
  }
  z8o($completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.zc();
    return this.a8q(tmp$ret$0);
  }
  b8q(block) {
    return this.x6e(Companion_getInstance_18(), block);
  }
  b8p() {
    return get_fastMicroseconds(1000000.0 / this.c8q());
  }
  d8q() {
    // Inline function 'korlibs.time.microseconds' call
    var this_0 = 1000000.0 / this.c8q();
    return toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
  }
  d8p() {
    return 60;
  }
  e8q(name, time) {
  }
  c8q() {
    return _get_fpsCached__581dty(this);
  }
  f8q(value) {
    return Unit_instance;
  }
  d2m() {
    return this.i8n_1;
  }
  e2m() {
    return this.j8n_1;
  }
  g8q(_set____db54di) {
    this.l8n_1 = _set____db54di;
  }
  h8q(_set____db54di) {
    this.m8n_1 = _set____db54di;
  }
  i8q(_set____db54di) {
    this.n8n_1 = _set____db54di;
  }
  j8q(_set____db54di) {
    this.o8n_1 = _set____db54di;
  }
  k8q() {
    return this.o8n_1;
  }
  l8q(value) {
    return Unit_instance;
  }
  e8i() {
    return Quality_AUTOMATIC_getInstance();
  }
  m8q(value) {
    this.s8n_1 = value;
    this.q8n_1.x20(value);
    if (value) {
      invoke(this.p8n_1);
    }
  }
  n8q() {
    return this.s8n_1;
  }
  o8q(width, height) {
    return Unit_instance;
  }
  p8q(exitCode) {
    return this.k1f(exitCode);
  }
  q8q(exitCode, $super) {
    exitCode = exitCode === VOID ? 0 : exitCode;
    var tmp;
    if ($super === VOID) {
      this.p8q(exitCode);
      tmp = Unit_instance;
    } else {
      tmp = $super.p8q.call(this, exitCode);
    }
    return tmp;
  }
  k1f(exitCode) {
    if (this.w8n_1)
      return Unit_instance;
    this.w8n_1 = true;
    this.v8n_1 = false;
    this.u8n_1 = exitCode;
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = CoroutineKey_getInstance().g8m_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.x2x(level)) {
      // Inline function 'korlibs.render.GameWindow.close.<anonymous>' call
      var tmp$ret$0 = 'GameWindow.close';
      this_0.y2x(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    this.z8p().n6();
    cancelChildren(this.z8p());
  }
  r8q(exitCode, $super) {
    exitCode = exitCode === VOID ? 0 : exitCode;
    var tmp;
    if ($super === VOID) {
      this.k1f(exitCode);
      tmp = Unit_instance;
    } else {
      tmp = $super.k1f.call(this, exitCode);
    }
    return tmp;
  }
  s8q($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_waitClose__fhnm35.bind(VOID, this), $completion);
  }
  t8q(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loop__qll5p8.bind(VOID, this, entry), $completion);
  }
  c8p(time, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loopDelay__vgtnit.bind(VOID, this, time), $completion);
  }
  u8q(_set____db54di) {
    return this.a8o_1.po(this, continuousRenderMode$factory(), _set____db54di);
  }
  v8q() {
    return this.a8o_1.no(this, continuousRenderMode$factory_0());
  }
  w8q(doUpdate, doRender, frameStartTime) {
    var startTime = PerformanceCounter_getInstance().x6c();
    if (doRender) {
      var tmp = this;
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      var mark = Monotonic_instance.kj();
      // Inline function 'korlibs.render.GameWindow.frame.<anonymous>' call
      this.x8q(doUpdate, true);
      tmp.x8n_1 = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
    }
    if (doUpdate) {
      var tmp_0 = this;
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      var mark_0 = Monotonic_instance.kj();
      // Inline function 'korlibs.render.GameWindow.frame.<anonymous>' call
      if (!doRender) {
        this.x8q(true, false);
      }
      this.y8q(frameStartTime);
      tmp_0.y8n_1 = ValueTimeMark__elapsedNow_impl_eonqvs(mark_0);
    }
    var endTime = PerformanceCounter_getInstance().y6c();
    return FastDuration__minus_impl_evs237_0(endTime, startTime);
  }
  a8p(doUpdate, doRender, frameStartTime, $super) {
    doUpdate = doUpdate === VOID ? true : doUpdate;
    doRender = doRender === VOID ? true : doRender;
    frameStartTime = frameStartTime === VOID ? PerformanceCounter_getInstance().y6c() : frameStartTime;
    return $super === VOID ? this.w8q(doUpdate, doRender, frameStartTime) : $super.w8q.call(this, doUpdate, doRender, new FastDuration(frameStartTime)).a1y_1;
  }
  x8q(doUpdate, doRender) {
    if (doRender) {
      if (this.i8o_1) {
        this.i8o_1 = false;
        this.y8p().z6n();
      }
      if (this.b8o_1) {
        this.b8o_1 = false;
        this.y8p().y6n().r6s(this.c8o_1, this.d8o_1, this.e8o_1, this.f8o_1);
        this.z8q(this.c8o_1, this.d8o_1, this.e8o_1, this.f8o_1);
      }
    }
    if (this.g8o_1) {
      this.g8o_1 = false;
      println('---------------- Trigger AG.initialized ag.mainFrameBuffer.setSize (' + this.d2m() + ', ' + this.e2m() + ') --------------');
      // Inline function 'korlibs.event.reset' call
      var this_0 = this.y8m_1;
      this_0.q6f_1 = false;
      // Inline function 'korlibs.event.reset.<anonymous>' call
      this.i6f(this_0);
    }
    try {
      this.a8r(doUpdate, doRender);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        println('ERROR GameWindow.frameRender:');
        println(e);
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
  }
  c6o() {
    this.j8o_1 = 0;
  }
  b8r() {
    this.j8o_1 = this.j8o_1 + 1 | 0;
  }
  y8q(startTime) {
    var tmp = this;
    // Inline function 'korlibs.time.fastMeasureTime' call
    var stopwatch = new Stopwatch();
    // Inline function 'korlibs.render.GameWindow.frameUpdate.<anonymous>' call
    this.c8r();
    tmp.k8o_1 = stopwatch.d6d();
    try {
      var now = PerformanceCounter_getInstance().x6c();
      var consumed = minus(now, startTime);
      var tmp0_elvis_lhs = this.z8p().t8p_1;
      var tmp_0;
      var tmp_1 = tmp0_elvis_lhs;
      if ((tmp_1 == null ? null : new Duration(tmp_1)) == null) {
        tmp_0 = Duration__times_impl_sfuzvp(this.d8q(), 10);
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var timeForTasks = tmp_0;
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$2 = toDuration(4, DurationUnit_MILLISECONDS_getInstance());
      var finalTimeForTasks = max(timeForTasks, tmp$ret$2);
      this.z8p().d8r(finalTimeForTasks);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        println('ERROR GameWindow.frameRender:');
        println(e);
      } else {
        throw $p;
      }
    }
  }
  c8r() {
  }
  a8r(update, render) {
    // Inline function 'korlibs.render.GameWindow.updateRenderLock' call
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = this.l8o_1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.i1y();
      try {
        // Inline function 'korlibs.event.reset' call
        var this_1 = this.x8m_1;
        this_1.q6f_1 = false;
        // Inline function 'korlibs.render.GameWindow.dispatchRenderEvent.<anonymous>.<anonymous>' call
        this_1.y6f_1 = update;
        this_1.z6f_1 = render;
        this.i6f(this_1);
        break $l$block;
      }finally {
        this_0.k1y();
      }
    }
  }
  e8r(type, files) {
    // Inline function 'korlibs.event.reset' call
    var this_0 = this.f8n_1;
    this_0.q6f_1 = false;
    // Inline function 'korlibs.render.GameWindow.dispatchDropfileEvent.<anonymous>' call
    this_0.m6i_1 = type;
    this_0.n6i_1 = files;
    return this.i6f(this_0);
  }
  z8q(x, y, width, height) {
    this.f8r(x, y, width, height, width, height);
  }
  f8r(x, y, width, height, fullWidth, fullHeight) {
    this.y8p().y6n().s6s(x, y, width, height, fullWidth, fullHeight);
    // Inline function 'korlibs.event.reset' call
    var this_0 = this.b8n_1;
    this_0.q6f_1 = false;
    // Inline function 'korlibs.render.GameWindow.dispatchReshapeEventEx.<anonymous>' call
    this_0.h6g_1 = x;
    this_0.i6g_1 = y;
    this_0.j6g_1 = width;
    this_0.k6g_1 = height;
    this.i6f(this_0);
  }
  q6k() {
    this.s8o_1.q6k();
  }
  c6l(info) {
    this.s8o_1.c6l(info);
  }
  e6l(out) {
    return this.s8o_1.e6l(out);
  }
  g8r(out, $super) {
    out = out === VOID ? IntArrayList.m2o() : out;
    return $super === VOID ? this.e6l(out) : $super.e6l.call(this, out);
  }
  yz(_set____db54di) {
    this.m8m_1.yz(_set____db54di);
  }
  zz() {
    return this.m8m_1.zz();
  }
}
class Companion_59 {
  constructor() {
    Companion_instance_68 = this;
    this.h8r_1 = new GameWindowCreationConfig();
  }
}
class GameWindowCreationConfig {
  constructor(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title) {
    Companion_getInstance_74();
    multithreaded = multithreaded === VOID ? null : multithreaded;
    hdr = hdr === VOID ? null : hdr;
    msaa = msaa === VOID ? null : msaa;
    checkGl = checkGl === VOID ? false : checkGl;
    logGl = logGl === VOID ? false : logGl;
    cacheGl = cacheGl === VOID ? false : cacheGl;
    fullscreen = fullscreen === VOID ? null : fullscreen;
    decorated = decorated === VOID ? true : decorated;
    transparent = transparent === VOID ? false : transparent;
    resizable = resizable === VOID ? true : resizable;
    title = title === VOID ? '' : title;
    this.i8r_1 = multithreaded;
    this.j8r_1 = hdr;
    this.k8r_1 = msaa;
    this.l8r_1 = checkGl;
    this.m8r_1 = logGl;
    this.n8r_1 = cacheGl;
    this.o8r_1 = fullscreen;
    this.p8r_1 = decorated;
    this.q8r_1 = transparent;
    this.r8r_1 = resizable;
    this.s8r_1 = title;
  }
  t8r(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title) {
    return new GameWindowCreationConfig(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title);
  }
  u8r(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title, $super) {
    multithreaded = multithreaded === VOID ? this.i8r_1 : multithreaded;
    hdr = hdr === VOID ? this.j8r_1 : hdr;
    msaa = msaa === VOID ? this.k8r_1 : msaa;
    checkGl = checkGl === VOID ? this.l8r_1 : checkGl;
    logGl = logGl === VOID ? this.m8r_1 : logGl;
    cacheGl = cacheGl === VOID ? this.n8r_1 : cacheGl;
    fullscreen = fullscreen === VOID ? this.o8r_1 : fullscreen;
    decorated = decorated === VOID ? this.p8r_1 : decorated;
    transparent = transparent === VOID ? this.q8r_1 : transparent;
    resizable = resizable === VOID ? this.r8r_1 : resizable;
    title = title === VOID ? this.s8r_1 : title;
    return $super === VOID ? this.t8r(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title) : $super.t8r.call(this, multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title);
  }
  toString() {
    return 'GameWindowCreationConfig(multithreaded=' + this.i8r_1 + ', hdr=' + this.j8r_1 + ', msaa=' + this.k8r_1 + ', checkGl=' + this.l8r_1 + ', logGl=' + this.m8r_1 + ', cacheGl=' + this.n8r_1 + ', fullscreen=' + this.o8r_1 + ', decorated=' + this.p8r_1 + ', transparent=' + this.q8r_1 + ', resizable=' + this.r8r_1 + ', title=' + this.s8r_1 + ')';
  }
  hashCode() {
    var result = this.i8r_1 == null ? 0 : getBooleanHashCode(this.i8r_1);
    result = imul(result, 31) + (this.j8r_1 == null ? 0 : getBooleanHashCode(this.j8r_1)) | 0;
    result = imul(result, 31) + (this.k8r_1 == null ? 0 : this.k8r_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l8r_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.m8r_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.n8r_1) | 0;
    result = imul(result, 31) + (this.o8r_1 == null ? 0 : getBooleanHashCode(this.o8r_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p8r_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.q8r_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.r8r_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s8r_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameWindowCreationConfig))
      return false;
    var tmp0_other_with_cast = other instanceof GameWindowCreationConfig ? other : THROW_CCE();
    if (!(this.i8r_1 == tmp0_other_with_cast.i8r_1))
      return false;
    if (!(this.j8r_1 == tmp0_other_with_cast.j8r_1))
      return false;
    if (!(this.k8r_1 == tmp0_other_with_cast.k8r_1))
      return false;
    if (!(this.l8r_1 === tmp0_other_with_cast.l8r_1))
      return false;
    if (!(this.m8r_1 === tmp0_other_with_cast.m8r_1))
      return false;
    if (!(this.n8r_1 === tmp0_other_with_cast.n8r_1))
      return false;
    if (!(this.o8r_1 == tmp0_other_with_cast.o8r_1))
      return false;
    if (!(this.p8r_1 === tmp0_other_with_cast.p8r_1))
      return false;
    if (!(this.q8r_1 === tmp0_other_with_cast.q8r_1))
      return false;
    if (!(this.r8r_1 === tmp0_other_with_cast.r8r_1))
      return false;
    if (!(this.s8r_1 === tmp0_other_with_cast.s8r_1))
      return false;
    return true;
  }
}
class TimedTask_0 {
  constructor(time, continuation, callback) {
    this.v8r_1 = time;
    this.w8r_1 = continuation;
    this.x8r_1 = callback;
    this.y8r_1 = null;
  }
}
class Companion_60 {
  constructor() {
    Companion_instance_69 = this;
    this.z8r_1 = Companion_getInstance_1().ey('GameWindow');
  }
}
class sam$kotlinx_coroutines_DisposableHandle$0_0 {
  constructor(function_0) {
    this.a8s_1 = function_0;
  }
  m1a() {
    return this.a8s_1();
  }
  o4() {
    return this.a8s_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DisposableHandle) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.o4(), other.o4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.o4());
  }
}
class GameWindowCoroutineDispatcher extends CoroutineDispatcher {
  static v8p(nowProvider, fast) {
    Companion_getInstance_75();
    var tmp;
    if (nowProvider === VOID) {
      tmp = GameWindowCoroutineDispatcher$_init_$lambda_ooms1e;
    } else {
      tmp = nowProvider;
    }
    nowProvider = tmp;
    fast = fast === VOID ? false : fast;
    var $this = this.p1d();
    $this.m8p_1 = nowProvider;
    $this.n8p_1 = fast;
    $this.o8p_1 = new TGenQueue();
    var tmp_0 = $this;
    var tmp_1 = Companion_instance_0;
    tmp_0.p8p_1 = tmp_1.t2u(VOID, GameWindowCoroutineDispatcher$timedTasks$lambda);
    $this.q8p_1 = new NonRecursiveLock();
    $this.r8p_1 = get_fastMilliseconds_0(0);
    $this.s8p_1 = get_fastMilliseconds_0(0);
    $this.t8p_1 = null;
    $this.u8p_1 = Companion_getInstance_1().ey('Korgw.GameWindow.TooManyCallbacks');
    return $this;
  }
  s1d(context, block) {
    return this.r1d(context, block);
  }
  b8s(block) {
    if (block == null)
      return Unit_instance;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.q8p_1.d1y_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    this.o8p_1.d2v(block);
  }
  r1d(context, block) {
    return this.b8s(block);
  }
  c8s() {
    return this.m8p_1().a1y_1;
  }
  d1e(timeMillis, continuation) {
    // Inline function 'korlibs.time.milliseconds' call
    var this_0 = timeMillis.n4();
    var tmp$ret$0 = toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
    this.d8s(tmp$ret$0, continuation);
  }
  d8s(time, continuation) {
    var task = new TimedTask_0(FastDuration__plus_impl_q1enab_0(this.c8s(), time), continuation, null);
    continuation.a1a(GameWindowCoroutineDispatcher$scheduleResumeAfterDelay$lambda(task));
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.q8p_1.d1y_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.scheduleResumeAfterDelay.<anonymous>' call
    this.p8p_1.o2q(task);
  }
  e1e(timeMillis, block, context) {
    var tmp = this.c8s();
    // Inline function 'korlibs.time.milliseconds' call
    var this_0 = timeMillis.n4();
    var tmp$ret$0 = toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
    var task = new TimedTask_0(FastDuration__plus_impl_q1enab_0(tmp, tmp$ret$0), null, block);
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.q8p_1.d1y_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.invokeOnTimeout.<anonymous>' call
    this.p8p_1.o2q(task);
    var tmp_0 = GameWindowCoroutineDispatcher$invokeOnTimeout$lambda(this, task);
    return new sam$kotlinx_coroutines_DisposableHandle$0_0(tmp_0);
  }
  d8r(availableTime) {
    this.e8s(get_fast(availableTime));
  }
  e8s(availableTime) {
    try {
      var startTime = this.c8s();
      var processedTimedTasks = 0;
      var processedTasks = 0;
      var tmp = this;
      // Inline function 'korlibs.time.fastMeasureTime' call
      var stopwatch = new Stopwatch();
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>' call
      $l$loop_0: while (true) {
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
        // Inline function 'kotlinx.atomicfu.locks.synchronized' call
        this.q8p_1.d1y_1;
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
        // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>.<anonymous>' call
        var tmp_0;
        var tmp_1;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.p8p_1.h1()) {
          tmp_1 = this.n8p_1 || FastDuration__compareTo_impl_4fhnj7(startTime, this.p8p_1.z2u().v8r_1) >= 0;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = this.p8p_1.a2v();
        } else {
          tmp_0 = null;
        }
        var tmp0_elvis_lhs = tmp_0;
        var tmp_2;
        if (tmp0_elvis_lhs == null) {
          break $l$loop_0;
        } else {
          tmp_2 = tmp0_elvis_lhs;
        }
        var item = tmp_2;
        try {
          if (!(item.y8r_1 == null)) {
            var tmp1_safe_receiver = item.w8r_1;
            if (tmp1_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.coroutines.resumeWithException' call
              // Inline function 'kotlin.Companion.failure' call
              var exception = ensureNotNull(item.y8r_1);
              var tmp$ret$5 = _Result___init__impl__xyqfz8(createFailure(exception));
              tmp1_safe_receiver.bd(tmp$ret$5);
            }
            if (!(item.x8r_1 == null)) {
              var tmp2_safe_receiver = item.y8r_1;
              if (tmp2_safe_receiver == null)
                null;
              else {
                printStackTrace(tmp2_safe_receiver);
              }
            }
          } else {
            var tmp3_safe_receiver = item.w8r_1;
            if (tmp3_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.coroutines.resume' call
              // Inline function 'kotlin.Companion.success' call
              var tmp$ret$7 = _Result___init__impl__xyqfz8(Unit_instance);
              tmp3_safe_receiver.bd(tmp$ret$7);
            }
            var tmp4_safe_receiver = item.x8r_1;
            if (tmp4_safe_receiver == null)
              null;
            else {
              tmp4_safe_receiver.n1c();
            }
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            printStackTrace(e);
          } else {
            throw $p;
          }
        }
        finally {
          processedTimedTasks = processedTimedTasks + 1 | 0;
        }
        var elapsedTime = FastDuration__minus_impl_evs237(this.c8s(), startTime);
        if (FastDuration__compareTo_impl_4fhnj7(elapsedTime, availableTime) >= 0) {
          this.f8s(elapsedTime, availableTime, processedTimedTasks, processedTasks);
          break $l$loop_0;
        }
      }
      tmp.r8p_1 = stopwatch.d6d();
      var tmp_3 = this;
      // Inline function 'korlibs.time.fastMeasureTime' call
      var stopwatch_0 = new Stopwatch();
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>' call
      $l$loop_2: while (true) {
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
        // Inline function 'kotlinx.atomicfu.locks.synchronized' call
        this.q8p_1.d1y_1;
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
        // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>.<anonymous>' call
        var tmp_4;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.o8p_1.h1()) {
          tmp_4 = this.o8p_1.e2v();
        } else {
          tmp_4 = null;
        }
        var tmp0_elvis_lhs_0 = tmp_4;
        var tmp_5;
        if (tmp0_elvis_lhs_0 == null) {
          break $l$loop_2;
        } else {
          tmp_5 = tmp0_elvis_lhs_0;
        }
        var task = tmp_5;
        // Inline function 'korlibs.time.fastMeasureTime' call
        var stopwatch_1 = new Stopwatch();
        // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>.<anonymous>' call
        try {
          task.n1c();
        } catch ($p) {
          if ($p instanceof Error) {
            var e_0 = $p;
            printStackTrace(e_0);
          } else {
            throw $p;
          }
        }
        finally {
          processedTasks = processedTasks + 1 | 0;
        }
        var time = stopwatch_1.d6d();
        var elapsed = FastDuration__minus_impl_evs237(this.c8s(), startTime);
        if (FastDuration__compareTo_impl_4fhnj7(elapsed, availableTime) >= 0) {
          this.f8s(elapsed, availableTime, processedTimedTasks, processedTasks);
          break $l$loop_2;
        }
      }
      tmp_3.s8p_1 = stopwatch_0.d6d();
    } catch ($p) {
      if ($p instanceof Error) {
        var e_1 = $p;
        println('Error in GameWindowCoroutineDispatcher.executePending:');
        printStackTrace(e_1);
      } else {
        throw $p;
      }
    }
  }
  f8s(elapsedTime, availableTime, processedTimedTasks, processedTasks) {
    // Inline function 'korlibs.logger.Logger.warn' call
    var this_0 = this.u8p_1;
    var level = Level_WARN_getInstance();
    var tmp;
    if (this_0.x2x(level)) {
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.informTooManyCallbacksToHandleInThisFrame.<anonymous>' call
      var tmp$ret$0 = 'Too many callbacks to handle in this frame elapsedTime=' + FastDuration__toString_impl_c9xohb(roundMilliseconds(elapsedTime)) + ', availableTime=' + FastDuration__toString_impl_c9xohb(roundMilliseconds(availableTime)) + ' pending timedTasks=' + this.p8p_1.w2u_1 + ', tasks=' + this.o8p_1.f1() + ', processedTimedTasks=' + processedTimedTasks + ', processedTasks=' + processedTasks;
      this_0.y2x(level, tmp$ret$0);
      tmp = Unit_instance;
    }
  }
  n6() {
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$1 = toDuration(2, DurationUnit_SECONDS_getInstance());
    this.d8r(tmp$ret$1);
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = Companion_getInstance_75().z8r_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.x2x(level)) {
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.close.<anonymous>' call
      var tmp$ret$2 = 'GameWindowCoroutineDispatcher.close';
      this_0.y2x(level, tmp$ret$2);
      tmp = Unit_instance;
    }
    $l$loop: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!this.p8p_1.h1()) {
        break $l$loop;
      }
      var tmp0_safe_receiver = this.p8p_1.a2v().w8r_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$5 = _Result___init__impl__xyqfz8(Unit_instance);
        tmp0_safe_receiver.bd(tmp$ret$5);
      }
    }
    $l$loop_0: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!this.o8p_1.h1()) {
        break $l$loop_0;
      }
      this.o8p_1.e2v().n1c();
    }
  }
  toString() {
    return 'GameWindowCoroutineDispatcher(setNow=setNow, fast=' + this.n8p_1 + ')';
  }
}
class SyncEventLoopCoroutineDispatcher extends CoroutineDispatcher {
  static g8s(eventLoop) {
    var $this = this.p1d();
    $this.j8p_1 = eventLoop;
    return $this;
  }
  static k8p(immediateRun) {
    immediateRun = immediateRun === VOID ? false : immediateRun;
    return this.g8s(new SyncEventLoop(immediateRun));
  }
  n6() {
    this.j8p_1.n6();
  }
  r1d(context, block) {
    this.j8p_1.d6e(SyncEventLoopCoroutineDispatcher$dispatch$lambda(block));
  }
  d1e(timeMillis, continuation) {
    var cancelled = {_v: null};
    continuation.a1a(SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda(cancelled));
    // Inline function 'korlibs.time.milliseconds' call
    var tmp = toDuration_0(timeMillis, DurationUnit_MILLISECONDS_getInstance());
    this.j8p_1.e6e(tmp, SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda_0(cancelled, continuation));
  }
  e1e(timeMillis, block, context) {
    // Inline function 'korlibs.time.milliseconds' call
    var tmp = toDuration_0(timeMillis, DurationUnit_MILLISECONDS_getInstance());
    return toDisposable(this.j8p_1.e6e(tmp, SyncEventLoopCoroutineDispatcher$invokeOnTimeout$lambda(block)));
  }
}
class Companion_61 {}
class UpdateEvent extends Event {
  constructor(fastDeltaTime) {
    fastDeltaTime = fastDeltaTime === VOID ? Companion_instance_3.x1x() : fastDeltaTime;
    super();
    this.j8s_1 = fastDeltaTime;
  }
  k8s() {
    return toDuration_1(this.j8s_1);
  }
  c2e() {
    return Companion_instance_70;
  }
  toString() {
    return 'UpdateEvent(time=' + FastDuration__toString_impl_c9xohb(this.j8s_1) + ')';
  }
}
class Companion_62 {
  constructor() {
    this.l8s_1 = 536805376;
    this.m8s_1 = 805240832;
    this.n8s_1 = 2;
    this.o8s_1 = 32;
    this.p8s_1 = 256;
    this.q8s_1 = 512;
    this.r8s_1 = 768;
    this.s8s_1 = 769;
    this.t8s_1 = 1024;
    this.u8s_1 = 1025;
    this.v8s_1 = 1026;
    this.w8s_1 = 1027;
  }
}
class SDL extends FFILib {
  static p8t() {
    var $this = this.o2z([get_SDLPath()]);
    var tmp = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config = Companion_getInstance_13().u2z_1;
    tmp.c8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false))]), false), null, config, true)).h2z($this, SDL_Init$factory());
    var tmp_0 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_0 = Companion_getInstance_13().u2z_1;
    tmp_0.d8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(6), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ig(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false))]), false), null, config_0, true)).h2z($this, SDL_CreateWindow$factory());
    var tmp_1 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_1 = Companion_getInstance_13().u2z_1;
    tmp_1.e8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ig(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_1, true)).h2z($this, SDL_SetWindowTitle$factory());
    var tmp_2 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_2 = Companion_getInstance_13().u2z_1;
    tmp_2.f8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_2, true)).h2z($this, SDL_SetWindowSize$factory());
    var tmp_3 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_3 = Companion_getInstance_13().u2z_1;
    tmp_3.g8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_3, true)).h2z($this, SDL_SetWindowPosition$factory());
    var tmp_4 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_4 = Companion_getInstance_13().u2z_1;
    tmp_4.h8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_4, true)).h2z($this, SDL_ShowWindow$factory());
    var tmp_5 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_5 = Companion_getInstance_13().u2z_1;
    tmp_5.i8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_5, true)).h2z($this, SDL_RaiseWindow$factory());
    var tmp_6 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_6 = Companion_getInstance_13().u2z_1;
    tmp_6.j8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false))]), false), null, config_6, true)).h2z($this, SDL_PollEvent$factory());
    var tmp_7 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_7 = Companion_getInstance_13().u2z_1;
    tmp_7.k8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_7, true)).h2z($this, SDL_Quit$factory());
    var tmp_8 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_8 = Companion_getInstance_13().u2z_1;
    tmp_8.l8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false))]), false), null, config_8, true)).h2z($this, SDL_GL_CreateContext$factory());
    var tmp_9 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_9 = Companion_getInstance_13().u2z_1;
    tmp_9.m8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_9, true)).h2z($this, SDL_GL_DeleteContext$factory());
    var tmp_10 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_10 = Companion_getInstance_13().u2z_1;
    tmp_10.n8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false))]), false), null, config_10, true)).h2z($this, SDL_GL_MakeCurrent$factory());
    var tmp_11 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_11 = Companion_getInstance_13().u2z_1;
    tmp_11.o8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_11, true)).h2z($this, SDL_GL_SwapWindow$factory());
    return $this;
  }
  q8t() {
    return this.c8t_1.no(this, SDL_Init$factory_0());
  }
  r8t() {
    return this.d8t_1.no(this, SDL_CreateWindow$factory_0());
  }
  s8t() {
    return this.e8t_1.no(this, SDL_SetWindowTitle$factory_0());
  }
  t8t() {
    return this.f8t_1.no(this, SDL_SetWindowSize$factory_0());
  }
  u8t() {
    return this.g8t_1.no(this, SDL_SetWindowPosition$factory_0());
  }
  v8t() {
    return this.h8t_1.no(this, SDL_ShowWindow$factory_0());
  }
  w8t() {
    return this.i8t_1.no(this, SDL_RaiseWindow$factory_0());
  }
  x8t() {
    return this.j8t_1.no(this, SDL_PollEvent$factory_0());
  }
  y8t() {
    return this.k8t_1.no(this, SDL_Quit$factory_0());
  }
  z8t() {
    return this.l8t_1.no(this, SDL_GL_CreateContext$factory_0());
  }
  a8u() {
    return this.m8t_1.no(this, SDL_GL_DeleteContext$factory_0());
  }
  b8u() {
    return this.n8t_1.no(this, SDL_GL_MakeCurrent$factory_0());
  }
  c8u() {
    return this.o8t_1.no(this, SDL_GL_SwapWindow$factory_0());
  }
}
class KmlGlOpenGL extends KmlGl {
  constructor(gl) {
    gl = gl === VOID ? OpenGL.g90() : gl;
    super();
    this.l90_1 = gl;
  }
  m90(_this__u8e3s4) {
    return CreateFFIPointer(toLong(_this__u8e3s4));
  }
  n90(_this__u8e3s4) {
    return CreateFFIPointer(_this__u8e3s4);
  }
  r7c(texture) {
    return this.l90_1.o90()(texture);
  }
  w7g(program, shader) {
    return this.l90_1.p90()(program, shader);
  }
  v7g(program, index, name) {
    return this.l90_1.q90()(program, index, name);
  }
  l7b(target, buffer) {
    return this.l90_1.r90()(target, buffer);
  }
  o7f(target, framebuffer) {
    return this.l90_1.s90()(target, framebuffer);
  }
  v7f(target, renderbuffer) {
    return this.l90_1.t90()(target, renderbuffer);
  }
  m7f(target, texture) {
    return this.l90_1.u90()(target, texture);
  }
  z7d(modeRGB, modeAlpha) {
    return this.l90_1.v90()(modeRGB, modeAlpha);
  }
  a7e(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha) {
    return this.l90_1.w90()(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha);
  }
  v7c(target, size, data, usage) {
    return this.l90_1.x90()(target, this.m90(size), get_pointer_0(data), usage);
  }
  u7c(target, offset, size, data) {
    return this.l90_1.y90()(target, this.m90(offset), this.m90(size), get_pointer_0(data));
  }
  v7d(mask) {
    return this.l90_1.z90()(mask);
  }
  q7d(red, green, blue, alpha) {
    return this.l90_1.a91()(red, green, blue, alpha);
  }
  s7d(d) {
    return this.l90_1.b91()(d);
  }
  u7d(s) {
    return this.l90_1.c91()(s);
  }
  c7g(red, green, blue, alpha) {
    var tmp = this.l90_1.d91();
    // Inline function 'korlibs.math.toInt' call
    var tmp_0 = red ? 1 : 0;
    // Inline function 'korlibs.math.toInt' call
    var tmp_1 = green ? 1 : 0;
    // Inline function 'korlibs.math.toInt' call
    var tmp_2 = blue ? 1 : 0;
    // Inline function 'korlibs.math.toInt' call
    return tmp(tmp_0, tmp_1, tmp_2, alpha ? 1 : 0);
  }
  n7g(shader) {
    return this.l90_1.e91()(shader);
  }
  p7g() {
    return this.l90_1.f91()();
  }
  l7g(type) {
    return this.l90_1.g91()(type);
  }
  s7e(mode) {
    return this.l90_1.h91()(mode);
  }
  t85(n, items) {
    return this.l90_1.i91()(n, get_pointer_0(items));
  }
  u85(n, items) {
    return this.l90_1.j91()(n, get_pointer_0(items));
  }
  k7g(program) {
    return this.l90_1.k91()(program);
  }
  v85(n, items) {
    return this.l90_1.l91()(n, get_pointer_0(items));
  }
  j7g(shader) {
    return this.l90_1.m91()(shader);
  }
  w85(n, items) {
    return this.l90_1.n91()(n, get_pointer_0(items));
  }
  b7g(func) {
    return this.l90_1.o91()(func);
  }
  r7d(flag) {
    var tmp = this.l90_1.p91();
    // Inline function 'korlibs.math.toInt' call
    return tmp(flag ? 1 : 0);
  }
  a7g(n, f) {
    return this.l90_1.q91()(n, f);
  }
  e7e(cap) {
    return this.l90_1.r91()(cap);
  }
  u7e(index) {
    return this.l90_1.s91()(index);
  }
  l7e(mode, first, count) {
    return this.l90_1.t91()(mode, first, count);
  }
  n7e(mode, count, type, indices) {
    return this.l90_1.u91()(mode, count, type, this.m90(indices));
  }
  f7e(cap) {
    return this.l90_1.v91()(cap);
  }
  y7e(index) {
    return this.l90_1.w91()(index);
  }
  yc() {
    return this.l90_1.x91()();
  }
  y7f(target, attachment, renderbuffertarget, renderbuffer) {
    return this.l90_1.y91()(target, attachment, renderbuffertarget, renderbuffer);
  }
  x7f(target, attachment, textarget, texture, level) {
    return this.l90_1.z91()(target, attachment, textarget, texture, level);
  }
  z7f(mode) {
    return this.l90_1.a92()(mode);
  }
  x85(n, buffers) {
    return this.l90_1.b92()(n, get_pointer_0(buffers));
  }
  z7c(target) {
    return this.l90_1.c92()(target);
  }
  y85(n, framebuffers) {
    return this.l90_1.d92()(n, get_pointer_0(framebuffers));
  }
  z85(n, renderbuffers) {
    return this.l90_1.e92()(n, get_pointer_0(renderbuffers));
  }
  a86(n, textures) {
    return this.l90_1.f92()(n, get_pointer_0(textures));
  }
  h7g(program, name) {
    return this.l90_1.g92()(program, name);
  }
  o7g() {
    return this.l90_1.h92()();
  }
  b86(pname, data) {
    return this.l90_1.i92()(pname, get_pointer_0(data));
  }
  c86(program, pname, params) {
    return this.l90_1.j92()(program, pname, get_pointer_0(params));
  }
  d86(shader, pname, params) {
    return this.l90_1.k92()(shader, pname, get_pointer_0(params));
  }
  e86(shader, bufSize, length, infoLog) {
    this.l90_1.l92()(shader, bufSize, get_pointer_0(length), get_pointer_0(infoLog));
  }
  g79(name) {
    var tmp0_elvis_lhs = this.l90_1.m92()(name);
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  }
  x7g(program) {
    return this.l90_1.n92()(program);
  }
  w7c(pname, param) {
    return this.l90_1.o92()(pname, param);
  }
  w7f(target, internalformat, width, height) {
    return this.l90_1.p92()(target, internalformat, width, height);
  }
  d7g(x, y, width, height) {
    return this.l90_1.q92()(x, y, width, height);
  }
  m7g(shader, string) {
    // Inline function 'korlibs.ffi.usePointer' call
    var this_0 = CreateFFIMemory(8);
    var lengthsPtr = get_pointer(Deno.UnsafePointer.of(this_0));
    var bytes = encodeToByteArray(string + '\x00');
    set32(lengthsPtr, bytes.length - 1 | 0);
    // Inline function 'korlibs.ffi.usePointer' call
    var this_1 = CreateFFIMemory_0(bytes);
    var strPtr = get_pointer(Deno.UnsafePointer.of(this_1));
    // Inline function 'korlibs.ffi.usePointer' call
    var this_2 = CreateFFIMemory(8);
    var strPtrPtr = get_pointer(Deno.UnsafePointer.of(this_2));
    setFFIPointer(strPtrPtr, strPtr);
    this.l90_1.r92()(shader, 1, strPtrPtr, lengthsPtr);
  }
  h7e(func, ref, mask) {
    return this.l90_1.s92()(func, ref, mask);
  }
  g7e(face, func, ref, mask) {
    return this.l90_1.t92()(face, func, ref, mask);
  }
  t7d(mask) {
    return this.l90_1.u92()(mask);
  }
  k7e(face, mask) {
    return this.l90_1.v92()(face, mask);
  }
  j7e(fail, zfail, zpass) {
    return this.l90_1.w92()(fail, zfail, zpass);
  }
  i7e(face, sfail, dpfail, dppass) {
    return this.l90_1.x92()(face, sfail, dpfail, dppass);
  }
  x7c(target, level, internalformat, width, height, border, format, type, pixels) {
    var tmp = this.l90_1.y92();
    tmp(target, level, internalformat, width, height, border, format, type, pixels == null ? null : get_pointer_0(pixels));
  }
  q7c(target, pname, param) {
    return this.l90_1.z92()(target, pname, param);
  }
  m7c(location, count, value) {
    return this.l90_1.a93()(location, count, get_pointer_0(value));
  }
  k7a(location, v0) {
    return this.l90_1.b93()(location, v0);
  }
  f7c(location, count, value) {
    return this.l90_1.c93()(location, count, get_pointer_0(value));
  }
  n7c(location, count, value) {
    return this.l90_1.d93()(location, count, get_pointer_0(value));
  }
  g7c(location, count, value) {
    return this.l90_1.e93()(location, count, get_pointer_0(value));
  }
  o7c(location, count, value) {
    return this.l90_1.f93()(location, count, get_pointer_0(value));
  }
  h7c(location, count, value) {
    return this.l90_1.g93()(location, count, get_pointer_0(value));
  }
  p7c(location, count, value) {
    return this.l90_1.h93()(location, count, get_pointer_0(value));
  }
  i7c(location, count, value) {
    return this.l90_1.i93()(location, count, get_pointer_0(value));
  }
  j7c(location, count, transpose, value) {
    var tmp = this.l90_1.j93();
    // Inline function 'korlibs.math.toInt' call
    return tmp(location, count, transpose ? 1 : 0, get_pointer_0(value));
  }
  k7c(location, count, transpose, value) {
    var tmp = this.l90_1.k93();
    // Inline function 'korlibs.math.toInt' call
    return tmp(location, count, transpose ? 1 : 0, get_pointer_0(value));
  }
  l7c(location, count, transpose, value) {
    var tmp = this.l90_1.l93();
    // Inline function 'korlibs.math.toInt' call
    return tmp(location, count, transpose ? 1 : 0, get_pointer_0(value));
  }
  i7g(program) {
    return this.l90_1.m93()(program);
  }
  z7e(index, size, type, normalized, stride, pointer) {
    var tmp = this.l90_1.n93();
    // Inline function 'korlibs.math.toInt' call
    return tmp(index, size, type, normalized ? 1 : 0, stride, this.n90(pointer));
  }
  n7f(x, y, width, height) {
    return this.l90_1.o93()(x, y, width, height);
  }
  m7e(mode, first, count, instancecount) {
    return this.l90_1.p93()(mode, first, count, instancecount);
  }
  o7e(mode, count, type, indices, instancecount) {
    return this.l90_1.q93()(mode, count, type, this.m90(indices), instancecount);
  }
  t7e(index, divisor) {
    return this.l90_1.r93()(index, divisor);
  }
  g6o() {
    return true;
  }
  g7f(target, index, buffer, offset, size) {
    return this.l90_1.s93()(target, index, buffer, this.m90(offset), this.m90(size));
  }
  l7a(program, name) {
    return this.l90_1.t93()(program, name);
  }
  m7a(program, uniformBlockIndex, uniformBlockBinding) {
    return this.l90_1.u93()(program, uniformBlockIndex, uniformBlockBinding);
  }
  h6o() {
    return true;
  }
  f86(n, arrays) {
    return this.l90_1.v93()(n, get_pointer_0(arrays));
  }
  v7e(array) {
    return this.l90_1.w93()(array);
  }
}
class Companion_63 {
  constructor() {
    this.x93_1 = 16384;
  }
}
class OpenGL extends FFILib {
  static g90() {
    var $this = this.o2z(['/System/Library/Frameworks/OpenGL.framework/OpenGL']);
    var tmp = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config = Companion_getInstance_13().u2z_1;
    tmp.i8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config, true)).h2z($this, glDrawArraysInstanced$factory());
    var tmp_0 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_0 = Companion_getInstance_13().u2z_1;
    tmp_0.j8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_0, true)).h2z($this, glDrawElementsInstanced$factory());
    var tmp_1 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_1 = Companion_getInstance_13().u2z_1;
    tmp_1.k8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_1, true)).h2z($this, glVertexAttribDivisor$factory());
    var tmp_2 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_2 = Companion_getInstance_13().u2z_1;
    tmp_2.l8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(9), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_2, true)).h2z($this, glTexSubImage2D$factory());
    var tmp_3 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_3 = Companion_getInstance_13().u2z_1;
    tmp_3.m8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(9), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_3, true)).h2z($this, glTexImage2D$factory());
    var tmp_4 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_4 = Companion_getInstance_13().u2z_1;
    tmp_4.n8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_4, true)).h2z($this, glTexParameteri$factory());
    var tmp_5 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_5 = Companion_getInstance_13().u2z_1;
    tmp_5.o8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_5, true)).h2z($this, glTexParameterf$factory());
    var tmp_6 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_6 = Companion_getInstance_13().u2z_1;
    tmp_6.p8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_6, true)).h2z($this, glTexParameterfv$factory());
    var tmp_7 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_7 = Companion_getInstance_13().u2z_1;
    tmp_7.q8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_7, true)).h2z($this, glTexParameteriv$factory());
    var tmp_8 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_8 = Companion_getInstance_13().u2z_1;
    tmp_8.r8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_8, true)).h2z($this, glStencilOp$factory());
    var tmp_9 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_9 = Companion_getInstance_13().u2z_1;
    tmp_9.s8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_9, true)).h2z($this, glStencilMask$factory());
    var tmp_10 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_10 = Companion_getInstance_13().u2z_1;
    tmp_10.t8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(7), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_10, true)).h2z($this, glReadPixels$factory());
    var tmp_11 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_11 = Companion_getInstance_13().u2z_1;
    tmp_11.u8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_11, true)).h2z($this, glStencilFunc$factory());
    var tmp_12 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_12 = Companion_getInstance_13().u2z_1;
    tmp_12.v8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_12, true)).h2z($this, glScissor$factory());
    var tmp_13 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_13 = Companion_getInstance_13().u2z_1;
    tmp_13.w8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_13, true)).h2z($this, glPolygonOffset$factory());
    var tmp_14 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_14 = Companion_getInstance_13().u2z_1;
    tmp_14.x8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_14, true)).h2z($this, glPixelStorei$factory());
    var tmp_15 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_15 = Companion_getInstance_13().u2z_1;
    tmp_15.y8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_15, true)).h2z($this, glLineWidth$factory());
    var tmp_16 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_16 = Companion_getInstance_13().u2z_1;
    tmp_16.z8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_16, true)).h2z($this, glGetTexParameterfv$factory());
    var tmp_17 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_17 = Companion_getInstance_13().u2z_1;
    tmp_17.a8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_17, true)).h2z($this, glGetTexParameteriv$factory());
    var tmp_18 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_18 = Companion_getInstance_13().u2z_1;
    tmp_18.b8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false))]), false), null, config_18, true)).h2z($this, glGetError$factory());
    var tmp_19 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_19 = Companion_getInstance_13().u2z_1;
    tmp_19.c8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_19, true)).h2z($this, glGetFloatv$factory());
    var tmp_20 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_20 = Companion_getInstance_13().u2z_1;
    tmp_20.d8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_20, true)).h2z($this, glGetIntegerv$factory());
    var tmp_21 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_21 = Companion_getInstance_13().u2z_1;
    tmp_21.e8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_21, true)).h2z($this, glGetBooleanv$factory());
    var tmp_22 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_22 = Companion_getInstance_13().u2z_1;
    tmp_22.f8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_22, true)).h2z($this, glGenTextures$factory());
    var tmp_23 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_23 = Companion_getInstance_13().u2z_1;
    tmp_23.g8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_23, true)).h2z($this, glDepthRange$factory());
    var tmp_24 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_24 = Companion_getInstance_13().u2z_1;
    tmp_24.h8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_24, true)).h2z($this, glDepthRangef$factory());
    var tmp_25 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_25 = Companion_getInstance_13().u2z_1;
    tmp_25.i8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_25, true)).h2z($this, glClearDepth$factory());
    var tmp_26 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_26 = Companion_getInstance_13().u2z_1;
    tmp_26.j8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_26, true)).h2z($this, glClearDepthf$factory());
    var tmp_27 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_27 = Companion_getInstance_13().u2z_1;
    tmp_27.k8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_27, true)).h2z($this, glDrawArrays$factory());
    var tmp_28 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_28 = Companion_getInstance_13().u2z_1;
    tmp_28.l8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_28, true)).h2z($this, glDrawElements$factory());
    var tmp_29 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_29 = Companion_getInstance_13().u2z_1;
    tmp_29.m8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_29, true)).h2z($this, glFrontFace$factory());
    var tmp_30 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_30 = Companion_getInstance_13().u2z_1;
    tmp_30.n8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_30, true)).h2z($this, glFinish$factory());
    var tmp_31 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_31 = Companion_getInstance_13().u2z_1;
    tmp_31.o8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_31, true)).h2z($this, glFlush$factory());
    var tmp_32 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_32 = Companion_getInstance_13().u2z_1;
    tmp_32.p8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_32, true)).h2z($this, glEnable$factory());
    var tmp_33 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_33 = Companion_getInstance_13().u2z_1;
    tmp_33.q8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false))]), false), null, config_33, true)).h2z($this, glIsEnabled$factory());
    var tmp_34 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_34 = Companion_getInstance_13().u2z_1;
    tmp_34.r8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_34, true)).h2z($this, glDisable$factory());
    var tmp_35 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_35 = Companion_getInstance_13().u2z_1;
    tmp_35.s8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_35, true)).h2z($this, glDepthMask$factory());
    var tmp_36 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_36 = Companion_getInstance_13().u2z_1;
    tmp_36.t8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_36, true)).h2z($this, glDepthFunc$factory());
    var tmp_37 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_37 = Companion_getInstance_13().u2z_1;
    tmp_37.u8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_37, true)).h2z($this, glDeleteTextures$factory());
    var tmp_38 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_38 = Companion_getInstance_13().u2z_1;
    tmp_38.v8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_38, true)).h2z($this, glCullFace$factory());
    var tmp_39 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_39 = Companion_getInstance_13().u2z_1;
    tmp_39.w8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(8), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_39, true)).h2z($this, glCopyTexImage2D$factory());
    var tmp_40 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_40 = Companion_getInstance_13().u2z_1;
    tmp_40.x8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(8), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_40, true)).h2z($this, glCopyTexSubImage2D$factory());
    var tmp_41 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_41 = Companion_getInstance_13().u2z_1;
    tmp_41.y8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_41, true)).h2z($this, glColorMask$factory());
    var tmp_42 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_42 = Companion_getInstance_13().u2z_1;
    tmp_42.z8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_42, true)).h2z($this, glClearStencil$factory());
    var tmp_43 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_43 = Companion_getInstance_13().u2z_1;
    tmp_43.a8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_43, true)).h2z($this, glClearColor$factory());
    var tmp_44 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_44 = Companion_getInstance_13().u2z_1;
    tmp_44.b8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_44, true)).h2z($this, glClear$factory());
    var tmp_45 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_45 = Companion_getInstance_13().u2z_1;
    tmp_45.c8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_45, true)).h2z($this, glBindTexture$factory());
    var tmp_46 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_46 = Companion_getInstance_13().u2z_1;
    tmp_46.d8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_46, true)).h2z($this, glHint$factory());
    var tmp_47 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_47 = Companion_getInstance_13().u2z_1;
    tmp_47.e8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_47, true)).h2z($this, glViewport$factory());
    var tmp_48 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_48 = Companion_getInstance_13().u2z_1;
    tmp_48.f8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ig(), arrayOf([]), true))]), false), null, config_48, true)).h2z($this, glGetString$factory());
    var tmp_49 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_49 = Companion_getInstance_13().u2z_1;
    tmp_49.g8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ig(), arrayOf([]), true))]), false), null, config_49, true)).h2z($this, glGetStringi$factory());
    var tmp_50 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_50 = Companion_getInstance_13().u2z_1;
    tmp_50.h8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(6), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_50, true)).h2z($this, glVertexAttribPointer$factory());
    var tmp_51 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_51 = Companion_getInstance_13().u2z_1;
    tmp_51.i8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_51, true)).h2z($this, glVertexAttrib4fv$factory());
    var tmp_52 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_52 = Companion_getInstance_13().u2z_1;
    tmp_52.j8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_52, true)).h2z($this, glActiveTexture$factory());
    var tmp_53 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_53 = Companion_getInstance_13().u2z_1;
    tmp_53.k8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_53, true)).h2z($this, glAttachShader$factory());
    var tmp_54 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_54 = Companion_getInstance_13().u2z_1;
    tmp_54.l8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ig(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_54, true)).h2z($this, glBindAttribLocation$factory());
    var tmp_55 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_55 = Companion_getInstance_13().u2z_1;
    tmp_55.m8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_55, true)).h2z($this, glBindBuffer$factory());
    var tmp_56 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_56 = Companion_getInstance_13().u2z_1;
    tmp_56.n8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_56, true)).h2z($this, glBindFramebuffer$factory());
    var tmp_57 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_57 = Companion_getInstance_13().u2z_1;
    tmp_57.o8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_57, true)).h2z($this, glBindRenderbuffer$factory());
    var tmp_58 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_58 = Companion_getInstance_13().u2z_1;
    tmp_58.p8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_58, true)).h2z($this, glBlendColor$factory());
    var tmp_59 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_59 = Companion_getInstance_13().u2z_1;
    tmp_59.q8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_59, true)).h2z($this, glBlendEquation$factory());
    var tmp_60 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_60 = Companion_getInstance_13().u2z_1;
    tmp_60.r8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_60, true)).h2z($this, glBlendEquationSeparate$factory());
    var tmp_61 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_61 = Companion_getInstance_13().u2z_1;
    tmp_61.s8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_61, true)).h2z($this, glBlendFunc$factory());
    var tmp_62 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_62 = Companion_getInstance_13().u2z_1;
    tmp_62.t8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_62, true)).h2z($this, glBlendFuncSeparate$factory());
    var tmp_63 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_63 = Companion_getInstance_13().u2z_1;
    tmp_63.u8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_63, true)).h2z($this, glBufferData$factory());
    var tmp_64 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_64 = Companion_getInstance_13().u2z_1;
    tmp_64.v8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_64, true)).h2z($this, glBufferSubData$factory());
    var tmp_65 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_65 = Companion_getInstance_13().u2z_1;
    tmp_65.w8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false))]), false), null, config_65, true)).h2z($this, glCheckFramebufferStatus$factory());
    var tmp_66 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_66 = Companion_getInstance_13().u2z_1;
    tmp_66.x8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_66, true)).h2z($this, glCompileShader$factory());
    var tmp_67 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_67 = Companion_getInstance_13().u2z_1;
    tmp_67.y8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(8), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_67, true)).h2z($this, glCompressedTexImage2D$factory());
    var tmp_68 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_68 = Companion_getInstance_13().u2z_1;
    tmp_68.z8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(9), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_68, true)).h2z($this, glCompressedTexSubImage2D$factory());
    var tmp_69 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_69 = Companion_getInstance_13().u2z_1;
    tmp_69.a8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false))]), false), null, config_69, true)).h2z($this, glCreateProgram$factory());
    var tmp_70 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_70 = Companion_getInstance_13().u2z_1;
    tmp_70.b8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false))]), false), null, config_70, true)).h2z($this, glCreateShader$factory());
    var tmp_71 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_71 = Companion_getInstance_13().u2z_1;
    tmp_71.c8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_71, true)).h2z($this, glDeleteBuffers$factory());
    var tmp_72 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_72 = Companion_getInstance_13().u2z_1;
    tmp_72.d8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_72, true)).h2z($this, glDeleteFramebuffers$factory());
    var tmp_73 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_73 = Companion_getInstance_13().u2z_1;
    tmp_73.e8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_73, true)).h2z($this, glDeleteProgram$factory());
    var tmp_74 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_74 = Companion_getInstance_13().u2z_1;
    tmp_74.f8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_74, true)).h2z($this, glDeleteRenderbuffers$factory());
    var tmp_75 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_75 = Companion_getInstance_13().u2z_1;
    tmp_75.g8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_75, true)).h2z($this, glDeleteShader$factory());
    var tmp_76 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_76 = Companion_getInstance_13().u2z_1;
    tmp_76.h8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_76, true)).h2z($this, glDetachShader$factory());
    var tmp_77 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_77 = Companion_getInstance_13().u2z_1;
    tmp_77.i8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_77, true)).h2z($this, glDisableVertexAttribArray$factory());
    var tmp_78 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_78 = Companion_getInstance_13().u2z_1;
    tmp_78.j8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_78, true)).h2z($this, glEnableVertexAttribArray$factory());
    var tmp_79 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_79 = Companion_getInstance_13().u2z_1;
    tmp_79.k8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_79, true)).h2z($this, glFramebufferRenderbuffer$factory());
    var tmp_80 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_80 = Companion_getInstance_13().u2z_1;
    tmp_80.l8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_80, true)).h2z($this, glFramebufferTexture2D$factory());
    var tmp_81 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_81 = Companion_getInstance_13().u2z_1;
    tmp_81.m8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_81, true)).h2z($this, glGenBuffers$factory());
    var tmp_82 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_82 = Companion_getInstance_13().u2z_1;
    tmp_82.n8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_82, true)).h2z($this, glGenerateMipmap$factory());
    var tmp_83 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_83 = Companion_getInstance_13().u2z_1;
    tmp_83.o8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_83, true)).h2z($this, glGenFramebuffers$factory());
    var tmp_84 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_84 = Companion_getInstance_13().u2z_1;
    tmp_84.p8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_84, true)).h2z($this, glGenRenderbuffers$factory());
    var tmp_85 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_85 = Companion_getInstance_13().u2z_1;
    tmp_85.q8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(7), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_85, true)).h2z($this, glGetActiveAttrib$factory());
    var tmp_86 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_86 = Companion_getInstance_13().u2z_1;
    tmp_86.r8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(7), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_86, true)).h2z($this, glGetActiveUniform$factory());
    var tmp_87 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_87 = Companion_getInstance_13().u2z_1;
    tmp_87.s8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_87, true)).h2z($this, glGetAttachedShaders$factory());
    var tmp_88 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_88 = Companion_getInstance_13().u2z_1;
    tmp_88.t8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ig(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false))]), false), null, config_88, true)).h2z($this, glGetAttribLocation$factory());
    var tmp_89 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_89 = Companion_getInstance_13().u2z_1;
    tmp_89.u8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ig(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false))]), false), null, config_89, true)).h2z($this, glGetUniformLocation$factory());
    var tmp_90 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_90 = Companion_getInstance_13().u2z_1;
    tmp_90.v8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_90, true)).h2z($this, glGetBufferParameteriv$factory());
    var tmp_91 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_91 = Companion_getInstance_13().u2z_1;
    tmp_91.w8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_91, true)).h2z($this, glGetFramebufferAttachmentParameteriv$factory());
    var tmp_92 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_92 = Companion_getInstance_13().u2z_1;
    tmp_92.x8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_92, true)).h2z($this, glGetProgramInfoLog$factory());
    var tmp_93 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_93 = Companion_getInstance_13().u2z_1;
    tmp_93.y8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_93, true)).h2z($this, glGetRenderbufferParameteriv$factory());
    var tmp_94 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_94 = Companion_getInstance_13().u2z_1;
    tmp_94.z8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_94, true)).h2z($this, glGetProgramiv$factory());
    var tmp_95 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_95 = Companion_getInstance_13().u2z_1;
    tmp_95.a8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_95, true)).h2z($this, glGetShaderiv$factory());
    var tmp_96 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_96 = Companion_getInstance_13().u2z_1;
    tmp_96.b8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_96, true)).h2z($this, glGetShaderInfoLog$factory());
    var tmp_97 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_97 = Companion_getInstance_13().u2z_1;
    tmp_97.c8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_97, true)).h2z($this, glGetShaderPrecisionFormat$factory());
    var tmp_98 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_98 = Companion_getInstance_13().u2z_1;
    tmp_98.d8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_98, true)).h2z($this, glGetShaderSource$factory());
    var tmp_99 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_99 = Companion_getInstance_13().u2z_1;
    tmp_99.e8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_99, true)).h2z($this, glGetUniformfv$factory());
    var tmp_100 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_100 = Companion_getInstance_13().u2z_1;
    tmp_100.f8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_100, true)).h2z($this, glGetUniformiv$factory());
    var tmp_101 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_101 = Companion_getInstance_13().u2z_1;
    tmp_101.g8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_101, true)).h2z($this, glGetVertexAttribfv$factory());
    var tmp_102 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_102 = Companion_getInstance_13().u2z_1;
    tmp_102.h8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_102, true)).h2z($this, glGetVertexAttribiv$factory());
    var tmp_103 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_103 = Companion_getInstance_13().u2z_1;
    tmp_103.i8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_103, true)).h2z($this, glGetVertexAttribPointerv$factory());
    var tmp_104 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_104 = Companion_getInstance_13().u2z_1;
    tmp_104.j8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false))]), false), null, config_104, true)).h2z($this, glIsBuffer$factory());
    var tmp_105 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_105 = Companion_getInstance_13().u2z_1;
    tmp_105.k8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false))]), false), null, config_105, true)).h2z($this, glIsFramebuffer$factory());
    var tmp_106 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_106 = Companion_getInstance_13().u2z_1;
    tmp_106.l8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false))]), false), null, config_106, true)).h2z($this, glIsProgram$factory());
    var tmp_107 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_107 = Companion_getInstance_13().u2z_1;
    tmp_107.m8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false))]), false), null, config_107, true)).h2z($this, glIsRenderbuffer$factory());
    var tmp_108 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_108 = Companion_getInstance_13().u2z_1;
    tmp_108.n8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false))]), false), null, config_108, true)).h2z($this, glIsTexture$factory());
    var tmp_109 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_109 = Companion_getInstance_13().u2z_1;
    tmp_109.o8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false))]), false), null, config_109, true)).h2z($this, glIsShader$factory());
    var tmp_110 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_110 = Companion_getInstance_13().u2z_1;
    tmp_110.p8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_110, true)).h2z($this, glLinkProgram$factory());
    var tmp_111 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_111 = Companion_getInstance_13().u2z_1;
    tmp_111.q8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_111, true)).h2z($this, glReleaseShaderCompiler$factory());
    var tmp_112 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_112 = Companion_getInstance_13().u2z_1;
    tmp_112.r8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_112, true)).h2z($this, glRenderbufferStorage$factory());
    var tmp_113 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_113 = Companion_getInstance_13().u2z_1;
    tmp_113.s8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_113, true)).h2z($this, glSampleCoverage$factory());
    var tmp_114 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_114 = Companion_getInstance_13().u2z_1;
    tmp_114.t8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_114, true)).h2z($this, glShaderBinary$factory());
    var tmp_115 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_115 = Companion_getInstance_13().u2z_1;
    tmp_115.u8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_115, true)).h2z($this, glShaderSource$factory());
    var tmp_116 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_116 = Companion_getInstance_13().u2z_1;
    tmp_116.v8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_116, true)).h2z($this, glStencilFuncSeparate$factory());
    var tmp_117 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_117 = Companion_getInstance_13().u2z_1;
    tmp_117.w8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_117, true)).h2z($this, glStencilMaskSeparate$factory());
    var tmp_118 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_118 = Companion_getInstance_13().u2z_1;
    tmp_118.x8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_118, true)).h2z($this, glStencilOpSeparate$factory());
    var tmp_119 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_119 = Companion_getInstance_13().u2z_1;
    tmp_119.y8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_119, true)).h2z($this, glUniform1f$factory());
    var tmp_120 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_120 = Companion_getInstance_13().u2z_1;
    tmp_120.z8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_120, true)).h2z($this, glUniform2f$factory());
    var tmp_121 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_121 = Companion_getInstance_13().u2z_1;
    tmp_121.a8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_121, true)).h2z($this, glUniform3f$factory());
    var tmp_122 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_122 = Companion_getInstance_13().u2z_1;
    tmp_122.b8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_122, true)).h2z($this, glUniform4f$factory());
    var tmp_123 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_123 = Companion_getInstance_13().u2z_1;
    tmp_123.c8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_123, true)).h2z($this, glUniform1i$factory());
    var tmp_124 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_124 = Companion_getInstance_13().u2z_1;
    tmp_124.d8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_124, true)).h2z($this, glUniform2i$factory());
    var tmp_125 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_125 = Companion_getInstance_13().u2z_1;
    tmp_125.e8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_125, true)).h2z($this, glUniform3i$factory());
    var tmp_126 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_126 = Companion_getInstance_13().u2z_1;
    tmp_126.f8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_126, true)).h2z($this, glUniform4i$factory());
    var tmp_127 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_127 = Companion_getInstance_13().u2z_1;
    tmp_127.g8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_127, true)).h2z($this, glUniform1fv$factory());
    var tmp_128 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_128 = Companion_getInstance_13().u2z_1;
    tmp_128.h8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_128, true)).h2z($this, glUniform2fv$factory());
    var tmp_129 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_129 = Companion_getInstance_13().u2z_1;
    tmp_129.i8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_129, true)).h2z($this, glUniform3fv$factory());
    var tmp_130 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_130 = Companion_getInstance_13().u2z_1;
    tmp_130.j8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_130, true)).h2z($this, glUniform4fv$factory());
    var tmp_131 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_131 = Companion_getInstance_13().u2z_1;
    tmp_131.k8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_131, true)).h2z($this, glUniform1iv$factory());
    var tmp_132 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_132 = Companion_getInstance_13().u2z_1;
    tmp_132.l8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_132, true)).h2z($this, glUniform2iv$factory());
    var tmp_133 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_133 = Companion_getInstance_13().u2z_1;
    tmp_133.m8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_133, true)).h2z($this, glUniform3iv$factory());
    var tmp_134 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_134 = Companion_getInstance_13().u2z_1;
    tmp_134.n8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_134, true)).h2z($this, glUniform4iv$factory());
    var tmp_135 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_135 = Companion_getInstance_13().u2z_1;
    tmp_135.o8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_135, true)).h2z($this, glUniformMatrix2fv$factory());
    var tmp_136 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_136 = Companion_getInstance_13().u2z_1;
    tmp_136.p8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_136, true)).h2z($this, glUniformMatrix3fv$factory());
    var tmp_137 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_137 = Companion_getInstance_13().u2z_1;
    tmp_137.q8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_137, true)).h2z($this, glUniformMatrix4fv$factory());
    var tmp_138 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_138 = Companion_getInstance_13().u2z_1;
    tmp_138.r8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_138, true)).h2z($this, glUseProgram$factory());
    var tmp_139 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_139 = Companion_getInstance_13().u2z_1;
    tmp_139.s8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_139, true)).h2z($this, glValidateProgram$factory());
    var tmp_140 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_140 = Companion_getInstance_13().u2z_1;
    tmp_140.t8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_140, true)).h2z($this, glVertexAttrib1f$factory());
    var tmp_141 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_141 = Companion_getInstance_13().u2z_1;
    tmp_141.u8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_141, true)).h2z($this, glVertexAttrib2f$factory());
    var tmp_142 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_142 = Companion_getInstance_13().u2z_1;
    tmp_142.v8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_142, true)).h2z($this, glVertexAttrib3f$factory());
    var tmp_143 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_143 = Companion_getInstance_13().u2z_1;
    tmp_143.w8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_143, true)).h2z($this, glVertexAttrib4f$factory());
    var tmp_144 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_144 = Companion_getInstance_13().u2z_1;
    tmp_144.x8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_144, true)).h2z($this, glVertexAttrib1fv$factory());
    var tmp_145 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_145 = Companion_getInstance_13().u2z_1;
    tmp_145.y8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_145, true)).h2z($this, glVertexAttrib2fv$factory());
    var tmp_146 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_146 = Companion_getInstance_13().u2z_1;
    tmp_146.z8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_146, true)).h2z($this, glVertexAttrib3fv$factory());
    var tmp_147 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_147 = Companion_getInstance_13().u2z_1;
    tmp_147.a90_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_147, true)).h2z($this, glBindBufferRange$factory());
    var tmp_148 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_148 = Companion_getInstance_13().u2z_1;
    tmp_148.b90_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ig(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false))]), false), null, config_148, true)).h2z($this, glGetUniformBlockIndex$factory());
    var tmp_149 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_149 = Companion_getInstance_13().u2z_1;
    tmp_149.c90_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_149, true)).h2z($this, glUniformBlockBinding$factory());
    var tmp_150 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_150 = Companion_getInstance_13().u2z_1;
    tmp_150.d90_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_150, true)).h2z($this, glGenVertexArrays$factory());
    var tmp_151 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_151 = Companion_getInstance_13().u2z_1;
    tmp_151.e90_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_151, true)).h2z($this, glDeleteVertexArrays$factory());
    var tmp_152 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_152 = Companion_getInstance_13().u2z_1;
    tmp_152.f90_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_152, true)).h2z($this, glBindVertexArray$factory());
    return $this;
  }
  p93() {
    return this.i8u_1.no(this, glDrawArraysInstanced$factory_0());
  }
  q93() {
    return this.j8u_1.no(this, glDrawElementsInstanced$factory_0());
  }
  r93() {
    return this.k8u_1.no(this, glVertexAttribDivisor$factory_0());
  }
  y93() {
    return this.l8u_1.no(this, glTexSubImage2D$factory_0());
  }
  y92() {
    return this.m8u_1.no(this, glTexImage2D$factory_0());
  }
  z92() {
    return this.n8u_1.no(this, glTexParameteri$factory_0());
  }
  z93() {
    return this.o8u_1.no(this, glTexParameterf$factory_0());
  }
  a94() {
    return this.p8u_1.no(this, glTexParameterfv$factory_0());
  }
  b94() {
    return this.q8u_1.no(this, glTexParameteriv$factory_0());
  }
  w92() {
    return this.r8u_1.no(this, glStencilOp$factory_0());
  }
  u92() {
    return this.s8u_1.no(this, glStencilMask$factory_0());
  }
  c94() {
    return this.t8u_1.no(this, glReadPixels$factory_0());
  }
  s92() {
    return this.u8u_1.no(this, glStencilFunc$factory_0());
  }
  q92() {
    return this.v8u_1.no(this, glScissor$factory_0());
  }
  d94() {
    return this.w8u_1.no(this, glPolygonOffset$factory_0());
  }
  o92() {
    return this.x8u_1.no(this, glPixelStorei$factory_0());
  }
  e94() {
    return this.y8u_1.no(this, glLineWidth$factory_0());
  }
  f94() {
    return this.z8u_1.no(this, glGetTexParameterfv$factory_0());
  }
  g94() {
    return this.a8v_1.no(this, glGetTexParameteriv$factory_0());
  }
  h92() {
    return this.b8v_1.no(this, glGetError$factory_0());
  }
  h94() {
    return this.c8v_1.no(this, glGetFloatv$factory_0());
  }
  i92() {
    return this.d8v_1.no(this, glGetIntegerv$factory_0());
  }
  i94() {
    return this.e8v_1.no(this, glGetBooleanv$factory_0());
  }
  f92() {
    return this.f8v_1.no(this, glGenTextures$factory_0());
  }
  j94() {
    return this.g8v_1.no(this, glDepthRange$factory_0());
  }
  q91() {
    return this.h8v_1.no(this, glDepthRangef$factory_0());
  }
  k94() {
    return this.i8v_1.no(this, glClearDepth$factory_0());
  }
  b91() {
    return this.j8v_1.no(this, glClearDepthf$factory_0());
  }
  t91() {
    return this.k8v_1.no(this, glDrawArrays$factory_0());
  }
  u91() {
    return this.l8v_1.no(this, glDrawElements$factory_0());
  }
  a92() {
    return this.m8v_1.no(this, glFrontFace$factory_0());
  }
  l94() {
    return this.n8v_1.no(this, glFinish$factory_0());
  }
  x91() {
    return this.o8v_1.no(this, glFlush$factory_0());
  }
  v91() {
    return this.p8v_1.no(this, glEnable$factory_0());
  }
  m94() {
    return this.q8v_1.no(this, glIsEnabled$factory_0());
  }
  r91() {
    return this.r8v_1.no(this, glDisable$factory_0());
  }
  p91() {
    return this.s8v_1.no(this, glDepthMask$factory_0());
  }
  o91() {
    return this.t8v_1.no(this, glDepthFunc$factory_0());
  }
  n91() {
    return this.u8v_1.no(this, glDeleteTextures$factory_0());
  }
  h91() {
    return this.v8v_1.no(this, glCullFace$factory_0());
  }
  n94() {
    return this.w8v_1.no(this, glCopyTexImage2D$factory_0());
  }
  o94() {
    return this.x8v_1.no(this, glCopyTexSubImage2D$factory_0());
  }
  d91() {
    return this.y8v_1.no(this, glColorMask$factory_0());
  }
  c91() {
    return this.z8v_1.no(this, glClearStencil$factory_0());
  }
  a91() {
    return this.a8w_1.no(this, glClearColor$factory_0());
  }
  z90() {
    return this.b8w_1.no(this, glClear$factory_0());
  }
  u90() {
    return this.c8w_1.no(this, glBindTexture$factory_0());
  }
  p94() {
    return this.d8w_1.no(this, glHint$factory_0());
  }
  o93() {
    return this.e8w_1.no(this, glViewport$factory_0());
  }
  m92() {
    return this.f8w_1.no(this, glGetString$factory_0());
  }
  q94() {
    return this.g8w_1.no(this, glGetStringi$factory_0());
  }
  n93() {
    return this.h8w_1.no(this, glVertexAttribPointer$factory_0());
  }
  r94() {
    return this.i8w_1.no(this, glVertexAttrib4fv$factory_0());
  }
  o90() {
    return this.j8w_1.no(this, glActiveTexture$factory_0());
  }
  p90() {
    return this.k8w_1.no(this, glAttachShader$factory_0());
  }
  q90() {
    return this.l8w_1.no(this, glBindAttribLocation$factory_0());
  }
  r90() {
    return this.m8w_1.no(this, glBindBuffer$factory_0());
  }
  s90() {
    return this.n8w_1.no(this, glBindFramebuffer$factory_0());
  }
  t90() {
    return this.o8w_1.no(this, glBindRenderbuffer$factory_0());
  }
  s94() {
    return this.p8w_1.no(this, glBlendColor$factory_0());
  }
  t94() {
    return this.q8w_1.no(this, glBlendEquation$factory_0());
  }
  v90() {
    return this.r8w_1.no(this, glBlendEquationSeparate$factory_0());
  }
  u94() {
    return this.s8w_1.no(this, glBlendFunc$factory_0());
  }
  w90() {
    return this.t8w_1.no(this, glBlendFuncSeparate$factory_0());
  }
  x90() {
    return this.u8w_1.no(this, glBufferData$factory_0());
  }
  y90() {
    return this.v8w_1.no(this, glBufferSubData$factory_0());
  }
  v94() {
    return this.w8w_1.no(this, glCheckFramebufferStatus$factory_0());
  }
  e91() {
    return this.x8w_1.no(this, glCompileShader$factory_0());
  }
  w94() {
    return this.y8w_1.no(this, glCompressedTexImage2D$factory_0());
  }
  x94() {
    return this.z8w_1.no(this, glCompressedTexSubImage2D$factory_0());
  }
  f91() {
    return this.a8x_1.no(this, glCreateProgram$factory_0());
  }
  g91() {
    return this.b8x_1.no(this, glCreateShader$factory_0());
  }
  i91() {
    return this.c8x_1.no(this, glDeleteBuffers$factory_0());
  }
  j91() {
    return this.d8x_1.no(this, glDeleteFramebuffers$factory_0());
  }
  k91() {
    return this.e8x_1.no(this, glDeleteProgram$factory_0());
  }
  l91() {
    return this.f8x_1.no(this, glDeleteRenderbuffers$factory_0());
  }
  m91() {
    return this.g8x_1.no(this, glDeleteShader$factory_0());
  }
  y94() {
    return this.h8x_1.no(this, glDetachShader$factory_0());
  }
  s91() {
    return this.i8x_1.no(this, glDisableVertexAttribArray$factory_0());
  }
  w91() {
    return this.j8x_1.no(this, glEnableVertexAttribArray$factory_0());
  }
  y91() {
    return this.k8x_1.no(this, glFramebufferRenderbuffer$factory_0());
  }
  z91() {
    return this.l8x_1.no(this, glFramebufferTexture2D$factory_0());
  }
  b92() {
    return this.m8x_1.no(this, glGenBuffers$factory_0());
  }
  c92() {
    return this.n8x_1.no(this, glGenerateMipmap$factory_0());
  }
  d92() {
    return this.o8x_1.no(this, glGenFramebuffers$factory_0());
  }
  e92() {
    return this.p8x_1.no(this, glGenRenderbuffers$factory_0());
  }
  z94() {
    return this.q8x_1.no(this, glGetActiveAttrib$factory_0());
  }
  a95() {
    return this.r8x_1.no(this, glGetActiveUniform$factory_0());
  }
  b95() {
    return this.s8x_1.no(this, glGetAttachedShaders$factory_0());
  }
  c95() {
    return this.t8x_1.no(this, glGetAttribLocation$factory_0());
  }
  g92() {
    return this.u8x_1.no(this, glGetUniformLocation$factory_0());
  }
  d95() {
    return this.v8x_1.no(this, glGetBufferParameteriv$factory_0());
  }
  e95() {
    return this.w8x_1.no(this, glGetFramebufferAttachmentParameteriv$factory_0());
  }
  f95() {
    return this.x8x_1.no(this, glGetProgramInfoLog$factory_0());
  }
  g95() {
    return this.y8x_1.no(this, glGetRenderbufferParameteriv$factory_0());
  }
  j92() {
    return this.z8x_1.no(this, glGetProgramiv$factory_0());
  }
  k92() {
    return this.a8y_1.no(this, glGetShaderiv$factory_0());
  }
  l92() {
    return this.b8y_1.no(this, glGetShaderInfoLog$factory_0());
  }
  h95() {
    return this.c8y_1.no(this, glGetShaderPrecisionFormat$factory_0());
  }
  i95() {
    return this.d8y_1.no(this, glGetShaderSource$factory_0());
  }
  j95() {
    return this.e8y_1.no(this, glGetUniformfv$factory_0());
  }
  k95() {
    return this.f8y_1.no(this, glGetUniformiv$factory_0());
  }
  l95() {
    return this.g8y_1.no(this, glGetVertexAttribfv$factory_0());
  }
  m95() {
    return this.h8y_1.no(this, glGetVertexAttribiv$factory_0());
  }
  n95() {
    return this.i8y_1.no(this, glGetVertexAttribPointerv$factory_0());
  }
  o95() {
    return this.j8y_1.no(this, glIsBuffer$factory_0());
  }
  p95() {
    return this.k8y_1.no(this, glIsFramebuffer$factory_0());
  }
  q95() {
    return this.l8y_1.no(this, glIsProgram$factory_0());
  }
  r95() {
    return this.m8y_1.no(this, glIsRenderbuffer$factory_0());
  }
  s95() {
    return this.n8y_1.no(this, glIsTexture$factory_0());
  }
  t95() {
    return this.o8y_1.no(this, glIsShader$factory_0());
  }
  n92() {
    return this.p8y_1.no(this, glLinkProgram$factory_0());
  }
  u95() {
    return this.q8y_1.no(this, glReleaseShaderCompiler$factory_0());
  }
  p92() {
    return this.r8y_1.no(this, glRenderbufferStorage$factory_0());
  }
  v95() {
    return this.s8y_1.no(this, glSampleCoverage$factory_0());
  }
  w95() {
    return this.t8y_1.no(this, glShaderBinary$factory_0());
  }
  r92() {
    return this.u8y_1.no(this, glShaderSource$factory_0());
  }
  t92() {
    return this.v8y_1.no(this, glStencilFuncSeparate$factory_0());
  }
  v92() {
    return this.w8y_1.no(this, glStencilMaskSeparate$factory_0());
  }
  x92() {
    return this.x8y_1.no(this, glStencilOpSeparate$factory_0());
  }
  x95() {
    return this.y8y_1.no(this, glUniform1f$factory_0());
  }
  y95() {
    return this.z8y_1.no(this, glUniform2f$factory_0());
  }
  z95() {
    return this.a8z_1.no(this, glUniform3f$factory_0());
  }
  a96() {
    return this.b8z_1.no(this, glUniform4f$factory_0());
  }
  b93() {
    return this.c8z_1.no(this, glUniform1i$factory_0());
  }
  b96() {
    return this.d8z_1.no(this, glUniform2i$factory_0());
  }
  c96() {
    return this.e8z_1.no(this, glUniform3i$factory_0());
  }
  d96() {
    return this.f8z_1.no(this, glUniform4i$factory_0());
  }
  a93() {
    return this.g8z_1.no(this, glUniform1fv$factory_0());
  }
  d93() {
    return this.h8z_1.no(this, glUniform2fv$factory_0());
  }
  f93() {
    return this.i8z_1.no(this, glUniform3fv$factory_0());
  }
  h93() {
    return this.j8z_1.no(this, glUniform4fv$factory_0());
  }
  c93() {
    return this.k8z_1.no(this, glUniform1iv$factory_0());
  }
  e93() {
    return this.l8z_1.no(this, glUniform2iv$factory_0());
  }
  g93() {
    return this.m8z_1.no(this, glUniform3iv$factory_0());
  }
  i93() {
    return this.n8z_1.no(this, glUniform4iv$factory_0());
  }
  j93() {
    return this.o8z_1.no(this, glUniformMatrix2fv$factory_0());
  }
  k93() {
    return this.p8z_1.no(this, glUniformMatrix3fv$factory_0());
  }
  l93() {
    return this.q8z_1.no(this, glUniformMatrix4fv$factory_0());
  }
  m93() {
    return this.r8z_1.no(this, glUseProgram$factory_0());
  }
  e96() {
    return this.s8z_1.no(this, glValidateProgram$factory_0());
  }
  f96() {
    return this.t8z_1.no(this, glVertexAttrib1f$factory_0());
  }
  g96() {
    return this.u8z_1.no(this, glVertexAttrib2f$factory_0());
  }
  h96() {
    return this.v8z_1.no(this, glVertexAttrib3f$factory_0());
  }
  i96() {
    return this.w8z_1.no(this, glVertexAttrib4f$factory_0());
  }
  j96() {
    return this.x8z_1.no(this, glVertexAttrib1fv$factory_0());
  }
  k96() {
    return this.y8z_1.no(this, glVertexAttrib2fv$factory_0());
  }
  l96() {
    return this.z8z_1.no(this, glVertexAttrib3fv$factory_0());
  }
  s93() {
    return this.a90_1.no(this, glBindBufferRange$factory_0());
  }
  t93() {
    return this.b90_1.no(this, glGetUniformBlockIndex$factory_0());
  }
  u93() {
    return this.c90_1.no(this, glUniformBlockBinding$factory_0());
  }
  v93() {
    return this.d90_1.no(this, glGenVertexArrays$factory_0());
  }
  m96() {
    return this.e90_1.no(this, glDeleteVertexArrays$factory_0());
  }
  w93() {
    return this.f90_1.no(this, glBindVertexArray$factory_0());
  }
}
class SDLGameWindow$ag$1 extends KmlGlContext {
  constructor(this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.q96_1 = this$0;
    super(this$0.f99_1, new KmlGlOpenGL(), VOID, $box);
  }
  p7e() {
    var tmp = this.q96_1.e99_1.b8u();
    var tmp_0 = this.i7d_1;
    tmp(tmp_0 instanceof DenoPointer ? tmp_0 : THROW_CCE(), this.q96_1.g99_1);
  }
  r7e() {
    var tmp = this.q96_1.e99_1.b8u();
    var tmp_0 = this.i7d_1;
    tmp(tmp_0 instanceof DenoPointer ? tmp_0 : THROW_CCE(), null);
  }
  n6() {
    this.q96_1.e99_1.a8u()(this.q96_1.g99_1);
  }
}
class SDLGameWindow extends GameWindow {
  static l99(size, config) {
    size = size === VOID ? Size2D.h2b(640, 480) : size;
    config = config === VOID ? Companion_getInstance_74().h8r_1 : config;
    var $this = this.h8p();
    $this.c99_1 = size;
    $this.d99_1 = config;
    $this.e99_1 = SDL.p8t();
    $this.f99_1 = $this.e99_1.r8t()($this.d99_1.s8r_1, 805240832, 805240832, numberToInt($this.c99_1.f2b_1), numberToInt($this.c99_1.g2b_1), 34);
    $this.g99_1 = $this.e99_1.z8t()($this.f99_1);
    $this.e99_1.v8t()($this.f99_1);
    var tmp = $this;
    tmp.h99_1 = AGOpengl.h7d(new SDLGameWindow$ag$1($this));
    $this.i99_1 = $this.y8p().w77_1;
    $this.j99_1 = '';
    $this.k99_1 = CreateFFIMemory(1024);
    return $this;
  }
  y8p() {
    return this.h99_1;
  }
  f8q(value) {
    this.j99_1 = value;
    this.e99_1.s8t()(this.f99_1, this.m99());
  }
  m99() {
    return this.j99_1;
  }
  o8q(width, height) {
    this.e99_1.t8t()(this.f99_1, width, height);
    this.e99_1.u8t()(this.f99_1, 805240832, 805240832);
  }
  n99() {
    // Inline function 'korlibs.ffi.usePointer' call
    var this_0 = this.k99_1;
    var it = get_pointer(Deno.UnsafePointer.of(this_0));
    while (this.e99_1.x8t()(it)) {
      var type = getS32(it, 0);
      switch (type) {
        case 512:
          println('WINDOW EVENT');
          break;
        case 1024:
          println('MOUSE MOTION');
          break;
        case 1025:
          println('MOUSE DOWN');
          break;
        case 1026:
          println('MOUSE UP');
          break;
        case 256:
          this.r8q();
          break;
        default:
          println('EVENT: type=' + type);
          break;
      }
    }
    this.e99_1.b8u()(this.f99_1, this.g99_1);
    this.i99_1.q7d(1.0, 0.0, 0.0, 1.0);
    this.i99_1.v7d(16384);
  }
  o99() {
    this.e99_1.c8u()(this.f99_1);
  }
  k1f(exitCode) {
    super.k1f(exitCode);
    this.e99_1.a8u()(this.g99_1);
    this.e99_1.y8t()();
  }
}
class Size3D {
  constructor(width, height, depthOrArrayLayers) {
    height = height === VOID ? 1 : height;
    depthOrArrayLayers = depthOrArrayLayers === VOID ? 1 : depthOrArrayLayers;
    this.width = width;
    this.height = height;
    this.depthOrArrayLayers = depthOrArrayLayers;
  }
  x8c(_set____db54di) {
    this.width = _set____db54di;
  }
  d2m() {
    return this.width;
  }
  y8c(_set____db54di) {
    this.height = _set____db54di;
  }
  e2m() {
    return this.height;
  }
  p99(_set____db54di) {
    this.depthOrArrayLayers = _set____db54di;
  }
  q99() {
    return this.depthOrArrayLayers;
  }
  toArray() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.width, this.height, this.depthOrArrayLayers];
  }
  nl() {
    return this.width;
  }
  ol() {
    return this.height;
  }
  vr() {
    return this.depthOrArrayLayers;
  }
  r99(width, height, depthOrArrayLayers) {
    return new Size3D(width, height, depthOrArrayLayers);
  }
  copy(width, height, depthOrArrayLayers, $super) {
    width = width === VOID ? this.width : width;
    height = height === VOID ? this.height : height;
    depthOrArrayLayers = depthOrArrayLayers === VOID ? this.depthOrArrayLayers : depthOrArrayLayers;
    return this.r99(width, height, depthOrArrayLayers);
  }
  toString() {
    return 'Size3D(width=' + this.width + ', height=' + this.height + ', depthOrArrayLayers=' + this.depthOrArrayLayers + ')';
  }
  hashCode() {
    var result = this.width;
    result = imul(result, 31) + this.height | 0;
    result = imul(result, 31) + this.depthOrArrayLayers | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Size3D))
      return false;
    var tmp0_other_with_cast = other instanceof Size3D ? other : THROW_CCE();
    if (!(this.width === tmp0_other_with_cast.width))
      return false;
    if (!(this.height === tmp0_other_with_cast.height))
      return false;
    if (!(this.depthOrArrayLayers === tmp0_other_with_cast.depthOrArrayLayers))
      return false;
    return true;
  }
}
class AGOpenglFactory {
  o8b() {
    // Inline function 'kotlin.js.unsafeCast' call
    return 'ontouchstart' in window || navigator.maxTouchPoints;
  }
}
class KmlGlJsCanvas extends KmlGl {
  constructor(canvas, glOpts) {
    super();
    this.w99_1 = canvas;
    this.x99_1 = glOpts;
    this.y99_1 = 1;
    var tmp = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_0;
    if (null == null) {
      var tmp1_safe_receiver = this.w99_1.getContext('webgl2', this.x99_1);
      var tmp_1;
      if (tmp1_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>' call
        this.y99_1 = 2;
        tmp_1 = tmp1_safe_receiver;
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = null;
    }
    var tmp2_elvis_lhs = tmp_0;
    var tmp3_elvis_lhs = tmp2_elvis_lhs == null ? this.w99_1.getContext('webgl', this.x99_1) : tmp2_elvis_lhs;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp4_safe_receiver = tmp3_elvis_lhs == null ? this.w99_1.getContext('experimental-webgl', this.x99_1) : tmp3_elvis_lhs;
    var tmp_2;
    if (tmp4_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>' call
      println('Created WebGL version=' + this.y99_1 + ', opts=' + JSON.stringify(this.x99_1));
      tmp_2 = tmp4_safe_receiver;
    }
    var tmp5_safe_receiver = tmp_2;
    var tmp_3;
    if (tmp5_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>' call
      tmp5_safe_receiver.getExtension('OES_standard_derivatives');
      tmp5_safe_receiver.getExtension('OES_texture_float');
      tmp5_safe_receiver.getExtension('OES_texture_float_linear');
      tmp5_safe_receiver.getExtension('OES_element_index_uint');
      tmp_3 = tmp5_safe_receiver;
    }
    var tmp6_elvis_lhs = tmp_3;
    var tmp_4;
    if (tmp6_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      try {
        var tmp0_safe_receiver = document.body;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.apply' call
          var tmp_5 = document.createElement('div');
          var this_0 = tmp_5 instanceof HTMLElement ? tmp_5 : THROW_CCE();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>.<anonymous>' call
          this_0.style.color = 'red';
          this_0.style.font = '30px Arial';
          this_0.innerText = "Can't get webgl context. Running in an android emulator without cross-walk?";
          tmp0_safe_receiver.prepend(this_0);
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
      var message = "Can't get webgl context";
      throw IllegalStateException.h5(toString(message));
    } else {
      tmp_4 = tmp6_elvis_lhs;
    }
    tmp.z99_1 = tmp_4;
    var tmp_6 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp_6.a9a_1 = fillArrayVal(Array(8192), null);
    this.b9a_1 = toMutableList(reversed_0(until(1, this.a9a_1.length)));
    var tmp_7 = this;
    tmp_7.c9a_1 = lazy(KmlGlJsCanvas$extensions$delegate$lambda(this));
    var tmp_8 = this;
    tmp_8.d9a_1 = lazy(KmlGlJsCanvas$isFloatTextureSupported$delegate$lambda(this));
    this.e9a_1 = new WebGLExtension(this, 'ANGLE_instanced_arrays', 2, listOf_0(['drawArraysInstanced', 'drawElementsInstanced', 'vertexAttribDivisor']), 'ANGLE');
    this.f9a_1 = new WebGLExtension(this, 'OES_vertex_array_object', 2, listOf_0(['createVertexArrayOES', 'deleteVertexArrayOES', 'isVertexArrayOES', 'bindVertexArrayOES']), 'OES');
  }
  s7c() {
    return Companion_instance_54.y7j(this.y99_1);
  }
  r7c(texture) {
    return this.z99_1.activeTexture(texture);
  }
  w7g(program, shader) {
    return this.z99_1.attachShader(get_2(program, this), get_2(shader, this));
  }
  v7g(program, index, name) {
    return this.z99_1.bindAttribLocation(get_2(program, this), index, name);
  }
  l7b(target, buffer) {
    return this.z99_1.bindBuffer(target, get_2(buffer, this));
  }
  o7f(target, framebuffer) {
    return this.z99_1.bindFramebuffer(target, get_2(framebuffer, this));
  }
  v7f(target, renderbuffer) {
    return this.z99_1.bindRenderbuffer(target, get_2(renderbuffer, this));
  }
  m7f(target, texture) {
    return this.z99_1.bindTexture(target, get_2(texture, this));
  }
  z7d(modeRGB, modeAlpha) {
    return this.z99_1.blendEquationSeparate(modeRGB, modeAlpha);
  }
  a7e(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha) {
    return this.z99_1.blendFuncSeparate(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha);
  }
  v7c(target, size, data, usage) {
    return this.z99_1.bufferData(target, get_arrayUByte(sliceBuffer(data, 0, size)), usage);
  }
  u7c(target, offset, size, data) {
    return this.z99_1.bufferSubData(target, offset, get_arrayUByte(sliceBuffer(data, 0, size)));
  }
  v7d(mask) {
    return this.z99_1.clear(mask);
  }
  q7d(red, green, blue, alpha) {
    return this.z99_1.clearColor(red, green, blue, alpha);
  }
  s7d(d) {
    return this.z99_1.clearDepth(d);
  }
  u7d(s) {
    return this.z99_1.clearStencil(s);
  }
  c7g(red, green, blue, alpha) {
    return this.z99_1.colorMask(red, green, blue, alpha);
  }
  n7g(shader) {
    return this.z99_1.compileShader(get_2(shader, this));
  }
  p7g() {
    return alloc(this.z99_1.createProgram(), this);
  }
  l7g(type) {
    return alloc(this.z99_1.createShader(type), this);
  }
  s7e(mode) {
    return this.z99_1.cullFace(mode);
  }
  t85(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.z99_1.deleteBuffer(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  u85(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.z99_1.deleteFramebuffer(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  k7g(program) {
    return this.z99_1.deleteProgram(get_2(program, this));
  }
  v85(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.z99_1.deleteRenderbuffer(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  j7g(shader) {
    return this.z99_1.deleteShader(get_2(shader, this));
  }
  w85(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.z99_1.deleteTexture(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  b7g(func) {
    return this.z99_1.depthFunc(func);
  }
  r7d(flag) {
    return this.z99_1.depthMask(flag);
  }
  a7g(n, f) {
    return this.z99_1.depthRange(n, f);
  }
  e7e(cap) {
    return this.z99_1.disable(cap);
  }
  u7e(index) {
    return this.z99_1.disableVertexAttribArray(index);
  }
  l7e(mode, first, count) {
    return this.z99_1.drawArrays(mode, first, count);
  }
  n7e(mode, count, type, indices) {
    return this.z99_1.drawElements(mode, count, type, indices);
  }
  f7e(cap) {
    return this.z99_1.enable(cap);
  }
  y7e(index) {
    return this.z99_1.enableVertexAttribArray(index);
  }
  yc() {
    return this.z99_1.flush();
  }
  y7f(target, attachment, renderbuffertarget, renderbuffer) {
    return this.z99_1.framebufferRenderbuffer(target, attachment, renderbuffertarget, get_2(renderbuffer, this));
  }
  x7f(target, attachment, textarget, texture, level) {
    return this.z99_1.framebufferTexture2D(target, attachment, textarget, get_2(texture, this), level);
  }
  z7f(mode) {
    return this.z99_1.frontFace(mode);
  }
  x85(n, buffers) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(buffers)[p] = alloc(this.z99_1.createBuffer(), this);
      }
       while (inductionVariable < n);
  }
  z7c(target) {
    return this.z99_1.generateMipmap(target);
  }
  y85(n, framebuffers) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(framebuffers)[p] = alloc(this.z99_1.createFramebuffer(), this);
      }
       while (inductionVariable < n);
  }
  z85(n, renderbuffers) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(renderbuffers)[p] = alloc(this.z99_1.createRenderbuffer(), this);
      }
       while (inductionVariable < n);
  }
  a86(n, textures) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(textures)[p] = alloc(this.z99_1.createTexture(), this);
      }
       while (inductionVariable < n);
  }
  h7g(program, name) {
    // Inline function 'kotlin.js.asDynamic' call
    var prg = get_2(program, this);
    if (prg.uniforms === undefined)
      prg.uniforms = {};
    if (prg.uniforms[name] === undefined) {
      prg.uniforms[name] = alloc(this.z99_1.getUniformLocation(prg, name), this);
    }
    // Inline function 'kotlin.js.unsafeCast' call
    return prg.uniforms[name];
  }
  o7g() {
    return this.z99_1.getError();
  }
  b86(pname, data) {
    // Inline function 'org.khronos.webgl.set' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    get_arrayInt(data)[0] = this.z99_1.getParameter(pname);
  }
  c86(program, pname, params) {
    // Inline function 'korlibs.kgl.KmlGl.INFO_LOG_LENGTH' call
    if (pname === 35716) {
      // Inline function 'org.khronos.webgl.set' call
      var this_0 = get_arrayInt(params);
      var tmp1_safe_receiver = this.z99_1.getProgramInfoLog(get_2(program, this));
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.length;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      this_0[0] = tmp3_elvis_lhs == null ? 1 : tmp3_elvis_lhs;
    } else {
      // Inline function 'org.khronos.webgl.set' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      get_arrayInt(params)[0] = this.z99_1.getProgramParameter(get_2(program, this), pname);
    }
  }
  d86(shader, pname, params) {
    // Inline function 'korlibs.kgl.KmlGl.INFO_LOG_LENGTH' call
    if (pname === 35716) {
      // Inline function 'org.khronos.webgl.set' call
      var this_0 = get_arrayInt(params);
      var tmp1_safe_receiver = this.z99_1.getShaderInfoLog(get_2(shader, this));
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.length;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      this_0[0] = tmp3_elvis_lhs == null ? 1 : tmp3_elvis_lhs;
    } else {
      // Inline function 'org.khronos.webgl.set' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      get_arrayInt(params)[0] = this.z99_1.getShaderParameter(get_2(shader, this), pname);
    }
  }
  e86(shader, bufSize, length, infoLog) {
    var tmp0_elvis_lhs = this.z99_1.getShaderInfoLog(get_2(shader, this));
    var str = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    // Inline function 'org.khronos.webgl.set' call
    // Inline function 'kotlin.js.asDynamic' call
    get_arrayInt(length)[0] = str.length;
    putAsciiString(infoLog, str);
  }
  g79(name) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.z99_1.getParameter(name);
  }
  x7g(program) {
    return this.z99_1.linkProgram(get_2(program, this));
  }
  w7c(pname, param) {
    return this.z99_1.pixelStorei(pname, param);
  }
  w7f(target, internalformat, width, height) {
    return this.z99_1.renderbufferStorage(target, internalformat, width, height);
  }
  d7g(x, y, width, height) {
    return this.z99_1.scissor(x, y, width, height);
  }
  m7g(shader, string) {
    return this.z99_1.shaderSource(get_2(shader, this), string);
  }
  h7e(func, ref, mask) {
    return this.z99_1.stencilFunc(func, ref, mask);
  }
  g7e(face, func, ref, mask) {
    return this.z99_1.stencilFuncSeparate(face, func, ref, mask);
  }
  t7d(mask) {
    return this.z99_1.stencilMask(mask);
  }
  k7e(face, mask) {
    return this.z99_1.stencilMaskSeparate(face, mask);
  }
  j7e(fail, zfail, zpass) {
    return this.z99_1.stencilOp(fail, zfail, zpass);
  }
  i7e(face, sfail, dpfail, dppass) {
    return this.z99_1.stencilOpSeparate(face, sfail, dpfail, dppass);
  }
  x7c(target, level, internalformat, width, height, border, format, type, pixels) {
    var tmp;
    // Inline function 'korlibs.kgl.KmlGl.FLOAT' call
    if (type === 5126) {
      tmp = pixels == null ? null : get_arrayFloat(pixels);
    } else {
      tmp = pixels == null ? null : get_arrayUByte(pixels);
    }
    var vpixels = tmp;
    this.z99_1.texImage2D(target, level, internalformat, width, height, border, format, type, vpixels);
  }
  y7c(target, level, internalformat, format, type, data) {
    if (data instanceof HtmlNativeImage) {
      // Inline function 'korlibs.math.toInt' call
      var tmp$ret$0 = !data.g3z_1 && data.f3z_1 ? 1 : 0;
      this.z99_1.pixelStorei(37441, tmp$ret$0);
      this.z99_1.texImage2D(target, level, internalformat, format, type, data.y5q_1);
      this.z99_1.pixelStorei(37441, 0);
    } else {
      return super.y7c(target, level, internalformat, format, type, data);
    }
  }
  q7c(target, pname, param) {
    return this.z99_1.texParameteri(target, pname, param);
  }
  m7c(location, count, value) {
    return this.z99_1.uniform1fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 1)));
  }
  k7a(location, v0) {
    return this.z99_1.uniform1i(get_2(location, this), v0);
  }
  f7c(location, count, value) {
    return this.z99_1.uniform1iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 1)));
  }
  n7c(location, count, value) {
    return this.z99_1.uniform2fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 2)));
  }
  g7c(location, count, value) {
    return this.z99_1.uniform2iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 2)));
  }
  o7c(location, count, value) {
    return this.z99_1.uniform3fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 3)));
  }
  h7c(location, count, value) {
    return this.z99_1.uniform3iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 3)));
  }
  p7c(location, count, value) {
    return this.z99_1.uniform4fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 4)));
  }
  i7c(location, count, value) {
    return this.z99_1.uniform4iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 4)));
  }
  j7c(location, count, transpose, value) {
    return this.z99_1.uniformMatrix2fv(get_2(location, this), transpose, get_arrayFloat(value).subarray(0, imul(count, 4)));
  }
  k7c(location, count, transpose, value) {
    return this.z99_1.uniformMatrix3fv(get_2(location, this), transpose, get_arrayFloat(value).subarray(0, imul(count, 9)));
  }
  l7c(location, count, transpose, value) {
    return this.z99_1.uniformMatrix4fv(get_2(location, this), transpose, get_arrayFloat(value).subarray(0, imul(count, 16)));
  }
  i7g(program) {
    return this.z99_1.useProgram(get_2(program, this));
  }
  z7e(index, size, type, normalized, stride, pointer) {
    return this.z99_1.vertexAttribPointer(index, size, type, normalized, stride, pointer.j2());
  }
  n7f(x, y, width, height) {
    return this.z99_1.viewport(x, y, width, height);
  }
  o5v() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.c9a_1;
    extensions$factory();
    return this_0.s1();
  }
  m7e(mode, first, count, instancecount) {
    // Inline function 'kotlin.js.asDynamic' call
    this.z99_1.drawArraysInstanced(mode, first, count, instancecount);
  }
  o7e(mode, count, type, indices, instancecount) {
    // Inline function 'kotlin.js.asDynamic' call
    this.z99_1.drawElementsInstanced(mode, count, type, indices, instancecount);
  }
  t7e(index, divisor) {
    // Inline function 'kotlin.js.asDynamic' call
    this.z99_1.vertexAttribDivisor(index, divisor);
  }
  g6o() {
    return get_versionInt(this) >= 2;
  }
  g7f(target, index, buffer, offset, size) {
    // Inline function 'kotlin.js.asDynamic' call
    this.z99_1.bindBufferRange(target, index, get_2(buffer, this), offset, size);
  }
  l7a(program, name) {
    // Inline function 'kotlin.js.asDynamic' call
    return this.z99_1.getUniformBlockIndex(get_2(program, this), name);
  }
  m7a(program, uniformBlockIndex, uniformBlockBinding) {
    // Inline function 'kotlin.js.asDynamic' call
    this.z99_1.uniformBlockBinding(get_2(program, this), uniformBlockIndex, uniformBlockBinding);
  }
  h6o() {
    return this.f9a_1.n9a();
  }
  f86(n, arrays) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = this.z99_1.createVertexArray();
        setInt32(arrays, i, alloc(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  v7e(array) {
    // Inline function 'kotlin.js.asDynamic' call
    this.z99_1.bindVertexArray(get_2(array, this));
  }
}
class WebGLExtension {
  constructor(canvas, name, coreSince, functions, suffix) {
    coreSince = coreSince === VOID ? 1000 : coreSince;
    functions = functions === VOID ? emptyList() : functions;
    suffix = suffix === VOID ? '' : suffix;
    this.g9a_1 = canvas;
    this.h9a_1 = name;
    this.i9a_1 = coreSince;
    this.j9a_1 = functions;
    this.k9a_1 = suffix;
    this.l9a_1 = false;
    this.m9a_1 = null;
  }
  s1() {
    if (!this.l9a_1) {
      this.l9a_1 = true;
      this.m9a_1 = this.g9a_1.z99_1.getExtension(this.h9a_1);
      var _iterator__ex2g4s = this.j9a_1.b1();
      while (_iterator__ex2g4s.c1()) {
        var func = _iterator__ex2g4s.d1();
        var base = removeSuffix(func, this.k9a_1);
        var vfunc = this.m9a_1[func];
        if (typeof vfunc === 'function') {
          // Inline function 'kotlin.js.asDynamic' call
          this.g9a_1.z99_1[base] = vfunc.bind(this.m9a_1);
        }
      }
    }
    return this.m9a_1;
  }
  n9a() {
    return this.g9a_1.y99_1 >= this.i9a_1 || this.s1() != null;
  }
}
class KorgeReloadInternal$1 extends KorgeReloadInternalImpl {}
class JsGameWindow extends GameWindow {
  static h9l() {
    return this.h8p();
  }
}
class NodeJsGameWindow extends JsGameWindow {
  static a9g() {
    return this.h9l();
  }
}
class BrowserCanvasJsGameWindow$close$slambda {
  constructor(this$0) {
    this.i9l_1 = this$0;
  }
  ce($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
  }
}
class BrowserCanvasJsGameWindow$loop$slambda {
  constructor($entry, this$0) {
    this.j9l_1 = $entry;
    this.k9l_1 = this$0;
  }
  ce($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
  }
}
class BrowserCanvasJsGameWindow extends JsGameWindow {
  static o9d(canvas) {
    canvas = canvas === VOID ? AGDefaultCanvas() : canvas;
    var $this = this.h9l();
    $this.z9c_1 = canvas;
    $this.a9d_1 = AGWebgl(new AGConfig(), $this.z9c_1);
    $this.b9d_1 = new DialogInterfaceJs();
    $this.c9d_1 = null;
    var tmp = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d9d_1 = [GameButton_BUTTON_SOUTH_getInstance(), GameButton_BUTTON_EAST_getInstance(), GameButton_BUTTON_WEST_getInstance(), GameButton_BUTTON_NORTH_getInstance(), GameButton_L1_getInstance(), GameButton_R1_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_SELECT_getInstance(), GameButton_START_getInstance(), GameButton_L3_getInstance(), GameButton_R3_getInstance(), GameButton_UP_getInstance(), GameButton_DOWN_getInstance(), GameButton_LEFT_getInstance(), GameButton_RIGHT_getInstance(), GameButton_SYSTEM_getInstance()];
    var tmp_0 = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0.e9d_1 = [GameButton_LX_getInstance(), GameButton_LY_getInstance(), GameButton_RX_getInstance(), GameButton_RY_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_DPADX_getInstance(), GameButton_DPADY_getInstance()];
    $this.f9d_1 = new GamepadInfo();
    $this.g9d_1 = Quality_AUTOMATIC_getInstance();
    $this.h9d_1 = 1.0;
    $this.i9d_1 = new TouchBuilder();
    $this.j9d_1 = Cursor_DEFAULT_getInstance();
    $this.k9d_1 = null;
    $this.l9d_1 = null;
    // Inline function 'kotlin.js.asDynamic' call
    window.canvas = $this.z9c_1;
    // Inline function 'kotlin.js.asDynamic' call
    window.ag = $this.y8p();
    // Inline function 'kotlin.js.asDynamic' call
    window.gl = $this.y8p().w77_1;
    if (get_isCanvasCreatedAndHandled()) {
      var tmp0_safe_receiver = document.body;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.appendChild($this.z9c_1);
      var tmp1_safe_receiver = document.body;
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.style;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.margin = '0px';
      }
      var tmp3_safe_receiver = document.body;
      var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.style;
      if (tmp4_safe_receiver == null)
        null;
      else {
        tmp4_safe_receiver.padding = '0px';
      }
      var tmp5_safe_receiver = document.body;
      var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.style;
      if (tmp6_safe_receiver == null)
        null;
      else {
        tmp6_safe_receiver.overflowX = 'hidden';
      }
      var tmp7_safe_receiver = document.body;
      var tmp8_safe_receiver = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.style;
      if (tmp8_safe_receiver == null)
        null;
      else {
        tmp8_safe_receiver.overflowY = 'hidden';
      }
    }
    $this.z9c_1.addEventListener('wheel', BrowserCanvasJsGameWindow$lambda($this));
    $this.z9c_1.addEventListener('mouseenter', BrowserCanvasJsGameWindow$lambda_0($this));
    $this.z9c_1.addEventListener('mouseleave', BrowserCanvasJsGameWindow$lambda_1($this));
    $this.z9c_1.addEventListener('mouseover', BrowserCanvasJsGameWindow$lambda_2($this));
    $this.z9c_1.addEventListener('mousemove', BrowserCanvasJsGameWindow$lambda_3($this));
    $this.z9c_1.addEventListener('mouseout', BrowserCanvasJsGameWindow$lambda_4($this));
    $this.z9c_1.addEventListener('mouseup', BrowserCanvasJsGameWindow$lambda_5($this));
    $this.z9c_1.addEventListener('mousedown', BrowserCanvasJsGameWindow$lambda_6($this));
    $this.z9c_1.addEventListener('click', BrowserCanvasJsGameWindow$lambda_7($this));
    $this.z9c_1.addEventListener('touchstart', BrowserCanvasJsGameWindow$lambda_8($this));
    $this.z9c_1.addEventListener('touchmove', BrowserCanvasJsGameWindow$lambda_9($this));
    $this.z9c_1.addEventListener('touchend', BrowserCanvasJsGameWindow$lambda_10($this));
    var tmp_1 = window;
    tmp_1.addEventListener('keypress', BrowserCanvasJsGameWindow$lambda_11($this));
    var tmp_2 = window;
    tmp_2.addEventListener('keydown', BrowserCanvasJsGameWindow$lambda_12($this));
    var tmp_3 = window;
    tmp_3.addEventListener('keyup', BrowserCanvasJsGameWindow$lambda_13($this));
    var tmp_4 = window;
    tmp_4.addEventListener('resize', BrowserCanvasJsGameWindow$lambda_14($this));
    $this.z9c_1.ondragenter = BrowserCanvasJsGameWindow$lambda_15($this);
    $this.z9c_1.ondragexit = BrowserCanvasJsGameWindow$lambda_16($this);
    $this.z9c_1.ondragleave = BrowserCanvasJsGameWindow$lambda_17($this);
    $this.z9c_1.ondragover = BrowserCanvasJsGameWindow$lambda_18;
    $this.z9c_1.ondragstart = BrowserCanvasJsGameWindow$lambda_19($this);
    $this.z9c_1.ondragend = BrowserCanvasJsGameWindow$lambda_20($this);
    $this.z9c_1.ondrop = BrowserCanvasJsGameWindow$lambda_21($this);
    onResized($this);
    var tmp_5 = $this;
    tmp_5.m9d_1 = BrowserCanvasJsGameWindow$lambda_22($this);
    $this.n9d_1 = null;
    return $this;
  }
  m9l() {
    return window.devicePixelRatio;
  }
  w8i() {
    return this.m9l() <= 0.0 ? 1.0 : isNaN_0(this.m9l()) ? 1.0 : isInfinite(this.m9l()) ? 1.0 : this.m9l();
  }
  y8p() {
    return this.a9d_1;
  }
  l9l() {
    if (this.c9d_1 == null) {
      var tmp = this;
      var tmp_0;
      try {
        document.createEvent('TouchEvent');
        tmp_0 = true;
      } catch ($p) {
        var tmp_1;
        var e = $p;
        tmp_1 = false;
        tmp_0 = tmp_1;
      }
      tmp.c9d_1 = tmp_0;
    }
    return ensureNotNull(this.c9d_1);
  }
  c8r() {
    try {
      if (navigator.getGamepads != null) {
        // Inline function 'kotlin.js.unsafeCast' call
        var gamepads = navigator.getGamepads();
        this.q6k();
        var inductionVariable = 0;
        var last = gamepads.length;
        if (inductionVariable < last)
          $l$loop_0: do {
            var gamepadId = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.render.get' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp0_elvis_lhs = gamepads[gamepadId];
            var tmp;
            if (tmp0_elvis_lhs == null) {
              continue $l$loop_0;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            var controller = tmp;
            if (!(controller.mapping === 'standard'))
              continue $l$loop_0;
            var gamepad = this.f9d_1;
            gamepad.x6k_1 = controller.id;
            var inductionVariable_0 = 0;
            // Inline function 'kotlin.math.min' call
            var a = controller.buttons.length;
            var b = this.d9d_1.length;
            var last_0 = Math.min(a, b);
            if (inductionVariable_0 < last_0)
              do {
                var n = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var tmp_0 = gamepad.y6k_1;
                var tmp_1 = this.d9d_1[n].u6l();
                // Inline function 'korlibs.render.get' call
                // Inline function 'kotlin.js.asDynamic' call
                tmp_0[tmp_1] = controller.buttons[n].value;
              }
               while (inductionVariable_0 < last_0);
            var inductionVariable_1 = 0;
            // Inline function 'kotlin.math.min' call
            var a_0 = controller.axes.length;
            var b_0 = this.e9d_1.length;
            var last_1 = Math.min(a_0, b_0);
            if (inductionVariable_1 < last_1)
              do {
                var n_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var isX = (n_0 % 2 | 0) === 0;
                var isY = !isX;
                // Inline function 'korlibs.render.get' call
                // Inline function 'kotlin.js.asDynamic' call
                var value = controller.axes[n_0];
                var valueWithoutDeadRange = Companion_instance_24.p6l(value, VOID, n_0 <= 3);
                gamepad.y6k_1[this.e9d_1[n_0].u6l()] = isY ? -valueWithoutDeadRange : valueWithoutDeadRange;
              }
               while (inductionVariable_1 < last_1);
            this.c6l(gamepad);
          }
           while (inductionVariable < last);
        this.g8r();
      }
    } catch ($p) {
      var e = $p;
      // Inline function 'korlibs.logger.Logger.error' call
      var this_0 = CoroutineKey_getInstance().g8m_1;
      var level = Level_ERROR_getInstance();
      var tmp_2;
      if (this_0.x2x(level)) {
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.updateGamepads.<anonymous>' call
        this_0.y2x(level, e);
        tmp_2 = Unit_instance;
      }
    }
  }
  l8q(value) {
    if (!this.g9d_1.equals(value)) {
      this.g9d_1 = value;
      onResized(this);
    }
  }
  e8i() {
    return this.g9d_1;
  }
  f8q(value) {
    document.title = value;
  }
  d2m() {
    return this.z9c_1.clientWidth;
  }
  e2m() {
    return this.z9c_1.clientHeight;
  }
  w8p(value) {
    this.j9d_1 = value;
    var tmp = this.z9c_1.style;
    var tmp_0;
    if (value instanceof Cursor) {
      switch (value.r3_1) {
        case 0:
          tmp_0 = 'default';
          break;
        case 1:
          tmp_0 = 'crosshair';
          break;
        case 2:
          tmp_0 = 'text';
          break;
        case 3:
          tmp_0 = 'pointer';
          break;
        case 4:
          tmp_0 = 'move';
          break;
        case 5:
          tmp_0 = 'wait';
          break;
        case 6:
          tmp_0 = 'e-resize';
          break;
        case 7:
          tmp_0 = 'w-resize';
          break;
        case 8:
          tmp_0 = 's-resize';
          break;
        case 9:
          tmp_0 = 'n-resize';
          break;
        case 10:
          tmp_0 = 'ne-resize';
          break;
        case 11:
          tmp_0 = 'nw-resize';
          break;
        case 12:
          tmp_0 = 'se-resize';
          break;
        case 13:
          tmp_0 = 'sw-resize';
          break;
        default:
          tmp_0 = 'default';
          break;
      }
    } else {
      tmp_0 = 'default';
    }
    tmp.cursor = tmp_0;
  }
  x8p() {
    return this.j9d_1;
  }
  g8q(value) {
    this.k9d_1 = value;
    if (!(value == null)) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var link = document.querySelector("link[rel*='icon']");
      link.type = 'image/png';
      link.rel = 'shortcut icon';
      link.href = toHtmlNative(value).o5r();
      // Inline function 'org.w3c.dom.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp0_safe_receiver = document.getElementsByTagName('head')[0];
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.appendChild(link);
    } else {
      var tmp1_safe_receiver = document.querySelector("link[rel*='icon']");
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.remove();
      }
    }
  }
  h8q(value) {
    if (!(this.n9l() === value)) {
      // Inline function 'kotlin.runCatching' call
      var tmp;
      try {
        // Inline function 'kotlin.Companion.success' call
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.<set-fullscreen>.<anonymous>' call
        var tmp_0;
        if (value) {
          tmp_0 = this.z9c_1.requestFullscreen();
        } else {
          tmp_0 = document.exitFullscreen();
        }
        var value_0 = tmp_0;
        tmp = _Result___init__impl__xyqfz8(value_0);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'kotlin.Companion.failure' call
          tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
        } else {
          throw $p;
        }
        tmp = tmp_1;
      }
    }
  }
  n9l() {
    return !(document.fullscreenElement == null);
  }
  i8q(value) {
    this.z9c_1.style.visibility = value ? 'visible' : 'hidden';
  }
  o8q(width, height) {
  }
  k1f(exitCode) {
    var tmp = MainScope();
    launchImmediately_0(tmp, BrowserCanvasJsGameWindow$close$slambda_0(this));
    this.l9d_1 = null;
  }
  t8q(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loop__qll5p8_0.bind(VOID, this, entry), $completion);
  }
}
class DenoJsGameWindow$loop$slambda {
  constructor($entry, this$0) {
    this.o9l_1 = $entry;
    this.p9l_1 = this$0;
  }
  ce($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
  }
}
class DenoJsGameWindow extends SDLGameWindow {
  static v9i(size, config) {
    size = size === VOID ? Size2D.h2b(640, 480) : size;
    config = config === VOID ? Companion_getInstance_74().h8r_1 : config;
    return this.l99(size, config);
  }
  t8q(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loop__qll5p8_1.bind(VOID, this, entry), $completion);
  }
  k1f(exitCode) {
    super.k1f(exitCode);
    Deno.exit(exitCode);
  }
}
class DialogInterfaceJs {}
//endregion
function _get_now__e6dlkr($this) {
  return $this.y6d_1().qj_1;
}
function _queueAfter($this, time, interval, task) {
  // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
  var this_0 = $this.v6d_1;
  $l$block: {
    // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
    this_0.i1y();
    try {
      // Inline function 'korlibs.datastructure.event.SyncEventLoop._queueAfter.<anonymous>' call
      var task_0 = new TimedTask($this, _get_now__e6dlkr($this), time, interval, task);
      if ($this.w6d_1) {
        $this.a6e_1.o2q(task_0);
      } else {
        Console_getInstance().d2x(['WARNING: QUEUED TASK time=' + Duration__toString_impl_8d916b(time) + ' interval=' + interval + ' without running']);
      }
      $this.v6d_1.m1y();
      break $l$block;
    }finally {
      this_0.k1y();
    }
  }
  return task_0;
}
function SyncEventLoop$nowProvider$lambda(this$0) {
  return function () {
    return new Duration(ValueTimeMark__elapsedNow_impl_eonqvs(this$0.x6d_1));
  };
}
function SyncEventLoop$timedTasks$lambda(a, b) {
  return a.q6d(b);
}
function SyncEventLoop$uncatchedExceptionHandler$lambda(it) {
  printStackTrace(it);
  return Unit_instance;
}
function paused$factory($b0) {
  return getPropertyCallableRef('paused', 0, KMutableProperty0, function () {
    return $b0.l2v_1;
  }, function (value) {
    return $b0.m2v(value);
  });
}
function __updateChildListenerCount($this, type, delta) {
  if (delta === 0)
    return Unit_instance;
  if ($this.u6e_1 == null)
    $this.u6e_1 = FastIdentityMap();
  var tmp0_safe_receiver = $this.u6e_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp1_elvis_lhs = get_0(ensureNotNull($this.u6e_1), type);
    set(tmp0_safe_receiver, type, (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) + delta | 0);
  }
  var tmp2_safe_receiver = $this.s6e_1;
  if (tmp2_safe_receiver == null)
    null;
  else {
    __updateChildListenerCount(tmp2_safe_receiver, type, delta);
  }
}
function __updateChildListenerCount_0($this, child, add) {
  var tmp0_safe_receiver = child.u6e_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.fastForEach' call
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = tmp0_safe_receiver.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.event.BaseEventListener.__updateChildListenerCount.<anonymous>' call
      var i = ensureNotNull(get_0(tmp0_safe_receiver, it));
      __updateChildListenerCount($this, it, add ? +i : -i | 0);
    }
  }
}
var Companion_instance_8;
function Companion_getInstance_14() {
  return Companion_instance_8;
}
var Companion_instance_9;
function Companion_getInstance_15() {
  return Companion_instance_9;
}
var Companion_instance_10;
function Companion_getInstance_16() {
  return Companion_instance_10;
}
var Companion_instance_11;
function Companion_getInstance_17() {
  return Companion_instance_11;
}
var Companion_instance_12;
function Companion_getInstance_18() {
  if (Companion_instance_12 === VOID)
    new Companion_3();
  return Companion_instance_12;
}
var Companion_instance_13;
function Companion_getInstance_19() {
  if (Companion_instance_13 === VOID)
    new Companion_4();
  return Companion_instance_13;
}
var Companion_instance_14;
function Companion_getInstance_20() {
  return Companion_instance_14;
}
var Companion_instance_15;
function Companion_getInstance_21() {
  return Companion_instance_15;
}
var Companion_instance_16;
function Companion_getInstance_22() {
  return Companion_instance_16;
}
var Type_UP_instance;
var Type_DOWN_instance;
var Type_TYPE_instance;
var Companion_instance_17;
function Companion_getInstance_23() {
  Type_initEntries();
  if (Companion_instance_17 === VOID)
    new Companion_8();
  return Companion_instance_17;
}
function values() {
  return [Type_UP_getInstance(), Type_DOWN_getInstance(), Type_TYPE_getInstance()];
}
var Type_entriesInitialized;
function Type_initEntries() {
  if (Type_entriesInitialized)
    return Unit_instance;
  Type_entriesInitialized = true;
  Type_UP_instance = new Type('UP', 0);
  Type_DOWN_instance = new Type('DOWN', 1);
  Type_TYPE_instance = new Type('TYPE', 2);
  Companion_getInstance_23();
}
function Type_UP_getInstance() {
  Type_initEntries();
  return Type_UP_instance;
}
function Type_DOWN_getInstance() {
  Type_initEntries();
  return Type_DOWN_instance;
}
function Type_TYPE_getInstance() {
  Type_initEntries();
  return Type_TYPE_instance;
}
var Type_MOVE_instance;
var Type_DRAG_instance;
var Type_UP_instance_0;
var Type_DOWN_instance_0;
var Type_CLICK_instance;
var Type_ENTER_instance;
var Type_EXIT_instance;
var Type_SCROLL_instance;
var Companion_instance_18;
function Companion_getInstance_24() {
  Type_initEntries_0();
  if (Companion_instance_18 === VOID)
    new Companion_9();
  return Companion_instance_18;
}
function values_0() {
  return [Type_MOVE_getInstance(), Type_DRAG_getInstance(), Type_UP_getInstance_0(), Type_DOWN_getInstance_0(), Type_CLICK_getInstance(), Type_ENTER_getInstance(), Type_EXIT_getInstance(), Type_SCROLL_getInstance()];
}
var Type_entriesInitialized_0;
function Type_initEntries_0() {
  if (Type_entriesInitialized_0)
    return Unit_instance;
  Type_entriesInitialized_0 = true;
  Type_MOVE_instance = new Type_0('MOVE', 0);
  Type_DRAG_instance = new Type_0('DRAG', 1);
  Type_UP_instance_0 = new Type_0('UP', 2);
  Type_DOWN_instance_0 = new Type_0('DOWN', 3);
  Type_CLICK_instance = new Type_0('CLICK', 4);
  Type_ENTER_instance = new Type_0('ENTER', 5);
  Type_EXIT_instance = new Type_0('EXIT', 6);
  Type_SCROLL_instance = new Type_0('SCROLL', 7);
  Companion_getInstance_24();
}
var ScrollDeltaMode_PIXEL_instance;
var ScrollDeltaMode_LINE_instance;
var ScrollDeltaMode_PAGE_instance;
var ScrollDeltaMode_entriesInitialized;
function ScrollDeltaMode_initEntries() {
  if (ScrollDeltaMode_entriesInitialized)
    return Unit_instance;
  ScrollDeltaMode_entriesInitialized = true;
  ScrollDeltaMode_PIXEL_instance = new ScrollDeltaMode('PIXEL', 0, 1.0);
  ScrollDeltaMode_LINE_instance = new ScrollDeltaMode('LINE', 1, 10.0);
  ScrollDeltaMode_PAGE_instance = new ScrollDeltaMode('PAGE', 2, 100.0);
}
function MouseEvent$requestLock$lambda() {
  return Unit_instance;
}
function Type_MOVE_getInstance() {
  Type_initEntries_0();
  return Type_MOVE_instance;
}
function Type_DRAG_getInstance() {
  Type_initEntries_0();
  return Type_DRAG_instance;
}
function Type_UP_getInstance_0() {
  Type_initEntries_0();
  return Type_UP_instance_0;
}
function Type_DOWN_getInstance_0() {
  Type_initEntries_0();
  return Type_DOWN_instance_0;
}
function Type_CLICK_getInstance() {
  Type_initEntries_0();
  return Type_CLICK_instance;
}
function Type_ENTER_getInstance() {
  Type_initEntries_0();
  return Type_ENTER_instance;
}
function Type_EXIT_getInstance() {
  Type_initEntries_0();
  return Type_EXIT_instance;
}
function Type_SCROLL_getInstance() {
  Type_initEntries_0();
  return Type_SCROLL_instance;
}
function ScrollDeltaMode_PIXEL_getInstance() {
  ScrollDeltaMode_initEntries();
  return ScrollDeltaMode_PIXEL_instance;
}
function ScrollDeltaMode_LINE_getInstance() {
  ScrollDeltaMode_initEntries();
  return ScrollDeltaMode_LINE_instance;
}
function ScrollDeltaMode_PAGE_getInstance() {
  ScrollDeltaMode_initEntries();
  return ScrollDeltaMode_PAGE_instance;
}
var Type_MAGNIFY_instance;
var Type_ROTATE_instance;
var Type_SWIPE_instance;
var Type_SMART_MAGNIFY_instance;
var Companion_instance_19;
function Companion_getInstance_25() {
  Type_initEntries_1();
  if (Companion_instance_19 === VOID)
    new Companion_10();
  return Companion_instance_19;
}
function values_1() {
  return [Type_MAGNIFY_getInstance(), Type_ROTATE_getInstance(), Type_SWIPE_getInstance(), Type_SMART_MAGNIFY_getInstance()];
}
var Type_entriesInitialized_1;
function Type_initEntries_1() {
  if (Type_entriesInitialized_1)
    return Unit_instance;
  Type_entriesInitialized_1 = true;
  Type_MAGNIFY_instance = new Type_1('MAGNIFY', 0);
  Type_ROTATE_instance = new Type_1('ROTATE', 1);
  Type_SWIPE_instance = new Type_1('SWIPE', 2);
  Type_SMART_MAGNIFY_instance = new Type_1('SMART_MAGNIFY', 3);
  Companion_getInstance_25();
}
function Type_MAGNIFY_getInstance() {
  Type_initEntries_1();
  return Type_MAGNIFY_instance;
}
function Type_ROTATE_getInstance() {
  Type_initEntries_1();
  return Type_ROTATE_instance;
}
function Type_SWIPE_getInstance() {
  Type_initEntries_1();
  return Type_SWIPE_instance;
}
function Type_SMART_MAGNIFY_getInstance() {
  Type_initEntries_1();
  return Type_SMART_MAGNIFY_instance;
}
var Type_START_instance;
var Type_END_instance;
var Type_DROP_instance;
var Companion_instance_20;
function Companion_getInstance_26() {
  Type_initEntries_2();
  if (Companion_instance_20 === VOID)
    new Companion_11();
  return Companion_instance_20;
}
function values_2() {
  return [Type_START_getInstance(), Type_END_getInstance(), Type_DROP_getInstance()];
}
var Type_entriesInitialized_2;
function Type_initEntries_2() {
  if (Type_entriesInitialized_2)
    return Unit_instance;
  Type_entriesInitialized_2 = true;
  Type_START_instance = new Type_2('START', 0);
  Type_END_instance = new Type_2('END', 1);
  Type_DROP_instance = new Type_2('DROP', 2);
  Companion_getInstance_26();
}
function Type_START_getInstance() {
  Type_initEntries_2();
  return Type_START_instance;
}
function Type_END_getInstance() {
  Type_initEntries_2();
  return Type_END_instance;
}
function Type_DROP_getInstance() {
  Type_initEntries_2();
  return Type_DROP_instance;
}
var Status_ADD_instance;
var Status_KEEP_instance;
var Status_REMOVE_instance;
var Status_entriesInitialized;
function Status_initEntries() {
  if (Status_entriesInitialized)
    return Unit_instance;
  Status_entriesInitialized = true;
  Status_ADD_instance = new Status('ADD', 0);
  Status_KEEP_instance = new Status('KEEP', 1);
  Status_REMOVE_instance = new Status('REMOVE', 2);
}
var Kind_FINGER_instance;
var Kind_MOUSE_instance;
var Kind_STYLUS_instance;
var Kind_ERASER_instance;
var Kind_UNKNOWN_instance;
var Kind_entriesInitialized;
function Kind_initEntries() {
  if (Kind_entriesInitialized)
    return Unit_instance;
  Kind_entriesInitialized = true;
  Kind_FINGER_instance = new Kind('FINGER', 0);
  Kind_MOUSE_instance = new Kind('MOUSE', 1);
  Kind_STYLUS_instance = new Kind('STYLUS', 2);
  Kind_ERASER_instance = new Kind('ERASER', 3);
  Kind_UNKNOWN_instance = new Kind('UNKNOWN', 4);
}
var Companion_instance_21;
function Companion_getInstance_27() {
  if (Companion_instance_21 === VOID)
    new Companion_12();
  return Companion_instance_21;
}
function Status_ADD_getInstance() {
  Status_initEntries();
  return Status_ADD_instance;
}
function Status_KEEP_getInstance() {
  Status_initEntries();
  return Status_KEEP_instance;
}
function Status_REMOVE_getInstance() {
  Status_initEntries();
  return Status_REMOVE_instance;
}
function Kind_FINGER_getInstance() {
  Kind_initEntries();
  return Kind_FINGER_instance;
}
function Kind_MOUSE_getInstance() {
  Kind_initEntries();
  return Kind_MOUSE_instance;
}
var Type_START_instance_0;
var Type_END_instance_0;
var Type_MOVE_instance_0;
var Type_HOVER_instance;
var Type_UNKNOWN_instance;
var Companion_instance_22;
function Companion_getInstance_28() {
  Type_initEntries_3();
  if (Companion_instance_22 === VOID)
    new Companion_13();
  return Companion_instance_22;
}
function values_3() {
  return [Type_START_getInstance_0(), Type_END_getInstance_0(), Type_MOVE_getInstance_0(), Type_HOVER_getInstance(), Type_UNKNOWN_getInstance()];
}
var Type_entriesInitialized_3;
function Type_initEntries_3() {
  if (Type_entriesInitialized_3)
    return Unit_instance;
  Type_entriesInitialized_3 = true;
  Type_START_instance_0 = new Type_3('START', 0);
  Type_END_instance_0 = new Type_3('END', 1);
  Type_MOVE_instance_0 = new Type_3('MOVE', 2);
  Type_HOVER_instance = new Type_3('HOVER', 3);
  Type_UNKNOWN_instance = new Type_3('UNKNOWN', 4);
  Companion_getInstance_28();
}
var Companion_instance_23;
function Companion_getInstance_29() {
  return Companion_instance_23;
}
function TouchEvent$toString$lambda(it) {
  return it.toString();
}
function Type_START_getInstance_0() {
  Type_initEntries_3();
  return Type_START_instance_0;
}
function Type_END_getInstance_0() {
  Type_initEntries_3();
  return Type_END_instance_0;
}
function Type_MOVE_getInstance_0() {
  Type_initEntries_3();
  return Type_MOVE_instance_0;
}
function Type_HOVER_getInstance() {
  Type_initEntries_3();
  return Type_HOVER_instance;
}
function Type_UNKNOWN_getInstance() {
  Type_initEntries_3();
  return Type_UNKNOWN_instance;
}
function invoke_0(_this__u8e3s4, block) {
  block(_this__u8e3s4);
  return _this__u8e3s4;
}
var Mode_JS_instance;
var Mode_Android_instance;
var Mode_IOS_instance;
var Mode_entriesInitialized;
function Mode_initEntries() {
  if (Mode_entriesInitialized)
    return Unit_instance;
  Mode_entriesInitialized = true;
  Mode_JS_instance = new Mode('JS', 0);
  Mode_Android_instance = new Mode('Android', 1);
  Mode_IOS_instance = new Mode('IOS', 2);
}
function Mode_JS_getInstance() {
  Mode_initEntries();
  return Mode_JS_instance;
}
var BatteryStatus_CHARGING_instance;
var BatteryStatus_DISCHARGING_instance;
var BatteryStatus_FULL_instance;
var BatteryStatus_UNKNOWN_instance;
var BatteryStatus_entriesInitialized;
function BatteryStatus_initEntries() {
  if (BatteryStatus_entriesInitialized)
    return Unit_instance;
  BatteryStatus_entriesInitialized = true;
  BatteryStatus_CHARGING_instance = new BatteryStatus('CHARGING', 0);
  BatteryStatus_DISCHARGING_instance = new BatteryStatus('DISCHARGING', 1);
  BatteryStatus_FULL_instance = new BatteryStatus('FULL', 2);
  BatteryStatus_UNKNOWN_instance = new BatteryStatus('UNKNOWN', 3);
}
var Companion_instance_24;
function Companion_getInstance_30() {
  return Companion_instance_24;
}
function BatteryStatus_UNKNOWN_getInstance() {
  BatteryStatus_initEntries();
  return BatteryStatus_UNKNOWN_instance;
}
var Companion_instance_25;
function Companion_getInstance_31() {
  return Companion_instance_25;
}
var Type_CONNECTED_instance;
var Type_DISCONNECTED_instance;
var Companion_instance_26;
function Companion_getInstance_32() {
  Type_initEntries_4();
  if (Companion_instance_26 === VOID)
    new Companion_17();
  return Companion_instance_26;
}
function values_4() {
  return [Type_CONNECTED_getInstance(), Type_DISCONNECTED_getInstance()];
}
var Type_entriesInitialized_4;
function Type_initEntries_4() {
  if (Type_entriesInitialized_4)
    return Unit_instance;
  Type_entriesInitialized_4 = true;
  Type_CONNECTED_instance = new Type_4('CONNECTED', 0);
  Type_DISCONNECTED_instance = new Type_4('DISCONNECTED', 1);
  Companion_getInstance_32();
}
function Type_CONNECTED_getInstance() {
  Type_initEntries_4();
  return Type_CONNECTED_instance;
}
function Type_DISCONNECTED_getInstance() {
  Type_initEntries_4();
  return Type_DISCONNECTED_instance;
}
var GameButton_LEFT_instance;
var GameButton_RIGHT_instance;
var GameButton_UP_instance;
var GameButton_DOWN_instance;
var GameButton_BUTTON_SOUTH_instance;
var GameButton_BUTTON_EAST_instance;
var GameButton_BUTTON_WEST_instance;
var GameButton_BUTTON_NORTH_instance;
var GameButton_SELECT_instance;
var GameButton_START_instance;
var GameButton_SYSTEM_instance;
var GameButton_L1_instance;
var GameButton_R1_instance;
var GameButton_L2_instance;
var GameButton_R2_instance;
var GameButton_L3_instance;
var GameButton_R3_instance;
var GameButton_LX_instance;
var GameButton_LY_instance;
var GameButton_RX_instance;
var GameButton_RY_instance;
var GameButton_BUTTON4_instance;
var GameButton_BUTTON5_instance;
var GameButton_BUTTON6_instance;
var GameButton_BUTTON7_instance;
var GameButton_BUTTON8_instance;
var GameButton_RECORD_instance;
var GameButton_DPADX_instance;
var GameButton_DPADY_instance;
var Companion_instance_27;
function Companion_getInstance_33() {
  GameButton_initEntries();
  if (Companion_instance_27 === VOID)
    new Companion_18();
  return Companion_instance_27;
}
function values_5() {
  return [GameButton_LEFT_getInstance(), GameButton_RIGHT_getInstance(), GameButton_UP_getInstance(), GameButton_DOWN_getInstance(), GameButton_BUTTON_SOUTH_getInstance(), GameButton_BUTTON_EAST_getInstance(), GameButton_BUTTON_WEST_getInstance(), GameButton_BUTTON_NORTH_getInstance(), GameButton_SELECT_getInstance(), GameButton_START_getInstance(), GameButton_SYSTEM_getInstance(), GameButton_L1_getInstance(), GameButton_R1_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_L3_getInstance(), GameButton_R3_getInstance(), GameButton_LX_getInstance(), GameButton_LY_getInstance(), GameButton_RX_getInstance(), GameButton_RY_getInstance(), GameButton_BUTTON4_getInstance(), GameButton_BUTTON5_getInstance(), GameButton_BUTTON6_getInstance(), GameButton_BUTTON7_getInstance(), GameButton_BUTTON8_getInstance(), GameButton_RECORD_getInstance(), GameButton_DPADX_getInstance(), GameButton_DPADY_getInstance()];
}
var GameButton_entriesInitialized;
function GameButton_initEntries() {
  if (GameButton_entriesInitialized)
    return Unit_instance;
  GameButton_entriesInitialized = true;
  GameButton_LEFT_instance = new GameButton('LEFT', 0);
  GameButton_RIGHT_instance = new GameButton('RIGHT', 1);
  GameButton_UP_instance = new GameButton('UP', 2);
  GameButton_DOWN_instance = new GameButton('DOWN', 3);
  GameButton_BUTTON_SOUTH_instance = new GameButton('BUTTON_SOUTH', 4);
  GameButton_BUTTON_EAST_instance = new GameButton('BUTTON_EAST', 5);
  GameButton_BUTTON_WEST_instance = new GameButton('BUTTON_WEST', 6);
  GameButton_BUTTON_NORTH_instance = new GameButton('BUTTON_NORTH', 7);
  GameButton_SELECT_instance = new GameButton('SELECT', 8);
  GameButton_START_instance = new GameButton('START', 9);
  GameButton_SYSTEM_instance = new GameButton('SYSTEM', 10);
  GameButton_L1_instance = new GameButton('L1', 11);
  GameButton_R1_instance = new GameButton('R1', 12);
  GameButton_L2_instance = new GameButton('L2', 13);
  GameButton_R2_instance = new GameButton('R2', 14);
  GameButton_L3_instance = new GameButton('L3', 15);
  GameButton_R3_instance = new GameButton('R3', 16);
  GameButton_LX_instance = new GameButton('LX', 17);
  GameButton_LY_instance = new GameButton('LY', 18);
  GameButton_RX_instance = new GameButton('RX', 19);
  GameButton_RY_instance = new GameButton('RY', 20);
  GameButton_BUTTON4_instance = new GameButton('BUTTON4', 21);
  GameButton_BUTTON5_instance = new GameButton('BUTTON5', 22);
  GameButton_BUTTON6_instance = new GameButton('BUTTON6', 23);
  GameButton_BUTTON7_instance = new GameButton('BUTTON7', 24);
  GameButton_BUTTON8_instance = new GameButton('BUTTON8', 25);
  GameButton_RECORD_instance = new GameButton('RECORD', 26);
  GameButton_DPADX_instance = new GameButton('DPADX', 27);
  GameButton_DPADY_instance = new GameButton('DPADY', 28);
  Companion_getInstance_33();
}
function GameButton_LEFT_getInstance() {
  GameButton_initEntries();
  return GameButton_LEFT_instance;
}
function GameButton_RIGHT_getInstance() {
  GameButton_initEntries();
  return GameButton_RIGHT_instance;
}
function GameButton_UP_getInstance() {
  GameButton_initEntries();
  return GameButton_UP_instance;
}
function GameButton_DOWN_getInstance() {
  GameButton_initEntries();
  return GameButton_DOWN_instance;
}
function GameButton_BUTTON_SOUTH_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_SOUTH_instance;
}
function GameButton_BUTTON_EAST_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_EAST_instance;
}
function GameButton_BUTTON_WEST_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_WEST_instance;
}
function GameButton_BUTTON_NORTH_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_NORTH_instance;
}
function GameButton_SELECT_getInstance() {
  GameButton_initEntries();
  return GameButton_SELECT_instance;
}
function GameButton_START_getInstance() {
  GameButton_initEntries();
  return GameButton_START_instance;
}
function GameButton_SYSTEM_getInstance() {
  GameButton_initEntries();
  return GameButton_SYSTEM_instance;
}
function GameButton_L1_getInstance() {
  GameButton_initEntries();
  return GameButton_L1_instance;
}
function GameButton_R1_getInstance() {
  GameButton_initEntries();
  return GameButton_R1_instance;
}
function GameButton_L2_getInstance() {
  GameButton_initEntries();
  return GameButton_L2_instance;
}
function GameButton_R2_getInstance() {
  GameButton_initEntries();
  return GameButton_R2_instance;
}
function GameButton_L3_getInstance() {
  GameButton_initEntries();
  return GameButton_L3_instance;
}
function GameButton_R3_getInstance() {
  GameButton_initEntries();
  return GameButton_R3_instance;
}
function GameButton_LX_getInstance() {
  GameButton_initEntries();
  return GameButton_LX_instance;
}
function GameButton_LY_getInstance() {
  GameButton_initEntries();
  return GameButton_LY_instance;
}
function GameButton_RX_getInstance() {
  GameButton_initEntries();
  return GameButton_RX_instance;
}
function GameButton_RY_getInstance() {
  GameButton_initEntries();
  return GameButton_RY_instance;
}
function GameButton_BUTTON4_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON4_instance;
}
function GameButton_BUTTON5_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON5_instance;
}
function GameButton_BUTTON6_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON6_instance;
}
function GameButton_BUTTON7_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON7_instance;
}
function GameButton_BUTTON8_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON8_instance;
}
function GameButton_RECORD_getInstance() {
  GameButton_initEntries();
  return GameButton_RECORD_instance;
}
function GameButton_DPADX_getInstance() {
  GameButton_initEntries();
  return GameButton_DPADX_instance;
}
function GameButton_DPADY_getInstance() {
  GameButton_initEntries();
  return GameButton_DPADY_instance;
}
var Key_SPACE_instance;
var Key_APOSTROPHE_instance;
var Key_COMMA_instance;
var Key_MINUS_instance;
var Key_PLUS_instance;
var Key_PERIOD_instance;
var Key_SLASH_instance;
var Key_N0_instance;
var Key_N1_instance;
var Key_N2_instance;
var Key_N3_instance;
var Key_N4_instance;
var Key_N5_instance;
var Key_N6_instance;
var Key_N7_instance;
var Key_N8_instance;
var Key_N9_instance;
var Key_N11_instance;
var Key_N12_instance;
var Key_N3D_MODE_instance;
var Key_SEMICOLON_instance;
var Key_EQUAL_instance;
var Key_AT_instance;
var Key_A_instance;
var Key_B_instance;
var Key_C_instance;
var Key_D_instance;
var Key_E_instance;
var Key_F_instance;
var Key_G_instance;
var Key_H_instance;
var Key_I_instance;
var Key_J_instance;
var Key_K_instance;
var Key_L_instance;
var Key_M_instance;
var Key_N_instance;
var Key_O_instance;
var Key_P_instance;
var Key_Q_instance;
var Key_R_instance;
var Key_S_instance;
var Key_T_instance;
var Key_U_instance;
var Key_V_instance;
var Key_W_instance;
var Key_X_instance;
var Key_Y_instance;
var Key_Z_instance;
var Key_LEFT_BRACKET_instance;
var Key_BACKSLASH_instance;
var Key_RIGHT_BRACKET_instance;
var Key_GRAVE_ACCENT_instance;
var Key_WORLD_1_instance;
var Key_WORLD_2_instance;
var Key_ESCAPE_instance;
var Key_META_instance;
var Key_ENTER_instance;
var Key_TAB_instance;
var Key_BACKSPACE_instance;
var Key_INSERT_instance;
var Key_DELETE_instance;
var Key_RIGHT_instance;
var Key_LEFT_instance;
var Key_DOWN_instance;
var Key_UP_instance;
var Key_PAGE_UP_instance;
var Key_PAGE_DOWN_instance;
var Key_FUNCTION_instance;
var Key_HELP_instance;
var Key_MUTE_instance;
var Key_VOLUME_DOWN_instance;
var Key_VOLUME_UP_instance;
var Key_VOLUME_MUTE_instance;
var Key_HOME_instance;
var Key_END_instance;
var Key_CAPS_LOCK_instance;
var Key_SCROLL_LOCK_instance;
var Key_NUM_LOCK_instance;
var Key_PRINT_SCREEN_instance;
var Key_PAUSE_instance;
var Key_F1_instance;
var Key_F2_instance;
var Key_F3_instance;
var Key_F4_instance;
var Key_F5_instance;
var Key_F6_instance;
var Key_F7_instance;
var Key_F8_instance;
var Key_F9_instance;
var Key_F10_instance;
var Key_F11_instance;
var Key_F12_instance;
var Key_F13_instance;
var Key_F14_instance;
var Key_F15_instance;
var Key_F16_instance;
var Key_F17_instance;
var Key_F18_instance;
var Key_F19_instance;
var Key_F20_instance;
var Key_F21_instance;
var Key_F22_instance;
var Key_F23_instance;
var Key_F24_instance;
var Key_F25_instance;
var Key_KP_0_instance;
var Key_KP_1_instance;
var Key_KP_2_instance;
var Key_KP_3_instance;
var Key_KP_4_instance;
var Key_KP_5_instance;
var Key_KP_6_instance;
var Key_KP_7_instance;
var Key_KP_8_instance;
var Key_KP_9_instance;
var Key_KP_DECIMAL_instance;
var Key_KP_DIVIDE_instance;
var Key_KP_MULTIPLY_instance;
var Key_KP_SUBTRACT_instance;
var Key_KP_ADD_instance;
var Key_KP_COMMA_instance;
var Key_KP_DOT_instance;
var Key_KP_ENTER_instance;
var Key_KP_EQUAL_instance;
var Key_KP_SEPARATOR_instance;
var Key_KP_LEFT_PAREN_instance;
var Key_KP_RIGHT_PAREN_instance;
var Key_SHIFT_instance;
var Key_CONTROL_instance;
var Key_ALT_instance;
var Key_SUPER_instance;
var Key_MENU_instance;
var Key_BACK_instance;
var Key_BACKQUOTE_instance;
var Key_QUOTE_instance;
var Key_KP_UP_instance;
var Key_KP_DOWN_instance;
var Key_KP_LEFT_instance;
var Key_KP_RIGHT_instance;
var Key_UNDERLINE_instance;
var Key_SELECT_KEY_instance;
var Key_CANCEL_instance;
var Key_CLEAR_instance;
var Key_OPEN_BRACKET_instance;
var Key_CLOSE_BRACKET_instance;
var Key_PLAY_instance;
var Key_NONAME_instance;
var Key_FINAL_instance;
var Key_OEM102_instance;
var Key_OEM1_instance;
var Key_OEM2_instance;
var Key_OEM3_instance;
var Key_OEM4_instance;
var Key_OEM5_instance;
var Key_OEM6_instance;
var Key_OEM7_instance;
var Key_OEM8_instance;
var Key_LEFT_MENU_instance;
var Key_RIGHT_MENU_instance;
var Key_SLEEP_instance;
var Key_SNAPSHOT_instance;
var Key_INFO_instance;
var Key_XBUTTON1_instance;
var Key_XBUTTON2_instance;
var Key_XBUTTON3_instance;
var Key_XBUTTON4_instance;
var Key_XBUTTON5_instance;
var Key_XBUTTON6_instance;
var Key_XBUTTON7_instance;
var Key_XBUTTON8_instance;
var Key_XBUTTON9_instance;
var Key_XBUTTON10_instance;
var Key_XBUTTON11_instance;
var Key_XBUTTON12_instance;
var Key_XBUTTON13_instance;
var Key_XBUTTON14_instance;
var Key_XBUTTON15_instance;
var Key_XBUTTON16_instance;
var Key_XBUTTON_A_instance;
var Key_XBUTTON_B_instance;
var Key_XBUTTON_C_instance;
var Key_XBUTTON_L1_instance;
var Key_XBUTTON_L2_instance;
var Key_XBUTTON_MODE_instance;
var Key_XBUTTON_R1_instance;
var Key_XBUTTON_R2_instance;
var Key_XBUTTON_SELECT_instance;
var Key_XBUTTON_START_instance;
var Key_XBUTTON_THUMBL_instance;
var Key_XBUTTON_THUMBR_instance;
var Key_XBUTTON_X_instance;
var Key_XBUTTON_Y_instance;
var Key_XBUTTON_Z_instance;
var Key_DPAD_CENTER_instance;
var Key_DPAD_DOWN_instance;
var Key_DPAD_DOWN_LEFT_instance;
var Key_DPAD_DOWN_RIGHT_instance;
var Key_DPAD_LEFT_instance;
var Key_DPAD_RIGHT_instance;
var Key_DPAD_UP_instance;
var Key_DPAD_UP_LEFT_instance;
var Key_DPAD_UP_RIGHT_instance;
var Key_DVR_instance;
var Key_EISU_instance;
var Key_ENDCALL_instance;
var Key_ENVELOPE_instance;
var Key_EXPLORER_instance;
var Key_FOCUS_instance;
var Key_FORWARD_instance;
var Key_GRAVE_instance;
var Key_GUIDE_instance;
var Key_HEADSETHOOK_instance;
var Key_ABNT_C1_instance;
var Key_ABNT_C2_instance;
var Key_ATTN_instance;
var Key_CRSEL_instance;
var Key_EREOF_instance;
var Key_EXECUTE_instance;
var Key_EXSEL_instance;
var Key_ICO_CLEAR_instance;
var Key_ICO_HELP_instance;
var Key_HENKAN_instance;
var Key_PAIRING_instance;
var Key_APP_SWITCH_instance;
var Key_ASSIST_instance;
var Key_AVR_INPUT_instance;
var Key_AVR_POWER_instance;
var Key_BOOKMARK_instance;
var Key_BREAK_instance;
var Key_CAPTIONS_instance;
var Key_CAMERA_instance;
var Key_CALL_instance;
var Key_CALENDAR_instance;
var Key_BRIGHTNESS_DOWN_instance;
var Key_BRIGHTNESS_UP_instance;
var Key_CHANNEL_DOWN_instance;
var Key_CHANNEL_UP_instance;
var Key_CALCULATOR_instance;
var Key_CONTACTS_instance;
var Key_NOTIFICATION_instance;
var Key_COPY_instance;
var Key_CUT_instance;
var Key_PASTE_instance;
var Key_SEARCH_instance;
var Key_SETTINGS_instance;
var Key_SOFT_LEFT_instance;
var Key_SOFT_RIGHT_instance;
var Key_SOFT_SLEEP_instance;
var Key_STAR_instance;
var Key_STB_INPUT_instance;
var Key_STB_POWER_instance;
var Key_STEM_1_instance;
var Key_STEM_2_instance;
var Key_STEM_3_instance;
var Key_STEM_PRIMARY_instance;
var Key_SWITCH_CHARSET_instance;
var Key_SYM_instance;
var Key_SYSRQ_instance;
var Key_NUM_instance;
var Key_TV_instance;
var Key_TV_ANTENNA_CABLE_instance;
var Key_TV_AUDIO_DESCRIPTION_instance;
var Key_TV_AUDIO_DESCRIPTION_MIX_DOWN_instance;
var Key_TV_AUDIO_DESCRIPTION_MIX_UP_instance;
var Key_TV_CONTENTS_MENU_instance;
var Key_TV_DATA_SERVICE_instance;
var Key_TV_INPUT_instance;
var Key_TV_INPUT_COMPONENT_1_instance;
var Key_TV_INPUT_COMPONENT_2_instance;
var Key_TV_INPUT_COMPOSITE_1_instance;
var Key_TV_INPUT_COMPOSITE_2_instance;
var Key_TV_INPUT_HDMI_1_instance;
var Key_TV_INPUT_HDMI_2_instance;
var Key_TV_INPUT_HDMI_3_instance;
var Key_TV_INPUT_HDMI_4_instance;
var Key_TV_INPUT_VGA_1_instance;
var Key_TV_MEDIA_CONTEXT_MENU_instance;
var Key_TV_NETWORK_instance;
var Key_TV_NUMBER_ENTRY_instance;
var Key_TV_POWER_instance;
var Key_TV_RADIO_SERVICE_instance;
var Key_TV_SATELLITE_instance;
var Key_TV_SATELLITE_BS_instance;
var Key_TV_SATELLITE_CS_instance;
var Key_TV_SATELLITE_SERVICE_instance;
var Key_TV_TELETEXT_instance;
var Key_TV_TERRESTRIAL_ANALOG_instance;
var Key_TV_TERRESTRIAL_DIGITAL_instance;
var Key_TV_TIMER_PROGRAMMING_instance;
var Key_TV_ZOOM_MODE_instance;
var Key_VOICE_ASSIST_instance;
var Key_WAKEUP_instance;
var Key_WINDOW_instance;
var Key_YEN_instance;
var Key_ZENKAKU_HANKAKU_instance;
var Key_ZOOM_IN_instance;
var Key_ZOOM_OUT_instance;
var Key_SYSTEM_NAVIGATION_DOWN_instance;
var Key_SYSTEM_NAVIGATION_LEFT_instance;
var Key_SYSTEM_NAVIGATION_RIGHT_instance;
var Key_SYSTEM_NAVIGATION_UP_instance;
var Key_PICTSYMBOLS_instance;
var Key_POUND_instance;
var Key_POWER_instance;
var Key_PROG_BLUE_instance;
var Key_PROG_GREEN_instance;
var Key_PROG_RED_instance;
var Key_PROG_YELLOW_instance;
var Key_RO_instance;
var Key_OEM_ATTN_instance;
var Key_OEM_AUTO_instance;
var Key_OEM_AX_instance;
var Key_OEM_BACKTAB_instance;
var Key_OEM_CLEAR_instance;
var Key_OEM_COMMA_instance;
var Key_OEM_COPY_instance;
var Key_OEM_CUSEL_instance;
var Key_OEM_ENLW_instance;
var Key_OEM_FINISH_instance;
var Key_OEM_FJ_LOYA_instance;
var Key_OEM_FJ_MASSHOU_instance;
var Key_OEM_FJ_ROYA_instance;
var Key_OEM_FJ_TOUROKU_instance;
var Key_OEM_JUMP_instance;
var Key_OEM_MINUS_instance;
var Key_OEM_PA1_instance;
var Key_OEM_PA2_instance;
var Key_OEM_PA3_instance;
var Key_OEM_PERIOD_instance;
var Key_OEM_PLUS_instance;
var Key_OEM_RESET_instance;
var Key_OEM_WSCTRL_instance;
var Key_PA1_instance;
var Key_PACKET_instance;
var Key_PROCESSKEY_instance;
var Key_ZOOM_instance;
var Key_NONE_instance;
var Key_ACCEPT_instance;
var Key_APPS_instance;
var Key_BROWSER_BACK_instance;
var Key_BROWSER_FAVORITES_instance;
var Key_BROWSER_FORWARD_instance;
var Key_BROWSER_HOME_instance;
var Key_BROWSER_REFRESH_instance;
var Key_BROWSER_SEARCH_instance;
var Key_BROWSER_STOP_instance;
var Key_CAPITAL_instance;
var Key_CONVERT_instance;
var Key_ICO_00_instance;
var Key_JUNJA_instance;
var Key_KANA_instance;
var Key_KANJI_instance;
var Key_KATAKANA_HIRAGANA_instance;
var Key_LANGUAGE_SWITCH_instance;
var Key_MUHENKAN_instance;
var Key_LAUNCH_APP1_instance;
var Key_LAUNCH_APP2_instance;
var Key_LAUNCH_MAIL_instance;
var Key_LAUNCH_MEDIA_SELECT_instance;
var Key_LEFT_BUTTON_instance;
var Key_MIDDLE_BUTTON_instance;
var Key_MUSIC_instance;
var Key_MEDIA_NEXT_TRACK_instance;
var Key_MEDIA_PLAY_PAUSE_instance;
var Key_MEDIA_PREV_TRACK_instance;
var Key_MEDIA_STOP_instance;
var Key_MEDIA_PLAY_instance;
var Key_MEDIA_PAUSE_instance;
var Key_MEDIA_AUDIO_TRACK_instance;
var Key_MEDIA_CLOSE_instance;
var Key_MEDIA_EJECT_instance;
var Key_MEDIA_FAST_FORWARD_instance;
var Key_MEDIA_RECORD_instance;
var Key_MEDIA_REWIND_instance;
var Key_MEDIA_SKIP_BACKWARD_instance;
var Key_MEDIA_SKIP_FORWARD_instance;
var Key_MEDIA_STEP_BACKWARD_instance;
var Key_MEDIA_STEP_FORWARD_instance;
var Key_MEDIA_TOP_MENU_instance;
var Key_MODECHANGE_instance;
var Key_NEXT_instance;
var Key_NONCONVERT_instance;
var Key_OEM_FJ_JISHO_instance;
var Key_PRIOR_instance;
var Key_RIGHT_BUTTON_instance;
var Key_LAST_CHANNEL_instance;
var Key_MANNER_MODE_instance;
var Key_NAVIGATE_IN_instance;
var Key_NAVIGATE_NEXT_instance;
var Key_NAVIGATE_OUT_instance;
var Key_NAVIGATE_PREVIOUS_instance;
var Key_HYPHEN_instance;
var Key_UNDEFINED_instance;
var Key_UNKNOWN_instance;
var Companion_instance_28;
function Companion_getInstance_34() {
  Key_initEntries();
  if (Companion_instance_28 === VOID)
    new Companion_19();
  return Companion_instance_28;
}
var Key_entriesInitialized;
function Key_initEntries() {
  if (Key_entriesInitialized)
    return Unit_instance;
  Key_entriesInitialized = true;
  Key_SPACE_instance = new Key('SPACE', 0);
  Key_APOSTROPHE_instance = new Key('APOSTROPHE', 1);
  Key_COMMA_instance = new Key('COMMA', 2);
  Key_MINUS_instance = new Key('MINUS', 3);
  Key_PLUS_instance = new Key('PLUS', 4);
  Key_PERIOD_instance = new Key('PERIOD', 5);
  Key_SLASH_instance = new Key('SLASH', 6);
  Key_N0_instance = new Key('N0', 7);
  Key_N1_instance = new Key('N1', 8);
  Key_N2_instance = new Key('N2', 9);
  Key_N3_instance = new Key('N3', 10);
  Key_N4_instance = new Key('N4', 11);
  Key_N5_instance = new Key('N5', 12);
  Key_N6_instance = new Key('N6', 13);
  Key_N7_instance = new Key('N7', 14);
  Key_N8_instance = new Key('N8', 15);
  Key_N9_instance = new Key('N9', 16);
  Key_N11_instance = new Key('N11', 17);
  Key_N12_instance = new Key('N12', 18);
  Key_N3D_MODE_instance = new Key('N3D_MODE', 19);
  Key_SEMICOLON_instance = new Key('SEMICOLON', 20);
  Key_EQUAL_instance = new Key('EQUAL', 21);
  Key_AT_instance = new Key('AT', 22);
  Key_A_instance = new Key('A', 23);
  Key_B_instance = new Key('B', 24);
  Key_C_instance = new Key('C', 25);
  Key_D_instance = new Key('D', 26);
  Key_E_instance = new Key('E', 27);
  Key_F_instance = new Key('F', 28);
  Key_G_instance = new Key('G', 29);
  Key_H_instance = new Key('H', 30);
  Key_I_instance = new Key('I', 31);
  Key_J_instance = new Key('J', 32);
  Key_K_instance = new Key('K', 33);
  Key_L_instance = new Key('L', 34);
  Key_M_instance = new Key('M', 35);
  Key_N_instance = new Key('N', 36);
  Key_O_instance = new Key('O', 37);
  Key_P_instance = new Key('P', 38);
  Key_Q_instance = new Key('Q', 39);
  Key_R_instance = new Key('R', 40);
  Key_S_instance = new Key('S', 41);
  Key_T_instance = new Key('T', 42);
  Key_U_instance = new Key('U', 43);
  Key_V_instance = new Key('V', 44);
  Key_W_instance = new Key('W', 45);
  Key_X_instance = new Key('X', 46);
  Key_Y_instance = new Key('Y', 47);
  Key_Z_instance = new Key('Z', 48);
  Key_LEFT_BRACKET_instance = new Key('LEFT_BRACKET', 49);
  Key_BACKSLASH_instance = new Key('BACKSLASH', 50);
  Key_RIGHT_BRACKET_instance = new Key('RIGHT_BRACKET', 51);
  Key_GRAVE_ACCENT_instance = new Key('GRAVE_ACCENT', 52);
  Key_WORLD_1_instance = new Key('WORLD_1', 53);
  Key_WORLD_2_instance = new Key('WORLD_2', 54);
  Key_ESCAPE_instance = new Key('ESCAPE', 55);
  Key_META_instance = new Key('META', 56);
  Key_ENTER_instance = new Key('ENTER', 57);
  Key_TAB_instance = new Key('TAB', 58);
  Key_BACKSPACE_instance = new Key('BACKSPACE', 59);
  Key_INSERT_instance = new Key('INSERT', 60);
  Key_DELETE_instance = new Key('DELETE', 61);
  Key_RIGHT_instance = new Key('RIGHT', 62);
  Key_LEFT_instance = new Key('LEFT', 63);
  Key_DOWN_instance = new Key('DOWN', 64);
  Key_UP_instance = new Key('UP', 65);
  Key_PAGE_UP_instance = new Key('PAGE_UP', 66);
  Key_PAGE_DOWN_instance = new Key('PAGE_DOWN', 67);
  Key_FUNCTION_instance = new Key('FUNCTION', 68);
  Key_HELP_instance = new Key('HELP', 69);
  Key_MUTE_instance = new Key('MUTE', 70);
  Key_VOLUME_DOWN_instance = new Key('VOLUME_DOWN', 71);
  Key_VOLUME_UP_instance = new Key('VOLUME_UP', 72);
  Key_VOLUME_MUTE_instance = new Key('VOLUME_MUTE', 73);
  Key_HOME_instance = new Key('HOME', 74);
  Key_END_instance = new Key('END', 75);
  Key_CAPS_LOCK_instance = new Key('CAPS_LOCK', 76);
  Key_SCROLL_LOCK_instance = new Key('SCROLL_LOCK', 77);
  Key_NUM_LOCK_instance = new Key('NUM_LOCK', 78);
  Key_PRINT_SCREEN_instance = new Key('PRINT_SCREEN', 79);
  Key_PAUSE_instance = new Key('PAUSE', 80);
  Key_F1_instance = new Key('F1', 81);
  Key_F2_instance = new Key('F2', 82);
  Key_F3_instance = new Key('F3', 83);
  Key_F4_instance = new Key('F4', 84);
  Key_F5_instance = new Key('F5', 85);
  Key_F6_instance = new Key('F6', 86);
  Key_F7_instance = new Key('F7', 87);
  Key_F8_instance = new Key('F8', 88);
  Key_F9_instance = new Key('F9', 89);
  Key_F10_instance = new Key('F10', 90);
  Key_F11_instance = new Key('F11', 91);
  Key_F12_instance = new Key('F12', 92);
  Key_F13_instance = new Key('F13', 93);
  Key_F14_instance = new Key('F14', 94);
  Key_F15_instance = new Key('F15', 95);
  Key_F16_instance = new Key('F16', 96);
  Key_F17_instance = new Key('F17', 97);
  Key_F18_instance = new Key('F18', 98);
  Key_F19_instance = new Key('F19', 99);
  Key_F20_instance = new Key('F20', 100);
  Key_F21_instance = new Key('F21', 101);
  Key_F22_instance = new Key('F22', 102);
  Key_F23_instance = new Key('F23', 103);
  Key_F24_instance = new Key('F24', 104);
  Key_F25_instance = new Key('F25', 105);
  Key_KP_0_instance = new Key('KP_0', 106);
  Key_KP_1_instance = new Key('KP_1', 107);
  Key_KP_2_instance = new Key('KP_2', 108);
  Key_KP_3_instance = new Key('KP_3', 109);
  Key_KP_4_instance = new Key('KP_4', 110);
  Key_KP_5_instance = new Key('KP_5', 111);
  Key_KP_6_instance = new Key('KP_6', 112);
  Key_KP_7_instance = new Key('KP_7', 113);
  Key_KP_8_instance = new Key('KP_8', 114);
  Key_KP_9_instance = new Key('KP_9', 115);
  Key_KP_DECIMAL_instance = new Key('KP_DECIMAL', 116);
  Key_KP_DIVIDE_instance = new Key('KP_DIVIDE', 117);
  Key_KP_MULTIPLY_instance = new Key('KP_MULTIPLY', 118);
  Key_KP_SUBTRACT_instance = new Key('KP_SUBTRACT', 119);
  Key_KP_ADD_instance = new Key('KP_ADD', 120);
  Key_KP_COMMA_instance = new Key('KP_COMMA', 121);
  Key_KP_DOT_instance = new Key('KP_DOT', 122);
  Key_KP_ENTER_instance = new Key('KP_ENTER', 123);
  Key_KP_EQUAL_instance = new Key('KP_EQUAL', 124);
  Key_KP_SEPARATOR_instance = new Key('KP_SEPARATOR', 125);
  Key_KP_LEFT_PAREN_instance = new Key('KP_LEFT_PAREN', 126);
  Key_KP_RIGHT_PAREN_instance = new Key('KP_RIGHT_PAREN', 127);
  Key_SHIFT_instance = new Key('SHIFT', 128);
  Key_CONTROL_instance = new Key('CONTROL', 129);
  Key_ALT_instance = new Key('ALT', 130);
  Key_SUPER_instance = new Key('SUPER', 131);
  Key_MENU_instance = new Key('MENU', 132);
  Key_BACK_instance = new Key('BACK', 133);
  Key_BACKQUOTE_instance = new Key('BACKQUOTE', 134);
  Key_QUOTE_instance = new Key('QUOTE', 135);
  Key_KP_UP_instance = new Key('KP_UP', 136);
  Key_KP_DOWN_instance = new Key('KP_DOWN', 137);
  Key_KP_LEFT_instance = new Key('KP_LEFT', 138);
  Key_KP_RIGHT_instance = new Key('KP_RIGHT', 139);
  Key_UNDERLINE_instance = new Key('UNDERLINE', 140);
  Key_SELECT_KEY_instance = new Key('SELECT_KEY', 141);
  Key_CANCEL_instance = new Key('CANCEL', 142);
  Key_CLEAR_instance = new Key('CLEAR', 143);
  Key_OPEN_BRACKET_instance = new Key('OPEN_BRACKET', 144);
  Key_CLOSE_BRACKET_instance = new Key('CLOSE_BRACKET', 145);
  Key_PLAY_instance = new Key('PLAY', 146);
  Key_NONAME_instance = new Key('NONAME', 147);
  Key_FINAL_instance = new Key('FINAL', 148);
  Key_OEM102_instance = new Key('OEM102', 149);
  Key_OEM1_instance = new Key('OEM1', 150);
  Key_OEM2_instance = new Key('OEM2', 151);
  Key_OEM3_instance = new Key('OEM3', 152);
  Key_OEM4_instance = new Key('OEM4', 153);
  Key_OEM5_instance = new Key('OEM5', 154);
  Key_OEM6_instance = new Key('OEM6', 155);
  Key_OEM7_instance = new Key('OEM7', 156);
  Key_OEM8_instance = new Key('OEM8', 157);
  Key_LEFT_MENU_instance = new Key('LEFT_MENU', 158);
  Key_RIGHT_MENU_instance = new Key('RIGHT_MENU', 159);
  Key_SLEEP_instance = new Key('SLEEP', 160);
  Key_SNAPSHOT_instance = new Key('SNAPSHOT', 161);
  Key_INFO_instance = new Key('INFO', 162);
  Key_XBUTTON1_instance = new Key('XBUTTON1', 163);
  Key_XBUTTON2_instance = new Key('XBUTTON2', 164);
  Key_XBUTTON3_instance = new Key('XBUTTON3', 165);
  Key_XBUTTON4_instance = new Key('XBUTTON4', 166);
  Key_XBUTTON5_instance = new Key('XBUTTON5', 167);
  Key_XBUTTON6_instance = new Key('XBUTTON6', 168);
  Key_XBUTTON7_instance = new Key('XBUTTON7', 169);
  Key_XBUTTON8_instance = new Key('XBUTTON8', 170);
  Key_XBUTTON9_instance = new Key('XBUTTON9', 171);
  Key_XBUTTON10_instance = new Key('XBUTTON10', 172);
  Key_XBUTTON11_instance = new Key('XBUTTON11', 173);
  Key_XBUTTON12_instance = new Key('XBUTTON12', 174);
  Key_XBUTTON13_instance = new Key('XBUTTON13', 175);
  Key_XBUTTON14_instance = new Key('XBUTTON14', 176);
  Key_XBUTTON15_instance = new Key('XBUTTON15', 177);
  Key_XBUTTON16_instance = new Key('XBUTTON16', 178);
  Key_XBUTTON_A_instance = new Key('XBUTTON_A', 179);
  Key_XBUTTON_B_instance = new Key('XBUTTON_B', 180);
  Key_XBUTTON_C_instance = new Key('XBUTTON_C', 181);
  Key_XBUTTON_L1_instance = new Key('XBUTTON_L1', 182);
  Key_XBUTTON_L2_instance = new Key('XBUTTON_L2', 183);
  Key_XBUTTON_MODE_instance = new Key('XBUTTON_MODE', 184);
  Key_XBUTTON_R1_instance = new Key('XBUTTON_R1', 185);
  Key_XBUTTON_R2_instance = new Key('XBUTTON_R2', 186);
  Key_XBUTTON_SELECT_instance = new Key('XBUTTON_SELECT', 187);
  Key_XBUTTON_START_instance = new Key('XBUTTON_START', 188);
  Key_XBUTTON_THUMBL_instance = new Key('XBUTTON_THUMBL', 189);
  Key_XBUTTON_THUMBR_instance = new Key('XBUTTON_THUMBR', 190);
  Key_XBUTTON_X_instance = new Key('XBUTTON_X', 191);
  Key_XBUTTON_Y_instance = new Key('XBUTTON_Y', 192);
  Key_XBUTTON_Z_instance = new Key('XBUTTON_Z', 193);
  Key_DPAD_CENTER_instance = new Key('DPAD_CENTER', 194);
  Key_DPAD_DOWN_instance = new Key('DPAD_DOWN', 195);
  Key_DPAD_DOWN_LEFT_instance = new Key('DPAD_DOWN_LEFT', 196);
  Key_DPAD_DOWN_RIGHT_instance = new Key('DPAD_DOWN_RIGHT', 197);
  Key_DPAD_LEFT_instance = new Key('DPAD_LEFT', 198);
  Key_DPAD_RIGHT_instance = new Key('DPAD_RIGHT', 199);
  Key_DPAD_UP_instance = new Key('DPAD_UP', 200);
  Key_DPAD_UP_LEFT_instance = new Key('DPAD_UP_LEFT', 201);
  Key_DPAD_UP_RIGHT_instance = new Key('DPAD_UP_RIGHT', 202);
  Key_DVR_instance = new Key('DVR', 203);
  Key_EISU_instance = new Key('EISU', 204);
  Key_ENDCALL_instance = new Key('ENDCALL', 205);
  Key_ENVELOPE_instance = new Key('ENVELOPE', 206);
  Key_EXPLORER_instance = new Key('EXPLORER', 207);
  Key_FOCUS_instance = new Key('FOCUS', 208);
  Key_FORWARD_instance = new Key('FORWARD', 209);
  Key_GRAVE_instance = new Key('GRAVE', 210);
  Key_GUIDE_instance = new Key('GUIDE', 211);
  Key_HEADSETHOOK_instance = new Key('HEADSETHOOK', 212);
  Key_ABNT_C1_instance = new Key('ABNT_C1', 213);
  Key_ABNT_C2_instance = new Key('ABNT_C2', 214);
  Key_ATTN_instance = new Key('ATTN', 215);
  Key_CRSEL_instance = new Key('CRSEL', 216);
  Key_EREOF_instance = new Key('EREOF', 217);
  Key_EXECUTE_instance = new Key('EXECUTE', 218);
  Key_EXSEL_instance = new Key('EXSEL', 219);
  Key_ICO_CLEAR_instance = new Key('ICO_CLEAR', 220);
  Key_ICO_HELP_instance = new Key('ICO_HELP', 221);
  Key_HENKAN_instance = new Key('HENKAN', 222);
  Key_PAIRING_instance = new Key('PAIRING', 223);
  Key_APP_SWITCH_instance = new Key('APP_SWITCH', 224);
  Key_ASSIST_instance = new Key('ASSIST', 225);
  Key_AVR_INPUT_instance = new Key('AVR_INPUT', 226);
  Key_AVR_POWER_instance = new Key('AVR_POWER', 227);
  Key_BOOKMARK_instance = new Key('BOOKMARK', 228);
  Key_BREAK_instance = new Key('BREAK', 229);
  Key_CAPTIONS_instance = new Key('CAPTIONS', 230);
  Key_CAMERA_instance = new Key('CAMERA', 231);
  Key_CALL_instance = new Key('CALL', 232);
  Key_CALENDAR_instance = new Key('CALENDAR', 233);
  Key_BRIGHTNESS_DOWN_instance = new Key('BRIGHTNESS_DOWN', 234);
  Key_BRIGHTNESS_UP_instance = new Key('BRIGHTNESS_UP', 235);
  Key_CHANNEL_DOWN_instance = new Key('CHANNEL_DOWN', 236);
  Key_CHANNEL_UP_instance = new Key('CHANNEL_UP', 237);
  Key_CALCULATOR_instance = new Key('CALCULATOR', 238);
  Key_CONTACTS_instance = new Key('CONTACTS', 239);
  Key_NOTIFICATION_instance = new Key('NOTIFICATION', 240);
  Key_COPY_instance = new Key('COPY', 241);
  Key_CUT_instance = new Key('CUT', 242);
  Key_PASTE_instance = new Key('PASTE', 243);
  Key_SEARCH_instance = new Key('SEARCH', 244);
  Key_SETTINGS_instance = new Key('SETTINGS', 245);
  Key_SOFT_LEFT_instance = new Key('SOFT_LEFT', 246);
  Key_SOFT_RIGHT_instance = new Key('SOFT_RIGHT', 247);
  Key_SOFT_SLEEP_instance = new Key('SOFT_SLEEP', 248);
  Key_STAR_instance = new Key('STAR', 249);
  Key_STB_INPUT_instance = new Key('STB_INPUT', 250);
  Key_STB_POWER_instance = new Key('STB_POWER', 251);
  Key_STEM_1_instance = new Key('STEM_1', 252);
  Key_STEM_2_instance = new Key('STEM_2', 253);
  Key_STEM_3_instance = new Key('STEM_3', 254);
  Key_STEM_PRIMARY_instance = new Key('STEM_PRIMARY', 255);
  Key_SWITCH_CHARSET_instance = new Key('SWITCH_CHARSET', 256);
  Key_SYM_instance = new Key('SYM', 257);
  Key_SYSRQ_instance = new Key('SYSRQ', 258);
  Key_NUM_instance = new Key('NUM', 259);
  Key_TV_instance = new Key('TV', 260);
  Key_TV_ANTENNA_CABLE_instance = new Key('TV_ANTENNA_CABLE', 261);
  Key_TV_AUDIO_DESCRIPTION_instance = new Key('TV_AUDIO_DESCRIPTION', 262);
  Key_TV_AUDIO_DESCRIPTION_MIX_DOWN_instance = new Key('TV_AUDIO_DESCRIPTION_MIX_DOWN', 263);
  Key_TV_AUDIO_DESCRIPTION_MIX_UP_instance = new Key('TV_AUDIO_DESCRIPTION_MIX_UP', 264);
  Key_TV_CONTENTS_MENU_instance = new Key('TV_CONTENTS_MENU', 265);
  Key_TV_DATA_SERVICE_instance = new Key('TV_DATA_SERVICE', 266);
  Key_TV_INPUT_instance = new Key('TV_INPUT', 267);
  Key_TV_INPUT_COMPONENT_1_instance = new Key('TV_INPUT_COMPONENT_1', 268);
  Key_TV_INPUT_COMPONENT_2_instance = new Key('TV_INPUT_COMPONENT_2', 269);
  Key_TV_INPUT_COMPOSITE_1_instance = new Key('TV_INPUT_COMPOSITE_1', 270);
  Key_TV_INPUT_COMPOSITE_2_instance = new Key('TV_INPUT_COMPOSITE_2', 271);
  Key_TV_INPUT_HDMI_1_instance = new Key('TV_INPUT_HDMI_1', 272);
  Key_TV_INPUT_HDMI_2_instance = new Key('TV_INPUT_HDMI_2', 273);
  Key_TV_INPUT_HDMI_3_instance = new Key('TV_INPUT_HDMI_3', 274);
  Key_TV_INPUT_HDMI_4_instance = new Key('TV_INPUT_HDMI_4', 275);
  Key_TV_INPUT_VGA_1_instance = new Key('TV_INPUT_VGA_1', 276);
  Key_TV_MEDIA_CONTEXT_MENU_instance = new Key('TV_MEDIA_CONTEXT_MENU', 277);
  Key_TV_NETWORK_instance = new Key('TV_NETWORK', 278);
  Key_TV_NUMBER_ENTRY_instance = new Key('TV_NUMBER_ENTRY', 279);
  Key_TV_POWER_instance = new Key('TV_POWER', 280);
  Key_TV_RADIO_SERVICE_instance = new Key('TV_RADIO_SERVICE', 281);
  Key_TV_SATELLITE_instance = new Key('TV_SATELLITE', 282);
  Key_TV_SATELLITE_BS_instance = new Key('TV_SATELLITE_BS', 283);
  Key_TV_SATELLITE_CS_instance = new Key('TV_SATELLITE_CS', 284);
  Key_TV_SATELLITE_SERVICE_instance = new Key('TV_SATELLITE_SERVICE', 285);
  Key_TV_TELETEXT_instance = new Key('TV_TELETEXT', 286);
  Key_TV_TERRESTRIAL_ANALOG_instance = new Key('TV_TERRESTRIAL_ANALOG', 287);
  Key_TV_TERRESTRIAL_DIGITAL_instance = new Key('TV_TERRESTRIAL_DIGITAL', 288);
  Key_TV_TIMER_PROGRAMMING_instance = new Key('TV_TIMER_PROGRAMMING', 289);
  Key_TV_ZOOM_MODE_instance = new Key('TV_ZOOM_MODE', 290);
  Key_VOICE_ASSIST_instance = new Key('VOICE_ASSIST', 291);
  Key_WAKEUP_instance = new Key('WAKEUP', 292);
  Key_WINDOW_instance = new Key('WINDOW', 293);
  Key_YEN_instance = new Key('YEN', 294);
  Key_ZENKAKU_HANKAKU_instance = new Key('ZENKAKU_HANKAKU', 295);
  Key_ZOOM_IN_instance = new Key('ZOOM_IN', 296);
  Key_ZOOM_OUT_instance = new Key('ZOOM_OUT', 297);
  Key_SYSTEM_NAVIGATION_DOWN_instance = new Key('SYSTEM_NAVIGATION_DOWN', 298);
  Key_SYSTEM_NAVIGATION_LEFT_instance = new Key('SYSTEM_NAVIGATION_LEFT', 299);
  Key_SYSTEM_NAVIGATION_RIGHT_instance = new Key('SYSTEM_NAVIGATION_RIGHT', 300);
  Key_SYSTEM_NAVIGATION_UP_instance = new Key('SYSTEM_NAVIGATION_UP', 301);
  Key_PICTSYMBOLS_instance = new Key('PICTSYMBOLS', 302);
  Key_POUND_instance = new Key('POUND', 303);
  Key_POWER_instance = new Key('POWER', 304);
  Key_PROG_BLUE_instance = new Key('PROG_BLUE', 305);
  Key_PROG_GREEN_instance = new Key('PROG_GREEN', 306);
  Key_PROG_RED_instance = new Key('PROG_RED', 307);
  Key_PROG_YELLOW_instance = new Key('PROG_YELLOW', 308);
  Key_RO_instance = new Key('RO', 309);
  Key_OEM_ATTN_instance = new Key('OEM_ATTN', 310);
  Key_OEM_AUTO_instance = new Key('OEM_AUTO', 311);
  Key_OEM_AX_instance = new Key('OEM_AX', 312);
  Key_OEM_BACKTAB_instance = new Key('OEM_BACKTAB', 313);
  Key_OEM_CLEAR_instance = new Key('OEM_CLEAR', 314);
  Key_OEM_COMMA_instance = new Key('OEM_COMMA', 315);
  Key_OEM_COPY_instance = new Key('OEM_COPY', 316);
  Key_OEM_CUSEL_instance = new Key('OEM_CUSEL', 317);
  Key_OEM_ENLW_instance = new Key('OEM_ENLW', 318);
  Key_OEM_FINISH_instance = new Key('OEM_FINISH', 319);
  Key_OEM_FJ_LOYA_instance = new Key('OEM_FJ_LOYA', 320);
  Key_OEM_FJ_MASSHOU_instance = new Key('OEM_FJ_MASSHOU', 321);
  Key_OEM_FJ_ROYA_instance = new Key('OEM_FJ_ROYA', 322);
  Key_OEM_FJ_TOUROKU_instance = new Key('OEM_FJ_TOUROKU', 323);
  Key_OEM_JUMP_instance = new Key('OEM_JUMP', 324);
  Key_OEM_MINUS_instance = new Key('OEM_MINUS', 325);
  Key_OEM_PA1_instance = new Key('OEM_PA1', 326);
  Key_OEM_PA2_instance = new Key('OEM_PA2', 327);
  Key_OEM_PA3_instance = new Key('OEM_PA3', 328);
  Key_OEM_PERIOD_instance = new Key('OEM_PERIOD', 329);
  Key_OEM_PLUS_instance = new Key('OEM_PLUS', 330);
  Key_OEM_RESET_instance = new Key('OEM_RESET', 331);
  Key_OEM_WSCTRL_instance = new Key('OEM_WSCTRL', 332);
  Key_PA1_instance = new Key('PA1', 333);
  Key_PACKET_instance = new Key('PACKET', 334);
  Key_PROCESSKEY_instance = new Key('PROCESSKEY', 335);
  Key_ZOOM_instance = new Key('ZOOM', 336);
  Key_NONE_instance = new Key('NONE', 337);
  Key_ACCEPT_instance = new Key('ACCEPT', 338);
  Key_APPS_instance = new Key('APPS', 339);
  Key_BROWSER_BACK_instance = new Key('BROWSER_BACK', 340);
  Key_BROWSER_FAVORITES_instance = new Key('BROWSER_FAVORITES', 341);
  Key_BROWSER_FORWARD_instance = new Key('BROWSER_FORWARD', 342);
  Key_BROWSER_HOME_instance = new Key('BROWSER_HOME', 343);
  Key_BROWSER_REFRESH_instance = new Key('BROWSER_REFRESH', 344);
  Key_BROWSER_SEARCH_instance = new Key('BROWSER_SEARCH', 345);
  Key_BROWSER_STOP_instance = new Key('BROWSER_STOP', 346);
  Key_CAPITAL_instance = new Key('CAPITAL', 347);
  Key_CONVERT_instance = new Key('CONVERT', 348);
  Key_ICO_00_instance = new Key('ICO_00', 349);
  Key_JUNJA_instance = new Key('JUNJA', 350);
  Key_KANA_instance = new Key('KANA', 351);
  Key_KANJI_instance = new Key('KANJI', 352);
  Key_KATAKANA_HIRAGANA_instance = new Key('KATAKANA_HIRAGANA', 353);
  Key_LANGUAGE_SWITCH_instance = new Key('LANGUAGE_SWITCH', 354);
  Key_MUHENKAN_instance = new Key('MUHENKAN', 355);
  Key_LAUNCH_APP1_instance = new Key('LAUNCH_APP1', 356);
  Key_LAUNCH_APP2_instance = new Key('LAUNCH_APP2', 357);
  Key_LAUNCH_MAIL_instance = new Key('LAUNCH_MAIL', 358);
  Key_LAUNCH_MEDIA_SELECT_instance = new Key('LAUNCH_MEDIA_SELECT', 359);
  Key_LEFT_BUTTON_instance = new Key('LEFT_BUTTON', 360);
  Key_MIDDLE_BUTTON_instance = new Key('MIDDLE_BUTTON', 361);
  Key_MUSIC_instance = new Key('MUSIC', 362);
  Key_MEDIA_NEXT_TRACK_instance = new Key('MEDIA_NEXT_TRACK', 363);
  Key_MEDIA_PLAY_PAUSE_instance = new Key('MEDIA_PLAY_PAUSE', 364);
  Key_MEDIA_PREV_TRACK_instance = new Key('MEDIA_PREV_TRACK', 365);
  Key_MEDIA_STOP_instance = new Key('MEDIA_STOP', 366);
  Key_MEDIA_PLAY_instance = new Key('MEDIA_PLAY', 367);
  Key_MEDIA_PAUSE_instance = new Key('MEDIA_PAUSE', 368);
  Key_MEDIA_AUDIO_TRACK_instance = new Key('MEDIA_AUDIO_TRACK', 369);
  Key_MEDIA_CLOSE_instance = new Key('MEDIA_CLOSE', 370);
  Key_MEDIA_EJECT_instance = new Key('MEDIA_EJECT', 371);
  Key_MEDIA_FAST_FORWARD_instance = new Key('MEDIA_FAST_FORWARD', 372);
  Key_MEDIA_RECORD_instance = new Key('MEDIA_RECORD', 373);
  Key_MEDIA_REWIND_instance = new Key('MEDIA_REWIND', 374);
  Key_MEDIA_SKIP_BACKWARD_instance = new Key('MEDIA_SKIP_BACKWARD', 375);
  Key_MEDIA_SKIP_FORWARD_instance = new Key('MEDIA_SKIP_FORWARD', 376);
  Key_MEDIA_STEP_BACKWARD_instance = new Key('MEDIA_STEP_BACKWARD', 377);
  Key_MEDIA_STEP_FORWARD_instance = new Key('MEDIA_STEP_FORWARD', 378);
  Key_MEDIA_TOP_MENU_instance = new Key('MEDIA_TOP_MENU', 379);
  Key_MODECHANGE_instance = new Key('MODECHANGE', 380);
  Key_NEXT_instance = new Key('NEXT', 381);
  Key_NONCONVERT_instance = new Key('NONCONVERT', 382);
  Key_OEM_FJ_JISHO_instance = new Key('OEM_FJ_JISHO', 383);
  Key_PRIOR_instance = new Key('PRIOR', 384);
  Key_RIGHT_BUTTON_instance = new Key('RIGHT_BUTTON', 385);
  Key_LAST_CHANNEL_instance = new Key('LAST_CHANNEL', 386);
  Key_MANNER_MODE_instance = new Key('MANNER_MODE', 387);
  Key_NAVIGATE_IN_instance = new Key('NAVIGATE_IN', 388);
  Key_NAVIGATE_NEXT_instance = new Key('NAVIGATE_NEXT', 389);
  Key_NAVIGATE_OUT_instance = new Key('NAVIGATE_OUT', 390);
  Key_NAVIGATE_PREVIOUS_instance = new Key('NAVIGATE_PREVIOUS', 391);
  Key_HYPHEN_instance = new Key('HYPHEN', 392);
  Key_UNDEFINED_instance = new Key('UNDEFINED', 393);
  Key_UNKNOWN_instance = new Key('UNKNOWN', 394);
  Companion_getInstance_34();
}
function Key_SPACE_getInstance() {
  Key_initEntries();
  return Key_SPACE_instance;
}
function Key_APOSTROPHE_getInstance() {
  Key_initEntries();
  return Key_APOSTROPHE_instance;
}
function Key_COMMA_getInstance() {
  Key_initEntries();
  return Key_COMMA_instance;
}
function Key_MINUS_getInstance() {
  Key_initEntries();
  return Key_MINUS_instance;
}
function Key_PLUS_getInstance() {
  Key_initEntries();
  return Key_PLUS_instance;
}
function Key_PERIOD_getInstance() {
  Key_initEntries();
  return Key_PERIOD_instance;
}
function Key_SLASH_getInstance() {
  Key_initEntries();
  return Key_SLASH_instance;
}
function Key_N0_getInstance() {
  Key_initEntries();
  return Key_N0_instance;
}
function Key_N1_getInstance() {
  Key_initEntries();
  return Key_N1_instance;
}
function Key_N2_getInstance() {
  Key_initEntries();
  return Key_N2_instance;
}
function Key_N3_getInstance() {
  Key_initEntries();
  return Key_N3_instance;
}
function Key_N4_getInstance() {
  Key_initEntries();
  return Key_N4_instance;
}
function Key_N5_getInstance() {
  Key_initEntries();
  return Key_N5_instance;
}
function Key_N6_getInstance() {
  Key_initEntries();
  return Key_N6_instance;
}
function Key_N7_getInstance() {
  Key_initEntries();
  return Key_N7_instance;
}
function Key_N8_getInstance() {
  Key_initEntries();
  return Key_N8_instance;
}
function Key_N9_getInstance() {
  Key_initEntries();
  return Key_N9_instance;
}
function Key_SEMICOLON_getInstance() {
  Key_initEntries();
  return Key_SEMICOLON_instance;
}
function Key_A_getInstance() {
  Key_initEntries();
  return Key_A_instance;
}
function Key_B_getInstance() {
  Key_initEntries();
  return Key_B_instance;
}
function Key_C_getInstance() {
  Key_initEntries();
  return Key_C_instance;
}
function Key_D_getInstance() {
  Key_initEntries();
  return Key_D_instance;
}
function Key_E_getInstance() {
  Key_initEntries();
  return Key_E_instance;
}
function Key_F_getInstance() {
  Key_initEntries();
  return Key_F_instance;
}
function Key_G_getInstance() {
  Key_initEntries();
  return Key_G_instance;
}
function Key_H_getInstance() {
  Key_initEntries();
  return Key_H_instance;
}
function Key_I_getInstance() {
  Key_initEntries();
  return Key_I_instance;
}
function Key_J_getInstance() {
  Key_initEntries();
  return Key_J_instance;
}
function Key_K_getInstance() {
  Key_initEntries();
  return Key_K_instance;
}
function Key_L_getInstance() {
  Key_initEntries();
  return Key_L_instance;
}
function Key_M_getInstance() {
  Key_initEntries();
  return Key_M_instance;
}
function Key_N_getInstance() {
  Key_initEntries();
  return Key_N_instance;
}
function Key_O_getInstance() {
  Key_initEntries();
  return Key_O_instance;
}
function Key_P_getInstance() {
  Key_initEntries();
  return Key_P_instance;
}
function Key_Q_getInstance() {
  Key_initEntries();
  return Key_Q_instance;
}
function Key_R_getInstance() {
  Key_initEntries();
  return Key_R_instance;
}
function Key_S_getInstance() {
  Key_initEntries();
  return Key_S_instance;
}
function Key_T_getInstance() {
  Key_initEntries();
  return Key_T_instance;
}
function Key_U_getInstance() {
  Key_initEntries();
  return Key_U_instance;
}
function Key_V_getInstance() {
  Key_initEntries();
  return Key_V_instance;
}
function Key_W_getInstance() {
  Key_initEntries();
  return Key_W_instance;
}
function Key_X_getInstance() {
  Key_initEntries();
  return Key_X_instance;
}
function Key_Y_getInstance() {
  Key_initEntries();
  return Key_Y_instance;
}
function Key_Z_getInstance() {
  Key_initEntries();
  return Key_Z_instance;
}
function Key_ESCAPE_getInstance() {
  Key_initEntries();
  return Key_ESCAPE_instance;
}
function Key_META_getInstance() {
  Key_initEntries();
  return Key_META_instance;
}
function Key_ENTER_getInstance() {
  Key_initEntries();
  return Key_ENTER_instance;
}
function Key_TAB_getInstance() {
  Key_initEntries();
  return Key_TAB_instance;
}
function Key_BACKSPACE_getInstance() {
  Key_initEntries();
  return Key_BACKSPACE_instance;
}
function Key_INSERT_getInstance() {
  Key_initEntries();
  return Key_INSERT_instance;
}
function Key_DELETE_getInstance() {
  Key_initEntries();
  return Key_DELETE_instance;
}
function Key_RIGHT_getInstance() {
  Key_initEntries();
  return Key_RIGHT_instance;
}
function Key_LEFT_getInstance() {
  Key_initEntries();
  return Key_LEFT_instance;
}
function Key_DOWN_getInstance() {
  Key_initEntries();
  return Key_DOWN_instance;
}
function Key_UP_getInstance() {
  Key_initEntries();
  return Key_UP_instance;
}
function Key_PAGE_UP_getInstance() {
  Key_initEntries();
  return Key_PAGE_UP_instance;
}
function Key_PAGE_DOWN_getInstance() {
  Key_initEntries();
  return Key_PAGE_DOWN_instance;
}
function Key_HOME_getInstance() {
  Key_initEntries();
  return Key_HOME_instance;
}
function Key_END_getInstance() {
  Key_initEntries();
  return Key_END_instance;
}
function Key_F1_getInstance() {
  Key_initEntries();
  return Key_F1_instance;
}
function Key_F2_getInstance() {
  Key_initEntries();
  return Key_F2_instance;
}
function Key_F3_getInstance() {
  Key_initEntries();
  return Key_F3_instance;
}
function Key_F4_getInstance() {
  Key_initEntries();
  return Key_F4_instance;
}
function Key_F5_getInstance() {
  Key_initEntries();
  return Key_F5_instance;
}
function Key_F6_getInstance() {
  Key_initEntries();
  return Key_F6_instance;
}
function Key_F7_getInstance() {
  Key_initEntries();
  return Key_F7_instance;
}
function Key_F8_getInstance() {
  Key_initEntries();
  return Key_F8_instance;
}
function Key_F9_getInstance() {
  Key_initEntries();
  return Key_F9_instance;
}
function Key_F10_getInstance() {
  Key_initEntries();
  return Key_F10_instance;
}
function Key_F11_getInstance() {
  Key_initEntries();
  return Key_F11_instance;
}
function Key_F12_getInstance() {
  Key_initEntries();
  return Key_F12_instance;
}
function Key_F13_getInstance() {
  Key_initEntries();
  return Key_F13_instance;
}
function Key_F14_getInstance() {
  Key_initEntries();
  return Key_F14_instance;
}
function Key_F15_getInstance() {
  Key_initEntries();
  return Key_F15_instance;
}
function Key_F16_getInstance() {
  Key_initEntries();
  return Key_F16_instance;
}
function Key_F17_getInstance() {
  Key_initEntries();
  return Key_F17_instance;
}
function Key_F18_getInstance() {
  Key_initEntries();
  return Key_F18_instance;
}
function Key_F19_getInstance() {
  Key_initEntries();
  return Key_F19_instance;
}
function Key_F20_getInstance() {
  Key_initEntries();
  return Key_F20_instance;
}
function Key_F21_getInstance() {
  Key_initEntries();
  return Key_F21_instance;
}
function Key_F22_getInstance() {
  Key_initEntries();
  return Key_F22_instance;
}
function Key_F23_getInstance() {
  Key_initEntries();
  return Key_F23_instance;
}
function Key_F24_getInstance() {
  Key_initEntries();
  return Key_F24_instance;
}
function Key_F25_getInstance() {
  Key_initEntries();
  return Key_F25_instance;
}
function Key_SHIFT_getInstance() {
  Key_initEntries();
  return Key_SHIFT_instance;
}
function Key_CONTROL_getInstance() {
  Key_initEntries();
  return Key_CONTROL_instance;
}
function Key_ALT_getInstance() {
  Key_initEntries();
  return Key_ALT_instance;
}
function Key_SUPER_getInstance() {
  Key_initEntries();
  return Key_SUPER_instance;
}
function Key_QUOTE_getInstance() {
  Key_initEntries();
  return Key_QUOTE_instance;
}
function Key_UNKNOWN_getInstance() {
  Key_initEntries();
  return Key_UNKNOWN_instance;
}
var MouseButton_LEFT_instance;
var MouseButton_MIDDLE_instance;
var MouseButton_RIGHT_instance;
var MouseButton_BUTTON3_instance;
var MouseButton_BUTTON4_instance;
var MouseButton_BUTTON5_instance;
var MouseButton_BUTTON6_instance;
var MouseButton_BUTTON7_instance;
var MouseButton_BUTTON_WHEEL_instance;
var MouseButton_BUTTON_UNKNOWN_instance;
var MouseButton_NONE_instance;
var Companion_instance_29;
function Companion_getInstance_35() {
  MouseButton_initEntries();
  if (Companion_instance_29 === VOID)
    new Companion_20();
  return Companion_instance_29;
}
function values_6() {
  return [MouseButton_LEFT_getInstance(), MouseButton_MIDDLE_getInstance(), MouseButton_RIGHT_getInstance(), MouseButton_BUTTON3_getInstance(), MouseButton_BUTTON4_getInstance(), MouseButton_BUTTON5_getInstance(), MouseButton_BUTTON6_getInstance(), MouseButton_BUTTON7_getInstance(), MouseButton_BUTTON_WHEEL_getInstance(), MouseButton_BUTTON_UNKNOWN_getInstance(), MouseButton_NONE_getInstance()];
}
var MouseButton_entriesInitialized;
function MouseButton_initEntries() {
  if (MouseButton_entriesInitialized)
    return Unit_instance;
  MouseButton_entriesInitialized = true;
  MouseButton_LEFT_instance = new MouseButton('LEFT', 0, 0);
  MouseButton_MIDDLE_instance = new MouseButton('MIDDLE', 1, 1);
  MouseButton_RIGHT_instance = new MouseButton('RIGHT', 2, 2);
  MouseButton_BUTTON3_instance = new MouseButton('BUTTON3', 3, 3);
  MouseButton_BUTTON4_instance = new MouseButton('BUTTON4', 4, 4);
  MouseButton_BUTTON5_instance = new MouseButton('BUTTON5', 5, 5);
  MouseButton_BUTTON6_instance = new MouseButton('BUTTON6', 6, 6);
  MouseButton_BUTTON7_instance = new MouseButton('BUTTON7', 7, 7);
  MouseButton_BUTTON_WHEEL_instance = new MouseButton('BUTTON_WHEEL', 8, 8);
  MouseButton_BUTTON_UNKNOWN_instance = new MouseButton('BUTTON_UNKNOWN', 9, 10);
  MouseButton_NONE_instance = new MouseButton('NONE', 10, 11, 0);
  Companion_getInstance_35();
}
function MouseButton_LEFT_getInstance() {
  MouseButton_initEntries();
  return MouseButton_LEFT_instance;
}
function MouseButton_MIDDLE_getInstance() {
  MouseButton_initEntries();
  return MouseButton_MIDDLE_instance;
}
function MouseButton_RIGHT_getInstance() {
  MouseButton_initEntries();
  return MouseButton_RIGHT_instance;
}
function MouseButton_BUTTON3_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON3_instance;
}
function MouseButton_BUTTON4_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON4_instance;
}
function MouseButton_BUTTON5_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON5_instance;
}
function MouseButton_BUTTON6_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON6_instance;
}
function MouseButton_BUTTON7_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON7_instance;
}
function MouseButton_BUTTON_WHEEL_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON_WHEEL_instance;
}
function MouseButton_BUTTON_UNKNOWN_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON_UNKNOWN_instance;
}
function MouseButton_NONE_getInstance() {
  MouseButton_initEntries();
  return MouseButton_NONE_instance;
}
var Companion_instance_30;
function Companion_getInstance_36() {
  if (Companion_instance_30 === VOID)
    new Companion_21();
  return Companion_instance_30;
}
function draw(_this__u8e3s4, frameBuffer, vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances) {
  indices = indices === VOID ? null : indices;
  indexType = indexType === VOID ? Companion_getInstance_41().k6o_1 : indexType;
  drawOffset = drawOffset === VOID ? 0 : drawOffset;
  blending = blending === VOID ? Companion_getInstance_42().o6o_1 : blending;
  uniformBlocks = uniformBlocks === VOID ? Companion_getInstance_58().s6o_1 : uniformBlocks;
  textureUnits = textureUnits === VOID ? Companion_instance_31.u6o() : textureUnits;
  stencilRef = stencilRef === VOID ? Companion_getInstance_45().w6o_1 : stencilRef;
  stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_46().y6o_1 : stencilOpFunc;
  colorMask = colorMask === VOID ? Companion_getInstance_47().c6p_1 : colorMask;
  depthAndFrontFace = depthAndFrontFace === VOID ? Companion_getInstance_48().g6p_1 : depthAndFrontFace;
  scissor = scissor === VOID ? Companion_getInstance_43().k6p_1 : scissor;
  cullFace = cullFace === VOID ? Companion_getInstance_49().m6p_1 : cullFace;
  instances = instances === VOID ? 1 : instances;
  return _this__u8e3s4.e6o(frameBuffer.k6n_1, frameBuffer.q6p(), vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances);
}
function draw_0(_this__u8e3s4, batch) {
  return batch.z6p(_this__u8e3s4);
}
function draw_1(_this__u8e3s4, batch) {
  return batch.z6p(_this__u8e3s4);
}
function upload($this, data, needClone) {
  var tmp0_safe_receiver = $this.x6q_1;
  if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r14()) === data.r14()) {
    if (data.r14() < 1024 && Companion_instance_4.j14(data, 0, ensureNotNull($this.x6q_1), 0, data.r14())) {
      return $this;
    }
    Companion_instance_4.i14(data, 0, ensureNotNull($this.x6q_1), 0, data.r14());
  } else {
    $this.x6q_1 = needClone ? clone(data) : data;
  }
  $this.c6r();
  return $this;
}
var Companion_instance_31;
function Companion_getInstance_37() {
  return Companion_instance_31;
}
var Companion_instance_32;
function Companion_getInstance_38() {
  return Companion_instance_32;
}
function markAsDirty($this) {
}
function checkBitmaps($this, bmp) {
  if (!bmp.f3z_1) {
    // Inline function 'korlibs.logger.Logger.error' call
    var this_0 = $this.y6s_1;
    var level = Level_ERROR_getInstance();
    var tmp;
    if (this_0.x2x(level)) {
      // Inline function 'korlibs.graphics.AGTexture.checkBitmaps.<anonymous>' call
      var tmp$ret$0 = 'Trying to upload a non-premultiplied bitmap: ' + toString(bmp) + '. This will cause rendering artifacts';
      this_0.y2x(level, tmp$ret$0);
      tmp = Unit_instance;
    }
  }
}
function _AGTextureUnitInfoArray___init__impl__c77rdb(data) {
  return data;
}
function _AGTextureUnitInfoArray___get_data__impl__a4ycyo($this) {
  return $this;
}
function _AGTextureUnitInfoArray___init__impl__c77rdb_0(size) {
  var tmp = 0;
  var tmp_0 = new Int32Array(size);
  while (tmp < size) {
    tmp_0[tmp] = _AGTextureUnitInfo___get_data__impl__oupy3n(Companion_getInstance_39().c6s_1);
    tmp = tmp + 1 | 0;
  }
  return _AGTextureUnitInfoArray___init__impl__c77rdb(tmp_0);
}
function AGTextureUnitInfoArray__set_impl_s95rfh($this, index, value) {
  _AGTextureUnitInfoArray___get_data__impl__a4ycyo($this)[index] = _AGTextureUnitInfo___get_data__impl__oupy3n(value);
}
function AGTextureUnitInfoArray__get_impl_xhvpef($this, index) {
  return Companion_getInstance_39().i6u(_AGTextureUnitInfoArray___get_data__impl__a4ycyo($this)[index]);
}
function AGTextureUnitInfoArray__copyOf_impl_z2w8z3($this) {
  // Inline function 'kotlin.collections.copyOf' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = _AGTextureUnitInfoArray___get_data__impl__a4ycyo($this).slice();
  return _AGTextureUnitInfoArray___init__impl__c77rdb(tmp$ret$1);
}
function AGTextureUnitInfoArray__toString_impl_kr9cgh($this) {
  return 'AGTextureUnitInfoArray(data=' + toString($this) + ')';
}
function AGTextureUnitInfoArray__hashCode_impl_siosps($this) {
  return hashCode($this);
}
function _AGTextureUnitInfo___init__impl__s1tthu(data) {
  return data;
}
function _AGTextureUnitInfo___get_data__impl__oupy3n($this) {
  return $this;
}
var Companion_instance_33;
function Companion_getInstance_39() {
  if (Companion_instance_33 === VOID)
    new Companion_24();
  return Companion_instance_33;
}
function _AGTextureUnitInfo___get_wrap__impl__dwp6l($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGTextureUnitInfo___get_data__impl__oupy3n($this) >>> 0 | 0) & 3;
  return _AGWrapMode___init__impl__x5wmya(tmp$ret$0);
}
function _AGTextureUnitInfo___get_linear__impl__jak6ny($this) {
  // Inline function 'korlibs.memory.extract' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGTextureUnitInfo___get_data__impl__oupy3n($this) >>> 2 | 0) & 1) === 0);
}
function _AGTextureUnitInfo___get_trilinear__impl__hxtqfb($this) {
  // Inline function 'korlibs.memory.extract' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGTextureUnitInfo___get_data__impl__oupy3n($this) >>> 3 | 0) & 1) === 0);
}
function _AGTextureUnitInfo___get_kind__impl__6xtjoz($this) {
  return _AGTextureTargetKind___init__impl__4zdmch(extract(_AGTextureUnitInfo___get_data__impl__oupy3n($this), 8, 5));
}
function AGTextureUnitInfo__withKind_impl_aa0b04($this, kind) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert5(_AGTextureUnitInfo___get_data__impl__oupy3n($this), _AGTextureTargetKind___get_ordinal__impl__gjzc5p(kind), 8));
}
function AGTextureUnitInfo__withWrap_impl_akwb6y($this, wrap) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert2(_AGTextureUnitInfo___get_data__impl__oupy3n($this), _AGWrapMode___get_ordinal__impl__rc38w2(wrap), 0));
}
function AGTextureUnitInfo__withLinear_impl_jl8yud($this, linear) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert(_AGTextureUnitInfo___get_data__impl__oupy3n($this), linear, 2));
}
function AGTextureUnitInfo__withTrilinear_impl_vhkcy2($this, trilinear) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert(_AGTextureUnitInfo___get_data__impl__oupy3n($this), trilinear, 3));
}
function AGTextureUnitInfo__withLinearTrilinear_impl_aactvz($this, linear, trilinear) {
  return AGTextureUnitInfo__withTrilinear_impl_vhkcy2(AGTextureUnitInfo__withLinear_impl_jl8yud($this, linear), trilinear);
}
function AGTextureUnitInfo__toString_impl_7im6je($this) {
  return 'AGTextureUnitInfo(wrap=' + AGWrapMode__toString_impl_8bjnw2(_AGTextureUnitInfo___get_wrap__impl__dwp6l($this)) + ', linear=' + _AGTextureUnitInfo___get_linear__impl__jak6ny($this) + ', trilinear=' + _AGTextureUnitInfo___get_trilinear__impl__hxtqfb($this) + ', kind=' + AGTextureTargetKind__toString_impl_68648p(_AGTextureUnitInfo___get_kind__impl__6xtjoz($this)) + ')';
}
function AGTextureUnitInfo__hashCode_impl_e8jq9h($this) {
  return $this;
}
function AGTextureUnitInfo__equals_impl_j2jlgn($this, other) {
  if (!(other instanceof AGTextureUnitInfo))
    return false;
  if (!($this === (other instanceof AGTextureUnitInfo ? other.o6u_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGDrawType___init__impl__emm6mb(ordinal) {
  return ordinal;
}
var Companion_instance_34;
function Companion_getInstance_40() {
  if (Companion_instance_34 === VOID)
    new Companion_25();
  return Companion_instance_34;
}
function AGDrawType__toString_impl_eonaeb($this) {
  return $this === Companion_getInstance_40().h6x_1 ? 'POINTS' : $this === Companion_getInstance_40().i6x_1 ? 'LINE_STRIP' : $this === Companion_getInstance_40().j6x_1 ? 'LINE_LOOP' : $this === Companion_getInstance_40().k6x_1 ? 'LINES' : $this === Companion_getInstance_40().l6x_1 ? 'TRIANGLES' : $this === Companion_getInstance_40().m6x_1 ? 'TRIANGLE_STRIP' : $this === Companion_getInstance_40().n6x_1 ? 'TRIANGLE_FAN' : '-';
}
function AGDrawType__hashCode_impl_ylaury($this) {
  return $this;
}
function AGDrawType__equals_impl_rtafo6($this, other) {
  if (!(other instanceof AGDrawType))
    return false;
  if (!($this === (other instanceof AGDrawType ? other.o6x_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGIndexType___init__impl__yqnmb7(ordinal) {
  return ordinal;
}
var Companion_instance_35;
function Companion_getInstance_41() {
  if (Companion_instance_35 === VOID)
    new Companion_26();
  return Companion_instance_35;
}
function AGIndexType__toString_impl_hjqwm3($this) {
  return $this === Companion_getInstance_41().i6o_1 ? 'null' : $this === Companion_getInstance_41().j6o_1 ? 'UBYTE' : $this === Companion_getInstance_41().k6o_1 ? 'USHORT' : $this === Companion_getInstance_41().l6o_1 ? 'UINT' : '-';
}
function AGIndexType__hashCode_impl_47f06s($this) {
  return $this;
}
function _AGBlending___init__impl__upt3bq(data) {
  return data;
}
function _AGBlending___get_data__impl__7m3zd1($this) {
  return $this;
}
function _AGBlending___get_srcRGB__impl__jvh03e($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 0 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_srcA__impl__ftmwxe($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 4 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_dstRGB__impl__nz9ogp($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 8 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_dstA__impl__l7q6tv($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 12 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_eqRGB__impl__7pv8oi($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 16 | 0) & 3;
  return _AGBlendEquation___init__impl__fpv7c2(tmp$ret$0);
}
function _AGBlending___get_eqA__impl__2j4ray($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 18 | 0) & 3;
  return _AGBlendEquation___init__impl__fpv7c2(tmp$ret$0);
}
function AGBlending__withSRC_impl_hh0mjq($this, rgb, a) {
  return _AGBlending___init__impl__upt3bq(insert4(insert4(_AGBlending___get_data__impl__7m3zd1($this), _AGBlendFactor___get_ordinal__impl__r9efzn(rgb), 0), _AGBlendFactor___get_ordinal__impl__r9efzn(a), 4));
}
function AGBlending__withSRC$default_impl_uuu5hz($this, rgb, a, $super) {
  a = a === VOID ? rgb : a;
  var tmp;
  if ($super === VOID) {
    tmp = AGBlending__withSRC_impl_hh0mjq($this, rgb, a);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGBlending(tmp_0)).q6x.call(new AGBlending($this), new AGBlendFactor(rgb), new AGBlendFactor(a)).p6x_1;
  }
  return tmp;
}
function AGBlending__withDST_impl_y1hpet($this, rgb, a) {
  return _AGBlending___init__impl__upt3bq(insert4(insert4(_AGBlending___get_data__impl__7m3zd1($this), _AGBlendFactor___get_ordinal__impl__r9efzn(rgb), 8), _AGBlendFactor___get_ordinal__impl__r9efzn(a), 12));
}
function AGBlending__withDST$default_impl_leu6qg($this, rgb, a, $super) {
  a = a === VOID ? rgb : a;
  var tmp;
  if ($super === VOID) {
    tmp = AGBlending__withDST_impl_y1hpet($this, rgb, a);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGBlending(tmp_0)).r6x.call(new AGBlending($this), new AGBlendFactor(rgb), new AGBlendFactor(a)).p6x_1;
  }
  return tmp;
}
function AGBlending__withEQ_impl_e9gm04($this, rgb, a) {
  return _AGBlending___init__impl__upt3bq(insert2(insert2(_AGBlending___get_data__impl__7m3zd1($this), _AGBlendEquation___get_ordinal__impl__895p3q(rgb), 16), _AGBlendEquation___get_ordinal__impl__895p3q(a), 18));
}
function AGBlending__withEQ$default_impl_iltiw7($this, rgb, a, $super) {
  a = a === VOID ? rgb : a;
  var tmp;
  if ($super === VOID) {
    tmp = AGBlending__withEQ_impl_e9gm04($this, rgb, a);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGBlending(tmp_0)).s6x.call(new AGBlending($this), new AGBlendEquation(rgb), new AGBlendEquation(a)).p6x_1;
  }
  return tmp;
}
function _AGBlending___get_enabled__impl__s7igz6($this) {
  return !($this === Companion_getInstance_42().n6o_1);
}
function AGBlending__toString_impl_d5hic6($this) {
  return 'Blending(outRGB = (srcRGB * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_srcRGB__impl__jvh03e($this)) + ') ' + _AGBlendEquation___get_op__impl__7f9os6(_AGBlending___get_eqRGB__impl__7pv8oi($this)) + ' (dstRGB * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_dstRGB__impl__nz9ogp($this)) + '), outA = (srcA * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_srcA__impl__ftmwxe($this)) + ') ' + _AGBlendEquation___get_op__impl__7f9os6(_AGBlending___get_eqA__impl__2j4ray($this)) + ' (dstA * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_dstA__impl__l7q6tv($this)) + '))';
}
var Companion_instance_36;
function Companion_getInstance_42() {
  if (Companion_instance_36 === VOID)
    new Companion_27();
  return Companion_instance_36;
}
function AGBlending__hashCode_impl_ywnf51($this) {
  return $this;
}
function AGBlending__equals_impl_rp3dmf($this, other) {
  if (!(other instanceof AGBlending))
    return false;
  if (!($this === (other instanceof AGBlending ? other.p6x_1 : THROW_CCE())))
    return false;
  return true;
}
var Companion_instance_37;
function Companion_getInstance_43() {
  if (Companion_instance_37 === VOID)
    new Companion_28();
  return Companion_instance_37;
}
function _AGFrameBufferInfo___init__impl__dbxiro(dataLong) {
  return dataLong;
}
function _AGFrameBufferInfo___get_dataLong__impl__7vov5d($this) {
  return $this;
}
function _AGFrameBufferInfo___get_data__impl__7q146j($this) {
  return get_low(_AGFrameBufferInfo___get_dataLong__impl__7vov5d($this));
}
function _AGFrameBufferInfo___get_data2__impl__rgyo5b($this) {
  return get_high(_AGFrameBufferInfo___get_dataLong__impl__7vov5d($this));
}
function _AGFrameBufferInfo___init__impl__dbxiro_0(data, data2) {
  // Inline function 'korlibs.memory.fromLowHigh' call
  Companion_getInstance_0();
  var tmp$ret$0 = toLong(data).j4(new Long(-1, 0)).k4(toLong(data2).g4(32));
  return _AGFrameBufferInfo___init__impl__dbxiro(tmp$ret$0);
}
function _AGFrameBufferInfo___get_width__impl__yhp94z($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 0 | 0) & 16383;
}
function _AGFrameBufferInfo___get_height__impl__yfespa($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 14 | 0) & 16383;
}
function _AGFrameBufferInfo___get_x__impl__6dzfjj($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data2__impl__rgyo5b($this) >>> 0 | 0) & 16383;
}
function _AGFrameBufferInfo___get_y__impl__mfn1io($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data2__impl__rgyo5b($this) >>> 14 | 0) & 16383;
}
function _AGFrameBufferInfo___get_size__impl__uw80y4($this) {
  return Companion_instance_48.x6y(_AGFrameBufferInfo___get_width__impl__yhp94z($this), _AGFrameBufferInfo___get_height__impl__yfespa($this));
}
function _AGFrameBufferInfo___get_hasDepth__impl__9knjmc($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 28 | 0) & 1) === 0);
}
function _AGFrameBufferInfo___get_hasStencil__impl__hjoes3($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 29 | 0) & 1) === 0);
}
function _get_samplesBits__rfaq0u($this) {
  // Inline function 'korlibs.memory.extract2' call
  return (_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 30 | 0) & 3;
}
function _AGFrameBufferInfo___get_samples__impl__7k555s($this) {
  return 1 << _get_samplesBits__rfaq0u($this);
}
function _AGFrameBufferInfo___get_hasStencilAndDepth__impl__aauqdj($this) {
  return _AGFrameBufferInfo___get_hasDepth__impl__9knjmc($this) && _AGFrameBufferInfo___get_hasStencil__impl__hjoes3($this);
}
function AGFrameBufferInfo__withXY_impl_rfdctr($this, x, y) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(_AGFrameBufferInfo___get_data__impl__7q146j($this), insert14(insert14(_AGFrameBufferInfo___get_data2__impl__rgyo5b($this), x, 0), y, 14));
}
function AGFrameBufferInfo__withSize_impl_sc5iep($this, width, height) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert14(insert14(_AGFrameBufferInfo___get_data__impl__7q146j($this), width, 0), height, 14), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__withBounds_impl_sg0n3x($this, x, y, width, height) {
  return AGFrameBufferInfo__withSize_impl_sc5iep(AGFrameBufferInfo__withXY_impl_rfdctr($this, x, y), width, height);
}
function AGFrameBufferInfo__withHasDepth_impl_fjgbiv($this, hasDepth) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert(_AGFrameBufferInfo___get_data__impl__7q146j($this), hasDepth, 28), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__withHasStencil_impl_nbaemo($this, hasStencil) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert(_AGFrameBufferInfo___get_data__impl__7q146j($this), hasStencil, 29), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__withSamples_impl_83818f($this, samples) {
  return withSamplesBits($this, ilog2(samples));
}
function withSamplesBits($this, bits) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert2(_AGFrameBufferInfo___get_data__impl__7q146j($this), bits, 30), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__toString_impl_xecyr8($this) {
  return 'AGFrameBufferInfo(width=' + _AGFrameBufferInfo___get_width__impl__yhp94z($this) + ', height=' + _AGFrameBufferInfo___get_height__impl__yfespa($this) + ', hasDepth=' + _AGFrameBufferInfo___get_hasDepth__impl__9knjmc($this) + ', hasStencil=' + _AGFrameBufferInfo___get_hasStencil__impl__hjoes3($this) + ', samples=' + _AGFrameBufferInfo___get_samples__impl__7k555s($this) + ')';
}
var Companion_instance_38;
function Companion_getInstance_44() {
  if (Companion_instance_38 === VOID)
    new Companion_29();
  return Companion_instance_38;
}
function AGFrameBufferInfo__hashCode_impl_fvl6f1($this) {
  return $this.hashCode();
}
var AGFinish_instance;
function AGFinish_getInstance() {
  return AGFinish_instance;
}
function _AGStencilReference___init__impl__rta8vg(data) {
  return data;
}
function _AGStencilReference___get_data__impl__j5p6bn($this) {
  return $this;
}
function _AGStencilReference___init__impl__rta8vg_0(front, back) {
  // Inline function 'korlibs.memory.fromLowHigh' call
  Companion_getInstance_0();
  var tmp$ret$0 = toLong(front).j4(new Long(-1, 0)).k4(toLong(back).g4(32));
  return _AGStencilReference___init__impl__rta8vg(tmp$ret$0);
}
var Companion_instance_39;
function Companion_getInstance_45() {
  if (Companion_instance_39 === VOID)
    new Companion_30();
  return Companion_instance_39;
}
function _AGStencilReference___get_front__impl__6ggyy0($this) {
  return get_low(_AGStencilReference___get_data__impl__j5p6bn($this));
}
function _AGStencilReference___get_back__impl__mm7fqe($this) {
  return get_high(_AGStencilReference___get_data__impl__j5p6bn($this));
}
function _AGStencilReference___get_referenceValueFront__impl__p7smsu($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_front__impl__6ggyy0($this) >>> 0 | 0) & 255;
}
function _AGStencilReference___get_readMaskFront__impl__oc0s46($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_front__impl__6ggyy0($this) >>> 8 | 0) & 255;
}
function _AGStencilReference___get_writeMaskFront__impl__cqdpbj($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_front__impl__6ggyy0($this) >>> 16 | 0) & 255;
}
function _AGStencilReference___get_referenceValueBack__impl__mlrbhc($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_back__impl__mm7fqe($this) >>> 0 | 0) & 255;
}
function _AGStencilReference___get_readMaskBack__impl__lwtaqk($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_back__impl__mm7fqe($this) >>> 8 | 0) & 255;
}
function _AGStencilReference___get_writeMaskBack__impl__mths73($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_back__impl__mm7fqe($this) >>> 16 | 0) & 255;
}
function AGStencilReference__withReferenceValue_impl_lm1qpg($this, referenceValue, referenceValueBack) {
  return _AGStencilReference___init__impl__rta8vg_0(insert8(_AGStencilReference___get_front__impl__6ggyy0($this), referenceValue, 0), insert8(_AGStencilReference___get_back__impl__mm7fqe($this), referenceValueBack, 0));
}
function AGStencilReference__withReferenceValue$default_impl_2trj0v($this, referenceValue, referenceValueBack, $super) {
  referenceValueBack = referenceValueBack === VOID ? referenceValue : referenceValueBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilReference__withReferenceValue_impl_lm1qpg($this, referenceValue, referenceValueBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilReference(tmp_0)).j6z.call(new AGStencilReference($this), referenceValue, referenceValueBack).i6z_1;
  }
  return tmp;
}
function AGStencilReference__withReadMask_impl_75whrk($this, readMask, readMaskBack) {
  return _AGStencilReference___init__impl__rta8vg_0(insert8(_AGStencilReference___get_front__impl__6ggyy0($this), readMask, 8), insert8(_AGStencilReference___get_back__impl__mm7fqe($this), readMaskBack, 8));
}
function AGStencilReference__withReadMask$default_impl_7mdffx($this, readMask, readMaskBack, $super) {
  readMaskBack = readMaskBack === VOID ? readMask : readMaskBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilReference__withReadMask_impl_75whrk($this, readMask, readMaskBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilReference(tmp_0)).k6z.call(new AGStencilReference($this), readMask, readMaskBack).i6z_1;
  }
  return tmp;
}
function AGStencilReference__withWriteMask_impl_s5s8t($this, writeMask, writeMaskBack) {
  return _AGStencilReference___init__impl__rta8vg_0(insert8(_AGStencilReference___get_front__impl__6ggyy0($this), writeMask, 16), insert8(_AGStencilReference___get_back__impl__mm7fqe($this), writeMaskBack, 16));
}
function AGStencilReference__withWriteMask$default_impl_b7j7b4($this, writeMask, writeMaskBack, $super) {
  writeMaskBack = writeMaskBack === VOID ? writeMask : writeMaskBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilReference__withWriteMask_impl_s5s8t($this, writeMask, writeMaskBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilReference(tmp_0)).l6z.call(new AGStencilReference($this), writeMask, writeMaskBack).i6z_1;
  }
  return tmp;
}
function AGStencilReference__toString_impl_qu5r8s($this) {
  return 'AGStencilReference(front=[referenceValue=' + _AGStencilReference___get_referenceValueFront__impl__p7smsu($this) + ', readMask=' + _AGStencilReference___get_readMaskFront__impl__oc0s46($this) + ', writeMask=' + _AGStencilReference___get_writeMaskFront__impl__cqdpbj($this) + '], back=[referenceValue=' + _AGStencilReference___get_referenceValueBack__impl__mlrbhc($this) + ', readMask=' + _AGStencilReference___get_readMaskBack__impl__lwtaqk($this) + ', writeMask=' + _AGStencilReference___get_writeMaskBack__impl__mths73($this) + '])';
}
function AGStencilReference__hashCode_impl_52zufx($this) {
  return $this.hashCode();
}
function AGStencilReference__equals_impl_kj05j($this, other) {
  if (!(other instanceof AGStencilReference))
    return false;
  var tmp0_other_with_cast = other instanceof AGStencilReference ? other.i6z_1 : THROW_CCE();
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function _AGStencilOpFunc___init__impl__t3f62q(data) {
  return data;
}
function _AGStencilOpFunc___get_data__impl__jitrg1($this) {
  return $this;
}
var Companion_instance_40;
function Companion_getInstance_46() {
  if (Companion_instance_40 === VOID)
    new Companion_31();
  return Companion_instance_40;
}
function _AGStencilOpFunc___get_enabled__impl__hxq8wy($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 31 | 0) & 1) === 0);
}
function _AGStencilOpFunc___get_compareModeFront__impl__uctsey($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 0 | 0) & 7;
  return _AGCompareMode___init__impl__j8kqbb(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 3 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 6 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 9 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_compareModeBack__impl__2rklx0($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 12 | 0) & 7;
  return _AGCompareMode___init__impl__j8kqbb(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 15 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 18 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 21 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function AGStencilOpFunc__withEnabled_impl_mpcwmr($this, enabled) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert(_AGStencilOpFunc___get_data__impl__jitrg1($this), enabled, 31));
}
function AGStencilOpFunc__withCompareMode_impl_5ovohy($this, compareMode, compareModeBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGCompareMode___get_ordinal__impl__ikvlmz(compareMode), 0), _AGCompareMode___get_ordinal__impl__ikvlmz(compareModeBack), 12));
}
function AGStencilOpFunc__withCompareMode$default_impl_rzbauv($this, compareMode, compareModeBack, $super) {
  compareModeBack = compareModeBack === VOID ? compareMode : compareModeBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilOpFunc__withCompareMode_impl_5ovohy($this, compareMode, compareModeBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).d70.call(new AGStencilOpFunc($this), new AGCompareMode(compareMode), new AGCompareMode(compareModeBack)).c70_1;
  }
  return tmp;
}
function AGStencilOpFunc__withActionOnBothPass_impl_qbn6at($this, actionOnBothPass, actionOnBothPassBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnBothPass), 3), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnBothPassBack), 15));
}
function AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo($this, actionOnBothPass, actionOnBothPassBack, $super) {
  actionOnBothPassBack = actionOnBothPassBack === VOID ? actionOnBothPass : actionOnBothPassBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilOpFunc__withActionOnBothPass_impl_qbn6at($this, actionOnBothPass, actionOnBothPassBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).e70.call(new AGStencilOpFunc($this), new AGStencilOp(actionOnBothPass), new AGStencilOp(actionOnBothPassBack)).c70_1;
  }
  return tmp;
}
function AGStencilOpFunc__withActionOnDepthFail_impl_6tt0te($this, actionOnDepthFail, actionOnDepthFailBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthFail), 6), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthFailBack), 18));
}
function AGStencilOpFunc__withActionOnDepthPassStencilFail_impl_q34w35($this, actionOnDepthPassStencilFail, actionOnDepthPassStencilFailBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthPassStencilFail), 9), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthPassStencilFailBack), 21));
}
function AGStencilOpFunc__withAction_impl_p1jbl6($this, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, actionOnBothPassBack, actionOnDepthFailBack, actionOnDepthPassStencilFailBack) {
  return AGStencilOpFunc__withActionOnDepthPassStencilFail_impl_q34w35(AGStencilOpFunc__withActionOnDepthFail_impl_6tt0te(AGStencilOpFunc__withActionOnBothPass_impl_qbn6at($this, actionOnBothPass, actionOnBothPassBack), actionOnDepthFail, actionOnDepthFailBack), actionOnDepthPassStencilFail, actionOnDepthPassStencilFailBack);
}
function AGStencilOpFunc__withAction$default_impl_jx9cm1($this, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, actionOnBothPassBack, actionOnDepthFailBack, actionOnDepthPassStencilFailBack, $super) {
  actionOnDepthFail = actionOnDepthFail === VOID ? actionOnBothPass : actionOnDepthFail;
  actionOnDepthPassStencilFail = actionOnDepthPassStencilFail === VOID ? actionOnDepthFail : actionOnDepthPassStencilFail;
  actionOnBothPassBack = actionOnBothPassBack === VOID ? actionOnBothPass : actionOnBothPassBack;
  actionOnDepthFailBack = actionOnDepthFailBack === VOID ? actionOnDepthFail : actionOnDepthFailBack;
  actionOnDepthPassStencilFailBack = actionOnDepthPassStencilFailBack === VOID ? actionOnDepthPassStencilFail : actionOnDepthPassStencilFailBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilOpFunc__withAction_impl_p1jbl6($this, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, actionOnBothPassBack, actionOnDepthFailBack, actionOnDepthPassStencilFailBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).f70.call(new AGStencilOpFunc($this), new AGStencilOp(actionOnBothPass), new AGStencilOp(actionOnDepthFail), new AGStencilOp(actionOnDepthPassStencilFail), new AGStencilOp(actionOnBothPassBack), new AGStencilOp(actionOnDepthFailBack), new AGStencilOp(actionOnDepthPassStencilFailBack)).c70_1;
  }
  return tmp;
}
function AGStencilOpFunc__toString_impl_pl8quy($this) {
  if (!_AGStencilOpFunc___get_enabled__impl__hxq8wy($this))
    return 'AGStencilOpFunc(enabled=false)';
  return 'AGStencilOpFunc(enabled=' + _AGStencilOpFunc___get_enabled__impl__hxq8wy($this) + ', front=[compareMode=' + AGCompareMode__toString_impl_gs33a9(_AGStencilOpFunc___get_compareModeFront__impl__uctsey($this)) + ', actions=[' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh($this)) + ']], back=[compareMode=' + AGCompareMode__toString_impl_gs33a9(_AGStencilOpFunc___get_compareModeBack__impl__2rklx0($this)) + ', actions=[' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh($this)) + ']])';
}
function AGStencilOpFunc__hashCode_impl_nopebb($this) {
  return $this;
}
function AGStencilOpFunc__equals_impl_y44i4z($this, other) {
  if (!(other instanceof AGStencilOpFunc))
    return false;
  if (!($this === (other instanceof AGStencilOpFunc ? other.c70_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGColorMask___init__impl__j38ai8(data) {
  return data;
}
function _AGColorMask___get_data__impl__swj1bz($this) {
  return $this;
}
function _AGColorMask___get_red__impl__opo1fo($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 0 | 0) & 1) === 0);
}
function _AGColorMask___get_green__impl__d3m1w2($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 1 | 0) & 1) === 0);
}
function _AGColorMask___get_blue__impl__42l0s1($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 2 | 0) & 1) === 0);
}
function _AGColorMask___get_alpha__impl__xmrqzb($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 3 | 0) & 1) === 0);
}
function _AGColorMask___init__impl__j38ai8_0(red, green, blue, alpha) {
  return _AGColorMask___init__impl__j38ai8(insert(insert(insert(insert(0, red, 0), green, 1), blue, 2), alpha, 3));
}
function _AGColorMask___init__impl__j38ai8_1(value) {
  value = value === VOID ? true : value;
  return _AGColorMask___init__impl__j38ai8_0(value, value, value, value);
}
function AGColorMask__toString_impl_5i5oqg($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.f();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.graphics.AGColorMask.toString.<anonymous>' call
  this_0.bc('AGColorMask(');
  this_0.bc(_AGColorMask___get_red__impl__opo1fo($this) ? 'R' : 'r');
  this_0.bc(_AGColorMask___get_green__impl__d3m1w2($this) ? 'G' : 'g');
  this_0.bc(_AGColorMask___get_blue__impl__42l0s1($this) ? 'B' : 'b');
  this_0.bc(_AGColorMask___get_alpha__impl__xmrqzb($this) ? 'A' : 'a');
  this_0.bc(')');
  return this_0.toString();
}
var Companion_instance_41;
function Companion_getInstance_47() {
  if (Companion_instance_41 === VOID)
    new Companion_32();
  return Companion_instance_41;
}
function AGColorMask__hashCode_impl_g9082f($this) {
  return $this;
}
function AGColorMask__equals_impl_mrih8l($this, other) {
  if (!(other instanceof AGColorMask))
    return false;
  if (!($this === (other instanceof AGColorMask ? other.g70_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGDepthAndFrontFace___init__impl__ra8x65(data) {
  return data;
}
function _AGDepthAndFrontFace___get_data__impl__v8zkce($this) {
  return $this;
}
var Companion_instance_42;
function Companion_getInstance_48() {
  if (Companion_instance_42 === VOID)
    new Companion_33();
  return Companion_instance_42;
}
function _AGDepthAndFrontFace___get_depthNear__impl__cir3a1($this) {
  return extractScaledf01(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), 0, 12);
}
function _AGDepthAndFrontFace___get_depthFar__impl__g0cno8($this) {
  return extractScaledf01(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), 12, 12);
}
function _AGDepthAndFrontFace___get_depthMask__impl__ouijn($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGDepthAndFrontFace___get_data__impl__v8zkce($this) >>> 24 | 0) & 1) === 0);
}
function _AGDepthAndFrontFace___get_depthFunc__impl__8fo7zp($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGDepthAndFrontFace___get_data__impl__v8zkce($this) >>> 26 | 0) & 7;
  return _AGCompareMode___init__impl__j8kqbb(tmp$ret$0);
}
function _AGDepthAndFrontFace___get_frontFace__impl__w07k4s($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGDepthAndFrontFace___get_data__impl__v8zkce($this) >>> 30 | 0) & 3;
  return _AGFrontFace___init__impl__vsm7rb(tmp$ret$0);
}
function AGDepthAndFrontFace__withDepth_impl_wsx82k($this, near, far) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insertScaledf01(insertScaledf01(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), near, 0, 12), far, 12, 12));
}
function AGDepthAndFrontFace__withDepthMask_impl_610nhs($this, depthMask) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insert(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), depthMask, 24));
}
function AGDepthAndFrontFace__withDepthFunc_impl_7t7yrs($this, depthFunc) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insert3(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), _AGCompareMode___get_ordinal__impl__ikvlmz(depthFunc), 26));
}
function AGDepthAndFrontFace__withFrontFace_impl_mwk87t($this, frontFace) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insert2(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), _AGFrontFace___get_ordinal__impl__d4iagj(frontFace), 30));
}
function AGDepthAndFrontFace__toString_impl_c305m3($this) {
  return 'AGDepthAndFrontFace(data=' + $this + ')';
}
function AGDepthAndFrontFace__hashCode_impl_xu62ey($this) {
  return $this;
}
function _AGCullFace___init__impl__ckmjdg(ordinal) {
  return ordinal;
}
function _AGCullFace___get_ordinal__impl__jd1wps($this) {
  return $this;
}
var Companion_instance_43;
function Companion_getInstance_49() {
  if (Companion_instance_43 === VOID)
    new Companion_34();
  return Companion_instance_43;
}
function AGCullFace__toString_impl_7d891w($this) {
  return $this === Companion_getInstance_49().m6p_1 ? 'NONE' : $this === Companion_getInstance_49().p6p_1 ? 'BOTH' : $this === Companion_getInstance_49().n6p_1 ? 'FRONT' : $this === Companion_getInstance_49().o6p_1 ? 'BACK' : '-';
}
function AGCullFace__hashCode_impl_t4e5ur($this) {
  return $this;
}
function AGCullFace__equals_impl_wgngjr($this, other) {
  if (!(other instanceof AGCullFace))
    return false;
  if (!($this === (other instanceof AGCullFace ? other.k70_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGTextureTargetKind___init__impl__4zdmch(ordinal) {
  return ordinal;
}
function _AGTextureTargetKind___get_ordinal__impl__gjzc5p($this) {
  return $this;
}
function AGTextureTargetKind__toString_impl_68648p($this) {
  return $this === Companion_getInstance_50().k6t_1 ? 'TEXTURE_2D' : $this === Companion_getInstance_50().l6t_1 ? 'TEXTURE_3D' : $this === Companion_getInstance_50().m6t_1 ? 'TEXTURE_CUBE_MAP' : $this === Companion_getInstance_50().n6t_1 ? 'EXTERNAL_TEXTURE' : 'AGTextureTargetKind(' + _AGTextureTargetKind___get_ordinal__impl__gjzc5p($this) + ')';
}
function _AGTextureTargetKind___get_dims__impl__k3cmhd($this) {
  return $this === Companion_getInstance_50().k6t_1 ? 2 : $this === Companion_getInstance_50().l6t_1 ? 3 : $this === Companion_getInstance_50().m6t_1 ? 3 : $this === Companion_getInstance_50().n6t_1 ? 3 : 0;
}
var Companion_instance_44;
function Companion_getInstance_50() {
  if (Companion_instance_44 === VOID)
    new Companion_35();
  return Companion_instance_44;
}
function AGTextureTargetKind__hashCode_impl_rzc11k($this) {
  return $this;
}
function AGTextureTargetKind__equals_impl_q2tams($this, other) {
  if (!(other instanceof AGTextureTargetKind))
    return false;
  if (!($this === (other instanceof AGTextureTargetKind ? other.p6t_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGWrapMode___init__impl__x5wmya(ordinal) {
  return ordinal;
}
function _AGWrapMode___get_ordinal__impl__rc38w2($this) {
  return $this;
}
var Companion_instance_45;
function Companion_getInstance_51() {
  if (Companion_instance_45 === VOID)
    new Companion_36();
  return Companion_instance_45;
}
function AGWrapMode__toString_impl_8bjnw2($this) {
  return $this === Companion_getInstance_51().j6u_1 ? 'CLAMP_TO_EDGE' : $this === Companion_getInstance_51().k6u_1 ? 'REPEAT' : $this === Companion_getInstance_51().l6u_1 ? 'MIRRORED_REPEAT' : '<' + _AGWrapMode___get_ordinal__impl__rc38w2($this) + '>';
}
function AGWrapMode__hashCode_impl_u2pkox($this) {
  return $this;
}
function AGWrapMode__equals_impl_4aw0kl($this, other) {
  if (!(other instanceof AGWrapMode))
    return false;
  if (!($this === (other instanceof AGWrapMode ? other.g71_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGBlendFactor___init__impl__iqtmxr(ordinal) {
  return ordinal;
}
function _AGBlendFactor___get_ordinal__impl__r9efzn($this) {
  return $this;
}
var Companion_instance_46;
function Companion_getInstance_52() {
  if (Companion_instance_46 === VOID)
    new Companion_37();
  return Companion_instance_46;
}
function AGBlendFactor__toString_impl_1hr6m1($this) {
  return $this === Companion_getInstance_52().t6x_1 ? 'DESTINATION_ALPHA' : $this === Companion_getInstance_52().u6x_1 ? 'DESTINATION_COLOR' : $this === Companion_getInstance_52().v6x_1 ? 'ONE' : $this === Companion_getInstance_52().w6x_1 ? 'ONE_MINUS_DESTINATION_ALPHA' : $this === Companion_getInstance_52().x6x_1 ? 'ONE_MINUS_DESTINATION_COLOR' : $this === Companion_getInstance_52().y6x_1 ? 'ONE_MINUS_SOURCE_ALPHA' : $this === Companion_getInstance_52().z6x_1 ? 'ONE_MINUS_SOURCE_COLOR' : $this === Companion_getInstance_52().a6y_1 ? 'SOURCE_ALPHA' : $this === Companion_getInstance_52().b6y_1 ? 'SOURCE_COLOR' : $this === Companion_getInstance_52().c6y_1 ? 'ZERO' : '-';
}
function _AGBlendFactor___get_op__impl__b5pfnd($this) {
  var tmp;
  if ($this === Companion_getInstance_52().t6x_1) {
    tmp = 'dstA';
  } else if ($this === Companion_getInstance_52().u6x_1) {
    tmp = 'dstRGB';
  } else if ($this === Companion_getInstance_52().v6x_1) {
    tmp = '1';
  } else if ($this === Companion_getInstance_52().w6x_1) {
    tmp = '(1 - dstA)';
  } else if ($this === Companion_getInstance_52().x6x_1) {
    tmp = '(1 - dstRGB)';
  } else if ($this === Companion_getInstance_52().y6x_1) {
    tmp = '(1 - srcA)';
  } else if ($this === Companion_getInstance_52().z6x_1) {
    tmp = '(1 - srcRGB)';
  } else if ($this === Companion_getInstance_52().a6y_1) {
    tmp = 'srcA';
  } else if ($this === Companion_getInstance_52().b6y_1) {
    tmp = 'srcRGB';
  } else if ($this === Companion_getInstance_52().c6y_1) {
    tmp = '0';
  } else {
    get_unreachable();
  }
  return tmp;
}
function AGBlendFactor__hashCode_impl_n8x3ew($this) {
  return $this;
}
function AGBlendFactor__equals_impl_dlauac($this, other) {
  if (!(other instanceof AGBlendFactor))
    return false;
  if (!($this === (other instanceof AGBlendFactor ? other.h71_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGBlendEquation___init__impl__fpv7c2(ordinal) {
  return ordinal;
}
function _AGBlendEquation___get_ordinal__impl__895p3q($this) {
  return $this;
}
var Companion_instance_47;
function Companion_getInstance_53() {
  if (Companion_instance_47 === VOID)
    new Companion_38();
  return Companion_instance_47;
}
function AGBlendEquation__toString_impl_5t2sx6($this) {
  return $this === Companion_getInstance_53().g6y_1 ? 'ADD' : $this === Companion_getInstance_53().h6y_1 ? 'SUBTRACT' : $this === Companion_getInstance_53().i6y_1 ? 'REVERSE_SUBTRACT' : '-';
}
function _AGBlendEquation___get_op__impl__7f9os6($this) {
  var tmp;
  if ($this === Companion_getInstance_53().g6y_1) {
    tmp = '+';
  } else if ($this === Companion_getInstance_53().h6y_1) {
    tmp = '-';
  } else if ($this === Companion_getInstance_53().i6y_1) {
    tmp = 'r-';
  } else {
    get_unreachable();
  }
  return tmp;
}
function AGBlendEquation__hashCode_impl_fy33vp($this) {
  return $this;
}
function AGBlendEquation__equals_impl_yykk3b($this, other) {
  if (!(other instanceof AGBlendEquation))
    return false;
  if (!($this === (other instanceof AGBlendEquation ? other.i71_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGSize___init__impl__h9blcq(data) {
  return data;
}
function AGSize__with_impl_qn6qww($this, width, height) {
  return _AGSize___init__impl__h9blcq(insert_0(insert_0(0, width, 0, 16), height, 16, 16));
}
var Companion_instance_48;
function Companion_getInstance_54() {
  return Companion_instance_48;
}
function _AGStencilOp___init__impl__llpkv6(ordinal) {
  return ordinal;
}
function _AGStencilOp___get_ordinal__impl__xkavfu($this) {
  return $this;
}
var Companion_instance_49;
function Companion_getInstance_55() {
  if (Companion_instance_49 === VOID)
    new Companion_40();
  return Companion_instance_49;
}
function AGStencilOp__toString_impl_1dm6fq($this) {
  return $this === Companion_getInstance_55().u6z_1 ? 'DECREMENT_SATURATE' : $this === Companion_getInstance_55().v6z_1 ? 'DECREMENT_WRAP' : $this === Companion_getInstance_55().w6z_1 ? 'INCREMENT_SATURATE' : $this === Companion_getInstance_55().x6z_1 ? 'INCREMENT_WRAP' : $this === Companion_getInstance_55().y6z_1 ? 'INVERT' : $this === Companion_getInstance_55().z6z_1 ? 'KEEP' : $this === Companion_getInstance_55().a70_1 ? 'SET' : $this === Companion_getInstance_55().b70_1 ? 'ZERO' : '-';
}
function AGStencilOp__hashCode_impl_n4s38l($this) {
  return $this;
}
function AGStencilOp__equals_impl_rq4p55($this, other) {
  if (!(other instanceof AGStencilOp))
    return false;
  if (!($this === (other instanceof AGStencilOp ? other.k71_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGCompareMode___init__impl__j8kqbb(ordinal) {
  return ordinal;
}
function _AGCompareMode___get_ordinal__impl__ikvlmz($this) {
  return $this;
}
var Companion_instance_50;
function Companion_getInstance_56() {
  if (Companion_instance_50 === VOID)
    new Companion_41();
  return Companion_instance_50;
}
function AGCompareMode__toString_impl_gs33a9($this) {
  return $this === Companion_getInstance_56().m6z_1 ? 'ALWAYS' : $this === Companion_getInstance_56().n6z_1 ? 'EQUAL' : $this === Companion_getInstance_56().o6z_1 ? 'GREATER' : $this === Companion_getInstance_56().p6z_1 ? 'GREATER_EQUAL' : $this === Companion_getInstance_56().q6z_1 ? 'LESS' : $this === Companion_getInstance_56().r6z_1 ? 'LESS_EQUAL' : $this === Companion_getInstance_56().s6z_1 ? 'NEVER' : $this === Companion_getInstance_56().t6z_1 ? 'NOT_EQUAL' : '-';
}
function AGCompareMode__inverted_impl_7xxk8m($this) {
  return $this === Companion_getInstance_56().m6z_1 ? Companion_getInstance_56().s6z_1 : $this === Companion_getInstance_56().n6z_1 ? Companion_getInstance_56().t6z_1 : $this === Companion_getInstance_56().o6z_1 ? Companion_getInstance_56().r6z_1 : $this === Companion_getInstance_56().p6z_1 ? Companion_getInstance_56().q6z_1 : $this === Companion_getInstance_56().q6z_1 ? Companion_getInstance_56().p6z_1 : $this === Companion_getInstance_56().r6z_1 ? Companion_getInstance_56().o6z_1 : $this === Companion_getInstance_56().s6z_1 ? Companion_getInstance_56().m6z_1 : $this === Companion_getInstance_56().t6z_1 ? Companion_getInstance_56().n6z_1 : Companion_getInstance_56().s6z_1;
}
function AGCompareMode__hashCode_impl_whv1w0($this) {
  return $this;
}
function AGCompareMode__equals_impl_rbniy4($this, other) {
  if (!(other instanceof AGCompareMode))
    return false;
  if (!($this === (other instanceof AGCompareMode ? other.l71_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGFrontFace___init__impl__vsm7rb(ordinal) {
  return ordinal;
}
function _AGFrontFace___get_ordinal__impl__d4iagj($this) {
  return $this;
}
var Companion_instance_51;
function Companion_getInstance_57() {
  if (Companion_instance_51 === VOID)
    new Companion_42();
  return Companion_instance_51;
}
function toAGScissor(_this__u8e3s4) {
  if (_this__u8e3s4 == null)
    return Companion_getInstance_43().k6p_1;
  return AGScissor.o6y(numberToInt(_this__u8e3s4.k2a_1), numberToInt(_this__u8e3s4.l2a_1), numberToInt(_this__u8e3s4.m2a_1), numberToInt(_this__u8e3s4.n2a_1));
}
function plus_5(_this__u8e3s4, scissor) {
  return BoundsBuilder__plus_impl_cz7f7x(BoundsBuilder__plus_impl_cz7f7x(_this__u8e3s4, Vector2D.x2c(scissor.r2a(), scissor.t2a())), Vector2D.x2c(scissor.s2a(), scissor.u2a()));
}
function applyMatrixBounds(_this__u8e3s4, m) {
  var x0 = m.i2e(_this__u8e3s4.r2a(), _this__u8e3s4.t2a());
  var x1 = m.i2e(_this__u8e3s4.s2a(), _this__u8e3s4.t2a());
  var x2 = m.i2e(_this__u8e3s4.r2a(), _this__u8e3s4.u2a());
  var x3 = m.i2e(_this__u8e3s4.s2a(), _this__u8e3s4.u2a());
  var y0 = m.j2e(_this__u8e3s4.r2a(), _this__u8e3s4.t2a());
  var y1 = m.j2e(_this__u8e3s4.s2a(), _this__u8e3s4.t2a());
  var y2 = m.j2e(_this__u8e3s4.r2a(), _this__u8e3s4.u2a());
  var y3 = m.j2e(_this__u8e3s4.s2a(), _this__u8e3s4.u2a());
  return Companion_getInstance_43().d2i(numberToInt(min(x0, x1, x2, x3)), numberToInt(min(y0, y1, y2, y3)), numberToInt(max_0(x0, x1, x2, x3)), numberToInt(max_0(y0, y1, y2, y3)));
}
var AGBufferKind_INDEX_instance;
var AGBufferKind_VERTEX_instance;
var AGBufferKind_UNIFORM_instance;
var AGBufferKind_entriesInitialized;
function AGBufferKind_initEntries() {
  if (AGBufferKind_entriesInitialized)
    return Unit_instance;
  AGBufferKind_entriesInitialized = true;
  AGBufferKind_INDEX_instance = new AGBufferKind('INDEX', 0);
  AGBufferKind_VERTEX_instance = new AGBufferKind('VERTEX', 1);
  AGBufferKind_UNIFORM_instance = new AGBufferKind('UNIFORM', 2);
}
function AGBufferKind_INDEX_getInstance() {
  AGBufferKind_initEntries();
  return AGBufferKind_INDEX_instance;
}
function AGBufferKind_VERTEX_getInstance() {
  AGBufferKind_initEntries();
  return AGBufferKind_VERTEX_instance;
}
function AGBufferKind_UNIFORM_getInstance() {
  AGBufferKind_initEntries();
  return AGBufferKind_UNIFORM_instance;
}
var ProjViewUB_instance;
function ProjViewUB_getInstance() {
  if (ProjViewUB_instance === VOID)
    new ProjViewUB();
  return ProjViewUB_instance;
}
var DefaultShaders_instance;
function DefaultShaders_getInstance() {
  if (DefaultShaders_instance === VOID)
    new DefaultShaders();
  return DefaultShaders_instance;
}
function u_Tex$factory() {
  return getPropertyCallableRef('u_Tex', 1, KProperty1, function (receiver) {
    return receiver.i75();
  }, null);
}
function u_TexEx$factory() {
  return getPropertyCallableRef('u_TexEx', 1, KProperty1, function (receiver) {
    return receiver.k75();
  }, null);
}
function u_Tex$factory_0() {
  return getPropertyCallableRef('u_Tex', 1, KProperty1, function (receiver) {
    return receiver.i75();
  }, null);
}
function u_TexEx$factory_0() {
  return getPropertyCallableRef('u_TexEx', 1, KProperty1, function (receiver) {
    return receiver.k75();
  }, null);
}
function u_ProjMat$factory() {
  return getPropertyCallableRef('u_ProjMat', 1, KProperty1, function (receiver) {
    return receiver.n72();
  }, null);
}
function u_ViewMat$factory() {
  return getPropertyCallableRef('u_ViewMat', 1, KProperty1, function (receiver) {
    return receiver.o72();
  }, null);
}
function u_ProjMat$factory_0() {
  return getPropertyCallableRef('u_ProjMat', 1, KProperty1, function (receiver) {
    return receiver.n72();
  }, null);
}
function u_ViewMat$factory_0() {
  return getPropertyCallableRef('u_ViewMat', 1, KProperty1, function (receiver) {
    return receiver.o72();
  }, null);
}
function get_ENABLE_UNIFORM_BLOCKS() {
  _init_properties_AGOpengl_kt__dtzqx7();
  return ENABLE_UNIFORM_BLOCKS;
}
var ENABLE_UNIFORM_BLOCKS;
function get_ENABLE_VERTEX_ARRAY_OBJECTS() {
  _init_properties_AGOpengl_kt__dtzqx7();
  return ENABLE_VERTEX_ARRAY_OBJECTS;
}
var ENABLE_VERTEX_ARRAY_OBJECTS;
function set_gl(_this__u8e3s4, _set____db54di) {
  _init_properties_AGOpengl_kt__dtzqx7();
  var this_0 = gl$delegate;
  var property = gl$factory();
  var value = this_0.e10_1(_this__u8e3s4, _set____db54di);
  var tmp0_elvis_lhs = this_0.c10_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_gl(_this__u8e3s4) {
  _init_properties_AGOpengl_kt__dtzqx7();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = gl$delegate;
    var property = gl$factory_0();
    var tmp0_elvis_lhs = this_0.c10_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.d10_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.c10_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var gl$delegate;
function useProgram($this, program) {
  var gl = $this.w77_1;
  var map = $this.a78_1;
  if ($this.b78_1 == null) {
    $this.b78_1 = gl.g79(35724);
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = Companion_getInstance_36().d6n_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.x2x(level)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$0 = 'GL_VERSION=' + gl.g79(7938);
      this_0.y2x(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_1 = Companion_getInstance_36().d6n_1;
    var level_0 = Level_INFO_getInstance();
    var tmp_0;
    if (this_1.x2x(level_0)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$2 = 'GL_SHADING_LANGUAGE_VERSION=' + $this.b78_1;
      this_1.y2x(level_0, tmp$ret$2);
      tmp_0 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_2 = Companion_getInstance_36().d6n_1;
    var level_1 = Level_INFO_getInstance();
    var tmp_1;
    if (this_2.x2x(level_1)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$4 = 'GL_UNIFORM_BUFFER_OFFSET_ALIGNMENT=' + getInteger(gl, 35380);
      this_2.y2x(level_1, tmp$ret$4);
      tmp_1 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_3 = Companion_getInstance_36().d6n_1;
    var level_2 = Level_INFO_getInstance();
    var tmp_2;
    if (this_3.x2x(level_2)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$6 = 'gl.versionString=' + get_versionString(gl);
      this_3.y2x(level_2, tmp$ret$6);
      tmp_2 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_4 = Companion_getInstance_36().d6n_1;
    var level_3 = Level_INFO_getInstance();
    var tmp_3;
    if (this_4.x2x(level_3)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$8 = 'gl.versionInt=' + get_versionInt(gl);
      this_4.y2x(level_3, tmp$ret$8);
      tmp_3 = Unit_instance;
    }
  }
  // Inline function 'kotlin.collections.getOrPut' call
  var value = map.f3(program);
  var tmp_4;
  if (value == null) {
    // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_5 = new GLBaseProgram($this.z77_1, GLShaderCompiler_getInstance().j79(gl, $this.h79(), program, program.m6v_1));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>.<anonymous>' call
    this_5.n79();
    var programInfo = this_5.m79_1;
    var programId = programInfo.o79_1;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = program.q6v_1.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>.<anonymous>.<anonymous>' call
      var location = programInfo.j7a(gl, element.e7a_1);
      gl.k7a(location, element.y6r_1);
    }
    if (programInfo.s79_1.r7a()) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_6 = program.p6v_1;
      var n = 0;
      while (n < this_6.f1()) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>.<anonymous>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var it = this_6.e1(_unary__edvuaz);
        var index = gl.l7a(programId, it.s3());
        gl.m7a(programId, index, it.k6w_1);
      }
    }
    var answer = this_5;
    map.h3(program, answer);
    tmp_4 = answer;
  } else {
    tmp_4 = value;
  }
  var nprogram = tmp_4;
  if (!equals($this.k78_1, nprogram)) {
    $this.k78_1 = nprogram;
    nprogram.n79();
  }
}
function resetObjects($this) {
  $this.d78_1 = null;
  $this.o78_1 = Companion_getInstance_43().j6p_1;
  $this.e78_1 = Companion_getInstance_42().m6o_1;
  $this.f78_1 = Companion_getInstance_49().l6p_1;
  $this.g78_1 = Companion_getInstance_46().x6o_1;
  $this.h78_1 = Companion_getInstance_45().v6o_1;
  $this.i78_1 = Companion_getInstance_47().z6o_1;
  $this.j78_1 = Companion_getInstance_48().f6p_1;
  $this.l78_1.k3();
  $this.k78_1 = null;
  $this.z78_1 = -1;
  $this.x78_1 = 0;
  $this.y78_1 = Companion_instance_48.j71();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.u78_1;
  var n = 0;
  while (n < this_0.length) {
    // Inline function 'korlibs.graphics.gl.AGOpengl.resetObjects.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    this_0[_unary__edvuaz].p2u();
  }
}
function deletePendingObjects($this) {
  while (true) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = $this.z77_1.g7b_1;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.i1y();
      try {
        // Inline function 'korlibs.graphics.gl.AGOpengl.deletePendingObjects.<anonymous>' call
        var tmp;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!$this.z77_1.h7b_1.h1()) {
          // Inline function 'kotlin.also' call
          var this_1 = toList($this.z77_1.h7b_1);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.gl.AGOpengl.deletePendingObjects.<anonymous>.<anonymous>' call
          $this.z77_1.h7b_1.k3();
          tmp = this_1;
        } else {
          return Unit_instance;
        }
        tmp$ret$3 = tmp;
        break $l$block;
      }finally {
        this_0.k1y();
      }
    }
    var n = 0;
    while (n < tmp$ret$3.f1()) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.deletePendingObjects.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      tmp$ret$3.e1(_unary__edvuaz).k7b();
    }
  }
}
function bindBuffer($this, buffer, target, onlyUpdate, reallocated, updated) {
  var gl = $this.w77_1;
  if (reallocated == null)
    null;
  else {
    reallocated.f2v(false);
  }
  if (updated == null)
    null;
  else {
    updated.f2v(false);
  }
  if (buffer == null) {
    gl.l7b(toGl_6(target), 0);
    return null;
  }
  var bufferInfo = _get_gl__ndc1ty(buffer, $this);
  if (!onlyUpdate) {
    gl.l7b(toGl_6(target), bufferInfo.o7b_1);
  }
  $this.r7b(buffer, AGOpengl$bindBuffer$lambda(buffer, bufferInfo, onlyUpdate, gl, target, reallocated, updated));
  return bufferInfo;
}
function bindBuffer$default($this, buffer, target, onlyUpdate, reallocated, updated, $super) {
  onlyUpdate = onlyUpdate === VOID ? false : onlyUpdate;
  reallocated = reallocated === VOID ? null : reallocated;
  updated = updated === VOID ? null : updated;
  return bindBuffer($this, buffer, target, onlyUpdate, reallocated, updated);
}
function writeUniform($this, uniform, programInfo, data, source) {
  var gl = $this.w77_1;
  var location = programInfo.j7a(gl, uniform.e7a_1);
  var uniformType = uniform.c2e();
  var arrayCount = uniform.u7b_1;
  if (uniformType.b7c_1.r3_1 === 6) {
    switch (uniformType.r3_1) {
      case 1:
        gl.j7c(location, arrayCount, false, data);
        break;
      case 2:
        var inductionVariable = 0;
        if (inductionVariable < 3)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            arraycopy_0(data, imul(n, 16), $this.t78_1, imul(n, 12), 12);
          }
           while (inductionVariable < 3);
        gl.k7c(location, arrayCount, false, $this.t78_1);
        break;
      case 3:
        gl.l7c(location, arrayCount, false, data);
        break;
      default:
        switch (uniformType.c7c_1) {
          case 1:
            gl.m7c(location, arrayCount, data);
            break;
          case 2:
            gl.n7c(location, arrayCount, data);
            break;
          case 3:
            gl.o7c(location, arrayCount, data);
            break;
          case 4:
            gl.p7c(location, arrayCount, data);
            break;
        }

        break;
    }
  } else {
    switch (uniformType.c7c_1) {
      case 1:
        gl.f7c(location, arrayCount, data);
        break;
      case 2:
        gl.g7c(location, arrayCount, data);
        break;
      case 3:
        gl.h7c(location, arrayCount, data);
        break;
      case 4:
        gl.i7c(location, arrayCount, data);
        break;
    }
  }
}
function textureUnitParameters($this, implForcedTexTarget, wrap, minFilter, magFilter, dims) {
  var gl = $this.w77_1;
  var params = $this.u78_1[$this.x78_1];
  var glTarget = toGl_8(implForcedTexTarget);
  params.t7a_1 = wrap;
  var glWrap = toGl_9(wrap);
  gl.q7c(glTarget, 10242, glWrap);
  gl.q7c(glTarget, 10243, glWrap);
  if (dims >= 3) {
    gl.q7c(glTarget, 32882, glWrap);
  }
  params.u7a_1 = minFilter;
  params.v7a_1 = magFilter;
  gl.q7c(glTarget, 10241, minFilter);
  gl.q7c(glTarget, 10240, magFilter);
}
function createBufferForBitmap($this, bmp) {
  var tmp;
  if (bmp == null) {
    tmp = null;
  } else {
    if (bmp instanceof NativeImage) {
      unsupported('Should not call createBufferForBitmap with a NativeImage');
    } else {
      if (bmp instanceof Bitmap8) {
        // Inline function 'kotlin.also' call
        var this_0 = Buffer.m14(bmp.l2j());
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.gl.AGOpengl.createBufferForBitmap.<anonymous>' call
        arraycopy_3(bmp.l48(), 0, get_i8(this_0), 0, bmp.l2j());
        tmp = this_0;
      } else {
        if (bmp instanceof FloatBitmap32) {
          // Inline function 'kotlin.also' call
          var this_1 = Buffer.m14(imul(imul(bmp.l2j(), 4), 4));
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.gl.AGOpengl.createBufferForBitmap.<anonymous>' call
          arraycopy_2(bmp.s4b_1, 0, get_f32(this_1), 0, imul(bmp.l2j(), 4));
          tmp = this_1;
        } else {
          // Inline function 'kotlin.also' call
          var this_2 = Buffer.m14(imul(bmp.l2j(), 4));
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.gl.AGOpengl.createBufferForBitmap.<anonymous>' call
          var abmp = bmp.f3z_1 ? bmp.w46().a4a() : bmp.w46().b4a();
          arraycopy_1(abmp.p3y_1, 0, get_i32(this_2), 0, abmp.l2j());
          tmp = this_2;
        }
      }
    }
  }
  return tmp;
}
function selectTextureUnit($this, index) {
  var old = $this.x78_1;
  if (!($this.x78_1 === index)) {
    $this.x78_1 = index;
    if (index >= 0) {
      $this.w77_1.r7c(33984 + index | 0);
    }
  }
  return old;
}
function _get_gl__ndc1ty(_this__u8e3s4, $this) {
  return gl(_this__u8e3s4, $this.z77_1);
}
function _get_gl__ndc1ty_0(_this__u8e3s4, $this) {
  return gl_0(_this__u8e3s4, $this.z77_1);
}
function _get_gl__ndc1ty_1(_this__u8e3s4, $this) {
  return gl_1(_this__u8e3s4, $this.z77_1);
}
function AGOpengl$glslConfig$delegate$lambda(this$0) {
  return function () {
    return new GlslConfig(this$0.w77_1.s7c(), this$0.w77_1);
  };
}
function AGOpengl$bindBuffer$lambda($buffer, $bufferInfo, $onlyUpdate, $gl, $target, $reallocated, $updated) {
  return function (it) {
    var tmp0_elvis_lhs = $buffer.x6q_1;
    var mem = tmp0_elvis_lhs == null ? Buffer.m14(0) : tmp0_elvis_lhs;
    $bufferInfo.t7c(mem.r14());
    var tmp;
    if ($onlyUpdate) {
      $gl.l7b(toGl_6($target), $bufferInfo.o7b_1);
      tmp = Unit_instance;
    }
    var tmp_0;
    if ($bufferInfo.p7b_1 < mem.r14()) {
      $bufferInfo.p7b_1 = mem.r14();
      $gl.v7c(toGl_6($target), mem.r14(), mem, 35048);
      var tmp1_safe_receiver = $reallocated;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.f2v(true);
      }
      tmp_0 = Unit_instance;
    } else {
      $gl.u7c(toGl_6($target), 0, mem.r14(), mem);
      tmp_0 = Unit_instance;
    }
    var tmp2_safe_receiver = $updated;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.f2v(true);
    }
    return Unit_instance;
  };
}
function AGOpengl$textureBind$lambda($tex, $target, $gl, this$0, $glTex) {
  return function (it) {
    var rbmp = $tex.d6t_1;
    var tmp0_safe_receiver = (rbmp == null ? true : rbmp instanceof MultiBitmap) ? rbmp : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e6u_1;
    var bmps = tmp1_elvis_lhs == null ? listOf(rbmp) : tmp1_elvis_lhs;
    var requestMipmaps = $tex.a6t_1;
    $tex.e6t_1 = $tex.g6u(rbmp, requestMipmaps);
    var totalSize = 0.0;
    var iterator = bmps.b1();
    var index = 0;
    while (iterator.c1()) {
      var index_0 = index;
      index = index + 1 | 0;
      var bmp = iterator.d1();
      var isFloat = bmp instanceof FloatBitmap32;
      var tmp;
      if (bmp instanceof Bitmap8) {
        tmp = 6409;
      } else {
        tmp = 6408;
      }
      var type = tmp;
      var texTarget = $target === Companion_getInstance_50().m6t_1 ? 34069 + index_0 | 0 : toGl_8($target);
      var internalFormat = isFloat && (_GLVariant___get_isWebGL__impl__bbd1dd($gl.s7c()) && _GLVariant___get_version__impl__9nyfwa($gl.s7c()) >= 2) ? 34836 : type;
      var format = type;
      var texType = isFloat ? 5126 : 5121;
      if (_GLVariant___get_os__impl__aswhdw($gl.s7c()).ov()) {
        $gl.w7c(3313, 0);
        $gl.w7c(3312, 1);
      }
      if (bmp == null) {
        $gl.x7c(toGl_8($target), 0, type, $tex.d2m(), $tex.e2m(), 0, type, 5121, null);
      } else {
        if (bmp instanceof NativeImage) {
          if (!(bmp.l2j() === 0)) {
            $gl.y7c(texTarget, 0, type, type, 5121, bmp);
          }
        } else {
          if (bmp instanceof NullBitmap) {
            $gl.x7c(texTarget, 0, internalFormat, bmp.z3y_1, bmp.a3z_1, 0, format, texType, null);
          } else {
            var buffer = createBufferForBitmap(this$0, bmp);
            if (!(buffer == null) && !(bmp.z3y_1 === 0) && !(bmp.a3z_1 === 0) && !(get_size_0(buffer) === 0)) {
              $gl.x7c(texTarget, 0, internalFormat, bmp.z3y_1, bmp.a3z_1, 0, format, texType, buffer);
            }
          }
        }
      }
      totalSize = totalSize + imul(imul($tex.d2m(), $tex.e2m()), 4);
      if (_GLVariant___get_supportTextureLevel__impl__3yeu62($gl.s7c())) {
        var tmp_0;
        if ($tex.e6t_1) {
          var tmp4_elvis_lhs = $tex.b6t_1;
          tmp_0 = tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs;
        } else {
          tmp_0 = 0;
        }
        $gl.q7c(3553, 33084, tmp_0);
        var tmp_1;
        if ($tex.e6t_1) {
          var tmp5_elvis_lhs = $tex.c6t_1;
          tmp_1 = tmp5_elvis_lhs == null ? 1000 : tmp5_elvis_lhs;
        } else {
          tmp_1 = 0;
        }
        $gl.q7c(3553, 33085, tmp_1);
      }
      if ($tex.e6t_1) {
        $gl.z7c(texTarget);
      }
    }
    $glTex.t7c(totalSize);
    return Unit_instance;
  };
}
function gl$delegate$lambda($this$PropertyThis) {
  _init_properties_AGOpengl_kt__dtzqx7();
  return new GLVAO($this$PropertyThis);
}
function gl$factory() {
  return getPropertyCallableRef('gl', 1, KMutableProperty1, function (receiver) {
    return get_gl(receiver);
  }, function (receiver, value) {
    return set_gl(receiver, value);
  });
}
function gl$factory_0() {
  return getPropertyCallableRef('gl', 1, KMutableProperty1, function (receiver) {
    return get_gl(receiver);
  }, function (receiver, value) {
    return set_gl(receiver, value);
  });
}
function glslConfig$factory() {
  return getPropertyCallableRef('glslConfig', 1, KProperty1, function (receiver) {
    return receiver.h79();
  }, null);
}
var properties_initialized_AGOpengl_kt_5em8g9;
function _init_properties_AGOpengl_kt__dtzqx7() {
  if (!properties_initialized_AGOpengl_kt_5em8g9) {
    properties_initialized_AGOpengl_kt_5em8g9 = true;
    ENABLE_UNIFORM_BLOCKS = !(Companion_instance_1.hi('DISABLE_UNIFORM_BLOCKS') === 'true');
    ENABLE_VERTEX_ARRAY_OBJECTS = !(Companion_instance_1.hi('DISABLE_VERTEX_ARRAY_OBJECTS') === 'true');
    gl$delegate = new PropertyThis(VOID, gl$delegate$lambda);
  }
}
function fromGl(_this__u8e3s4, value) {
  var tmp;
  switch (value) {
    case 3553:
      tmp = Companion_getInstance_50().k6t_1;
      break;
    case 32879:
      tmp = Companion_getInstance_50().l6t_1;
      break;
    case 34067:
      tmp = Companion_getInstance_50().m6t_1;
      break;
    case 36197:
      tmp = Companion_getInstance_50().n6t_1;
      break;
    case 34069:
      tmp = Companion_getInstance_50().m6t_1;
      break;
    case 34070:
      tmp = Companion_getInstance_50().m6t_1;
      break;
    case 34071:
      tmp = Companion_getInstance_50().m6t_1;
      break;
    case 34072:
      tmp = Companion_getInstance_50().m6t_1;
      break;
    case 34073:
      tmp = Companion_getInstance_50().m6t_1;
      break;
    case 34074:
      tmp = Companion_getInstance_50().m6t_1;
      break;
    default:
      var reason = 'Unknown TextureTargetKind: ' + value;
      throw NotImplementedError.be('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function toGl(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_53().g6y_1) {
    tmp = 32774;
  } else if (_this__u8e3s4 === Companion_getInstance_53().h6y_1) {
    tmp = 32778;
  } else if (_this__u8e3s4 === Companion_getInstance_53().i6y_1) {
    tmp = 32779;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_0(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_52().t6x_1) {
    tmp = 772;
  } else if (_this__u8e3s4 === Companion_getInstance_52().u6x_1) {
    tmp = 774;
  } else if (_this__u8e3s4 === Companion_getInstance_52().v6x_1) {
    tmp = 1;
  } else if (_this__u8e3s4 === Companion_getInstance_52().w6x_1) {
    tmp = 773;
  } else if (_this__u8e3s4 === Companion_getInstance_52().x6x_1) {
    tmp = 775;
  } else if (_this__u8e3s4 === Companion_getInstance_52().y6x_1) {
    tmp = 771;
  } else if (_this__u8e3s4 === Companion_getInstance_52().z6x_1) {
    tmp = 769;
  } else if (_this__u8e3s4 === Companion_getInstance_52().a6y_1) {
    tmp = 770;
  } else if (_this__u8e3s4 === Companion_getInstance_52().b6y_1) {
    tmp = 768;
  } else if (_this__u8e3s4 === Companion_getInstance_52().c6y_1) {
    tmp = 0;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_1(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_56().m6z_1) {
    tmp = 519;
  } else if (_this__u8e3s4 === Companion_getInstance_56().n6z_1) {
    tmp = 514;
  } else if (_this__u8e3s4 === Companion_getInstance_56().o6z_1) {
    tmp = 516;
  } else if (_this__u8e3s4 === Companion_getInstance_56().p6z_1) {
    tmp = 518;
  } else if (_this__u8e3s4 === Companion_getInstance_56().q6z_1) {
    tmp = 513;
  } else if (_this__u8e3s4 === Companion_getInstance_56().r6z_1) {
    tmp = 515;
  } else if (_this__u8e3s4 === Companion_getInstance_56().s6z_1) {
    tmp = 512;
  } else if (_this__u8e3s4 === Companion_getInstance_56().t6z_1) {
    tmp = 517;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_2(_this__u8e3s4) {
  return _this__u8e3s4 === Companion_getInstance_55().u6z_1 ? 7683 : _this__u8e3s4 === Companion_getInstance_55().v6z_1 ? 34056 : _this__u8e3s4 === Companion_getInstance_55().w6z_1 ? 7682 : _this__u8e3s4 === Companion_getInstance_55().x6z_1 ? 34055 : _this__u8e3s4 === Companion_getInstance_55().y6z_1 ? 5386 : _this__u8e3s4 === Companion_getInstance_55().z6z_1 ? 7680 : _this__u8e3s4 === Companion_getInstance_55().a70_1 ? 7681 : _this__u8e3s4 === Companion_getInstance_55().b70_1 ? 0 : 0;
}
function toGl_3(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_40().h6x_1) {
    tmp = 0;
  } else if (_this__u8e3s4 === Companion_getInstance_40().i6x_1) {
    tmp = 3;
  } else if (_this__u8e3s4 === Companion_getInstance_40().j6x_1) {
    tmp = 2;
  } else if (_this__u8e3s4 === Companion_getInstance_40().k6x_1) {
    tmp = 1;
  } else if (_this__u8e3s4 === Companion_getInstance_40().m6x_1) {
    tmp = 5;
  } else if (_this__u8e3s4 === Companion_getInstance_40().n6x_1) {
    tmp = 6;
  } else if (_this__u8e3s4 === Companion_getInstance_40().l6x_1) {
    tmp = 4;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_4(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_41().i6o_1) {
    tmp = 0;
  } else if (_this__u8e3s4 === Companion_getInstance_41().j6o_1) {
    tmp = 5121;
  } else if (_this__u8e3s4 === Companion_getInstance_41().k6o_1) {
    tmp = 5123;
  } else if (_this__u8e3s4 === Companion_getInstance_41().l6o_1) {
    tmp = 5125;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_5(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_49().p6p_1) {
    tmp = 1032;
  } else if (_this__u8e3s4 === Companion_getInstance_49().n6p_1) {
    tmp = 1028;
  } else if (_this__u8e3s4 === Companion_getInstance_49().o6p_1) {
    tmp = 1029;
  } else {
    var reason = 'Invalid AGCullFace(' + AGCullFace__toString_impl_7d891w(_this__u8e3s4) + ')';
    throw NotImplementedError.be('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function toGl_6(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.r3_1) {
    case 0:
      tmp = 34963;
      break;
    case 1:
      tmp = 34962;
      break;
    case 2:
      tmp = 35345;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function toGl_7(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.b7c_1.r3_1) {
    case 0:
      tmp = 35670;
      break;
    case 1:
      tmp = 5120;
      break;
    case 2:
      tmp = 5121;
      break;
    case 3:
      tmp = 5122;
      break;
    case 4:
      tmp = 5123;
      break;
    case 5:
      tmp = 5125;
      break;
    case 6:
      tmp = 5126;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function toGl_8(_this__u8e3s4) {
  return _this__u8e3s4 === Companion_getInstance_50().k6t_1 ? 3553 : _this__u8e3s4 === Companion_getInstance_50().l6t_1 ? 32879 : _this__u8e3s4 === Companion_getInstance_50().m6t_1 ? 34067 : _this__u8e3s4 === Companion_getInstance_50().n6t_1 ? 36197 : _AGTextureTargetKind___get_ordinal__impl__gjzc5p(_this__u8e3s4);
}
function toGl_9(_this__u8e3s4) {
  return _this__u8e3s4 === Companion_getInstance_51().j6u_1 ? 33071 : _this__u8e3s4 === Companion_getInstance_51().k6u_1 ? 10497 : _this__u8e3s4 === Companion_getInstance_51().l6u_1 ? 33648 : 33071;
}
function toGl_10(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_57().h70_1) {
    tmp = 2305;
  } else if (_this__u8e3s4 === Companion_getInstance_57().j70_1) {
    tmp = 2304;
  } else if (_this__u8e3s4 === Companion_getInstance_57().i70_1) {
    tmp = 2305;
  } else {
    get_unreachable();
  }
  return tmp;
}
function gl(_this__u8e3s4, state) {
  return createOnce(_this__u8e3s4, state, gl$lambda(state));
}
function gl_0(_this__u8e3s4, state) {
  return createOnce(_this__u8e3s4, state, gl$lambda_0(state, _this__u8e3s4));
}
function gl_1(_this__u8e3s4, state) {
  return createOnce(_this__u8e3s4, state, gl$lambda_1(state));
}
function createOnce(_this__u8e3s4, state, block) {
  if (_this__u8e3s4.y6q_1 == null || !(_this__u8e3s4.z6q_1 === state.z7a_1.h6n_1)) {
    _this__u8e3s4.z6q_1 = state.z7a_1.h6n_1;
    _this__u8e3s4.g6r();
    _this__u8e3s4.y6q_1 = block(_this__u8e3s4);
  }
  var tmp = _this__u8e3s4.y6q_1;
  return (!(tmp == null) ? isInterface(tmp, AGNativeObject) : false) ? tmp : THROW_CCE();
}
function gl$lambda($state) {
  return function (it) {
    return new GLBuffer($state);
  };
}
function gl$lambda_0($state, $this_gl) {
  return function (it) {
    return new GLFrameBuffer($state, $this_gl);
  };
}
function gl$lambda_1($state) {
  return function (it) {
    return new GLTexture($state);
  };
}
function get_versionString(_this__u8e3s4) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = versionString$delegate;
    var property = versionString$factory();
    var tmp0_elvis_lhs = this_0.c10_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.d10_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.c10_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var versionString$delegate;
function get_versionInt(_this__u8e3s4) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = versionInt$delegate;
    var property = versionInt$factory();
    var tmp0_elvis_lhs = this_0.c10_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.d10_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.c10_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var versionInt$delegate;
function createShader($this, gl, type, str, debugName) {
  var shaderId = gl.l7g(type);
  gl.m7g(shaderId, str);
  gl.n7g(shaderId);
  // Inline function 'korlibs.kgl.KmlGl.COMPILE_STATUS' call
  var out = getShaderiv(gl, shaderId, 35713);
  var errorInt = gl.o7g();
  // Inline function 'korlibs.kgl.KmlGl.GTRUE' call
  if (!(out === 1)) {
    var error = getShaderInfoLog(gl, shaderId);
    throw ShaderException.r77(str, error, errorInt, gl, debugName, type, out);
  }
  return shaderId;
}
var GLShaderCompiler_instance;
function GLShaderCompiler_getInstance() {
  if (GLShaderCompiler_instance === VOID)
    new GLShaderCompiler();
  return GLShaderCompiler_instance;
}
function versionString$delegate$lambda($this$PropertyThis) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp;
  if (_GLVariant___get_isWebGL__impl__bbd1dd($this$PropertyThis.s7c())) {
    tmp = _GLVariant___get_version__impl__9nyfwa($this$PropertyThis.s7c()) === 1 ? '1.00' : '3.00';
  } else {
    // Inline function 'korlibs.kgl.KmlGl.SHADING_LANGUAGE_VERSION' call
    tmp = $this$PropertyThis.g79(35724);
  }
  return tmp;
}
function versionInt$delegate$lambda($this$PropertyThis) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp0_safe_receiver = Regex.vh('(\\d+\\.\\d+)').yh(get_versionString($this$PropertyThis));
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s1();
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : replace(tmp1_safe_receiver, '.', '');
  var tmp;
  if (tmp2_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.text.trim' call
    tmp = toString(trim(isCharSequence(tmp2_safe_receiver) ? tmp2_safe_receiver : THROW_CCE()));
  }
  var tmp3_safe_receiver = tmp;
  var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : toIntOrNull(tmp3_safe_receiver);
  return tmp4_elvis_lhs == null ? 100 : tmp4_elvis_lhs;
}
function versionString$factory() {
  return getPropertyCallableRef('versionString', 1, KProperty1, function (receiver) {
    return get_versionString(receiver);
  }, null);
}
function versionInt$factory() {
  return getPropertyCallableRef('versionInt', 1, KProperty1, function (receiver) {
    return get_versionInt(receiver);
  }, null);
}
var properties_initialized_GLShaderCompiler_kt_k11ei3;
function _init_properties_GLShaderCompiler_kt__3td561() {
  if (!properties_initialized_GLShaderCompiler_kt_k11ei3) {
    properties_initialized_GLShaderCompiler_kt_k11ei3 = true;
    versionString$delegate = new PropertyThis(VOID, versionString$delegate$lambda);
    versionInt$delegate = new PropertyThis(VOID, versionInt$delegate$lambda);
  }
}
var Kind_COMMAND_instance;
var Kind_DRAW_instance;
var Kind_DRAW_DETAILS_instance;
var Kind_CLEAR_instance;
var Kind_METRICS_instance;
var Kind_FLIP_instance;
var Kind_READ_instance;
var Kind_REPAINT_instance;
var Kind_DISPOSE_instance;
var Kind_TEXTURE_UPLOAD_instance;
var Kind_CLOSE_instance;
var Kind_FRAME_BUFFER_instance;
var Kind_BUFFER_instance;
var Kind_TEXTURE_instance;
var Kind_SHADER_instance;
var Kind_OTHER_instance;
var Kind_UNIFORM_instance;
var Kind_UNIFORM_VALUES_instance;
var Kind_SCISSORS_instance;
var Kind_VIEWPORT_instance;
var Kind_VERTEX_instance;
var Kind_ENABLE_DISABLE_instance;
var Kind_CONTEXT_LOST_instance;
var Kind_FLUSH_instance;
var Kind_entriesInitialized_0;
function Kind_initEntries_0() {
  if (Kind_entriesInitialized_0)
    return Unit_instance;
  Kind_entriesInitialized_0 = true;
  Kind_COMMAND_instance = new Kind_0('COMMAND', 0);
  Kind_DRAW_instance = new Kind_0('DRAW', 1);
  Kind_DRAW_DETAILS_instance = new Kind_0('DRAW_DETAILS', 2);
  Kind_CLEAR_instance = new Kind_0('CLEAR', 3);
  Kind_METRICS_instance = new Kind_0('METRICS', 4);
  Kind_FLIP_instance = new Kind_0('FLIP', 5);
  Kind_READ_instance = new Kind_0('READ', 6);
  Kind_REPAINT_instance = new Kind_0('REPAINT', 7);
  Kind_DISPOSE_instance = new Kind_0('DISPOSE', 8);
  Kind_TEXTURE_UPLOAD_instance = new Kind_0('TEXTURE_UPLOAD', 9);
  Kind_CLOSE_instance = new Kind_0('CLOSE', 10);
  Kind_FRAME_BUFFER_instance = new Kind_0('FRAME_BUFFER', 11);
  Kind_BUFFER_instance = new Kind_0('BUFFER', 12);
  Kind_TEXTURE_instance = new Kind_0('TEXTURE', 13);
  Kind_SHADER_instance = new Kind_0('SHADER', 14);
  Kind_OTHER_instance = new Kind_0('OTHER', 15);
  Kind_UNIFORM_instance = new Kind_0('UNIFORM', 16);
  Kind_UNIFORM_VALUES_instance = new Kind_0('UNIFORM_VALUES', 17);
  Kind_SCISSORS_instance = new Kind_0('SCISSORS', 18);
  Kind_VIEWPORT_instance = new Kind_0('VIEWPORT', 19);
  Kind_VERTEX_instance = new Kind_0('VERTEX', 20);
  Kind_ENABLE_DISABLE_instance = new Kind_0('ENABLE_DISABLE', 21);
  Kind_CONTEXT_LOST_instance = new Kind_0('CONTEXT_LOST', 22);
  Kind_FLUSH_instance = new Kind_0('FLUSH', 23);
}
function Kind_COMMAND_getInstance() {
  Kind_initEntries_0();
  return Kind_COMMAND_instance;
}
function Kind_FLIP_getInstance() {
  Kind_initEntries_0();
  return Kind_FLIP_instance;
}
var Companion_instance_52;
function Companion_getInstance_58() {
  if (Companion_instance_52 === VOID)
    new Companion_43();
  return Companion_instance_52;
}
function UniformBlock$Gen$uniform$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.also' call
    var tmp0_elvis_lhs = this$0.e72_1;
    var this_0 = TypedUniform.y7h(tmp0_elvis_lhs == null ? 'unknown' + this$0.d72_1.s72() : tmp0_elvis_lhs, this$0.f72_1, this$0.g72_1, this$0.d72_1, this$0.h72_1, this$0.i72_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Gen.uniform$delegate.<anonymous>.<anonymous>' call
    this$0.d72_1.m6w_1.h(this_0);
    return this_0;
  };
}
var Companion_instance_53;
function Companion_getInstance_59() {
  return Companion_instance_53;
}
function _get_bufferSize__mp12kq($this) {
  return $this.v6u_1.r14() / $this.t6u_1 | 0;
}
function align($this, size) {
  var tmp = $this;
  // Inline function 'kotlin.math.max' call
  var a = $this.b7i_1;
  tmp.b7i_1 = Math.max(a, size);
  while (!(($this.a7i_1 % size | 0) === 0)) {
    $this.a7i_1 = $this.a7i_1 + 1 | 0;
  }
  return $this;
}
function UBLayoutBuilder$size$delegate$lambda(this$0) {
  return function () {
    align(this$0, this$0.b7i_1);
    return this$0.a7i_1;
  };
}
function uniform$factory() {
  return getPropertyCallableRef('uniform', 1, KProperty1, function (receiver) {
    return receiver.z7h();
  }, null);
}
function size$factory() {
  return getPropertyCallableRef('size', 1, KProperty1, function (receiver) {
    return receiver.f1();
  }, null);
}
function _GLVariant___init__impl__cjzpjb(data) {
  return data;
}
function _GLVariant___get_data__impl__nn46ye($this) {
  return $this;
}
function _GLVariant___get_isES__impl__yezzg8($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_GLVariant___get_data__impl__nn46ye($this) >>> 0 | 0) & 1) === 0);
}
function _GLVariant___get_isWebGL__impl__bbd1dd($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_GLVariant___get_data__impl__nn46ye($this) >>> 1 | 0) & 1) === 0);
}
function _GLVariant___get_version__impl__9nyfwa($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_GLVariant___get_data__impl__nn46ye($this) >>> 8 | 0) & 255;
}
function _GLVariant___get_os__impl__aswhdw($this) {
  var tmp = Companion_getInstance_2().kv_1;
  // Inline function 'korlibs.memory.extract8' call
  var tmp$ret$0 = (_GLVariant___get_data__impl__nn46ye($this) >>> 16 | 0) & 255;
  var tmp0_elvis_lhs = getOrNull(tmp, tmp$ret$0);
  return tmp0_elvis_lhs == null ? Os_UNKNOWN_getInstance() : tmp0_elvis_lhs;
}
function _GLVariant___get_supportTextureLevel__impl__3yeu62($this) {
  return !_GLVariant___get_isWebGL__impl__bbd1dd($this) && !_GLVariant___get_isES__impl__yezzg8($this);
}
var Companion_instance_54;
function Companion_getInstance_60() {
  return Companion_instance_54;
}
function GLVariant__toString_impl_o5yi3l($this) {
  return 'GLVariant(data=' + $this + ')';
}
function GLVariant__hashCode_impl_2eslaq($this) {
  return $this;
}
function GLVariant__equals_impl_kmlw2($this, other) {
  if (!(other instanceof GLVariant))
    return false;
  if (!($this === (other instanceof GLVariant ? other.w7j_1 : THROW_CCE())))
    return false;
  return true;
}
function toNewGlslString(_this__u8e3s4, config) {
  return toNewGlslStringResult(_this__u8e3s4, config).a7k_1;
}
function toNewGlslStringResult(_this__u8e3s4, config) {
  return (new GlslGenerator(_this__u8e3s4.e7k_1, config)).s7k(_this__u8e3s4);
}
var Companion_instance_55;
function Companion_getInstance_61() {
  if (Companion_instance_55 === VOID)
    new Companion_46();
  return Companion_instance_55;
}
function GlslGenerator$generateResult$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
  var tmp = a.e7a_1;
  // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
  var tmp$ret$1 = b.e7a_1;
  return compareValues(tmp, tmp$ret$1);
}
function GlslGenerator$generateResult$lambda(this$0, $types, $allFuncs) {
  return function ($this$Indenter) {
    var tmp;
    if (!this$0.r7k_1.q7a_1) {
      var suffix = _GLVariant___get_isES__impl__yezzg8(this$0.r7k_1.n7a_1) ? ' es' : '';
      $this$Indenter.oy('#version ' + this$0.r7k_1.p7a_1 + suffix);
      tmp = Unit_instance;
    }
    var tmp_0;
    if (this$0.q7k_1.equals(ShaderType_FRAGMENT_getInstance())) {
      $this$Indenter.oy('#extension GL_OES_standard_derivatives : enable');
      tmp_0 = Unit_instance;
    }
    $this$Indenter.oy('#ifdef GL_ES');
    $this$Indenter.oy('precision mediump float;');
    $this$Indenter.oy('#endif');
    var _iterator__ex2g4s = $types.u7k_1.b1();
    while (_iterator__ex2g4s.c1()) {
      var it = _iterator__ex2g4s.d1();
      var layout = this$0.r7k_1.z7m() && this$0.r7k_1.p7a_1 >= 410 ? 'layout(location = ' + it.r73_1 + ') ' : '';
      $this$Indenter.oy(layout + this$0.a7n() + ' ' + this$0.b7n(it.f7a_1) + this$0.c7n(it.c2e()) + ' ' + it.e7a_1 + this$0.d7n(it) + ';');
    }
    var _iterator__ex2g4s_0 = $types.z7k_1.b1();
    while (_iterator__ex2g4s_0.c1()) {
      var it_0 = _iterator__ex2g4s_0.d1();
      var layout_0 = this$0.r7k_1.z7m() ? '' : '';
      $this$Indenter.oy(layout_0 + this$0.e7n() + ' ' + this$0.b7n(it_0.f7a_1) + this$0.c7n(it_0.c2e()) + ' ' + it_0.e7a_1 + this$0.d7n(it_0) + ';');
    }
    var tmp_1;
    if (this$0.r7k_1.r7a()) {
      var _iterator__ex2g4s_1 = $types.y7k_1.b1();
      while (_iterator__ex2g4s_1.c1()) {
        var block = _iterator__ex2g4s_1.d1();
        $this$Indenter.oy('layout(std140) uniform ' + block.s3() + ' {');
        var _iterator__ex2g4s_2 = block.p72().b1();
        while (_iterator__ex2g4s_2.c1()) {
          var uniform = _iterator__ex2g4s_2.d1();
          $this$Indenter.oy('  ' + this$0.b7n(uniform.f7a_1) + this$0.c7n(uniform.c2e()) + ' ' + uniform.e7a_1 + this$0.d7n(uniform) + ';');
        }
        $this$Indenter.oy('};');
      }
      tmp_1 = Unit_instance;
    } else {
      var _iterator__ex2g4s_3 = $types.w7k_1.b1();
      while (_iterator__ex2g4s_3.c1()) {
        var it_1 = _iterator__ex2g4s_3.d1();
        $this$Indenter.oy(this$0.e7n() + ' ' + this$0.b7n(it_1.f7a_1) + this$0.c7n(it_1.c2e()) + ' ' + it_1.e7a_1 + this$0.d7n(it_1) + ';');
      }
      tmp_1 = Unit_instance;
    }
    // Inline function 'kotlin.collections.sortedBy' call
    var this_0 = $types.v7k_1;
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_2 = GlslGenerator$generateResult$lambda$lambda;
    var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp_2);
    var iterator = sortedWith(this_0, tmp$ret$0).b1();
    var index = 0;
    $l$loop: while (iterator.c1()) {
      var index_0 = index;
      index = index + 1 | 0;
      var it_2 = iterator.d1();
      if (it_2 instanceof Output)
        continue $l$loop;
      var INOUT = !this$0.r7k_1.z7m() ? this$0.f7n() : it_2.e7a_1 === this$0.r7k_1.g7n() && this$0.q7k_1.equals(ShaderType_FRAGMENT_getInstance()) ? this$0.f7n() : this$0.q7k_1.equals(ShaderType_VERTEX_getInstance()) ? this$0.f7n() : this$0.a7n();
      $this$Indenter.oy(INOUT + ' ' + this$0.b7n(it_2.f7a_1) + this$0.c7n(it_2.c2e()) + ' ' + it_2.e7a_1 + ';');
    }
    var _iterator__ex2g4s_4 = $allFuncs.b1();
    while (_iterator__ex2g4s_4.c1()) {
      var func = _iterator__ex2g4s_4.d1();
      var gen = new GlslBodyGenerator(this$0.q7k_1, this$0.r7k_1);
      gen.s7l(func);
      // Inline function 'kotlin.collections.map' call
      var this_1 = func.j7n_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator = this_1.b1();
      while (tmp0_iterator.c1()) {
        var item = tmp0_iterator.d1();
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var tmp$ret$2 = this$0.c7n(item.ml_1) + ' ' + item.ll_1;
        destination.h(tmp$ret$2);
      }
      var argsStrings = destination;
      // Inline function 'korlibs.io.util.Indenter.line' call
      var str = this$0.c7n(func.i7n_1) + ' ' + func.h7n_1 + '(' + joinToString(argsStrings, ', ') + ')';
      var tmp_3;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(str) === 0) {
        tmp_3 = '{';
      } else {
        tmp_3 = str + ' {';
      }
      $this$Indenter.oy(tmp_3);
      // Inline function 'korlibs.io.util.Indenter.indent' call
      $this$Indenter.py();
      try {
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var _iterator__ex2g4s_5 = gen.p7n_1.b1();
        while (_iterator__ex2g4s_5.c1()) {
          var temp = _iterator__ex2g4s_5.d1();
          $this$Indenter.oy(this$0.b7n(temp.f7a_1) + this$0.c7n(temp.c2e()) + ' ' + temp.e7a_1 + ';');
        }
        $this$Indenter.s38(gen.q7n_1);
      }finally {
        $this$Indenter.qy();
      }
      $this$Indenter.oy('}');
    }
    return Unit_instance;
  };
}
var Companion_instance_56;
function Companion_getInstance_62() {
  if (Companion_instance_56 === VOID)
    new Companion_47();
  return Companion_instance_56;
}
function errorType($this, type) {
  invalidOp("Don't know how to serialize type " + type.toString());
}
function GlslBodyGenerator$visit$lambda(this$0) {
  return function (it) {
    return this$0.d7m(it);
  };
}
function GlslBodyGenerator$visit$lambda_0(this$0) {
  return function (it) {
    return this$0.d7m(it);
  };
}
function ProgramLayout$names$lambda(it) {
  return it.e7a_1;
}
var Discard_instance;
function Discard_getInstance() {
  if (Discard_instance === VOID)
    new Discard();
  return Discard_instance;
}
var Companion_instance_57;
function Companion_getInstance_63() {
  if (Companion_instance_57 === VOID)
    new Companion_48();
  return Companion_instance_57;
}
function Program$Builder$FuncProvider$provideDelegate$lambda(this$0) {
  return function ($this$FUNC) {
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_0 = this$0.v7p_1;
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var index = 0;
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.graphics.shader.FuncProvider.provideDelegate.<anonymous>.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var index_0 = checkIndexOverflow(tmp1);
      var tmp$ret$0 = $this$FUNC.b7q('p' + index_0, item);
      destination.h(tmp$ret$0);
    }
    var args = destination;
    this$0.x7p_1($this$FUNC, args);
    return Unit_instance;
  };
}
function Program$Builder$FUNC$lambda($block) {
  return function ($this$FuncProvider, it) {
    $block($this$FuncProvider, it.e1(0));
    return Unit_instance;
  };
}
function Program$Builder$FUNC$lambda_0($block) {
  return function ($this$FuncProvider, it) {
    $block($this$FuncProvider, it.e1(0), it.e1(1));
    return Unit_instance;
  };
}
function Program$Builder$FUNC$lambda_1($block) {
  return function ($this$FuncProvider, it) {
    $block($this$FuncProvider, it.e1(0), it.e1(1), it.e1(2));
    return Unit_instance;
  };
}
function Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda($block, $max) {
  return function ($this$ELSE) {
    $block($this$ELSE, $max);
    return Unit_instance;
  };
}
function Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda_0($ref, $middle, $max, $block) {
  return function ($this$ELSE) {
    $this$ELSE.e76($ref, $middle + 1 | 0, $max, $block);
    return Unit_instance;
  };
}
function Program$Builder$IF_ELSE_LIST$lambda($ref, $min, $max, $block) {
  return function ($this$ELSE) {
    $this$ELSE.f76($ref, $min + 1 | 0, $max, $block);
    return Unit_instance;
  };
}
var Output_instance;
function Output_getInstance() {
  if (Output_instance === VOID)
    Output.s7s();
  return Output_instance;
}
function Sampler_0(index, stype) {
  return new Provider(index, stype);
}
var SamplerVarType_Sampler1D_instance;
var SamplerVarType_Sampler2D_instance;
var SamplerVarType_Sampler3D_instance;
var SamplerVarType_SamplerCube_instance;
var SamplerVarType_entriesInitialized;
function SamplerVarType_initEntries() {
  if (SamplerVarType_entriesInitialized)
    return Unit_instance;
  SamplerVarType_entriesInitialized = true;
  SamplerVarType_Sampler1D_instance = new SamplerVarType('Sampler1D', 0, VarType_Sampler1D_getInstance());
  SamplerVarType_Sampler2D_instance = new SamplerVarType('Sampler2D', 1, VarType_Sampler2D_getInstance());
  SamplerVarType_Sampler3D_instance = new SamplerVarType('Sampler3D', 2, VarType_Sampler3D_getInstance());
  SamplerVarType_SamplerCube_instance = new SamplerVarType('SamplerCube', 3, VarType_SamplerCube_getInstance());
}
var VarType_TVOID_instance;
var VarType_Mat2_instance;
var VarType_Mat3_instance;
var VarType_Mat4_instance;
var VarType_Sampler1D_instance;
var VarType_Sampler2D_instance;
var VarType_Sampler3D_instance;
var VarType_SamplerCube_instance;
var VarType_Int1_instance;
var VarType_Float1_instance;
var VarType_Float2_instance;
var VarType_Float3_instance;
var VarType_Float4_instance;
var VarType_Short1_instance;
var VarType_Short2_instance;
var VarType_Short3_instance;
var VarType_Short4_instance;
var VarType_Bool1_instance;
var VarType_Bool2_instance;
var VarType_Bool3_instance;
var VarType_Bool4_instance;
var VarType_Byte4_instance;
var VarType_SByte1_instance;
var VarType_SByte2_instance;
var VarType_SByte3_instance;
var VarType_SByte4_instance;
var VarType_UByte1_instance;
var VarType_UByte2_instance;
var VarType_UByte3_instance;
var VarType_UByte4_instance;
var VarType_SShort1_instance;
var VarType_SShort2_instance;
var VarType_SShort3_instance;
var VarType_SShort4_instance;
var VarType_UShort1_instance;
var VarType_UShort2_instance;
var VarType_UShort3_instance;
var VarType_UShort4_instance;
var VarType_SInt1_instance;
var VarType_SInt2_instance;
var VarType_SInt3_instance;
var VarType_SInt4_instance;
var Companion_instance_58;
function Companion_getInstance_64() {
  return Companion_instance_58;
}
var VarType_entriesInitialized;
function VarType_initEntries() {
  if (VarType_entriesInitialized)
    return Unit_instance;
  VarType_entriesInitialized = true;
  VarType_TVOID_instance = new VarType('TVOID', 0, VarKind_TBYTE_getInstance(), 0);
  VarType_Mat2_instance = new VarType('Mat2', 1, VarKind_TFLOAT_getInstance(), 4, true);
  VarType_Mat3_instance = new VarType('Mat3', 2, VarKind_TFLOAT_getInstance(), 9, true);
  VarType_Mat4_instance = new VarType('Mat4', 3, VarKind_TFLOAT_getInstance(), 16, true);
  VarType_Sampler1D_instance = new VarType('Sampler1D', 4, VarKind_TINT_getInstance(), 1);
  VarType_Sampler2D_instance = new VarType('Sampler2D', 5, VarKind_TINT_getInstance(), 1);
  VarType_Sampler3D_instance = new VarType('Sampler3D', 6, VarKind_TINT_getInstance(), 1);
  VarType_SamplerCube_instance = new VarType('SamplerCube', 7, VarKind_TINT_getInstance(), 1);
  VarType_Int1_instance = new VarType('Int1', 8, VarKind_TINT_getInstance(), 1);
  VarType_Float1_instance = new VarType('Float1', 9, VarKind_TFLOAT_getInstance(), 1);
  VarType_Float2_instance = new VarType('Float2', 10, VarKind_TFLOAT_getInstance(), 2);
  VarType_Float3_instance = new VarType('Float3', 11, VarKind_TFLOAT_getInstance(), 3);
  VarType_Float4_instance = new VarType('Float4', 12, VarKind_TFLOAT_getInstance(), 4);
  VarType_Short1_instance = new VarType('Short1', 13, VarKind_TSHORT_getInstance(), 1);
  VarType_Short2_instance = new VarType('Short2', 14, VarKind_TSHORT_getInstance(), 2);
  VarType_Short3_instance = new VarType('Short3', 15, VarKind_TSHORT_getInstance(), 3);
  VarType_Short4_instance = new VarType('Short4', 16, VarKind_TSHORT_getInstance(), 4);
  VarType_Bool1_instance = new VarType('Bool1', 17, VarKind_TBOOL_getInstance(), 1);
  VarType_Bool2_instance = new VarType('Bool2', 18, VarKind_TBOOL_getInstance(), 2);
  VarType_Bool3_instance = new VarType('Bool3', 19, VarKind_TBOOL_getInstance(), 3);
  VarType_Bool4_instance = new VarType('Bool4', 20, VarKind_TBOOL_getInstance(), 4);
  VarType_Byte4_instance = new VarType('Byte4', 21, VarKind_TUNSIGNED_BYTE_getInstance(), 4);
  VarType_SByte1_instance = new VarType('SByte1', 22, VarKind_TBYTE_getInstance(), 1);
  VarType_SByte2_instance = new VarType('SByte2', 23, VarKind_TBYTE_getInstance(), 2);
  VarType_SByte3_instance = new VarType('SByte3', 24, VarKind_TBYTE_getInstance(), 3);
  VarType_SByte4_instance = new VarType('SByte4', 25, VarKind_TBYTE_getInstance(), 4);
  VarType_UByte1_instance = new VarType('UByte1', 26, VarKind_TUNSIGNED_BYTE_getInstance(), 1);
  VarType_UByte2_instance = new VarType('UByte2', 27, VarKind_TUNSIGNED_BYTE_getInstance(), 2);
  VarType_UByte3_instance = new VarType('UByte3', 28, VarKind_TUNSIGNED_BYTE_getInstance(), 3);
  VarType_UByte4_instance = new VarType('UByte4', 29, VarKind_TUNSIGNED_BYTE_getInstance(), 4);
  VarType_SShort1_instance = new VarType('SShort1', 30, VarKind_TSHORT_getInstance(), 1);
  VarType_SShort2_instance = new VarType('SShort2', 31, VarKind_TSHORT_getInstance(), 2);
  VarType_SShort3_instance = new VarType('SShort3', 32, VarKind_TSHORT_getInstance(), 3);
  VarType_SShort4_instance = new VarType('SShort4', 33, VarKind_TSHORT_getInstance(), 4);
  VarType_UShort1_instance = new VarType('UShort1', 34, VarKind_TUNSIGNED_SHORT_getInstance(), 1);
  VarType_UShort2_instance = new VarType('UShort2', 35, VarKind_TUNSIGNED_SHORT_getInstance(), 2);
  VarType_UShort3_instance = new VarType('UShort3', 36, VarKind_TUNSIGNED_SHORT_getInstance(), 3);
  VarType_UShort4_instance = new VarType('UShort4', 37, VarKind_TUNSIGNED_SHORT_getInstance(), 4);
  VarType_SInt1_instance = new VarType('SInt1', 38, VarKind_TINT_getInstance(), 1);
  VarType_SInt2_instance = new VarType('SInt2', 39, VarKind_TINT_getInstance(), 2);
  VarType_SInt3_instance = new VarType('SInt3', 40, VarKind_TINT_getInstance(), 3);
  VarType_SInt4_instance = new VarType('SInt4', 41, VarKind_TINT_getInstance(), 4);
}
var Precision_DEFAULT_instance;
var Precision_LOW_instance;
var Precision_MEDIUM_instance;
var Precision_HIGH_instance;
var Precision_entriesInitialized;
function Precision_initEntries() {
  if (Precision_entriesInitialized)
    return Unit_instance;
  Precision_entriesInitialized = true;
  Precision_DEFAULT_instance = new Precision('DEFAULT', 0);
  Precision_LOW_instance = new Precision('LOW', 1);
  Precision_MEDIUM_instance = new Precision('MEDIUM', 2);
  Precision_HIGH_instance = new Precision('HIGH', 3);
}
function FragmentShader(info) {
  return FragmentShader_0(info.ll_1, info.ml_1);
}
var VarKind_TBOOL_instance;
var VarKind_TBYTE_instance;
var VarKind_TUNSIGNED_BYTE_instance;
var VarKind_TSHORT_instance;
var VarKind_TUNSIGNED_SHORT_instance;
var VarKind_TINT_instance;
var VarKind_TFLOAT_instance;
var VarKind_entriesInitialized;
function VarKind_initEntries() {
  if (VarKind_entriesInitialized)
    return Unit_instance;
  VarKind_entriesInitialized = true;
  VarKind_TBOOL_instance = new VarKind('TBOOL', 0, 1);
  VarKind_TBYTE_instance = new VarKind('TBYTE', 1, 1);
  VarKind_TUNSIGNED_BYTE_instance = new VarKind('TUNSIGNED_BYTE', 2, 1);
  VarKind_TSHORT_instance = new VarKind('TSHORT', 3, 2);
  VarKind_TUNSIGNED_SHORT_instance = new VarKind('TUNSIGNED_SHORT', 4, 2);
  VarKind_TINT_instance = new VarKind('TINT', 5, 4);
  VarKind_TFLOAT_instance = new VarKind('TFLOAT', 6, 4);
}
var ShaderType_VERTEX_instance;
var ShaderType_FRAGMENT_instance;
var ShaderType_entriesInitialized;
function ShaderType_initEntries() {
  if (ShaderType_entriesInitialized)
    return Unit_instance;
  ShaderType_entriesInitialized = true;
  ShaderType_VERTEX_instance = new ShaderType('VERTEX', 0);
  ShaderType_FRAGMENT_instance = new ShaderType('FRAGMENT', 1);
}
function VertexShader(info) {
  return VertexShader_0(info.ll_1, info.ml_1);
}
function FragmentShader_0(stm, funcs) {
  var tmp;
  if (funcs === VOID) {
    // Inline function 'kotlin.collections.listOf' call
    tmp = emptyList();
  } else {
    tmp = funcs;
  }
  funcs = tmp;
  return new Shader(ShaderType_FRAGMENT_getInstance(), stm, funcs);
}
function VertexShader_0(stm, funcs) {
  var tmp;
  if (funcs === VOID) {
    // Inline function 'kotlin.collections.listOf' call
    tmp = emptyList();
  } else {
    tmp = funcs;
  }
  funcs = tmp;
  return new Shader(ShaderType_VERTEX_getInstance(), stm, funcs);
}
function SamplerVarType_Sampler2D_getInstance() {
  SamplerVarType_initEntries();
  return SamplerVarType_Sampler2D_instance;
}
function VarType_TVOID_getInstance() {
  VarType_initEntries();
  return VarType_TVOID_instance;
}
function VarType_Mat2_getInstance() {
  VarType_initEntries();
  return VarType_Mat2_instance;
}
function VarType_Mat4_getInstance() {
  VarType_initEntries();
  return VarType_Mat4_instance;
}
function VarType_Sampler1D_getInstance() {
  VarType_initEntries();
  return VarType_Sampler1D_instance;
}
function VarType_Sampler2D_getInstance() {
  VarType_initEntries();
  return VarType_Sampler2D_instance;
}
function VarType_Sampler3D_getInstance() {
  VarType_initEntries();
  return VarType_Sampler3D_instance;
}
function VarType_SamplerCube_getInstance() {
  VarType_initEntries();
  return VarType_SamplerCube_instance;
}
function VarType_Float1_getInstance() {
  VarType_initEntries();
  return VarType_Float1_instance;
}
function VarType_Float2_getInstance() {
  VarType_initEntries();
  return VarType_Float2_instance;
}
function VarType_Float3_getInstance() {
  VarType_initEntries();
  return VarType_Float3_instance;
}
function VarType_Float4_getInstance() {
  VarType_initEntries();
  return VarType_Float4_instance;
}
function VarType_SByte1_getInstance() {
  VarType_initEntries();
  return VarType_SByte1_instance;
}
function VarType_SByte2_getInstance() {
  VarType_initEntries();
  return VarType_SByte2_instance;
}
function VarType_SByte3_getInstance() {
  VarType_initEntries();
  return VarType_SByte3_instance;
}
function VarType_SByte4_getInstance() {
  VarType_initEntries();
  return VarType_SByte4_instance;
}
function VarType_UByte1_getInstance() {
  VarType_initEntries();
  return VarType_UByte1_instance;
}
function VarType_UByte2_getInstance() {
  VarType_initEntries();
  return VarType_UByte2_instance;
}
function VarType_UByte3_getInstance() {
  VarType_initEntries();
  return VarType_UByte3_instance;
}
function VarType_UByte4_getInstance() {
  VarType_initEntries();
  return VarType_UByte4_instance;
}
function VarType_SShort1_getInstance() {
  VarType_initEntries();
  return VarType_SShort1_instance;
}
function VarType_SShort2_getInstance() {
  VarType_initEntries();
  return VarType_SShort2_instance;
}
function VarType_SShort3_getInstance() {
  VarType_initEntries();
  return VarType_SShort3_instance;
}
function VarType_SShort4_getInstance() {
  VarType_initEntries();
  return VarType_SShort4_instance;
}
function VarType_UShort1_getInstance() {
  VarType_initEntries();
  return VarType_UShort1_instance;
}
function VarType_UShort2_getInstance() {
  VarType_initEntries();
  return VarType_UShort2_instance;
}
function VarType_UShort3_getInstance() {
  VarType_initEntries();
  return VarType_UShort3_instance;
}
function VarType_UShort4_getInstance() {
  VarType_initEntries();
  return VarType_UShort4_instance;
}
function VarType_SInt1_getInstance() {
  VarType_initEntries();
  return VarType_SInt1_instance;
}
function VarType_SInt2_getInstance() {
  VarType_initEntries();
  return VarType_SInt2_instance;
}
function VarType_SInt3_getInstance() {
  VarType_initEntries();
  return VarType_SInt3_instance;
}
function VarType_SInt4_getInstance() {
  VarType_initEntries();
  return VarType_SInt4_instance;
}
function Precision_DEFAULT_getInstance() {
  Precision_initEntries();
  return Precision_DEFAULT_instance;
}
function Precision_LOW_getInstance() {
  Precision_initEntries();
  return Precision_LOW_instance;
}
function Precision_MEDIUM_getInstance() {
  Precision_initEntries();
  return Precision_MEDIUM_instance;
}
function Precision_HIGH_getInstance() {
  Precision_initEntries();
  return Precision_HIGH_instance;
}
function VarKind_TBOOL_getInstance() {
  VarKind_initEntries();
  return VarKind_TBOOL_instance;
}
function VarKind_TBYTE_getInstance() {
  VarKind_initEntries();
  return VarKind_TBYTE_instance;
}
function VarKind_TUNSIGNED_BYTE_getInstance() {
  VarKind_initEntries();
  return VarKind_TUNSIGNED_BYTE_instance;
}
function VarKind_TSHORT_getInstance() {
  VarKind_initEntries();
  return VarKind_TSHORT_instance;
}
function VarKind_TUNSIGNED_SHORT_getInstance() {
  VarKind_initEntries();
  return VarKind_TUNSIGNED_SHORT_instance;
}
function VarKind_TINT_getInstance() {
  VarKind_initEntries();
  return VarKind_TINT_instance;
}
function VarKind_TFLOAT_getInstance() {
  VarKind_initEntries();
  return VarKind_TFLOAT_instance;
}
function ShaderType_VERTEX_getInstance() {
  ShaderType_initEntries();
  return ShaderType_VERTEX_instance;
}
function ShaderType_FRAGMENT_getInstance() {
  ShaderType_initEntries();
  return ShaderType_FRAGMENT_instance;
}
function toDisposable(_this__u8e3s4) {
  var tmp = toDisposable$lambda(_this__u8e3s4);
  return new sam$kotlinx_coroutines_DisposableHandle$0(tmp);
}
function toDisposable$lambda($this_toDisposable) {
  return function () {
    $this_toDisposable.n6();
    return Unit_instance;
  };
}
function putAsciiString(_this__u8e3s4, str) {
  var n = 0;
  var inductionVariable = 0;
  var last = str.length;
  while (inductionVariable < last) {
    var c = charSequenceGet(str, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    if (get_size_0(_this__u8e3s4) >= n) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.code' call
      var tmp$ret$0 = Char__toInt_impl_vasixd(c);
      _this__u8e3s4.c15(_unary__edvuaz, toByte(tmp$ret$0));
    }
  }
  if (get_size_0(_this__u8e3s4) >= n) {
    var _unary__edvuaz_0 = n;
    n = _unary__edvuaz_0 + 1 | 0;
    _this__u8e3s4.c15(_unary__edvuaz_0, 0);
  }
  return _this__u8e3s4;
}
function toAsciiString(_this__u8e3s4) {
  var out = '';
  var inductionVariable = 0;
  var last = get_size_0(_this__u8e3s4);
  if (inductionVariable < last)
    $l$loop: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var b = _this__u8e3s4.a15(n);
      if (b === 0)
        break $l$loop;
      out = out + toString_0(numberToChar(b));
    }
     while (inductionVariable < last);
  return out;
}
function KmlGl$ContextInfo$current$lambda() {
  return null;
}
var Companion_instance_59;
function Companion_getInstance_65() {
  return Companion_instance_59;
}
function KmlGl$isFloatTextureSupported$delegate$lambda(this$0) {
  return function () {
    return this$0.o5v().x2('GL_OES_texture_float') || this$0.o5v().x2('GL_ARB_texture_float');
  };
}
var logger;
var tempNBufferByte;
function get_tempNBuffer1() {
  _init_properties_KmlGlExt_kt__r5nfv2();
  return tempNBuffer1;
}
var tempNBuffer1;
var tempNBuffer4;
function getIntegerv(_this__u8e3s4, pname) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.getIntegerv.<anonymous>' call
  _this__u8e3s4.b86(pname, it);
  return getInt32(it, 0);
}
function getInteger(_this__u8e3s4, pname) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  return getIntegerv(_this__u8e3s4, pname);
}
function genVertexArray(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genVertexArray.<anonymous>' call
  _this__u8e3s4.f86(1, it);
  return getInt32(it, 0);
}
function getProgramiv(_this__u8e3s4, program, type) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.getProgramiv.<anonymous>' call
  _this__u8e3s4.c86(program, type, it);
  return getInt32(it, 0);
}
function getShaderiv(_this__u8e3s4, shader, type) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.getShaderiv.<anonymous>' call
  _this__u8e3s4.d86(shader, type, it);
  return getInt32(it, 0);
}
function getShaderInfoLog(_this__u8e3s4, shader) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.getInfoLog' call
  // Inline function 'korlibs.kgl.KmlGl.INFO_LOG_LENGTH' call
  var size = getShaderiv(_this__u8e3s4, shader, 35716);
  // Inline function 'korlibs.memory.BufferTemp' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.getInfoLog.<anonymous>' call
  var sizev = allocDirect(Companion_instance_4, 4);
  // Inline function 'korlibs.memory.BufferTemp' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.getInfoLog.<anonymous>.<anonymous>' call
  var mbuffer = allocDirect(Companion_instance_4, size);
  _this__u8e3s4.e86(shader, size, sizev, mbuffer);
  return toAsciiString(mbuffer);
}
function genBuffer(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genBuffer.<anonymous>' call
  _this__u8e3s4.x85(1, it);
  return getInt32(it, 0);
}
function deleteBuffer(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteBuffer.<anonymous>' call
  _this__u8e3s4.t85(1, it);
  getInt32(it, 0);
}
function genTexture(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genTexture.<anonymous>' call
  _this__u8e3s4.a86(1, it);
  return getInt32(it, 0);
}
function deleteTexture(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteTexture.<anonymous>' call
  _this__u8e3s4.w85(1, it);
  getInt32(it, 0);
}
function genRenderbuffer(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genRenderbuffer.<anonymous>' call
  _this__u8e3s4.z85(1, it);
  return getInt32(it, 0);
}
function genFramebuffer(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genFramebuffer.<anonymous>' call
  _this__u8e3s4.y85(1, it);
  return getInt32(it, 0);
}
function deleteRenderbuffer(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteRenderbuffer.<anonymous>' call
  _this__u8e3s4.v85(1, it);
  getInt32(it, 0);
}
function deleteFramebuffer(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteFramebuffer.<anonymous>' call
  _this__u8e3s4.u85(1, it);
  getInt32(it, 0);
}
function _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo() {
  _init_properties_KmlGlExt_kt__r5nfv2();
  return get_tempNBuffer1();
}
var properties_initialized_KmlGlExt_kt_yrhd4c;
function _init_properties_KmlGlExt_kt__r5nfv2() {
  if (!properties_initialized_KmlGlExt_kt_yrhd4c) {
    properties_initialized_KmlGlExt_kt_yrhd4c = true;
    logger = Companion_getInstance_1().ey('KmlGlException');
    tempNBufferByte = Buffer.m14(1, true);
    tempNBuffer1 = Buffer.m14(4, true);
    tempNBuffer4 = Buffer.m14(16, true);
  }
}
var KorgeReload_instance;
function KorgeReload_getInstance() {
  if (KorgeReload_instance === VOID)
    new KorgeReload();
  return KorgeReload_instance;
}
var Companion_instance_60;
function Companion_getInstance_66() {
  return Companion_instance_60;
}
function drawText(_this__u8e3s4, font, textSize, str, x, y, m, colMul, blendMode, filtering) {
  m = m === VOID ? Companion_getInstance_7().m2d_1 : m;
  colMul = colMul === VOID ? Colors_getInstance().g40_1 : colMul;
  blendMode = blendMode === VOID ? Companion_getInstance_67().r86_1 : blendMode;
  filtering = filtering === VOID ? true : filtering;
  drawText_0(font, _this__u8e3s4, textSize, str, x, y, m, colMul, blendMode, filtering);
}
function drawText_0(_this__u8e3s4, ctx, textSize, str, x, y, m, colMul, blendMode, filtering) {
  m = m === VOID ? Companion_getInstance_7().m2d_1 : m;
  colMul = colMul === VOID ? Colors_getInstance().g40_1 : colMul;
  blendMode = blendMode === VOID ? Companion_getInstance_67().r86_1 : blendMode;
  filtering = filtering === VOID ? true : filtering;
  var scale = textSize / _this__u8e3s4.l4h();
  var m2 = m.w2e(x, y).o2e(scale, scale);
  var dx = 0.0;
  var dy = 0.0;
  // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
  // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
  var this_0 = ctx.j88_1;
  var this_1 = this_0.s88_1;
  if (!(this_1.n88_1 === this_0)) {
    this_1.n88_1 = this_0;
    this_1.x89();
  }
  var inductionVariable = 0;
  var last = charSequenceLength(str) - 1 | 0;
  var tmp;
  if (inductionVariable <= last) {
    $l$loop: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c1 = Char__toInt_impl_vasixd(charSequenceGet(str, n));
      if (c1 === 10) {
        dx = 0.0;
        dy = dy + _this__u8e3s4.l4h();
        continue $l$loop;
      }
      // Inline function 'kotlin.text.getOrElse' call
      var index = n + 1 | 0;
      // Inline function 'kotlin.contracts.contract' call
      var tmp_0;
      if (0 <= index ? index <= (charSequenceLength(str) - 1 | 0) : false) {
        tmp_0 = charSequenceGet(str, index);
      } else {
        // Inline function 'korlibs.korge.bitmapfont.drawText.<anonymous>.<anonymous>' call
        tmp_0 = _Char___init__impl__6a9atx(32);
      }
      var tmp$ret$1 = tmp_0;
      var c2 = Char__toInt_impl_vasixd(tmp$ret$1);
      var glyph = _this__u8e3s4.e1(c1);
      var tex = glyph.b4h_1;
      var tmp0_tex = ctx.y89(tex);
      var tmp1_x = dx + glyph.c4h_1;
      var tmp2_y = dy + glyph.d4h_1;
      var tmp3_width = tex.a3k_1;
      var tmp4_height = tex.b3k_1;
      var tmp5_m = get_immutable(m2);
      this_0.z89(tmp0_tex, tmp1_x, tmp2_y, tmp3_width, tmp4_height, tmp5_m, filtering, colMul, blendMode);
      var tmp6_safe_receiver = _this__u8e3s4.p4h().e1(Companion_instance_5.y4g(c1, c2));
      var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.j4h_1;
      var kerningOffset = tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs;
      dx = dx + (glyph.e4h_1 + kerningOffset | 0);
    }
     while (inductionVariable <= last);
    tmp = Unit_instance;
  }
}
var debugBmpFontOrNull;
function *_generator_debugBmpFont__zhh4ef($completion) {
  if (debugBmpFontOrNull == null) {
    var tmp = readBitmap(openAsync(get_DEBUG_FONT_BYTES()), new ImageDecodingProps(VOID, VOID, VOID, VOID, VOID, VOID, VOID, true), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    debugBmpFontOrNull = debugBmpFont_0(slice(tmp.w46()));
  }
  return ensureNotNull(debugBmpFontOrNull);
}
function debugBmpFont($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_debugBmpFont__zhh4ef.bind(VOID), $completion);
}
function debugBmpFont_0(tex) {
  var fntAdvance = 7.0;
  var fntWidth = 8.0;
  var fntHeight = 8.0;
  var fntBlockX = 2.0;
  var fntBlockY = 2.0;
  var fntBlockWidth = 12.0;
  var fntBlockHeight = 12.0;
  // Inline function 'korlibs.image.font.Companion.invoke' call
  var base = fntHeight - 1.0;
  // Inline function 'kotlin.collections.associateWith' call
  var this_0 = until(0, 256);
  var result = LinkedHashMap.pc(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
  // Inline function 'kotlin.collections.associateWithTo' call
  var inductionVariable = this_0.b2_1;
  var last = this_0.c2_1;
  if (inductionVariable <= last)
    do {
      var element = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.korge.bitmapfont.debugBmpFont.<anonymous>' call
      var it = element;
      var x = it % 16 | 0;
      var y = it / 16 | 0;
      var tmp$ret$0 = new Glyph(fntHeight, it, tex.i3l(numberToInt(x * fntBlockWidth + fntBlockX), numberToInt(y * fntBlockHeight + fntBlockY), numberToInt(fntWidth), numberToInt(fntHeight)), 0, 0, numberToInt(fntAdvance));
      result.h3(element, tmp$ret$0);
    }
     while (!(element === last));
  var glyphs = toIntMap(result);
  var kernings = IntMap.v2s();
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fntHeight), numberToDouble(fntHeight), numberToDouble(base), glyphs, kernings, name, null);
}
function get_DEBUG_FONT_BYTES() {
  return fromBase64('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');
}
var Companion_instance_61;
function Companion_getInstance_67() {
  if (Companion_instance_61 === VOID)
    new Companion_52();
  return Companion_instance_61;
}
var Companion_instance_62;
function Companion_getInstance_68() {
  return Companion_instance_62;
}
function endFrameOldKeys($this, delta) {
  var inductionVariable = 0;
  if (inductionVariable < 256)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var prev = $this.g8b_1[n];
      var curr = $this.f8b_1[n];
      $this.l8b_1[n] = (prev && !curr);
      $this.k8b_1[n] = (!prev && curr);
      if (curr) {
        var _array__4zh2yp = $this.h8b_1;
        _array__4zh2yp[n] = _array__4zh2yp[n] + _FastDuration___get_fastNanoseconds__impl__9kjwbr(delta);
      } else {
        $this.h8b_1[n] = 0.0;
        $this.i8b_1[n] = 0.0;
      }
      var triggerPress = false;
      var pressingTime = get_fastNanoseconds($this.h8b_1[n]);
      if ($this.h8b_1[n] > 0) {
        var tmp0_subject = _FastDuration___get_fastMilliseconds__impl__pe68va(pressingTime);
        var timeBarrier = (0.0 <= tmp0_subject ? tmp0_subject <= 1.0 : false) ? get_fastMilliseconds(0.0) : (1.0 <= tmp0_subject ? tmp0_subject <= 300.0 : false) ? get_fastMilliseconds(100.0) : (300.0 <= tmp0_subject ? tmp0_subject <= 1000.0 : false) ? get_fastMilliseconds(50.0) : get_fastMilliseconds(20.0);
        var elapsedTime = FastDuration__minus_impl_evs237(pressingTime, get_fastNanoseconds($this.i8b_1[n]));
        if (FastDuration__compareTo_impl_4fhnj7(elapsedTime, timeBarrier) >= 0) {
          triggerPress = true;
        }
      }
      if (triggerPress) {
        $this.i8b_1[n] = $this.h8b_1[n];
      }
      $this.j8b_1[n] = triggerPress;
    }
     while (inductionVariable < 256);
  arraycopy_4($this.f8b_1, 0, $this.g8b_1, 0, 256);
}
function Input$_isTouchDeviceGen$lambda() {
  return AGOpenglFactory_instance.o8b();
}
var DefaultViewport_instance;
function DefaultViewport_getInstance() {
  if (DefaultViewport_instance === VOID)
    new DefaultViewport();
  return DefaultViewport_instance;
}
function *_generator_configureLoggerFromProperties__heiqlb(file, $completion) {
  try {
    var tmp = file.q28(VOID, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    configureLoggerFromProperties_0(tmp);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function configureLoggerFromProperties(file, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_configureLoggerFromProperties__heiqlb.bind(VOID, file), $completion);
}
function configureLoggerFromProperties_0(str) {
  var props = Companion_instance_63.b8c(str);
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = props.q1().b1();
  while (_iterator__ex2g4s.c1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.d1();
    // Inline function 'kotlin.collections.component1' call
    var key = _destruct__k2r9zo.r1();
    // Inline function 'kotlin.collections.component2' call
    var value = _destruct__k2r9zo.s1();
    try {
      var tmp = Companion_getInstance_1().ey(key);
      // Inline function 'kotlin.text.toUpperCase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$4 = value.toUpperCase();
      tmp.q2x(valueOf(tmp$ret$4));
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
  }
}
var Companion_instance_63;
function Companion_getInstance_69() {
  return Companion_instance_63;
}
function AgAutoFreeManager$entryPool$lambda(it) {
  it.p2u();
  return Unit_instance;
}
function AgAutoFreeManager$entryPool$lambda_0(it) {
  return new Entry();
}
function getTextureInfo($this, bitmap) {
  if ($this.i8d_1 === bitmap && ensureNotNull($this.j8d_1).r8c_1.v8c_1 === bitmap.i3z_1)
    return ensureNotNull($this.j8d_1);
  if ($this.k8d_1 === bitmap && ensureNotNull($this.l8d_1).r8c_1.v8c_1 === bitmap.i3z_1)
    return ensureNotNull($this.l8d_1);
  $this.c8d_1.m2r(bitmap);
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.getOrPut' call
    var this_0 = $this.h8d_1;
    var res = get_0(this_0, bitmap);
    if (!(res == null)) {
      tmp$ret$0 = res;
      break $l$block;
    }
    // Inline function 'korlibs.korge.render.AgBitmapTextureManager.getTextureInfo.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_1 = $this.g8d_1.z2t();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.AgBitmapTextureManager.getTextureInfo.<anonymous>.<anonymous>' call
    var base = this_1.r8c_1;
    base.v8c_1 = -1;
    var tmp = base;
    var tmp_0;
    if (bitmap instanceof MultiBitmap) {
      tmp_0 = Companion_getInstance_50().m6t_1;
    } else {
      tmp_0 = Companion_getInstance_50().k6t_1;
    }
    tmp.t8c_1 = new AGTexture(tmp_0);
    base.x8c(bitmap.z3y_1);
    base.y8c(bitmap.a3z_1);
    var out = this_1;
    set(this_0, bitmap, out);
    tmp$ret$0 = out;
  }
  var textureInfo = tmp$ret$0;
  $this.k8d_1 = $this.i8d_1;
  $this.l8d_1 = $this.j8d_1;
  var base_0 = textureInfo.r8c_1;
  $this.i8d_1 = bitmap;
  $this.j8d_1 = textureInfo;
  if (!(bitmap.i3z_1 === base_0.v8c_1)) {
    base_0.v8c_1 = bitmap.i3z_1;
    var tmp_1 = $this;
    // Inline function 'kotlin.Long.minus' call
    var this_2 = $this.f8d_1;
    var other = textureInfo.q8c_1;
    tmp_1.f8d_1 = this_2.y1(toLong(other));
    try {
      base_0.r8d(bitmap, bitmap.k3z_1, get_baseMipmapLevel(bitmap), get_maxMipmapLevel(bitmap));
    }finally {
      textureInfo.q8c_1 = _get_estimateSizeInBytes__tshb4c(bitmap, $this);
      var tmp_2 = $this;
      // Inline function 'kotlin.Long.plus' call
      var this_3 = $this.f8d_1;
      var other_0 = textureInfo.q8c_1;
      tmp_2.f8d_1 = this_3.y3(toLong(other_0));
    }
    bitmap.v3z();
  }
  return textureInfo;
}
function _get_estimateSizeInBytes__tshb4c(_this__u8e3s4, $this) {
  return imul(_this__u8e3s4.a3z_1, imul(_this__u8e3s4.z3y_1, _this__u8e3s4.b3z_1) / 8 | 0);
}
function _getTexture($this, slice) {
  if ($this.m8d_1 === slice)
    return ensureNotNull($this.n8d_1);
  if ($this.o8d_1 === slice)
    return ensureNotNull($this.p8d_1);
  var info = getTextureInfo($this, slice.a3l());
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.getOrPut' call
    var this_0 = info.s8c_1;
    var res = get_0(this_0, slice);
    if (!(res == null)) {
      tmp$ret$0 = res;
      break $l$block;
    }
    // Inline function 'korlibs.korge.render.AgBitmapTextureManager._getTexture.<anonymous>' call
    var tmp;
    if (slice instanceof RectSlice) {
      tmp = Texture_1(info.r8c_1).k3l(RectangleInt.x2i(slice.r2a(), slice.t2a(), slice.a3k_1, slice.b3k_1));
    } else {
      tmp = Companion_instance_7.y3l(info.r8c_1, slice);
    }
    var out = tmp;
    set(this_0, slice, out);
    tmp$ret$0 = out;
  }
  var texture = tmp$ret$0;
  $this.o8d_1 = $this.m8d_1;
  $this.p8d_1 = $this.n8d_1;
  $this.m8d_1 = slice;
  $this.n8d_1 = texture;
  return texture;
}
function clearFastCacheAccess($this) {
  $this.i8d_1 = null;
  $this.j8d_1 = null;
  $this.k8d_1 = null;
  $this.l8d_1 = null;
  $this.m8d_1 = null;
  $this.n8d_1 = null;
  $this.o8d_1 = null;
  $this.p8d_1 = null;
}
function AgBitmapTextureManager$textureInfoPool$lambda(it) {
  it.p2u();
  return Unit_instance;
}
function AgBitmapTextureManager$textureInfoPool$lambda_0(it) {
  return new BitmapTextureInfo();
}
function removeCache($this) {
}
function AgBufferManager$bufferPool$lambda(it) {
  return new AGBuffer();
}
function get_logger() {
  _init_properties_BatchBuilder2D_kt__vdn94j();
  return logger_0;
}
var logger_0;
function get_BB_MAX_TEXTURES() {
  _init_properties_BatchBuilder2D_kt__vdn94j();
  return BB_MAX_TEXTURES;
}
var BB_MAX_TEXTURES;
function BatchBuilder2D$Companion$createTextureLookup$lambda($$this$apply) {
  return function ($this$IF_ELSE_BINARY_LOOKUP, n) {
    $this$IF_ELSE_BINARY_LOOKUP.y74($this$IF_ELSE_BINARY_LOOKUP.b75(), $this$IF_ELSE_BINARY_LOOKUP.j75(Companion_getInstance_70().m8e_1[n], $this$IF_ELSE_BINARY_LOOKUP.h75($$this$apply.u74(), 'xy')));
    return Unit_instance;
  };
}
function _addIndices($this, indicesI16, pos, i0, i1, i2, i3, i4, i5) {
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 0 | 0, i0);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 1 | 0, i1);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 2 | 0, i2);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 3 | 0, i3);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 4 | 0, i4);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 5 | 0, i5);
  return 6;
}
function applyMatrix($this, matrix, idx, vcount) {
  var f32 = get_f32($this.a89_1);
  var idx_0 = idx;
  var ma = matrix.r2d_1;
  var mb = matrix.s2d_1;
  var mc = matrix.t2d_1;
  var md = matrix.u2d_1;
  var mtx = matrix.v2d_1;
  var mty = matrix.w2d_1;
  var inductionVariable = 0;
  if (inductionVariable < vcount)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var p = Vector2D.v2e(Float32Buffer__get_impl_659lhu(f32, idx_0 + 0 | 0), Float32Buffer__get_impl_659lhu(f32, idx_0 + 1 | 0));
      var pt = Companion_getInstance_7().z2d(ma, mb, mc, md, mtx, mty, p);
      Float32Buffer__set_impl_34szne(f32, idx_0 + 0 | 0, pt.a2a_1);
      Float32Buffer__set_impl_34szne(f32, idx_0 + 1 | 0, pt.b2a_1);
      idx_0 = idx_0 + 6 | 0;
    }
     while (inductionVariable < vcount);
}
function checkAvailable($this, indices, vertices) {
  return ($this.g89_1 + indices | 0) < $this.z88_1 && ($this.f89_1 + vertices | 0) < $this.y88_1;
}
var Companion_instance_64;
function Companion_getInstance_70() {
  if (Companion_instance_64 === VOID)
    new Companion_55();
  return Companion_instance_64;
}
function BatchBuilder2D$lambda(this$0) {
  return function (it) {
    var tmp;
    switch (it.r3_1) {
      case 0:
        this$0.d8f();
        tmp = Unit_instance;
        break;
      case 1:
        this$0.e8f();
        tmp = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return Unit_instance;
  };
}
function BatchBuilder2D$buffers$lambda(it) {
  return new BatchBuffers();
}
var properties_initialized_BatchBuilder2D_kt_532b2j;
function _init_properties_BatchBuilder2D_kt__vdn94j() {
  if (!properties_initialized_BatchBuilder2D_kt_532b2j) {
    properties_initialized_BatchBuilder2D_kt_532b2j = true;
    logger_0 = Companion_getInstance_1().ey('BatchBuilder2D');
    BB_MAX_TEXTURES = Companion_getInstance_3().ov() && Companion_getInstance_3().rv().zu_1 && Companion_getInstance_3().rv().ev() ? 1 : 4;
  }
}
function get_debugLineRenderContext(_this__u8e3s4) {
  _init_properties_LineRenderBatcher_kt__ezqewb();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = debugLineRenderContext$delegate;
    var property = debugLineRenderContext$factory();
    var tmp0_elvis_lhs = this_0.c10_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.d10_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.c10_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var debugLineRenderContext$delegate;
var Companion_instance_65;
function Companion_getInstance_71() {
  if (Companion_instance_65 === VOID)
    new Companion_56();
  return Companion_instance_65;
}
function addVertex($this, x, y, color, m) {
  setFloat32($this.r8h_1, $this.u8h_1 + 0 | 0, m.f2e(x, y));
  setFloat32($this.r8h_1, $this.u8h_1 + 1 | 0, m.g2e(x, y));
  setInt32($this.r8h_1, $this.u8h_1 + 2 | 0, _RGBA___get_value__impl__hhco8v(color));
  $this.u8h_1 = $this.u8h_1 + (Companion_getInstance_71().g8h_1.c6x_1 / 4 | 0) | 0;
  $this.t8h_1 = $this.t8h_1 + 1 | 0;
}
function LineRenderBatcher$lambda(this$0) {
  return function (it) {
    this$0.yc();
    return Unit_instance;
  };
}
function debugLineRenderContext$delegate$lambda($this$PropertyThis) {
  _init_properties_LineRenderBatcher_kt__ezqewb();
  return new LineRenderBatcher($this$PropertyThis);
}
function debugLineRenderContext$factory() {
  return getPropertyCallableRef('debugLineRenderContext', 1, KProperty1, function (receiver) {
    return get_debugLineRenderContext(receiver);
  }, null);
}
var properties_initialized_LineRenderBatcher_kt_urwcod;
function _init_properties_LineRenderBatcher_kt__ezqewb() {
  if (!properties_initialized_LineRenderBatcher_kt_urwcod) {
    properties_initialized_LineRenderBatcher_kt_urwcod = true;
    debugLineRenderContext$delegate = new PropertyThis(VOID, debugLineRenderContext$delegate$lambda);
  }
}
var FlushKind_STATE_instance;
var FlushKind_FULL_instance;
var FlushKind_entriesInitialized;
function FlushKind_initEntries() {
  if (FlushKind_entriesInitialized)
    return Unit_instance;
  FlushKind_entriesInitialized = true;
  FlushKind_STATE_instance = new FlushKind('STATE', 0);
  FlushKind_FULL_instance = new FlushKind('FULL', 1);
}
function RenderContext$tempTexturePool$lambda(it) {
  return new AGTexture();
}
function RenderContext$projViewMatUB$delegate$lambda(this$0) {
  return function () {
    return this$0.a6v(ProjViewUB_getInstance());
  };
}
function RenderContext$dynamicVertexBufferPool$lambda(it) {
  return new AGBuffer();
}
function RenderContext$frameBuffers$lambda(it) {
  return AGFrameBuffer.x6n(VOID, it);
}
function FlushKind_FULL_getInstance() {
  FlushKind_initEntries();
  return FlushKind_FULL_instance;
}
function projViewMatUB$factory() {
  return getPropertyCallableRef('projViewMatUB', 1, KProperty1, function (receiver) {
    return receiver.f8i();
  }, null);
}
function get_logger_0() {
  _init_properties_RenderContext2D_kt__7o43tz();
  return logger_1;
}
var logger_1;
function RenderContext2D$mpool$lambda(it) {
  return new MMatrix();
}
var properties_initialized_RenderContext2D_kt_ica10b;
function _init_properties_RenderContext2D_kt__7o43tz() {
  if (!properties_initialized_RenderContext2D_kt_ica10b) {
    properties_initialized_RenderContext2D_kt_ica10b = true;
    logger_1 = Companion_getInstance_1().ey('RenderContext2D');
  }
}
function SDFShaders$opInterpolate$delegate$lambda($this$FUNC, a, b, c) {
  $this$FUNC.h76($this$FUNC.w7q(a, b, c));
  return Unit_instance;
}
function SDFShaders$opUnion$delegate$lambda($this$FUNC, a, b) {
  $this$FUNC.h76($this$FUNC.t7q(a, b));
  return Unit_instance;
}
function SDFShaders$opIntersect$delegate$lambda($this$FUNC, a, b) {
  $this$FUNC.h76($this$FUNC.u7q(a, b));
  return Unit_instance;
}
function SDFShaders$opSubtract$delegate$lambda($this$FUNC, a, b) {
  $this$FUNC.h76($this$FUNC.u7q(a, $this$FUNC.w76(b)));
  return Unit_instance;
}
function SDFShaders$opRound$delegate$lambda($this$FUNC, d, r) {
  $this$FUNC.h76($this$FUNC.x76(d, r));
  return Unit_instance;
}
function SDFShaders$opBorder$delegate$lambda($this$FUNC, d, r) {
  $this$FUNC.h76($this$FUNC.x76($this$FUNC.o76(d), r));
  return Unit_instance;
}
function SDFShaders$opBorderInner$delegate$lambda($this$FUNC, d, r) {
  // Inline function 'korlibs.graphics.shader.Builder.IF' call
  var cond = $this$FUNC.c7r(d, 0.0);
  var body = $this$FUNC.p75();
  // Inline function 'korlibs.korge.render.SDFShaders.opBorderInner$delegate.<anonymous>.<anonymous>' call
  body.h76(d);
  var stmIf = new If(cond, body.r75());
  // Inline function 'kotlin.collections.plusAssign' call
  $this$FUNC.x74_1.h(stmIf);
  var tmp = stmIf;
  $this$FUNC.d76(tmp, SDFShaders$opBorderInner$delegate$lambda$lambda(d, r));
  return Unit_instance;
}
function SDFShaders$opBorderInner$delegate$lambda$lambda($d, $r) {
  return function ($this$ELSE) {
    $this$ELSE.h76($this$ELSE.x76($this$ELSE.o76($d), $r));
    return Unit_instance;
  };
}
function SDFShaders$opAA$delegate$lambda($this$FUNC, d) {
  $this$FUNC.h76($this$FUNC.y7q(1.0, $this$FUNC.s7q($this$FUNC.a7r($this$FUNC.n75(d, $this$FUNC.v7q(d)), 0.5), $this$FUNC.e75(0.0), $this$FUNC.e75(1.0))));
  return Unit_instance;
}
function SDFShaders$opAARev$delegate$lambda($this$FUNC, d) {
  $this$FUNC.h76($this$FUNC.s7q($this$FUNC.a7r($this$FUNC.n75(d, $this$FUNC.v7q(d)), 0.5), $this$FUNC.e75(0.0), $this$FUNC.e75(1.0)));
  return Unit_instance;
}
function SDFShaders$opSmoothUnion$delegate$lambda($this$FUNC, d1, d2, k) {
  var h = $this$FUNC.q7q($this$FUNC.s7q($this$FUNC.z7q(0.5, $this$FUNC.n75($this$FUNC.b7r(0.5, $this$FUNC.x76(d2, d1)), k)), $this$FUNC.e75(0.0), $this$FUNC.e75(1.0)));
  $this$FUNC.h76($this$FUNC.x76($this$FUNC.w7q(d2, d1, h), $this$FUNC.c75($this$FUNC.c75(k, h), $this$FUNC.y7q(1.0, h))));
  return Unit_instance;
}
function SDFShaders$opSmoothSubtraction$delegate$lambda($this$FUNC, d1, d2, k) {
  var h = $this$FUNC.q7q($this$FUNC.s7q($this$FUNC.y7q(0.5, $this$FUNC.n75($this$FUNC.b7r(0.5, $this$FUNC.y76(d2, d1)), k)), $this$FUNC.e75(0.0), $this$FUNC.e75(1.0)));
  $this$FUNC.h76($this$FUNC.y76($this$FUNC.w7q(d2, $this$FUNC.w76(d1), h), $this$FUNC.c75($this$FUNC.c75(k, h), $this$FUNC.y7q(1.0, h))));
  return Unit_instance;
}
function SDFShaders$opSmoothIntersection$delegate$lambda($this$FUNC, d1, d2, k) {
  var h = $this$FUNC.q7q($this$FUNC.s7q($this$FUNC.y7q(0.5, $this$FUNC.n75($this$FUNC.b7r(0.5, $this$FUNC.x76(d2, d1)), k)), $this$FUNC.e75(0.0), $this$FUNC.e75(1.0)));
  $this$FUNC.h76($this$FUNC.y76($this$FUNC.w7q(d2, d1, h), $this$FUNC.c75($this$FUNC.c75(k, h), $this$FUNC.y7q(1.0, h))));
  return Unit_instance;
}
function SDFShaders$circle$delegate$lambda($this$FUNC, p, r) {
  $this$FUNC.h76($this$FUNC.x76($this$FUNC.x7q(p), r));
  return Unit_instance;
}
function SDFShaders$roundedBox$delegate$lambda($this$FUNC, p, b, r) {
  $this$FUNC.y74($this$FUNC.h75(r, 'xy'), $this$FUNC.r7q($this$FUNC.c7r($this$FUNC.s76(p), 0.0), $this$FUNC.h75(r, 'xy'), $this$FUNC.h75(r, 'zw')));
  $this$FUNC.y74($this$FUNC.s76(r), $this$FUNC.r7q($this$FUNC.c7r($this$FUNC.t76(p), 0.0), $this$FUNC.s76(r), $this$FUNC.t76(r)));
  var q = $this$FUNC.q7q($this$FUNC.y76($this$FUNC.x76($this$FUNC.o76(p), b), $this$FUNC.s76(r)));
  $this$FUNC.h76($this$FUNC.x76($this$FUNC.y76($this$FUNC.t7q($this$FUNC.u7q($this$FUNC.s76(q), $this$FUNC.t76(q)), $this$FUNC.e75(0.0)), $this$FUNC.x7q($this$FUNC.u7q(q, $this$FUNC.e75(0.0)))), $this$FUNC.s76(r)));
  return Unit_instance;
}
function SDFShaders$box$delegate$lambda($this$FUNC, p, b) {
  var d = $this$FUNC.q7q($this$FUNC.x76($this$FUNC.o76(p), b));
  $this$FUNC.h76($this$FUNC.y76($this$FUNC.x7q($this$FUNC.u7q(d, $this$FUNC.e75(0.0))), $this$FUNC.t7q($this$FUNC.u7q($this$FUNC.s76(d), $this$FUNC.t76(d)), $this$FUNC.e75(0.0))));
  return Unit_instance;
}
function SDFShaders$opCombinePremultipliedColors$delegate$lambda($this$FUNC, dst, src) {
  $this$FUNC.h76($this$FUNC.y76(src, $this$FUNC.c75(dst, $this$FUNC.y7q(1.0, $this$FUNC.l75(src)))));
  return Unit_instance;
}
var SDFShaders_instance;
function SDFShaders_getInstance() {
  if (SDFShaders_instance === VOID)
    SDFShaders.b8k();
  return SDFShaders_instance;
}
function opInterpolate$factory() {
  return getPropertyCallableRef('opInterpolate', 1, KProperty1, function (receiver) {
    return receiver.c8k();
  }, null);
}
function opUnion$factory() {
  return getPropertyCallableRef('opUnion', 1, KProperty1, function (receiver) {
    return receiver.d8k();
  }, null);
}
function opIntersect$factory() {
  return getPropertyCallableRef('opIntersect', 1, KProperty1, function (receiver) {
    return receiver.e8k();
  }, null);
}
function opSubtract$factory() {
  return getPropertyCallableRef('opSubtract', 1, KProperty1, function (receiver) {
    return receiver.f8k();
  }, null);
}
function opRound$factory() {
  return getPropertyCallableRef('opRound', 1, KProperty1, function (receiver) {
    return receiver.g8k();
  }, null);
}
function opBorder$factory() {
  return getPropertyCallableRef('opBorder', 1, KProperty1, function (receiver) {
    return receiver.h8k();
  }, null);
}
function opBorderInner$factory() {
  return getPropertyCallableRef('opBorderInner', 1, KProperty1, function (receiver) {
    return receiver.i8k();
  }, null);
}
function opAA$factory() {
  return getPropertyCallableRef('opAA', 1, KProperty1, function (receiver) {
    return receiver.j8k();
  }, null);
}
function opAARev$factory() {
  return getPropertyCallableRef('opAARev', 1, KProperty1, function (receiver) {
    return receiver.k8k();
  }, null);
}
function opSmoothUnion$factory() {
  return getPropertyCallableRef('opSmoothUnion', 1, KProperty1, function (receiver) {
    return receiver.l8k();
  }, null);
}
function opSmoothSubtraction$factory() {
  return getPropertyCallableRef('opSmoothSubtraction', 1, KProperty1, function (receiver) {
    return receiver.m8k();
  }, null);
}
function opSmoothIntersection$factory() {
  return getPropertyCallableRef('opSmoothIntersection', 1, KProperty1, function (receiver) {
    return receiver.n8k();
  }, null);
}
function circle$factory() {
  return getPropertyCallableRef('circle', 1, KProperty1, function (receiver) {
    return receiver.o8k();
  }, null);
}
function roundedBox$factory() {
  return getPropertyCallableRef('roundedBox', 1, KProperty1, function (receiver) {
    return receiver.p8k();
  }, null);
}
function box$factory() {
  return getPropertyCallableRef('box', 1, KProperty1, function (receiver) {
    return receiver.q8k();
  }, null);
}
function opCombinePremultipliedColors$factory() {
  return getPropertyCallableRef('opCombinePremultipliedColors', 1, KProperty1, function (receiver) {
    return receiver.r8k();
  }, null);
}
function opInterpolate$factory_0() {
  return getPropertyCallableRef('opInterpolate', 1, KProperty1, function (receiver) {
    return receiver.c8k();
  }, null);
}
function opUnion$factory_0() {
  return getPropertyCallableRef('opUnion', 1, KProperty1, function (receiver) {
    return receiver.d8k();
  }, null);
}
function opIntersect$factory_0() {
  return getPropertyCallableRef('opIntersect', 1, KProperty1, function (receiver) {
    return receiver.e8k();
  }, null);
}
function opSubtract$factory_0() {
  return getPropertyCallableRef('opSubtract', 1, KProperty1, function (receiver) {
    return receiver.f8k();
  }, null);
}
function opRound$factory_0() {
  return getPropertyCallableRef('opRound', 1, KProperty1, function (receiver) {
    return receiver.g8k();
  }, null);
}
function opBorder$factory_0() {
  return getPropertyCallableRef('opBorder', 1, KProperty1, function (receiver) {
    return receiver.h8k();
  }, null);
}
function opBorderInner$factory_0() {
  return getPropertyCallableRef('opBorderInner', 1, KProperty1, function (receiver) {
    return receiver.i8k();
  }, null);
}
function opAA$factory_0() {
  return getPropertyCallableRef('opAA', 1, KProperty1, function (receiver) {
    return receiver.j8k();
  }, null);
}
function opAARev$factory_0() {
  return getPropertyCallableRef('opAARev', 1, KProperty1, function (receiver) {
    return receiver.k8k();
  }, null);
}
function opSmoothUnion$factory_0() {
  return getPropertyCallableRef('opSmoothUnion', 1, KProperty1, function (receiver) {
    return receiver.l8k();
  }, null);
}
function opSmoothSubtraction$factory_0() {
  return getPropertyCallableRef('opSmoothSubtraction', 1, KProperty1, function (receiver) {
    return receiver.m8k();
  }, null);
}
function opSmoothIntersection$factory_0() {
  return getPropertyCallableRef('opSmoothIntersection', 1, KProperty1, function (receiver) {
    return receiver.n8k();
  }, null);
}
function circle$factory_0() {
  return getPropertyCallableRef('circle', 1, KProperty1, function (receiver) {
    return receiver.o8k();
  }, null);
}
function roundedBox$factory_0() {
  return getPropertyCallableRef('roundedBox', 1, KProperty1, function (receiver) {
    return receiver.p8k();
  }, null);
}
function box$factory_0() {
  return getPropertyCallableRef('box', 1, KProperty1, function (receiver) {
    return receiver.q8k();
  }, null);
}
function opCombinePremultipliedColors$factory_0() {
  return getPropertyCallableRef('opCombinePremultipliedColors', 1, KProperty1, function (receiver) {
    return receiver.r8k();
  }, null);
}
function Texture(frameBuffer) {
  return Texture_0(frameBuffer.p6s(), frameBuffer.r6n_1, frameBuffer.s6n_1);
}
function Texture_0(agBase, width, height) {
  return new RectSlice(TextureBase.s8k(agBase, SizeInt.n2k(width, height)), RectangleInt.x2i(0, 0, width, height));
}
function Texture_1(base, left, top, right, bottom) {
  left = left === VOID ? 0 : left;
  top = top === VOID ? 0 : top;
  right = right === VOID ? base.d2m() : right;
  bottom = bottom === VOID ? base.e2m() : bottom;
  return new RectSlice(base, Companion_instance_2.d2i(left, top, right, bottom));
}
function get_TEXTURED_ARRAY_QUAD_INDICES() {
  _init_properties_TexturedVertexArray_kt__kev7cq();
  return TEXTURED_ARRAY_QUAD_INDICES;
}
var TEXTURED_ARRAY_QUAD_INDICES;
var TEXTURED_ARRAY_EMPTY_INT_ARRAY;
var TEXTURED_ARRAY_EMPTY_SHORT_ARRAY;
var Companion_instance_66;
function Companion_getInstance_72() {
  if (Companion_instance_66 === VOID)
    new Companion_57();
  return Companion_instance_66;
}
var properties_initialized_TexturedVertexArray_kt_ouua70;
function _init_properties_TexturedVertexArray_kt__kev7cq() {
  if (!properties_initialized_TexturedVertexArray_kt_ouua70) {
    properties_initialized_TexturedVertexArray_kt_ouua70 = true;
    // Inline function 'kotlin.shortArrayOf' call
    TEXTURED_ARRAY_QUAD_INDICES = new Int16Array([0, 1, 2, 3, 0, 2]);
    TEXTURED_ARRAY_EMPTY_INT_ARRAY = new Int32Array(0);
    TEXTURED_ARRAY_EMPTY_SHORT_ARRAY = new Int16Array(0);
  }
}
function _get_root__dd8asp($this) {
  var tmp = $this.x8k_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('root');
  }
}
function _get_mountable__707cy($this) {
  var tmp = $this.y8k_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('mountable');
  }
}
function _interpolateRatio(ratio, l, r) {
  return interpolate(ratio, l, r);
}
var DEFAULT_instance;
function DEFAULT_getInstance() {
  return DEFAULT_instance;
}
var GLOBAL_CHECK_GL;
var Cursor_DEFAULT_instance;
var Cursor_CROSSHAIR_instance;
var Cursor_TEXT_instance;
var Cursor_HAND_instance;
var Cursor_MOVE_instance;
var Cursor_WAIT_instance;
var Cursor_RESIZE_EAST_instance;
var Cursor_RESIZE_WEST_instance;
var Cursor_RESIZE_SOUTH_instance;
var Cursor_RESIZE_NORTH_instance;
var Cursor_RESIZE_NORTH_EAST_instance;
var Cursor_RESIZE_NORTH_WEST_instance;
var Cursor_RESIZE_SOUTH_EAST_instance;
var Cursor_RESIZE_SOUTH_WEST_instance;
var Companion_instance_67;
function Companion_getInstance_73() {
  Cursor_initEntries();
  if (Companion_instance_67 === VOID)
    new Companion_58();
  return Companion_instance_67;
}
var Cursor_entriesInitialized;
function Cursor_initEntries() {
  if (Cursor_entriesInitialized)
    return Unit_instance;
  Cursor_entriesInitialized = true;
  Cursor_DEFAULT_instance = new Cursor('DEFAULT', 0);
  Cursor_CROSSHAIR_instance = new Cursor('CROSSHAIR', 1);
  Cursor_TEXT_instance = new Cursor('TEXT', 2);
  Cursor_HAND_instance = new Cursor('HAND', 3);
  Cursor_MOVE_instance = new Cursor('MOVE', 4);
  Cursor_WAIT_instance = new Cursor('WAIT', 5);
  Cursor_RESIZE_EAST_instance = new Cursor('RESIZE_EAST', 6);
  Cursor_RESIZE_WEST_instance = new Cursor('RESIZE_WEST', 7);
  Cursor_RESIZE_SOUTH_instance = new Cursor('RESIZE_SOUTH', 8);
  Cursor_RESIZE_NORTH_instance = new Cursor('RESIZE_NORTH', 9);
  Cursor_RESIZE_NORTH_EAST_instance = new Cursor('RESIZE_NORTH_EAST', 10);
  Cursor_RESIZE_NORTH_WEST_instance = new Cursor('RESIZE_NORTH_WEST', 11);
  Cursor_RESIZE_SOUTH_EAST_instance = new Cursor('RESIZE_SOUTH_EAST', 12);
  Cursor_RESIZE_SOUTH_WEST_instance = new Cursor('RESIZE_SOUTH_WEST', 13);
  Companion_getInstance_73();
}
function GameWindow$MenuItem$_init_$lambda_465oqx() {
  return Unit_instance;
}
var Quality_PERFORMANCE_instance;
var Quality_QUALITY_instance;
var Quality_AUTOMATIC_instance;
var Quality_entriesInitialized;
function Quality_initEntries() {
  if (Quality_entriesInitialized)
    return Unit_instance;
  Quality_entriesInitialized = true;
  Quality_PERFORMANCE_instance = new Quality('PERFORMANCE', 0, 0.0);
  Quality_QUALITY_instance = new Quality('QUALITY', 1, 1.0);
  Quality_AUTOMATIC_instance = new Quality('AUTOMATIC', 2, 0.5);
}
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = $this.z8l_1($this.a8m_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var CoroutineKey_instance;
function CoroutineKey_getInstance() {
  if (CoroutineKey_instance === VOID)
    new CoroutineKey();
  return CoroutineKey_instance;
}
function _get_fpsCached__581dty($this) {
  return $this.g8n_1.mo($this, fpsCached$factory());
}
function *_generator_waitClose__fhnm35($this, $completion) {
  while ($this.v8n_1) {
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$1 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
    var tmp = delay_0(tmp$ret$1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function *_generator_loop__qll5p8($this, entry, $completion) {
  var tmp = $this.z8o($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.cn(CoroutineName.x1d('GameWindow.loop'));
  launchImmediately(tmp_0, GameWindow$loop$slambda_0(entry, $this));
  while ($this.v8n_1) {
    var elapsed;
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    var mark = Monotonic_instance.kj();
    // Inline function 'korlibs.render.GameWindow.loop.<anonymous>' call
    elapsed = $this.a8p();
    var realElapsed = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
    var available = FastDuration__minus_impl_evs237($this.b8p(), elapsed);
    if (FastDuration__compareTo_impl_4fhnj7(available, Companion_instance_3.x1x()) > 0) {
      var tmp_1 = $this.c8p(available, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
    }
  }
  return Unit_instance;
}
function *_generator_loopDelay__vgtnit($this, time, $completion) {
  var tmp = delay(time, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function GameWindow$fpsCached$delegate$lambda(this$0) {
  return function () {
    return this$0.d8p();
  };
}
function GameWindow$loop$slambda_0($entry, this$0) {
  var i = new GameWindow$loop$slambda($entry, this$0);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function Cursor_DEFAULT_getInstance() {
  Cursor_initEntries();
  return Cursor_DEFAULT_instance;
}
function Cursor_RESIZE_EAST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_EAST_instance;
}
function Cursor_RESIZE_WEST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_WEST_instance;
}
function Cursor_RESIZE_SOUTH_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_SOUTH_instance;
}
function Cursor_RESIZE_NORTH_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_NORTH_instance;
}
function Cursor_RESIZE_NORTH_EAST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_NORTH_EAST_instance;
}
function Cursor_RESIZE_NORTH_WEST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_NORTH_WEST_instance;
}
function Cursor_RESIZE_SOUTH_EAST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_SOUTH_EAST_instance;
}
function Cursor_RESIZE_SOUTH_WEST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_SOUTH_WEST_instance;
}
function Quality_PERFORMANCE_getInstance() {
  Quality_initEntries();
  return Quality_PERFORMANCE_instance;
}
function Quality_AUTOMATIC_getInstance() {
  Quality_initEntries();
  return Quality_AUTOMATIC_instance;
}
var Companion_instance_68;
function Companion_getInstance_74() {
  if (Companion_instance_68 === VOID)
    new Companion_59();
  return Companion_instance_68;
}
function configure(_this__u8e3s4, size, title, icon, fullscreen, bgcolor) {
  title = title === VOID ? 'GameWindow' : title;
  icon = icon === VOID ? null : icon;
  fullscreen = fullscreen === VOID ? null : fullscreen;
  bgcolor = bgcolor === VOID ? Colors_getInstance().h40_1 : bgcolor;
  _this__u8e3s4.o8q(numberToInt(size.f2b_1), numberToInt(size.g2b_1));
  if (!(title == null)) {
    _this__u8e3s4.f8q(title);
  }
  _this__u8e3s4.g8q(icon);
  if (!(fullscreen == null)) {
    _this__u8e3s4.h8q(fullscreen);
  }
  _this__u8e3s4.j8q(bgcolor);
  _this__u8e3s4.i8q(true);
}
function fpsCached$factory() {
  return getPropertyCallableRef('fpsCached', 1, KProperty1, function (receiver) {
    return _get_fpsCached__581dty(receiver);
  }, null);
}
function continuousRenderMode$factory() {
  return getPropertyCallableRef('continuousRenderMode', 1, KMutableProperty1, function (receiver) {
    return receiver.v8q();
  }, function (receiver, value) {
    return receiver.u8q(value);
  });
}
function continuousRenderMode$factory_0() {
  return getPropertyCallableRef('continuousRenderMode', 1, KMutableProperty1, function (receiver) {
    return receiver.v8q();
  }, function (receiver, value) {
    return receiver.u8q(value);
  });
}
var Companion_instance_69;
function Companion_getInstance_75() {
  if (Companion_instance_69 === VOID)
    new Companion_60();
  return Companion_instance_69;
}
function GameWindowCoroutineDispatcher$_init_$lambda_ooms1e() {
  return new FastDuration(PerformanceCounter_getInstance().y6c());
}
function GameWindowCoroutineDispatcher$timedTasks$lambda(a, b) {
  return FastDuration__compareTo_impl_4fhnj7(a.v8r_1, b.v8r_1);
}
function GameWindowCoroutineDispatcher$scheduleResumeAfterDelay$lambda($task) {
  return function (it) {
    $task.y8r_1 = it;
    return Unit_instance;
  };
}
function GameWindowCoroutineDispatcher$invokeOnTimeout$lambda(this$0, $task) {
  return function () {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this$0.q8p_1.d1y_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    this$0.p8p_1.p2q($task);
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$dispatch$lambda($block) {
  return function () {
    $block.n1c();
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda($cancelled) {
  return function (it) {
    $cancelled._v = it;
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda_0($cancelled, $continuation) {
  return function () {
    var tmp;
    if (!($cancelled._v == null)) {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      var this_0 = $continuation;
      // Inline function 'kotlin.Companion.failure' call
      var exception = ensureNotNull($cancelled._v);
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
      this_0.bd(tmp$ret$0);
      tmp = Unit_instance;
    } else {
      // Inline function 'kotlin.coroutines.resume' call
      var this_1 = $continuation;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$2 = _Result___init__impl__xyqfz8(Unit_instance);
      this_1.bd(tmp$ret$2);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$invokeOnTimeout$lambda($block) {
  return function () {
    $block.n1c();
    return Unit_instance;
  };
}
var Companion_instance_70;
function Companion_getInstance_76() {
  return Companion_instance_70;
}
var korgwJvmEngine;
function get_SDLPath() {
  _init_properties_SDL_kt__pqu7sn();
  // Inline function 'kotlin.getValue' call
  var this_0 = SDLPath$delegate;
  SDLPath$factory();
  return this_0.s1();
}
var SDLPath$delegate;
var Companion_instance_71;
function Companion_getInstance_77() {
  return Companion_instance_71;
}
var Companion_instance_72;
function Companion_getInstance_78() {
  return Companion_instance_72;
}
function SDLPath$delegate$lambda() {
  _init_properties_SDL_kt__pqu7sn();
  return Companion_getInstance_3().pv() ? '/Library/Frameworks/SDL2.framework/SDL2' : 'SDL2.dll';
}
function SDLPath$factory() {
  return getPropertyCallableRef('SDLPath', 0, KProperty0, function () {
    return get_SDLPath();
  }, null);
}
function SDL_Init$factory() {
  return getPropertyCallableRef('SDL_Init', 1, KProperty1, function (receiver) {
    return receiver.q8t();
  }, null);
}
function SDL_CreateWindow$factory() {
  return getPropertyCallableRef('SDL_CreateWindow', 1, KProperty1, function (receiver) {
    return receiver.r8t();
  }, null);
}
function SDL_SetWindowTitle$factory() {
  return getPropertyCallableRef('SDL_SetWindowTitle', 1, KProperty1, function (receiver) {
    return receiver.s8t();
  }, null);
}
function SDL_SetWindowSize$factory() {
  return getPropertyCallableRef('SDL_SetWindowSize', 1, KProperty1, function (receiver) {
    return receiver.t8t();
  }, null);
}
function SDL_SetWindowPosition$factory() {
  return getPropertyCallableRef('SDL_SetWindowPosition', 1, KProperty1, function (receiver) {
    return receiver.u8t();
  }, null);
}
function SDL_ShowWindow$factory() {
  return getPropertyCallableRef('SDL_ShowWindow', 1, KProperty1, function (receiver) {
    return receiver.v8t();
  }, null);
}
function SDL_RaiseWindow$factory() {
  return getPropertyCallableRef('SDL_RaiseWindow', 1, KProperty1, function (receiver) {
    return receiver.w8t();
  }, null);
}
function SDL_PollEvent$factory() {
  return getPropertyCallableRef('SDL_PollEvent', 1, KProperty1, function (receiver) {
    return receiver.x8t();
  }, null);
}
function SDL_Quit$factory() {
  return getPropertyCallableRef('SDL_Quit', 1, KProperty1, function (receiver) {
    return receiver.y8t();
  }, null);
}
function SDL_GL_CreateContext$factory() {
  return getPropertyCallableRef('SDL_GL_CreateContext', 1, KProperty1, function (receiver) {
    return receiver.z8t();
  }, null);
}
function SDL_GL_DeleteContext$factory() {
  return getPropertyCallableRef('SDL_GL_DeleteContext', 1, KProperty1, function (receiver) {
    return receiver.a8u();
  }, null);
}
function SDL_GL_MakeCurrent$factory() {
  return getPropertyCallableRef('SDL_GL_MakeCurrent', 1, KProperty1, function (receiver) {
    return receiver.b8u();
  }, null);
}
function SDL_GL_SwapWindow$factory() {
  return getPropertyCallableRef('SDL_GL_SwapWindow', 1, KProperty1, function (receiver) {
    return receiver.c8u();
  }, null);
}
function SDL_Init$factory_0() {
  return getPropertyCallableRef('SDL_Init', 1, KProperty1, function (receiver) {
    return receiver.q8t();
  }, null);
}
function SDL_CreateWindow$factory_0() {
  return getPropertyCallableRef('SDL_CreateWindow', 1, KProperty1, function (receiver) {
    return receiver.r8t();
  }, null);
}
function SDL_SetWindowTitle$factory_0() {
  return getPropertyCallableRef('SDL_SetWindowTitle', 1, KProperty1, function (receiver) {
    return receiver.s8t();
  }, null);
}
function SDL_SetWindowSize$factory_0() {
  return getPropertyCallableRef('SDL_SetWindowSize', 1, KProperty1, function (receiver) {
    return receiver.t8t();
  }, null);
}
function SDL_SetWindowPosition$factory_0() {
  return getPropertyCallableRef('SDL_SetWindowPosition', 1, KProperty1, function (receiver) {
    return receiver.u8t();
  }, null);
}
function SDL_ShowWindow$factory_0() {
  return getPropertyCallableRef('SDL_ShowWindow', 1, KProperty1, function (receiver) {
    return receiver.v8t();
  }, null);
}
function SDL_RaiseWindow$factory_0() {
  return getPropertyCallableRef('SDL_RaiseWindow', 1, KProperty1, function (receiver) {
    return receiver.w8t();
  }, null);
}
function SDL_PollEvent$factory_0() {
  return getPropertyCallableRef('SDL_PollEvent', 1, KProperty1, function (receiver) {
    return receiver.x8t();
  }, null);
}
function SDL_Quit$factory_0() {
  return getPropertyCallableRef('SDL_Quit', 1, KProperty1, function (receiver) {
    return receiver.y8t();
  }, null);
}
function SDL_GL_CreateContext$factory_0() {
  return getPropertyCallableRef('SDL_GL_CreateContext', 1, KProperty1, function (receiver) {
    return receiver.z8t();
  }, null);
}
function SDL_GL_DeleteContext$factory_0() {
  return getPropertyCallableRef('SDL_GL_DeleteContext', 1, KProperty1, function (receiver) {
    return receiver.a8u();
  }, null);
}
function SDL_GL_MakeCurrent$factory_0() {
  return getPropertyCallableRef('SDL_GL_MakeCurrent', 1, KProperty1, function (receiver) {
    return receiver.b8u();
  }, null);
}
function SDL_GL_SwapWindow$factory_0() {
  return getPropertyCallableRef('SDL_GL_SwapWindow', 1, KProperty1, function (receiver) {
    return receiver.c8u();
  }, null);
}
function glDrawArraysInstanced$factory() {
  return getPropertyCallableRef('glDrawArraysInstanced', 1, KProperty1, function (receiver) {
    return receiver.p93();
  }, null);
}
function glDrawElementsInstanced$factory() {
  return getPropertyCallableRef('glDrawElementsInstanced', 1, KProperty1, function (receiver) {
    return receiver.q93();
  }, null);
}
function glVertexAttribDivisor$factory() {
  return getPropertyCallableRef('glVertexAttribDivisor', 1, KProperty1, function (receiver) {
    return receiver.r93();
  }, null);
}
function glTexSubImage2D$factory() {
  return getPropertyCallableRef('glTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.y93();
  }, null);
}
function glTexImage2D$factory() {
  return getPropertyCallableRef('glTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.y92();
  }, null);
}
function glTexParameteri$factory() {
  return getPropertyCallableRef('glTexParameteri', 1, KProperty1, function (receiver) {
    return receiver.z92();
  }, null);
}
function glTexParameterf$factory() {
  return getPropertyCallableRef('glTexParameterf', 1, KProperty1, function (receiver) {
    return receiver.z93();
  }, null);
}
function glTexParameterfv$factory() {
  return getPropertyCallableRef('glTexParameterfv', 1, KProperty1, function (receiver) {
    return receiver.a94();
  }, null);
}
function glTexParameteriv$factory() {
  return getPropertyCallableRef('glTexParameteriv', 1, KProperty1, function (receiver) {
    return receiver.b94();
  }, null);
}
function glStencilOp$factory() {
  return getPropertyCallableRef('glStencilOp', 1, KProperty1, function (receiver) {
    return receiver.w92();
  }, null);
}
function glStencilMask$factory() {
  return getPropertyCallableRef('glStencilMask', 1, KProperty1, function (receiver) {
    return receiver.u92();
  }, null);
}
function glReadPixels$factory() {
  return getPropertyCallableRef('glReadPixels', 1, KProperty1, function (receiver) {
    return receiver.c94();
  }, null);
}
function glStencilFunc$factory() {
  return getPropertyCallableRef('glStencilFunc', 1, KProperty1, function (receiver) {
    return receiver.s92();
  }, null);
}
function glScissor$factory() {
  return getPropertyCallableRef('glScissor', 1, KProperty1, function (receiver) {
    return receiver.q92();
  }, null);
}
function glPolygonOffset$factory() {
  return getPropertyCallableRef('glPolygonOffset', 1, KProperty1, function (receiver) {
    return receiver.d94();
  }, null);
}
function glPixelStorei$factory() {
  return getPropertyCallableRef('glPixelStorei', 1, KProperty1, function (receiver) {
    return receiver.o92();
  }, null);
}
function glLineWidth$factory() {
  return getPropertyCallableRef('glLineWidth', 1, KProperty1, function (receiver) {
    return receiver.e94();
  }, null);
}
function glGetTexParameterfv$factory() {
  return getPropertyCallableRef('glGetTexParameterfv', 1, KProperty1, function (receiver) {
    return receiver.f94();
  }, null);
}
function glGetTexParameteriv$factory() {
  return getPropertyCallableRef('glGetTexParameteriv', 1, KProperty1, function (receiver) {
    return receiver.g94();
  }, null);
}
function glGetError$factory() {
  return getPropertyCallableRef('glGetError', 1, KProperty1, function (receiver) {
    return receiver.h92();
  }, null);
}
function glGetFloatv$factory() {
  return getPropertyCallableRef('glGetFloatv', 1, KProperty1, function (receiver) {
    return receiver.h94();
  }, null);
}
function glGetIntegerv$factory() {
  return getPropertyCallableRef('glGetIntegerv', 1, KProperty1, function (receiver) {
    return receiver.i92();
  }, null);
}
function glGetBooleanv$factory() {
  return getPropertyCallableRef('glGetBooleanv', 1, KProperty1, function (receiver) {
    return receiver.i94();
  }, null);
}
function glGenTextures$factory() {
  return getPropertyCallableRef('glGenTextures', 1, KProperty1, function (receiver) {
    return receiver.f92();
  }, null);
}
function glDepthRange$factory() {
  return getPropertyCallableRef('glDepthRange', 1, KProperty1, function (receiver) {
    return receiver.j94();
  }, null);
}
function glDepthRangef$factory() {
  return getPropertyCallableRef('glDepthRangef', 1, KProperty1, function (receiver) {
    return receiver.q91();
  }, null);
}
function glClearDepth$factory() {
  return getPropertyCallableRef('glClearDepth', 1, KProperty1, function (receiver) {
    return receiver.k94();
  }, null);
}
function glClearDepthf$factory() {
  return getPropertyCallableRef('glClearDepthf', 1, KProperty1, function (receiver) {
    return receiver.b91();
  }, null);
}
function glDrawArrays$factory() {
  return getPropertyCallableRef('glDrawArrays', 1, KProperty1, function (receiver) {
    return receiver.t91();
  }, null);
}
function glDrawElements$factory() {
  return getPropertyCallableRef('glDrawElements', 1, KProperty1, function (receiver) {
    return receiver.u91();
  }, null);
}
function glFrontFace$factory() {
  return getPropertyCallableRef('glFrontFace', 1, KProperty1, function (receiver) {
    return receiver.a92();
  }, null);
}
function glFinish$factory() {
  return getPropertyCallableRef('glFinish', 1, KProperty1, function (receiver) {
    return receiver.l94();
  }, null);
}
function glFlush$factory() {
  return getPropertyCallableRef('glFlush', 1, KProperty1, function (receiver) {
    return receiver.x91();
  }, null);
}
function glEnable$factory() {
  return getPropertyCallableRef('glEnable', 1, KProperty1, function (receiver) {
    return receiver.v91();
  }, null);
}
function glIsEnabled$factory() {
  return getPropertyCallableRef('glIsEnabled', 1, KProperty1, function (receiver) {
    return receiver.m94();
  }, null);
}
function glDisable$factory() {
  return getPropertyCallableRef('glDisable', 1, KProperty1, function (receiver) {
    return receiver.r91();
  }, null);
}
function glDepthMask$factory() {
  return getPropertyCallableRef('glDepthMask', 1, KProperty1, function (receiver) {
    return receiver.p91();
  }, null);
}
function glDepthFunc$factory() {
  return getPropertyCallableRef('glDepthFunc', 1, KProperty1, function (receiver) {
    return receiver.o91();
  }, null);
}
function glDeleteTextures$factory() {
  return getPropertyCallableRef('glDeleteTextures', 1, KProperty1, function (receiver) {
    return receiver.n91();
  }, null);
}
function glCullFace$factory() {
  return getPropertyCallableRef('glCullFace', 1, KProperty1, function (receiver) {
    return receiver.h91();
  }, null);
}
function glCopyTexImage2D$factory() {
  return getPropertyCallableRef('glCopyTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.n94();
  }, null);
}
function glCopyTexSubImage2D$factory() {
  return getPropertyCallableRef('glCopyTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.o94();
  }, null);
}
function glColorMask$factory() {
  return getPropertyCallableRef('glColorMask', 1, KProperty1, function (receiver) {
    return receiver.d91();
  }, null);
}
function glClearStencil$factory() {
  return getPropertyCallableRef('glClearStencil', 1, KProperty1, function (receiver) {
    return receiver.c91();
  }, null);
}
function glClearColor$factory() {
  return getPropertyCallableRef('glClearColor', 1, KProperty1, function (receiver) {
    return receiver.a91();
  }, null);
}
function glClear$factory() {
  return getPropertyCallableRef('glClear', 1, KProperty1, function (receiver) {
    return receiver.z90();
  }, null);
}
function glBindTexture$factory() {
  return getPropertyCallableRef('glBindTexture', 1, KProperty1, function (receiver) {
    return receiver.u90();
  }, null);
}
function glHint$factory() {
  return getPropertyCallableRef('glHint', 1, KProperty1, function (receiver) {
    return receiver.p94();
  }, null);
}
function glViewport$factory() {
  return getPropertyCallableRef('glViewport', 1, KProperty1, function (receiver) {
    return receiver.o93();
  }, null);
}
function glGetString$factory() {
  return getPropertyCallableRef('glGetString', 1, KProperty1, function (receiver) {
    return receiver.m92();
  }, null);
}
function glGetStringi$factory() {
  return getPropertyCallableRef('glGetStringi', 1, KProperty1, function (receiver) {
    return receiver.q94();
  }, null);
}
function glVertexAttribPointer$factory() {
  return getPropertyCallableRef('glVertexAttribPointer', 1, KProperty1, function (receiver) {
    return receiver.n93();
  }, null);
}
function glVertexAttrib4fv$factory() {
  return getPropertyCallableRef('glVertexAttrib4fv', 1, KProperty1, function (receiver) {
    return receiver.r94();
  }, null);
}
function glActiveTexture$factory() {
  return getPropertyCallableRef('glActiveTexture', 1, KProperty1, function (receiver) {
    return receiver.o90();
  }, null);
}
function glAttachShader$factory() {
  return getPropertyCallableRef('glAttachShader', 1, KProperty1, function (receiver) {
    return receiver.p90();
  }, null);
}
function glBindAttribLocation$factory() {
  return getPropertyCallableRef('glBindAttribLocation', 1, KProperty1, function (receiver) {
    return receiver.q90();
  }, null);
}
function glBindBuffer$factory() {
  return getPropertyCallableRef('glBindBuffer', 1, KProperty1, function (receiver) {
    return receiver.r90();
  }, null);
}
function glBindFramebuffer$factory() {
  return getPropertyCallableRef('glBindFramebuffer', 1, KProperty1, function (receiver) {
    return receiver.s90();
  }, null);
}
function glBindRenderbuffer$factory() {
  return getPropertyCallableRef('glBindRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.t90();
  }, null);
}
function glBlendColor$factory() {
  return getPropertyCallableRef('glBlendColor', 1, KProperty1, function (receiver) {
    return receiver.s94();
  }, null);
}
function glBlendEquation$factory() {
  return getPropertyCallableRef('glBlendEquation', 1, KProperty1, function (receiver) {
    return receiver.t94();
  }, null);
}
function glBlendEquationSeparate$factory() {
  return getPropertyCallableRef('glBlendEquationSeparate', 1, KProperty1, function (receiver) {
    return receiver.v90();
  }, null);
}
function glBlendFunc$factory() {
  return getPropertyCallableRef('glBlendFunc', 1, KProperty1, function (receiver) {
    return receiver.u94();
  }, null);
}
function glBlendFuncSeparate$factory() {
  return getPropertyCallableRef('glBlendFuncSeparate', 1, KProperty1, function (receiver) {
    return receiver.w90();
  }, null);
}
function glBufferData$factory() {
  return getPropertyCallableRef('glBufferData', 1, KProperty1, function (receiver) {
    return receiver.x90();
  }, null);
}
function glBufferSubData$factory() {
  return getPropertyCallableRef('glBufferSubData', 1, KProperty1, function (receiver) {
    return receiver.y90();
  }, null);
}
function glCheckFramebufferStatus$factory() {
  return getPropertyCallableRef('glCheckFramebufferStatus', 1, KProperty1, function (receiver) {
    return receiver.v94();
  }, null);
}
function glCompileShader$factory() {
  return getPropertyCallableRef('glCompileShader', 1, KProperty1, function (receiver) {
    return receiver.e91();
  }, null);
}
function glCompressedTexImage2D$factory() {
  return getPropertyCallableRef('glCompressedTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.w94();
  }, null);
}
function glCompressedTexSubImage2D$factory() {
  return getPropertyCallableRef('glCompressedTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.x94();
  }, null);
}
function glCreateProgram$factory() {
  return getPropertyCallableRef('glCreateProgram', 1, KProperty1, function (receiver) {
    return receiver.f91();
  }, null);
}
function glCreateShader$factory() {
  return getPropertyCallableRef('glCreateShader', 1, KProperty1, function (receiver) {
    return receiver.g91();
  }, null);
}
function glDeleteBuffers$factory() {
  return getPropertyCallableRef('glDeleteBuffers', 1, KProperty1, function (receiver) {
    return receiver.i91();
  }, null);
}
function glDeleteFramebuffers$factory() {
  return getPropertyCallableRef('glDeleteFramebuffers', 1, KProperty1, function (receiver) {
    return receiver.j91();
  }, null);
}
function glDeleteProgram$factory() {
  return getPropertyCallableRef('glDeleteProgram', 1, KProperty1, function (receiver) {
    return receiver.k91();
  }, null);
}
function glDeleteRenderbuffers$factory() {
  return getPropertyCallableRef('glDeleteRenderbuffers', 1, KProperty1, function (receiver) {
    return receiver.l91();
  }, null);
}
function glDeleteShader$factory() {
  return getPropertyCallableRef('glDeleteShader', 1, KProperty1, function (receiver) {
    return receiver.m91();
  }, null);
}
function glDetachShader$factory() {
  return getPropertyCallableRef('glDetachShader', 1, KProperty1, function (receiver) {
    return receiver.y94();
  }, null);
}
function glDisableVertexAttribArray$factory() {
  return getPropertyCallableRef('glDisableVertexAttribArray', 1, KProperty1, function (receiver) {
    return receiver.s91();
  }, null);
}
function glEnableVertexAttribArray$factory() {
  return getPropertyCallableRef('glEnableVertexAttribArray', 1, KProperty1, function (receiver) {
    return receiver.w91();
  }, null);
}
function glFramebufferRenderbuffer$factory() {
  return getPropertyCallableRef('glFramebufferRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.y91();
  }, null);
}
function glFramebufferTexture2D$factory() {
  return getPropertyCallableRef('glFramebufferTexture2D', 1, KProperty1, function (receiver) {
    return receiver.z91();
  }, null);
}
function glGenBuffers$factory() {
  return getPropertyCallableRef('glGenBuffers', 1, KProperty1, function (receiver) {
    return receiver.b92();
  }, null);
}
function glGenerateMipmap$factory() {
  return getPropertyCallableRef('glGenerateMipmap', 1, KProperty1, function (receiver) {
    return receiver.c92();
  }, null);
}
function glGenFramebuffers$factory() {
  return getPropertyCallableRef('glGenFramebuffers', 1, KProperty1, function (receiver) {
    return receiver.d92();
  }, null);
}
function glGenRenderbuffers$factory() {
  return getPropertyCallableRef('glGenRenderbuffers', 1, KProperty1, function (receiver) {
    return receiver.e92();
  }, null);
}
function glGetActiveAttrib$factory() {
  return getPropertyCallableRef('glGetActiveAttrib', 1, KProperty1, function (receiver) {
    return receiver.z94();
  }, null);
}
function glGetActiveUniform$factory() {
  return getPropertyCallableRef('glGetActiveUniform', 1, KProperty1, function (receiver) {
    return receiver.a95();
  }, null);
}
function glGetAttachedShaders$factory() {
  return getPropertyCallableRef('glGetAttachedShaders', 1, KProperty1, function (receiver) {
    return receiver.b95();
  }, null);
}
function glGetAttribLocation$factory() {
  return getPropertyCallableRef('glGetAttribLocation', 1, KProperty1, function (receiver) {
    return receiver.c95();
  }, null);
}
function glGetUniformLocation$factory() {
  return getPropertyCallableRef('glGetUniformLocation', 1, KProperty1, function (receiver) {
    return receiver.g92();
  }, null);
}
function glGetBufferParameteriv$factory() {
  return getPropertyCallableRef('glGetBufferParameteriv', 1, KProperty1, function (receiver) {
    return receiver.d95();
  }, null);
}
function glGetFramebufferAttachmentParameteriv$factory() {
  return getPropertyCallableRef('glGetFramebufferAttachmentParameteriv', 1, KProperty1, function (receiver) {
    return receiver.e95();
  }, null);
}
function glGetProgramInfoLog$factory() {
  return getPropertyCallableRef('glGetProgramInfoLog', 1, KProperty1, function (receiver) {
    return receiver.f95();
  }, null);
}
function glGetRenderbufferParameteriv$factory() {
  return getPropertyCallableRef('glGetRenderbufferParameteriv', 1, KProperty1, function (receiver) {
    return receiver.g95();
  }, null);
}
function glGetProgramiv$factory() {
  return getPropertyCallableRef('glGetProgramiv', 1, KProperty1, function (receiver) {
    return receiver.j92();
  }, null);
}
function glGetShaderiv$factory() {
  return getPropertyCallableRef('glGetShaderiv', 1, KProperty1, function (receiver) {
    return receiver.k92();
  }, null);
}
function glGetShaderInfoLog$factory() {
  return getPropertyCallableRef('glGetShaderInfoLog', 1, KProperty1, function (receiver) {
    return receiver.l92();
  }, null);
}
function glGetShaderPrecisionFormat$factory() {
  return getPropertyCallableRef('glGetShaderPrecisionFormat', 1, KProperty1, function (receiver) {
    return receiver.h95();
  }, null);
}
function glGetShaderSource$factory() {
  return getPropertyCallableRef('glGetShaderSource', 1, KProperty1, function (receiver) {
    return receiver.i95();
  }, null);
}
function glGetUniformfv$factory() {
  return getPropertyCallableRef('glGetUniformfv', 1, KProperty1, function (receiver) {
    return receiver.j95();
  }, null);
}
function glGetUniformiv$factory() {
  return getPropertyCallableRef('glGetUniformiv', 1, KProperty1, function (receiver) {
    return receiver.k95();
  }, null);
}
function glGetVertexAttribfv$factory() {
  return getPropertyCallableRef('glGetVertexAttribfv', 1, KProperty1, function (receiver) {
    return receiver.l95();
  }, null);
}
function glGetVertexAttribiv$factory() {
  return getPropertyCallableRef('glGetVertexAttribiv', 1, KProperty1, function (receiver) {
    return receiver.m95();
  }, null);
}
function glGetVertexAttribPointerv$factory() {
  return getPropertyCallableRef('glGetVertexAttribPointerv', 1, KProperty1, function (receiver) {
    return receiver.n95();
  }, null);
}
function glIsBuffer$factory() {
  return getPropertyCallableRef('glIsBuffer', 1, KProperty1, function (receiver) {
    return receiver.o95();
  }, null);
}
function glIsFramebuffer$factory() {
  return getPropertyCallableRef('glIsFramebuffer', 1, KProperty1, function (receiver) {
    return receiver.p95();
  }, null);
}
function glIsProgram$factory() {
  return getPropertyCallableRef('glIsProgram', 1, KProperty1, function (receiver) {
    return receiver.q95();
  }, null);
}
function glIsRenderbuffer$factory() {
  return getPropertyCallableRef('glIsRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.r95();
  }, null);
}
function glIsTexture$factory() {
  return getPropertyCallableRef('glIsTexture', 1, KProperty1, function (receiver) {
    return receiver.s95();
  }, null);
}
function glIsShader$factory() {
  return getPropertyCallableRef('glIsShader', 1, KProperty1, function (receiver) {
    return receiver.t95();
  }, null);
}
function glLinkProgram$factory() {
  return getPropertyCallableRef('glLinkProgram', 1, KProperty1, function (receiver) {
    return receiver.n92();
  }, null);
}
function glReleaseShaderCompiler$factory() {
  return getPropertyCallableRef('glReleaseShaderCompiler', 1, KProperty1, function (receiver) {
    return receiver.u95();
  }, null);
}
function glRenderbufferStorage$factory() {
  return getPropertyCallableRef('glRenderbufferStorage', 1, KProperty1, function (receiver) {
    return receiver.p92();
  }, null);
}
function glSampleCoverage$factory() {
  return getPropertyCallableRef('glSampleCoverage', 1, KProperty1, function (receiver) {
    return receiver.v95();
  }, null);
}
function glShaderBinary$factory() {
  return getPropertyCallableRef('glShaderBinary', 1, KProperty1, function (receiver) {
    return receiver.w95();
  }, null);
}
function glShaderSource$factory() {
  return getPropertyCallableRef('glShaderSource', 1, KProperty1, function (receiver) {
    return receiver.r92();
  }, null);
}
function glStencilFuncSeparate$factory() {
  return getPropertyCallableRef('glStencilFuncSeparate', 1, KProperty1, function (receiver) {
    return receiver.t92();
  }, null);
}
function glStencilMaskSeparate$factory() {
  return getPropertyCallableRef('glStencilMaskSeparate', 1, KProperty1, function (receiver) {
    return receiver.v92();
  }, null);
}
function glStencilOpSeparate$factory() {
  return getPropertyCallableRef('glStencilOpSeparate', 1, KProperty1, function (receiver) {
    return receiver.x92();
  }, null);
}
function glUniform1f$factory() {
  return getPropertyCallableRef('glUniform1f', 1, KProperty1, function (receiver) {
    return receiver.x95();
  }, null);
}
function glUniform2f$factory() {
  return getPropertyCallableRef('glUniform2f', 1, KProperty1, function (receiver) {
    return receiver.y95();
  }, null);
}
function glUniform3f$factory() {
  return getPropertyCallableRef('glUniform3f', 1, KProperty1, function (receiver) {
    return receiver.z95();
  }, null);
}
function glUniform4f$factory() {
  return getPropertyCallableRef('glUniform4f', 1, KProperty1, function (receiver) {
    return receiver.a96();
  }, null);
}
function glUniform1i$factory() {
  return getPropertyCallableRef('glUniform1i', 1, KProperty1, function (receiver) {
    return receiver.b93();
  }, null);
}
function glUniform2i$factory() {
  return getPropertyCallableRef('glUniform2i', 1, KProperty1, function (receiver) {
    return receiver.b96();
  }, null);
}
function glUniform3i$factory() {
  return getPropertyCallableRef('glUniform3i', 1, KProperty1, function (receiver) {
    return receiver.c96();
  }, null);
}
function glUniform4i$factory() {
  return getPropertyCallableRef('glUniform4i', 1, KProperty1, function (receiver) {
    return receiver.d96();
  }, null);
}
function glUniform1fv$factory() {
  return getPropertyCallableRef('glUniform1fv', 1, KProperty1, function (receiver) {
    return receiver.a93();
  }, null);
}
function glUniform2fv$factory() {
  return getPropertyCallableRef('glUniform2fv', 1, KProperty1, function (receiver) {
    return receiver.d93();
  }, null);
}
function glUniform3fv$factory() {
  return getPropertyCallableRef('glUniform3fv', 1, KProperty1, function (receiver) {
    return receiver.f93();
  }, null);
}
function glUniform4fv$factory() {
  return getPropertyCallableRef('glUniform4fv', 1, KProperty1, function (receiver) {
    return receiver.h93();
  }, null);
}
function glUniform1iv$factory() {
  return getPropertyCallableRef('glUniform1iv', 1, KProperty1, function (receiver) {
    return receiver.c93();
  }, null);
}
function glUniform2iv$factory() {
  return getPropertyCallableRef('glUniform2iv', 1, KProperty1, function (receiver) {
    return receiver.e93();
  }, null);
}
function glUniform3iv$factory() {
  return getPropertyCallableRef('glUniform3iv', 1, KProperty1, function (receiver) {
    return receiver.g93();
  }, null);
}
function glUniform4iv$factory() {
  return getPropertyCallableRef('glUniform4iv', 1, KProperty1, function (receiver) {
    return receiver.i93();
  }, null);
}
function glUniformMatrix2fv$factory() {
  return getPropertyCallableRef('glUniformMatrix2fv', 1, KProperty1, function (receiver) {
    return receiver.j93();
  }, null);
}
function glUniformMatrix3fv$factory() {
  return getPropertyCallableRef('glUniformMatrix3fv', 1, KProperty1, function (receiver) {
    return receiver.k93();
  }, null);
}
function glUniformMatrix4fv$factory() {
  return getPropertyCallableRef('glUniformMatrix4fv', 1, KProperty1, function (receiver) {
    return receiver.l93();
  }, null);
}
function glUseProgram$factory() {
  return getPropertyCallableRef('glUseProgram', 1, KProperty1, function (receiver) {
    return receiver.m93();
  }, null);
}
function glValidateProgram$factory() {
  return getPropertyCallableRef('glValidateProgram', 1, KProperty1, function (receiver) {
    return receiver.e96();
  }, null);
}
function glVertexAttrib1f$factory() {
  return getPropertyCallableRef('glVertexAttrib1f', 1, KProperty1, function (receiver) {
    return receiver.f96();
  }, null);
}
function glVertexAttrib2f$factory() {
  return getPropertyCallableRef('glVertexAttrib2f', 1, KProperty1, function (receiver) {
    return receiver.g96();
  }, null);
}
function glVertexAttrib3f$factory() {
  return getPropertyCallableRef('glVertexAttrib3f', 1, KProperty1, function (receiver) {
    return receiver.h96();
  }, null);
}
function glVertexAttrib4f$factory() {
  return getPropertyCallableRef('glVertexAttrib4f', 1, KProperty1, function (receiver) {
    return receiver.i96();
  }, null);
}
function glVertexAttrib1fv$factory() {
  return getPropertyCallableRef('glVertexAttrib1fv', 1, KProperty1, function (receiver) {
    return receiver.j96();
  }, null);
}
function glVertexAttrib2fv$factory() {
  return getPropertyCallableRef('glVertexAttrib2fv', 1, KProperty1, function (receiver) {
    return receiver.k96();
  }, null);
}
function glVertexAttrib3fv$factory() {
  return getPropertyCallableRef('glVertexAttrib3fv', 1, KProperty1, function (receiver) {
    return receiver.l96();
  }, null);
}
function glBindBufferRange$factory() {
  return getPropertyCallableRef('glBindBufferRange', 1, KProperty1, function (receiver) {
    return receiver.s93();
  }, null);
}
function glGetUniformBlockIndex$factory() {
  return getPropertyCallableRef('glGetUniformBlockIndex', 1, KProperty1, function (receiver) {
    return receiver.t93();
  }, null);
}
function glUniformBlockBinding$factory() {
  return getPropertyCallableRef('glUniformBlockBinding', 1, KProperty1, function (receiver) {
    return receiver.u93();
  }, null);
}
function glGenVertexArrays$factory() {
  return getPropertyCallableRef('glGenVertexArrays', 1, KProperty1, function (receiver) {
    return receiver.v93();
  }, null);
}
function glDeleteVertexArrays$factory() {
  return getPropertyCallableRef('glDeleteVertexArrays', 1, KProperty1, function (receiver) {
    return receiver.m96();
  }, null);
}
function glBindVertexArray$factory() {
  return getPropertyCallableRef('glBindVertexArray', 1, KProperty1, function (receiver) {
    return receiver.w93();
  }, null);
}
function glDrawArraysInstanced$factory_0() {
  return getPropertyCallableRef('glDrawArraysInstanced', 1, KProperty1, function (receiver) {
    return receiver.p93();
  }, null);
}
function glDrawElementsInstanced$factory_0() {
  return getPropertyCallableRef('glDrawElementsInstanced', 1, KProperty1, function (receiver) {
    return receiver.q93();
  }, null);
}
function glVertexAttribDivisor$factory_0() {
  return getPropertyCallableRef('glVertexAttribDivisor', 1, KProperty1, function (receiver) {
    return receiver.r93();
  }, null);
}
function glTexSubImage2D$factory_0() {
  return getPropertyCallableRef('glTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.y93();
  }, null);
}
function glTexImage2D$factory_0() {
  return getPropertyCallableRef('glTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.y92();
  }, null);
}
function glTexParameteri$factory_0() {
  return getPropertyCallableRef('glTexParameteri', 1, KProperty1, function (receiver) {
    return receiver.z92();
  }, null);
}
function glTexParameterf$factory_0() {
  return getPropertyCallableRef('glTexParameterf', 1, KProperty1, function (receiver) {
    return receiver.z93();
  }, null);
}
function glTexParameterfv$factory_0() {
  return getPropertyCallableRef('glTexParameterfv', 1, KProperty1, function (receiver) {
    return receiver.a94();
  }, null);
}
function glTexParameteriv$factory_0() {
  return getPropertyCallableRef('glTexParameteriv', 1, KProperty1, function (receiver) {
    return receiver.b94();
  }, null);
}
function glStencilOp$factory_0() {
  return getPropertyCallableRef('glStencilOp', 1, KProperty1, function (receiver) {
    return receiver.w92();
  }, null);
}
function glStencilMask$factory_0() {
  return getPropertyCallableRef('glStencilMask', 1, KProperty1, function (receiver) {
    return receiver.u92();
  }, null);
}
function glReadPixels$factory_0() {
  return getPropertyCallableRef('glReadPixels', 1, KProperty1, function (receiver) {
    return receiver.c94();
  }, null);
}
function glStencilFunc$factory_0() {
  return getPropertyCallableRef('glStencilFunc', 1, KProperty1, function (receiver) {
    return receiver.s92();
  }, null);
}
function glScissor$factory_0() {
  return getPropertyCallableRef('glScissor', 1, KProperty1, function (receiver) {
    return receiver.q92();
  }, null);
}
function glPolygonOffset$factory_0() {
  return getPropertyCallableRef('glPolygonOffset', 1, KProperty1, function (receiver) {
    return receiver.d94();
  }, null);
}
function glPixelStorei$factory_0() {
  return getPropertyCallableRef('glPixelStorei', 1, KProperty1, function (receiver) {
    return receiver.o92();
  }, null);
}
function glLineWidth$factory_0() {
  return getPropertyCallableRef('glLineWidth', 1, KProperty1, function (receiver) {
    return receiver.e94();
  }, null);
}
function glGetTexParameterfv$factory_0() {
  return getPropertyCallableRef('glGetTexParameterfv', 1, KProperty1, function (receiver) {
    return receiver.f94();
  }, null);
}
function glGetTexParameteriv$factory_0() {
  return getPropertyCallableRef('glGetTexParameteriv', 1, KProperty1, function (receiver) {
    return receiver.g94();
  }, null);
}
function glGetError$factory_0() {
  return getPropertyCallableRef('glGetError', 1, KProperty1, function (receiver) {
    return receiver.h92();
  }, null);
}
function glGetFloatv$factory_0() {
  return getPropertyCallableRef('glGetFloatv', 1, KProperty1, function (receiver) {
    return receiver.h94();
  }, null);
}
function glGetIntegerv$factory_0() {
  return getPropertyCallableRef('glGetIntegerv', 1, KProperty1, function (receiver) {
    return receiver.i92();
  }, null);
}
function glGetBooleanv$factory_0() {
  return getPropertyCallableRef('glGetBooleanv', 1, KProperty1, function (receiver) {
    return receiver.i94();
  }, null);
}
function glGenTextures$factory_0() {
  return getPropertyCallableRef('glGenTextures', 1, KProperty1, function (receiver) {
    return receiver.f92();
  }, null);
}
function glDepthRange$factory_0() {
  return getPropertyCallableRef('glDepthRange', 1, KProperty1, function (receiver) {
    return receiver.j94();
  }, null);
}
function glDepthRangef$factory_0() {
  return getPropertyCallableRef('glDepthRangef', 1, KProperty1, function (receiver) {
    return receiver.q91();
  }, null);
}
function glClearDepth$factory_0() {
  return getPropertyCallableRef('glClearDepth', 1, KProperty1, function (receiver) {
    return receiver.k94();
  }, null);
}
function glClearDepthf$factory_0() {
  return getPropertyCallableRef('glClearDepthf', 1, KProperty1, function (receiver) {
    return receiver.b91();
  }, null);
}
function glDrawArrays$factory_0() {
  return getPropertyCallableRef('glDrawArrays', 1, KProperty1, function (receiver) {
    return receiver.t91();
  }, null);
}
function glDrawElements$factory_0() {
  return getPropertyCallableRef('glDrawElements', 1, KProperty1, function (receiver) {
    return receiver.u91();
  }, null);
}
function glFrontFace$factory_0() {
  return getPropertyCallableRef('glFrontFace', 1, KProperty1, function (receiver) {
    return receiver.a92();
  }, null);
}
function glFinish$factory_0() {
  return getPropertyCallableRef('glFinish', 1, KProperty1, function (receiver) {
    return receiver.l94();
  }, null);
}
function glFlush$factory_0() {
  return getPropertyCallableRef('glFlush', 1, KProperty1, function (receiver) {
    return receiver.x91();
  }, null);
}
function glEnable$factory_0() {
  return getPropertyCallableRef('glEnable', 1, KProperty1, function (receiver) {
    return receiver.v91();
  }, null);
}
function glIsEnabled$factory_0() {
  return getPropertyCallableRef('glIsEnabled', 1, KProperty1, function (receiver) {
    return receiver.m94();
  }, null);
}
function glDisable$factory_0() {
  return getPropertyCallableRef('glDisable', 1, KProperty1, function (receiver) {
    return receiver.r91();
  }, null);
}
function glDepthMask$factory_0() {
  return getPropertyCallableRef('glDepthMask', 1, KProperty1, function (receiver) {
    return receiver.p91();
  }, null);
}
function glDepthFunc$factory_0() {
  return getPropertyCallableRef('glDepthFunc', 1, KProperty1, function (receiver) {
    return receiver.o91();
  }, null);
}
function glDeleteTextures$factory_0() {
  return getPropertyCallableRef('glDeleteTextures', 1, KProperty1, function (receiver) {
    return receiver.n91();
  }, null);
}
function glCullFace$factory_0() {
  return getPropertyCallableRef('glCullFace', 1, KProperty1, function (receiver) {
    return receiver.h91();
  }, null);
}
function glCopyTexImage2D$factory_0() {
  return getPropertyCallableRef('glCopyTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.n94();
  }, null);
}
function glCopyTexSubImage2D$factory_0() {
  return getPropertyCallableRef('glCopyTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.o94();
  }, null);
}
function glColorMask$factory_0() {
  return getPropertyCallableRef('glColorMask', 1, KProperty1, function (receiver) {
    return receiver.d91();
  }, null);
}
function glClearStencil$factory_0() {
  return getPropertyCallableRef('glClearStencil', 1, KProperty1, function (receiver) {
    return receiver.c91();
  }, null);
}
function glClearColor$factory_0() {
  return getPropertyCallableRef('glClearColor', 1, KProperty1, function (receiver) {
    return receiver.a91();
  }, null);
}
function glClear$factory_0() {
  return getPropertyCallableRef('glClear', 1, KProperty1, function (receiver) {
    return receiver.z90();
  }, null);
}
function glBindTexture$factory_0() {
  return getPropertyCallableRef('glBindTexture', 1, KProperty1, function (receiver) {
    return receiver.u90();
  }, null);
}
function glHint$factory_0() {
  return getPropertyCallableRef('glHint', 1, KProperty1, function (receiver) {
    return receiver.p94();
  }, null);
}
function glViewport$factory_0() {
  return getPropertyCallableRef('glViewport', 1, KProperty1, function (receiver) {
    return receiver.o93();
  }, null);
}
function glGetString$factory_0() {
  return getPropertyCallableRef('glGetString', 1, KProperty1, function (receiver) {
    return receiver.m92();
  }, null);
}
function glGetStringi$factory_0() {
  return getPropertyCallableRef('glGetStringi', 1, KProperty1, function (receiver) {
    return receiver.q94();
  }, null);
}
function glVertexAttribPointer$factory_0() {
  return getPropertyCallableRef('glVertexAttribPointer', 1, KProperty1, function (receiver) {
    return receiver.n93();
  }, null);
}
function glVertexAttrib4fv$factory_0() {
  return getPropertyCallableRef('glVertexAttrib4fv', 1, KProperty1, function (receiver) {
    return receiver.r94();
  }, null);
}
function glActiveTexture$factory_0() {
  return getPropertyCallableRef('glActiveTexture', 1, KProperty1, function (receiver) {
    return receiver.o90();
  }, null);
}
function glAttachShader$factory_0() {
  return getPropertyCallableRef('glAttachShader', 1, KProperty1, function (receiver) {
    return receiver.p90();
  }, null);
}
function glBindAttribLocation$factory_0() {
  return getPropertyCallableRef('glBindAttribLocation', 1, KProperty1, function (receiver) {
    return receiver.q90();
  }, null);
}
function glBindBuffer$factory_0() {
  return getPropertyCallableRef('glBindBuffer', 1, KProperty1, function (receiver) {
    return receiver.r90();
  }, null);
}
function glBindFramebuffer$factory_0() {
  return getPropertyCallableRef('glBindFramebuffer', 1, KProperty1, function (receiver) {
    return receiver.s90();
  }, null);
}
function glBindRenderbuffer$factory_0() {
  return getPropertyCallableRef('glBindRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.t90();
  }, null);
}
function glBlendColor$factory_0() {
  return getPropertyCallableRef('glBlendColor', 1, KProperty1, function (receiver) {
    return receiver.s94();
  }, null);
}
function glBlendEquation$factory_0() {
  return getPropertyCallableRef('glBlendEquation', 1, KProperty1, function (receiver) {
    return receiver.t94();
  }, null);
}
function glBlendEquationSeparate$factory_0() {
  return getPropertyCallableRef('glBlendEquationSeparate', 1, KProperty1, function (receiver) {
    return receiver.v90();
  }, null);
}
function glBlendFunc$factory_0() {
  return getPropertyCallableRef('glBlendFunc', 1, KProperty1, function (receiver) {
    return receiver.u94();
  }, null);
}
function glBlendFuncSeparate$factory_0() {
  return getPropertyCallableRef('glBlendFuncSeparate', 1, KProperty1, function (receiver) {
    return receiver.w90();
  }, null);
}
function glBufferData$factory_0() {
  return getPropertyCallableRef('glBufferData', 1, KProperty1, function (receiver) {
    return receiver.x90();
  }, null);
}
function glBufferSubData$factory_0() {
  return getPropertyCallableRef('glBufferSubData', 1, KProperty1, function (receiver) {
    return receiver.y90();
  }, null);
}
function glCheckFramebufferStatus$factory_0() {
  return getPropertyCallableRef('glCheckFramebufferStatus', 1, KProperty1, function (receiver) {
    return receiver.v94();
  }, null);
}
function glCompileShader$factory_0() {
  return getPropertyCallableRef('glCompileShader', 1, KProperty1, function (receiver) {
    return receiver.e91();
  }, null);
}
function glCompressedTexImage2D$factory_0() {
  return getPropertyCallableRef('glCompressedTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.w94();
  }, null);
}
function glCompressedTexSubImage2D$factory_0() {
  return getPropertyCallableRef('glCompressedTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.x94();
  }, null);
}
function glCreateProgram$factory_0() {
  return getPropertyCallableRef('glCreateProgram', 1, KProperty1, function (receiver) {
    return receiver.f91();
  }, null);
}
function glCreateShader$factory_0() {
  return getPropertyCallableRef('glCreateShader', 1, KProperty1, function (receiver) {
    return receiver.g91();
  }, null);
}
function glDeleteBuffers$factory_0() {
  return getPropertyCallableRef('glDeleteBuffers', 1, KProperty1, function (receiver) {
    return receiver.i91();
  }, null);
}
function glDeleteFramebuffers$factory_0() {
  return getPropertyCallableRef('glDeleteFramebuffers', 1, KProperty1, function (receiver) {
    return receiver.j91();
  }, null);
}
function glDeleteProgram$factory_0() {
  return getPropertyCallableRef('glDeleteProgram', 1, KProperty1, function (receiver) {
    return receiver.k91();
  }, null);
}
function glDeleteRenderbuffers$factory_0() {
  return getPropertyCallableRef('glDeleteRenderbuffers', 1, KProperty1, function (receiver) {
    return receiver.l91();
  }, null);
}
function glDeleteShader$factory_0() {
  return getPropertyCallableRef('glDeleteShader', 1, KProperty1, function (receiver) {
    return receiver.m91();
  }, null);
}
function glDetachShader$factory_0() {
  return getPropertyCallableRef('glDetachShader', 1, KProperty1, function (receiver) {
    return receiver.y94();
  }, null);
}
function glDisableVertexAttribArray$factory_0() {
  return getPropertyCallableRef('glDisableVertexAttribArray', 1, KProperty1, function (receiver) {
    return receiver.s91();
  }, null);
}
function glEnableVertexAttribArray$factory_0() {
  return getPropertyCallableRef('glEnableVertexAttribArray', 1, KProperty1, function (receiver) {
    return receiver.w91();
  }, null);
}
function glFramebufferRenderbuffer$factory_0() {
  return getPropertyCallableRef('glFramebufferRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.y91();
  }, null);
}
function glFramebufferTexture2D$factory_0() {
  return getPropertyCallableRef('glFramebufferTexture2D', 1, KProperty1, function (receiver) {
    return receiver.z91();
  }, null);
}
function glGenBuffers$factory_0() {
  return getPropertyCallableRef('glGenBuffers', 1, KProperty1, function (receiver) {
    return receiver.b92();
  }, null);
}
function glGenerateMipmap$factory_0() {
  return getPropertyCallableRef('glGenerateMipmap', 1, KProperty1, function (receiver) {
    return receiver.c92();
  }, null);
}
function glGenFramebuffers$factory_0() {
  return getPropertyCallableRef('glGenFramebuffers', 1, KProperty1, function (receiver) {
    return receiver.d92();
  }, null);
}
function glGenRenderbuffers$factory_0() {
  return getPropertyCallableRef('glGenRenderbuffers', 1, KProperty1, function (receiver) {
    return receiver.e92();
  }, null);
}
function glGetActiveAttrib$factory_0() {
  return getPropertyCallableRef('glGetActiveAttrib', 1, KProperty1, function (receiver) {
    return receiver.z94();
  }, null);
}
function glGetActiveUniform$factory_0() {
  return getPropertyCallableRef('glGetActiveUniform', 1, KProperty1, function (receiver) {
    return receiver.a95();
  }, null);
}
function glGetAttachedShaders$factory_0() {
  return getPropertyCallableRef('glGetAttachedShaders', 1, KProperty1, function (receiver) {
    return receiver.b95();
  }, null);
}
function glGetAttribLocation$factory_0() {
  return getPropertyCallableRef('glGetAttribLocation', 1, KProperty1, function (receiver) {
    return receiver.c95();
  }, null);
}
function glGetUniformLocation$factory_0() {
  return getPropertyCallableRef('glGetUniformLocation', 1, KProperty1, function (receiver) {
    return receiver.g92();
  }, null);
}
function glGetBufferParameteriv$factory_0() {
  return getPropertyCallableRef('glGetBufferParameteriv', 1, KProperty1, function (receiver) {
    return receiver.d95();
  }, null);
}
function glGetFramebufferAttachmentParameteriv$factory_0() {
  return getPropertyCallableRef('glGetFramebufferAttachmentParameteriv', 1, KProperty1, function (receiver) {
    return receiver.e95();
  }, null);
}
function glGetProgramInfoLog$factory_0() {
  return getPropertyCallableRef('glGetProgramInfoLog', 1, KProperty1, function (receiver) {
    return receiver.f95();
  }, null);
}
function glGetRenderbufferParameteriv$factory_0() {
  return getPropertyCallableRef('glGetRenderbufferParameteriv', 1, KProperty1, function (receiver) {
    return receiver.g95();
  }, null);
}
function glGetProgramiv$factory_0() {
  return getPropertyCallableRef('glGetProgramiv', 1, KProperty1, function (receiver) {
    return receiver.j92();
  }, null);
}
function glGetShaderiv$factory_0() {
  return getPropertyCallableRef('glGetShaderiv', 1, KProperty1, function (receiver) {
    return receiver.k92();
  }, null);
}
function glGetShaderInfoLog$factory_0() {
  return getPropertyCallableRef('glGetShaderInfoLog', 1, KProperty1, function (receiver) {
    return receiver.l92();
  }, null);
}
function glGetShaderPrecisionFormat$factory_0() {
  return getPropertyCallableRef('glGetShaderPrecisionFormat', 1, KProperty1, function (receiver) {
    return receiver.h95();
  }, null);
}
function glGetShaderSource$factory_0() {
  return getPropertyCallableRef('glGetShaderSource', 1, KProperty1, function (receiver) {
    return receiver.i95();
  }, null);
}
function glGetUniformfv$factory_0() {
  return getPropertyCallableRef('glGetUniformfv', 1, KProperty1, function (receiver) {
    return receiver.j95();
  }, null);
}
function glGetUniformiv$factory_0() {
  return getPropertyCallableRef('glGetUniformiv', 1, KProperty1, function (receiver) {
    return receiver.k95();
  }, null);
}
function glGetVertexAttribfv$factory_0() {
  return getPropertyCallableRef('glGetVertexAttribfv', 1, KProperty1, function (receiver) {
    return receiver.l95();
  }, null);
}
function glGetVertexAttribiv$factory_0() {
  return getPropertyCallableRef('glGetVertexAttribiv', 1, KProperty1, function (receiver) {
    return receiver.m95();
  }, null);
}
function glGetVertexAttribPointerv$factory_0() {
  return getPropertyCallableRef('glGetVertexAttribPointerv', 1, KProperty1, function (receiver) {
    return receiver.n95();
  }, null);
}
function glIsBuffer$factory_0() {
  return getPropertyCallableRef('glIsBuffer', 1, KProperty1, function (receiver) {
    return receiver.o95();
  }, null);
}
function glIsFramebuffer$factory_0() {
  return getPropertyCallableRef('glIsFramebuffer', 1, KProperty1, function (receiver) {
    return receiver.p95();
  }, null);
}
function glIsProgram$factory_0() {
  return getPropertyCallableRef('glIsProgram', 1, KProperty1, function (receiver) {
    return receiver.q95();
  }, null);
}
function glIsRenderbuffer$factory_0() {
  return getPropertyCallableRef('glIsRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.r95();
  }, null);
}
function glIsTexture$factory_0() {
  return getPropertyCallableRef('glIsTexture', 1, KProperty1, function (receiver) {
    return receiver.s95();
  }, null);
}
function glIsShader$factory_0() {
  return getPropertyCallableRef('glIsShader', 1, KProperty1, function (receiver) {
    return receiver.t95();
  }, null);
}
function glLinkProgram$factory_0() {
  return getPropertyCallableRef('glLinkProgram', 1, KProperty1, function (receiver) {
    return receiver.n92();
  }, null);
}
function glReleaseShaderCompiler$factory_0() {
  return getPropertyCallableRef('glReleaseShaderCompiler', 1, KProperty1, function (receiver) {
    return receiver.u95();
  }, null);
}
function glRenderbufferStorage$factory_0() {
  return getPropertyCallableRef('glRenderbufferStorage', 1, KProperty1, function (receiver) {
    return receiver.p92();
  }, null);
}
function glSampleCoverage$factory_0() {
  return getPropertyCallableRef('glSampleCoverage', 1, KProperty1, function (receiver) {
    return receiver.v95();
  }, null);
}
function glShaderBinary$factory_0() {
  return getPropertyCallableRef('glShaderBinary', 1, KProperty1, function (receiver) {
    return receiver.w95();
  }, null);
}
function glShaderSource$factory_0() {
  return getPropertyCallableRef('glShaderSource', 1, KProperty1, function (receiver) {
    return receiver.r92();
  }, null);
}
function glStencilFuncSeparate$factory_0() {
  return getPropertyCallableRef('glStencilFuncSeparate', 1, KProperty1, function (receiver) {
    return receiver.t92();
  }, null);
}
function glStencilMaskSeparate$factory_0() {
  return getPropertyCallableRef('glStencilMaskSeparate', 1, KProperty1, function (receiver) {
    return receiver.v92();
  }, null);
}
function glStencilOpSeparate$factory_0() {
  return getPropertyCallableRef('glStencilOpSeparate', 1, KProperty1, function (receiver) {
    return receiver.x92();
  }, null);
}
function glUniform1f$factory_0() {
  return getPropertyCallableRef('glUniform1f', 1, KProperty1, function (receiver) {
    return receiver.x95();
  }, null);
}
function glUniform2f$factory_0() {
  return getPropertyCallableRef('glUniform2f', 1, KProperty1, function (receiver) {
    return receiver.y95();
  }, null);
}
function glUniform3f$factory_0() {
  return getPropertyCallableRef('glUniform3f', 1, KProperty1, function (receiver) {
    return receiver.z95();
  }, null);
}
function glUniform4f$factory_0() {
  return getPropertyCallableRef('glUniform4f', 1, KProperty1, function (receiver) {
    return receiver.a96();
  }, null);
}
function glUniform1i$factory_0() {
  return getPropertyCallableRef('glUniform1i', 1, KProperty1, function (receiver) {
    return receiver.b93();
  }, null);
}
function glUniform2i$factory_0() {
  return getPropertyCallableRef('glUniform2i', 1, KProperty1, function (receiver) {
    return receiver.b96();
  }, null);
}
function glUniform3i$factory_0() {
  return getPropertyCallableRef('glUniform3i', 1, KProperty1, function (receiver) {
    return receiver.c96();
  }, null);
}
function glUniform4i$factory_0() {
  return getPropertyCallableRef('glUniform4i', 1, KProperty1, function (receiver) {
    return receiver.d96();
  }, null);
}
function glUniform1fv$factory_0() {
  return getPropertyCallableRef('glUniform1fv', 1, KProperty1, function (receiver) {
    return receiver.a93();
  }, null);
}
function glUniform2fv$factory_0() {
  return getPropertyCallableRef('glUniform2fv', 1, KProperty1, function (receiver) {
    return receiver.d93();
  }, null);
}
function glUniform3fv$factory_0() {
  return getPropertyCallableRef('glUniform3fv', 1, KProperty1, function (receiver) {
    return receiver.f93();
  }, null);
}
function glUniform4fv$factory_0() {
  return getPropertyCallableRef('glUniform4fv', 1, KProperty1, function (receiver) {
    return receiver.h93();
  }, null);
}
function glUniform1iv$factory_0() {
  return getPropertyCallableRef('glUniform1iv', 1, KProperty1, function (receiver) {
    return receiver.c93();
  }, null);
}
function glUniform2iv$factory_0() {
  return getPropertyCallableRef('glUniform2iv', 1, KProperty1, function (receiver) {
    return receiver.e93();
  }, null);
}
function glUniform3iv$factory_0() {
  return getPropertyCallableRef('glUniform3iv', 1, KProperty1, function (receiver) {
    return receiver.g93();
  }, null);
}
function glUniform4iv$factory_0() {
  return getPropertyCallableRef('glUniform4iv', 1, KProperty1, function (receiver) {
    return receiver.i93();
  }, null);
}
function glUniformMatrix2fv$factory_0() {
  return getPropertyCallableRef('glUniformMatrix2fv', 1, KProperty1, function (receiver) {
    return receiver.j93();
  }, null);
}
function glUniformMatrix3fv$factory_0() {
  return getPropertyCallableRef('glUniformMatrix3fv', 1, KProperty1, function (receiver) {
    return receiver.k93();
  }, null);
}
function glUniformMatrix4fv$factory_0() {
  return getPropertyCallableRef('glUniformMatrix4fv', 1, KProperty1, function (receiver) {
    return receiver.l93();
  }, null);
}
function glUseProgram$factory_0() {
  return getPropertyCallableRef('glUseProgram', 1, KProperty1, function (receiver) {
    return receiver.m93();
  }, null);
}
function glValidateProgram$factory_0() {
  return getPropertyCallableRef('glValidateProgram', 1, KProperty1, function (receiver) {
    return receiver.e96();
  }, null);
}
function glVertexAttrib1f$factory_0() {
  return getPropertyCallableRef('glVertexAttrib1f', 1, KProperty1, function (receiver) {
    return receiver.f96();
  }, null);
}
function glVertexAttrib2f$factory_0() {
  return getPropertyCallableRef('glVertexAttrib2f', 1, KProperty1, function (receiver) {
    return receiver.g96();
  }, null);
}
function glVertexAttrib3f$factory_0() {
  return getPropertyCallableRef('glVertexAttrib3f', 1, KProperty1, function (receiver) {
    return receiver.h96();
  }, null);
}
function glVertexAttrib4f$factory_0() {
  return getPropertyCallableRef('glVertexAttrib4f', 1, KProperty1, function (receiver) {
    return receiver.i96();
  }, null);
}
function glVertexAttrib1fv$factory_0() {
  return getPropertyCallableRef('glVertexAttrib1fv', 1, KProperty1, function (receiver) {
    return receiver.j96();
  }, null);
}
function glVertexAttrib2fv$factory_0() {
  return getPropertyCallableRef('glVertexAttrib2fv', 1, KProperty1, function (receiver) {
    return receiver.k96();
  }, null);
}
function glVertexAttrib3fv$factory_0() {
  return getPropertyCallableRef('glVertexAttrib3fv', 1, KProperty1, function (receiver) {
    return receiver.l96();
  }, null);
}
function glBindBufferRange$factory_0() {
  return getPropertyCallableRef('glBindBufferRange', 1, KProperty1, function (receiver) {
    return receiver.s93();
  }, null);
}
function glGetUniformBlockIndex$factory_0() {
  return getPropertyCallableRef('glGetUniformBlockIndex', 1, KProperty1, function (receiver) {
    return receiver.t93();
  }, null);
}
function glUniformBlockBinding$factory_0() {
  return getPropertyCallableRef('glUniformBlockBinding', 1, KProperty1, function (receiver) {
    return receiver.u93();
  }, null);
}
function glGenVertexArrays$factory_0() {
  return getPropertyCallableRef('glGenVertexArrays', 1, KProperty1, function (receiver) {
    return receiver.v93();
  }, null);
}
function glDeleteVertexArrays$factory_0() {
  return getPropertyCallableRef('glDeleteVertexArrays', 1, KProperty1, function (receiver) {
    return receiver.m96();
  }, null);
}
function glBindVertexArray$factory_0() {
  return getPropertyCallableRef('glBindVertexArray', 1, KProperty1, function (receiver) {
    return receiver.w93();
  }, null);
}
var properties_initialized_SDL_kt_s4ko39;
function _init_properties_SDL_kt__pqu7sn() {
  if (!properties_initialized_SDL_kt_s4ko39) {
    properties_initialized_SDL_kt_s4ko39 = true;
    SDLPath$delegate = lazy(SDLPath$delegate$lambda);
  }
}
var AGOpenglFactory_instance;
function AGOpenglFactory_getInstance() {
  return AGOpenglFactory_instance;
}
function get_korgwCanvasQuery() {
  _init_properties_GlExt_kt__oxmdm();
  // Inline function 'kotlin.getValue' call
  var this_0 = korgwCanvasQuery$delegate;
  korgwCanvasQuery$factory();
  return this_0.s1();
}
var korgwCanvasQuery$delegate;
function jsObject(pairs) {
  _init_properties_GlExt_kt__oxmdm();
  var out = jsEmptyObject();
  var inductionVariable = 0;
  var last = pairs.length;
  while (inductionVariable < last) {
    var _destruct__k2r9zo = pairs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var k = _destruct__k2r9zo.nl();
    var v = _destruct__k2r9zo.ol();
    if (!(v == null)) {
      out[k] = v;
    }
  }
  return out;
}
function jsEmptyObject() {
  _init_properties_GlExt_kt__oxmdm();
  return {};
}
function AGDefaultCanvas() {
  _init_properties_GlExt_kt__oxmdm();
  var tmp0_safe_receiver = get_korgwCanvasQuery();
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.gl.AGDefaultCanvas.<anonymous>' call
    var tmp_0 = document.querySelector(tmp0_safe_receiver);
    tmp = tmp_0 instanceof HTMLCanvasElement ? tmp_0 : THROW_CCE();
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    var tmp_2 = document.createElement('canvas');
    tmp_1 = tmp_2 instanceof HTMLCanvasElement ? tmp_2 : THROW_CCE();
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  return tmp_1;
}
function AGWebgl(config, canvas) {
  canvas = canvas === VOID ? AGDefaultCanvas() : canvas;
  _init_properties_GlExt_kt__oxmdm();
  // Inline function 'kotlin.also' call
  var this_0 = AGOpengl.g7d(new KmlGlJsCanvas(canvas, jsObject([to('premultipliedAlpha', false), to('alpha', false), to('stencil', true), to('antialias', config.m71_1)])));
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.graphics.gl.AGWebgl.<anonymous>' call
  // Inline function 'kotlin.js.asDynamic' call
  window.ag = this_0;
  canvas.addEventListener('webglcontextlost', AGWebgl$lambda, false);
  canvas.addEventListener('webglcontextrestored', AGWebgl$lambda_0(this_0), false);
  return this_0;
}
function get_isCanvasCreatedAndHandled() {
  _init_properties_GlExt_kt__oxmdm();
  return get_korgwCanvasQuery() == null;
}
function korgwCanvasQuery$delegate$lambda() {
  _init_properties_GlExt_kt__oxmdm();
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return window.korgwCanvasQuery;
}
function AGWebgl$lambda(e) {
  _init_properties_GlExt_kt__oxmdm();
  e.preventDefault();
  return Unit_instance;
}
function AGWebgl$lambda_0($ag) {
  return function (e) {
    $ag.z6n();
    return Unit_instance;
  };
}
function korgwCanvasQuery$factory() {
  return getPropertyCallableRef('korgwCanvasQuery', 0, KProperty0, function () {
    return get_korgwCanvasQuery();
  }, null);
}
var properties_initialized_GlExt_kt_6pmiss;
function _init_properties_GlExt_kt__oxmdm() {
  if (!properties_initialized_GlExt_kt_6pmiss) {
    properties_initialized_GlExt_kt_6pmiss = true;
    korgwCanvasQuery$delegate = lazy(korgwCanvasQuery$delegate$lambda);
  }
}
function alloc(_this__u8e3s4, $this) {
  if (_this__u8e3s4 === null)
    return 0;
  // Inline function 'kotlin.js.asDynamic' call
  if (_this__u8e3s4.id === undefined) {
    if ($this.b9a_1.h1()) {
      // Inline function 'kotlin.error' call
      var message = 'KmlGlJsCanvas.freeList is empty. (Probably allocating lots of OpenGL objects without releasing them)';
      throw IllegalStateException.h5(toString(message));
    }
    var index = $this.b9a_1.p3($this.b9a_1.f1() - 1 | 0);
    $this.a9a_1[index] = _this__u8e3s4;
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.id = index;
  }
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.id;
}
function get_2(_this__u8e3s4, $this) {
  var tmp;
  if (!(_this__u8e3s4 === 0)) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = $this.a9a_1[_this__u8e3s4];
  } else {
    tmp = null;
  }
  return tmp;
}
function free(_this__u8e3s4, $this) {
  var tmp;
  if (!(_this__u8e3s4 === 0)) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var out = $this.a9a_1[_this__u8e3s4];
    // Inline function 'kotlin.collections.plusAssign' call
    $this.b9a_1.h(_this__u8e3s4);
    $this.a9a_1[_this__u8e3s4] = null;
    tmp = out;
  } else {
    tmp = null;
  }
  return tmp;
}
function KmlGlJsCanvas$extensions$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.z99_1.getSupportedExtensions();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [];
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return toSet_0(tmp);
  };
}
function KmlGlJsCanvas$isFloatTextureSupported$delegate$lambda(this$0) {
  return function () {
    return this$0.z99_1.getExtension('OES_texture_float_linear') != null || this$0.z99_1.getExtension('OES_texture_float') != null || this$0.y99_1 >= 2;
  };
}
function extensions$factory() {
  return getPropertyCallableRef('extensions', 1, KProperty1, function (receiver) {
    return receiver.o5v();
  }, null);
}
function get_KorgeReloadInternal() {
  _init_properties_KorgeReload_getReloadedClass_kt__lithzw();
  return KorgeReloadInternal;
}
var KorgeReloadInternal;
var properties_initialized_KorgeReload_getReloadedClass_kt_tswp16;
function _init_properties_KorgeReload_getReloadedClass_kt__lithzw() {
  if (!properties_initialized_KorgeReload_getReloadedClass_kt_tswp16) {
    properties_initialized_KorgeReload_getReloadedClass_kt_tswp16 = true;
    KorgeReloadInternal = new KorgeReloadInternal$1();
  }
}
function CreateDefaultGameWindow(config) {
  return Companion_getInstance_3().bw() ? DenoJsGameWindow.v9i(VOID, config) : Companion_getInstance_3().aw() ? NodeJsGameWindow.a9g() : BrowserCanvasJsGameWindow.o9d();
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp0_safe_receiver = $this.i9l_1.l9d_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp = cancelAndJoin(tmp0_safe_receiver, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  window.close();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = $this.j9l_1($this.k9l_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function onResized($this) {
  $this.c9d_1 = null;
  if (get_isCanvasCreatedAndHandled()) {
    var scale = $this.e8i().y8o(window.innerWidth, window.innerHeight, $this.w8i());
    var canvasWidth = numberToInt(window.innerWidth * scale);
    var canvasHeight = numberToInt(window.innerHeight * scale);
    $this.z9c_1.width = canvasWidth;
    $this.z9c_1.height = canvasHeight;
    $this.z9c_1.style.position = 'absolute';
    $this.z9c_1.style.left = '0';
    $this.z9c_1.style.right = '0';
    $this.z9c_1.style.width = '' + window.innerWidth + 'px';
    $this.z9c_1.style.height = '' + window.innerHeight + 'px';
    $this.h9d_1 = scale;
  } else {
    $this.h9d_1 = $this.z9c_1.width / $this.z9c_1.clientWidth;
  }
  $this.z8q(0, 0, $this.z9c_1.width, $this.z9c_1.height);
}
function keyEvent($this, me) {
  var tmp;
  switch (me.key) {
    case '0':
      tmp = Key_N0_getInstance();
      break;
    case '1':
      tmp = Key_N1_getInstance();
      break;
    case '2':
      tmp = Key_N2_getInstance();
      break;
    case '3':
      tmp = Key_N3_getInstance();
      break;
    case '4':
      tmp = Key_N4_getInstance();
      break;
    case '5':
      tmp = Key_N5_getInstance();
      break;
    case '6':
      tmp = Key_N6_getInstance();
      break;
    case '7':
      tmp = Key_N7_getInstance();
      break;
    case '8':
      tmp = Key_N8_getInstance();
      break;
    case '9':
      tmp = Key_N9_getInstance();
      break;
    case 'a':
      tmp = Key_A_getInstance();
      break;
    case 'b':
      tmp = Key_B_getInstance();
      break;
    case 'c':
      tmp = Key_C_getInstance();
      break;
    case 'd':
      tmp = Key_D_getInstance();
      break;
    case 'e':
      tmp = Key_E_getInstance();
      break;
    case 'f':
      tmp = Key_F_getInstance();
      break;
    case 'g':
      tmp = Key_G_getInstance();
      break;
    case 'h':
      tmp = Key_H_getInstance();
      break;
    case 'i':
      tmp = Key_I_getInstance();
      break;
    case 'j':
      tmp = Key_J_getInstance();
      break;
    case 'k':
      tmp = Key_K_getInstance();
      break;
    case 'l':
      tmp = Key_L_getInstance();
      break;
    case 'm':
      tmp = Key_M_getInstance();
      break;
    case 'n':
      tmp = Key_N_getInstance();
      break;
    case 'o':
      tmp = Key_O_getInstance();
      break;
    case 'p':
      tmp = Key_P_getInstance();
      break;
    case 'q':
      tmp = Key_Q_getInstance();
      break;
    case 'r':
      tmp = Key_R_getInstance();
      break;
    case 's':
      tmp = Key_S_getInstance();
      break;
    case 't':
      tmp = Key_T_getInstance();
      break;
    case 'u':
      tmp = Key_U_getInstance();
      break;
    case 'v':
      tmp = Key_V_getInstance();
      break;
    case 'w':
      tmp = Key_W_getInstance();
      break;
    case 'x':
      tmp = Key_X_getInstance();
      break;
    case 'y':
      tmp = Key_Y_getInstance();
      break;
    case 'z':
      tmp = Key_Z_getInstance();
      break;
    case 'F1':
      tmp = Key_F1_getInstance();
      break;
    case 'F2':
      tmp = Key_F2_getInstance();
      break;
    case 'F3':
      tmp = Key_F3_getInstance();
      break;
    case 'F4':
      tmp = Key_F4_getInstance();
      break;
    case 'F5':
      tmp = Key_F5_getInstance();
      break;
    case 'F6':
      tmp = Key_F6_getInstance();
      break;
    case 'F7':
      tmp = Key_F7_getInstance();
      break;
    case 'F8':
      tmp = Key_F8_getInstance();
      break;
    case 'F9':
      tmp = Key_F9_getInstance();
      break;
    case 'F10':
      tmp = Key_F10_getInstance();
      break;
    case 'F11':
      tmp = Key_F11_getInstance();
      break;
    case 'F12':
      tmp = Key_F12_getInstance();
      break;
    case 'F13':
      tmp = Key_F13_getInstance();
      break;
    case 'F14':
      tmp = Key_F14_getInstance();
      break;
    case 'F15':
      tmp = Key_F15_getInstance();
      break;
    case 'F16':
      tmp = Key_F16_getInstance();
      break;
    case 'F17':
      tmp = Key_F17_getInstance();
      break;
    case 'F18':
      tmp = Key_F18_getInstance();
      break;
    case 'F19':
      tmp = Key_F19_getInstance();
      break;
    case 'F20':
      tmp = Key_F20_getInstance();
      break;
    case 'F21':
      tmp = Key_F21_getInstance();
      break;
    case 'F22':
      tmp = Key_F22_getInstance();
      break;
    case 'F23':
      tmp = Key_F23_getInstance();
      break;
    case 'F24':
      tmp = Key_F24_getInstance();
      break;
    case 'F25':
      tmp = Key_F25_getInstance();
      break;
    case '+':
      tmp = Key_PLUS_getInstance();
      break;
    case '-':
      tmp = Key_MINUS_getInstance();
      break;
    case "'":
      tmp = Key_APOSTROPHE_getInstance();
      break;
    case '"':
      tmp = Key_QUOTE_getInstance();
      break;
    default:
      var tmp_0;
      switch (me.code) {
        case 'MetaLeft':
          tmp_0 = Companion_getInstance_34().r6m();
          break;
        case 'MetaRight':
          tmp_0 = Companion_getInstance_34().s6m();
          break;
        case 'ShiftLeft':
          tmp_0 = Companion_getInstance_34().n6m();
          break;
        case 'ShiftRight':
          tmp_0 = Companion_getInstance_34().o6m();
          break;
        case 'ControlLeft':
          tmp_0 = Companion_getInstance_34().l6m();
          break;
        case 'ControlRight':
          tmp_0 = Companion_getInstance_34().m6m();
          break;
        case 'AltLeft':
          tmp_0 = Companion_getInstance_34().p6m();
          break;
        case 'AltRight':
          tmp_0 = Companion_getInstance_34().q6m();
          break;
        case 'Space':
          tmp_0 = Key_SPACE_getInstance();
          break;
        case 'ArrowUp':
          tmp_0 = Key_UP_getInstance();
          break;
        case 'ArrowDown':
          tmp_0 = Key_DOWN_getInstance();
          break;
        case 'ArrowLeft':
          tmp_0 = Key_LEFT_getInstance();
          break;
        case 'ArrowRight':
          tmp_0 = Key_RIGHT_getInstance();
          break;
        case 'PageUp':
          tmp_0 = Key_PAGE_UP_getInstance();
          break;
        case 'PageDown':
          tmp_0 = Key_PAGE_DOWN_getInstance();
          break;
        case 'Home':
          tmp_0 = Key_HOME_getInstance();
          break;
        case 'End':
          tmp_0 = Key_END_getInstance();
          break;
        case 'Enter':
          tmp_0 = Key_ENTER_getInstance();
          break;
        case 'Escape':
          tmp_0 = Key_ESCAPE_getInstance();
          break;
        case 'Backspace':
          tmp_0 = Key_BACKSPACE_getInstance();
          break;
        case 'Delete':
          tmp_0 = Key_DELETE_getInstance();
          break;
        case 'Insert':
          tmp_0 = Key_INSERT_getInstance();
          break;
        case 'Period':
          tmp_0 = Key_PERIOD_getInstance();
          break;
        case 'Comma':
          tmp_0 = Key_COMMA_getInstance();
          break;
        case 'Semicolon':
          tmp_0 = Key_SEMICOLON_getInstance();
          break;
        case 'Slash':
          tmp_0 = Key_SLASH_getInstance();
          break;
        case 'Tab':
          tmp_0 = Key_TAB_getInstance();
          break;
        default:
          // Inline function 'kotlin.js.asDynamic' call

          if (window.korgwShowUnsupportedKeys) {
            // Inline function 'korlibs.logger.Logger.info' call
            var this_0 = CoroutineKey_getInstance().g8m_1;
            var level = Level_INFO_getInstance();
            var tmp_1;
            if (this_0.x2x(level)) {
              // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.keyEvent.<anonymous>' call
              var tmp$ret$1 = 'Unsupported key key=' + me.key + ', code=' + me.code;
              this_0.y2x(level, tmp$ret$1);
              tmp_1 = Unit_instance;
            }
          }

          tmp_0 = Key_UNKNOWN_getInstance();
          break;
      }

      tmp = tmp_0;
      break;
  }
  var key = tmp;
  $this.i6f(invoke_0($this.c8n_1, BrowserCanvasJsGameWindow$keyEvent$lambda(me, key)));
  if (key.equals(Key_TAB_getInstance()) || key.v6m()) {
    me.preventDefault();
  }
}
function touchEvent($this, e, type) {
  var canvasBounds = $this.z9c_1.getBoundingClientRect();
  // Inline function 'kotlin.also' call
  // Inline function 'korlibs.event.TouchBuilder.frame' call
  var this_0 = $this.i9d_1;
  this_0.g6k_1 = Mode_JS_getInstance();
  this_0.h6k(type, false);
  try {
    // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.touchEvent.<anonymous>' call
    var inductionVariable = 0;
    var last = e.touches.length;
    if (inductionVariable < last)
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_elvis_lhs = e.touches.item(n);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var touch = tmp;
        var touchId = touch.identifier;
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventX' call
        var tmp_0 = (touch.clientX - canvasBounds.left) * $this.h9d_1;
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventY' call
        var tmp$ret$1 = (touch.clientY - canvasBounds.top) * $this.h9d_1;
        var tmp_1 = Vector2D.v2e(tmp_0, tmp$ret$1);
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp1_elvis_lhs = touch.force;
        this_0.k6k(touchId, tmp_1, tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs, Kind_FINGER_getInstance());
      }
       while (inductionVariable < last);
  }finally {
    this_0.i6k();
  }
  var this_1 = this_0.f6k_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.touchEvent.<anonymous>' call
  $this.i6f(this_1);
}
function mouseEvent($this, e, type, pressingType) {
  var canvasBounds = $this.z9c_1.getBoundingClientRect();
  // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventX' call
  var tmp$ret$0 = (e.clientX - canvasBounds.left) * $this.h9d_1;
  var tx = numberToInt(tmp$ret$0);
  // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventY' call
  var tmp$ret$1 = (e.clientY - canvasBounds.top) * $this.h9d_1;
  var ty = numberToInt(tmp$ret$1);
  invoke_0($this.d8n_1, BrowserCanvasJsGameWindow$mouseEvent$lambda(e, pressingType, type, tx, ty));
  if (!$this.l9l() || type.equals(Type_SCROLL_getInstance())) {
    $this.i6f($this.d8n_1);
  }
}
function mouseEvent$default($this, e, type, pressingType, $super) {
  pressingType = pressingType === VOID ? type : pressingType;
  return mouseEvent($this, e, type, pressingType);
}
function *_generator_loop__qll5p8_0($this, entry, $completion) {
  var tmp = $this;
  var tmp_0 = $this.z8o($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.l9d_1 = launchImmediately(tmp_0, BrowserCanvasJsGameWindow$loop$slambda_0(entry, $this));
  _get_jsFrame__gugpar($this)(0.0);
  return Unit_instance;
}
function _get_jsFrame__gugpar($this) {
  var tmp = $this.m9d_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('jsFrame');
  }
}
function BrowserCanvasJsGameWindow$keyEvent$lambda($me, $key) {
  return function ($this$keyEvent) {
    var tmp = $this$keyEvent;
    var tmp_0;
    switch ($me.type) {
      case 'keydown':
        tmp_0 = Type_DOWN_getInstance();
        break;
      case 'keyup':
        tmp_0 = Type_UP_getInstance();
        break;
      case 'keypress':
        tmp_0 = Type_TYPE_getInstance();
        break;
      default:
        var message = 'Unsupported event type ' + $me.type;
        throw IllegalStateException.h5(toString(message));
    }
    tmp.p6g_1 = tmp_0;
    $this$keyEvent.q6g_1 = 0;
    $this$keyEvent.s6g_1 = $me.keyCode;
    $this$keyEvent.r6g_1 = $key;
    $this$keyEvent.u6g_1 = $me.shiftKey;
    $this$keyEvent.v6g_1 = $me.ctrlKey;
    $this$keyEvent.w6g_1 = $me.altKey;
    $this$keyEvent.x6g_1 = $me.metaKey;
    $this$keyEvent.t6g_1 = numberToChar($me.charCode);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$mouseEvent$lambda($e, $pressingType, $type, $tx, $ty) {
  return function ($this$mouseEvent) {
    $this$mouseEvent.h6h_1 = !($e.buttons === 0) ? $pressingType : $type;
    $this$mouseEvent.u6h_1 = false;
    $this$mouseEvent.i6h_1 = 0;
    $this$mouseEvent.j6h_1 = $tx;
    $this$mouseEvent.k6h_1 = $ty;
    $this$mouseEvent.l6h_1 = Companion_getInstance_35().e1($e.button);
    $this$mouseEvent.m6h_1 = $e.buttons;
    $this$mouseEvent.q6h_1 = $e.shiftKey;
    $this$mouseEvent.r6h_1 = $e.ctrlKey;
    $this$mouseEvent.s6h_1 = $e.altKey;
    $this$mouseEvent.t6h_1 = $e.metaKey;
    var tmp;
    if ($type.equals(Type_SCROLL_getInstance())) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var we = $e;
      var tmp0_subject = we.deltaMode;
      var mode = tmp0_subject === WheelEvent.DOM_DELTA_PIXEL ? ScrollDeltaMode_PIXEL_getInstance() : tmp0_subject === WheelEvent.DOM_DELTA_LINE ? ScrollDeltaMode_LINE_getInstance() : tmp0_subject === WheelEvent.DOM_DELTA_PAGE ? ScrollDeltaMode_PAGE_getInstance() : ScrollDeltaMode_LINE_getInstance();
      var sensitivity = 0.05;
      $this$mouseEvent.b6i(mode, we.deltaX * sensitivity, we.deltaY * sensitivity, we.deltaZ * sensitivity);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$close$slambda_0(this$0) {
  var i = new BrowserCanvasJsGameWindow$close$slambda(this$0);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function BrowserCanvasJsGameWindow$loop$slambda_0($entry, this$0) {
  var i = new BrowserCanvasJsGameWindow$loop$slambda($entry, this$0);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function BrowserCanvasJsGameWindow$lambda(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_SCROLL_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_0(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_ENTER_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_1(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_EXIT_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_2(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent(this$0, it, Type_MOVE_getInstance(), Type_DRAG_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_3(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent(this$0, it, Type_MOVE_getInstance(), Type_DRAG_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_4(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_EXIT_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_5(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_UP_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_6(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_DOWN_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_7(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_CLICK_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_8(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    touchEvent(this$0, it, Type_START_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_9(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    touchEvent(this$0, it, Type_MOVE_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_10(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    touchEvent(this$0, it, Type_END_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_11(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    keyEvent(this$0, it);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_12(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    keyEvent(this$0, it);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_13(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    keyEvent(this$0, it);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_14(this$0) {
  return function (it) {
    onResized(this$0);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_15(this$0) {
  return function (it) {
    return this$0.e8r(Type_START_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_16(this$0) {
  return function (it) {
    return this$0.e8r(Type_END_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_17(this$0) {
  return function (it) {
    return this$0.e8r(Type_END_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_18(it) {
  it.preventDefault();
  return Unit_instance;
}
function BrowserCanvasJsGameWindow$lambda_19(this$0) {
  return function (it) {
    return this$0.e8r(Type_START_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_20(this$0) {
  return function (it) {
    return this$0.e8r(Type_END_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_21(this$0) {
  return function (it) {
    it.preventDefault();
    this$0.e8r(Type_END_getInstance(), null);
    var items = ensureNotNull(it.dataTransfer).items;
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = until(0, items.length);
    var destination = ArrayList.j1();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = this_0.b2_1;
    var last = this_0.c2_1;
    if (inductionVariable <= last)
      do {
        var element = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.<anonymous>.<anonymous>' call
        // Inline function 'org.w3c.dom.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_safe_receiver = items[element];
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.getAsFile();
        var tmp0_safe_receiver_0 = tmp1_safe_receiver == null ? null : toVfs(tmp1_safe_receiver);
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.h(tmp0_safe_receiver_0);
        }
      }
       while (!(element === last));
    var files = destination;
    return this$0.e8r(Type_DROP_getInstance(), files);
  };
}
function BrowserCanvasJsGameWindow$lambda_22(this$0) {
  return function (step) {
    window.requestAnimationFrame(_get_jsFrame__gugpar(this$0));
    this$0.a8p();
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  var tmp = $this.o9l_1($this.p9l_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_loop__qll5p8_1($this, entry, $completion) {
  var tmp = $this.z8o($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  launchImmediately(tmp, DenoJsGameWindow$loop$slambda_0(entry, $this));
  var tmp_0 = get_jsGlobalThis();
  tmp_0.setInterval(DenoJsGameWindow$loop$lambda($this), 16);
  return Unit_instance;
}
function DenoJsGameWindow$loop$slambda_0($entry, this$0) {
  var i = new DenoJsGameWindow$loop$slambda($entry, this$0);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function DenoJsGameWindow$loop$lambda(this$0) {
  return function () {
    this$0.n99();
    this$0.a8p();
    this$0.o99();
    return Unit_instance;
  };
}
//region block: post-declaration
initMetadataForClass(TimedTask, 'TimedTask', VOID, VOID, [Comparable, AutoCloseable]);
initMetadataForClass(BaseEventLoop, 'BaseEventLoop', VOID, VOID, [AutoCloseable]);
initMetadataForClass(SyncEventLoop, 'SyncEventLoop', SyncEventLoop);
protoOf(Listener).ot = cancel;
initMetadataForClass(Listener, 'Listener', VOID, VOID, [CloseableCancellable]);
initMetadataForClass(ListenerNode, 'ListenerNode');
initMetadataForInterface(EventListener, 'EventListener');
protoOf(BaseEventListener).h6f = dispatch$default;
protoOf(BaseEventListener).j6f = onEvents;
protoOf(BaseEventListener).k6f = dispatchDown;
protoOf(BaseEventListener).l6f = dispatchUp;
initMetadataForClass(BaseEventListener, 'BaseEventListener', BaseEventListener.v6e, VOID, [EventListener]);
initMetadataForClass(EventResult, 'EventResult', EventResult);
initMetadataForCompanion(Companion);
initMetadataForClass(Event, 'Event');
initMetadataForClass(TypedEvent, 'TypedEvent');
initMetadataForClass(PauseEvent, 'PauseEvent', PauseEvent);
initMetadataForCompanion(Companion_0);
initMetadataForClass(ResumeEvent, 'ResumeEvent', ResumeEvent);
initMetadataForCompanion(Companion_1);
initMetadataForClass(StopEvent, 'StopEvent', StopEvent);
initMetadataForCompanion(Companion_2);
initMetadataForClass(DestroyEvent, 'DestroyEvent', DestroyEvent);
initMetadataForClass(RenderEvent, 'RenderEvent', RenderEvent);
initMetadataForCompanion(Companion_3);
initMetadataForClass(InitEvent, 'InitEvent', InitEvent);
initMetadataForCompanion(Companion_4);
initMetadataForCompanion(Companion_5);
initMetadataForClass(DisposeEvent, 'DisposeEvent', DisposeEvent);
initMetadataForCompanion(Companion_6);
initMetadataForClass(FullScreenEvent, 'FullScreenEvent', FullScreenEvent);
initMetadataForCompanion(Companion_7);
initMetadataForClass(ReshapeEvent, 'ReshapeEvent', ReshapeEvent);
initMetadataForCompanion(Companion_8);
initMetadataForClass(Type, 'Type');
initMetadataForClass(KeyEvent, 'KeyEvent', KeyEvent);
initMetadataForCompanion(Companion_9);
initMetadataForClass(Type_0, 'Type');
initMetadataForClass(ScrollDeltaMode, 'ScrollDeltaMode');
initMetadataForClass(MouseEvent, 'MouseEvent', MouseEvent);
initMetadataForCompanion(Companion_10);
initMetadataForClass(Type_1, 'Type');
initMetadataForClass(GestureEvent, 'GestureEvent', GestureEvent);
initMetadataForCompanion(Companion_11);
initMetadataForClass(Type_2, 'Type');
initMetadataForClass(DropFileEvent, 'DropFileEvent', DropFileEvent);
initMetadataForClass(StopPropagatingException, 'StopPropagatingException', StopPropagatingException.r6i);
initMetadataForClass(Status, 'Status');
initMetadataForClass(Kind, 'Kind');
initMetadataForCompanion(Companion_12);
initMetadataForClass(Touch, 'Touch', Touch);
initMetadataForCompanion(Companion_13);
initMetadataForClass(Type_3, 'Type');
initMetadataForCompanion(Companion_14);
initMetadataForClass(TouchEvent, 'TouchEvent', TouchEvent);
initMetadataForClass(Mode, 'Mode');
initMetadataForClass(TouchBuilder, 'TouchBuilder', TouchBuilder);
initMetadataForClass(GamepadInfoEmitter, 'GamepadInfoEmitter');
initMetadataForClass(BatteryStatus, 'BatteryStatus');
initMetadataForCompanion(Companion_15);
initMetadataForClass(GamepadInfo, 'GamepadInfo', GamepadInfo);
initMetadataForCompanion(Companion_16);
initMetadataForClass(GamePadUpdateEvent, 'GamePadUpdateEvent', GamePadUpdateEvent);
initMetadataForCompanion(Companion_17);
initMetadataForClass(Type_4, 'Type');
initMetadataForClass(GamePadConnectionEvent, 'GamePadConnectionEvent', GamePadConnectionEvent);
initMetadataForCompanion(Companion_18);
initMetadataForClass(GameButton, 'GameButton');
initMetadataForCompanion(Companion_19);
initMetadataForClass(Key, 'Key');
initMetadataForCompanion(Companion_20);
initMetadataForClass(MouseButton, 'MouseButton');
initMetadataForCompanion(Companion_21);
initMetadataForInterface(AGFeatures, 'AGFeatures');
protoOf(AG).f6o = get_parentFeatures;
protoOf(AG).g6o = get_isUniformBuffersSupported;
protoOf(AG).h6o = get_isVertexArraysSupported;
initMetadataForClass(AG, 'AG', VOID, VOID, [AGFeatures]);
initMetadataForClass(Immutable, 'Immutable', Immutable, VOID, [AGFeatures]);
initMetadataForClass(AGObject, 'AGObject', AGObject, VOID, [AutoCloseable]);
initMetadataForClass(AGBuffer, 'AGBuffer', AGBuffer);
initMetadataForCompanion(Companion_22);
initMetadataForClass(AGTextureUnits, 'AGTextureUnits', AGTextureUnits.j6r);
initMetadataForCompanion(Companion_23);
initMetadataForClass(AGFrameBuffer, 'AGFrameBuffer', AGFrameBuffer.x6n, VOID, [AutoCloseable]);
initMetadataForClass(AGTexture, 'AGTexture', AGTexture, VOID, [AGObject, AutoCloseable]);
initMetadataForClass(AGFrameBufferBase, 'AGFrameBufferBase');
initMetadataForCompanion(Companion_24);
initMetadataForClass(AGTextureUnitInfo, 'AGTextureUnitInfo');
initMetadataForInterface(AGNativeObject, 'AGNativeObject');
initMetadataForClass(BufferCache, 'BufferCache', BufferCache);
initMetadataForClass(AGProgramWithUniforms, 'AGProgramWithUniforms');
initMetadataForClass(AGVertexArrayObject, 'AGVertexArrayObject');
initMetadataForClass(AGVertexData, 'AGVertexData', AGVertexData);
initMetadataForCompanion(Companion_25);
initMetadataForClass(AGDrawType, 'AGDrawType');
initMetadataForCompanion(Companion_26);
initMetadataForCompanion(Companion_27);
initMetadataForClass(AGBlending, 'AGBlending');
initMetadataForCompanion(Companion_28);
initMetadataForClass(AGScissor, 'AGScissor');
initMetadataForCompanion(Companion_29);
initMetadataForObject(AGFinish, 'AGFinish');
initMetadataForClass(AGClear, 'AGClear');
initMetadataForCompanion(Companion_30);
initMetadataForClass(AGStencilReference, 'AGStencilReference');
initMetadataForCompanion(Companion_31);
initMetadataForClass(AGStencilOpFunc, 'AGStencilOpFunc');
initMetadataForCompanion(Companion_32);
initMetadataForClass(AGColorMask, 'AGColorMask');
initMetadataForCompanion(Companion_33);
initMetadataForCompanion(Companion_34);
initMetadataForClass(AGCullFace, 'AGCullFace');
initMetadataForClass(AGBatch, 'AGBatch');
initMetadataForCompanion(Companion_35);
initMetadataForClass(AGTextureTargetKind, 'AGTextureTargetKind');
initMetadataForCompanion(Companion_36);
initMetadataForClass(AGWrapMode, 'AGWrapMode');
initMetadataForCompanion(Companion_37);
initMetadataForClass(AGBlendFactor, 'AGBlendFactor');
initMetadataForCompanion(Companion_38);
initMetadataForClass(AGBlendEquation, 'AGBlendEquation');
initMetadataForCompanion(Companion_39);
initMetadataForCompanion(Companion_40);
initMetadataForClass(AGStencilOp, 'AGStencilOp');
initMetadataForCompanion(Companion_41);
initMetadataForClass(AGCompareMode, 'AGCompareMode');
initMetadataForCompanion(Companion_42);
initMetadataForClass(AGMultiBatch, 'AGMultiBatch');
initMetadataForClass(AGConfig, 'AGConfig', AGConfig);
initMetadataForClass(AGBufferKind, 'AGBufferKind');
initMetadataForClass(AGStats, 'AGStats', AGStats);
initMetadataForClass(UniformBlock, 'UniformBlock');
initMetadataForObject(ProjViewUB, 'ProjViewUB');
initMetadataForObject(DefaultShaders, 'DefaultShaders');
initMetadataForInterface(VarTypeAccessor, 'VarTypeAccessor');
initMetadataForInterface(ExpressionBuilder, 'ExpressionBuilder');
protoOf(Builder).k76 = get_Float1;
protoOf(Builder).b7s = get_Float2;
protoOf(Builder).c7s = get_Float4;
protoOf(Builder).b75 = get_out;
protoOf(Builder).l76 = atan;
protoOf(Builder).j75 = texture2D;
protoOf(Builder).r7q = TERNARY;
protoOf(Builder).m76 = pow;
protoOf(Builder).n76 = sqrt;
protoOf(Builder).o76 = abs;
protoOf(Builder).p76 = fract;
protoOf(Builder).s7q = clamp;
protoOf(Builder).t7q = min_0;
protoOf(Builder).u7q = max_1;
protoOf(Builder).v7q = fwidth;
protoOf(Builder).w7q = mix;
protoOf(Builder).q76 = smoothstep;
protoOf(Builder).x7q = length;
protoOf(Builder).e75 = get_lit;
protoOf(Builder).r76 = vec2;
protoOf(Builder).f75 = vec4;
protoOf(Builder).h75 = get_1;
protoOf(Builder).s76 = get_x;
protoOf(Builder).t76 = get_y;
protoOf(Builder).u76 = get_z;
protoOf(Builder).v76 = get_w;
protoOf(Builder).l75 = get_a;
protoOf(Builder).w76 = unaryMinus;
protoOf(Builder).x76 = minus_0;
protoOf(Builder).y7q = minus_1;
protoOf(Builder).y76 = plus_2;
protoOf(Builder).z7q = plus_3;
protoOf(Builder).a7r = plus_4;
protoOf(Builder).c75 = times;
protoOf(Builder).b7r = times_0;
protoOf(Builder).n75 = div;
protoOf(Builder).z76 = eq;
protoOf(Builder).a77 = lt;
protoOf(Builder).b77 = le;
protoOf(Builder).c77 = gt;
protoOf(Builder).c7r = gt_0;
initMetadataForClass(Builder, 'Builder', Builder.o75, VOID, [VarTypeAccessor, ExpressionBuilder]);
initMetadataForInterface(IDefaultShaders, 'IDefaultShaders');
protoOf(ProgramBuilderDefault).i75 = get_u_Tex;
protoOf(ProgramBuilderDefault).n72 = get_u_ProjMat;
protoOf(ProgramBuilderDefault).o72 = get_u_ViewMat;
protoOf(ProgramBuilderDefault).d75 = get_a_Pos;
protoOf(ProgramBuilderDefault).v74 = get_a_Tex;
protoOf(ProgramBuilderDefault).a75 = get_a_Col;
protoOf(ProgramBuilderDefault).u74 = get_v_Tex;
protoOf(ProgramBuilderDefault).z74 = get_v_Col;
protoOf(ProgramBuilderDefault).m75 = get_t_Temp0;
protoOf(ProgramBuilderDefault).d77 = get_t_Temp1;
initMetadataForClass(ProgramBuilderDefault, 'ProgramBuilderDefault', ProgramBuilderDefault.t74, VOID, [Builder, IDefaultShaders]);
initMetadataForClass(GLVAO, 'GLVAO');
initMetadataForClass(ShaderException, 'ShaderException');
initMetadataForClass(TextureUnitParams, 'TextureUnitParams');
initMetadataForClass(AGOpengl, 'AGOpengl');
initMetadataForClass(GLGlobalState, 'GLGlobalState');
initMetadataForClass(GLBaseObject, 'GLBaseObject', VOID, VOID, [AGNativeObject]);
initMetadataForClass(GLBaseProgram, 'GLBaseProgram');
initMetadataForClass(GLBuffer, 'GLBuffer');
initMetadataForClass(GLTexture, 'GLTexture');
initMetadataForClass(GLFrameBuffer, 'GLFrameBuffer');
initMetadataForClass(GLProgramInfo, 'GLProgramInfo');
initMetadataForObject(GLShaderCompiler, 'GLShaderCompiler');
initMetadataForClass(AGDummy, 'AGDummy', AGDummy.c7h);
initMetadataForClass(AGBaseLog, 'AGBaseLog', AGBaseLog.w7h);
initMetadataForClass(AGPrint, 'AGPrint', AGPrint.m7h);
initMetadataForClass(Kind_0, 'Kind');
initMetadataForCompanion(Companion_43);
initMetadataForClass(UniformBlocksBuffersRef, 'UniformBlocksBuffersRef');
initMetadataForClass(Gen, 'Gen');
initMetadataForClass(Operand, 'Operand');
initMetadataForClass(OperandWithArray, 'OperandWithArray');
initMetadataForClass(Variable, 'Variable');
initMetadataForClass(VariableWithOffset, 'VariableWithOffset');
initMetadataForClass(TypedUniform, 'TypedUniform');
initMetadataForCompanion(Companion_44);
initMetadataForClass(UniformBlockBuffer, 'UniformBlockBuffer');
initMetadataForClass(UBLayoutBuilder, 'UBLayoutBuilder', UBLayoutBuilder);
initMetadataForClass(UniformsRef, 'UniformsRef');
initMetadataForCompanion(Companion_45);
initMetadataForClass(GLVariant, 'GLVariant');
initMetadataForClass(Visitor, 'Visitor');
initMetadataForClass(GlobalsProgramVisitor, 'GlobalsProgramVisitor', GlobalsProgramVisitor);
initMetadataForCompanion(Companion_46);
initMetadataForClass(Result, 'Result');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForInterface(BaseGlslGenerator, 'BaseGlslGenerator');
protoOf(GlslGenerator).b7n = precToString;
protoOf(GlslGenerator).c7n = typeToString;
protoOf(GlslGenerator).d7n = get_arrayDecl;
protoOf(GlslGenerator).a7n = get_IN;
protoOf(GlslGenerator).f7n = get_OUT;
protoOf(GlslGenerator).e7n = get_UNIFORM;
initMetadataForClass(GlslGenerator, 'GlslGenerator', VOID, VOID, [BaseGlslGenerator]);
initMetadataForCompanion(Companion_47);
initMetadataForClass(GlslConfig, 'GlslConfig');
protoOf(GlslBodyGenerator).c7n = typeToString;
initMetadataForClass(GlslBodyGenerator, 'GlslBodyGenerator', VOID, VOID, [Visitor, BaseGlslGenerator]);
initMetadataForClass(ProgramLayout, 'ProgramLayout', VOID, VOID, [Iterable]);
initMetadataForClass(Attribute, 'Attribute');
initMetadataForClass(Stm, 'Stm');
initMetadataForClass(Stms, 'Stms');
initMetadataForClass(Set, 'Set');
initMetadataForClass(Return, 'Return');
initMetadataForObject(Break, 'Break');
initMetadataForObject(Continue, 'Continue');
initMetadataForObject(Discard, 'Discard');
initMetadataForClass(If, 'If');
initMetadataForClass(ForSimple, 'ForSimple');
initMetadataForClass(Raw, 'Raw');
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).m76 = pow;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).e75 = get_lit;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).h75 = get_1;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).x76 = minus_0;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).y76 = plus_2;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).c75 = times;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).c77 = gt;
initMetadataForClass(Program$ExpressionBuilder$Companion$INSTANCE$1, VOID, VOID, VOID, [ExpressionBuilder]);
initMetadataForCompanion(Companion_48);
initMetadataForClass(FuncBuilder, 'FuncBuilder');
initMetadataForClass(FuncDeclGetter, 'FuncDeclGetter');
initMetadataForClass(FuncProvider, 'FuncProvider');
initMetadataForClass(Program$Builder$_funcs$1);
initMetadataForClass(Ternary, 'Ternary');
initMetadataForClass(Unop, 'Unop');
initMetadataForClass(Binop, 'Binop');
initMetadataForClass(IntLiteral, 'IntLiteral');
initMetadataForClass(FloatLiteral, 'FloatLiteral');
initMetadataForClass(BoolLiteral, 'BoolLiteral');
initMetadataForClass(Vector, 'Vector');
initMetadataForClass(Swizzle, 'Swizzle');
initMetadataForClass(ArrayAccess, 'ArrayAccess');
initMetadataForClass(BaseFunc, 'BaseFunc');
initMetadataForClass(Func, 'Func');
initMetadataForClass(CustomFunc, 'CustomFunc');
initMetadataForInterface(FuncRef, 'FuncRef');
initMetadataForClass(BuilderContext, 'BuilderContext', BuilderContext);
initMetadataForClass(Program, 'Program', VOID, VOID, [AutoCloseable]);
initMetadataForClass(Shader, 'Shader');
initMetadataForClass(Varying, 'Varying');
initMetadataForObject(Output, 'Output');
initMetadataForClass(Provider, 'Provider');
initMetadataForClass(Sampler, 'Sampler');
initMetadataForClass(SamplerVarType, 'SamplerVarType');
initMetadataForClass(Uniform, 'Uniform');
initMetadataForCompanion(Companion_49);
initMetadataForClass(VarType, 'VarType');
initMetadataForClass(Precision, 'Precision');
initMetadataForClass(Temp, 'Temp');
initMetadataForClass(FuncDecl, 'FuncDecl', VOID, VOID, [FuncRef]);
initMetadataForClass(VarKind, 'VarKind');
initMetadataForClass(UniformInProgram, 'UniformInProgram');
initMetadataForClass(Arg, 'Arg');
initMetadataForClass(ShaderType, 'ShaderType');
initMetadataForClass(sam$kotlinx_coroutines_DisposableHandle$0, 'sam$kotlinx_coroutines_DisposableHandle$0', VOID, VOID, [DisposableHandle, FunctionAdapter]);
initMetadataForClass(ContextInfo, 'ContextInfo', ContextInfo);
initMetadataForCompanion(Companion_50);
protoOf(KmlGl).f6o = get_parentFeatures;
protoOf(KmlGl).g6o = get_isUniformBuffersSupported;
protoOf(KmlGl).h6o = get_isVertexArraysSupported;
initMetadataForClass(KmlGl, 'KmlGl', KmlGl, VOID, [AGFeatures]);
initMetadataForClass(KmlGlContext, 'KmlGlContext', VOID, VOID, [AutoCloseable]);
initMetadataForClass(KorgeReloadInternalImpl, 'KorgeReloadInternalImpl', KorgeReloadInternalImpl);
initMetadataForClass(ReloadClassContext, 'ReloadClassContext');
initMetadataForObject(KorgeReload, 'KorgeReload');
initMetadataForCompanion(Companion_51);
initMetadataForCompanion(Companion_52);
initMetadataForClass(BlendMode, 'BlendMode');
initMetadataForClass(InputKeys, 'InputKeys', InputKeys);
initMetadataForCompanion(Companion_53);
initMetadataForClass(Input, 'Input', Input);
initMetadataForObject(DefaultViewport, 'DefaultViewport');
initMetadataForCompanion(Companion_54);
initMetadataForClass(Props, 'Props', Props, VOID, [KtMutableMap]);
initMetadataForClass(Entry, 'Entry', Entry);
initMetadataForClass(AgAutoFreeManager, 'AgAutoFreeManager', AgAutoFreeManager, VOID, [AutoCloseable]);
initMetadataForClass(BitmapTextureInfo, 'BitmapTextureInfo', BitmapTextureInfo);
initMetadataForClass(AgBitmapTextureManager, 'AgBitmapTextureManager', VOID, VOID, [AutoCloseable]);
initMetadataForClass(AgBufferManager, 'AgBufferManager');
initMetadataForClass(AgCachedBuffer, 'AgCachedBuffer');
initMetadataForClass(BatchBuffers, 'BatchBuffers', BatchBuffers);
initMetadataForCompanion(Companion_55);
initMetadataForClass(BatchBuilder2D, 'BatchBuilder2D');
initMetadataForInterface(BoundsProvider, 'BoundsProvider');
protoOf(Base).d8h = get_windowToGlobalScaleAvg;
protoOf(Base).e8h = get_globalToWindowScaleAvg;
protoOf(Base).f8h = windowToGlobalCoords;
initMetadataForClass(Base, 'Base', Base, VOID, [BoundsProvider]);
initMetadataForCompanion(Companion_56);
initMetadataForClass(LineRenderBatcher, 'LineRenderBatcher');
initMetadataForClass(FlushKind, 'FlushKind');
initMetadataForInterface(DeviceDimensionsProvider, 'DeviceDimensionsProvider');
initMetadataForClass(RenderContext, 'RenderContext', VOID, VOID, [BoundsProvider, AGFeatures, DeviceDimensionsProvider, AutoCloseable]);
initMetadataForClass(RenderContext2D, 'RenderContext2D');
initMetadataForObject(SDFShaders, 'SDFShaders');
initMetadataForClass(TextureBase, 'TextureBase', VOID, VOID, [AutoCloseable]);
initMetadataForCompanion(Companion_57);
initMetadataForClass(TexturedVertexArray, 'TexturedVertexArray');
initMetadataForClass(ResourcesRoot, 'ResourcesRoot', ResourcesRoot, VOID, [InjectorDependency], [1]);
initMetadataForClass(RCollection, 'RCollection', RCollection);
initMetadataForClass(Stats, 'Stats', Stats);
initMetadataForClass(V2, 'V2');
protoOf(DEFAULT).w8i = get_devicePixelRatio;
protoOf(DEFAULT).x8i = get_pixelsPerInch;
protoOf(DEFAULT).y8i = get_pixelsPerLogicalInchRatio;
protoOf(DEFAULT).h8i = get_computedPixelRatio;
initMetadataForObject(DEFAULT, 'DEFAULT', VOID, VOID, [DeviceDimensionsProvider]);
initMetadataForClass(Impl, 'Impl', Impl);
initMetadataForCompanion(Companion_58);
initMetadataForClass(Cursor, 'Cursor');
initMetadataForClass(MenuItem, 'MenuItem');
initMetadataForObject(CoroutineKey, 'CoroutineKey');
initMetadataForClass(Quality, 'Quality');
initMetadataForLambda(GameWindow$loop$slambda, VOID, VOID, [0]);
initMetadataForClass(_no_name_provided__qut3iv);
protoOf(GameWindow).w8i = get_devicePixelRatio;
protoOf(GameWindow).x8i = get_pixelsPerInch;
protoOf(GameWindow).y8i = get_pixelsPerLogicalInchRatio;
protoOf(GameWindow).h8i = get_computedPixelRatio;
protoOf(GameWindow).md = get;
protoOf(GameWindow).bn = fold;
protoOf(GameWindow).an = minusKey;
protoOf(GameWindow).cn = plus_1;
initMetadataForClass(GameWindow, 'GameWindow', GameWindow.h8p, VOID, [BaseEventListener, DeviceDimensionsProvider, Element], [0, 1]);
initMetadataForCompanion(Companion_59);
initMetadataForClass(GameWindowCreationConfig, 'GameWindowCreationConfig', GameWindowCreationConfig);
initMetadataForClass(TimedTask_0, 'TimedTask');
initMetadataForCompanion(Companion_60);
initMetadataForClass(sam$kotlinx_coroutines_DisposableHandle$0_0, 'sam$kotlinx_coroutines_DisposableHandle$0', VOID, VOID, [DisposableHandle, FunctionAdapter]);
initMetadataForClass(GameWindowCoroutineDispatcher, 'GameWindowCoroutineDispatcher', GameWindowCoroutineDispatcher.v8p, VOID, [CoroutineDispatcher, Delay, AutoCloseable], [1]);
initMetadataForClass(SyncEventLoopCoroutineDispatcher, 'SyncEventLoopCoroutineDispatcher', SyncEventLoopCoroutineDispatcher.k8p, VOID, [CoroutineDispatcher, Delay, AutoCloseable], [1]);
initMetadataForCompanion(Companion_61);
initMetadataForClass(UpdateEvent, 'UpdateEvent', UpdateEvent);
initMetadataForCompanion(Companion_62);
initMetadataForClass(SDL, 'SDL', SDL.p8t);
initMetadataForClass(KmlGlOpenGL, 'KmlGlOpenGL', KmlGlOpenGL);
initMetadataForCompanion(Companion_63);
initMetadataForClass(OpenGL, 'OpenGL', OpenGL.g90);
initMetadataForClass(SDLGameWindow$ag$1);
initMetadataForClass(SDLGameWindow, 'SDLGameWindow', VOID, VOID, VOID, [0, 1]);
initMetadataForClass(Size3D, 'Size3D');
initMetadataForObject(AGOpenglFactory, 'AGOpenglFactory');
initMetadataForClass(KmlGlJsCanvas, 'KmlGlJsCanvas');
initMetadataForClass(WebGLExtension, 'WebGLExtension');
initMetadataForClass(KorgeReloadInternal$1);
initMetadataForClass(JsGameWindow, 'JsGameWindow', JsGameWindow.h9l, VOID, VOID, [0, 1]);
initMetadataForClass(NodeJsGameWindow, 'NodeJsGameWindow', NodeJsGameWindow.a9g, VOID, VOID, [0, 1]);
initMetadataForLambda(BrowserCanvasJsGameWindow$close$slambda, VOID, VOID, [0]);
initMetadataForLambda(BrowserCanvasJsGameWindow$loop$slambda, VOID, VOID, [0]);
initMetadataForClass(BrowserCanvasJsGameWindow, 'BrowserCanvasJsGameWindow', BrowserCanvasJsGameWindow.o9d, VOID, VOID, [1, 0]);
initMetadataForLambda(DenoJsGameWindow$loop$slambda, VOID, VOID, [0]);
initMetadataForClass(DenoJsGameWindow, 'DenoJsGameWindow', DenoJsGameWindow.v9i, VOID, VOID, [1, 0]);
initMetadataForClass(DialogInterfaceJs, 'DialogInterfaceJs', DialogInterfaceJs, VOID, VOID, [1, 2, 4]);
//endregion
//region block: init
Companion_instance_8 = new Companion();
Companion_instance_9 = new Companion_0();
Companion_instance_10 = new Companion_1();
Companion_instance_11 = new Companion_2();
Companion_instance_14 = new Companion_5();
Companion_instance_15 = new Companion_6();
Companion_instance_16 = new Companion_7();
Companion_instance_23 = new Companion_14();
Companion_instance_24 = new Companion_15();
Companion_instance_25 = new Companion_16();
Companion_instance_31 = new Companion_22();
Companion_instance_32 = new Companion_23();
AGFinish_instance = new AGFinish();
Companion_instance_48 = new Companion_39();
Companion_instance_53 = new Companion_44();
Companion_instance_54 = new Companion_45();
Companion_instance_58 = new Companion_49();
Companion_instance_59 = new Companion_50();
Companion_instance_60 = new Companion_51();
debugBmpFontOrNull = null;
Companion_instance_62 = new Companion_53();
Companion_instance_63 = new Companion_54();
DEFAULT_instance = new DEFAULT();
GLOBAL_CHECK_GL = false;
Companion_instance_70 = new Companion_61();
korgwJvmEngine = null;
Companion_instance_71 = new Companion_62();
Companion_instance_72 = new Companion_63();
AGOpenglFactory_instance = new AGOpenglFactory();
//endregion
//region block: exports
export {
  Size3D as Size3D,
};
export {
  Key_F12_getInstance as Key_F12_getInstance20smmrbslhgku,
  Key_F7_getInstance as Key_F7_getInstance1fxfgbmldwoq6,
  Type_DOWN_getInstance as Type_DOWN_getInstance3w3upujzs6x5,
  Type_TYPE_getInstance as Type_TYPE_getInstance3kl3gtiytkq1p,
  Type_UP_getInstance as Type_UP_getInstance2onpl7vaj0n6f,
  MouseButton_LEFT_getInstance as MouseButton_LEFT_getInstance2pxjdxrpl68c5,
  ScrollDeltaMode_PIXEL_getInstance as ScrollDeltaMode_PIXEL_getInstancen2y5xk1auels,
  Type_DOWN_getInstance_0 as Type_DOWN_getInstance1zas01g4tazis,
  Type_DRAG_getInstance as Type_DRAG_getInstance1oyczma3u1sfi,
  Type_UP_getInstance_0 as Type_UP_getInstance1azeslmnft6l5,
  Kind_MOUSE_getInstance as Kind_MOUSE_getInstance104tc4m897tyy,
  Status_ADD_getInstance as Status_ADD_getInstance22apyg5ct4px7,
  Status_KEEP_getInstance as Status_KEEP_getInstance3tj4183qdgyi5,
  Status_REMOVE_getInstance as Status_REMOVE_getInstance19drpw6lfvon8,
  Type_END_getInstance_0 as Type_END_getInstance3ekhp9k4xqwsb,
  Type_MOVE_getInstance_0 as Type_MOVE_getInstanceavavmobr5nzz,
  Type_START_getInstance_0 as Type_START_getInstance27oonvh9zpi1o,
  Precision_MEDIUM_getInstance as Precision_MEDIUM_getInstancewn61okav7bh4,
  VarType_Float1_getInstance as VarType_Float1_getInstance1fp6gxp2vmo7y,
  VarType_Float2_getInstance as VarType_Float2_getInstance321ftm11bbyai,
  Cursor_DEFAULT_getInstance as Cursor_DEFAULT_getInstancemdqrzfwu4c9e,
  Quality_PERFORMANCE_getInstance as Quality_PERFORMANCE_getInstance2edcjnp9auwx5,
  debugBmpFont as debugBmpFont2i7i2ml66o1iy,
  configureLoggerFromProperties as configureLoggerFromProperties2zy8apzr93pqp,
  AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo as AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgoupfk5vp49hcf,
  AGStencilOpFunc__withCompareMode$default_impl_rzbauv as AGStencilOpFunc__withCompareMode$default_impl_rzbauv2a7p3ocsjaav3,
  AGStencilReference__withReadMask$default_impl_7mdffx as AGStencilReference__withReadMask$default_impl_7mdffx3h4nrtbyv01sb,
  AGStencilReference__withReferenceValue$default_impl_2trj0v as AGStencilReference__withReferenceValue$default_impl_2trj0vn7k078mgur5t,
  AGStencilReference__withWriteMask$default_impl_b7j7b4 as AGStencilReference__withWriteMask$default_impl_b7j7b425xwuml31ig42,
  _AGColorMask___init__impl__j38ai8_0 as _AGColorMask___init__impl__j38ai828hvpfxybxjk7,
  _AGColorMask___init__impl__j38ai8_1 as _AGColorMask___init__impl__j38ai819ejt5rq8iy6o,
  AGColorMask__hashCode_impl_g9082f as AGColorMask__hashCode_impl_g9082fge542b8j3bn5,
  AGColorMask__toString_impl_5i5oqg as AGColorMask__toString_impl_5i5oqgpd3xxn1kc5a,
  AGCompareMode__inverted_impl_7xxk8m as AGCompareMode__inverted_impl_7xxk8m1fvhgazpgzedy,
  AGCullFace__hashCode_impl_t4e5ur as AGCullFace__hashCode_impl_t4e5urey2md6modztx,
  AGCullFace__toString_impl_7d891w as AGCullFace__toString_impl_7d891w3d9dwll45l9u7,
  AGDrawType__hashCode_impl_ylaury as AGDrawType__hashCode_impl_ylaurytzzq8sas7cp2,
  AGDrawType__toString_impl_eonaeb as AGDrawType__toString_impl_eonaeb3ais8d8qrz6pw,
  AGStencilOpFunc__hashCode_impl_nopebb as AGStencilOpFunc__hashCode_impl_nopebb37r56bx19rj5s,
  AGStencilOpFunc__toString_impl_pl8quy as AGStencilOpFunc__toString_impl_pl8quy1rqibzqlcrdqz,
  AGStencilOpFunc__withActionOnBothPass_impl_qbn6at as AGStencilOpFunc__withActionOnBothPass_impl_qbn6at1fkyyctti87u0,
  AGStencilOpFunc__withEnabled_impl_mpcwmr as AGStencilOpFunc__withEnabled_impl_mpcwmr3endm713vq1t4,
  AGStencilReference__hashCode_impl_52zufx as AGStencilReference__hashCode_impl_52zufx32vlakxm4newn,
  AGStencilReference__toString_impl_qu5r8s as AGStencilReference__toString_impl_qu5r8s2c4bvb2linrx,
  Companion_instance_11 as Companion_instance99w5lpdgjzr4,
  Companion_getInstance_26 as Companion_getInstance18y91gyxi2z7,
  Companion_getInstance_32 as Companion_getInstanceok0yphc67vv6,
  Companion_instance_25 as Companion_instancekcgdgz2aik3h,
  Companion_getInstance_25 as Companion_getInstance2ckr5i14ndxro,
  Companion_getInstance_23 as Companion_getInstance1wltq3fgn1avz,
  Companion_getInstance_24 as Companion_getInstancekjblelnta22u,
  Companion_instance_8 as Companion_instance2ovjg7lp6gfg7,
  Companion_instance_16 as Companion_instance12t49ingjwxzt,
  Companion_instance_9 as Companion_instance3i2v9jzzqvdkl,
  Companion_instance_10 as Companion_instancef7estul0zruo,
  Companion_getInstance_28 as Companion_getInstance6ryfwvwg9trm,
  Companion_getInstance_63 as Companion_getInstance31h96uhdj5cc,
  Companion_instance_53 as Companion_instance31en7fj48z7ti,
  Companion_getInstance_47 as Companion_getInstance29a9zmyrrw3c9,
  Companion_getInstance_56 as Companion_getInstancei2plsq4vst79,
  Companion_getInstance_49 as Companion_getInstance14dcva8uz4sb6,
  Companion_getInstance_40 as Companion_getInstanceae40js4gnuwg,
  Companion_getInstance_43 as Companion_getInstance23l94gq35u9ye,
  Companion_getInstance_55 as Companion_getInstance203qp9xyfv543,
  Companion_getInstance_46 as Companion_getInstance2cx7brx0y6bm1,
  Companion_getInstance_45 as Companion_getInstance3dym1csqm206y,
  ProjViewUB_getInstance as ProjViewUB_getInstance2c14wyrj73xek,
  DefaultShaders_getInstance as DefaultShaders_getInstance2nkm3g7twu3qg,
  Companion_getInstance_67 as Companion_getInstance1ifu77pbb1si2,
  DefaultViewport_getInstance as DefaultViewport_getInstance3ta8638tkh0q1,
  Companion_getInstance_70 as Companion_getInstance1dp345vz250gb,
  SDFShaders_getInstance as SDFShaders_getInstance2aqc6fv2u457r,
  Companion_getInstance_72 as Companion_getInstance2vwksse73neff,
  KorgeReload_getInstance as KorgeReload_getInstance1jsrcs9uzp4z9,
  Companion_instance_60 as Companion_instance7uo85wjiqj61,
  Companion_instance_70 as Companion_instanceyamrbth4pjfq,
  CoroutineKey_getInstance as CoroutineKey_getInstance2jikmq30sknr8,
  BaseEventListener as BaseEventListener6clplq3qhf9k,
  EventResult as EventResult1qajuo9ssrvv5,
  Event as Eventnral6s6c3h27,
  KeyEvent as KeyEvent3kdv2rq8w0dew,
  MouseEvent as MouseEventmt8xebywpdp9,
  ReshapeEvent as ReshapeEvent3137ki3m95agm,
  StopPropagatingException as StopPropagatingException3fryyzw9pc422,
  TouchEvent as TouchEvent37l81isz00qgj,
  AGPrint as AGPrint2do8iynklt71b,
  Attribute as Attribute3obvnbxr5w4xd,
  FragmentShader as FragmentShader2u3ycaqbgbmdi,
  If as If1av5krmfyt44s,
  ProgramLayout as ProgramLayout373hh4xkth3qt,
  Program as Program1hnygp9hph4ry,
  UniformBlockBuffer as UniformBlockBuffer2p2oao2ic417b,
  UniformBlock as UniformBlock2qoqszhm3r9i2,
  Varying as Varying105nnu9x9j75f,
  VertexShader as VertexShader26kcg39ndf3s1,
  AGBatch as AGBatch2bse24318tbhc,
  AGColorMask as AGColorMaskwqd86t1dhpnk,
  AGCullFace as AGCullFaceff7di2v9k2ne,
  AGDrawType as AGDrawType11vxw4gf0yugk,
  AGScissor as AGScissor1lpa42gfyr1p2,
  AGStencilOpFunc as AGStencilOpFunc1juigl5mvjr07,
  AGStencilReference as AGStencilReference8at184sv64zi,
  AGTextureUnits as AGTextureUnits3k80ikbk5qbv9,
  AGVertexArrayObject as AGVertexArrayObjectp6l6cor3jhq8,
  AGVertexData as AGVertexDatawn78bdwnwjab,
  AG as AG35f0xk1ko87rh,
  ProgramBuilderDefault as ProgramBuilderDefault3573mhybddt0b,
  applyMatrixBounds as applyMatrixBounds3j13fpymjibm6,
  draw_1 as draw3n7i8s75fp58g,
  plus_5 as plus3tmekjwnqrsa6,
  toAGScissor as toAGScissor50oxbqy8vpfx,
  drawText as drawText2ld6eqw3mc9xd,
  Input as Input3ljaq07eyi73v,
  AgCachedBuffer as AgCachedBuffer8k1i505isl6b,
  get_BB_MAX_TEXTURES as get_BB_MAX_TEXTURES19x2awozztfc7,
  Base as Basef4lqzcfsxjhi,
  BoundsProvider as BoundsProvideri69utw6h2duh,
  RenderContext as RenderContext3l27as458i66g,
  get_TEXTURED_ARRAY_QUAD_INDICES as get_TEXTURED_ARRAY_QUAD_INDICES20zmm5sqavviz,
  TextureBase as TextureBase31xvoisoo1pp7,
  TexturedVertexArray as TexturedVertexArrayt1cf0uhgxqi1,
  Texture as Texture2obedkmljq67n,
  Texture_1 as Texture39uvj3jju6ujd,
  get_debugLineRenderContext as get_debugLineRenderContext3s3h9yq8a0rtj,
  ResourcesRoot as ResourcesRoot36ooexy6oq69y,
  Stats as Statslnkcsgem8jjl,
  V2 as V22su20mpwty0v0,
  _interpolateRatio as _interpolateRatio2cj6ldbl0g6ae,
  UpdateEvent as UpdateEvent2wwv3f0im2cby,
  CreateDefaultGameWindow as CreateDefaultGameWindow1l94icsbq4y8h,
  DeviceDimensionsProvider as DeviceDimensionsProvider22igvmdnpe2w1,
  GameWindowCreationConfig as GameWindowCreationConfigbzmga8g39et1,
  GameWindow as GameWindow35197f3hcbh1b,
  configure as configure1a7py4k2lj4vi,
};
//endregion
